function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
            return;
        }
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("exkzN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$bb80c5e41397c940$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $e9YVH;
    var $jLOUq;
    var $4dRjY;
    var $13lzj;
    const $bb80c5e41397c940$var$KbRequestsReportsApp = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jLOUq")).default), {
            pageId: "reports-requests",
            appName: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_REPORTS_REQUESTS,
            dontShowHeader: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)()
        }, ({ pageContext: pageContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13lzj")).default), {
                pageContext: pageContext
            })));
    var $bb80c5e41397c940$export$2e2bcd8739ae039 = $bb80c5e41397c940$var$KbRequestsReportsApp;
});
parcelRegister("jLOUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcf67f44913f9c86$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $jD5no;
    var $81ps3;
    var $koVbs;
    var $3HwlS;
    var $9noxX;
    var $aLLc7;
    var $cf7yQ;
    var $e33py;
    var $8pMQX;
    var $gq0sA;
    var $4S0uJ;
    var $cz40O;
    var $fP2yI;
    var $doZTA;
    var $1BIUA;
    var $cHb7s;
    var $gMO5K;
    const $bcf67f44913f9c86$var$ReportsAppBase = ({ appName: appName, pageId: pageId, pageTitle: pageTitle, children: children, AppBase: AppBase, ErrorView: ErrorView, PageStyle: PageStyle, actions: actions, dontShowHeader: dontShowHeader = false })=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ data: pageContextData, error: error }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { projectKey: projectKey, projectName: projectName } = projectContext || {};
        const { baseUrl: baseUrl } = tenantContext || {};
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const pageContextProps = (0, $5uXOq.useMemo)(()=>({
                ...tenantContext,
                ...projectContext,
                ...serviceDeskContext
            }), [
            projectContext,
            serviceDeskContext,
            tenantContext
        ]);
        const breadcrumbs = [
            {
                href: '/jira/projects',
                text: formatMessage((0, (0, parcelRequire("gMO5K")).default).projectsBreadcrumb)
            },
            {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey || ''),
                text: projectName || ''
            },
            {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
                text: formatMessage((0, (0, parcelRequire("gMO5K")).default).reportsBreadcrumb)
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cz40O")).SpaPageWrapper), {
            pageId: pageId,
            baseUrl: baseUrl,
            currentUrl: match.url,
            projectContext: projectContext,
            isLoading: !pageContextData && !error,
            error: error
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
            projectName: projectName,
            section: "reports"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(AppBase, {
            id: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aLLc7")).ServiceDeskErrorBoundary), {
            appName: appName,
            ErrorView: ErrorView
        }, !dontShowHeader && ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fP2yI")).Header), {
            title: pageTitle ? formatMessage(pageTitle) : '',
            breadcrumbs: breadcrumbs,
            actions: actions
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $bcf67f44913f9c86$var$HeaderContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(PageStyle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHb7s")).default), {
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BIUA")).default), {
                baseUrl: baseUrl,
                projectKey: projectKey,
                projectName: projectName
            }),
            title: pageTitle,
            actions: actions
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement(PageStyle, null, children({
            pageContext: pageContextProps
        })))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    const $bcf67f44913f9c86$var$HeaderContainer = (0, (0, parcelRequire("99gde")).xcss)({
        paddingBottom: 'space.200'
    });
    $bcf67f44913f9c86$var$ReportsAppBase.defaultProps = {
        AppBase: (0, (0, parcelRequire("jD5no")).default),
        ErrorView: (0, (0, parcelRequire("8pMQX")).GenericError),
        PageStyle: (0, (0, parcelRequire("4S0uJ")).PageStyle)
    };
    var $bcf67f44913f9c86$export$2e2bcd8739ae039 = $bcf67f44913f9c86$var$ReportsAppBase;
});
parcelRegister("aLLc7", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskErrorBoundary", ()=>$8803d19bf51a79cd$export$d999c9325a45f4cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $e9YVH;
    const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
    const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
        if (error instanceof Error) return error;
        if (typeof error === 'string') return new Error(error);
        return undefined;
    };
    class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
            this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
        }
        componentDidCatch(error) {
            const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
            const data = error instanceof Error ? {
                message: error.message,
                stack: error.stack
            } : {
                message: error
            };
            this.triggerEvent('error-boundary.error-caught', data);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'unhandled',
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)(appName) || 'jiraServicedeskCommon'
                },
                event: this.triggerEvent,
                error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
                sendToPrivacyUnsafeSplunk: true
            });
            if (ErrorView) return;
            if (onErrorHandler) onErrorHandler(error);
            else throw error;
        }
        render() {
            const { hasError: hasError } = this.state;
            const { ErrorView: ErrorView, children: children } = this.props;
            if (hasError && ErrorView) return (0, ($parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
            return children;
        }
    }
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("3kACf")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("CFRIm")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("hnw8Z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("7opQ6")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("3kACf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("chQyv")
    ]).then(()=>parcelRequire('hZyYK'));
});
parcelRegister("CFRIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("hnw8Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("7opQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        }
    });
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $hIKcp;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $hDzhb;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("hIKcp")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdvFP;
    var $6Ll2T;
    var $99gde;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdvFP")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("gdvFP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1e3ab6f5cd16b56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3cdTK;
    var $1VQAj;
    var $3wq9L;
    var $kOLPm;
    const $e1e3ab6f5cd16b56$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("3cdTK")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("3wq9L")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kOLPm")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $e1e3ab6f5cd16b56$var$CodeBlock.displayName = 'CodeBlock';
    var $e1e3ab6f5cd16b56$export$2e2bcd8739ae039 = $e1e3ab6f5cd16b56$var$CodeBlock;
});
parcelRegister("3cdTK", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$9354ecb135d9efb8$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $9354ecb135d9efb8$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $9354ecb135d9efb8$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1VQAj", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$1f3f8b295e4f1970$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$1f3f8b295e4f1970$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$1f3f8b295e4f1970$export$57a2d4b573afd64a);
    var $9jPr7;
    var $dW8Ue;
    const $1f3f8b295e4f1970$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $1f3f8b295e4f1970$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("9jPr7")).SPACING),
            marginRight: (0, (0, parcelRequire("9jPr7")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $1f3f8b295e4f1970$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $1f3f8b295e4f1970$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("9jPr7")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $1f3f8b295e4f1970$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("9jPr7")).SPACING}px 0` : (0, (0, parcelRequire("9jPr7")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("9jPr7")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme),
                ...$1f3f8b295e4f1970$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $1f3f8b295e4f1970$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("9jPr7")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("9jPr7")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $1f3f8b295e4f1970$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("dW8Ue")).getBaseTheme)();
        const baseStyles = $1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $1f3f8b295e4f1970$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("dW8Ue")).getBaseTheme)(),
            ...(0, (0, parcelRequire("dW8Ue")).getColorPalette)(),
            lineNumberWidth: maxLines ? $1f3f8b295e4f1970$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("9jPr7", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$16851b1001a2abd2$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$16851b1001a2abd2$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$16851b1001a2abd2$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$16851b1001a2abd2$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$16851b1001a2abd2$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$16851b1001a2abd2$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$16851b1001a2abd2$export$1758fda69688282e);
    var $bUQGL;
    const $16851b1001a2abd2$export$431ac46d758d98c8 = 12;
    const $16851b1001a2abd2$export$8e3c04032121c606 = '20px';
    const $16851b1001a2abd2$export$c8b5dc30e9f2b86e = '4px';
    const $16851b1001a2abd2$export$82ea42e772d49e5b = (0, (0, parcelRequire("bUQGL")).gridSize)();
    const $16851b1001a2abd2$export$eeeea0ff98e06fff = $16851b1001a2abd2$export$82ea42e772d49e5b * 2;
    const $16851b1001a2abd2$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $16851b1001a2abd2$export$1758fda69688282e = '--ds--code--bg-color';
    const $16851b1001a2abd2$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("dW8Ue", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$c352b5d6d7e52441$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$c352b5d6d7e52441$export$fe2a6478976e8b17);
    var $8QpSo;
    var $5w2JH;
    const $c352b5d6d7e52441$var$T800 = '#067384';
    const $c352b5d6d7e52441$var$Y1100 = '#7A5D1A';
    const $c352b5d6d7e52441$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("5w2JH")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`
        });
    const $c352b5d6d7e52441$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$72ba03e317f3d228$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`
        };
    });
    const $c352b5d6d7e52441$var$getTheme = ()=>({
            ...$c352b5d6d7e52441$export$4464aa303b3e4fda(),
            ...$c352b5d6d7e52441$export$fe2a6478976e8b17()
        });
    var $c352b5d6d7e52441$export$2e2bcd8739ae039 = $c352b5d6d7e52441$var$getTheme;
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("3wq9L", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$41e362fed9e5618b$export$f38728011c178796);
    var $8QpSo;
    var $5lUaL;
    const $41e362fed9e5618b$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("5lUaL")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("5lUaL", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$91fe7c840a716685$export$7c77c3a9bb93870d);
    const $91fe7c840a716685$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("kOLPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a42fbdf1f5ea3ed9$export$2e2bcd8739ae039);
    var $aVBRo;
    var $a42fbdf1f5ea3ed9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("aVBRo")).default);
});
parcelRegister("aVBRo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9ccff03a95a648$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTRwa;
    const $5f9ccff03a95a648$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("bTRwa")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $5f9ccff03a95a648$var$asyncGenerator = $5f9ccff03a95a648$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $5f9ccff03a95a648$export$2e2bcd8739ae039 = $5f9ccff03a95a648$var$asyncGenerator;
});
parcelRegister("bTRwa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714e39a7d165750f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bQkeD;
    var $bAA7E;
    const $714e39a7d165750f$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("bQkeD")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("bAA7E")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $714e39a7d165750f$export$2e2bcd8739ae039 = $714e39a7d165750f$var$Highlight;
});
parcelRegister("bQkeD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300f970a4217b631$export$2e2bcd8739ae039);
    var $h1mgC;
    var $7cd5I;
    var $756jv;
    var $g0987;
    const $300f970a4217b631$var$newLineRegex = /\n/g;
    function $300f970a4217b631$var$getNewLines(str) {
        return str.match($300f970a4217b631$var$newLineRegex);
    }
    function $300f970a4217b631$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g0987")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("h1mgC")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("756jv")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $300f970a4217b631$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("7cd5I")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("7cd5I")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("h1mgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e802874db56687b3$export$2e2bcd8739ae039);
    var $7cd5I;
    var $9T5KR;
    function $e802874db56687b3$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("7cd5I")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("9T5KR")).default)(lineNumber));
                return children;
            }
        };
    }
    var $e802874db56687b3$export$2e2bcd8739ae039 = $e802874db56687b3$var$createLineGenerator;
});
parcelRegister("7cd5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb90ce175080ebd7$export$2e2bcd8739ae039);
    var $9T5KR;
    function $fb90ce175080ebd7$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("9T5KR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16511336cb833d65$export$2e2bcd8739ae039);
    function $16511336cb833d65$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("756jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3722626977573637$export$2e2bcd8739ae039);
    var $7cd5I;
    function $3722626977573637$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("7cd5I")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $3722626977573637$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g0987", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$043f48aa29101879$export$2e2bcd8739ae039);
    function $043f48aa29101879$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("bAA7E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbb5a6617decb03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCYD;
    function $ffbb5a6617decb03$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("laCYD")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("laCYD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b56eeb7e6ac46855$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47G8n;
    var $dE7lx;
    var $4CTxJ;
    function $b56eeb7e6ac46855$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $b56eeb7e6ac46855$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("dE7lx")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47G8n")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("4CTxJ")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $b56eeb7e6ac46855$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("47G8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8606b73bc0e8d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $barbM;
    function $6c8606b73bc0e8d9$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            tag: $6c8606b73bc0e8d9$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $6c8606b73bc0e8d9$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("barbM", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$c9e1f2aa239b72a9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $AHUyh;
    const $c9e1f2aa239b72a9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $c9e1f2aa239b72a9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c9e1f2aa239b72a9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("dE7lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511185a3065642e8$export$2e2bcd8739ae039);
    const $511185a3065642e8$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $511185a3065642e8$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($511185a3065642e8$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("4CTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfcf1fd1989f08a6$export$2e2bcd8739ae039);
    var $laCYD;
    function $cfcf1fd1989f08a6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("laCYD")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UU68;
    var $iozM6;
    var $6Ll2T;
    var $99gde;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iozM6"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UU68")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("iozM6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d646380862d200fa$var$_react = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d646380862d200fa$var$_copy = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("4BWWV")));
    var $d646380862d200fa$var$_copy2 = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("gu5qi")));
    function $d646380862d200fa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d646380862d200fa$var$CopyIcon = (props)=>$d646380862d200fa$var$_react.default.createElement($d646380862d200fa$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $d646380862d200fa$var$_copy2.default
        }, props));
    $d646380862d200fa$var$CopyIcon.Name = 'CopyIconMigration';
    var $d646380862d200fa$var$_default = module.exports.default = $d646380862d200fa$var$CopyIcon;
});
parcelRegister("4BWWV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35b85845832ae75f$var$_react = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35b85845832ae75f$var$_UNSAFE_baseNew = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $35b85845832ae75f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35b85845832ae75f$var$CopyIcon = (props)=>$35b85845832ae75f$var$_react.default.createElement($35b85845832ae75f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $35b85845832ae75f$var$CopyIcon.displayName = 'CopyIcon';
    var $35b85845832ae75f$var$_default = module.exports.default = $35b85845832ae75f$var$CopyIcon;
});
parcelRegister("gu5qi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c003a79a3c70e52e$var$_react = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c003a79a3c70e52e$var$_copy = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("4BWWV")));
    function $c003a79a3c70e52e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c003a79a3c70e52e$var$CopyIcon = (props)=>$c003a79a3c70e52e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $c003a79a3c70e52e$var$_copy.default
        }));
    $c003a79a3c70e52e$var$CopyIcon.displayName = 'CopyIcon';
    var $c003a79a3c70e52e$var$_default = module.exports.default = $c003a79a3c70e52e$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $loZC0;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("4S0uJ", function(module, exports) {
    $parcel$export(module.exports, "PageStyle", ()=>$7307247c9fc02c84$export$c59987a647e9a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dUzNt;
    const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null, children));
    $7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
        Page: (0, (0, parcelRequire("dUzNt")).default)
    };
    var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
    const $7307247c9fc02c84$var$JSDSpaPageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dUzNt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ee69114caaf0a79$export$2e2bcd8739ae039);
    var $ip1ks;
    var $esRRj;
    var $PhrmH;
    var $1ee69114caaf0a79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ip1ks")).default);
});
parcelRegister("ip1ks", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50f4f87827a8a74$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2xIx0;
    function $c50f4f87827a8a74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c50f4f87827a8a74$var$bannerStyles = {
        name: "4oew4k",
        styles: "width:100%;position:fixed"
    };
    const $c50f4f87827a8a74$var$bannerContainerStyles = {
        name: "1x3pv69",
        styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
    };
    const $c50f4f87827a8a74$var$pageContentStyles = {
        name: "15n167b",
        styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$wrapperStyles = {
        name: "m5v4sl",
        styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
    };
    const $c50f4f87827a8a74$var$mainContainerStyles = {
        name: "1cete8c",
        styles: "display:flex;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$navigationStyles = {
        name: "wrqbg1",
        styles: "position:relative;z-index:2"
    };
    const $c50f4f87827a8a74$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, (0, parcelRequire("2xIx0")).defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$wrapperStyles,
            "data-testid": testId
        }, banner ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerContainerStyles,
            style: {
                height: isBannerOpen ? `${bannerHeight}px` : '0'
            },
            "aria-hidden": !isBannerOpen,
            "data-testid": testId ? `${testId}--banner-container` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerStyles
        }, banner)) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$mainContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$navigationStyles
        }, navigation), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$pageContentStyles
        }, children)));
    };
    var $c50f4f87827a8a74$export$2e2bcd8739ae039 = $c50f4f87827a8a74$var$Page;
});
parcelRegister("2xIx0", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$03960cd5eff6a11d$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$03960cd5eff6a11d$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$03960cd5eff6a11d$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$03960cd5eff6a11d$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$03960cd5eff6a11d$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$03960cd5eff6a11d$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$03960cd5eff6a11d$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$03960cd5eff6a11d$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$03960cd5eff6a11d$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$03960cd5eff6a11d$export$936829b4511db3e4);
    const $03960cd5eff6a11d$export$3aaf3a78c909ea56 = 8;
    const $03960cd5eff6a11d$export$74797698e12f8baa = 12;
    const $03960cd5eff6a11d$export$b8241a1616ab1b96 = $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 10;
    const $03960cd5eff6a11d$export$2a89a65a43bab52d = {
        comfortable: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 5,
        cosy: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 2,
        compact: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 0.5
    };
    const $03960cd5eff6a11d$export$8ec7372efd74b753 = 'cosy';
    const $03960cd5eff6a11d$export$d77f83c3d17a7b8a = 52;
    const $03960cd5eff6a11d$export$f8725d21f81f3e01 = 0;
    const $03960cd5eff6a11d$export$2303d2bd9eeff99a = 'fixed';
    const $03960cd5eff6a11d$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $03960cd5eff6a11d$export$8b7e31f391e6e681 = '--ds-column-span';
    const $03960cd5eff6a11d$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("esRRj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a731a05bdccc64ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    var $2cP5D;
    var $PhrmH;
    var $6MCgd;
    const $a731a05bdccc64ea$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("PhrmH")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("2xIx0")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("2xIx0")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MCgd")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2cP5D")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $a731a05bdccc64ea$export$2e2bcd8739ae039 = $a731a05bdccc64ea$var$GridWrapper;
});
parcelRegister("2cP5D", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$674dfadcfd40015c$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    function $674dfadcfd40015c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $674dfadcfd40015c$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $674dfadcfd40015c$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}) * ${(0, (0, parcelRequire("2xIx0")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $674dfadcfd40015c$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`
    });
    const $674dfadcfd40015c$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("2xIx0")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $674dfadcfd40015c$var$gridStyles,
                $674dfadcfd40015c$var$gridLayoutStyles[layout],
                isNested && $674dfadcfd40015c$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("2xIx0")).varGridSpacing)]: `${(0, (0, parcelRequire("2xIx0")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("6MCgd", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$d3f7b1d05770bd6c$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    const $d3f7b1d05770bd6c$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("2xIx0")).defaultSpacing),
        columns: (0, (0, parcelRequire("2xIx0")).defaultGridColumns)
    });
});
parcelRegister("PhrmH", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$505f9b94cbbad1b8$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$505f9b94cbbad1b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    var $505f9b94cbbad1b8$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($505f9b94cbbad1b8$var$ColumnVariant || ($505f9b94cbbad1b8$var$ColumnVariant = {}));
    const $505f9b94cbbad1b8$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("2xIx0")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $505f9b94cbbad1b8$var$availableWidth = '99.9999%';
    const $505f9b94cbbad1b8$var$singleColumnWidth = `(${$505f9b94cbbad1b8$var$availableWidth} / var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}))`;
    const $505f9b94cbbad1b8$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $505f9b94cbbad1b8$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("2xIx0")).varColumnSpan)}) - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $505f9b94cbbad1b8$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("2xIx0")).defaultMedium)
    });
    const $505f9b94cbbad1b8$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("2xIx0")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $505f9b94cbbad1b8$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($505f9b94cbbad1b8$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $505f9b94cbbad1b8$var$gridColumnStyles,
                $505f9b94cbbad1b8$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $505f9b94cbbad1b8$export$2e2bcd8739ae039 = $505f9b94cbbad1b8$var$GridColumn;
});
parcelRegister("cz40O", function(module, exports) {
    $parcel$export(module.exports, "SpaPageWrapper", ()=>$2099b56eb86565d0$export$577514961fbf4842);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $9sGI6;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    var $8pMQX;
    const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
        const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : (0, ($parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        }
        if (projectContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, (0, ($parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
        return null;
    };
    const $2099b56eb86565d0$export$577514961fbf4842 = (0, (0, parcelRequire("9sGI6")).default)($2099b56eb86565d0$export$91f88695e0d311a5, {
        AccessCheck: (0, (0, parcelRequire("cYaqS")).default),
        GenericError: (0, (0, parcelRequire("8pMQX")).GenericError),
        ProjectNotFound: (0, (0, parcelRequire("8pMQX")).ProjectNotFound),
        AuthenticationCheck: (0, (0, parcelRequire("9NiTW")).AuthenticationCheck),
        SubProductUpdater: (0, (0, parcelRequire("9dbF6")).SubProductUpdater)
    });
    var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $7tQej;
    var $bmKPg;
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $bmKPg;
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("fP2yI", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$514ba5774a77a46a$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $doZTA;
    var $l8dz7;
    var $2r4US;
    var $cZ1Pf;
    var $6Ll2T;
    var $fm763;
    var $k0Jvh;
    var $99gde;
    const $514ba5774a77a46a$var$headerContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.200',
        marginBottom: 'space.200',
        marginLeft: 'space.300',
        marginRight: 'space.300',
        gap: 'space.050'
    });
    const $514ba5774a77a46a$var$headerBorder = (0, (0, parcelRequire("99gde")).xcss)({
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
    });
    const $514ba5774a77a46a$var$headerElementsSpace = (0, (0, parcelRequire("99gde")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'end'
    });
    const $514ba5774a77a46a$export$8b251419efc915eb = ({ title: title, breadcrumbs: breadcrumbs, actions: actions })=>{
        const [, { push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const onClick = (link)=>{
            push(link);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            xcss: $514ba5774a77a46a$var$headerBorder
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            xcss: $514ba5774a77a46a$var$headerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2r4US")).default), null, breadcrumbs.map((crumb)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8dz7")).default), {
                onClick: ()=>onClick(crumb.href),
                text: crumb.text
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $514ba5774a77a46a$var$headerElementsSpace
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large"
        }, title), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, actions)))));
    };
});
parcelRegister("1BIUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73c84489faf50721$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0Brz;
    var $jS4lj;
    var $c2D8L;
    var $gEFwt;
    var $koVbs;
    var $kwX4O;
    const $73c84489faf50721$var$ProjectSettingsBreadcrumb = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
                text: formatMessage((0, (0, parcelRequire("kwX4O")).default).reportsBreadcrumbTitle),
                type: 'projectSettings'
            }
        })));
    };
    var $73c84489faf50721$export$2e2bcd8739ae039 = $73c84489faf50721$var$ProjectSettingsBreadcrumb;
});
parcelRegister("kwX4O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0683f400a1ea0c3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0683f400a1ea0c3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reportsBreadcrumbTitle: {
            "id": "spa-apps-servicedesk-reports-base.breadcrumb.reports-breadcrumb-title",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("cHb7s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$595a97230cddb61d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZ1Pf;
    var $6Ll2T;
    var $99gde;
    var $cS37j;
    var $az4zD;
    const $595a97230cddb61d$var$Header = ({ title: title, breadcrumbs: breadcrumbs, intl: { formatMessage: formatMessage }, actions: actions })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            breadcrumbs: breadcrumbs
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $595a97230cddb61d$var$titleContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large",
            as: "h1"
        }, title && formatMessage(title))), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, actions)));
    var $595a97230cddb61d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($595a97230cddb61d$var$Header);
    const $595a97230cddb61d$var$titleContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $95hAT;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95hAT")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("95hAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$034db3cc90f9772f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6fW4E;
    const $034db3cc90f9772f$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $034db3cc90f9772f$export$2e2bcd8739ae039 = $034db3cc90f9772f$var$PageHeader;
});
parcelRegister("6fW4E", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$3eb2c0b3fddef147$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$3eb2c0b3fddef147$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$3eb2c0b3fddef147$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$3eb2c0b3fddef147$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$3eb2c0b3fddef147$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$3eb2c0b3fddef147$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $99gde;
    function $3eb2c0b3fddef147$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3eb2c0b3fddef147$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $3eb2c0b3fddef147$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $3eb2c0b3fddef147$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $3eb2c0b3fddef147$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $3eb2c0b3fddef147$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $3eb2c0b3fddef147$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $3eb2c0b3fddef147$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $3eb2c0b3fddef147$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $3eb2c0b3fddef147$var$bottomBarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $3eb2c0b3fddef147$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$outerStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $3eb2c0b3fddef147$var$titleStyles,
                truncateTitle && $3eb2c0b3fddef147$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $3eb2c0b3fddef147$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleWrapperStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleContainerStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$actionStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $3eb2c0b3fddef147$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("gMO5K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ceb509eee39709$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b6ceb509eee39709$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsBreadcrumb: {
            "id": "spa-apps-servicedesk-reports-base.projects-breadcrumb",
            "defaultMessage": "Projects"
        },
        reportsBreadcrumb: {
            "id": "spa-apps-servicedesk-reports-base.reports-breadcrumb",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("13lzj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efff5bc3f5eed044$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bYGxE;
    var $g5X3G;
    var $eEETY;
    const $efff5bc3f5eed044$var$KbRequestsReportsSpa = ({ pageContext: pageContext })=>{
        const { projectKey: projectKey, projectId: projectId, projectName: projectName } = pageContext;
        const routerProps = (0, (0, parcelRequire("eEETY")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYGxE")).default), {
            baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
            projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey),
            projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(String(projectId)),
            routerProps: routerProps,
            projectName: projectName
        });
    };
    var $efff5bc3f5eed044$export$2e2bcd8739ae039 = $efff5bc3f5eed044$var$KbRequestsReportsSpa;
});
parcelRegister("bYGxE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d61cfdb457a8833$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $6jY6G;
    var $dp7nU;
    var $2m0sQ;
    var $4Kc9u;
    const $4d61cfdb457a8833$var$KbRequestsReports = ({ routerProps: routerProps, baseUrl: baseUrl, projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        (0, $5uXOq.useEffect)(()=>{
            if (route.perfMetricKey) (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey);
        }, [
            routerProps.reportId,
            route.perfMetricKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "reportsKBRequests",
            packageName: "jiraServicedeskKbRequestsReports",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dp7nU")).UIStateContainer), {
            scope: "kb-requests",
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectId: projectId,
            routerProps: routerProps,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Kc9u")).KbRequestsReportsMain), {
            routerProps: routerProps,
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectName
        })));
    };
    var $4d61cfdb457a8833$export$2e2bcd8739ae039 = $4d61cfdb457a8833$var$KbRequestsReports;
});
parcelRegister("dp7nU", function(module, exports) {
    $parcel$export(module.exports, "useUIStateStore", ()=>$59f9dc999a2e968d$export$bc19f6a0f463699c);
    $parcel$export(module.exports, "UIStateContainer", ()=>$59f9dc999a2e968d$export$7a236534a832e2a0);
    var $g5X3G;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $kmKHQ;
    var $39vSm;
    const $59f9dc999a2e968d$export$d4c72bab9d6cc13a = {
        dateFilterQuery: {
            reportId: '',
            timescaleId: 0
        },
        baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
        projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(''),
        projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(''),
        projectName: ''
    };
    const $59f9dc999a2e968d$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'CustomReportsUiState',
        initialState: $59f9dc999a2e968d$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("39vSm"))
    });
    const $59f9dc999a2e968d$export$bc19f6a0f463699c = (0, (0, parcelRequire("3sQ5x")).createHook)($59f9dc999a2e968d$export$6f57813fe9f31bf9);
    const $59f9dc999a2e968d$var$onContainerChange = ()=>({ getState: getState, setState: setState }, { routerProps: routerProps, ...projectContext })=>{
            const { dateFilterQuery: dateFilterQuery } = getState();
            if (routerProps && routerProps.timescaleId === undefined) setState({
                dateFilterQuery: (0, (0, parcelRequire("kmKHQ")).getReportsQueryParams)({
                    ...dateFilterQuery,
                    reportId: routerProps.reportId || ''
                }),
                ...projectContext
            });
            else setState({
                dateFilterQuery: (0, (0, parcelRequire("kmKHQ")).getReportsQueryParams)(routerProps || {
                    reportId: ''
                }),
                ...projectContext
            });
        };
    const $59f9dc999a2e968d$export$7a236534a832e2a0 = (0, (0, parcelRequire("gg7kZ")).createContainer)($59f9dc999a2e968d$export$6f57813fe9f31bf9, {
        onInit: $59f9dc999a2e968d$var$onContainerChange,
        onUpdate: $59f9dc999a2e968d$var$onContainerChange
    });
});
parcelRegister("kmKHQ", function(module, exports) {
    $parcel$export(module.exports, "getReportsQueryParams", ()=>$99d62706a41aea1a$export$7f3783713a221f4d);
    var $32TkL;
    var $bvS9p;
    var $88d59;
    const $99d62706a41aea1a$export$7f3783713a221f4d = (routerProps, defaultQuery)=>{
        const timescaleId = Number(routerProps.timescaleId) || Number(defaultQuery && defaultQuery.timescaleId) || Number((0, (0, parcelRequire("88d59")).REPORT_DEFAULTS).searchByPastSevenDays);
        if ((0, (0, parcelRequire("bvS9p")).isCustomTimeScale)(timescaleId)) {
            const { startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown } = routerProps;
            if (startDate !== undefined && endDate !== undefined) return {
                reportId: routerProps.reportId,
                timescaleId: timescaleId,
                startDate: startDate,
                endDate: endDate,
                timeBreakdown: timeBreakdown || (0, (0, parcelRequire("88d59")).REPORT_DEFAULTS).timeBreakdown
            };
            if (defaultQuery !== undefined) return {
                ...defaultQuery,
                reportId: routerProps.reportId
            };
        }
        return {
            reportId: routerProps.reportId,
            ...(0, (0, parcelRequire("32TkL")).timescaleToTimePeriodBreakdownMap)[timescaleId],
            timescaleId: timescaleId
        };
    };
});
parcelRegister("32TkL", function(module, exports) {
    $parcel$export(module.exports, "ABORT_ERR", ()=>$e9f584bc433c5797$export$16e59c3676e6ec88);
    $parcel$export(module.exports, "stringifyOptions", ()=>$e9f584bc433c5797$export$8ca327d1d4eb828a);
    $parcel$export(module.exports, "timescaleToTimePeriodBreakdownMap", ()=>$e9f584bc433c5797$export$60e856ddfbc4076a);
    var $9nenm;
    const $e9f584bc433c5797$export$16e59c3676e6ec88 = 20;
    const $e9f584bc433c5797$export$8ca327d1d4eb828a = {
        skipNull: true,
        sort: false
    };
    const $e9f584bc433c5797$export$60e856ddfbc4076a = {
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).past48Hours]: {
            timeBreakdown: 'h',
            timePeriod: 'PT48H'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).past7Days]: {
            timeBreakdown: 'd',
            timePeriod: 'P7D'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).past14Days]: {
            timeBreakdown: 'd',
            timePeriod: 'P14D'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).past30Days]: {
            timeBreakdown: 'd',
            timePeriod: 'P30D'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).pastQuarterByDay]: {
            timeBreakdown: 'd',
            timePeriod: 'P3M'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).pastQuarterByWeek]: {
            timeBreakdown: 'w',
            timePeriod: 'P3M'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).pastYearByWeek]: {
            timeBreakdown: 'w',
            timePeriod: 'P1Y'
        },
        [(0, (0, parcelRequire("9nenm")).TIME_SCALES).pastYearByMonth]: {
            timeBreakdown: 'm',
            timePeriod: 'P1Y'
        }
    };
});
parcelRegister("9nenm", function(module, exports) {
    $parcel$export(module.exports, "LINE", ()=>$118c88390a21cde0$export$f4dbacc416028787);
    $parcel$export(module.exports, "ISO_DATE_FORMAT", ()=>$118c88390a21cde0$export$e63e1e1c17a0e8b);
    $parcel$export(module.exports, "SEARCH_BY", ()=>$118c88390a21cde0$export$73579ee3a6c6da2d);
    $parcel$export(module.exports, "TIME_SCALES", ()=>$118c88390a21cde0$export$f4b7bd2d183699);
    $parcel$export(module.exports, "TIME_SCALE_TO_LABEL_FORMAT_MAP", ()=>$118c88390a21cde0$export$d294667ef4c55b77);
    $parcel$export(module.exports, "TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP", ()=>$118c88390a21cde0$export$d747786a0fd0612a);
    $parcel$export(module.exports, "TIME_SCALE_TO_EXPANDED_FORMAT_MAP", ()=>$118c88390a21cde0$export$10269a0feece8850);
    $parcel$export(module.exports, "HOUR_TIME_SCALES", ()=>$118c88390a21cde0$export$3a0518a58fb5a137);
    $parcel$export(module.exports, "WEEK_TIME_SCALES", ()=>$118c88390a21cde0$export$4a7e81f242db56eb);
    $parcel$export(module.exports, "MONTH_TIME_SCALES", ()=>$118c88390a21cde0$export$4d0f9c0d6ea181d8);
    const $118c88390a21cde0$export$f4dbacc416028787 = 'line';
    const $118c88390a21cde0$export$819df699d4b89202 = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };
    const $118c88390a21cde0$export$aeb3068fe93add26 = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    };
    const $118c88390a21cde0$export$91f5690a90ac7547 = {
        weekday: 'short',
        hour: 'numeric',
        hour12: true
    };
    const $118c88390a21cde0$export$2879907f3ed21511 = {
        day: 'numeric',
        month: 'short'
    };
    const $118c88390a21cde0$export$717efa0dc6e0515d = {
        weekday: 'long',
        hour: 'numeric',
        hour12: true
    };
    const $118c88390a21cde0$export$d8a30ff1ae1d321e = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    };
    const $118c88390a21cde0$export$6da506db6d19da8d = {
        month: 'long',
        year: 'numeric'
    };
    const $118c88390a21cde0$export$94f447fe753c3528 = {
        month: 'short'
    };
    const $118c88390a21cde0$export$c003002ffeb9f3c0 = {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };
    const $118c88390a21cde0$export$e63e1e1c17a0e8b = 'yyyy-MM-dd';
    const $118c88390a21cde0$export$430f49a23dab85d4 = 'YYYY-MM-DD';
    const $118c88390a21cde0$export$73579ee3a6c6da2d = {
        hourly: 'h',
        daily: 'd',
        weekly: 'w',
        monthly: 'm'
    };
    const $118c88390a21cde0$export$f4b7bd2d183699 = {
        past48Hours: '1',
        past7Days: '2',
        past14Days: '3',
        past30Days: '4',
        pastQuarterByDay: '5',
        pastQuarterByWeek: '6',
        pastYearByWeek: '7',
        pastYearByMonth: '8',
        customTimeScale: 9,
        customDatesByHours: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.hourly}`,
        customDatesByDays: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.daily}`,
        customDatesByWeeks: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.weekly}`,
        customDatesByMonth: `9${$118c88390a21cde0$export$73579ee3a6c6da2d.monthly}`
    };
    const $118c88390a21cde0$export$d294667ef4c55b77 = {
        [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$91f5690a90ac7547,
        [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$94f447fe753c3528,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$91f5690a90ac7547,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$94f447fe753c3528
    };
    const $118c88390a21cde0$export$d747786a0fd0612a = {
        [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$717efa0dc6e0515d,
        [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$aeb3068fe93add26,
        [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$aeb3068fe93add26,
        [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$aeb3068fe93add26,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$6da506db6d19da8d,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$717efa0dc6e0515d,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$aeb3068fe93add26,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$6da506db6d19da8d
    };
    const $118c88390a21cde0$export$10269a0feece8850 = {
        [$118c88390a21cde0$export$f4b7bd2d183699.past48Hours]: $118c88390a21cde0$export$819df699d4b89202,
        [$118c88390a21cde0$export$f4b7bd2d183699.past7Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
        [$118c88390a21cde0$export$f4b7bd2d183699.past14Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
        [$118c88390a21cde0$export$f4b7bd2d183699.past30Days]: $118c88390a21cde0$export$c003002ffeb9f3c0,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByDay]: $118c88390a21cde0$export$2879907f3ed21511,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth]: $118c88390a21cde0$export$6da506db6d19da8d,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours]: $118c88390a21cde0$export$819df699d4b89202,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByDays]: $118c88390a21cde0$export$aeb3068fe93add26,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks]: $118c88390a21cde0$export$d8a30ff1ae1d321e,
        [$118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth]: $118c88390a21cde0$export$6da506db6d19da8d
    };
    const $118c88390a21cde0$export$3a0518a58fb5a137 = [
        $118c88390a21cde0$export$f4b7bd2d183699.past48Hours,
        $118c88390a21cde0$export$f4b7bd2d183699.customDatesByHours
    ];
    const $118c88390a21cde0$export$4a7e81f242db56eb = [
        $118c88390a21cde0$export$f4b7bd2d183699.pastQuarterByWeek,
        $118c88390a21cde0$export$f4b7bd2d183699.pastYearByWeek,
        $118c88390a21cde0$export$f4b7bd2d183699.customDatesByWeeks
    ];
    const $118c88390a21cde0$export$4d0f9c0d6ea181d8 = [
        $118c88390a21cde0$export$f4b7bd2d183699.pastYearByMonth,
        $118c88390a21cde0$export$f4b7bd2d183699.customDatesByMonth
    ];
});
parcelRegister("bvS9p", function(module, exports) {
    $parcel$export(module.exports, "isCustomTimeScale", ()=>$6fa57c5281275469$export$a0a0756dadf12882);
    $parcel$export(module.exports, "transformSummarySource", ()=>$6fa57c5281275469$export$a1b7447ceadada1e);
    $parcel$export(module.exports, "transformCustomSummarySource", ()=>$6fa57c5281275469$export$ca4cf779304602d7);
    var $jcw0u;
    var $8npOo;
    var $9nenm;
    var $V3NN5;
    var $cnldZ;
    const $6fa57c5281275469$export$a0a0756dadf12882 = (timescaleId)=>timescaleId === (0, (0, parcelRequire("9nenm")).TIME_SCALES).customTimeScale;
    const $6fa57c5281275469$var$formatChartData = (source, searchQueryString)=>{
        const result = {
            id: '',
            label: '',
            timezone: '',
            startDate: '',
            endDate: '',
            searchBy: '',
            axisLabels: [],
            chartSeries: [],
            isPercentage: false,
            yAxisMinMax: {}
        };
        result.id = source.reportId;
        result.label = source.name;
        result.timezone = source.timezone;
        try {
            result.startDate = (0, (0, parcelRequire("V3NN5")).formatDateISO)(source.startTime, source.timezone);
            result.endDate = (0, (0, parcelRequire("V3NN5")).formatDateISO)(source.endTime, source.timezone);
        } catch (err) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'formatChartData',
                    packageName: 'jiraServicedeskReportsCommon',
                    teamName: 'itsm-saga'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: err,
                attributes: {
                    startDate: source.startTime,
                    endDate: source.endTime,
                    timezone: source.timezone
                }
            });
            throw err;
        }
        if ((0, (0, parcelRequire("9nenm")).MONTH_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, (0, parcelRequire("9nenm")).SEARCH_BY).monthly;
        else if ((0, (0, parcelRequire("9nenm")).WEEK_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, (0, parcelRequire("9nenm")).SEARCH_BY).weekly;
        else if ((0, (0, parcelRequire("9nenm")).HOUR_TIME_SCALES).includes(searchQueryString)) result.searchBy = (0, (0, parcelRequire("9nenm")).SEARCH_BY).hourly;
        else result.searchBy = (0, (0, parcelRequire("9nenm")).SEARCH_BY).daily;
        return result;
    };
    const $6fa57c5281275469$export$a1b7447ceadada1e = (source, searchParams, intl)=>{
        const searchQueryString = $6fa57c5281275469$export$a0a0756dadf12882(searchParams.timescaleId) ? `${searchParams.timescaleId}${searchParams.timeBreakdown || ''}` : `${searchParams.timescaleId}`;
        const result = $6fa57c5281275469$var$formatChartData(source, searchQueryString);
        result.yAxisMinMax = (0, (0, parcelRequire("cnldZ")).getYAxisMinMax)(source);
        const formatter = (0, (0, parcelRequire("cnldZ")).getValueFormatter)(source);
        const chartItems = source.series.map((s, seriesIndex)=>({
                type: (0, (0, parcelRequire("9nenm")).LINE),
                seriesIndex: seriesIndex,
                seriesId: s.seriesId,
                name: s.label,
                summaryValue: formatter(s.seriesSummaryValue),
                itemStyle: {
                    color: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                    borderWidth: 2,
                    shadowColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color)
                },
                showAllSymbol: true,
                emphasis: {
                    itemStyle: {
                        borderColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                        shadowColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                        borderWidth: 7,
                        shadowBlur: 0
                    }
                },
                symbolSize: 9,
                data: s.data.map(({ x: x, y: y }, dataIndex)=>({
                        id: x,
                        seriesId: s.seriesId,
                        seriesIndex: seriesIndex,
                        dataIndex: dataIndex,
                        label: (0, (0, parcelRequire("V3NN5")).getLabel)(x, source.timezone, searchQueryString, intl),
                        ...formatter(y),
                        ...(0, (0, parcelRequire("V3NN5")).getMetaData)(x, source.timezone, searchQueryString, intl)
                    }))
            }));
        result.chartSeries = chartItems;
        result.taskId = source.taskId;
        if (chartItems.length > 0) result.axisLabels = chartItems[0].data.map(({ label: label })=>label);
        return result;
    };
    const $6fa57c5281275469$export$ca4cf779304602d7 = (source, searchParams, intl)=>{
        const searchQueryString = $6fa57c5281275469$export$a0a0756dadf12882(searchParams.timescaleId) ? `${searchParams.timescaleId}${searchParams.timeBreakdown || ''}` : `${searchParams.timescaleId}`;
        const result = $6fa57c5281275469$var$formatChartData(source, searchQueryString);
        result.isPercentage = (0, (0, parcelRequire("cnldZ")).isPercentageChart)(source);
        result.yAxisMinMax = (0, (0, parcelRequire("cnldZ")).getYAxisMinMax)(source);
        const formatter = (0, (0, parcelRequire("cnldZ")).getValueFormatter)(source);
        const chartItems = source.series.map((s, seriesIndex)=>({
                type: (0, (0, parcelRequire("9nenm")).LINE),
                typeKey: s.seriesType.typeKey,
                seriesIndex: seriesIndex,
                seriesId: s.seriesId,
                name: s.label,
                summaryValue: formatter(s.seriesSummaryValue),
                itemStyle: {
                    color: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                    borderWidth: 2,
                    shadowColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color)
                },
                showAllSymbol: true,
                emphasis: {
                    itemStyle: {
                        borderColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                        shadowColor: (0, (0, parcelRequire("8npOo")).dynamicColorToToken)(s.color),
                        borderWidth: 7,
                        shadowBlur: 0
                    }
                },
                symbolSize: 9,
                data: s.data.map(({ x: x, y: y }, dataIndex)=>({
                        id: x,
                        seriesId: s.seriesId,
                        seriesIndex: seriesIndex,
                        dataIndex: dataIndex,
                        label: (0, (0, parcelRequire("V3NN5")).getLabel)(x, source.timezone, searchQueryString, intl),
                        ...formatter(y),
                        ...(0, (0, parcelRequire("V3NN5")).getMetaData)(x, source.timezone, searchQueryString, intl)
                    })),
                markLine: (0, (0, parcelRequire("cnldZ")).getTargetMarkLine)(source),
                seriesType: s.seriesType
            }));
        result.chartSeries = chartItems;
        result.target = source.target;
        if (chartItems.length > 0) result.axisLabels = chartItems[0].data.map(({ label: label })=>label);
        result.taskId = source.taskId;
        return result;
    };
});
parcelRegister("8npOo", function(module, exports) {
    $parcel$export(module.exports, "dynamicColorToToken", ()=>$3d4e9fa54280eebb$export$6429b014bf18a94b);
    var $5w2JH;
    var $jcw0u;
    const $3d4e9fa54280eebb$export$6429b014bf18a94b = (color, isCanvas = true)=>{
        switch(color){
            case '#d04437':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.red.bolder', '#d04437') : "var(--ds-chart-red-bolder, #d04437)";
            case '#e7a19B':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.red.bold', '#e7a19B') : "var(--ds-chart-red-bold, #e7a19B)";
            case '#14892c':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.bolder', '#14892c') : "var(--ds-chart-green-bolder, #14892c)";
            case '#89c495':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.bold', '#89c495') : "var(--ds-chart-green-bold, #89c495)";
            case '#815b3a':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.yellow.bolder', '#815b3a') : "var(--ds-chart-yellow-bolder, #815b3a)";
            case '#c0ad9c':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.yellow.bold', '#c0ad9c') : "var(--ds-chart-yellow-bold, #c0ad9c)";
            case '#ea632b':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.orange.bolder', '#ea632b') : "var(--ds-chart-orange-bolder, #ea632b)";
            case '#f8d0ab':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.orange.bold', '#f8d0ab') : "var(--ds-chart-orange-bold, #f8d0ab)";
            case '#d39c3f':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.orange.boldest', '#d39c3f') : "var(--ds-chart-orange-boldest, #d39c3f)";
            case '#e9cd9f':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.yellow.boldest', '#e9cd9f') : "var(--ds-chart-yellow-boldest, #e9cd9f)";
            case '#8eb021':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.boldest', '#8eb021') : "var(--ds-chart-green-boldest, #8eb021)";
            case '#c6d790':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.bold', '#c6d790') : "var(--ds-chart-green-bold, #c6d790)";
            case '#ac707a':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.red.boldest', '#ac707a') : "var(--ds-chart-red-boldest, #ac707a)";
            case '#d5b7bc':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.red.bolder.hovered', '#d5b7bc') : "var(--ds-chart-red-bolder-hovered, #d5b7bc)";
            case '#654982':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.purple.bolder', '#654982') : "var(--ds-chart-purple-bolder, #654982)";
            case '#b2a4c0':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.purple.bold', '#b2a4c0') : "var(--ds-chart-purple-bold, #b2a4c0)";
            case '#7bc1a1':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.bolder', '#7bc1a1') : "var(--ds-chart-green-bolder, #7bc1a1)";
            case '#bde0d0':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.bold', '#bde0d0') : "var(--ds-chart-green-bold, #bde0d0)";
            case '#f15c75':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.magenta.bolder', '#f15c75') : "var(--ds-chart-magenta-bolder, #f15c75)";
            case '#fac8d8':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.magenta.bold', '#fac8d8') : "var(--ds-chart-magenta-bold, #fac8d8)";
            case '#59afe1':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.teal.bolder', '#59afe1') : "var(--ds-chart-teal-bolder, #59afe1)";
            case '#acd7f0':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.teal.bold', '#acd7f0') : "var(--ds-chart-teal-bold, #acd7f0)";
            case '#333':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.gray.bolder', '#333') : "var(--ds-chart-gray-bolder, #333)";
            case '#999':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.gray.bold', '#999') : "var(--ds-chart-gray-bold, #999)";
            case '#3572b0':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.blue.bolder', '#3572b0') : "var(--ds-chart-blue-bolder, #3572b0)";
            case '#84bbc6':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.blue.bold', '#84bbc6') : "var(--ds-chart-blue-bold, #84bbc6)";
            case '#67ab49':
                return isCanvas ? (0, (0, parcelRequire("5w2JH")).default)('color.chart.green.boldest', '#67ab49') : "var(--ds-chart-green-boldest, #67ab49)";
            default:
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'dynamicColorToToken',
                        packageName: 'jiraServicedeskReportsCommon',
                        teamName: 'itsm-saga'
                    },
                    attributes: {
                        color: color
                    }
                });
                return color;
        }
    };
});
parcelRegister("V3NN5", function(module, exports) {
    $parcel$export(module.exports, "getLabel", ()=>$a1ecb66eda455221$export$236350842f3cd9bc);
    $parcel$export(module.exports, "getMetaData", ()=>$a1ecb66eda455221$export$929b5cc2a4ac0922);
    $parcel$export(module.exports, "formatDateISO", ()=>$a1ecb66eda455221$export$70d0d14fb4385eaf);
    var $dwDIK;
    var $7CMcV;
    var $9nenm;
    const $a1ecb66eda455221$var$formatDateWithInternationalisation = (intl, utcTimestamp, timezone, formatOps)=>{
        const options = {
            ...formatOps,
            timeZone: timezone
        };
        return intl.formatDate(utcTimestamp, options);
    };
    const $a1ecb66eda455221$export$236350842f3cd9bc = (utcTimestamp, timezone, searchQueryString, intl)=>{
        const formatType = (0, (0, parcelRequire("9nenm")).TIME_SCALE_TO_LABEL_FORMAT_MAP)[searchQueryString];
        return $a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, formatType);
    };
    const $a1ecb66eda455221$export$929b5cc2a4ac0922 = (utcTimestamp, timezone, searchQueryString, intl)=>{
        const formatType = (0, (0, parcelRequire("9nenm")).TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP)[searchQueryString];
        const expandedFormatType = (0, (0, parcelRequire("9nenm")).TIME_SCALE_TO_EXPANDED_FORMAT_MAP)[searchQueryString];
        return {
            formattedDate: `${$a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, formatType)}`,
            expandedDate: `${$a1ecb66eda455221$var$formatDateWithInternationalisation(intl, utcTimestamp, timezone, expandedFormatType)}`
        };
    };
    const $a1ecb66eda455221$export$70d0d14fb4385eaf = (utcTimestamp, timezone)=>(0, (0, parcelRequire("dwDIK")).default)((0, (0, parcelRequire("7CMcV")).default)(utcTimestamp, timezone), (0, (0, parcelRequire("9nenm")).ISO_DATE_FORMAT), {
            timeZone: timezone
        });
});
parcelRegister("cnldZ", function(module, exports) {
    $parcel$export(module.exports, "getFormattedLabel", ()=>$2da17c9210f90187$export$73d65be4271316b7);
    $parcel$export(module.exports, "getYAxisMinMax", ()=>$2da17c9210f90187$export$6ee7d486ec3c7c13);
    $parcel$export(module.exports, "getValueFormatter", ()=>$2da17c9210f90187$export$f037bf6aad5a4e75);
    $parcel$export(module.exports, "isPercentageType", ()=>$2da17c9210f90187$export$dc62ac670e083e7f);
    $parcel$export(module.exports, "isPercentageChart", ()=>$2da17c9210f90187$export$b76b4efc5e57034a);
    $parcel$export(module.exports, "createMarkLine", ()=>$2da17c9210f90187$export$6d48878d5c505874);
    $parcel$export(module.exports, "getTargetMarkLine", ()=>$2da17c9210f90187$export$d0f6b554d3bfbf7c);
    var $fEeCa = parcelRequire("fEeCa");
    var $gwejS;
    var $7XUeK;
    var $3DR3e;
    var $4s7ll;
    var $5w2JH;
    var $1p96B;
    var $bHMD8;
    var $dRNTN;
    const $2da17c9210f90187$var$minimumInterval = 5;
    const $2da17c9210f90187$var$fiveMinutesInMilliSeconds = (0, (0, parcelRequire("4s7ll")).default)($2da17c9210f90187$var$minimumInterval);
    const $2da17c9210f90187$export$a7575cf0cdf968c5 = (value)=>({
            yAxisValue: value,
            value: (0, (0, parcelRequire("1p96B")).floatDifferenceOfDates)(new Date(value), new Date(0), 'months').toFixed((0, (0, parcelRequire("bHMD8")).TYPE_TIME_DECIMAL_PLACES)).toString(),
            valueType: (0, (0, parcelRequire("bHMD8")).VALUE_TYPES).months
        });
    const $2da17c9210f90187$export$7677066daa99156a = (value)=>({
            yAxisValue: value,
            value: (0, (0, parcelRequire("1p96B")).floatDifferenceOfDates)(new Date(value), new Date(0), 'days').toFixed((0, (0, parcelRequire("bHMD8")).TYPE_TIME_DECIMAL_PLACES)).toString(),
            valueType: (0, (0, parcelRequire("bHMD8")).VALUE_TYPES).days
        });
    const $2da17c9210f90187$export$537b2b4658db7016 = (value)=>({
            yAxisValue: value,
            value: (0, (0, parcelRequire("1p96B")).floatDifferenceOfDates)(new Date(value), new Date(0), 'hours').toFixed((0, (0, parcelRequire("bHMD8")).TYPE_TIME_DECIMAL_PLACES)).toString(),
            valueType: (0, (0, parcelRequire("bHMD8")).VALUE_TYPES).hours
        });
    const $2da17c9210f90187$export$c0ceab4d963647f5 = (value)=>({
            yAxisValue: value,
            value: (0, (0, parcelRequire("1p96B")).floatDifferenceOfDates)(new Date(value), new Date(0), 'minutes').toFixed((0, (0, parcelRequire("bHMD8")).TYPE_TIME_DECIMAL_PLACES)).toString(),
            valueType: (0, (0, parcelRequire("bHMD8")).VALUE_TYPES).minutes
        });
    const $2da17c9210f90187$export$8aab500945125417 = (value)=>({
            yAxisValue: value,
            value: value.toFixed((0, (0, parcelRequire("bHMD8")).TYPE_STAR_DECIMAL_PLACES)),
            valueType: ''
        });
    const $2da17c9210f90187$export$3e1eee59f5dc52be = (value)=>({
            yAxisValue: value,
            value: (value * 100).toFixed((0, (0, parcelRequire("bHMD8")).TYPE_PERCENTAGE_DECIMAL_PLACES)),
            valueType: (0, (0, parcelRequire("bHMD8")).VALUE_TYPES).percentage
        });
    const $2da17c9210f90187$export$ac7aad1fd2ffc519 = (value)=>({
            yAxisValue: value,
            value: value.toString(),
            valueType: ''
        });
    const $2da17c9210f90187$export$978ad5764137b5ad = (source)=>{
        const eachSeriesMaxValues = source.series.map(({ data: data })=>(0, ($parcel$interopDefault($fEeCa)))(data.map(({ y: y })=>y)));
        return (0, ($parcel$interopDefault($fEeCa)))(eachSeriesMaxValues);
    };
    const $2da17c9210f90187$export$73d65be4271316b7 = (type, value, formatMessage)=>{
        if ((0, (0, parcelRequire("dRNTN")).default)[type]) return `${value} ${formatMessage((0, (0, parcelRequire("dRNTN")).default)[type])}`;
        return value;
    };
    const $2da17c9210f90187$export$d039bddcd4b404fc = (maxYValue)=>{
        if (maxYValue > (0, (0, parcelRequire("3DR3e")).default)(new Date(0), 6).getTime()) return $2da17c9210f90187$export$a7575cf0cdf968c5;
        if (maxYValue > (0, (0, parcelRequire("gwejS")).default)(new Date(0), 30).getTime()) return $2da17c9210f90187$export$7677066daa99156a;
        if (maxYValue > (0, (0, parcelRequire("7XUeK")).default)(new Date(0), 2).getTime()) return $2da17c9210f90187$export$537b2b4658db7016;
        return $2da17c9210f90187$export$c0ceab4d963647f5;
    };
    const $2da17c9210f90187$export$4e29c52c0ab49da1 = (source)=>{
        if (source.series.length > 0) return source.series[0].yAxisType;
        return '';
    };
    const $2da17c9210f90187$export$6ee7d486ec3c7c13 = (source)=>{
        const yAxisType = $2da17c9210f90187$export$4e29c52c0ab49da1(source);
        let maxInterval;
        switch(yAxisType){
            case 0, (0, parcelRequire("bHMD8")).TYPE_TIME:
                {
                    const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                    if (maxYValue <= $2da17c9210f90187$var$fiveMinutesInMilliSeconds) maxInterval = $2da17c9210f90187$var$minimumInterval;
                    return {
                        min: 0,
                        max: maxInterval
                    };
                }
            case 0, (0, parcelRequire("bHMD8")).TYPE_PERCENTAGE:
                return {
                    min: 0,
                    max: 100
                };
            default:
                {
                    const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                    if (maxYValue <= $2da17c9210f90187$var$minimumInterval) maxInterval = $2da17c9210f90187$var$minimumInterval;
                    return {
                        min: 0,
                        max: maxInterval
                    };
                }
        }
    };
    const $2da17c9210f90187$export$f037bf6aad5a4e75 = (source)=>{
        const yAxisType = $2da17c9210f90187$export$4e29c52c0ab49da1(source);
        switch(yAxisType){
            case 0, (0, parcelRequire("bHMD8")).TYPE_TIME:
                {
                    const maxYValue = $2da17c9210f90187$export$978ad5764137b5ad(source);
                    return $2da17c9210f90187$export$d039bddcd4b404fc(maxYValue);
                }
            case 0, (0, parcelRequire("bHMD8")).TYPE_STAR:
                return $2da17c9210f90187$export$8aab500945125417;
            case 0, (0, parcelRequire("bHMD8")).TYPE_PERCENTAGE:
                return $2da17c9210f90187$export$3e1eee59f5dc52be;
            default:
                return $2da17c9210f90187$export$ac7aad1fd2ffc519;
        }
    };
    const $2da17c9210f90187$export$dc62ac670e083e7f = (type)=>type === (0, (0, parcelRequire("bHMD8")).PERCENTAGE_TYPE);
    const $2da17c9210f90187$export$b76b4efc5e57034a = (source)=>source.series.some((_series)=>$2da17c9210f90187$export$dc62ac670e083e7f(_series.seriesType.yaxis.typeKey));
    const $2da17c9210f90187$export$6d48878d5c505874 = (target)=>({
            label: {
                formatter: `${target}%`,
                color: (0, (0, parcelRequire("5w2JH")).default)('color.chart.neutral', (0, $72ba03e317f3d228$exports).N800)
            },
            silent: true,
            lineStyle: {
                color: (0, (0, parcelRequire("5w2JH")).default)('color.chart.neutral', (0, $72ba03e317f3d228$exports).N800)
            },
            animation: false,
            data: [
                {
                    name: 'Target',
                    yAxis: target
                }
            ]
        });
    const $2da17c9210f90187$export$d0f6b554d3bfbf7c = (source)=>{
        if ($2da17c9210f90187$export$b76b4efc5e57034a(source) && source.target !== undefined && source.target !== 0) return $2da17c9210f90187$export$6d48878d5c505874(source.target);
        return undefined;
    };
});
parcelRegister("fEeCa", function(module, exports) {
    var $la2vn = parcelRequire("la2vn");
    var $5JMmU = parcelRequire("5JMmU");
    var $etyzk = parcelRequire("etyzk");
    function $b645ed9a7ba1767e$var$max(array) {
        return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
    }
    module.exports = $b645ed9a7ba1767e$var$max;
});
parcelRegister("la2vn", function(module, exports) {
    var $4faK3 = parcelRequire("4faK3");
    function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
        var index = -1, length = array.length;
        while(++index < length){
            var value = array[index], current = iteratee(value);
            if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
        }
        return result;
    }
    module.exports = $f67c7999c5b61dcb$var$baseExtremum;
});
parcelRegister("5JMmU", function(module, exports) {
    function $42d6acb577163acc$var$baseGt(value, other) {
        return value > other;
    }
    module.exports = $42d6acb577163acc$var$baseGt;
});
parcelRegister("bHMD8", function(module, exports) {
    $parcel$export(module.exports, "TYPE_TIME", ()=>$2c24ef97c7f09ac1$export$65ca97a2a68797a8);
    $parcel$export(module.exports, "TYPE_STAR", ()=>$2c24ef97c7f09ac1$export$cd717bf7d618e43a);
    $parcel$export(module.exports, "TYPE_PERCENTAGE", ()=>$2c24ef97c7f09ac1$export$ddba3ac5dec72a9);
    $parcel$export(module.exports, "TYPE_TIME_DECIMAL_PLACES", ()=>$2c24ef97c7f09ac1$export$ffd1712c506d054d);
    $parcel$export(module.exports, "TYPE_STAR_DECIMAL_PLACES", ()=>$2c24ef97c7f09ac1$export$2ce8e14b52da595f);
    $parcel$export(module.exports, "TYPE_PERCENTAGE_DECIMAL_PLACES", ()=>$2c24ef97c7f09ac1$export$1c3fcfa5fdf9d3c1);
    $parcel$export(module.exports, "VALUE_TYPES", ()=>$2c24ef97c7f09ac1$export$b58fc909dae49e21);
    $parcel$export(module.exports, "PERCENTAGE_TYPE", ()=>$2c24ef97c7f09ac1$export$ed6b492cc720ae5d);
    const $2c24ef97c7f09ac1$export$8b6962479fda3507 = 'count';
    const $2c24ef97c7f09ac1$export$65ca97a2a68797a8 = 'time';
    const $2c24ef97c7f09ac1$export$cd717bf7d618e43a = 'star';
    const $2c24ef97c7f09ac1$export$ddba3ac5dec72a9 = 'percentage';
    const $2c24ef97c7f09ac1$export$ffd1712c506d054d = 2;
    const $2c24ef97c7f09ac1$export$2ce8e14b52da595f = 2;
    const $2c24ef97c7f09ac1$export$1c3fcfa5fdf9d3c1 = 1;
    const $2c24ef97c7f09ac1$export$b58fc909dae49e21 = {
        months: 'months',
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        percentage: 'percentage'
    };
    const $2c24ef97c7f09ac1$export$ed6b492cc720ae5d = 'sd.report.axis.type.percentage';
});
parcelRegister("dRNTN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08ee6c450b14c24c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $08ee6c450b14c24c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        months: {
            "id": "servicedesk-reports-common.common.summary.utils.months",
            "defaultMessage": "mths"
        },
        days: {
            "id": "servicedesk-reports-common.common.summary.utils.days",
            "defaultMessage": "days"
        },
        hours: {
            "id": "servicedesk-reports-common.common.summary.utils.hours",
            "defaultMessage": "hrs"
        },
        minutes: {
            "id": "servicedesk-reports-common.common.summary.utils.minutes",
            "defaultMessage": "mins"
        },
        percentage: {
            "id": "servicedesk-reports-common.common.summary.utils.percentage",
            "defaultMessage": "%"
        }
    });
});
parcelRegister("88d59", function(module, exports) {
    $parcel$export(module.exports, "REPORT_DEFAULTS", ()=>$744e80a5920da16a$export$27f8e5cdbed7aefe);
    var $9nenm;
    const $744e80a5920da16a$export$27f8e5cdbed7aefe = {
        searchByPastSevenDays: (0, (0, parcelRequire("9nenm")).TIME_SCALES).past7Days,
        timeBreakdown: (0, (0, parcelRequire("9nenm")).SEARCH_BY).daily
    };
});
parcelRegister("39vSm", function(module, exports) {
    $parcel$export(module.exports, "updateDateFilterQuery", ()=>(parcelRequire("lx5Ct")).updateDateFilterQuery);
    var $lx5Ct;
});
parcelRegister("lx5Ct", function(module, exports) {
    $parcel$export(module.exports, "updateDateFilterQuery", ()=>$7e08aeb11b8142dd$export$5c7c5a53ea53e72);
    const $7e08aeb11b8142dd$export$5c7c5a53ea53e72 = (data)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            setState({
                ...state,
                dateFilterQuery: data
            });
        };
});
parcelRegister("4Kc9u", function(module, exports) {
    $parcel$export(module.exports, "KbRequestsReportsMain", ()=>$77287e1a038c2402$export$45bad0bbfe683de8);
    var $5uXOq = parcelRequire("5uXOq");
    var $4cWVb;
    var $9nTS2;
    const $77287e1a038c2402$export$45bad0bbfe683de8 = (props)=>{
        const resources = (0, (0, parcelRequire("4cWVb")).default)(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9nTS2")).default), {
            ...props,
            ...resources
        });
    };
});
parcelRegister("4cWVb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48770cfc9ecf9606$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $koVbs;
    var $f3VcY;
    var $b6q3N;
    var $9nenm;
    var $bvS9p;
    var $aiZK8;
    const $48770cfc9ecf9606$var$onSummaryError = (error)=>{
        (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
            error: error,
            id: 'fetchKbRequestsSummary',
            packageName: 'jiraServicedeskKbRequestsReports',
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $48770cfc9ecf9606$var$onDrillDownError = (error)=>{
        (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
            error: error,
            id: 'fetchKbRequestsDrilldown',
            packageName: 'jiraServicedeskKbRequestsReports',
            sendToPrivacyUnsafeSplunk: true
        });
    };
    var $48770cfc9ecf9606$export$2e2bcd8739ae039 = ({ baseUrl: baseUrl, routerProps: routerProps, projectKey: projectKey, onFetchDrillDown: onFetchDrillDown = (0, (0, parcelRequire("aiZK8")).get), onFetchSummary: onFetchSummary = (0, (0, parcelRequire("b6q3N")).default), transformSummarySource: transformSummarySource = (0, (0, parcelRequire("bvS9p")).transformSummarySource) })=>{
        const { reportId: reportId } = routerProps;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const transformKbSource = (0, $5uXOq.useCallback)((source)=>transformSummarySource(source, {
                timescaleId: Number(routerProps.timescaleId !== undefined ? routerProps.timescaleId : (0, (0, parcelRequire("9nenm")).TIME_SCALES).past7Days),
                timeBreakdown: routerProps.timeBreakdown
            }, intl), [
            routerProps.timeBreakdown,
            routerProps.timescaleId,
            transformSummarySource
        ]);
        const summaryResource = (0, (0, parcelRequire("f3VcY")).default)({
            baseUrl: baseUrl,
            projectKey: projectKey,
            onFetch: onFetchSummary,
            initialLoadingState: true,
            onError: $48770cfc9ecf9606$var$onSummaryError,
            onTransformSource: transformKbSource
        });
        const drilldownResource = (0, (0, parcelRequire("f3VcY")).default)({
            baseUrl: baseUrl,
            projectKey: projectKey,
            onFetch: onFetchDrillDown,
            initialLoadingState: false,
            onError: $48770cfc9ecf9606$var$onDrillDownError
        });
        const { resetProvider: resetSummaryProvider } = summaryResource;
        const { resetProvider: resetDrillDownProvider } = drilldownResource;
        (0, $5uXOq.useEffect)(()=>{
            resetSummaryProvider();
            resetDrillDownProvider();
        }, [
            reportId,
            resetSummaryProvider,
            resetDrillDownProvider
        ]);
        return {
            summaryResource: summaryResource,
            drilldownResource: drilldownResource
        };
    };
});
parcelRegister("f3VcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f86d55196972d87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $hmJa1;
    var $32TkL;
    const $6f86d55196972d87$var$usePaginationProvider = ({ baseUrl: baseUrl, projectKey: projectKey, onFetch: onFetch, cache: cache, onError: onError, onTransformSource: onTransformSource, initialLoadingState: initialLoadingState = false })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hmJa1")).default)();
        const [loading, setLoading] = (0, $5uXOq.useState)(initialLoadingState);
        const [error, setError] = (0, $5uXOq.useState)();
        const [pageData, setPageData] = (0, $5uXOq.useState)();
        const [pageCache, updatePageCache] = (0, $5uXOq.useState)(cache || new Map());
        const abortController = (0, $5uXOq.useRef)(null);
        const getCacheKey = (request)=>{
            const queryString = (0, $ebyGx.stringify)({
                ...request
            });
            return queryString;
        };
        const transformPageData = (0, $5uXOq.useCallback)((response)=>{
            const transformedPageData = onTransformSource ? onTransformSource(response) : response;
            setPageData(transformedPageData);
            setLoading(false);
        }, [
            onTransformSource,
            colorMode
        ]);
        const getPageDataFromCache = (0, $5uXOq.useCallback)((key)=>pageCache.get(key), [
            pageCache
        ]);
        const compareStateAndFetch = (0, $5uXOq.useCallback)(async (request)=>{
            if (abortController.current?.abort) abortController.current.abort();
            if (!request) {
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(undefined);
            const queryKey = getCacheKey(request);
            const cachedData = getPageDataFromCache(queryKey);
            if (cachedData) transformPageData(cachedData);
            else try {
                abortController.current = new AbortController();
                const response = await onFetch({
                    ...request,
                    baseUrl: baseUrl,
                    projectKey: projectKey,
                    signal: abortController.current.signal
                });
                updatePageCache((prev)=>prev.set(queryKey, response));
                transformPageData(response);
            } catch (err) {
                if (err?.code === (0, (0, parcelRequire("32TkL")).ABORT_ERR)) return;
                const isAbortControllerReferenceError = err?.name === 'ReferenceError' && err?.message?.includes('AbortController');
                if (!isAbortControllerReferenceError) onError(err);
                setError(err.message);
                setPageData(undefined);
                setLoading(false);
            }
        }, [
            baseUrl,
            getPageDataFromCache,
            onError,
            onFetch,
            projectKey,
            transformPageData
        ]);
        const fetch = (0, $5uXOq.useCallback)(async (requestQuery)=>{
            compareStateAndFetch(requestQuery);
        }, [
            compareStateAndFetch
        ]);
        const clearCache = (0, $5uXOq.useCallback)(()=>{
            updatePageCache((prev)=>{
                prev.clear();
                return prev;
            });
        }, []);
        const resetProvider = (0, $5uXOq.useCallback)(()=>{
            setLoading(true);
            setError(undefined);
            setPageData(undefined);
            clearCache();
        }, [
            clearCache
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearCache();
            }, [
            clearCache,
            updatePageCache
        ]);
        return {
            loading: loading,
            error: error,
            data: pageData,
            fetch: fetch,
            resetProvider: resetProvider
        };
    };
    var $6f86d55196972d87$export$2e2bcd8739ae039 = $6f86d55196972d87$var$usePaginationProvider;
});
parcelRegister("b6q3N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80f270205a1a437e$export$2e2bcd8739ae039);
    var $aBmRh;
    var $hPK1h;
    var $80f270205a1a437e$export$2e2bcd8739ae039 = (request)=>(0, (0, parcelRequire("hPK1h")).default)(request).then((response)=>(0, (0, parcelRequire("aBmRh")).default)(response.taskId, request).then((result)=>Promise.resolve({
                    ...result,
                    taskId: response.taskId
                })));
});
parcelRegister("aBmRh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3ad0eb873d85c0f$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $32TkL;
    const $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL = 1000;
    const $f3ad0eb873d85c0f$export$8201d195ec654b2c = 5 * $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL;
    const $f3ad0eb873d85c0f$export$4fd465ca4b3a7a02 = (taskId, { baseUrl: baseUrl, projectKey: projectKey, reportId: reportId })=>{
        const queryParam = (0, $ebyGx.stringify)({
            jobID: taskId
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions));
        return `${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}/poll?${queryParam}`;
    };
    const $f3ad0eb873d85c0f$var$getNextInterval = (interval)=>{
        if (interval === 0) return $f3ad0eb873d85c0f$var$INITIAL_POLLING_INTERVAL;
        const nextInterval = interval * 1.1;
        return Math.min($f3ad0eb873d85c0f$export$8201d195ec654b2c, nextInterval);
    };
    const $f3ad0eb873d85c0f$var$fetchData = (taskId, summaryRequest)=>{
        const url = $f3ad0eb873d85c0f$export$4fd465ca4b3a7a02(taskId, summaryRequest);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET',
            signal: summaryRequest.signal
        });
    };
    const $f3ad0eb873d85c0f$var$shouldKeepPolling = (pollData)=>{
        switch(pollData.status){
            case 'RUNNING':
            case 'ENQUEUED':
                return true;
            default:
                return false;
        }
    };
    const $f3ad0eb873d85c0f$var$pollWithInterval = (taskId, summaryRequest, interval)=>new Promise((resolve, reject)=>{
            const poll = ()=>$f3ad0eb873d85c0f$var$fetchData(taskId, summaryRequest).then((pollData)=>{
                    if ($f3ad0eb873d85c0f$var$shouldKeepPolling(pollData)) $f3ad0eb873d85c0f$var$pollWithInterval(taskId, summaryRequest, $f3ad0eb873d85c0f$var$getNextInterval(interval)).then(resolve, reject);
                    else if (pollData.status === 'COMPLETE' && pollData.reportDataResponse) resolve(pollData.reportDataResponse);
                    else reject(new Error(`Unable to fetch the report data due to unknown error. The task status was ${pollData.status}.`));
                }).catch(reject);
            setTimeout(poll, interval);
        });
    var $f3ad0eb873d85c0f$export$2e2bcd8739ae039 = async (taskId, summaryRequest)=>$f3ad0eb873d85c0f$var$pollWithInterval(taskId, summaryRequest, 0);
});
parcelRegister("hPK1h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98dfac32cbb1f7d0$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $32TkL;
    var $bvS9p;
    const $98dfac32cbb1f7d0$export$a74292244f995bcd = ({ baseUrl: baseUrl, projectKey: projectKey, reportId: reportId, startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown })=>`${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}/date-range?${(0, $ebyGx.stringify)({
            startDate: startDate,
            endDate: endDate,
            timeBreakdown: timeBreakdown
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $98dfac32cbb1f7d0$export$4fd465ca4b3a7a02 = ({ baseUrl: baseUrl, projectKey: projectKey, reportId: reportId, timescaleId: timescaleId })=>`${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/${reportId}?${(0, $ebyGx.stringify)({
            timescaleId: timescaleId
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    var $98dfac32cbb1f7d0$export$2e2bcd8739ae039 = (request)=>{
        const url = (0, (0, parcelRequire("bvS9p")).isCustomTimeScale)(request.timescaleId) ? $98dfac32cbb1f7d0$export$a74292244f995bcd(request) : $98dfac32cbb1f7d0$export$4fd465ca4b3a7a02(request);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET',
            signal: request.signal
        });
    };
});
parcelRegister("aiZK8", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$23a99540494e825b$export$3988ae62b71be9a3);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $32TkL;
    var $bvS9p;
    var $6CLRS;
    const $23a99540494e825b$export$990567e21daaa358 = ({ baseUrl: baseUrl, projectKey: projectKey, seriesId: seriesId, timescaleId: timescaleId, date: date, timeBreakdown: timeBreakdown, start: start, limit: limit })=>`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined?${(0, $ebyGx.stringify)({
            date: date,
            timeBreakdown: timeBreakdown,
            timescaleId: timescaleId,
            start: start,
            limit: limit,
            _: Date.now()
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $23a99540494e825b$export$19abf5776d2293f0 = ({ baseUrl: baseUrl, projectKey: projectKey, seriesId: seriesId, date: date, timeBreakdown: timeBreakdown, timescaleId: timescaleId, start: start, limit: limit })=>`${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/series/${seriesId}/drilldown/predefined/date-range?${(0, $ebyGx.stringify)({
            date: date,
            timeBreakdown: timeBreakdown,
            timescaleId: timescaleId,
            start: start,
            limit: limit,
            _: Date.now()
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $23a99540494e825b$export$3988ae62b71be9a3 = async (request)=>{
        const url = (0, (0, parcelRequire("bvS9p")).isCustomTimeScale)(request.timescaleId) ? $23a99540494e825b$export$19abf5776d2293f0(request) : $23a99540494e825b$export$990567e21daaa358(request);
        const response = await (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET',
            signal: request.signal
        });
        return (0, (0, parcelRequire("6CLRS")).transformSource)(request, response);
    };
});
parcelRegister("6CLRS", function(module, exports) {
    $parcel$export(module.exports, "transformSource", ()=>$f399311972a3ad3a$export$258739ac4e431f7e);
    const $f399311972a3ad3a$export$258739ac4e431f7e = ({ start: start, limit: limit }, response)=>{
        const page = start / limit + 1;
        return {
            ...response,
            page: page,
            pageSize: limit
        };
    };
});
parcelRegister("9nTS2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0d50845b1b23273$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $iXVV6;
    var $5oFIy;
    var $dp7nU;
    var $cht8b;
    var $8Fmle;
    var $dAFqR;
    var $5WvTQ;
    var $5ZLpF;
    var $4w0k3;
    var $fySF6;
    const $f0d50845b1b23273$var$KbRequestsReports = ({ routerProps: routerProps, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, summaryResource: summaryResource, drilldownResource: drilldownResource })=>{
        const { modifyPageUrl: modifyPageUrl } = (0, (0, parcelRequire("fySF6")).useUrlActions)({
            baseUrl: baseUrl,
            projectKey: projectKey,
            routerProps: routerProps,
            projectName: projectName
        });
        const [selectedDrillDownPoint, setDrillDownPoint] = (0, $5uXOq.useState)();
        const [{ dateFilterQuery: dateFilterQuery }] = (0, (0, parcelRequire("dp7nU")).useUIStateStore)();
        const { reportId: reportId } = routerProps;
        const { data: summaryData, error: summaryError, loading: summaryLoading, fetch: onFetchSummary } = summaryResource;
        (0, $5uXOq.useEffect)(()=>{
            const fetchData = async ()=>{
                await onFetchSummary(dateFilterQuery);
            };
            fetchData();
            setDrillDownPoint(undefined);
        }, [
            dateFilterQuery,
            onFetchSummary
        ]);
        const sourceName = (0, $5uXOq.useMemo)(()=>{
            switch(reportId){
                case 'kb-requests-deflected':
                    return 'viewRequestsDeflectedReport';
                case 'kb-requests-resolved':
                    return 'viewRequestsResolvedReport';
                default:
                    throw new Error(`${reportId} is an invalid reportId`);
            }
        }, [
            reportId
        ]);
        if (summaryError !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAFqR")).default), null);
        if (summaryData === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        let csvUrl;
        if (!summaryLoading) csvUrl = (0, (0, parcelRequire("fySF6")).getCsvForGeneratedReport)(baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint, summaryData.taskId);
        else csvUrl = (0, (0, parcelRequire("fySF6")).getCsvUrl)(baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: sourceName,
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Fmle")).default), {
            title: summaryData.label,
            projectKey: projectKey,
            projectName: projectName,
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ZLpF")).default), {
            href: csvUrl
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5WvTQ")).Banner), {
            baseUrl: baseUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cht8b")).default), {
            loading: summaryLoading,
            routerProps: routerProps,
            lastSearchQuery: {
                startDate: summaryData.startDate,
                endDate: summaryData.endDate
            },
            onSelect: modifyPageUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4w0k3")).default), {
            summaryResource: summaryResource,
            reportId: reportId,
            drilldownResource: drilldownResource,
            dateFilterQuery: dateFilterQuery,
            selectedDrillDownPoint: selectedDrillDownPoint,
            onSetDrillDownPoint: setDrillDownPoint
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            key: reportId
        }));
    };
    var $f0d50845b1b23273$export$2e2bcd8739ae039 = $f0d50845b1b23273$var$KbRequestsReports;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("cht8b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0e75ac5dd18a567$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $knKRw;
    var $gN6Vx;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $8TqM4;
    var $dp7nU;
    var $k74Ot;
    var $1d28l;
    var $35hYY;
    var $2XnCQ;
    const $a0e75ac5dd18a567$var$itemClickedEvent = {
        eventType: 'UI',
        eventName: 'item clicked',
        action: 'clicked',
        actionSubject: 'dropdownItem'
    };
    const $a0e75ac5dd18a567$var$DateFilter = ({ loading: loading, routerProps: routerProps, lastSearchQuery: lastSearchQuery, onSelect: onSelect, fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents) })=>{
        const [{ dateFilterQuery: savedDateFilterQuery }] = (0, (0, parcelRequire("dp7nU")).useUIStateStore)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const savedTimescaleId = (0, $5uXOq.useMemo)(()=>savedDateFilterQuery ? savedDateFilterQuery.timescaleId : undefined, [
            savedDateFilterQuery
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const onDropdownSelect = (0, $5uXOq.useCallback)(({ id: id })=>{
            onSelect((0, (0, parcelRequire("2XnCQ")).mapToDateQuery)({
                reportId: routerProps.reportId,
                timescaleId: id
            }, lastSearchQuery));
            const timescaleOption = (0, (0, parcelRequire("k74Ot")).TIMESCALE_OPTIONS).find((option)=>option.id === id);
            fireUIAnalytics(createAnalyticsEvent({
                actionSubject: 'dropdownItem',
                action: 'clicked'
            }), 'dateFilter', {
                periodViewed: timescaleOption ? timescaleOption.analyticsKey : 'unknown'
            });
        }, [
            fireUIAnalytics,
            lastSearchQuery,
            onSelect,
            routerProps.reportId,
            createAnalyticsEvent
        ]);
        const handleChange = (0, $5uXOq.useCallback)((option)=>{
            if (option) onDropdownSelect(option);
        }, [
            onDropdownSelect
        ]);
        const onCustomDateRangeUpdate = (0, $5uXOq.useCallback)((args)=>{
            const analyticsEvent = createAnalyticsEvent($a0e75ac5dd18a567$var$itemClickedEvent);
            const dateQuery = (0, (0, parcelRequire("2XnCQ")).mapToDateQuery)({
                ...routerProps,
                ...args
            }, lastSearchQuery);
            onSelect(dateQuery);
            const timescaleOption = (0, (0, parcelRequire("k74Ot")).TIMESCALE_OPTIONS).find((option)=>option.id === (0, (0, parcelRequire("k74Ot")).CUSTOM_TIMESCALE_ID));
            fireUIAnalytics(analyticsEvent, 'dateFilter', {
                periodViewed: timescaleOption ? timescaleOption.analyticsKey : 'unknown'
            });
        }, [
            createAnalyticsEvent,
            fireUIAnalytics,
            lastSearchQuery,
            onSelect,
            routerProps
        ]);
        const dropdownOptions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("k74Ot")).TIMESCALE_OPTIONS).map(({ id: id, message: message })=>({
                    id: id,
                    value: `${id}`,
                    label: intl.formatMessage(message)
                })), [
            intl
        ]);
        const selectedOption = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2XnCQ")).getSelectedOptionByRouterProps)(dropdownOptions, routerProps, savedTimescaleId), [
            savedTimescaleId,
            dropdownOptions,
            routerProps
        ]);
        const showLabel = (0, $5uXOq.useMemo)(()=>intl.formatMessage((0, (0, parcelRequire("35hYY")).default).dropdownLabel), [
            intl
        ]);
        const dateTimeBreakdown = (0, $5uXOq.useMemo)(()=>{
            let source = routerProps;
            if (routerProps !== (0, (0, parcelRequire("k74Ot")).CUSTOM_TIMESCALE_ID) && savedDateFilterQuery) source = savedDateFilterQuery;
            return {
                startDate: source.startDate,
                endDate: source.endDate,
                timeBreakdown: source.timeBreakdown
            };
        }, [
            savedDateFilterQuery,
            routerProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a0e75ac5dd18a567$var$DateFilterContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "servicedesk-reports-common.ui.date-filter.timescale-picker"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TqM4")).LabelWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            name: "showLabel",
            label: showLabel,
            id: "date-filter-dropdown"
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
                inputId: "date-filter-dropdown",
                "aria-labelledby": "date-filter-dropdown-label",
                value: selectedOption,
                options: dropdownOptions,
                spacing: "compact",
                hideSelectedOptions: true,
                onChange: handleChange,
                controlShouldRenderValue: true,
                styles: {
                    menu: (base)=>({
                            ...base,
                            minWidth: '160px'
                        })
                }
            }))))), selectedOption.id === (0, (0, parcelRequire("k74Ot")).CUSTOM_TIMESCALE_ID) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1d28l")).default), {
            loading: loading,
            onUpdate: onCustomDateRangeUpdate,
            dateTimeBreakdown: dateTimeBreakdown
        }));
    };
    var $a0e75ac5dd18a567$export$2e2bcd8739ae039 = $a0e75ac5dd18a567$var$DateFilter;
    const $a0e75ac5dd18a567$var$DateFilterContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _18s81bvd",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("knKRw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$110243b5cd2eb92d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $bkJDg;
    var $1FTEF;
    var $lOr6E;
    var $7VnW8;
    var $8knNZ;
    var $6cAn5 = parcelRequire("6cAn5");
    function $110243b5cd2eb92d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $110243b5cd2eb92d$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $110243b5cd2eb92d$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $110243b5cd2eb92d$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $110243b5cd2eb92d$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $110243b5cd2eb92d$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $110243b5cd2eb92d$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $110243b5cd2eb92d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $110243b5cd2eb92d$var$usePreviousRef(props);
        const isDefaultValueChanged = !$110243b5cd2eb92d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $110243b5cd2eb92d$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $110243b5cd2eb92d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($110243b5cd2eb92d$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $110243b5cd2eb92d$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8knNZ")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("1FTEF", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$b38f467b8b7721b2$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $b38f467b8b7721b2$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("lOr6E", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$75a5255a3d60692c$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$75a5255a3d60692c$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$75a5255a3d60692c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $75a5255a3d60692c$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $75a5255a3d60692c$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $75a5255a3d60692c$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("7VnW8", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$bc5fcc4d894aeca1$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$bc5fcc4d894aeca1$export$ed247974535929c7);
    var $f8Sb3;
    function $bc5fcc4d894aeca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc5fcc4d894aeca1$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $bc5fcc4d894aeca1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $bc5fcc4d894aeca1$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles
        }, children);
    };
    var $bc5fcc4d894aeca1$export$2e2bcd8739ae039 = $bc5fcc4d894aeca1$export$b04be29aa201d4f5;
});
parcelRegister("8knNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3fe143ced70112a$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d3fe143ced70112a$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d3fe143ced70112a$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d3fe143ced70112a$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("gN6Vx", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$8c2db7d5c814622a$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$8c2db7d5c814622a$export$2e2bcd8739ae039);
    var $4ZiMV;
    var $dvXtt;
    var $7GEKO;
    var $kWDSl;
    var $2s2ld;
    const $8c2db7d5c814622a$var$packageName = "platform-pkg";
    const $8c2db7d5c814622a$var$packageVersion = "0.0.0-use.local";
    const $8c2db7d5c814622a$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("2s2ld")).default)((0, (0, parcelRequire("kWDSl")).default));
    const $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("4ZiMV")).default)('atlaskit');
    const $8c2db7d5c814622a$var$Select = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'select',
        packageName: $8c2db7d5c814622a$var$packageName,
        packageVersion: $8c2db7d5c814622a$var$packageVersion
    })((0, (0, parcelRequire("7GEKO")).default)({
        onChange: $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $8c2db7d5c814622a$var$packageName,
                packageVersion: $8c2db7d5c814622a$var$packageVersion
            }
        })
    })($8c2db7d5c814622a$export$d1de3b251ccaa8a3));
    var $8c2db7d5c814622a$export$2e2bcd8739ae039 = $8c2db7d5c814622a$var$Select;
});
parcelRegister("kWDSl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f69c74a471c03f5$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("6vVYA")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $3uzTK;
    var $6vVYA;
    var $dIVa9;
    const $4f69c74a471c03f5$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("6vVYA")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("dIVa9")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uzTK")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $4f69c74a471c03f5$export$2e2bcd8739ae039 = $4f69c74a471c03f5$var$AsyncSelect;
});
parcelRegister("3uzTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c6e1da0a778b1ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    var $3vyhk;
    var $g6yke;
    var $2JKLA;
    var $aFNBY;
    var $gSXak;
    var $iTuaH;
    var $fenYw;
    var $b4pnV;
    var $by9Y7;
    var $crsHE;
    var $gZxD5;
    var $g2UN3;
    const $9c6e1da0a778b1ba$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("by9Y7")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("g6yke")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("g6yke")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("g6yke")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("g6yke")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("g2UN3")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue);
        const label = $9c6e1da0a778b1ba$var$getOptionLabel(props, option);
        const value = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $9c6e1da0a778b1ba$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("g2UN3")).notNullish));
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) {
        return $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue));
    }
    function $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$9c6e1da0a778b1ba$var$shouldHideSelectedOptions(props) || !isSelected) && $9c6e1da0a778b1ba$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $9c6e1da0a778b1ba$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $9c6e1da0a778b1ba$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $9c6e1da0a778b1ba$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return selectValue.some((i)=>$9c6e1da0a778b1ba$var$getOptionValue(props, i) === candidate);
    }
    function $9c6e1da0a778b1ba$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $9c6e1da0a778b1ba$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $9c6e1da0a778b1ba$var$instanceId = 1;
    class $9c6e1da0a778b1ba$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $9c6e1da0a778b1ba$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("3vyhk")).isSafari)() : (0, (0, parcelRequire("3vyhk")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("g2UN3")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $9c6e1da0a778b1ba$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("g2UN3")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("crsHE")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("2JKLA")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("g2UN3")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $9c6e1da0a778b1ba$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$9c6e1da0a778b1ba$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $9c6e1da0a778b1ba$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $9c6e1da0a778b1ba$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("gZxD5")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("gZxD5")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("gZxD5")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $9c6e1da0a778b1ba$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFNBY")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("g2UN3")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b4pnV")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTuaH")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSXak")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fenYw")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("3vyhk", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$2274fb9bfe3ef11a$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$2274fb9bfe3ef11a$export$e1865c3bedcd822b);
    function $2274fb9bfe3ef11a$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $2274fb9bfe3ef11a$export$186c6964ca17d99() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPhone/i);
    }
    function $2274fb9bfe3ef11a$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $2274fb9bfe3ef11a$export$9ac100e40613ea10() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^Mac/i);
    }
    function $2274fb9bfe3ef11a$export$7bef049ce92e4224() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPad/i) || $2274fb9bfe3ef11a$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $2274fb9bfe3ef11a$export$fedb369cb70207f1() {
        return $2274fb9bfe3ef11a$export$186c6964ca17d99() || $2274fb9bfe3ef11a$export$7bef049ce92e4224();
    }
    function $2274fb9bfe3ef11a$export$e1865c3bedcd822b() {
        return $2274fb9bfe3ef11a$export$9ac100e40613ea10() || $2274fb9bfe3ef11a$export$fedb369cb70207f1();
    }
});
parcelRegister("g6yke", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$949b2d8695786188$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$949b2d8695786188$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$949b2d8695786188$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$949b2d8695786188$export$56bd0c8d90db075);
    const $949b2d8695786188$export$f4da216a6ca54656 = (group)=>group.label;
    const $949b2d8695786188$export$dac6ace3020563ca = (option)=>option.label;
    const $949b2d8695786188$export$40be908210c5a79c = (option)=>option.value;
    const $949b2d8695786188$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("2JKLA", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$d8841908a1a3116c$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$d8841908a1a3116c$export$71abc632aa29e6fe);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $d8841908a1a3116c$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("8KLo7")).ClearIndicator),
        Control: (0, (0, parcelRequire("5EgAF")).default),
        DropdownIndicator: (0, (0, parcelRequire("8KLo7")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("8KLo7")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("8KLo7")).CrossIcon),
        Group: (0, (0, parcelRequire("5dHSO")).default),
        GroupHeading: (0, (0, parcelRequire("5dHSO")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("hekcY")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("8KLo7")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("loRFz")).default),
        LoadingIndicator: (0, (0, parcelRequire("8KLo7")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("b4pnV")).default),
        MenuList: (0, (0, parcelRequire("b4pnV")).MenuList),
        MenuPortal: (0, (0, parcelRequire("b4pnV")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("b4pnV")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("b4pnV")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hti3c")).default),
        MultiValueContainer: (0, (0, parcelRequire("hti3c")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hti3c")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hti3c")).MultiValueRemove),
        Option: (0, (0, parcelRequire("1MDaa")).default),
        Placeholder: (0, (0, parcelRequire("hklN8")).default),
        SelectContainer: (0, (0, parcelRequire("hekcY")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("7SnYw")).default),
        ValueContainer: (0, (0, parcelRequire("hekcY")).ValueContainer)
    };
    const $d8841908a1a3116c$export$71abc632aa29e6fe = (props)=>({
            ...$d8841908a1a3116c$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("hekcY", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$c0357af0bdb2c3e2$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$c0357af0bdb2c3e2$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$c0357af0bdb2c3e2$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$c0357af0bdb2c3e2$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$c0357af0bdb2c3e2$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$c0357af0bdb2c3e2$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $g2UN3;
    const $c0357af0bdb2c3e2$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $c0357af0bdb2c3e2$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $c0357af0bdb2c3e2$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $c0357af0bdb2c3e2$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("g2UN3", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$d301bcbf5bee5718$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$d301bcbf5bee5718$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$d301bcbf5bee5718$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$d301bcbf5bee5718$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$d301bcbf5bee5718$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$d301bcbf5bee5718$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$d301bcbf5bee5718$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$d301bcbf5bee5718$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$d301bcbf5bee5718$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$d301bcbf5bee5718$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$d301bcbf5bee5718$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$d301bcbf5bee5718$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$d301bcbf5bee5718$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$d301bcbf5bee5718$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$d301bcbf5bee5718$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$d301bcbf5bee5718$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$d301bcbf5bee5718$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$d301bcbf5bee5718$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$d301bcbf5bee5718$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$d301bcbf5bee5718$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$d301bcbf5bee5718$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$d301bcbf5bee5718$export$4213b25a1c4e877);
    const $d301bcbf5bee5718$export$8793edee2d425525 = ()=>{};
    const $d301bcbf5bee5718$export$1643ccb46f49255c = ()=>'';
    function $d301bcbf5bee5718$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $d301bcbf5bee5718$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$d301bcbf5bee5718$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $d301bcbf5bee5718$export$33f062f47f21a01 = (value)=>{
        if ($d301bcbf5bee5718$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $d301bcbf5bee5718$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $d301bcbf5bee5718$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $d301bcbf5bee5718$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $d301bcbf5bee5718$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $d301bcbf5bee5718$export$2e0654fad740d2e4(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $d301bcbf5bee5718$export$3f99968195accfaf(el, top) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $d301bcbf5bee5718$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $d301bcbf5bee5718$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $d301bcbf5bee5718$export$858c30343199f3af(element, to, duration = 200, callback = $d301bcbf5bee5718$export$8793edee2d425525) {
        const start = $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $d301bcbf5bee5718$var$easeOutCubic(currentTime, start, change, duration);
            $d301bcbf5bee5718$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $d301bcbf5bee5718$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $d301bcbf5bee5718$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $d301bcbf5bee5718$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $d301bcbf5bee5718$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $d301bcbf5bee5718$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $d301bcbf5bee5718$var$passiveOptionAccessed = false;
    const $d301bcbf5bee5718$var$options = {
        get passive () {
            return $d301bcbf5bee5718$var$passiveOptionAccessed = true;
        }
    };
    const $d301bcbf5bee5718$var$w = typeof window !== 'undefined' ? window : {};
    if ($d301bcbf5bee5718$var$w.addEventListener && $d301bcbf5bee5718$var$w.removeEventListener) {
        $d301bcbf5bee5718$var$w.addEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, $d301bcbf5bee5718$var$options);
        $d301bcbf5bee5718$var$w.removeEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, false);
    }
    const $d301bcbf5bee5718$export$b0622a6911dbeaf5 = $d301bcbf5bee5718$var$passiveOptionAccessed;
    function $d301bcbf5bee5718$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $d301bcbf5bee5718$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $d301bcbf5bee5718$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $d301bcbf5bee5718$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $d301bcbf5bee5718$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $d301bcbf5bee5718$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("5EgAF", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$112794acdb2bce64$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$112794acdb2bce64$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $112794acdb2bce64$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $112794acdb2bce64$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $112794acdb2bce64$export$2e2bcd8739ae039 = $112794acdb2bce64$var$Control;
});
parcelRegister("5dHSO", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$f6fdd3148ce7aff3$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$f6fdd3148ce7aff3$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$f6fdd3148ce7aff3$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$f6fdd3148ce7aff3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $f6fdd3148ce7aff3$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $f6fdd3148ce7aff3$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $f6fdd3148ce7aff3$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $f6fdd3148ce7aff3$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $f6fdd3148ce7aff3$export$2e2bcd8739ae039 = $f6fdd3148ce7aff3$var$Group;
});
parcelRegister("8KLo7", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$c5c80ec94c3996b7$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$c5c80ec94c3996b7$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$c5c80ec94c3996b7$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$c5c80ec94c3996b7$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$c5c80ec94c3996b7$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$c5c80ec94c3996b7$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$c5c80ec94c3996b7$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$c5c80ec94c3996b7$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$c5c80ec94c3996b7$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$c5c80ec94c3996b7$export$7c20be4c1d342248);
    var $f8Sb3;
    var $g2UN3;
    function $c5c80ec94c3996b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5c80ec94c3996b7$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $c5c80ec94c3996b7$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $c5c80ec94c3996b7$var$styles,
            ...props
        });
    const $c5c80ec94c3996b7$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $c5c80ec94c3996b7$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $c5c80ec94c3996b7$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $c5c80ec94c3996b7$export$e1687335805e1230 = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$c5cbe1656ba71e6c, null));
    };
    const $c5c80ec94c3996b7$export$9c0419fd944c1def = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$3b621d86b1566b2, null));
    };
    const $c5c80ec94c3996b7$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $c5c80ec94c3996b7$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $c5c80ec94c3996b7$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$c5c80ec94c3996b7$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $c5c80ec94c3996b7$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("loRFz", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$722f6bdaf9005a3c$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$722f6bdaf9005a3c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $722f6bdaf9005a3c$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$722f6bdaf9005a3c$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $722f6bdaf9005a3c$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $722f6bdaf9005a3c$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$722f6bdaf9005a3c$var$spacingStyle
        }
    };
    const $722f6bdaf9005a3c$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$722f6bdaf9005a3c$var$spacingStyle
        });
    const $722f6bdaf9005a3c$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $722f6bdaf9005a3c$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $722f6bdaf9005a3c$export$2e2bcd8739ae039 = $722f6bdaf9005a3c$var$Input;
});
parcelRegister("b4pnV", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$b1a905a6e7ee6f32$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$b1a905a6e7ee6f32$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$b1a905a6e7ee6f32$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$b1a905a6e7ee6f32$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$b1a905a6e7ee6f32$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$b1a905a6e7ee6f32$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$b1a905a6e7ee6f32$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$b1a905a6e7ee6f32$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$b1a905a6e7ee6f32$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$b1a905a6e7ee6f32$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $g2UN3;
    function $b1a905a6e7ee6f32$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("g2UN3")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("g2UN3")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("g2UN3")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $b1a905a6e7ee6f32$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $b1a905a6e7ee6f32$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $b1a905a6e7ee6f32$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$b1a905a6e7ee6f32$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $b1a905a6e7ee6f32$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $b1a905a6e7ee6f32$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b1a905a6e7ee6f32$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $b1a905a6e7ee6f32$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $b1a905a6e7ee6f32$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $b1a905a6e7ee6f32$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $b1a905a6e7ee6f32$export$2e2bcd8739ae039 = $b1a905a6e7ee6f32$var$Menu;
    const $b1a905a6e7ee6f32$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $b1a905a6e7ee6f32$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $b1a905a6e7ee6f32$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $b1a905a6e7ee6f32$export$cf0e22534d8b0074 = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$98ec46397a8cb3cd = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $b1a905a6e7ee6f32$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $b1a905a6e7ee6f32$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b1a905a6e7ee6f32$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("g2UN3")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b1a905a6e7ee6f32$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hti3c", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$04718750df22b9a9$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$04718750df22b9a9$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$04718750df22b9a9$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$04718750df22b9a9$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$04718750df22b9a9$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$04718750df22b9a9$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$04718750df22b9a9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    var $8KLo7;
    const $04718750df22b9a9$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $04718750df22b9a9$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $04718750df22b9a9$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $04718750df22b9a9$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $04718750df22b9a9$export$cf9cf2a30a59265c = $04718750df22b9a9$export$e1de505c1242dc1a;
    const $04718750df22b9a9$export$544aeea2a5ce08ee = $04718750df22b9a9$export$e1de505c1242dc1a;
    function $04718750df22b9a9$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8KLo7")).CrossIcon), {
            size: 14
        }));
    }
    const $04718750df22b9a9$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $04718750df22b9a9$export$2e2bcd8739ae039 = $04718750df22b9a9$var$MultiValue;
});
parcelRegister("1MDaa", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$32784da36597034c$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$32784da36597034c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $32784da36597034c$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $32784da36597034c$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $32784da36597034c$export$2e2bcd8739ae039 = $32784da36597034c$var$Option;
});
parcelRegister("hklN8", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$897d07c49a2fc3b7$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$897d07c49a2fc3b7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $897d07c49a2fc3b7$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $897d07c49a2fc3b7$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $897d07c49a2fc3b7$export$2e2bcd8739ae039 = $897d07c49a2fc3b7$var$Placeholder;
});
parcelRegister("7SnYw", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$8be3a115a328f6d6$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$8be3a115a328f6d6$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $8be3a115a328f6d6$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $8be3a115a328f6d6$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $8be3a115a328f6d6$export$2e2bcd8739ae039 = $8be3a115a328f6d6$var$SingleValue;
});
parcelRegister("aFNBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53a19d4b009f6971$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $53a19d4b009f6971$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $53a19d4b009f6971$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("g2UN3")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $53a19d4b009f6971$var$dummyInputStyles
        });
    }
});
parcelRegister("gSXak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cda2f07a4dd034e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gCBvJ;
    function $5cda2f07a4dd034e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5cda2f07a4dd034e$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $5cda2f07a4dd034e$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $5cda2f07a4dd034e$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("gCBvJ")).default)
        });
    var $5cda2f07a4dd034e$export$2e2bcd8739ae039 = $5cda2f07a4dd034e$var$RequiredInput;
});
parcelRegister("iTuaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$117d781a987cee69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7pQpP;
    var $6QLsL;
    function $117d781a987cee69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $117d781a987cee69$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $117d781a987cee69$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $117d781a987cee69$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("7pQpP")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("6QLsL")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $117d781a987cee69$var$blurSelectInput,
            css: $117d781a987cee69$var$styles
        }), children(targetRef));
    }
});
parcelRegister("7pQpP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$356f91d0bcb9815a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    const $356f91d0bcb9815a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $356f91d0bcb9815a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $356f91d0bcb9815a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("g2UN3")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("6QLsL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9237a2ecafc7ea7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b9237a2ecafc7ea7$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $b9237a2ecafc7ea7$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $b9237a2ecafc7ea7$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $b9237a2ecafc7ea7$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $b9237a2ecafc7ea7$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $b9237a2ecafc7ea7$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $b9237a2ecafc7ea7$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $b9237a2ecafc7ea7$var$activeScrollLocks = 0;
    const $b9237a2ecafc7ea7$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $b9237a2ecafc7ea7$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($b9237a2ecafc7ea7$var$LOCK_STYLES).forEach((key)=>{
                    const val = $b9237a2ecafc7ea7$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.addEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
            $b9237a2ecafc7ea7$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $b9237a2ecafc7ea7$var$activeScrollLocks = Math.max($b9237a2ecafc7ea7$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("fenYw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bb923c406dba917$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $7y9my;
    var $bsT3T;
    const $8bb923c406dba917$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("7y9my")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $8bb923c406dba917$export$2e2bcd8739ae039 = $8bb923c406dba917$var$LiveRegion;
});
parcelRegister("7y9my", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$a7b3e13a3bcf9c77$export$a7265767c78f9bae);
    var $2oS3b;
    const $a7b3e13a3bcf9c77$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bsT3T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974422c50fb59952$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $974422c50fb59952$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $974422c50fb59952$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $974422c50fb59952$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $974422c50fb59952$var$styles,
            ...props
        });
    var $974422c50fb59952$export$2e2bcd8739ae039 = $974422c50fb59952$var$A11yText;
});
parcelRegister("by9Y7", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$1012133c72ff468e$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $4PUAy;
    const $1012133c72ff468e$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("4PUAy")).stripDiacritics));
    const $1012133c72ff468e$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $1012133c72ff468e$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $1012133c72ff468e$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $1012133c72ff468e$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $1012133c72ff468e$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $1012133c72ff468e$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $1012133c72ff468e$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("4PUAy")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("4PUAy", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$a5a026396014cf91$export$b5bee4b27048330b);
    const $a5a026396014cf91$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $a5a026396014cf91$var$anyDiacritic = new RegExp('[' + $a5a026396014cf91$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $a5a026396014cf91$var$diacriticToBase = {};
    for(let i = 0; i < $a5a026396014cf91$var$diacritics.length; i++){
        let diacritic = $a5a026396014cf91$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$a5a026396014cf91$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $a5a026396014cf91$export$b5bee4b27048330b = (str)=>{
        return str.replace($a5a026396014cf91$var$anyDiacritic, (match)=>$a5a026396014cf91$var$diacriticToBase[match]);
    };
});
parcelRegister("crsHE", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$b3155602f5f642fc$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$b3155602f5f642fc$export$e618dc39ac9ad607);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $b3155602f5f642fc$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("8KLo7")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("hekcY")).containerCSS),
        control: (0, (0, parcelRequire("5EgAF")).css),
        dropdownIndicator: (0, (0, parcelRequire("8KLo7")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("5dHSO")).groupCSS),
        groupHeading: (0, (0, parcelRequire("5dHSO")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("hekcY")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("8KLo7")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("loRFz")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("8KLo7")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("b4pnV")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("b4pnV")).menuCSS),
        menuList: (0, (0, parcelRequire("b4pnV")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("b4pnV")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hti3c")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hti3c")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hti3c")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("b4pnV")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("1MDaa")).optionCSS),
        placeholder: (0, (0, parcelRequire("hklN8")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("7SnYw")).css),
        valueContainer: (0, (0, parcelRequire("hekcY")).valueContainerCSS)
    };
    function $b3155602f5f642fc$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("gZxD5", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$87a511a775a34fb9$export$164de7ab8df77ef0);
    const $87a511a775a34fb9$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $87a511a775a34fb9$var$borderRadius = 4;
    const $87a511a775a34fb9$var$baseUnit = 4;
    const $87a511a775a34fb9$var$controlHeight = 38;
    const $87a511a775a34fb9$var$menuGutter = $87a511a775a34fb9$var$baseUnit * 2;
    const $87a511a775a34fb9$export$5458b64234d1333c = {
        baseUnit: $87a511a775a34fb9$var$baseUnit,
        controlHeight: $87a511a775a34fb9$var$controlHeight,
        menuGutter: $87a511a775a34fb9$var$menuGutter
    };
    const $87a511a775a34fb9$export$164de7ab8df77ef0 = {
        borderRadius: $87a511a775a34fb9$var$borderRadius,
        colors: $87a511a775a34fb9$export$8f45430ccf837300,
        spacing: $87a511a775a34fb9$export$5458b64234d1333c
    };
});
parcelRegister("6vVYA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9332a65322bdfb79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    function $9332a65322bdfb79$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("g2UN3")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("dIVa9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dbf9d49c9b24aee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $7dbf9d49c9b24aee$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("2s2ld", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5214de49fe3c4d80$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $crsHE;
    var $hjioQ;
    var $kbK1u;
    var $aKHA6;
    var $b7a6t;
    var $imyI2;
    var $HFUaQ;
    function $5214de49fe3c4d80$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("hjioQ")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("hjioQ")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("hjioQ")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("kbK1u")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("kbK1u")).IndicatorSeparator,
                    Input: (0, parcelRequire("aKHA6")).Input,
                    NoOptionsMessage: (0, parcelRequire("b7a6t")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("HFUaQ")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("HFUaQ")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("crsHE")).mergeStyles)((0, (0, parcelRequire("imyI2")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("hjioQ", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$e3b166afd75430c9$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$e3b166afd75430c9$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$e3b166afd75430c9$export$7c20be4c1d342248);
    var $f8Sb3;
    var $h8Wzd;
    var $2uz6y;
    var $fm763;
    var $a95o8;
    var $99gde;
    var $2JKLA;
    var $113Tq;
    const $e3b166afd75430c9$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $e3b166afd75430c9$var$dropdownWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.075'
    });
    const $e3b166afd75430c9$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            xcss: $e3b166afd75430c9$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2uz6y"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $e3b166afd75430c9$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
            as: "span",
            xcss: $e3b166afd75430c9$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8Wzd"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $e3b166afd75430c9$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("113Tq")).default), {
            size: "small"
        })));
    };
});
parcelRegister("2uz6y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1d099d27a685bf63$var$_react = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1d099d27a685bf63$var$_crossCircle = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("2gX5A")));
    var $1d099d27a685bf63$var$_selectClear = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("3h0rt")));
    function $1d099d27a685bf63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1d099d27a685bf63$var$CrossCircleIcon = (props)=>$1d099d27a685bf63$var$_react.default.createElement($1d099d27a685bf63$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $1d099d27a685bf63$var$_selectClear.default
        }, props));
    $1d099d27a685bf63$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $1d099d27a685bf63$var$_default = module.exports.default = $1d099d27a685bf63$var$CrossCircleIcon;
});
parcelRegister("2gX5A", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1a7ae93c4f2b7ce5$var$_react = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $1a7ae93c4f2b7ce5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1a7ae93c4f2b7ce5$var$CrossCircleIcon = (props)=>$1a7ae93c4f2b7ce5$var$_react.default.createElement($1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $1a7ae93c4f2b7ce5$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $1a7ae93c4f2b7ce5$var$_default = module.exports.default = $1a7ae93c4f2b7ce5$var$CrossCircleIcon;
});
parcelRegister("3h0rt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $26234d72bec5adf7$var$_react = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $26234d72bec5adf7$var$_crossCircle = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("hA8Dz")));
    function $26234d72bec5adf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $26234d72bec5adf7$var$SelectClearIcon = (props)=>$26234d72bec5adf7$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $26234d72bec5adf7$var$_crossCircle.default
        }));
    $26234d72bec5adf7$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $26234d72bec5adf7$var$_default = module.exports.default = $26234d72bec5adf7$var$SelectClearIcon;
});
parcelRegister("hA8Dz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cccc7fa1583dbf38$var$_react = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cccc7fa1583dbf38$var$_UNSAFE_baseNew = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $cccc7fa1583dbf38$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cccc7fa1583dbf38$var$CrossCircleIcon = (props)=>$cccc7fa1583dbf38$var$_react.default.createElement($cccc7fa1583dbf38$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $cccc7fa1583dbf38$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $cccc7fa1583dbf38$var$_default = module.exports.default = $cccc7fa1583dbf38$var$CrossCircleIcon;
});
parcelRegister("kbK1u", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$440bbf009bc44946$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$440bbf009bc44946$export$bd638c2ba7915668);
    var $f8Sb3;
    var $3h0rt;
    var $eM5qw;
    var $2oS3b;
    var $fm763;
    var $99gde;
    var $2JKLA;
    var $hjioQ;
    function $440bbf009bc44946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $440bbf009bc44946$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $440bbf009bc44946$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $440bbf009bc44946$var$iconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025'
    });
    const $440bbf009bc44946$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
                xcss: $440bbf009bc44946$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("3h0rt"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $440bbf009bc44946$var$disabledStyles : $440bbf009bc44946$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $440bbf009bc44946$export$bd638c2ba7915668 = null;
});
parcelRegister("eM5qw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ac19c20d14390f4c$var$_react = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ac19c20d14390f4c$var$_UNSAFE_baseNew = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $ac19c20d14390f4c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ac19c20d14390f4c$var$CrossIcon = (props)=>$ac19c20d14390f4c$var$_react.default.createElement($ac19c20d14390f4c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $ac19c20d14390f4c$var$CrossIcon.displayName = 'CrossIcon';
    var $ac19c20d14390f4c$var$_default = module.exports.default = $ac19c20d14390f4c$var$CrossIcon;
});
parcelRegister("aKHA6", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$54e7208482951c00$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    function $54e7208482951c00$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("b7a6t", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$cde8873635d1057d$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ZuPvl;
    var $2JKLA;
    const $cde8873635d1057d$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("imyI2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b98022bba24ece5$export$2e2bcd8739ae039);
    var $2oS3b;
    function $6b98022bba24ece5$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $72ba03e317f3d228$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $72ba03e317f3d228$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $72ba03e317f3d228$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("HFUaQ", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$79b4bf05f1ff4469$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$79b4bf05f1ff4469$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$79b4bf05f1ff4469$export$8ee33f304118fce4);
    function $79b4bf05f1ff4469$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $79b4bf05f1ff4469$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $79b4bf05f1ff4469$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("8TqM4", function(module, exports) {
    $parcel$export(module.exports, "LabelWrapper", ()=>$5a29205b0dd1dcfc$export$147422f7450ccfac);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $5a29205b0dd1dcfc$export$147422f7450ccfac = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("k74Ot", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_TIMESCALE_ID", ()=>$fb3ed106a3659591$export$edb46b113b5df303);
    $parcel$export(module.exports, "TIMESCALE_OPTIONS", ()=>$fb3ed106a3659591$export$2265585593f3283c);
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$fb3ed106a3659591$export$93ca5d3f8675ae4c);
    var $arzTB;
    var $35hYY;
    const $fb3ed106a3659591$export$930ada39a040821e = 1;
    const $fb3ed106a3659591$export$f8447a3b6bdf76b0 = 2;
    const $fb3ed106a3659591$export$5b9b786e9cb1188 = 3;
    const $fb3ed106a3659591$export$55501131f0e0fa74 = 4;
    const $fb3ed106a3659591$export$da30c0bc3e078809 = 5;
    const $fb3ed106a3659591$export$1fd26187b35d98d9 = 6;
    const $fb3ed106a3659591$export$abf95687cd6d45a7 = 7;
    const $fb3ed106a3659591$export$8afcf4edee140deb = 8;
    const $fb3ed106a3659591$export$edb46b113b5df303 = 9;
    const $fb3ed106a3659591$export$2265585593f3283c = [
        {
            id: $fb3ed106a3659591$export$930ada39a040821e,
            analyticsKey: 'past48hours',
            message: (0, (0, parcelRequire("35hYY")).default).past48Hours
        },
        {
            id: $fb3ed106a3659591$export$f8447a3b6bdf76b0,
            analyticsKey: 'past7',
            message: (0, (0, parcelRequire("35hYY")).default).past7Days
        },
        {
            id: $fb3ed106a3659591$export$5b9b786e9cb1188,
            analyticsKey: 'past14',
            message: (0, (0, parcelRequire("35hYY")).default).past14Days
        },
        {
            id: $fb3ed106a3659591$export$55501131f0e0fa74,
            analyticsKey: 'past30',
            message: (0, (0, parcelRequire("35hYY")).default).past30Days
        },
        {
            id: $fb3ed106a3659591$export$da30c0bc3e078809,
            analyticsKey: 'pastquarter',
            message: (0, (0, parcelRequire("35hYY")).default).pastQuarterByDay
        },
        {
            id: $fb3ed106a3659591$export$1fd26187b35d98d9,
            analyticsKey: 'pastquarterbyweek',
            message: (0, (0, parcelRequire("35hYY")).default).pastQuarterByWeek
        },
        {
            id: $fb3ed106a3659591$export$abf95687cd6d45a7,
            analyticsKey: 'pastyearbyweek',
            message: (0, (0, parcelRequire("35hYY")).default).pastYearByWeek
        },
        {
            id: $fb3ed106a3659591$export$8afcf4edee140deb,
            analyticsKey: 'pastquarterbymonth',
            message: (0, (0, parcelRequire("35hYY")).default).pastYearByMonth
        },
        {
            id: $fb3ed106a3659591$export$edb46b113b5df303,
            analyticsKey: 'custom',
            message: (0, (0, parcelRequire("35hYY")).default).customDates
        }
    ];
    const $fb3ed106a3659591$export$93ca5d3f8675ae4c = {
        timescaleId: $fb3ed106a3659591$export$f8447a3b6bdf76b0,
        timeBreakdown: (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly
    };
});
parcelRegister("arzTB", function(module, exports) {
    $parcel$export(module.exports, "TIME_BREAKDOWN_OPTIONS", ()=>$bb80c15a18ab744d$export$88710739a99d72c);
    $parcel$export(module.exports, "DROPDOWN_OPTIONS", ()=>$bb80c15a18ab744d$export$93f40b2c0434cd46);
    var $38EUq;
    const $bb80c15a18ab744d$export$88710739a99d72c = {
        hourly: 'h',
        daily: 'd',
        weekly: 'w',
        monthly: 'm'
    };
    const $bb80c15a18ab744d$export$93f40b2c0434cd46 = [
        {
            id: $bb80c15a18ab744d$export$88710739a99d72c.hourly,
            message: (0, (0, parcelRequire("38EUq")).default).hourly
        },
        {
            id: $bb80c15a18ab744d$export$88710739a99d72c.daily,
            message: (0, (0, parcelRequire("38EUq")).default).daily
        },
        {
            id: $bb80c15a18ab744d$export$88710739a99d72c.weekly,
            message: (0, (0, parcelRequire("38EUq")).default).weekly
        },
        {
            id: $bb80c15a18ab744d$export$88710739a99d72c.monthly,
            message: (0, (0, parcelRequire("38EUq")).default).monthly
        }
    ];
    const $bb80c15a18ab744d$export$45c85543ba71221d = 'YYYY-MM-DD';
});
parcelRegister("38EUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b862d65058b7215f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b862d65058b7215f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        period: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.period",
            "defaultMessage": "period"
        },
        hourly: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.hourly",
            "defaultMessage": "hourly"
        },
        daily: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.daily",
            "defaultMessage": "daily"
        },
        weekly: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.weekly",
            "defaultMessage": "weekly"
        },
        monthly: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.time-breakdown.monthly",
            "defaultMessage": "monthly"
        }
    });
});
parcelRegister("35hYY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e81d4f3d744c68e6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e81d4f3d744c68e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        past48Hours: {
            "id": "servicedesk-reports-common.date-filter.past-48-hours",
            "defaultMessage": "Past 48 hours"
        },
        past7Days: {
            "id": "servicedesk-reports-common.date-filter.past-7-days",
            "defaultMessage": "Past 7 days"
        },
        past14Days: {
            "id": "servicedesk-reports-common.date-filter.past-14-days",
            "defaultMessage": "Past 14 days"
        },
        past30Days: {
            "id": "servicedesk-reports-common.date-filter.past-30-days",
            "defaultMessage": "Past 30 days"
        },
        pastQuarterByDay: {
            "id": "servicedesk-reports-common.date-filter.past-quarter-by-day",
            "defaultMessage": "Past quarter by day"
        },
        pastQuarterByWeek: {
            "id": "servicedesk-reports-common.date-filter.past-quarter-by-week",
            "defaultMessage": "Past quarter by week"
        },
        pastYearByWeek: {
            "id": "servicedesk-reports-common.date-filter.past-year-by-week",
            "defaultMessage": "Past year by week"
        },
        pastYearByMonth: {
            "id": "servicedesk-reports-common.date-filter.past-year-by-month",
            "defaultMessage": "Past year by month"
        },
        customDates: {
            "id": "servicedesk-reports-common.date-filter.custom-dates",
            "defaultMessage": "Custom range"
        },
        dropdownLabel: {
            "id": "servicedesk-reports-common.date-filter.dropdown-label",
            "defaultMessage": "Show"
        }
    });
});
parcelRegister("1d28l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23ae1de0a669ff08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4EETE;
    var $8RXs9;
    var $esQIR;
    var $8eIEK;
    var $kOyYV;
    var $a0Usa;
    var $gENXG;
    const $23ae1de0a669ff08$var$DatePickerGroup = ({ intl: intl, loading: loading, dateTimeBreakdown: dateTimeBreakdown, onUpdate: onUpdate, allowedDateRange: allowedDateRange = (0, (0, parcelRequire("gENXG")).getAllowedDateRange)() })=>{
        const [selectedStart, setStart] = (0, $5uXOq.useState)({
            date: dateTimeBreakdown.startDate,
            invalidMessages: []
        });
        const [selectedEnd, setEnd] = (0, $5uXOq.useState)({
            date: dateTimeBreakdown.endDate,
            invalidMessages: []
        });
        const [timeBreakdown, setTimeBreakdown] = (0, $5uXOq.useState)(dateTimeBreakdown.timeBreakdown);
        const updateBtnDisabled = (0, $5uXOq.useMemo)(()=>{
            const isDatePickerInvalid = selectedStart.invalidMessages.length > 0 || selectedEnd.invalidMessages.length > 0;
            if (isDatePickerInvalid) return isDatePickerInvalid;
            return selectedStart.date === dateTimeBreakdown.startDate && selectedEnd.date === dateTimeBreakdown.endDate && timeBreakdown === dateTimeBreakdown.timeBreakdown;
        }, [
            dateTimeBreakdown.endDate,
            dateTimeBreakdown.startDate,
            dateTimeBreakdown.timeBreakdown,
            selectedEnd.date,
            selectedEnd.invalidMessages.length,
            selectedStart.date,
            selectedStart.invalidMessages.length,
            timeBreakdown
        ]);
        const availableTimeBreakdownOptions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gENXG")).getAvailableOptionsByDateRange)({
                startDate: selectedStart.date,
                endDate: selectedEnd.date
            }), [
            selectedEnd.date,
            selectedStart.date
        ]);
        const selectedTimeBreakdownId = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gENXG")).getTimeBreakdownByDateRange)(availableTimeBreakdownOptions, {
                timeBreakdown: timeBreakdown
            }), [
            availableTimeBreakdownOptions,
            timeBreakdown
        ]);
        const onUpdateButtonClick = (0, $5uXOq.useCallback)(()=>{
            onUpdate({
                startDate: selectedStart.date,
                endDate: selectedEnd.date,
                timeBreakdown: selectedTimeBreakdownId
            });
        }, [
            onUpdate,
            selectedEnd.date,
            selectedStart.date,
            selectedTimeBreakdownId
        ]);
        const onSelectedDateRangeUpdate = ({ type: type, date: date, invalidMessages: { startDateErrorMessages: startDateErrorMessages, endDateErrorMessages: endDateErrorMessages } })=>{
            const isStartDate = type === (0, (0, parcelRequire("esQIR")).DATE_PICKER_TYPES).START;
            setStart((prev)=>({
                    date: isStartDate ? date : prev.date,
                    invalidMessages: startDateErrorMessages
                }));
            setEnd((prev)=>({
                    date: isStartDate ? prev.date : date,
                    invalidMessages: endDateErrorMessages
                }));
        };
        (0, $5uXOq.useEffect)(()=>{
            setStart({
                date: dateTimeBreakdown.startDate,
                invalidMessages: []
            });
            setEnd({
                date: dateTimeBreakdown.endDate,
                invalidMessages: []
            });
            setTimeBreakdown(dateTimeBreakdown.timeBreakdown);
        }, [
            dateTimeBreakdown
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$GroupedDatePickerWrapper, {
            "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.grouped-date-picker-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$Spaced, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8eIEK")).default), {
            loading: loading,
            allowedDateRange: allowedDateRange,
            selectedStart: selectedStart,
            selectedEnd: selectedEnd,
            onUpdate: onSelectedDateRangeUpdate
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$Spaced, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a0Usa")).default), {
            loading: loading,
            selectedTimeBreakdownId: selectedTimeBreakdownId,
            availableTimeBreakdownOptions: availableTimeBreakdownOptions,
            onTimeBreakdownSelect: (breakdown)=>setTimeBreakdown(breakdown)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($23ae1de0a669ff08$var$UpdateButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4EETE")).default), {
            isDisabled: !loading && updateBtnDisabled,
            isLoading: loading,
            onClick: onUpdateButtonClick,
            appearance: "primary"
        }, intl.formatMessage((0, (0, parcelRequire("kOyYV")).default).update))));
    };
    var $23ae1de0a669ff08$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($23ae1de0a669ff08$var$DatePickerGroup);
    const $23ae1de0a669ff08$var$GroupedDatePickerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $23ae1de0a669ff08$var$Spaced = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01ejb",
                __cmplp.className
            ])
        });
    });
    const $23ae1de0a669ff08$var$UpdateButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8yhun",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("esQIR", function(module, exports) {
    $parcel$export(module.exports, "DATE_PICKER_TYPES", ()=>$cf5b77909bbdc6b3$export$145569f7aadfe842);
    const $cf5b77909bbdc6b3$export$145569f7aadfe842 = {
        START: 'start',
        END: 'end'
    };
});
parcelRegister("8eIEK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35dd6abae6d5f2cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1PqPz;
    var $c4CWe;
    var $knKRw;
    var $gwIPs;
    var $koVbs;
    var $1p96B;
    var $DVljb;
    var $8TqM4;
    var $esQIR;
    var $g9eUw;
    var $394jw;
    const $35dd6abae6d5f2cb$var$DatePickerGroup = ({ loading: loading, allowedDateRange: allowedDateRange, selectedStart: selectedStart, selectedEnd: selectedEnd, onUpdate: onUpdate, useLocale: useLocale = (0, (0, parcelRequire("DVljb")).useLocale) })=>{
        const locale = useLocale();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getMessages = (startDate, endDate)=>(0, (0, parcelRequire("394jw")).dateRangeValidator)(allowedDateRange, {
                startDate: startDate,
                endDate: endDate
            }, formatMessage);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$GroupedDatePickerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$Spaced, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TqM4")).LabelWrapper), {
            "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.from-label"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            name: "fromDate",
            label: formatMessage((0, (0, parcelRequire("g9eUw")).default).from)
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PqPz")).default), {
                ...fieldProps,
                testId: "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.data-picker-from",
                spacing: "compact",
                value: (0, (0, parcelRequire("1p96B")).formatDateStringToISO)(selectedStart.date),
                onChange: (date)=>{
                    onUpdate({
                        type: (0, (0, parcelRequire("esQIR")).DATE_PICKER_TYPES).START,
                        date: date,
                        invalidMessages: getMessages(date, selectedEnd.date)
                    });
                },
                innerProps: {
                    style: {
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 20
                    }
                },
                isDisabled: loading,
                locale: locale,
                isInvalid: Boolean(selectedStart.invalidMessages.length)
            }))), selectedStart.invalidMessages.map((message)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).ErrorMessage), {
                key: message
            }, message))), (0, ($parcel$interopDefault($5uXOq))).createElement($35dd6abae6d5f2cb$var$Spaced, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TqM4")).LabelWrapper), {
            "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.to-label"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            name: "toDate",
            label: formatMessage((0, (0, parcelRequire("g9eUw")).default).to)
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PqPz")).default), {
                ...fieldProps,
                testId: "servicedesk-reports-common.ui.date-filter.date-picker-group.connected-date-pickers-with-validator.date-picker-to",
                spacing: "compact",
                value: (0, (0, parcelRequire("1p96B")).formatDateStringToISO)(selectedEnd.date),
                onChange: (date)=>{
                    onUpdate({
                        type: (0, (0, parcelRequire("esQIR")).DATE_PICKER_TYPES).END,
                        date: date,
                        invalidMessages: getMessages(selectedStart.date, date)
                    });
                },
                innerProps: {
                    style: {
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 20
                    }
                },
                isDisabled: loading,
                locale: locale,
                isInvalid: Boolean(selectedEnd.invalidMessages.length)
            }))), selectedEnd.invalidMessages.map((message)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).ErrorMessage), {
                key: message
            }, message))));
    };
    var $35dd6abae6d5f2cb$export$2e2bcd8739ae039 = $35dd6abae6d5f2cb$var$DatePickerGroup;
    const $35dd6abae6d5f2cb$var$GroupedDatePickerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $35dd6abae6d5f2cb$var$Spaced = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1PqPz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7a9ff772bf03053$export$2e2bcd8739ae039);
    var $2oS3b;
    var $ggf8m;
    var $5JmJ5;
    var $j0OrS;
    const $b7a9ff772bf03053$var$DatePicker = (0, (0, parcelRequire("ggf8m")).componentWithCondition)(()=>(0, (0, parcelRequire("2oS3b")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("j0OrS")).default), (0, (0, parcelRequire("5JmJ5")).default));
    var $b7a9ff772bf03053$export$2e2bcd8739ae039 = $b7a9ff772bf03053$var$DatePicker;
});
parcelRegister("ggf8m", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8c8e59faefa0075d$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8c8e59faefa0075d$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("5JmJ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f82d402b9e451fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $4ZiMV;
    var $dvXtt;
    var $7GEKO;
    var $bkJDg;
    var $Zmmeo;
    var $bLDEj;
    var $czw3v;
    var $2oS3b;
    var $6Ll2T;
    var $a95o8;
    var $99gde;
    var $gN6Vx;
    var $crsHE;
    var $AHUyh;
    var $bs2mW;
    var $fe3ss;
    var $VlOuZ;
    var $dcRCd;
    var $dfejw;
    var $bjeU4;
    function $f82d402b9e451fad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f82d402b9e451fad$var$packageName = "platform-pkg";
    const $f82d402b9e451fad$var$packageVersion = "0.0.0-use.local";
    const $f82d402b9e451fad$var$dropdownIndicatorStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $f82d402b9e451fad$var$CalendarIcon = (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("Zmmeo"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bLDEj")))));
    const $f82d402b9e451fad$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $f82d402b9e451fad$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $f82d402b9e451fad$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`
        }
    });
    const $f82d402b9e451fad$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $f82d402b9e451fad$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $f82d402b9e451fad$var$calendarButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $f82d402b9e451fad$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $f82d402b9e451fad$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props);
            this.containerRef = null;
            this.calendarRef = (0, $5uXOq.createRef)();
            this.calendarButtonRef = (0, $5uXOq.createRef)();
            this.getValue = ()=>this.props.value ?? this.state.value;
            this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
            this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("fe3ss")).getParsedISO)({
                        iso: iso
                    })
                });
            };
            this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            };
            this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            };
            this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            };
            this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            };
            this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("fe3ss")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("dfejw")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("fe3ss")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("dfejw")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            };
            this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            };
            this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            };
            this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            };
            this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            };
            this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            };
            this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("czw3v")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("czw3v")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $f82d402b9e451fad$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $f82d402b9e451fad$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("bjeU4")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("bs2mW")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("VlOuZ")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("dcRCd")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("bs2mW")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("dfejw")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("fe3ss")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $f82d402b9e451fad$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gN6Vx")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("fe3ss")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bkJDg")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $f82d402b9e451fad$var$iconContainerStyles,
                        value && !hideIcon ? $f82d402b9e451fad$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStylesNew : $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $f82d402b9e451fad$var$calendarButtonStyles,
                        (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') && $f82d402b9e451fad$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($f82d402b9e451fad$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $f82d402b9e451fad$var$DatePicker = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'datePicker',
        packageName: $f82d402b9e451fad$var$packageName,
        packageVersion: $f82d402b9e451fad$var$packageVersion
    })((0, (0, parcelRequire("7GEKO")).default)({
        onChange: (0, (0, parcelRequire("4ZiMV")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $f82d402b9e451fad$var$packageName,
                packageVersion: $f82d402b9e451fad$var$packageVersion
            }
        })
    })($f82d402b9e451fad$export$df43d21f5faca9f7));
    var $f82d402b9e451fad$export$2e2bcd8739ae039 = $f82d402b9e451fad$var$DatePicker;
});
parcelRegister("Zmmeo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0b870a5dd988cc2f$var$_react = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0b870a5dd988cc2f$var$_calendar = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("lL8mO")));
    var $0b870a5dd988cc2f$var$_calendar2 = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("bLDEj")));
    function $0b870a5dd988cc2f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0b870a5dd988cc2f$var$CalendarIcon = (props)=>$0b870a5dd988cc2f$var$_react.default.createElement($0b870a5dd988cc2f$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $0b870a5dd988cc2f$var$_calendar2.default
        }, props));
    $0b870a5dd988cc2f$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $0b870a5dd988cc2f$var$_default = module.exports.default = $0b870a5dd988cc2f$var$CalendarIcon;
});
parcelRegister("lL8mO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd747a425ea05ec4$var$_react = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd747a425ea05ec4$var$_UNSAFE_baseNew = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fd747a425ea05ec4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd747a425ea05ec4$var$CalendarIcon = (props)=>$fd747a425ea05ec4$var$_react.default.createElement($fd747a425ea05ec4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $fd747a425ea05ec4$var$CalendarIcon.displayName = 'CalendarIcon';
    var $fd747a425ea05ec4$var$_default = module.exports.default = $fd747a425ea05ec4$var$CalendarIcon;
});
parcelRegister("bLDEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8912d6fb9cca436d$var$_react = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8912d6fb9cca436d$var$_calendar = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("lL8mO")));
    function $8912d6fb9cca436d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8912d6fb9cca436d$var$CalendarIcon = (props)=>$8912d6fb9cca436d$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $8912d6fb9cca436d$var$_calendar.default
        }));
    $8912d6fb9cca436d$var$CalendarIcon.displayName = 'CalendarIcon';
    var $8912d6fb9cca436d$var$_default = module.exports.default = $8912d6fb9cca436d$var$CalendarIcon;
});
parcelRegister("czw3v", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$047faaad49e2ca54$export$ea56ca58f08ffa52);
    var $kaZ5I;
    var $bciOi;
    var $foH1K;
    const $047faaad49e2ca54$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("kaZ5I")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("bciOi")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("foH1K")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("foH1K")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("kaZ5I", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$9ca0adfc15679689$export$dca0327c9b9c6498);
    const $9ca0adfc15679689$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("bciOi", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$f81fbac7b9fa6173$export$cfa2ef2687faeda2);
    var $adbFL;
    var $kaZ5I;
    const $f81fbac7b9fa6173$var$INVALID_DATE = new Date(NaN);
    const $f81fbac7b9fa6173$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $f81fbac7b9fa6173$var$INVARIANT_DATE = (0, (0, parcelRequire("adbFL")).toDate)($f81fbac7b9fa6173$var$INVARIANT);
    const $f81fbac7b9fa6173$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $f81fbac7b9fa6173$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $f81fbac7b9fa6173$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $f81fbac7b9fa6173$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $f81fbac7b9fa6173$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("kaZ5I")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($f81fbac7b9fa6173$var$INVARIANT_DATE);
        const shortDate = $f81fbac7b9fa6173$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($f81fbac7b9fa6173$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $f81fbac7b9fa6173$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $f81fbac7b9fa6173$var$stripExtras(date).match($f81fbac7b9fa6173$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $f81fbac7b9fa6173$var$INVALID_DATE;
            const dateParts = $f81fbac7b9fa6173$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("adbFL")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("adbFL")).isValid)(normalizedDate)) return $f81fbac7b9fa6173$var$INVALID_DATE;
            return (0, (0, parcelRequire("adbFL")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("adbFL", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$cc7776c87982d016$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$cc7776c87982d016$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$cc7776c87982d016$export$fcc71269590ba0a8);
    const $cc7776c87982d016$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $cc7776c87982d016$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $cc7776c87982d016$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $cc7776c87982d016$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $cc7776c87982d016$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $cc7776c87982d016$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $cc7776c87982d016$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $cc7776c87982d016$export$fcc71269590ba0a8 = (date)=>{
        const now = $cc7776c87982d016$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("foH1K", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$3ff49b479a5f8f06$export$9b7ca29af37c192);
    const $3ff49b479a5f8f06$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("bs2mW", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$83fe1f9bc0251903$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$83fe1f9bc0251903$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$83fe1f9bc0251903$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$83fe1f9bc0251903$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$83fe1f9bc0251903$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$83fe1f9bc0251903$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$83fe1f9bc0251903$export$2eeb05a2ecc2ce0a);
    const $83fe1f9bc0251903$export$5e30e9a24d6c1203 = ()=>null;
    const $83fe1f9bc0251903$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $83fe1f9bc0251903$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $83fe1f9bc0251903$export$9e6d8fcf62256b85 = 'h:mma';
    const $83fe1f9bc0251903$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $83fe1f9bc0251903$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $83fe1f9bc0251903$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("fe3ss", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$3668e6d89a8f2990$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$3668e6d89a8f2990$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$3668e6d89a8f2990$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$3668e6d89a8f2990$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$3668e6d89a8f2990$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $uTa2o;
    var $bs2mW;
    const $3668e6d89a8f2990$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $3668e6d89a8f2990$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $3668e6d89a8f2990$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("bs2mW")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $3668e6d89a8f2990$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("bs2mW")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("uTa2o")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $3668e6d89a8f2990$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("bs2mW")).placeholderDatetime));
    };
});
parcelRegister("uTa2o", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$6653de9d6f157fc3$export$4d5430175be73d45);
    const $6653de9d6f157fc3$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $6653de9d6f157fc3$var$v1tokens = Object.keys($6653de9d6f157fc3$var$tokensMap).sort().reverse();
    const $6653de9d6f157fc3$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $6653de9d6f157fc3$var$v1tokens.join('|') + '|.)', 'g');
    function $6653de9d6f157fc3$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($6653de9d6f157fc3$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $6653de9d6f157fc3$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("VlOuZ", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$387a1fc7d4da19ac$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $2JKLA;
    function $387a1fc7d4da19ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $387a1fc7d4da19ac$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $387a1fc7d4da19ac$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $387a1fc7d4da19ac$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $387a1fc7d4da19ac$var$calendarButtonInclusionStyles : $387a1fc7d4da19ac$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).IndicatorsContainer, rest));
});
parcelRegister("dcRCd", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$6ff67a91201a79f3$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $kYQh1;
    var $8ftoa;
    var $bUQGL;
    var $kcwgO;
    function $6ff67a91201a79f3$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $6ff67a91201a79f3$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("bUQGL")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $72ba03e317f3d228$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $6ff67a91201a79f3$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $6ff67a91201a79f3$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        const onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8ftoa")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kcwgO")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6ff67a91201a79f3$var$menuStyles,
                ...innerProps,
                onMouseDown: onMenuMouseDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kYQh1")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("kYQh1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02d6b440f1b43dcd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $gCBvJ;
    var $bkJDg;
    var $6Ll2T;
    var $k0Jvh;
    var $99gde;
    var $3GUIq;
    var $jOPPf;
    var $ijHGX;
    var $dCeMv;
    var $cmovf;
    var $d6s06;
    var $i7w6K;
    var $5u0Mq;
    var $gIplh;
    var $iSoE5;
    const $02d6b440f1b43dcd$var$boxStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $02d6b440f1b43dcd$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $02d6b440f1b43dcd$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("dCeMv")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("dCeMv")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("gCBvJ")).default), onChange: onChange = (0, (0, parcelRequire("gCBvJ")).default), onFocus: onFocus = (0, (0, parcelRequire("gCBvJ")).default), onSelect: onSelect = (0, (0, parcelRequire("gCBvJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("cmovf")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$02d6b440f1b43dcd$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("5u0Mq")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$02d6b440f1b43dcd$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("gIplh")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("d6s06")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("iSoE5")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("i7w6K")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("bkJDg")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $02d6b440f1b43dcd$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k0Jvh")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3GUIq")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ijHGX")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jOPPf")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $02d6b440f1b43dcd$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($02d6b440f1b43dcd$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $02d6b440f1b43dcd$var$Calendar.displayName = 'Calendar';
    var $02d6b440f1b43dcd$export$2e2bcd8739ae039 = $02d6b440f1b43dcd$var$Calendar;
});
parcelRegister("3GUIq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31ae19bb9453b0ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9jNMw;
    var $bkJDg;
    var $cZ1Pf;
    var $asmPY;
    var $80QIn;
    var $6Ll2T;
    var $fm763;
    const $31ae19bb9453b0ed$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("bkJDg")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("asmPY"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("80QIn"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $31ae19bb9453b0ed$var$Header.displayName = 'Header';
    var $31ae19bb9453b0ed$export$2e2bcd8739ae039 = $31ae19bb9453b0ed$var$Header;
});
parcelRegister("asmPY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79ce3be6fdbee77d$var$_react = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79ce3be6fdbee77d$var$_chevronLeft = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("fY25f")));
    var $79ce3be6fdbee77d$var$_chevronLeftLarge = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("f7JN7")));
    function $79ce3be6fdbee77d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79ce3be6fdbee77d$var$ChevronLeftIcon = (props)=>$79ce3be6fdbee77d$var$_react.default.createElement($79ce3be6fdbee77d$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $79ce3be6fdbee77d$var$_chevronLeftLarge.default
        }, props));
    $79ce3be6fdbee77d$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $79ce3be6fdbee77d$var$_default = module.exports.default = $79ce3be6fdbee77d$var$ChevronLeftIcon;
});
parcelRegister("fY25f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b9fe135dcc94eb49$var$_react = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b9fe135dcc94eb49$var$_UNSAFE_baseNew = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $b9fe135dcc94eb49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b9fe135dcc94eb49$var$ChevronLeftIcon = (props)=>$b9fe135dcc94eb49$var$_react.default.createElement($b9fe135dcc94eb49$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $b9fe135dcc94eb49$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $b9fe135dcc94eb49$var$_default = module.exports.default = $b9fe135dcc94eb49$var$ChevronLeftIcon;
});
parcelRegister("f7JN7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b02b07a3c9f0c0ab$var$_react = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $b02b07a3c9f0c0ab$var$_chevronLeft = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("fY25f")));
    function $b02b07a3c9f0c0ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon = (props)=>$b02b07a3c9f0c0ab$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $b02b07a3c9f0c0ab$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $b02b07a3c9f0c0ab$var$_default = module.exports.default = $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon;
});
parcelRegister("80QIn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d5736e094bab377$var$_react = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5d5736e094bab377$var$_chevronRight = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("jkePi")));
    var $5d5736e094bab377$var$_chevronRightLarge = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("4T92P")));
    function $5d5736e094bab377$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d5736e094bab377$var$ChevronRightIcon = (props)=>$5d5736e094bab377$var$_react.default.createElement($5d5736e094bab377$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $5d5736e094bab377$var$_chevronRightLarge.default
        }, props));
    $5d5736e094bab377$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $5d5736e094bab377$var$_default = module.exports.default = $5d5736e094bab377$var$ChevronRightIcon;
});
parcelRegister("4T92P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $38f3508bf8b7f617$var$_react = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $38f3508bf8b7f617$var$_chevronRight = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("jkePi")));
    function $38f3508bf8b7f617$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $38f3508bf8b7f617$var$ChevronRightLargeIcon = (props)=>$38f3508bf8b7f617$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $38f3508bf8b7f617$var$_chevronRight.default,
            iconType: "utility"
        }));
    $38f3508bf8b7f617$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $38f3508bf8b7f617$var$_default = module.exports.default = $38f3508bf8b7f617$var$ChevronRightLargeIcon;
});
parcelRegister("jOPPf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1debce2d24cddd8b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $ciaUb;
    var $kTVUo;
    const $1debce2d24cddd8b$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kTVUo")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ciaUb")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $1debce2d24cddd8b$var$WeekDays.displayName = 'WeekDays';
    var $1debce2d24cddd8b$export$2e2bcd8739ae039 = $1debce2d24cddd8b$var$WeekDays;
});
parcelRegister("ciaUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a38e4fc2d454c91d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gCBvJ;
    var $2NYPZ;
    var $8se5h;
    const $a38e4fc2d454c91d$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("gCBvJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("8se5h")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NYPZ")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $a38e4fc2d454c91d$var$Date.displayName = 'Date';
    var $a38e4fc2d454c91d$export$2e2bcd8739ae039 = $a38e4fc2d454c91d$var$Date;
});
parcelRegister("8se5h", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$027048cc62663b6f$export$f62807af68630d86);
    const $027048cc62663b6f$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("kTVUo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$892d99999f450b8d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2NYPZ;
    const $892d99999f450b8d$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NYPZ")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $892d99999f450b8d$export$2e2bcd8739ae039 = $892d99999f450b8d$var$WeekDayGrid;
});
parcelRegister("ijHGX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b57d282f034f3ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $kTVUo;
    const $3b57d282f034f3ec$var$columnHeaderStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $3b57d282f034f3ec$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kTVUo")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                padding: "space.100",
                xcss: $3b57d282f034f3ec$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $3b57d282f034f3ec$var$WeekHeader.displayName = 'WeekHeader';
    var $3b57d282f034f3ec$export$2e2bcd8739ae039 = $3b57d282f034f3ec$var$WeekHeader;
});
parcelRegister("dCeMv", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$e2e59ee8d488f5cc$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$e2e59ee8d488f5cc$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$e2e59ee8d488f5cc$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$e2e59ee8d488f5cc$export$8fa20d70624f8b9d);
    const $e2e59ee8d488f5cc$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $e2e59ee8d488f5cc$export$3ae905d9742bef55 = 7;
    const $e2e59ee8d488f5cc$export$c9b7c010035d60c6 = 12;
    const $e2e59ee8d488f5cc$export$8fa20d70624f8b9d = [];
});
parcelRegister("cmovf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e312976738ceb23$export$2e2bcd8739ae039);
    var $cI4Vd;
    var $4Ybnr;
    var $2Coha;
    function $1e312976738ceb23$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("4Ybnr")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("cI4Vd")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("cI4Vd")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("cI4Vd")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("cI4Vd")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("2Coha")).default)(thisMonth)}-${(0, (0, parcelRequire("2Coha")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("cI4Vd")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("cI4Vd")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("2Coha", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d50e0112bd0e0be$export$2e2bcd8739ae039);
    function $8d50e0112bd0e0be$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("d6s06", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e42ef4255870deb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e42ef4255870deb3$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("i7w6K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b0bdc97ebc874dd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $dCeMv;
    var $dgjvv;
    var $61dkV;
    function $6b0bdc97ebc874dd$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("61dkV")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("dCeMv")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $6b0bdc97ebc874dd$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("61dkV")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $6b0bdc97ebc874dd$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("dgjvv")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("dgjvv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac834acee3d5efb8$export$2e2bcd8739ae039);
    var $2Coha;
    function $ac834acee3d5efb8$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("2Coha")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("2Coha")).default)(date.day)}`;
    }
});
parcelRegister("61dkV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7aa43d5fe6f4c0f9$export$2e2bcd8739ae039);
    var $dCeMv;
    var $lRz9J;
    function $7aa43d5fe6f4c0f9$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("dCeMv")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("dCeMv")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("lRz9J")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("dCeMv")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("lRz9J")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("dCeMv")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("dCeMv")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("dCeMv")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("lRz9J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$734856d8c616cad9$export$2e2bcd8739ae039);
    function $734856d8c616cad9$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("5u0Mq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd9ee79f364c0103$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dCeMv;
    var $dgjvv;
    var $lRz9J;
    const $fd9ee79f364c0103$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("dCeMv")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $fd9ee79f364c0103$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("dCeMv")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $fd9ee79f364c0103$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("dgjvv")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("dCeMv")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("lRz9J")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $fd9ee79f364c0103$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $fd9ee79f364c0103$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("lRz9J")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("lRz9J")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $fd9ee79f364c0103$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("dCeMv")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $fd9ee79f364c0103$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("lRz9J")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$fd9ee79f364c0103$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$fd9ee79f364c0103$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("gIplh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1ab74d3a687b21b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dCeMv;
    var $dgjvv;
    function $b1ab74d3a687b21b$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("dgjvv")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("dCeMv")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("iSoE5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389da60b06bc3c2f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $czw3v;
    function $389da60b06bc3c2f$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("czw3v")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("kcwgO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d32ccb92d217080c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gCBvJ;
    var $bH6vj;
    var $hRbZE;
    var $itR3E;
    var $71yya;
    var $bUQGL;
    class $d32ccb92d217080c$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("bH6vj")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("bUQGL")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hRbZE")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71yya")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itR3E")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("bUQGL")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args);
            this.update = (0, (0, parcelRequire("gCBvJ")).default);
        }
    }
});
parcelRegister("dfejw", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$c43aa0d990fc9aec$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$c43aa0d990fc9aec$export$ff525416014fb67d);
    var $k7m40;
    var $uTa2o;
    function $c43aa0d990fc9aec$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("uTa2o")).convertTokens)('YYYY-MM-DD'));
    }
    function $c43aa0d990fc9aec$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $c43aa0d990fc9aec$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("bjeU4", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$f9cee91e1b5ee962$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    const $f9cee91e1b5ee962$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("j0OrS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62d63fe30176b88d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $2cjvv;
    var $bkJDg;
    var $Zmmeo;
    var $bLDEj;
    var $czw3v;
    var $2oS3b;
    var $6Ll2T;
    var $a95o8;
    var $99gde;
    var $gN6Vx;
    var $crsHE;
    var $AHUyh;
    var $bs2mW;
    var $fe3ss;
    var $VlOuZ;
    var $dcRCd;
    var $dfejw;
    var $bjeU4;
    function $62d63fe30176b88d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $62d63fe30176b88d$var$packageName = "platform-pkg";
    const $62d63fe30176b88d$var$packageVersion = "0.0.0-use.local";
    const $62d63fe30176b88d$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $62d63fe30176b88d$var$packageName,
        packageVersion: $62d63fe30176b88d$var$packageVersion
    };
    const $62d63fe30176b88d$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $62d63fe30176b88d$var$dropdownIndicatorStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $62d63fe30176b88d$var$CalendarIcon = (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("Zmmeo"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bLDEj")))));
    const $62d63fe30176b88d$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $62d63fe30176b88d$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $62d63fe30176b88d$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $62d63fe30176b88d$var$calendarButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $62d63fe30176b88d$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $62d63fe30176b88d$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("czw3v")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$62d63fe30176b88d$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("czw3v")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("fe3ss")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("fe3ss")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("dfejw")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("fe3ss")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("dfejw")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $62d63fe30176b88d$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("bjeU4")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("bs2mW")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("VlOuZ")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("dcRCd")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("bs2mW")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("dfejw")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("fe3ss")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("bkJDg")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $62d63fe30176b88d$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gN6Vx")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("fe3ss")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $62d63fe30176b88d$var$iconContainerStyles,
                value && !hideIcon ? $62d63fe30176b88d$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStylesNew : $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $62d63fe30176b88d$var$calendarButtonStyles,
                (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') && $62d63fe30176b88d$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($62d63fe30176b88d$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $62d63fe30176b88d$export$2e2bcd8739ae039 = $62d63fe30176b88d$var$DatePicker;
});
parcelRegister("c4CWe", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$37aaa14c21610882$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$37aaa14c21610882$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$37aaa14c21610882$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$37aaa14c21610882$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2ISpW;
    var $4ljkj;
    var $1FTEF;
    function $37aaa14c21610882$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $37aaa14c21610882$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $37aaa14c21610882$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $37aaa14c21610882$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $37aaa14c21610882$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $37aaa14c21610882$var$iconWrapperStyles
        }, children);
    };
    const $37aaa14c21610882$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2ISpW"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("4ljkj"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $37aaa14c21610882$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $37aaa14c21610882$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($37aaa14c21610882$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $37aaa14c21610882$var$messageStyles,
                $37aaa14c21610882$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$IconWrapper, null, icon), content);
    };
    const $37aaa14c21610882$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $37aaa14c21610882$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("2ISpW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1fb9e6fe23750f95$var$_react = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1fb9e6fe23750f95$var$_error = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("4b40Y")));
    var $1fb9e6fe23750f95$var$_error2 = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("6UxUy")));
    function $1fb9e6fe23750f95$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1fb9e6fe23750f95$var$ErrorIcon = (props)=>$1fb9e6fe23750f95$var$_react.default.createElement($1fb9e6fe23750f95$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $1fb9e6fe23750f95$var$_error2.default
        }, props));
    $1fb9e6fe23750f95$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $1fb9e6fe23750f95$var$_default = module.exports.default = $1fb9e6fe23750f95$var$ErrorIcon;
});
parcelRegister("4b40Y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30ab4dbd64ae5aed$var$_react = $30ab4dbd64ae5aed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30ab4dbd64ae5aed$var$_UNSAFE_baseNew = $30ab4dbd64ae5aed$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $30ab4dbd64ae5aed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30ab4dbd64ae5aed$var$ErrorIcon = (props)=>$30ab4dbd64ae5aed$var$_react.default.createElement($30ab4dbd64ae5aed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $30ab4dbd64ae5aed$var$ErrorIcon.displayName = 'ErrorIcon';
    var $30ab4dbd64ae5aed$var$_default = module.exports.default = $30ab4dbd64ae5aed$var$ErrorIcon;
});
parcelRegister("4ljkj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32981d764c8c8a36$var$_react = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32981d764c8c8a36$var$_success = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("5x8hX")));
    var $32981d764c8c8a36$var$_success2 = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("jyRWF")));
    function $32981d764c8c8a36$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32981d764c8c8a36$var$SuccessIcon = (props)=>$32981d764c8c8a36$var$_react.default.createElement($32981d764c8c8a36$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $32981d764c8c8a36$var$_success2.default
        }, props));
    $32981d764c8c8a36$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $32981d764c8c8a36$var$_default = module.exports.default = $32981d764c8c8a36$var$SuccessIcon;
});
parcelRegister("5x8hX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $407676ca7dbef70c$var$_react = $407676ca7dbef70c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $407676ca7dbef70c$var$_UNSAFE_baseNew = $407676ca7dbef70c$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $407676ca7dbef70c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $407676ca7dbef70c$var$SuccessIcon = (props)=>$407676ca7dbef70c$var$_react.default.createElement($407676ca7dbef70c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $407676ca7dbef70c$var$SuccessIcon.displayName = 'SuccessIcon';
    var $407676ca7dbef70c$var$_default = module.exports.default = $407676ca7dbef70c$var$SuccessIcon;
});
parcelRegister("jyRWF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e3db09ac6ef9c7a0$var$_react = $e3db09ac6ef9c7a0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $e3db09ac6ef9c7a0$var$_success = $e3db09ac6ef9c7a0$var$_interopRequireDefault((parcelRequire("c10Ip")));
    function $e3db09ac6ef9c7a0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e3db09ac6ef9c7a0$var$EditorSuccessIcon = (props)=>$e3db09ac6ef9c7a0$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $e3db09ac6ef9c7a0$var$_success.default
        }));
    $e3db09ac6ef9c7a0$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $e3db09ac6ef9c7a0$var$_default = module.exports.default = $e3db09ac6ef9c7a0$var$EditorSuccessIcon;
});
parcelRegister("c10Ip", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bf62213531adf65$var$_react = $8bf62213531adf65$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bf62213531adf65$var$_UNSAFE_baseNew = $8bf62213531adf65$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $8bf62213531adf65$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bf62213531adf65$var$SuccessIcon = (props)=>$8bf62213531adf65$var$_react.default.createElement($8bf62213531adf65$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8bf62213531adf65$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8bf62213531adf65$var$_default = module.exports.default = $8bf62213531adf65$var$SuccessIcon;
});
parcelRegister("g9eUw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$458221e87e426e9b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $458221e87e426e9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        from: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.from",
            "defaultMessage": "From"
        },
        to: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.to",
            "defaultMessage": "To"
        }
    });
});
parcelRegister("394jw", function(module, exports) {
    $parcel$export(module.exports, "dateRangeValidator", ()=>$b56e714a18050279$export$4b1ad2ad4172d1e7);
    var $kQZsR = parcelRequire("kQZsR");
    var $gwejS;
    var $g7reD;
    var $k7m40;
    var $jovBr;
    var $el0er;
    var $bJgtF;
    const $b56e714a18050279$export$45c85543ba71221d = 'yyyy/MM/dd';
    const $b56e714a18050279$export$aa350b96d91cd94 = (dateString)=>(0, ($parcel$interopDefault($kQZsR)))(dateString) ? new Date() : new Date(dateString);
    const $b56e714a18050279$export$4b1ad2ad4172d1e7 = (allowedDateRange, selectedDateRange, formatMessage)=>{
        const { min: min, max: max } = allowedDateRange;
        const start = (0, (0, parcelRequire("el0er")).default)($b56e714a18050279$export$aa350b96d91cd94(selectedDateRange.startDate));
        const end = (0, (0, parcelRequire("el0er")).default)($b56e714a18050279$export$aa350b96d91cd94(selectedDateRange.endDate));
        const startDateErrorMessages = [];
        const endDateErrorMessages = [];
        if (!(0, (0, parcelRequire("jovBr")).default)(start)) startDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).invalidFrom));
        if (!(0, (0, parcelRequire("jovBr")).default)(end)) endDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).invalidTo));
        if (startDateErrorMessages.length || endDateErrorMessages.length) return {
            startDateErrorMessages: startDateErrorMessages,
            endDateErrorMessages: endDateErrorMessages
        };
        if ((0, (0, parcelRequire("g7reD")).default)(start, max) > 0) startDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).futureStartDateValidationMessage, {
            date: (0, (0, parcelRequire("k7m40")).default)(max, $b56e714a18050279$export$45c85543ba71221d)
        }));
        if ((0, (0, parcelRequire("g7reD")).default)(min, start) > 0) startDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).maxFromDateExceededMessage, {
            date: (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("gwejS")).default)(min, 1), $b56e714a18050279$export$45c85543ba71221d)
        }));
        if ((0, (0, parcelRequire("g7reD")).default)(start, end) > 0) startDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).fromDateExceededMessage));
        if ((0, (0, parcelRequire("g7reD")).default)(end, max) > 0) endDateErrorMessages.push(formatMessage((0, (0, parcelRequire("bJgtF")).default).futureEndDateValidationMessage, {
            date: (0, (0, parcelRequire("k7m40")).default)(max, $b56e714a18050279$export$45c85543ba71221d)
        }));
        return {
            startDateErrorMessages: startDateErrorMessages,
            endDateErrorMessages: endDateErrorMessages
        };
    };
});
parcelRegister("kQZsR", function(module, exports) {
    function $f2e8578be8331871$var$isNull(value) {
        return value === null;
    }
    module.exports = $f2e8578be8331871$var$isNull;
});
parcelRegister("bJgtF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fedcddbde8f6684d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fedcddbde8f6684d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        invalidFrom: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-from",
            "defaultMessage": "From date must be valid date"
        },
        invalidTo: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-to",
            "defaultMessage": "To date must be valid date"
        },
        futureStartDateValidationMessage: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-start-date-validation-message",
            "defaultMessage": "From date must not be after {date}"
        },
        futureEndDateValidationMessage: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-end-date-validation-message",
            "defaultMessage": "To date must not be after {date}"
        },
        maxFromDateExceededMessage: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.max-from-date-exceeded-message",
            "defaultMessage": "From date range cannot be longer than {date}"
        },
        fromDateExceededMessage: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.from-date-exceeded-message",
            "defaultMessage": "From date must be before To date"
        }
    });
});
parcelRegister("kOyYV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f31077416b2729a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f31077416b2729a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        from: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.from",
            "defaultMessage": "From"
        },
        to: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.to",
            "defaultMessage": "To"
        },
        update: {
            "id": "servicedesk-reports-common.date-filter.date-picker-group.update",
            "defaultMessage": "Update"
        }
    });
});
parcelRegister("a0Usa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0341d20458b8f2a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iriM5;
    var $lUP1Q;
    var $6ESxT;
    var $knKRw;
    var $8RXs9;
    var $8TqM4;
    var $arzTB;
    var $38EUq;
    var $1YZdF;
    const $a0341d20458b8f2a$var$TimeBreakdownDropdown = ({ intl: intl, loading: loading, selectedTimeBreakdownId: selectedTimeBreakdownId, availableTimeBreakdownOptions: availableTimeBreakdownOptions, onTimeBreakdownSelect: onTimeBreakdownSelect })=>{
        const [open, setOpen] = (0, $5uXOq.useState)(false);
        const onDropdownSelect = (0, $5uXOq.useCallback)(({ id: id })=>{
            onTimeBreakdownSelect(id);
        }, [
            onTimeBreakdownSelect
        ]);
        const toggleDropdown = ()=>setOpen((isOpen)=>!isOpen);
        const dropdownOptions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("arzTB")).DROPDOWN_OPTIONS).map(({ id: id, message: message })=>({
                    id: id,
                    message: intl.formatMessage(message)
                })), [
            intl
        ]);
        const selectedOption = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1YZdF")).getSelectedOptionByTimeBreakdown)(dropdownOptions, selectedTimeBreakdownId), [
            dropdownOptions,
            selectedTimeBreakdownId
        ]);
        const dropdownItems = (0, $5uXOq.useMemo)(()=>{
            const { validOptions: validOptions } = availableTimeBreakdownOptions;
            return dropdownOptions.map((item)=>item.id !== selectedOption.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUP1Q")).default), {
                    key: item.id,
                    onClick: ()=>onDropdownSelect(item),
                    isDisabled: loading || !validOptions.includes(item.id)
                }, item.message) : null);
        }, [
            availableTimeBreakdownOptions,
            dropdownOptions,
            loading,
            onDropdownSelect,
            selectedOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "servicedesk-reports-common.ui.date-filter.date-picker-group.time-breakdown.time-breakdown-picker"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TqM4")).LabelWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            name: "period",
            label: intl.formatMessage((0, (0, parcelRequire("38EUq")).default).period)
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iriM5")).default), {
                trigger: selectedOption.message,
                isOpen: open,
                onOpenChange: toggleDropdown
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ESxT")).default), null, dropdownItems))))));
    };
    var $a0341d20458b8f2a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a0341d20458b8f2a$var$TimeBreakdownDropdown);
});
parcelRegister("lUP1Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4df1eec061f00ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jXXts;
    var $3IisA;
    var $6iX1e;
    var $2uy6c;
    var $2oS3b;
    var $dIGjU;
    const $f4df1eec061f00ce$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("dIGjU")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6iX1e")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2uy6c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $f4df1eec061f00ce$export$2e2bcd8739ae039 = $f4df1eec061f00ce$var$DropdownMenuItem;
});
parcelRegister("6ESxT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37f61b5921ce569$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bkJDg;
    var $pbV7V;
    var $3c7E2;
    const $e37f61b5921ce569$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3c7E2")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $e37f61b5921ce569$export$2e2bcd8739ae039 = $e37f61b5921ce569$var$DropdownMenuItemGroup;
});
parcelRegister("1YZdF", function(module, exports) {
    $parcel$export(module.exports, "getSelectedOptionByTimeBreakdown", ()=>$0f6cf846a9cb5b5b$export$48f5cf1e86210a8e);
    const $0f6cf846a9cb5b5b$export$48f5cf1e86210a8e = (options, timeBreakdown)=>{
        const idx = options.findIndex((option)=>option.id === timeBreakdown);
        return options[idx];
    };
});
parcelRegister("gENXG", function(module, exports) {
    $parcel$export(module.exports, "getAvailableOptionsByDateRange", ()=>$84b191b07506f571$export$de7d264907d0bed2);
    $parcel$export(module.exports, "getTimeBreakdownByDateRange", ()=>$84b191b07506f571$export$f33126db3bb7a7d2);
    $parcel$export(module.exports, "getAllowedDateRange", ()=>$84b191b07506f571$export$9b1b1e3f65b0efed);
    var $hGgHi = parcelRequire("hGgHi");
    var $kQZsR = parcelRequire("kQZsR");
    var $4mBKK;
    var $70Rr2;
    var $it1wb;
    var $1WDNN;
    var $arzTB;
    const $84b191b07506f571$var$getDate = (dateString)=>(0, ($parcel$interopDefault($kQZsR)))(dateString) ? new Date() : new Date(dateString);
    const $84b191b07506f571$export$de7d264907d0bed2 = (dateTimeBreakdown)=>{
        const result = {
            validOptions: [],
            defaultOption: (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly
        };
        const startDate = $84b191b07506f571$var$getDate(dateTimeBreakdown.startDate);
        const endDate = $84b191b07506f571$var$getDate(dateTimeBreakdown.endDate);
        const daysInBetween = (0, (0, parcelRequire("4mBKK")).default)(endDate, startDate);
        if (daysInBetween < 3) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).hourly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).hourly;
        } else if (daysInBetween < 5) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).hourly);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).hourly;
        } else if (daysInBetween < 14) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily;
        } else if (daysInBetween < 28) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily;
        } else if (daysInBetween < 60) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly;
        } else if (daysInBetween < 92) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).daily);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly;
        } else if (daysInBetween < 180) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly;
        } else if (daysInBetween < 366) {
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).weekly);
            result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly);
            result.defaultOption = (0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly;
        } else result.validOptions.push((0, (0, parcelRequire("arzTB")).TIME_BREAKDOWN_OPTIONS).monthly);
        return result;
    };
    const $84b191b07506f571$export$f33126db3bb7a7d2 = (availableOptions, dateQuery)=>{
        const { validOptions: validOptions, defaultOption: defaultOption } = availableOptions;
        return dateQuery.timeBreakdown && validOptions.includes(dateQuery.timeBreakdown) ? dateQuery.timeBreakdown : defaultOption;
    };
    const $84b191b07506f571$export$9b1b1e3f65b0efed = (dateStr)=>{
        const date = (0, ($parcel$interopDefault($hGgHi)))(dateStr) ? new Date() : new Date(dateStr);
        const endDate = (0, (0, parcelRequire("70Rr2")).default)(date);
        const startDate = new Date((0, (0, parcelRequire("1WDNN")).default)((0, (0, parcelRequire("it1wb")).default)(date), 1));
        return {
            min: startDate,
            max: endDate
        };
    };
});
parcelRegister("2XnCQ", function(module, exports) {
    $parcel$export(module.exports, "mapToDateQuery", ()=>$5b7b62e058c17691$export$34b1bc5528be50fe);
    $parcel$export(module.exports, "getSelectedOptionByRouterProps", ()=>$5b7b62e058c17691$export$7f7630742786ff6a);
    var $k74Ot;
    var $gENXG;
    const $5b7b62e058c17691$export$a0c0a3d47691e36a = ({ timescaleId: timescaleId }, defaultTimescaleId)=>Number(timescaleId) || Number(defaultTimescaleId) || (0, (0, parcelRequire("k74Ot")).DEFAULT_OPTIONS).timescaleId;
    const $5b7b62e058c17691$export$34b1bc5528be50fe = (routerProps, lastSearchQuery)=>{
        if (Number(routerProps.timescaleId) === (0, (0, parcelRequire("k74Ot")).CUSTOM_TIMESCALE_ID) && lastSearchQuery) {
            const startDate = routerProps.startDate !== undefined && routerProps.startDate !== '' ? routerProps.startDate : lastSearchQuery.startDate;
            const endDate = routerProps.endDate !== undefined && routerProps.endDate !== '' ? routerProps.endDate : lastSearchQuery.endDate;
            let { timeBreakdown: timeBreakdown } = routerProps;
            if (!timeBreakdown) timeBreakdown = (0, (0, parcelRequire("gENXG")).getAvailableOptionsByDateRange)({
                startDate: startDate,
                endDate: endDate
            }).defaultOption;
            return {
                timescaleId: (0, (0, parcelRequire("k74Ot")).CUSTOM_TIMESCALE_ID),
                startDate: startDate,
                endDate: endDate,
                timeBreakdown: timeBreakdown
            };
        }
        return {
            timescaleId: $5b7b62e058c17691$export$a0c0a3d47691e36a(routerProps)
        };
    };
    const $5b7b62e058c17691$export$7f7630742786ff6a = (options, routerProps, defaultTimescaleId)=>{
        const timescaleId = $5b7b62e058c17691$export$a0c0a3d47691e36a(routerProps, defaultTimescaleId);
        const idx = options.findIndex((option)=>option.id === timescaleId);
        return options[idx];
    };
});
parcelRegister("8Fmle", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6928b190f194107f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cZ1Pf;
    var $6Ll2T;
    var $99gde;
    var $81ps3;
    var $koVbs;
    var $3HwlS;
    var $fP2yI;
    var $hVAug;
    var $6928b190f194107f$export$2e2bcd8739ae039 = ({ title: title, children: children, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const breadcrumbs = [
            {
                href: '/jira/projects',
                text: formatMessage((0, (0, parcelRequire("hVAug")).default).projectsBreadcrumb)
            },
            {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey || ''),
                text: projectName || ''
            },
            {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
                text: formatMessage((0, (0, parcelRequire("hVAug")).default).reportsBreadcrumb)
            }
        ];
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6928b190f194107f$var$commonNav4HeaderWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6928b190f194107f$var$nav4HeaderWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fP2yI")).Header), {
            title: title,
            breadcrumbs: breadcrumbs,
            actions: children
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement($6928b190f194107f$var$TitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large",
            as: "h1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6928b190f194107f$var$StyledTitle, {
            "data-test-id": "servicedesk-reports-common.ui.header.title"
        }, title)), children);
    };
    const $6928b190f194107f$var$commonNav4HeaderWrapper = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.negative.100',
        marginRight: 'space.negative.100'
    });
    const $6928b190f194107f$var$nav4HeaderWrapper = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.negative.400',
        marginRight: 'space.negative.400'
    });
    const $6928b190f194107f$var$StyledTitle = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4xy5q _19pkidpf",
                __cmplp.className
            ])
        });
    });
    const $6928b190f194107f$var$TitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _19pkmgjw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hVAug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30ec4baeeb8fec86$export$2e2bcd8739ae039);
    var $7VHMR;
    var $30ec4baeeb8fec86$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsBreadcrumb: {
            "id": "servicedesk-reports-common.header.projects-breadcrumb",
            "defaultMessage": "Projects"
        },
        reportsBreadcrumb: {
            "id": "servicedesk-reports-common.header.reports-breadcrumb",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("dAFqR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67cba9b9374b5799$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $fBF8a;
    var $iVgQf;
    var $koVbs;
    var $2m0sQ;
    var $kPIJk;
    const $67cba9b9374b5799$var$Error = ()=>{
        (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).failure({
            force: true
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("kPIJk")).default).errorHeader),
            description: formatMessage((0, (0, parcelRequire("kPIJk")).default).errorDescription),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($67cba9b9374b5799$var$ImageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fBF8a")).default), {
                    alt: "error-image",
                    fill: true
                })))
        });
    };
    const $67cba9b9374b5799$var$ImageWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $67cba9b9374b5799$var$wrapperStyles
        }, children);
    const $67cba9b9374b5799$var$wrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '160px',
        position: 'relative'
    });
    var $67cba9b9374b5799$export$2e2bcd8739ae039 = $67cba9b9374b5799$var$Error;
});
parcelRegister("fBF8a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58b29d503461142d$export$2e2bcd8739ae039);
    var $dCLgq;
    var $6ntiT = parcelRequire("6ntiT");
    const $58b29d503461142d$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($6ntiT)),
        srcDark: ($parcel$interopDefault($6ntiT))
    });
    var $58b29d503461142d$export$2e2bcd8739ae039 = $58b29d503461142d$var$Illustration;
    const $58b29d503461142d$export$a179c88182cb9d56 = [
        0,
        0,
        163,
        218
    ];
});
parcelRegister("6ntiT", function(module, exports) {
    module.exports = new URL("exclamation-triangle-yellow.a39d9b20.svg", import.meta.url).toString();
});
parcelRegister("kPIJk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a517a82336cbd5a2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a517a82336cbd5a2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeader: {
            "id": "servicedesk-reports-common.table.error.error-header",
            "defaultMessage": "Couldn't fetch results"
        },
        errorDescription: {
            "id": "servicedesk-reports-common.table.error.error-description",
            "defaultMessage": "There was a problem while communicating with the server. Please try again later."
        }
    });
});
parcelRegister("5WvTQ", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$03eb1a987fb3bf09$export$3b4e64e77073e307);
    var $5uXOq = parcelRequire("5uXOq");
    var $6FTcZ;
    var $gq0sA;
    var $fQW4s;
    var $e952N;
    const $03eb1a987fb3bf09$export$3b4e64e77073e307 = ({ baseUrl: baseUrl, usePageContext: usePageContext = (0, (0, parcelRequire("gq0sA")).usePageContext), useKbConfluenceContext: useKbConfluenceContext = (0, (0, parcelRequire("6FTcZ")).useKbConfluenceContext) })=>{
        const [{ data: pageContextData }] = usePageContext();
        const { projectContext: projectContext } = pageContextData || {};
        const { projectKey: projectKey, isAdmin: isAdmin } = projectContext || {};
        const [{ data: confluenceLink, error: confluenceLinkError, loading: loading }] = useKbConfluenceContext(projectKey);
        if (loading) return null;
        const noConfMsgProps = {
            settingMessage: (0, (0, parcelRequire("fQW4s")).default).linkToConfluenceSetting,
            warningIconLabel: (0, (0, parcelRequire("fQW4s")).default).warningIconLabel,
            isAdmin: isAdmin,
            baseUrl: baseUrl,
            projectKey: projectKey
        };
        if (confluenceLinkError) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e952N")).NotLinkConfluenceMessage), {
            ...noConfMsgProps,
            errorMessage: (0, (0, parcelRequire("fQW4s")).default).linkNotSupportedJsm
        }));
        if (!confluenceLink) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e952N")).NotLinkConfluenceMessage), {
            ...noConfMsgProps,
            errorMessage: (0, (0, parcelRequire("fQW4s")).default).linkNotAvailableJsm
        }));
        return null;
    };
});
parcelRegister("6FTcZ", function(module, exports) {
    $parcel$export(module.exports, "useKbConfluenceContext", ()=>$5955acba1bcddf7a$export$a8450b4f39918e6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjZiV;
    var $2YP9W;
    const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource);
    const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("2YP9W")).useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
    var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;
});
parcelRegister("fQW4s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3f3e962dd09f811$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e3f3e962dd09f811$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        linkNotSupportedJsm: {
            "id": "servicedesk-kb-requests-reports.banner.link-not-supported-jsm",
            "defaultMessage": "This service project is {tagStart}currently does not linked to a same domain Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves."
        },
        linkNotAvailableJsm: {
            "id": "servicedesk-kb-requests-reports.banner.link-not-available-jsm",
            "defaultMessage": "This service project is {tagStart}currently not linked to a Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves."
        },
        linkToConfluenceSetting: {
            "id": "servicedesk-kb-requests-reports.banner.link-to-confluence-setting",
            "defaultMessage": "Configure your knowledge base settings"
        },
        warningIconLabel: {
            "id": "servicedesk-kb-requests-reports.banner.warning-icon-label",
            "defaultMessage": "Not Supported Confluence Space"
        }
    });
});
parcelRegister("e952N", function(module, exports) {
    $parcel$export(module.exports, "NotLinkConfluenceMessage", ()=>$d5fb99130033a2af$export$c8d76945603e7c7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gIcG2;
    var $koVbs;
    var $cqCFF;
    var $og0kl;
    const $d5fb99130033a2af$export$c8d76945603e7c7f = ({ warningIconLabel: warningIconLabel, errorMessage: errorMessage, isAdmin: isAdmin, ...rest })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d5fb99130033a2af$var$BannerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d5fb99130033a2af$var$StyledWarningIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gIcG2"))))), {
            label: intl.formatMessage(warningIconLabel),
            primaryColor: `var(--ds-icon-warning, ${(0, $72ba03e317f3d228$exports).B400})`,
            size: "medium"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cqCFF")).ErrorMessage), {
            errorMessage: errorMessage
        }), isAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("og0kl")).LinkToConfluenceSetting), rest)));
    };
    const $d5fb99130033a2af$var$BannerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt46ucv _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $d5fb99130033a2af$var$StyledWarningIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4ie5z",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cqCFF", function(module, exports) {
    $parcel$export(module.exports, "ErrorMessage", ()=>$a2865fd89b7c8236$export$915e9e7bd4f0f96d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ZuPvl;
    var $koVbs;
    var $hZF5L;
    const $a2865fd89b7c8236$export$915e9e7bd4f0f96d = ({ errorMessage: errorMessage })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZF5L")).FormattedReactMessage), {
            message: intl.formatMessage(errorMessage, {
                tagStart: '{tagStart}',
                tagEnd: '{tagEnd}'
            }),
            openingTag: "{tagStart}",
            closingTag: "{tagEnd}",
            Component: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                    as: "strong"
                }, children)
        }));
    };
});
parcelRegister("hZF5L", function(module, exports) {
    $parcel$export(module.exports, "FormattedReactMessage", ()=>$b9b519d540c2bd1e$export$20942ce5ea74ad18);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XO6n;
    var $gl0PU;
    var $1RLjE;
    const $b9b519d540c2bd1e$export$20942ce5ea74ad18 = (props)=>{
        const { message: message, openingTag: openingTag, closingTag: closingTag, Component: Component } = props;
        const startIndex = message.indexOf(openingTag);
        const endIndex = message.indexOf(closingTag);
        if (startIndex === -1 || endIndex === -1 || startIndex > endIndex) {
            (0, (0, parcelRequire("1RLjE")).logError)((0, (0, parcelRequire("3XO6n")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('formatReactMessage'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)(`Malformed message: "${message}"`));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, message.replace(openingTag, '').replace(closingTag, ''));
        }
        const parts = message.split(openingTag);
        if (parts.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, message.replace(closingTag, ''));
        const before = parts[0];
        const [children, after] = parts[1].split(closingTag);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, before, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null, children), after);
    };
});
parcelRegister("og0kl", function(module, exports) {
    $parcel$export(module.exports, "LinkToConfluenceSetting", ()=>$9c9a9a235872d053$export$b2c1ee6fa7fc211e);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $koVbs;
    const $9c9a9a235872d053$export$b2c1ee6fa7fc211e = ({ baseUrl: baseUrl, projectKey: projectKey, settingMessage: settingMessage })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "link",
            href: `${baseUrl}/${projectKey}/confluence-kb`,
            spacing: "none"
        }, intl.formatMessage(settingMessage)));
    };
});
parcelRegister("5ZLpF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f23c3e4b0f79cdc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $koVbs;
    var $8zOmE;
    var $gSNDu;
    const $8f23c3e4b0f79cdc$var$ExportCsvButton = ({ href: href })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportCsvButton');
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8f23c3e4b0f79cdc$var$CsvButtonContainer, {
            "data-test-id": "servicedesk-kb-requests-reports.ui.export-csv.export-csv"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "default",
            href: href,
            onClick: handleClick
        }, formatMessage((0, (0, parcelRequire("gSNDu")).default).exportCsvButtonLabel)));
    };
    var $8f23c3e4b0f79cdc$export$2e2bcd8739ae039 = $8f23c3e4b0f79cdc$var$ExportCsvButton;
    const $8f23c3e4b0f79cdc$var$CsvButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug _u5f3xy5q",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gSNDu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$639e3e104990770b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $639e3e104990770b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        exportCsvButtonLabel: {
            "id": "servicedesk-kb-requests-reports.export-csv.export-csv-button-label",
            "defaultMessage": "Export CSV"
        }
    });
});
parcelRegister("4w0k3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4238f033ae1b1fc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $8PRuf;
    var $3TpKp;
    var $cVReG;
    var $aVOcX;
    var $dAFqR;
    var $dZIz9;
    var $kuEHb;
    var $8u51m;
    const $d4238f033ae1b1fc$var$ChartWithSummaryDetails = ({ summaryResource: summaryResource, drilldownResource: drilldownResource, reportId: reportId, dateFilterQuery: dateFilterQuery, selectedDrillDownPoint: selectedDrillDownPoint, onSetDrillDownPoint: onSetDrillDownPoint })=>{
        const { data: data, loading: loading, error: error } = summaryResource;
        const { fetch: fetchDrillDown } = drilldownResource;
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (selectedDrillDownPoint) {
                ref.current && ref.current.highlightPoint({
                    seriesIndex: selectedDrillDownPoint.seriesIndex,
                    dataIndex: selectedDrillDownPoint.dataIndex,
                    data: selectedDrillDownPoint
                });
                const fetch = async ()=>{
                    await fetchDrillDown({
                        reportId: reportId,
                        date: selectedDrillDownPoint.id,
                        seriesId: selectedDrillDownPoint.seriesId,
                        ...dateFilterQuery,
                        start: (0, (0, parcelRequire("8u51m")).APP_PAGINATION_DEFAULTS).start,
                        limit: (0, (0, parcelRequire("8u51m")).APP_PAGINATION_DEFAULTS).limit
                    });
                };
                fetch();
            } else ref.current && ref.current.downplayPoint();
        }, [
            fetchDrillDown,
            dateFilterQuery,
            reportId,
            selectedDrillDownPoint
        ]);
        const onDrilldownPageChange = (0, $5uXOq.useCallback)((page)=>{
            if (selectedDrillDownPoint) fetchDrillDown({
                reportId: reportId,
                date: selectedDrillDownPoint.id,
                seriesId: selectedDrillDownPoint.seriesId,
                ...dateFilterQuery,
                start: (page - 1) * (0, (0, parcelRequire("8u51m")).APP_PAGINATION_DEFAULTS).limit,
                limit: (0, (0, parcelRequire("8u51m")).APP_PAGINATION_DEFAULTS).limit
            });
        }, [
            fetchDrillDown,
            dateFilterQuery,
            reportId,
            selectedDrillDownPoint
        ]);
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (error !== undefined || data === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAFqR")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVOcX")).default), {
            chartSeries: data.chartSeries
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cVReG")).default), {
            source: data,
            ref: ref,
            onPointSelect: (pointEvent)=>{
                onSetDrillDownPoint(pointEvent.data);
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZIz9")).default), {
            summaryResource: summaryResource,
            drilldownResource: drilldownResource,
            selectedDrillDownPoint: selectedDrillDownPoint,
            onSetDrillDownPoint: onSetDrillDownPoint,
            onDrilldownPageChange: onDrilldownPageChange
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TpKp")).JsmPageInteractiveEvent), {
            key: reportId,
            metricKey: "servicedesk.kb-requests-reports-v2",
            withMarks: [
                (0, (0, parcelRequire("8PRuf")).appBundleReadyMark)
            ],
            appName: "servicedesk.kb-requests-reports-v2",
            metric: (0, (0, parcelRequire("kuEHb")).kbRequestsReportsPageLoad)
        }));
    };
    var $d4238f033ae1b1fc$export$2e2bcd8739ae039 = $d4238f033ae1b1fc$var$ChartWithSummaryDetails;
});
parcelRegister("3TpKp", function(module, exports) {
    $parcel$export(module.exports, "JsmPageInteractiveEvent", ()=>$bbb7386cf97044f2$export$c4ba40c380ee9a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), args);
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
        isExpectedToHaveSsr: false,
        withMarks: [],
        extra: {}
    };
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $czVoz;
    var $9TpzN;
    var $d7oXH;
    var $co1wz;
    var $2m0sQ;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("czVoz")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TpzN")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("d7oXH")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("9TpzN", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$886eecd9178dd67d$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $d7oXH;
    var $knQnR;
    function $886eecd9178dd67d$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $886eecd9178dd67d$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsv1")).default));
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $886eecd9178dd67d$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("knQnR")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $9efn2;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("9efn2")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $2m0sQ;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $d7oXH;
    var $knQnR;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $d7oXH;
    var $knQnR;
    var $2m0sQ;
    var $h9AzB;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("h9AzB")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $d7oXH;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("cVReG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d990bbba331c671$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lXVui = parcelRequire("lXVui");
    var $47isN;
    var $6OGL8;
    var $48mDj;
    var $gLj36;
    var $ixV1I;
    var $koMvQ;
    var $6Ll2T;
    var $k0Jvh;
    var $99gde;
    var $hmJa1;
    var $koVbs;
    var $cnldZ;
    var $2HWES;
    var $aMUni;
    var $61iTG;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("gLj36")).install),
        (0, (0, parcelRequire("48mDj")).install),
        (0, (0, parcelRequire("6OGL8")).install),
        (0, (0, parcelRequire("47isN")).install),
        (0, (0, parcelRequire("koMvQ")).install)
    ]);
    const $3d990bbba331c671$var$echartsForReactStyle = {
        width: '100%',
        height: '100%'
    };
    var $3d990bbba331c671$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)(({ source: source, onPointSelect: onPointSelect }, ref)=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hmJa1")).default)();
        const { searchBy: searchBy, axisLabels: axisLabels, chartSeries: chartSeries, yAxisMinMax: yAxisMinMax } = source;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const formatter = (0, $5uXOq.useCallback)((points)=>(0, (0, parcelRequire("61iTG")).formatTooltip)(intl, points, searchBy), [
            intl,
            searchBy
        ]);
        const yAxisFormatterType = (0, $5uXOq.useMemo)(()=>chartSeries.length && chartSeries[0].data.length && chartSeries[0].data[0].valueType, [
            chartSeries
        ]);
        const yAxisFormatter = (0, $5uXOq.useCallback)((axisValue)=>{
            if (yAxisFormatterType) return (0, (0, parcelRequire("cnldZ")).getFormattedLabel)(yAxisFormatterType, axisValue, intl.formatMessage);
            return axisValue;
        }, [
            intl.formatMessage,
            yAxisFormatterType
        ]);
        const option = (0, $5uXOq.useMemo)(()=>({
                animation: true,
                animationDuration: 300,
                xAxis: (0, (0, parcelRequire("2HWES")).getXAxisConfiguration)(axisLabels),
                yAxis: (0, (0, parcelRequire("2HWES")).getYAxisConfiguration)({
                    yAxisFormatter: yAxisFormatter,
                    minMaxConfig: yAxisMinMax
                }),
                grid: (0, (0, parcelRequire("2HWES")).getGridConfiguration)(),
                tooltip: (0, (0, parcelRequire("2HWES")).getTooltipConfiguration)(formatter),
                series: chartSeries
            }), [
            axisLabels,
            chartSeries,
            formatter,
            yAxisFormatter,
            yAxisMinMax,
            colorMode
        ]);
        const { initChartEventsOnMount: initChartEventsOnMount, highlightPoint: highlightPoint, downplayPoint: downplayPoint, refreshOptions: refreshOptions } = (0, (0, parcelRequire("aMUni")).useChartEvents)({
            onPointSelect: onPointSelect,
            source: source
        });
        (0, $5uXOq.useImperativeHandle)(ref, ()=>({
                highlightPoint: highlightPoint,
                downplayPoint: downplayPoint
            }));
        (0, $5uXOq.useEffect)(()=>{
            refreshOptions(option);
        }, [
            option,
            refreshOptions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3d990bbba331c671$var$JsmReportsEcharts, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            echarts: (0, parcelRequire("ixV1I")),
            onChartReady: initChartEventsOnMount,
            option: option,
            style: $3d990bbba331c671$var$echartsForReactStyle
        }));
    });
    const $3d990bbba331c671$var$AspectRatioFallback = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "div",
            xcss: $3d990bbba331c671$var$aspectRatioFallbackStyles
        }, children);
    const $3d990bbba331c671$var$JsmReportsEcharts = ({ children: children })=>{
        const [supportsAspectRatio, setSupportsAspectRatio] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (typeof window !== 'undefined' && 'CSS' in window && 'supports' in CSS) setSupportsAspectRatio(CSS.supports('aspect-ratio', '1 / 1'));
        }, []);
        const jsmReportsEchartsFallbackStyles = (0, (0, parcelRequire("99gde")).xcss)({
            position: 'relative'
        });
        const combinedStyles = supportsAspectRatio ? $3d990bbba331c671$var$jsmReportsEchartsBaseStyles : {
            ...$3d990bbba331c671$var$jsmReportsEchartsBaseStyles,
            ...jsmReportsEchartsFallbackStyles
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: combinedStyles
        }, !supportsAspectRatio ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3d990bbba331c671$var$AspectRatioFallback, null, children)) : children));
    };
    const $3d990bbba331c671$var$aspectRatioFallbackStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '100%',
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        left: 'space.0'
    });
    const $3d990bbba331c671$var$jsmReportsEchartsBaseStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        aspectRatio: '3 / 1'
    });
});
parcelRegister("lXVui", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $ffdbb37eea52750b$var$react_1 = (0, (0, parcelRequire("3VFsf")).__importStar)((parcelRequire("5uXOq")));
    var $grS0X = parcelRequire("grS0X");
    var $6gLUT = parcelRequire("6gLUT");
    var $eBzeD = parcelRequire("eBzeD");
    var $lj6jE = parcelRequire("lj6jE");
    var $1pywT = parcelRequire("1pywT");
    var $ffdbb37eea52750b$var$EChartsReactCore = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EChartsReactCore, _super);
        function EChartsReactCore(props) {
            var _this = _super.call(this, props) || this;
            _this.echarts = props.echarts;
            _this.ele = null;
            _this.isInitialResize = true;
            return _this;
        }
        EChartsReactCore.prototype.componentDidMount = function() {
            this.renderNewEcharts();
        };
        EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
            var shouldSetOption = this.props.shouldSetOption;
            if ((0, $eBzeD.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
            if (!(0, $1pywT.isEqual)(prevProps.theme, this.props.theme) || !(0, $1pywT.isEqual)(prevProps.opts, this.props.opts) || !(0, $1pywT.isEqual)(prevProps.onEvents, this.props.onEvents)) {
                this.dispose();
                this.renderNewEcharts();
                return;
            }
            var pickKeys = [
                'option',
                'notMerge',
                'lazyUpdate',
                'showLoading',
                'loadingOption'
            ];
            if (!(0, $1pywT.isEqual)((0, $6gLUT.pick)(this.props, pickKeys), (0, $6gLUT.pick)(prevProps, pickKeys))) this.updateEChartsOption();
            if (!(0, $1pywT.isEqual)(prevProps.style, this.props.style) || !(0, $1pywT.isEqual)(prevProps.className, this.props.className)) this.resize();
        };
        EChartsReactCore.prototype.componentWillUnmount = function() {
            this.dispose();
        };
        EChartsReactCore.prototype.getEchartsInstance = function() {
            return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
        };
        EChartsReactCore.prototype.dispose = function() {
            if (this.ele) {
                try {
                    (0, $grS0X.clear)(this.ele);
                } catch (e) {
                    console.warn(e);
                }
                this.echarts.dispose(this.ele);
            }
        };
        EChartsReactCore.prototype.renderNewEcharts = function() {
            var _this = this;
            var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
            var echartsInstance = this.updateEChartsOption();
            this.bindEvents(echartsInstance, onEvents || {});
            if ((0, $eBzeD.isFunction)(onChartReady)) onChartReady(echartsInstance);
            if (this.ele) (0, $grS0X.bind)(this.ele, function() {
                _this.resize();
            });
        };
        EChartsReactCore.prototype.bindEvents = function(instance, events) {
            function _bindEvent(eventName, func) {
                if ((0, $lj6jE.isString)(eventName) && (0, $eBzeD.isFunction)(func)) instance.on(eventName, function(param) {
                    func(param, instance);
                });
            }
            for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
        };
        EChartsReactCore.prototype.updateEChartsOption = function() {
            var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
            var echartInstance = this.getEchartsInstance();
            echartInstance.setOption(option, notMerge, lazyUpdate);
            if (showLoading) echartInstance.showLoading(loadingOption);
            else echartInstance.hideLoading();
            return echartInstance;
        };
        EChartsReactCore.prototype.resize = function() {
            var echartsInstance = this.getEchartsInstance();
            if (!this.isInitialResize) try {
                echartsInstance.resize();
            } catch (e) {
                console.warn(e);
            }
            this.isInitialResize = false;
        };
        EChartsReactCore.prototype.render = function() {
            var _this = this;
            var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
            var newStyle = (0, (0, parcelRequire("3VFsf")).__assign)({
                height: 300
            }, style);
            return $ffdbb37eea52750b$var$react_1.default.createElement("div", {
                ref: function(e) {
                    _this.ele = e;
                },
                style: newStyle,
                className: "echarts-for-react " + className
            });
        };
        return EChartsReactCore;
    }($ffdbb37eea52750b$var$react_1.PureComponent);
    module.exports.default = $ffdbb37eea52750b$var$EChartsReactCore;
});
parcelRegister("grS0X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ver = module.exports.clear = module.exports.bind = void 0;
    var $8x2zG = parcelRequire("8x2zG");
    var $bf9911179e98088f$var$bind = function bind(element, cb) {
        var sensor = (0, $8x2zG.getSensor)(element);
        sensor.bind(cb);
        return function() {
            sensor.unbind(cb);
        };
    };
    module.exports.bind = $bf9911179e98088f$var$bind;
    var $bf9911179e98088f$var$clear = function clear(element) {
        var sensor = (0, $8x2zG.getSensor)(element);
        (0, $8x2zG.removeSensor)(sensor);
    };
    module.exports.clear = $bf9911179e98088f$var$clear;
    var $bf9911179e98088f$var$ver = "1.0.1";
    module.exports.ver = $bf9911179e98088f$var$ver;
});
parcelRegister("8x2zG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.removeSensor = module.exports.getSensor = void 0;
    var $6363670a61880ddf$var$_id = $6363670a61880ddf$var$_interopRequireDefault((parcelRequire("fiP6o")));
    var $gWzBv = parcelRequire("gWzBv");
    var $cdrHo = parcelRequire("cdrHo");
    function $6363670a61880ddf$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $6363670a61880ddf$var$Sensors = {};
    var $6363670a61880ddf$var$getSensor = function getSensor(element) {
        var sensorId = element.getAttribute($cdrHo.SizeSensorId);
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) return $6363670a61880ddf$var$Sensors[sensorId];
        var newId = (0, $6363670a61880ddf$var$_id["default"])();
        element.setAttribute($cdrHo.SizeSensorId, newId);
        var sensor = (0, $gWzBv.createSensor)(element);
        $6363670a61880ddf$var$Sensors[newId] = sensor;
        return sensor;
    };
    module.exports.getSensor = $6363670a61880ddf$var$getSensor;
    var $6363670a61880ddf$var$removeSensor = function removeSensor(sensor) {
        var sensorId = sensor.element.getAttribute($cdrHo.SizeSensorId);
        sensor.element.removeAttribute($cdrHo.SizeSensorId);
        sensor.destroy();
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) delete $6363670a61880ddf$var$Sensors[sensorId];
    };
    module.exports.removeSensor = $6363670a61880ddf$var$removeSensor;
});
parcelRegister("fiP6o", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $b2402d3f57c74659$var$id = 1;
    var $b2402d3f57c74659$var$_default = function _default() {
        return "".concat($b2402d3f57c74659$var$id++);
    };
    module.exports["default"] = $b2402d3f57c74659$var$_default;
});
parcelRegister("gWzBv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $1oYX1 = parcelRequire("1oYX1");
    var $gxB4H = parcelRequire("gxB4H");
    var $c55dae5359197dfc$var$createSensor = typeof ResizeObserver !== 'undefined' ? $gxB4H.createSensor : $1oYX1.createSensor;
    module.exports.createSensor = $c55dae5359197dfc$var$createSensor;
});
parcelRegister("1oYX1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $10574fe90a26a00a$var$_debounce = $10574fe90a26a00a$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    var $cdrHo = parcelRequire("cdrHo");
    function $10574fe90a26a00a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $10574fe90a26a00a$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var newSensor = function newSensor() {
            if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
            var obj = document.createElement('object');
            obj.onload = function() {
                obj.contentDocument.defaultView.addEventListener('resize', resizeListener);
                resizeListener();
            };
            obj.style.display = 'block';
            obj.style.position = 'absolute';
            obj.style.top = '0';
            obj.style.left = '0';
            obj.style.height = '100%';
            obj.style.width = '100%';
            obj.style.overflow = 'hidden';
            obj.style.pointerEvents = 'none';
            obj.style.zIndex = '-1';
            obj.style.opacity = '0';
            obj.setAttribute('class', $cdrHo.SensorClassName);
            obj.setAttribute('tabindex', $cdrHo.SensorTabIndex);
            obj.type = 'text/html';
            element.appendChild(obj);
            obj.data = 'about:blank';
            return obj;
        };
        var resizeListener = (0, $10574fe90a26a00a$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            if (sensor && sensor.parentNode) {
                if (sensor.contentDocument) sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
                sensor.parentNode.removeChild(sensor);
                sensor = undefined;
                listeners = [];
            }
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $10574fe90a26a00a$var$createSensor;
});
parcelRegister("hwNQ2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $cc2c15b4a43e3633$var$_default = function _default(fn) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
        var timer = null;
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(_this, args);
            }, delay);
        };
    };
    module.exports["default"] = $cc2c15b4a43e3633$var$_default;
});
parcelRegister("cdrHo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
    var $8e4c2f559be5b9b7$var$SizeSensorId = 'size-sensor-id';
    module.exports.SizeSensorId = $8e4c2f559be5b9b7$var$SizeSensorId;
    var $8e4c2f559be5b9b7$var$SensorClassName = 'size-sensor-object';
    module.exports.SensorClassName = $8e4c2f559be5b9b7$var$SensorClassName;
    var $8e4c2f559be5b9b7$var$SensorTabIndex = '-1';
    module.exports.SensorTabIndex = $8e4c2f559be5b9b7$var$SensorTabIndex;
});
parcelRegister("gxB4H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $c0ac7cab0e8dcc43$var$_debounce = $c0ac7cab0e8dcc43$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    function $c0ac7cab0e8dcc43$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $c0ac7cab0e8dcc43$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var resizeListener = (0, $c0ac7cab0e8dcc43$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var newSensor = function newSensor() {
            var s = new ResizeObserver(resizeListener);
            s.observe(element);
            resizeListener();
            return s;
        };
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            sensor.disconnect();
            listeners = [];
            sensor = undefined;
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $c0ac7cab0e8dcc43$var$createSensor;
});
parcelRegister("6gLUT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.pick = void 0;
    function $490967eff7da5641$var$pick(obj, keys) {
        var r = {};
        keys.forEach(function(key) {
            r[key] = obj[key];
        });
        return r;
    }
    module.exports.pick = $490967eff7da5641$var$pick;
});
parcelRegister("eBzeD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isFunction = void 0;
    function $aa1fda532dd852be$var$isFunction(v) {
        return typeof v === 'function';
    }
    module.exports.isFunction = $aa1fda532dd852be$var$isFunction;
});
parcelRegister("lj6jE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isString = void 0;
    function $f83045889662a498$var$isString(v) {
        return typeof v === 'string';
    }
    module.exports.isString = $f83045889662a498$var$isString;
});
parcelRegister("1pywT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isEqual = void 0;
    var $3VFsf;
    var $1072e91c08f205e9$var$fast_deep_equal_1 = (0, (0, parcelRequire("3VFsf")).__importDefault)((parcelRequire("1SBaA")));
    module.exports.isEqual = $1072e91c08f205e9$var$fast_deep_equal_1.default;
});
parcelRegister("1SBaA", function(module, exports) {
    'use strict';
    module.exports = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        return a !== a && b !== b;
    };
});
parcelRegister("47isN", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$2ff6234e7db26f51$export$4b3e715f166fdd78);
    var $jvYs5;
    var $cDBtZ;
    var $5xgWc;
    var $7jcIW;
    function $2ff6234e7db26f51$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("cDBtZ")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("jvYs5")).default));
        registers.registerLayout((0, (0, parcelRequire("5xgWc")).default)('line', true));
        registers.registerVisual({
            seriesType: 'line',
            reset: function(seriesModel) {
                var data = seriesModel.getData();
                var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
                if (lineStyle && !lineStyle.stroke) lineStyle.stroke = data.getVisual('style').fill;
                data.setVisual('legendLineStyle', lineStyle);
            }
        });
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, (0, parcelRequire("7jcIW")).default)('line'));
    }
});
parcelRegister("jvYs5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e34fce1556fedd5e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bAY5l;
    var $1O7Ua;
    var $7yklO;
    var $4KVOr;
    var $e34fce1556fedd5e$var$LineSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LineSeriesModel, _super);
        function LineSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = LineSeriesModel.type;
            _this.hasSymbolVisual = true;
            return _this;
        }
        LineSeriesModel.prototype.getInitialData = function(option) {
            var coordSys;
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        LineSeriesModel.prototype.getLegendIcon = function(opt) {
            var group = new (0, (0, parcelRequire("4KVOr")).default)();
            var line = (0, (0, parcelRequire("7yklO")).createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
            group.add(line);
            line.setStyle(opt.lineStyle);
            var visualType = this.getData().getVisual('symbol');
            var visualRotate = this.getData().getVisual('symbolRotate');
            var symbolType = visualType === 'none' ? 'circle' : visualType;
            var size = opt.itemHeight * 0.8;
            var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
            group.add(symbol);
            symbol.setStyle(opt.itemStyle);
            var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
            symbol.rotation = symbolRotate * Math.PI / 180;
            symbol.setOrigin([
                opt.itemWidth / 2,
                opt.itemHeight / 2
            ]);
            if (symbolType.indexOf('empty') > -1) {
                symbol.style.stroke = symbol.style.fill;
                symbol.style.fill = '#fff';
                symbol.style.lineWidth = 2;
            }
            return group;
        };
        LineSeriesModel.type = 'series.line';
        LineSeriesModel.dependencies = [
            'grid',
            'polar'
        ];
        LineSeriesModel.defaultOption = {
            zlevel: 0,
            z: 3,
            coordinateSystem: 'cartesian2d',
            legendHoverLink: true,
            clip: true,
            label: {
                position: 'top'
            },
            endLabel: {
                show: false,
                valueAnimation: true,
                distance: 8
            },
            lineStyle: {
                width: 2,
                type: 'solid'
            },
            emphasis: {
                scale: true,
                lineStyle: {
                    width: 'bolder'
                }
            },
            step: false,
            smooth: false,
            smoothMonotone: null,
            symbol: 'emptyCircle',
            symbolSize: 4,
            symbolRotate: null,
            showSymbol: true,
            showAllSymbol: 'auto',
            connectNulls: false,
            sampling: 'none',
            animationEasing: 'linear',
            progressive: 0,
            hoverLayerThreshold: Infinity,
            universalTransition: {
                divideShape: 'clone'
            }
        };
        return LineSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    var $e34fce1556fedd5e$export$2e2bcd8739ae039 = $e34fce1556fedd5e$var$LineSeriesModel;
});
parcelRegister("bAY5l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8711aa3240a9c687$export$2e2bcd8739ae039);
    var $bahqM;
    var $liBXN;
    var $h9jiS;
    var $bnVGB;
    var $eaKsF;
    var $gyhNQ;
    var $lhMGv;
    var $20liu;
    var $5R8Hi;
    var $cNGs8;
    var $2Rbm1;
    function $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var registeredCoordSys = (0, (0, parcelRequire("gyhNQ")).default).get(coordSysName);
        var coordSysDimDefs;
        if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = (0, parcelRequire("bahqM")).map(coordSysInfo.coordSysDims, function(dim) {
            var dimInfo = {
                name: dim
            };
            var axisModel = coordSysInfo.axisMap.get(dim);
            if (axisModel) {
                var axisType = axisModel.get('type');
                dimInfo.type = (0, (0, parcelRequire("bnVGB")).getDimensionTypeByAxis)(axisType);
            }
            return dimInfo;
        });
        if (!coordSysDimDefs) coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
            'x',
            'y'
        ];
        return coordSysDimDefs;
    }
    function $8711aa3240a9c687$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
        var firstCategoryDimIndex;
        var hasNameEncode;
        coordSysInfo && (0, parcelRequire("bahqM")).each(dimInfoList, function(dimInfo, dimIndex) {
            var coordDim = dimInfo.coordDim;
            var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
            if (categoryAxisModel) {
                if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
                dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
                if (createInvertedIndices) dimInfo.createInvertedIndices = true;
            }
            if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
        });
        if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
        return firstCategoryDimIndex;
    }
    function $8711aa3240a9c687$var$createSeriesData(sourceRaw, seriesModel, opt) {
        opt = opt || {};
        var sourceManager = seriesModel.getSourceManager();
        var source;
        var isOriginalSource = false;
        if (sourceRaw) {
            isOriginalSource = true;
            source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceRaw);
        } else {
            source = sourceManager.getSource();
            isOriginalSource = source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
        }
        var coordSysInfo = (0, (0, parcelRequire("lhMGv")).getCoordSysInfoBySeries)(seriesModel);
        var coordSysDimDefs = $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
        var useEncodeDefaulter = opt.useEncodeDefaulter;
        var encodeDefaulter = (0, parcelRequire("bahqM")).isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("cNGs8")).makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
        var createDimensionOptions = {
            coordDimensions: coordSysDimDefs,
            generateCoord: opt.generateCoord,
            encodeDefine: seriesModel.getEncode(),
            encodeDefaulter: encodeDefaulter,
            canOmitUnusedDimensions: !isOriginalSource
        };
        var schema = (0, (0, parcelRequire("h9jiS")).default)(source, createDimensionOptions);
        var firstCategoryDimIndex = $8711aa3240a9c687$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
        var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
        var stackCalculationInfo = (0, (0, parcelRequire("5R8Hi")).enableDataStack)(seriesModel, {
            schema: schema,
            store: store
        });
        var data = new (0, (0, parcelRequire("liBXN")).default)(schema, seriesModel);
        data.setCalculationInfo(stackCalculationInfo);
        var dimValueGetter = firstCategoryDimIndex != null && $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
            return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
        } : null;
        data.hasItemOption = false;
        data.initData(isOriginalSource ? source : store, null, dimValueGetter);
        return data;
    }
    function $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) {
        if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var sampleItem = $8711aa3240a9c687$var$firstDataNotNull(source.data || []);
            return sampleItem != null && !(0, parcelRequire("bahqM")).isArray((0, (0, parcelRequire("eaKsF")).getDataItemValue)(sampleItem));
        }
    }
    function $8711aa3240a9c687$var$firstDataNotNull(arr) {
        var i = 0;
        while(i < arr.length && arr[i] == null)i++;
        return arr[i];
    }
    var $8711aa3240a9c687$export$2e2bcd8739ae039 = $8711aa3240a9c687$var$createSeriesData;
});
parcelRegister("bahqM", function(module, exports) {
    $parcel$export(module.exports, "$override", ()=>$820e264882d7264f$export$d35a04b83ea6803e);
    $parcel$export(module.exports, "guid", ()=>$820e264882d7264f$export$46e8f25c7328f77e);
    $parcel$export(module.exports, "logError", ()=>$820e264882d7264f$export$58da9968c3170cb1);
    $parcel$export(module.exports, "clone", ()=>$820e264882d7264f$export$9cd59f9826255e47);
    $parcel$export(module.exports, "isPrimitive", ()=>$820e264882d7264f$export$c3825b437cbdea5c);
    $parcel$export(module.exports, "isDom", ()=>$820e264882d7264f$export$9f57505b7bd8dae);
    $parcel$export(module.exports, "merge", ()=>$820e264882d7264f$export$4950aa0f605343fb);
    $parcel$export(module.exports, "isObject", ()=>$820e264882d7264f$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "isArray", ()=>$820e264882d7264f$export$43bee75e5e14138e);
    $parcel$export(module.exports, "isBuiltInObject", ()=>$820e264882d7264f$export$fa523b2c4941fd4f);
    $parcel$export(module.exports, "mergeAll", ()=>$820e264882d7264f$export$18aef43295bbe906);
    $parcel$export(module.exports, "extend", ()=>$820e264882d7264f$export$8b58be045bf06082);
    $parcel$export(module.exports, "defaults", ()=>$820e264882d7264f$export$ebe90cb607ad99e);
    $parcel$export(module.exports, "keys", ()=>$820e264882d7264f$export$ed97f33186d4b816);
    $parcel$export(module.exports, "createCanvas", ()=>$820e264882d7264f$export$cd3d1f114b139967);
    $parcel$export(module.exports, "indexOf", ()=>$820e264882d7264f$export$305f7d4e9d4624f2);
    $parcel$export(module.exports, "inherits", ()=>$820e264882d7264f$export$69f1b2dcda23c5f8);
    $parcel$export(module.exports, "mixin", ()=>$820e264882d7264f$export$e36fc9d62a853069);
    $parcel$export(module.exports, "isArrayLike", ()=>$820e264882d7264f$export$1e2f57719e155213);
    $parcel$export(module.exports, "each", ()=>$820e264882d7264f$export$79b2f7037acddd43);
    $parcel$export(module.exports, "map", ()=>$820e264882d7264f$export$871de8747c9eaa88);
    $parcel$export(module.exports, "slice", ()=>$820e264882d7264f$export$58adb3bec8346d0f);
    $parcel$export(module.exports, "reduce", ()=>$820e264882d7264f$export$533b26079ad0b4b);
    $parcel$export(module.exports, "filter", ()=>$820e264882d7264f$export$3dea766d36a8935f);
    $parcel$export(module.exports, "find", ()=>$820e264882d7264f$export$71aa6c912b956294);
    $parcel$export(module.exports, "bind", ()=>$820e264882d7264f$export$2385a24977818dd0);
    $parcel$export(module.exports, "isFunction", ()=>$820e264882d7264f$export$f6e2535fb5126e54);
    $parcel$export(module.exports, "curry", ()=>$820e264882d7264f$export$c3095a23b368d1f2);
    $parcel$export(module.exports, "isString", ()=>$820e264882d7264f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isStringSafe", ()=>$820e264882d7264f$export$29d0bb2a4e07b252);
    $parcel$export(module.exports, "isNumber", ()=>$820e264882d7264f$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isTypedArray", ()=>$820e264882d7264f$export$b119cc7e1840e59c);
    $parcel$export(module.exports, "isGradientObject", ()=>$820e264882d7264f$export$fa2c283003ed971c);
    $parcel$export(module.exports, "isImagePatternObject", ()=>$820e264882d7264f$export$a49bbf3a55dcef7b);
    $parcel$export(module.exports, "isRegExp", ()=>$820e264882d7264f$export$49841c62b9eff15);
    $parcel$export(module.exports, "eqNaN", ()=>$820e264882d7264f$export$7d667b9a0c48c975);
    $parcel$export(module.exports, "retrieve", ()=>$820e264882d7264f$export$8a4d17b6e8486e66);
    $parcel$export(module.exports, "retrieve2", ()=>$820e264882d7264f$export$995e01f2f5c9d030);
    $parcel$export(module.exports, "retrieve3", ()=>$820e264882d7264f$export$2e94551289abb95b);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$820e264882d7264f$export$f3a38102c49f4268);
    $parcel$export(module.exports, "assert", ()=>$820e264882d7264f$export$a7a9523472993e97);
    $parcel$export(module.exports, "trim", ()=>$820e264882d7264f$export$87c2784dc9fc4ab);
    $parcel$export(module.exports, "setAsPrimitive", ()=>$820e264882d7264f$export$112e66431016387b);
    $parcel$export(module.exports, "HashMap", ()=>$820e264882d7264f$export$60ef0b43d585640a);
    $parcel$export(module.exports, "createHashMap", ()=>$820e264882d7264f$export$55f8aa7ef875b0a4);
    $parcel$export(module.exports, "concatArray", ()=>$820e264882d7264f$export$4fd8af2c48c43416);
    $parcel$export(module.exports, "createObject", ()=>$820e264882d7264f$export$79c7e160a7743efd);
    $parcel$export(module.exports, "hasOwn", ()=>$820e264882d7264f$export$b5a638e9b3fff9f3);
    $parcel$export(module.exports, "noop", ()=>$820e264882d7264f$export$8793edee2d425525);
    var $820e264882d7264f$var$BUILTIN_OBJECT = {
        '[object Function]': true,
        '[object RegExp]': true,
        '[object Date]': true,
        '[object Error]': true,
        '[object CanvasGradient]': true,
        '[object CanvasPattern]': true,
        '[object Image]': true,
        '[object Canvas]': true
    };
    var $820e264882d7264f$var$TYPED_ARRAY = {
        '[object Int8Array]': true,
        '[object Uint8Array]': true,
        '[object Uint8ClampedArray]': true,
        '[object Int16Array]': true,
        '[object Uint16Array]': true,
        '[object Int32Array]': true,
        '[object Uint32Array]': true,
        '[object Float32Array]': true,
        '[object Float64Array]': true
    };
    var $820e264882d7264f$var$objToString = Object.prototype.toString;
    var $820e264882d7264f$var$arrayProto = Array.prototype;
    var $820e264882d7264f$var$nativeForEach = $820e264882d7264f$var$arrayProto.forEach;
    var $820e264882d7264f$var$nativeFilter = $820e264882d7264f$var$arrayProto.filter;
    var $820e264882d7264f$var$nativeSlice = $820e264882d7264f$var$arrayProto.slice;
    var $820e264882d7264f$var$nativeMap = $820e264882d7264f$var$arrayProto.map;
    var $820e264882d7264f$var$ctorFunction = (function() {}).constructor;
    var $820e264882d7264f$var$protoFunction = $820e264882d7264f$var$ctorFunction ? $820e264882d7264f$var$ctorFunction.prototype : null;
    var $820e264882d7264f$var$protoKey = '__proto__';
    var $820e264882d7264f$var$methods = {};
    function $820e264882d7264f$export$d35a04b83ea6803e(name, fn) {
        $820e264882d7264f$var$methods[name] = fn;
    }
    var $820e264882d7264f$var$idStart = 0x0907;
    function $820e264882d7264f$export$46e8f25c7328f77e() {
        return $820e264882d7264f$var$idStart++;
    }
    function $820e264882d7264f$export$58da9968c3170cb1() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (typeof console !== 'undefined') console.error.apply(console, args);
    }
    function $820e264882d7264f$export$9cd59f9826255e47(source) {
        if (source == null || typeof source !== 'object') return source;
        var result = source;
        var typeStr = $820e264882d7264f$var$objToString.call(source);
        if (typeStr === '[object Array]') {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                result = [];
                for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
            }
        } else if ($820e264882d7264f$var$TYPED_ARRAY[typeStr]) {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                var Ctor = source.constructor;
                if (Ctor.from) result = Ctor.from(source);
                else {
                    result = new Ctor(source.length);
                    for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
                }
            }
        } else if (!$820e264882d7264f$var$BUILTIN_OBJECT[typeStr] && !$820e264882d7264f$export$c3825b437cbdea5c(source) && !$820e264882d7264f$export$9f57505b7bd8dae(source)) {
            result = {};
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) result[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return result;
    }
    function $820e264882d7264f$export$4950aa0f605343fb(target, source, overwrite) {
        if (!$820e264882d7264f$export$a6cdc56e425d0d0a(source) || !$820e264882d7264f$export$a6cdc56e425d0d0a(target)) return overwrite ? $820e264882d7264f$export$9cd59f9826255e47(source) : target;
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) {
            var targetProp = target[key];
            var sourceProp = source[key];
            if ($820e264882d7264f$export$a6cdc56e425d0d0a(sourceProp) && $820e264882d7264f$export$a6cdc56e425d0d0a(targetProp) && !$820e264882d7264f$export$43bee75e5e14138e(sourceProp) && !$820e264882d7264f$export$43bee75e5e14138e(targetProp) && !$820e264882d7264f$export$9f57505b7bd8dae(sourceProp) && !$820e264882d7264f$export$9f57505b7bd8dae(targetProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(sourceProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(targetProp) && !$820e264882d7264f$export$c3825b437cbdea5c(sourceProp) && !$820e264882d7264f$export$c3825b437cbdea5c(targetProp)) $820e264882d7264f$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
            else if (overwrite || !(key in target)) target[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return target;
    }
    function $820e264882d7264f$export$18aef43295bbe906(targetAndSources, overwrite) {
        var result = targetAndSources[0];
        for(var i = 1, len = targetAndSources.length; i < len; i++)result = $820e264882d7264f$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
        return result;
    }
    function $820e264882d7264f$export$8b58be045bf06082(target, source) {
        if (Object.assign) Object.assign(target, source);
        else {
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) target[key] = source[key];
        }
        return target;
    }
    function $820e264882d7264f$export$ebe90cb607ad99e(target, source, overlay) {
        var keysArr = $820e264882d7264f$export$ed97f33186d4b816(source);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
        }
        return target;
    }
    var $820e264882d7264f$export$cd3d1f114b139967 = function() {
        return $820e264882d7264f$var$methods.createCanvas();
    };
    $820e264882d7264f$var$methods.createCanvas = function() {
        return document.createElement('canvas');
    };
    function $820e264882d7264f$export$305f7d4e9d4624f2(array, value) {
        if (array) {
            if (array.indexOf) return array.indexOf(value);
            for(var i = 0, len = array.length; i < len; i++){
                if (array[i] === value) return i;
            }
        }
        return -1;
    }
    function $820e264882d7264f$export$69f1b2dcda23c5f8(clazz, baseClazz) {
        var clazzPrototype = clazz.prototype;
        function F() {}
        F.prototype = baseClazz.prototype;
        clazz.prototype = new F();
        for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
        clazz.prototype.constructor = clazz;
        clazz.superClass = baseClazz;
    }
    function $820e264882d7264f$export$e36fc9d62a853069(target, source, override) {
        target = 'prototype' in target ? target.prototype : target;
        source = 'prototype' in source ? source.prototype : source;
        if (Object.getOwnPropertyNames) {
            var keyList = Object.getOwnPropertyNames(source);
            for(var i = 0; i < keyList.length; i++){
                var key = keyList[i];
                if (key !== 'constructor') {
                    if (override ? source[key] != null : target[key] == null) target[key] = source[key];
                }
            }
        } else $820e264882d7264f$export$ebe90cb607ad99e(target, source, override);
    }
    function $820e264882d7264f$export$1e2f57719e155213(data) {
        if (!data) return false;
        if (typeof data === 'string') return false;
        return typeof data.length === 'number';
    }
    function $820e264882d7264f$export$79b2f7037acddd43(arr, cb, context) {
        if (!(arr && cb)) return;
        if (arr.forEach && arr.forEach === $820e264882d7264f$var$nativeForEach) arr.forEach(cb, context);
        else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
        else {
            for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
        }
    }
    function $820e264882d7264f$export$871de8747c9eaa88(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.map && arr.map === $820e264882d7264f$var$nativeMap) return arr.map(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
            return result;
        }
    }
    function $820e264882d7264f$export$533b26079ad0b4b(arr, cb, memo, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
        return memo;
    }
    function $820e264882d7264f$export$3dea766d36a8935f(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.filter && arr.filter === $820e264882d7264f$var$nativeFilter) return arr.filter(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
            return result;
        }
    }
    function $820e264882d7264f$export$71aa6c912b956294(arr, cb, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++){
            if (cb.call(context, arr[i], i, arr)) return arr[i];
        }
    }
    function $820e264882d7264f$export$ed97f33186d4b816(obj) {
        if (!obj) return [];
        if (Object.keys) return Object.keys(obj);
        var keyList = [];
        for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
        return keyList;
    }
    function $820e264882d7264f$var$bindPolyfill(func, context) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return function() {
            return func.apply(context, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    var $820e264882d7264f$export$2385a24977818dd0 = $820e264882d7264f$var$protoFunction && $820e264882d7264f$export$f6e2535fb5126e54($820e264882d7264f$var$protoFunction.bind) ? $820e264882d7264f$var$protoFunction.call.bind($820e264882d7264f$var$protoFunction.bind) : $820e264882d7264f$var$bindPolyfill;
    function $820e264882d7264f$export$c3095a23b368d1f2(func) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return function() {
            return func.apply(this, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    function $820e264882d7264f$export$43bee75e5e14138e(value) {
        if (Array.isArray) return Array.isArray(value);
        return $820e264882d7264f$var$objToString.call(value) === '[object Array]';
    }
    function $820e264882d7264f$export$f6e2535fb5126e54(value) {
        return typeof value === 'function';
    }
    function $820e264882d7264f$export$844ec244b1367d54(value) {
        return typeof value === 'string';
    }
    function $820e264882d7264f$export$29d0bb2a4e07b252(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object String]';
    }
    function $820e264882d7264f$export$7e4aa119212bc614(value) {
        return typeof value === 'number';
    }
    function $820e264882d7264f$export$a6cdc56e425d0d0a(value) {
        var type = typeof value;
        return type === 'function' || !!value && type === 'object';
    }
    function $820e264882d7264f$export$fa523b2c4941fd4f(value) {
        return !!$820e264882d7264f$var$BUILTIN_OBJECT[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$b119cc7e1840e59c(value) {
        return !!$820e264882d7264f$var$TYPED_ARRAY[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$9f57505b7bd8dae(value) {
        return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
    }
    function $820e264882d7264f$export$fa2c283003ed971c(value) {
        return value.colorStops != null;
    }
    function $820e264882d7264f$export$a49bbf3a55dcef7b(value) {
        return value.image != null;
    }
    function $820e264882d7264f$export$49841c62b9eff15(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object RegExp]';
    }
    function $820e264882d7264f$export$7d667b9a0c48c975(value) {
        return value !== value;
    }
    function $820e264882d7264f$export$8a4d17b6e8486e66() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        for(var i = 0, len = args.length; i < len; i++){
            if (args[i] != null) return args[i];
        }
    }
    function $820e264882d7264f$export$995e01f2f5c9d030(value0, value1) {
        return value0 != null ? value0 : value1;
    }
    function $820e264882d7264f$export$2e94551289abb95b(value0, value1, value2) {
        return value0 != null ? value0 : value1 != null ? value1 : value2;
    }
    function $820e264882d7264f$export$58adb3bec8346d0f(arr) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $820e264882d7264f$var$nativeSlice.apply(arr, args);
    }
    function $820e264882d7264f$export$f3a38102c49f4268(val) {
        if (typeof val === 'number') return [
            val,
            val,
            val,
            val
        ];
        var len = val.length;
        if (len === 2) return [
            val[0],
            val[1],
            val[0],
            val[1]
        ];
        else if (len === 3) return [
            val[0],
            val[1],
            val[2],
            val[1]
        ];
        return val;
    }
    function $820e264882d7264f$export$a7a9523472993e97(condition, message) {
        if (!condition) throw new Error(message);
    }
    function $820e264882d7264f$export$87c2784dc9fc4ab(str) {
        if (str == null) return null;
        else if (typeof str.trim === 'function') return str.trim();
        else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    var $820e264882d7264f$var$primitiveKey = '__ec_primitive__';
    function $820e264882d7264f$export$112e66431016387b(obj) {
        obj[$820e264882d7264f$var$primitiveKey] = true;
    }
    function $820e264882d7264f$export$c3825b437cbdea5c(obj) {
        return obj[$820e264882d7264f$var$primitiveKey];
    }
    var $820e264882d7264f$export$60ef0b43d585640a = function() {
        function HashMap(obj) {
            this.data = {};
            var isArr = $820e264882d7264f$export$43bee75e5e14138e(obj);
            this.data = {};
            var thisMap = this;
            obj instanceof HashMap ? obj.each(visit) : obj && $820e264882d7264f$export$79b2f7037acddd43(obj, visit);
            function visit(value, key) {
                isArr ? thisMap.set(value, key) : thisMap.set(key, value);
            }
        }
        HashMap.prototype.get = function(key) {
            return this.data.hasOwnProperty(key) ? this.data[key] : null;
        };
        HashMap.prototype.set = function(key, value) {
            return this.data[key] = value;
        };
        HashMap.prototype.each = function(cb, context) {
            for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
        };
        HashMap.prototype.keys = function() {
            return $820e264882d7264f$export$ed97f33186d4b816(this.data);
        };
        HashMap.prototype.removeKey = function(key) {
            delete this.data[key];
        };
        return HashMap;
    }();
    function $820e264882d7264f$export$55f8aa7ef875b0a4(obj) {
        return new $820e264882d7264f$export$60ef0b43d585640a(obj);
    }
    function $820e264882d7264f$export$4fd8af2c48c43416(a, b) {
        var newArray = new a.constructor(a.length + b.length);
        for(var i = 0; i < a.length; i++)newArray[i] = a[i];
        var offset = a.length;
        for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
        return newArray;
    }
    function $820e264882d7264f$export$79c7e160a7743efd(proto, properties) {
        var obj;
        if (Object.create) obj = Object.create(proto);
        else {
            var StyleCtor = function() {};
            StyleCtor.prototype = proto;
            obj = new StyleCtor();
        }
        if (properties) $820e264882d7264f$export$8b58be045bf06082(obj, properties);
        return obj;
    }
    function $820e264882d7264f$export$b5a638e9b3fff9f3(own, prop) {
        return own.hasOwnProperty(prop);
    }
    function $820e264882d7264f$export$8793edee2d425525() {}
});
parcelRegister("liBXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f818ba28c897a2f2$export$2e2bcd8739ae039);
    var $bahqM;
    var $gaMkj;
    var $4wWkb;
    var $9OHWG;
    var $bnVGB;
    var $dhxbO;
    var $2Rbm1;
    var $eaKsF;
    var $7QjoM;
    var $20liu;
    var $8c3gC;
    var $2Om11;
    var $f818ba28c897a2f2$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $f818ba28c897a2f2$var$map = (0, parcelRequire("bahqM")).map;
    var $f818ba28c897a2f2$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
    var $f818ba28c897a2f2$var$ID_PREFIX = 'e\0\0';
    var $f818ba28c897a2f2$var$INDEX_NOT_FOUND = -1;
    var $f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES = [
        'hasItemOption',
        '_nameList',
        '_idList',
        '_invertedIndicesMap',
        '_dimSummary',
        'userOutput',
        '_rawData',
        '_dimValueGetter',
        '_nameDimIdx',
        '_idDimIdx',
        '_nameRepeatCount'
    ];
    var $f818ba28c897a2f2$var$CLONE_PROPERTIES = [
        '_approximateExtent'
    ];
    var $f818ba28c897a2f2$var$prepareInvertedIndex;
    var $f818ba28c897a2f2$var$getId;
    var $f818ba28c897a2f2$var$getIdNameFromStore;
    var $f818ba28c897a2f2$var$normalizeDimensions;
    var $f818ba28c897a2f2$var$transferProperties;
    var $f818ba28c897a2f2$var$cloneListForMapAndSample;
    var $f818ba28c897a2f2$var$makeIdFromName;
    var $f818ba28c897a2f2$var$SeriesData = function() {
        function SeriesData(dimensionsInput, hostModel) {
            this.type = 'list';
            this._dimOmitted = false;
            this._nameList = [];
            this._idList = [];
            this._visual = {};
            this._layout = {};
            this._itemVisuals = [];
            this._itemLayouts = [];
            this._graphicEls = [];
            this._approximateExtent = {};
            this._calculationInfo = {};
            this.hasItemOption = false;
            this.TRANSFERABLE_METHODS = [
                'cloneShallow',
                'downSample',
                'lttbDownSample',
                'map'
            ];
            this.CHANGABLE_METHODS = [
                'filterSelf',
                'selectRange'
            ];
            this.DOWNSAMPLE_METHODS = [
                'downSample',
                'lttbDownSample'
            ];
            var dimensions;
            var assignStoreDimIdx = false;
            if ((0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput)) {
                dimensions = dimensionsInput.dimensions;
                this._dimOmitted = dimensionsInput.isDimensionOmitted();
                this._schema = dimensionsInput;
            } else {
                assignStoreDimIdx = true;
                dimensions = dimensionsInput;
            }
            dimensions = dimensions || [
                'x',
                'y'
            ];
            var dimensionInfos = {};
            var dimensionNames = [];
            var invertedIndicesMap = {};
            var needsHasOwn = false;
            var emptyObj = {};
            for(var i = 0; i < dimensions.length; i++){
                var dimInfoInput = dimensions[i];
                var dimensionInfo = (0, parcelRequire("bahqM")).isString(dimInfoInput) ? new (0, (0, parcelRequire("dhxbO")).default)({
                    name: dimInfoInput
                }) : !(dimInfoInput instanceof (0, (0, parcelRequire("dhxbO")).default)) ? new (0, (0, parcelRequire("dhxbO")).default)(dimInfoInput) : dimInfoInput;
                var dimensionName = dimensionInfo.name;
                dimensionInfo.type = dimensionInfo.type || 'float';
                if (!dimensionInfo.coordDim) {
                    dimensionInfo.coordDim = dimensionName;
                    dimensionInfo.coordDimIndex = 0;
                }
                var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
                dimensionNames.push(dimensionName);
                dimensionInfos[dimensionName] = dimensionInfo;
                if (emptyObj[dimensionName] != null) needsHasOwn = true;
                if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
                if (otherDims.itemName === 0) this._nameDimIdx = i;
                if (otherDims.itemId === 0) this._idDimIdx = i;
                if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            }
            this.dimensions = dimensionNames;
            this._dimInfos = dimensionInfos;
            this._initGetDimensionInfo(needsHasOwn);
            this.hostModel = hostModel;
            this._invertedIndicesMap = invertedIndicesMap;
            if (this._dimOmitted) {
                var dimIdxToName_1 = this._dimIdxToName = (0, parcelRequire("bahqM")).createHashMap();
                (0, parcelRequire("bahqM")).each(dimensionNames, function(dimName) {
                    dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
                });
            }
        }
        SeriesData.prototype.getDimension = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx == null) return dim;
            dimIdx = dim;
            if (!this._dimOmitted) return this.dimensions[dimIdx];
            var dimName = this._dimIdxToName.get(dimIdx);
            if (dimName != null) return dimName;
            var sourceDimDef = this._schema.getSourceDimension(dimIdx);
            if (sourceDimDef) return sourceDimDef.name;
        };
        SeriesData.prototype.getDimensionIndex = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx != null) return dimIdx;
            if (dim == null) return -1;
            var dimInfo = this._getDimInfo(dim);
            return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
        };
        SeriesData.prototype._recognizeDimIndex = function(dim) {
            if (typeof dim === 'number' || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
        };
        SeriesData.prototype._getStoreDimIndex = function(dim) {
            var dimIdx = this.getDimensionIndex(dim);
            return dimIdx;
        };
        SeriesData.prototype.getDimensionInfo = function(dim) {
            return this._getDimInfo(this.getDimension(dim));
        };
        SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
            var dimensionInfos = this._dimInfos;
            this._getDimInfo = needsHasOwn ? function(dimName) {
                return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
            } : function(dimName) {
                return dimensionInfos[dimName];
            };
        };
        SeriesData.prototype.getDimensionsOnCoord = function() {
            return this._dimSummary.dataDimsOnCoord.slice();
        };
        SeriesData.prototype.mapDimension = function(coordDim, idx) {
            var dimensionsSummary = this._dimSummary;
            if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
            var dims = dimensionsSummary.encode[coordDim];
            return dims ? dims[idx] : null;
        };
        SeriesData.prototype.mapDimensionsAll = function(coordDim) {
            var dimensionsSummary = this._dimSummary;
            var dims = dimensionsSummary.encode[coordDim];
            return (dims || []).slice();
        };
        SeriesData.prototype.getStore = function() {
            return this._store;
        };
        SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
            var _this = this;
            var store;
            if (data instanceof (0, (0, parcelRequire("8c3gC")).default)) store = data;
            if (!store) {
                var dimensions = this.dimensions;
                var provider = (0, (0, parcelRequire("20liu")).isSourceInstance)(data) || (0, parcelRequire("bahqM")).isArrayLike(data) ? new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(data, dimensions.length) : data;
                store = new (0, (0, parcelRequire("8c3gC")).default)();
                var dimensionInfos = $f818ba28c897a2f2$var$map(dimensions, function(dimName) {
                    return {
                        type: _this._dimInfos[dimName].type,
                        property: dimName
                    };
                });
                store.initData(provider, dimensionInfos, dimValueGetter);
            }
            this._store = store;
            this._nameList = (nameList || []).slice();
            this._idList = [];
            this._nameRepeatCount = {};
            this._doInit(0, store.count());
            this._dimSummary = (0, (0, parcelRequire("bnVGB")).summarizeDimensions)(this, this._schema);
            this.userOutput = this._dimSummary.userOutput;
        };
        SeriesData.prototype.appendData = function(data) {
            var range = this._store.appendData(data);
            this._doInit(range[0], range[1]);
        };
        SeriesData.prototype.appendValues = function(values, names) {
            var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
            var shouldMakeIdFromName = this._shouldMakeIdFromName();
            this._updateOrdinalMeta();
            if (names) for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                this._nameList[idx] = names[sourceIdx];
                if (shouldMakeIdFromName) $f818ba28c897a2f2$var$makeIdFromName(this, idx);
            }
        };
        SeriesData.prototype._updateOrdinalMeta = function() {
            var store = this._store;
            var dimensions = this.dimensions;
            for(var i = 0; i < dimensions.length; i++){
                var dimInfo = this._dimInfos[dimensions[i]];
                if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
            }
        };
        SeriesData.prototype._shouldMakeIdFromName = function() {
            var provider = this._store.getProvider();
            return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
        };
        SeriesData.prototype._doInit = function(start, end) {
            if (start >= end) return;
            var store = this._store;
            var provider = store.getProvider();
            this._updateOrdinalMeta();
            var nameList = this._nameList;
            var idList = this._idList;
            var sourceFormat = provider.getSource().sourceFormat;
            var isFormatOriginal = sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
            if (isFormatOriginal && !provider.pure) {
                var sharedDataItem = [];
                for(var idx = start; idx < end; idx++){
                    var dataItem = provider.getItem(idx, sharedDataItem);
                    if (!this.hasItemOption && (0, (0, parcelRequire("eaKsF")).isDataItemOption)(dataItem)) this.hasItemOption = true;
                    if (dataItem) {
                        var itemName = dataItem.name;
                        if (nameList[idx] == null && itemName != null) nameList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemName, null);
                        var itemId = dataItem.id;
                        if (idList[idx] == null && itemId != null) idList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemId, null);
                    }
                }
            }
            if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$f818ba28c897a2f2$var$makeIdFromName(this, idx);
            $f818ba28c897a2f2$var$prepareInvertedIndex(this);
        };
        SeriesData.prototype.getApproximateExtent = function(dim) {
            return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.setApproximateExtent = function(extent, dim) {
            dim = this.getDimension(dim);
            this._approximateExtent[dim] = extent.slice();
        };
        SeriesData.prototype.getCalculationInfo = function(key) {
            return this._calculationInfo[key];
        };
        SeriesData.prototype.setCalculationInfo = function(key, value) {
            $f818ba28c897a2f2$var$isObject(key) ? (0, parcelRequire("bahqM")).extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
        };
        SeriesData.prototype.getName = function(idx) {
            var rawIndex = this.getRawIndex(idx);
            var name = this._nameList[rawIndex];
            if (name == null && this._nameDimIdx != null) name = $f818ba28c897a2f2$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
            if (name == null) name = '';
            return name;
        };
        SeriesData.prototype._getCategory = function(dimIdx, idx) {
            var ordinal = this._store.get(dimIdx, idx);
            var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
            if (ordinalMeta) return ordinalMeta.categories[ordinal];
            return ordinal;
        };
        SeriesData.prototype.getId = function(idx) {
            return $f818ba28c897a2f2$var$getId(this, this.getRawIndex(idx));
        };
        SeriesData.prototype.count = function() {
            return this._store.count();
        };
        SeriesData.prototype.get = function(dim, idx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
        };
        SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
        };
        SeriesData.prototype.getIndices = function() {
            return this._store.getIndices();
        };
        SeriesData.prototype.getDataExtent = function(dim) {
            return this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getSum = function(dim) {
            return this._store.getSum(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getMedian = function(dim) {
            return this._store.getMedian(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getValues = function(dimensions, idx) {
            var _this = this;
            var store = this._store;
            return (0, parcelRequire("bahqM")).isArray(dimensions) ? store.getValues($f818ba28c897a2f2$var$map(dimensions, function(dim) {
                return _this._getStoreDimIndex(dim);
            }), idx) : store.getValues(dimensions);
        };
        SeriesData.prototype.hasValue = function(idx) {
            var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
            for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
                if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
            }
            return true;
        };
        SeriesData.prototype.indexOfName = function(name) {
            for(var i = 0, len = this._store.count(); i < len; i++){
                if (this.getName(i) === name) return i;
            }
            return -1;
        };
        SeriesData.prototype.getRawIndex = function(idx) {
            return this._store.getRawIndex(idx);
        };
        SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
            return this._store.indexOfRawIndex(rawIndex);
        };
        SeriesData.prototype.rawIndexOf = function(dim, value) {
            var invertedIndices = dim && this._invertedIndicesMap[dim];
            var rawIndex = invertedIndices[value];
            if (rawIndex == null || isNaN(rawIndex)) return $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
            return rawIndex;
        };
        SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
        };
        SeriesData.prototype.each = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.each(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store = this._store.filter(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return this;
        };
        SeriesData.prototype.selectRange = function(range) {
            'use strict';
            var _this = this;
            var innerRange = {};
            var dims = (0, parcelRequire("bahqM")).keys(range);
            var dimIndices = [];
            (0, parcelRequire("bahqM")).each(dims, function(dim) {
                var dimIdx = _this._getStoreDimIndex(dim);
                innerRange[dimIdx] = range[dim];
                dimIndices.push(dimIdx);
            });
            this._store = this._store.selectRange(innerRange);
            return this;
        };
        SeriesData.prototype.mapArray = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            ctx = ctx || this;
            var result = [];
            this.each(dims, function() {
                result.push(cb && cb.apply(this, arguments));
            }, ctx);
            return result;
        };
        SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
            'use strict';
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.map(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return list;
        };
        SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
            var _this = this;
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.modify(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
            return list;
        };
        SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
            return list;
        };
        SeriesData.prototype.getRawDataItem = function(idx) {
            return this._store.getRawDataItem(idx);
        };
        SeriesData.prototype.getItemModel = function(idx) {
            var hostModel = this.hostModel;
            var dataItem = this.getRawDataItem(idx);
            return new (0, (0, parcelRequire("gaMkj")).default)(dataItem, hostModel, hostModel && hostModel.ecModel);
        };
        SeriesData.prototype.diff = function(otherList) {
            var thisList = this;
            return new (0, (0, parcelRequire("4wWkb")).default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
                return $f818ba28c897a2f2$var$getId(otherList, idx);
            }, function(idx) {
                return $f818ba28c897a2f2$var$getId(thisList, idx);
            });
        };
        SeriesData.prototype.getVisual = function(key) {
            var visual = this._visual;
            return visual && visual[key];
        };
        SeriesData.prototype.setVisual = function(kvObj, val) {
            this._visual = this._visual || {};
            if ($f818ba28c897a2f2$var$isObject(kvObj)) (0, parcelRequire("bahqM")).extend(this._visual, kvObj);
            else this._visual[kvObj] = val;
        };
        SeriesData.prototype.getItemVisual = function(idx, key) {
            var itemVisual = this._itemVisuals[idx];
            var val = itemVisual && itemVisual[key];
            if (val == null) return this.getVisual(key);
            return val;
        };
        SeriesData.prototype.hasItemVisual = function() {
            return this._itemVisuals.length > 0;
        };
        SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
            var itemVisuals = this._itemVisuals;
            var itemVisual = itemVisuals[idx];
            if (!itemVisual) itemVisual = itemVisuals[idx] = {};
            var val = itemVisual[key];
            if (val == null) {
                val = this.getVisual(key);
                if ((0, parcelRequire("bahqM")).isArray(val)) val = val.slice();
                else if ($f818ba28c897a2f2$var$isObject(val)) val = (0, parcelRequire("bahqM")).extend({}, val);
                itemVisual[key] = val;
            }
            return val;
        };
        SeriesData.prototype.setItemVisual = function(idx, key, value) {
            var itemVisual = this._itemVisuals[idx] || {};
            this._itemVisuals[idx] = itemVisual;
            if ($f818ba28c897a2f2$var$isObject(key)) (0, parcelRequire("bahqM")).extend(itemVisual, key);
            else itemVisual[key] = value;
        };
        SeriesData.prototype.clearAllVisual = function() {
            this._visual = {};
            this._itemVisuals = [];
        };
        SeriesData.prototype.setLayout = function(key, val) {
            if ($f818ba28c897a2f2$var$isObject(key)) {
                for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
                return;
            }
            this._layout[key] = val;
        };
        SeriesData.prototype.getLayout = function(key) {
            return this._layout[key];
        };
        SeriesData.prototype.getItemLayout = function(idx) {
            return this._itemLayouts[idx];
        };
        SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
            this._itemLayouts[idx] = merge ? (0, parcelRequire("bahqM")).extend(this._itemLayouts[idx] || {}, layout) : layout;
        };
        SeriesData.prototype.clearItemLayouts = function() {
            this._itemLayouts.length = 0;
        };
        SeriesData.prototype.setItemGraphicEl = function(idx, el) {
            var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
            (0, (0, parcelRequire("7QjoM")).setCommonECData)(seriesIndex, this.dataType, idx, el);
            this._graphicEls[idx] = el;
        };
        SeriesData.prototype.getItemGraphicEl = function(idx) {
            return this._graphicEls[idx];
        };
        SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
            (0, parcelRequire("bahqM")).each(this._graphicEls, function(el, idx) {
                if (el) cb && cb.call(context, el, idx);
            });
        };
        SeriesData.prototype.cloneShallow = function(list) {
            if (!list) list = new SeriesData(this._schema ? this._schema : $f818ba28c897a2f2$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
            $f818ba28c897a2f2$var$transferProperties(list, this);
            list._store = this._store;
            return list;
        };
        SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
            var originalMethod = this[methodName];
            if (typeof originalMethod !== 'function') return;
            this.__wrappedMethods = this.__wrappedMethods || [];
            this.__wrappedMethods.push(methodName);
            this[methodName] = function() {
                var res = originalMethod.apply(this, arguments);
                return injectFunction.apply(this, [
                    res
                ].concat((0, parcelRequire("bahqM")).slice(arguments)));
            };
        };
        SeriesData.internalField = function() {
            $f818ba28c897a2f2$var$prepareInvertedIndex = function(data) {
                var invertedIndicesMap = data._invertedIndicesMap;
                (0, parcelRequire("bahqM")).each(invertedIndicesMap, function(invertedIndices, dim) {
                    var dimInfo = data._dimInfos[dim];
                    var ordinalMeta = dimInfo.ordinalMeta;
                    var store = data._store;
                    if (ordinalMeta) {
                        invertedIndices = invertedIndicesMap[dim] = new $f818ba28c897a2f2$var$CtorInt32Array(ordinalMeta.categories.length);
                        for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
                        for(var i = 0; i < store.count(); i++)invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                    }
                });
            };
            $f818ba28c897a2f2$var$getIdNameFromStore = function(data, dimIdx, idx) {
                return (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(data._getCategory(dimIdx, idx), null);
            };
            $f818ba28c897a2f2$var$getId = function(data, rawIndex) {
                var id = data._idList[rawIndex];
                if (id == null && data._idDimIdx != null) id = $f818ba28c897a2f2$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
                if (id == null) id = $f818ba28c897a2f2$var$ID_PREFIX + rawIndex;
                return id;
            };
            $f818ba28c897a2f2$var$normalizeDimensions = function(dimensions) {
                if (!(0, parcelRequire("bahqM")).isArray(dimensions)) dimensions = dimensions != null ? [
                    dimensions
                ] : [];
                return dimensions;
            };
            $f818ba28c897a2f2$var$cloneListForMapAndSample = function(original) {
                var list = new SeriesData(original._schema ? original._schema : $f818ba28c897a2f2$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
                $f818ba28c897a2f2$var$transferProperties(list, original);
                return list;
            };
            $f818ba28c897a2f2$var$transferProperties = function(target, source) {
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                    if (source.hasOwnProperty(propName)) target[propName] = source[propName];
                });
                target.__wrappedMethods = source.__wrappedMethods;
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$CLONE_PROPERTIES, function(propName) {
                    target[propName] = (0, parcelRequire("bahqM")).clone(source[propName]);
                });
                target._calculationInfo = (0, parcelRequire("bahqM")).extend({}, source._calculationInfo);
            };
            $f818ba28c897a2f2$var$makeIdFromName = function(data, idx) {
                var nameList = data._nameList;
                var idList = data._idList;
                var nameDimIdx = data._nameDimIdx;
                var idDimIdx = data._idDimIdx;
                var name = nameList[idx];
                var id = idList[idx];
                if (name == null && nameDimIdx != null) nameList[idx] = name = $f818ba28c897a2f2$var$getIdNameFromStore(data, nameDimIdx, idx);
                if (id == null && idDimIdx != null) idList[idx] = id = $f818ba28c897a2f2$var$getIdNameFromStore(data, idDimIdx, idx);
                if (id == null && name != null) {
                    var nameRepeatCount = data._nameRepeatCount;
                    var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                    id = name;
                    if (nmCnt > 1) id += '__ec__' + nmCnt;
                    idList[idx] = id;
                }
            };
        }();
        return SeriesData;
    }();
    var $f818ba28c897a2f2$export$2e2bcd8739ae039 = $f818ba28c897a2f2$var$SeriesData;
});
parcelRegister("gaMkj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc63113067804ddc$export$2e2bcd8739ae039);
    var $hZfwb;
    var $aLwh0;
    var $8P3Or;
    var $hyGik;
    var $46U6E;
    var $4rldO;
    var $bahqM;
    var $bc63113067804ddc$var$Model = function() {
        function Model(option, parentModel, ecModel) {
            this.parentModel = parentModel;
            this.ecModel = ecModel;
            this.option = option;
        }
        Model.prototype.init = function(option, parentModel, ecModel) {
            var rest = [];
            for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
        };
        Model.prototype.mergeOption = function(option, ecModel) {
            (0, (0, parcelRequire("bahqM")).merge)(this.option, option, true);
        };
        Model.prototype.get = function(path, ignoreParent) {
            if (path == null) return this.option;
            return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
        };
        Model.prototype.getShallow = function(key, ignoreParent) {
            var option = this.option;
            var val = option == null ? option : option[key];
            if (val == null && !ignoreParent) {
                var parentModel = this.parentModel;
                if (parentModel) val = parentModel.getShallow(key);
            }
            return val;
        };
        Model.prototype.getModel = function(path, parentModel) {
            var hasPath = path != null;
            var pathFinal = hasPath ? this.parsePath(path) : null;
            var obj = hasPath ? this._doGet(pathFinal) : this.option;
            parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
            return new Model(obj, parentModel, this.ecModel);
        };
        Model.prototype.isEmpty = function() {
            return this.option == null;
        };
        Model.prototype.restoreData = function() {};
        Model.prototype.clone = function() {
            var Ctor = this.constructor;
            return new Ctor((0, (0, parcelRequire("bahqM")).clone)(this.option));
        };
        Model.prototype.parsePath = function(path) {
            if (typeof path === 'string') return path.split('.');
            return path;
        };
        Model.prototype.resolveParentPath = function(path) {
            return path;
        };
        Model.prototype.isAnimationEnabled = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).node && this.option) {
                if (this.option.animation != null) return !!this.option.animation;
                else if (this.parentModel) return this.parentModel.isAnimationEnabled();
            }
        };
        Model.prototype._doGet = function(pathArr, parentModel) {
            var obj = this.option;
            if (!pathArr) return obj;
            for(var i = 0; i < pathArr.length; i++){
                if (!pathArr[i]) continue;
                obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
                if (obj == null) break;
            }
            if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
            return obj;
        };
        return Model;
    }();
    (0, (0, parcelRequire("aLwh0")).enableClassExtend)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("aLwh0")).enableClassCheck)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("46U6E")).LineStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("4rldO")).ItemStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("8P3Or")).AreaStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("hyGik")).default));
    var $bc63113067804ddc$export$2e2bcd8739ae039 = $bc63113067804ddc$var$Model;
});
parcelRegister("hZfwb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1842bbf4a5e2f15$export$2e2bcd8739ae039);
    var $d1842bbf4a5e2f15$var$Browser = function() {
        function Browser() {
            this.firefox = false;
            this.ie = false;
            this.edge = false;
            this.newEdge = false;
            this.weChat = false;
        }
        return Browser;
    }();
    var $d1842bbf4a5e2f15$var$Env = function() {
        function Env() {
            this.browser = new $d1842bbf4a5e2f15$var$Browser();
            this.node = false;
            this.wxa = false;
            this.worker = false;
            this.canvasSupported = false;
            this.svgSupported = false;
            this.touchEventsSupported = false;
            this.pointerEventsSupported = false;
            this.domSupported = false;
            this.transformSupported = false;
            this.transform3dSupported = false;
        }
        return Env;
    }();
    var $d1842bbf4a5e2f15$var$env = new $d1842bbf4a5e2f15$var$Env();
    if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
        $d1842bbf4a5e2f15$var$env.wxa = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.touchEventsSupported = true;
    } else if (typeof document === 'undefined' && typeof self !== 'undefined') {
        $d1842bbf4a5e2f15$var$env.worker = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    } else if (typeof navigator === 'undefined') {
        $d1842bbf4a5e2f15$var$env.node = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.svgSupported = true;
    } else $d1842bbf4a5e2f15$var$detect(navigator.userAgent, $d1842bbf4a5e2f15$var$env);
    function $d1842bbf4a5e2f15$var$detect(ua, env) {
        var browser = env.browser;
        var firefox = ua.match(/Firefox\/([\d.]+)/);
        var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
        var edge = ua.match(/Edge?\/([\d.]+)/);
        var weChat = /micromessenger/i.test(ua);
        if (firefox) {
            browser.firefox = true;
            browser.version = firefox[1];
        }
        if (ie) {
            browser.ie = true;
            browser.version = ie[1];
        }
        if (edge) {
            browser.edge = true;
            browser.version = edge[1];
            browser.newEdge = +edge[1].split('.')[0] > 18;
        }
        if (weChat) browser.weChat = true;
        env.canvasSupported = !!document.createElement('canvas').getContext;
        env.svgSupported = typeof SVGRect !== 'undefined';
        env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
        env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
        env.domSupported = typeof document !== 'undefined';
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
    var $d1842bbf4a5e2f15$export$2e2bcd8739ae039 = $d1842bbf4a5e2f15$var$env;
});
parcelRegister("aLwh0", function(module, exports) {
    $parcel$export(module.exports, "parseClassType", ()=>$7d6753f3a830ddbc$export$fbe18865d303bf01);
    $parcel$export(module.exports, "isExtendedClass", ()=>$7d6753f3a830ddbc$export$4f3b818f3dd2d182);
    $parcel$export(module.exports, "enableClassExtend", ()=>$7d6753f3a830ddbc$export$cd4c3a4dca301c70);
    $parcel$export(module.exports, "mountExtend", ()=>$7d6753f3a830ddbc$export$c9c2d87774f1275d);
    $parcel$export(module.exports, "enableClassCheck", ()=>$7d6753f3a830ddbc$export$e1aac4552ae82081);
    $parcel$export(module.exports, "enableClassManagement", ()=>$7d6753f3a830ddbc$export$241315e45585454d);
    var $3VFsf;
    var $bahqM;
    var $7d6753f3a830ddbc$var$TYPE_DELIMITER = '.';
    var $7d6753f3a830ddbc$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
    var $7d6753f3a830ddbc$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
    function $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType) {
        var ret = {
            main: '',
            sub: ''
        };
        if (componentType) {
            var typeArr = componentType.split($7d6753f3a830ddbc$var$TYPE_DELIMITER);
            ret.main = typeArr[0] || '';
            ret.sub = typeArr[1] || '';
        }
        return ret;
    }
    function $7d6753f3a830ddbc$var$checkClassType(componentType) {
        (0, parcelRequire("bahqM")).assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
    }
    function $7d6753f3a830ddbc$export$4f3b818f3dd2d182(clz) {
        return !!(clz && clz[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS]);
    }
    function $7d6753f3a830ddbc$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
        rootClz.$constructor = rootClz;
        rootClz.extend = function(proto) {
            var superClass = this;
            function ExtendedClass() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (!proto.$constructor) {
                    if (!$7d6753f3a830ddbc$var$isESClass(superClass)) superClass.apply(this, arguments);
                    else {
                        var ins = (0, parcelRequire("bahqM")).createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, (0, parcelRequire("3VFsf")).__spreadArray)([
                            void 0
                        ], args)))());
                        return ins;
                    }
                } else proto.$constructor.apply(this, arguments);
            }
            ExtendedClass[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS] = true;
            (0, parcelRequire("bahqM")).extend(ExtendedClass.prototype, proto);
            ExtendedClass.extend = this.extend;
            ExtendedClass.superCall = $7d6753f3a830ddbc$var$superCall;
            ExtendedClass.superApply = $7d6753f3a830ddbc$var$superApply;
            (0, parcelRequire("bahqM")).inherits(ExtendedClass, this);
            ExtendedClass.superClass = superClass;
            return ExtendedClass;
        };
    }
    function $7d6753f3a830ddbc$var$isESClass(fn) {
        return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
    }
    function $7d6753f3a830ddbc$export$c9c2d87774f1275d(SubClz, SupperClz) {
        SubClz.extend = SupperClz.extend;
    }
    var $7d6753f3a830ddbc$var$classBase = Math.round(Math.random() * 10);
    function $7d6753f3a830ddbc$export$e1aac4552ae82081(target) {
        var classAttr = [
            '__\0is_clz',
            $7d6753f3a830ddbc$var$classBase++
        ].join('_');
        target.prototype[classAttr] = true;
        target.isInstance = function(obj) {
            return !!(obj && obj[classAttr]);
        };
    }
    function $7d6753f3a830ddbc$var$superCall(context, methodName) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$var$superApply(context, methodName, args) {
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$export$241315e45585454d(target) {
        var storage = {};
        target.registerClass = function(clz) {
            var componentFullType = clz.type || clz.prototype.type;
            if (componentFullType) {
                $7d6753f3a830ddbc$var$checkClassType(componentFullType);
                clz.prototype.type = componentFullType;
                var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentFullType);
                if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
                else if (componentTypeInfo.sub !== $7d6753f3a830ddbc$var$IS_CONTAINER) {
                    var container = makeContainer(componentTypeInfo);
                    container[componentTypeInfo.sub] = clz;
                }
            }
            return clz;
        };
        target.getClass = function(mainType, subType, throwWhenNotFound) {
            var clz = storage[mainType];
            if (clz && clz[$7d6753f3a830ddbc$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
            if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
            return clz;
        };
        target.getClassesByMainType = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var result = [];
            var obj = storage[componentTypeInfo.main];
            if (obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER]) (0, parcelRequire("bahqM")).each(obj, function(o, type) {
                type !== $7d6753f3a830ddbc$var$IS_CONTAINER && result.push(o);
            });
            else result.push(obj);
            return result;
        };
        target.hasClass = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            return !!storage[componentTypeInfo.main];
        };
        target.getAllClassMainTypes = function() {
            var types = [];
            (0, parcelRequire("bahqM")).each(storage, function(obj, type) {
                types.push(type);
            });
            return types;
        };
        target.hasSubTypes = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var obj = storage[componentTypeInfo.main];
            return obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER];
        };
        function makeContainer(componentTypeInfo) {
            var container = storage[componentTypeInfo.main];
            if (!container || !container[$7d6753f3a830ddbc$var$IS_CONTAINER]) {
                container = storage[componentTypeInfo.main] = {};
                container[$7d6753f3a830ddbc$var$IS_CONTAINER] = true;
            }
            return container;
        }
    }
});
parcelRegister("8P3Or", function(module, exports) {
    $parcel$export(module.exports, "AreaStyleMixin", ()=>$66c60b4522f41760$export$a3a0ed7e2dd84c9e);
    var $1BJbl;
    var $66c60b4522f41760$export$52de6e304d934d85 = [
        [
            'fill',
            'color'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'opacity'
        ],
        [
            'shadowColor'
        ]
    ];
    var $66c60b4522f41760$var$getAreaStyle = (0, (0, parcelRequire("1BJbl")).default)($66c60b4522f41760$export$52de6e304d934d85);
    var $66c60b4522f41760$export$a3a0ed7e2dd84c9e = function() {
        function AreaStyleMixin() {}
        AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
            return $66c60b4522f41760$var$getAreaStyle(this, excludes, includes);
        };
        return AreaStyleMixin;
    }();
});
parcelRegister("1BJbl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12bc4b5222290b4b$export$2e2bcd8739ae039);
    var $bahqM;
    function $12bc4b5222290b4b$export$2e2bcd8739ae039(properties, ignoreParent) {
        for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
        ignoreParent = ignoreParent || false;
        return function(model, excludes, includes) {
            var style = {};
            for(var i = 0; i < properties.length; i++){
                var propName = properties[i][1];
                if (excludes && (0, parcelRequire("bahqM")).indexOf(excludes, propName) >= 0 || includes && (0, parcelRequire("bahqM")).indexOf(includes, propName) < 0) continue;
                var val = model.getShallow(propName, ignoreParent);
                if (val != null) style[properties[i][0]] = val;
            }
            return style;
        };
    }
});
parcelRegister("hyGik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc866b770f3f8e08$export$2e2bcd8739ae039);
    var $gvLUt;
    var $4gEFv;
    var $cc866b770f3f8e08$var$PATH_COLOR = [
        'textStyle',
        'color'
    ];
    var $cc866b770f3f8e08$var$tmpRichText = new (0, (0, parcelRequire("4gEFv")).default)();
    var $cc866b770f3f8e08$var$TextStyleMixin = function() {
        function TextStyleMixin() {}
        TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
            var ecModel = this.ecModel;
            return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($cc866b770f3f8e08$var$PATH_COLOR) : null);
        };
        TextStyleMixin.prototype.getFont = function() {
            return (0, (0, parcelRequire("gvLUt")).getFont)({
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily')
            }, this.ecModel);
        };
        TextStyleMixin.prototype.getTextRect = function(text) {
            $cc866b770f3f8e08$var$tmpRichText.useStyle({
                text: text,
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily'),
                verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
                padding: this.getShallow('padding'),
                lineHeight: this.getShallow('lineHeight'),
                rich: this.getShallow('rich')
            });
            $cc866b770f3f8e08$var$tmpRichText.update();
            return $cc866b770f3f8e08$var$tmpRichText.getBoundingRect();
        };
        return TextStyleMixin;
    }();
    var $cc866b770f3f8e08$export$2e2bcd8739ae039 = $cc866b770f3f8e08$var$TextStyleMixin;
});
parcelRegister("gvLUt", function(module, exports) {
    $parcel$export(module.exports, "setLabelStyle", ()=>$c054b479467e8395$export$9a13992917966657);
    $parcel$export(module.exports, "createTextStyle", ()=>$c054b479467e8395$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "createTextConfig", ()=>$c054b479467e8395$export$e149afab8df6e053);
    $parcel$export(module.exports, "labelInner", ()=>$c054b479467e8395$export$f62786d3261ab0f4);
    $parcel$export(module.exports, "getLabelStatesModels", ()=>$c054b479467e8395$export$9739a32674be5893);
    $parcel$export(module.exports, "getFont", ()=>$c054b479467e8395$export$155316a870a9d61e);
    $parcel$export(module.exports, "setLabelValueAnimation", ()=>$c054b479467e8395$export$7bdbceaf9ab378f2);
    $parcel$export(module.exports, "animateLabelValue", ()=>$c054b479467e8395$export$dd6101605f5c186);
    var $4gEFv;
    var $bahqM;
    var $fIXXx;
    var $eaKsF;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $c054b479467e8395$var$EMPTY_OBJ = {};
    function $c054b479467e8395$export$b533918394a58529(label, labelTexts) {
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var text = labelTexts[stateName];
            var state = label.ensureState(stateName);
            state.style = state.style || {};
            state.style.text = text;
        }
        var oldStates = label.currentStates.slice();
        label.clearStates(true);
        label.setStyle({
            text: labelTexts.normal
        });
        label.useStates(oldStates, true);
    }
    function $c054b479467e8395$var$getLabelText(opt, stateModels, interpolatedValue) {
        var labelFetcher = opt.labelFetcher;
        var labelDataIndex = opt.labelDataIndex;
        var labelDimIndex = opt.labelDimIndex;
        var normalModel = stateModels.normal;
        var baseText;
        if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
            interpolatedValue: interpolatedValue
        } : null);
        if (baseText == null) baseText = (0, (0, parcelRequire("bahqM")).isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
        var statesText = {
            normal: baseText
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var stateModel = stateModels[stateName];
            statesText[stateName] = (0, (0, parcelRequire("bahqM")).retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
        }
        return statesText;
    }
    function $c054b479467e8395$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var isSetOnText = targetEl instanceof (0, (0, parcelRequire("4gEFv")).default);
        var needsCreateText = false;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateModel = labelStatesModels[(0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i]];
            if (stateModel && stateModel.getShallow('show')) {
                needsCreateText = true;
                break;
            }
        }
        var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
        if (needsCreateText) {
            if (!isSetOnText) {
                if (!textContent) {
                    textContent = new (0, (0, parcelRequire("4gEFv")).default)();
                    targetEl.setTextContent(textContent);
                }
                if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
            }
            var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels);
            var normalModel = labelStatesModels.normal;
            var showNormal = !!normalModel.getShallow('show');
            var normalStyle = $c054b479467e8395$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
            normalStyle.text = labelStatesTexts.normal;
            if (!isSetOnText) targetEl.setTextConfig($c054b479467e8395$export$e149afab8df6e053(normalModel, opt, false));
            for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
                var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
                var stateModel = labelStatesModels[stateName];
                if (stateModel) {
                    var stateObj = textContent.ensureState(stateName);
                    var stateShow = !!(0, (0, parcelRequire("bahqM")).retrieve2)(stateModel.getShallow('show'), showNormal);
                    if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                    stateObj.style = $c054b479467e8395$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                    stateObj.style.text = labelStatesTexts[stateName];
                    if (!isSetOnText) {
                        var targetElEmphasisState = targetEl.ensureState(stateName);
                        targetElEmphasisState.textConfig = $c054b479467e8395$export$e149afab8df6e053(stateModel, opt, true);
                    }
                }
            }
            textContent.silent = !!normalModel.getShallow('silent');
            if (textContent.style.x != null) normalStyle.x = textContent.style.x;
            if (textContent.style.y != null) normalStyle.y = textContent.style.y;
            textContent.ignore = !showNormal;
            textContent.useStyle(normalStyle);
            textContent.dirty();
            if (opt.enableTextSetter) $c054b479467e8395$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
                var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels, interpolatedValue);
                $c054b479467e8395$export$b533918394a58529(textContent, labelStatesTexts);
            };
        } else if (textContent) textContent.ignore = true;
        targetEl.dirty();
    }
    function $c054b479467e8395$export$9739a32674be5893(itemModel, labelName) {
        labelName = labelName || 'label';
        var statesModels = {
            normal: itemModel.getModel(labelName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelName
            ]);
        }
        return statesModels;
    }
    function $c054b479467e8395$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached) {
        var textStyle = {};
        $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
        specifiedTextStyle && (0, (0, parcelRequire("bahqM")).extend)(textStyle, specifiedTextStyle);
        return textStyle;
    }
    function $c054b479467e8395$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
        opt = opt || {};
        var textConfig = {};
        var labelPosition;
        var labelRotate = textStyleModel.getShallow('rotate');
        var labelDistance = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
        var labelOffset = textStyleModel.getShallow('offset');
        labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
        labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
        if (labelPosition != null) textConfig.position = labelPosition;
        if (labelOffset != null) textConfig.offset = labelOffset;
        if (labelRotate != null) {
            labelRotate *= Math.PI / 180;
            textConfig.rotation = labelRotate;
        }
        if (labelDistance != null) textConfig.distance = labelDistance;
        textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
        return textConfig;
    }
    function $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var ecModel = textStyleModel.ecModel;
        var globalTextStyle = ecModel && ecModel.option.textStyle;
        var richItemNames = $c054b479467e8395$var$getRichItemNames(textStyleModel);
        var richResult;
        if (richItemNames) {
            richResult = {};
            for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
                var richTextStyle = textStyleModel.getModel([
                    'rich',
                    name_1
                ]);
                $c054b479467e8395$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
            }
        }
        if (richResult) textStyle.rich = richResult;
        var overflow = textStyleModel.get('overflow');
        if (overflow) textStyle.overflow = overflow;
        var margin = textStyleModel.get('minMargin');
        if (margin != null) textStyle.margin = margin;
        $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
    }
    function $c054b479467e8395$var$getRichItemNames(textStyleModel) {
        var richItemNameMap;
        while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
            var rich = (textStyleModel.option || $c054b479467e8395$var$EMPTY_OBJ).rich;
            if (rich) {
                richItemNameMap = richItemNameMap || {};
                var richKeys = (0, (0, parcelRequire("bahqM")).keys)(rich);
                for(var i = 0; i < richKeys.length; i++){
                    var richKey = richKeys[i];
                    richItemNameMap[richKey] = 1;
                }
            }
            textStyleModel = textStyleModel.parentModel;
        }
        return richItemNameMap;
    }
    var $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_SELF = [
        'align',
        'lineHeight',
        'width',
        'height',
        'tag',
        'verticalAlign'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_BOX = [
        'padding',
        'borderWidth',
        'borderRadius',
        'borderDashOffset',
        'backgroundColor',
        'borderColor',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    function $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
        globalTextStyle = !isNotNormal && globalTextStyle || $c054b479467e8395$var$EMPTY_OBJ;
        var inheritColor = opt && opt.inheritColor;
        var fillColor = textStyleModel.getShallow('color');
        var strokeColor = textStyleModel.getShallow('textBorderColor');
        var opacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
        if (fillColor === 'inherit' || fillColor === 'auto') {
            if (inheritColor) fillColor = inheritColor;
            else fillColor = null;
        }
        if (strokeColor === 'inherit' || strokeColor === 'auto') {
            if (inheritColor) strokeColor = inheritColor;
            else strokeColor = null;
        }
        if (!isAttached) {
            fillColor = fillColor || globalTextStyle.color;
            strokeColor = strokeColor || globalTextStyle.textBorderColor;
        }
        if (fillColor != null) textStyle.fill = fillColor;
        if (strokeColor != null) textStyle.stroke = strokeColor;
        var textBorderWidth = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
        if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
        var textBorderType = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
        if (textBorderType != null) textStyle.lineDash = textBorderType;
        var textBorderDashOffset = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
        if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
        if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
        if (opacity != null) textStyle.opacity = opacity;
        if (!isNotNormal && !isAttached) {
            if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL[i];
            var val = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
            if (val != null) textStyle[key] = val;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_SELF.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_SELF[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        if (textStyle.verticalAlign == null) {
            var baseline = textStyleModel.getShallow('baseline');
            if (baseline != null) textStyle.verticalAlign = baseline;
        }
        if (!isBlock || !opt.disableBox) {
            for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_BOX.length; i++){
                var key = $c054b479467e8395$var$TEXT_PROPS_BOX[i];
                var val = textStyleModel.getShallow(key);
                if (val != null) textStyle[key] = val;
            }
            var borderType = textStyleModel.getShallow('borderType');
            if (borderType != null) textStyle.borderDash = borderType;
            if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
            if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
        }
    }
    function $c054b479467e8395$export$155316a870a9d61e(opt, ecModel) {
        var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
        return (0, (0, parcelRequire("bahqM")).trim)([
            opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
            opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
            (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
            opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
        ].join(' '));
    }
    var $c054b479467e8395$export$f62786d3261ab0f4 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $c054b479467e8395$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
        if (!label) return;
        var obj = $c054b479467e8395$export$f62786d3261ab0f4(label);
        obj.prevValue = obj.value;
        obj.value = value;
        var normalLabelModel = labelStatesModels.normal;
        obj.valueAnimation = normalLabelModel.get('valueAnimation');
        if (obj.valueAnimation) {
            obj.precision = normalLabelModel.get('precision');
            obj.defaultInterpolatedText = getDefaultText;
            obj.statesModels = labelStatesModels;
        }
    }
    function $c054b479467e8395$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
        var labelInnerStore = $c054b479467e8395$export$f62786d3261ab0f4(textEl);
        if (!labelInnerStore.valueAnimation) return;
        var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
        var currValue = (0, (0, parcelRequire("bahqM")).retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
        var targetValue = labelInnerStore.value;
        function during(percent) {
            var interpolated = (0, (0, parcelRequire("eaKsF")).interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
            labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
            var labelText = $c054b479467e8395$var$getLabelText({
                labelDataIndex: dataIndex,
                labelFetcher: labelFetcher,
                defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
            }, labelInnerStore.statesModels, interpolated);
            $c054b479467e8395$export$b533918394a58529(textEl, labelText);
        }
        (labelInnerStore.prevValue == null ? (0, (0, parcelRequire("eYgMC")).initProps) : (0, (0, parcelRequire("eYgMC")).updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
    }
});
parcelRegister("4gEFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b833f429060f54$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h6fMM;
    var $45jlh;
    var $bahqM;
    var $b7ZX8;
    var $gcbBH;
    var $7Tw7u;
    var $1E3E8;
    var $lBQ88;
    var $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR = {
        fill: '#000'
    };
    var $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH = 2;
    var $31b833f429060f54$export$21aaaa0607ee0e2b = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineWidth: true,
            fontSize: true,
            lineHeight: true,
            width: true,
            height: true,
            textShadowColor: true,
            textShadowBlur: true,
            textShadowOffsetX: true,
            textShadowOffsetY: true,
            backgroundColor: true,
            padding: true,
            borderColor: true,
            borderWidth: true,
            borderRadius: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $31b833f429060f54$var$ZRText = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRText, _super);
        function ZRText(opts) {
            var _this = _super.call(this) || this;
            _this.type = 'text';
            _this._children = [];
            _this._defaultStyle = $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
            _this.attr(opts);
            return _this;
        }
        ZRText.prototype.childrenRef = function() {
            return this._children;
        };
        ZRText.prototype.update = function() {
            _super.prototype.update.call(this);
            if (this.styleChanged()) this._updateSubTexts();
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.zlevel = this.zlevel;
                child.z = this.z;
                child.z2 = this.z2;
                child.culling = this.culling;
                child.cursor = this.cursor;
                child.invisible = this.invisible;
            }
        };
        ZRText.prototype.updateTransform = function() {
            var innerTransformable = this.innerTransformable;
            if (innerTransformable) {
                innerTransformable.updateTransform();
                if (innerTransformable.transform) this.transform = innerTransformable.transform;
            } else _super.prototype.updateTransform.call(this);
        };
        ZRText.prototype.getLocalTransform = function(m) {
            var innerTransformable = this.innerTransformable;
            return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
        };
        ZRText.prototype.getComputedTransform = function() {
            if (this.__hostTarget) {
                this.__hostTarget.getComputedTransform();
                this.__hostTarget.updateInnerText(true);
            }
            return _super.prototype.getComputedTransform.call(this);
        };
        ZRText.prototype._updateSubTexts = function() {
            this._childCursor = 0;
            $31b833f429060f54$export$176336068cc5371f(this.style);
            this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
            this._children.length = this._childCursor;
            this.styleUpdated();
        };
        ZRText.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
        };
        ZRText.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
        };
        ZRText.prototype.getBoundingRect = function() {
            if (this.styleChanged()) this._updateSubTexts();
            if (!this._rect) {
                var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                var children = this._children;
                var tmpMat = [];
                var rect = null;
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    var childRect = child.getBoundingRect();
                    var transform = child.getLocalTransform(tmpMat);
                    if (transform) {
                        tmpRect.copy(childRect);
                        tmpRect.applyTransform(transform);
                        rect = rect || tmpRect.clone();
                        rect.union(tmpRect);
                    } else {
                        rect = rect || childRect.clone();
                        rect.union(childRect);
                    }
                }
                this._rect = rect || tmpRect;
            }
            return this._rect;
        };
        ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
            this._defaultStyle = defaultTextStyle || $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
        };
        ZRText.prototype.setTextContent = function(textContent) {
            throw new Error('Can\'t attach text on another text');
        };
        ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            if (!sourceStyle) return targetStyle;
            var sourceRich = sourceStyle.rich;
            var targetRich = targetStyle.rich || sourceRich && {};
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            if (sourceRich && targetRich) {
                this._mergeRich(targetRich, sourceRich);
                targetStyle.rich = targetRich;
            } else if (targetRich) targetStyle.rich = targetRich;
            return targetStyle;
        };
        ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
            var richNames = (0, (0, parcelRequire("bahqM")).keys)(sourceRich);
            for(var i = 0; i < richNames.length; i++){
                var richName = richNames[i];
                targetRich[richName] = targetRich[richName] || {};
                (0, (0, parcelRequire("bahqM")).extend)(targetRich[richName], sourceRich[richName]);
            }
        };
        ZRText.prototype.getAnimationStyleProps = function() {
            return $31b833f429060f54$export$21aaaa0607ee0e2b;
        };
        ZRText.prototype._getOrCreateChild = function(Ctor) {
            var child = this._children[this._childCursor];
            if (!child || !(child instanceof Ctor)) child = new Ctor();
            this._children[this._childCursor++] = child;
            child.__zr = this.__zr;
            child.parent = this;
            return child;
        };
        ZRText.prototype._updatePlainTexts = function() {
            var style = this.style;
            var textFont = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            var textPadding = style.padding;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parsePlainText)(text, style);
            var needDrawBg = $31b833f429060f54$var$needDrawBackground(style);
            var bgColorDrawn = !!style.backgroundColor;
            var outerHeight = contentBlock.outerHeight;
            var textLines = contentBlock.lines;
            var lineHeight = contentBlock.lineHeight;
            var defaultStyle = this._defaultStyle;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var textAlign = style.align || defaultStyle.align || 'left';
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
            var textX = baseX;
            var textY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
            if (needDrawBg || textPadding) {
                var outerWidth_1 = contentBlock.width;
                textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
                var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth_1, textAlign);
                var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
                needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
            }
            textY += lineHeight / 2;
            if (textPadding) {
                textX = $31b833f429060f54$var$getTextXForPadding(baseX, textAlign, textPadding);
                if (verticalAlign === 'top') textY += textPadding[0];
                else if (verticalAlign === 'bottom') textY -= textPadding[2];
            }
            var defaultLineWidth = 0;
            var useDefaultFill = false;
            var textFill = $31b833f429060f54$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = style.textShadowBlur > 0;
            var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
            var calculatedLineHeight = contentBlock.calculatedLineHeight;
            for(var i = 0; i < textLines.length; i++){
                var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
                var subElStyle = el.createStyle();
                el.useStyle(subElStyle);
                subElStyle.text = textLines[i];
                subElStyle.x = textX;
                subElStyle.y = textY;
                if (textAlign) subElStyle.textAlign = textAlign;
                subElStyle.textBaseline = 'middle';
                subElStyle.opacity = style.opacity;
                subElStyle.strokeFirst = true;
                if (hasShadow) {
                    subElStyle.shadowBlur = style.textShadowBlur || 0;
                    subElStyle.shadowColor = style.textShadowColor || 'transparent';
                    subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                    subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
                }
                if (textStroke) {
                    subElStyle.stroke = textStroke;
                    subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                    subElStyle.lineDash = style.lineDash;
                    subElStyle.lineDashOffset = style.lineDashOffset || 0;
                }
                if (textFill) subElStyle.fill = textFill;
                subElStyle.font = textFont;
                textY += lineHeight;
                if (fixedBoundingRect) el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
            }
        };
        ZRText.prototype._updateRichTexts = function() {
            var style = this.style;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parseRichText)(text, style);
            var contentWidth = contentBlock.width;
            var outerWidth = contentBlock.outerWidth;
            var outerHeight = contentBlock.outerHeight;
            var textPadding = style.padding;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var defaultStyle = this._defaultStyle;
            var textAlign = style.align || defaultStyle.align;
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
            var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth, textAlign);
            var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
            var xLeft = boxX;
            var lineTop = boxY;
            if (textPadding) {
                xLeft += textPadding[3];
                lineTop += textPadding[0];
            }
            var xRight = xLeft + contentWidth;
            if ($31b833f429060f54$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
            var bgColorDrawn = !!style.backgroundColor;
            for(var i = 0; i < contentBlock.lines.length; i++){
                var line = contentBlock.lines[i];
                var tokens = line.tokens;
                var tokenCount = tokens.length;
                var lineHeight = line.lineHeight;
                var remainedWidth = line.width;
                var leftIndex = 0;
                var lineXLeft = xLeft;
                var lineXRight = xRight;
                var rightIndex = tokenCount - 1;
                var token = void 0;
                while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXLeft += token.width;
                    leftIndex++;
                }
                while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXRight -= token.width;
                    rightIndex--;
                }
                lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
                while(leftIndex <= rightIndex){
                    token = tokens[leftIndex];
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                    lineXLeft += token.width;
                    leftIndex++;
                }
                lineTop += lineHeight;
            }
        };
        ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
            var tokenStyle = style.rich[token.styleName] || {};
            tokenStyle.text = token.text;
            var verticalAlign = token.verticalAlign;
            var y = lineTop + lineHeight / 2;
            if (verticalAlign === 'top') y = lineTop + token.height / 2;
            else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
            var needDrawBg = !token.isLineHolder && $31b833f429060f54$var$needDrawBackground(tokenStyle);
            needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
            var bgColorDrawn = !!tokenStyle.backgroundColor;
            var textPadding = token.textPadding;
            if (textPadding) {
                x = $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding);
                y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
            }
            var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            var defaultStyle = this._defaultStyle;
            var useDefaultFill = false;
            var defaultLineWidth = 0;
            var textFill = $31b833f429060f54$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
            subElStyle.text = token.text;
            subElStyle.x = x;
            subElStyle.y = y;
            if (hasShadow) {
                subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
                subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
            }
            subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.font = token.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            subElStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.opacity, style.opacity, 1);
            if (textStroke) {
                subElStyle.lineWidth = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
                subElStyle.lineDash = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.lineDash, style.lineDash);
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
                subElStyle.stroke = textStroke;
            }
            if (textFill) subElStyle.fill = textFill;
            var textWidth = token.contentWidth;
            var textHeight = token.contentHeight;
            el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
        };
        ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
            var textBackgroundColor = style.backgroundColor;
            var textBorderWidth = style.borderWidth;
            var textBorderColor = style.borderColor;
            var isImageBg = textBackgroundColor && textBackgroundColor.image;
            var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
            var textBorderRadius = style.borderRadius;
            var self = this;
            var rectEl;
            var imgEl;
            if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
                rectEl = this._getOrCreateChild((0, (0, parcelRequire("7Tw7u")).default));
                rectEl.useStyle(rectEl.createStyle());
                rectEl.style.fill = null;
                var rectShape = rectEl.shape;
                rectShape.x = x;
                rectShape.y = y;
                rectShape.width = width;
                rectShape.height = height;
                rectShape.r = textBorderRadius;
                rectEl.dirtyShape();
            }
            if (isPlainOrGradientBg) {
                var rectStyle = rectEl.style;
                rectStyle.fill = textBackgroundColor || null;
                rectStyle.fillOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.fillOpacity, 1);
            } else if (isImageBg) {
                imgEl = this._getOrCreateChild((0, (0, parcelRequire("gcbBH")).default));
                imgEl.onload = function() {
                    self.dirtyStyle();
                };
                var imgStyle = imgEl.style;
                imgStyle.image = textBackgroundColor.image;
                imgStyle.x = x;
                imgStyle.y = y;
                imgStyle.width = width;
                imgStyle.height = height;
            }
            if (textBorderWidth && textBorderColor) {
                var rectStyle = rectEl.style;
                rectStyle.lineWidth = textBorderWidth;
                rectStyle.stroke = textBorderColor;
                rectStyle.strokeOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.strokeOpacity, 1);
                rectStyle.lineDash = style.borderDash;
                rectStyle.lineDashOffset = style.borderDashOffset || 0;
                rectEl.strokeContainThreshold = 0;
                if (rectEl.hasFill() && rectEl.hasStroke()) {
                    rectStyle.strokeFirst = true;
                    rectStyle.lineWidth *= 2;
                }
            }
            var commonStyle = (rectEl || imgEl).style;
            commonStyle.shadowBlur = style.shadowBlur || 0;
            commonStyle.shadowColor = style.shadowColor || 'transparent';
            commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
            commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
            commonStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(style.opacity, topStyle.opacity, 1);
        };
        ZRText.makeFont = function(style) {
            var font = '';
            if (style.fontSize || style.fontFamily || style.fontWeight) {
                var fontSize = '';
                if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
                else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
                else fontSize = '12px';
                font = [
                    style.fontStyle,
                    style.fontWeight,
                    fontSize,
                    style.fontFamily || 'sans-serif'
                ].join(' ');
            }
            return font && (0, (0, parcelRequire("bahqM")).trim)(font) || style.textFont || style.font;
        };
        return ZRText;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $31b833f429060f54$var$VALID_TEXT_ALIGN = {
        left: true,
        right: 1,
        center: 1
    };
    var $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN = {
        top: 1,
        bottom: 1,
        middle: 1
    };
    function $31b833f429060f54$export$176336068cc5371f(style) {
        $31b833f429060f54$var$normalizeStyle(style);
        (0, (0, parcelRequire("bahqM")).each)(style.rich, $31b833f429060f54$var$normalizeStyle);
        return style;
    }
    function $31b833f429060f54$var$normalizeStyle(style) {
        if (style) {
            style.font = $31b833f429060f54$var$ZRText.makeFont(style);
            var textAlign = style.align;
            textAlign === 'middle' && (textAlign = 'center');
            style.align = textAlign == null || $31b833f429060f54$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
            var verticalAlign = style.verticalAlign;
            verticalAlign === 'center' && (verticalAlign = 'middle');
            style.verticalAlign = verticalAlign == null || $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
            var textPadding = style.padding;
            if (textPadding) style.padding = (0, (0, parcelRequire("bahqM")).normalizeCssArray)(style.padding);
        }
    }
    function $31b833f429060f54$var$getStroke(stroke, lineWidth) {
        return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
    }
    function $31b833f429060f54$var$getFill(fill) {
        return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
    }
    function $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding) {
        return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
    }
    function $31b833f429060f54$var$getStyleText(style) {
        var text = style.text;
        text != null && (text += '');
        return text;
    }
    function $31b833f429060f54$var$needDrawBackground(style) {
        return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
    }
    var $31b833f429060f54$export$2e2bcd8739ae039 = $31b833f429060f54$var$ZRText;
});
parcelRegister("h6fMM", function(module, exports) {
    $parcel$export(module.exports, "truncateText", ()=>$c72f3dec0993863b$export$59a943b34a82e690);
    $parcel$export(module.exports, "parsePlainText", ()=>$c72f3dec0993863b$export$5772575e34ef80f9);
    $parcel$export(module.exports, "parseRichText", ()=>$c72f3dec0993863b$export$15ec9472ff2d721);
    var $63nvx;
    var $bahqM;
    var $b7ZX8;
    var $c72f3dec0993863b$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
    function $c72f3dec0993863b$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
        if (!containerWidth) return '';
        var textLines = (text + '').split('\n');
        options = $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
        for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c72f3dec0993863b$var$truncateSingleLine(textLines[i], options);
        return textLines.join('\n');
    }
    function $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
        options = options || {};
        var preparedOpts = (0, (0, parcelRequire("bahqM")).extend)({}, options);
        preparedOpts.font = font;
        ellipsis = (0, (0, parcelRequire("bahqM")).retrieve2)(ellipsis, '...');
        preparedOpts.maxIterations = (0, (0, parcelRequire("bahqM")).retrieve2)(options.maxIterations, 2);
        var minChar = preparedOpts.minChar = (0, (0, parcelRequire("bahqM")).retrieve2)(options.minChar, 0);
        preparedOpts.cnCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)("\u56FD", font);
        var ascCharWidth = preparedOpts.ascCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)('a', font);
        preparedOpts.placeholder = (0, (0, parcelRequire("bahqM")).retrieve2)(options.placeholder, '');
        var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
        for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
        var ellipsisWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ellipsis, font);
        if (ellipsisWidth > contentWidth) {
            ellipsis = '';
            ellipsisWidth = 0;
        }
        contentWidth = containerWidth - ellipsisWidth;
        preparedOpts.ellipsis = ellipsis;
        preparedOpts.ellipsisWidth = ellipsisWidth;
        preparedOpts.contentWidth = contentWidth;
        preparedOpts.containerWidth = containerWidth;
        return preparedOpts;
    }
    function $c72f3dec0993863b$var$truncateSingleLine(textLine, options) {
        var containerWidth = options.containerWidth;
        var font = options.font;
        var contentWidth = options.contentWidth;
        if (!containerWidth) return '';
        var lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        if (lineWidth <= containerWidth) return textLine;
        for(var j = 0;; j++){
            if (lineWidth <= contentWidth || j >= options.maxIterations) {
                textLine += options.ellipsis;
                break;
            }
            var subLength = j === 0 ? $c72f3dec0993863b$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
            textLine = textLine.substr(0, subLength);
            lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        }
        if (textLine === '') textLine = options.placeholder;
        return textLine;
    }
    function $c72f3dec0993863b$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
        var width = 0;
        var i = 0;
        for(var len = text.length; i < len && width < contentWidth; i++){
            var charCode = text.charCodeAt(i);
            width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
        }
        return i;
    }
    function $c72f3dec0993863b$export$5772575e34ef80f9(text, style) {
        text != null && (text += '');
        var overflow = style.overflow;
        var padding = style.padding;
        var font = style.font;
        var truncate = overflow === 'truncate';
        var calculatedLineHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
        var lineHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(style.lineHeight, calculatedLineHeight);
        var truncateLineOverflow = style.lineOverflow === 'truncate';
        var width = style.width;
        var lines;
        if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c72f3dec0993863b$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
        else lines = text ? text.split('\n') : [];
        var contentHeight = lines.length * lineHeight;
        var height = (0, (0, parcelRequire("bahqM")).retrieve2)(style.height, contentHeight);
        if (contentHeight > height && truncateLineOverflow) {
            var lineCount = Math.floor(height / lineHeight);
            lines = lines.slice(0, lineCount);
        }
        var outerHeight = height;
        var outerWidth = width;
        if (padding) {
            outerHeight += padding[0] + padding[2];
            if (outerWidth != null) outerWidth += padding[1] + padding[3];
        }
        if (text && truncate && outerWidth != null) {
            var options = $c72f3dec0993863b$var$prepareTruncateOptions(width, font, style.ellipsis, {
                minChar: style.truncateMinChar,
                placeholder: style.placeholder
            });
            for(var i = 0; i < lines.length; i++)lines[i] = $c72f3dec0993863b$var$truncateSingleLine(lines[i], options);
        }
        if (width == null) {
            var maxWidth = 0;
            for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, (0, parcelRequire("b7ZX8")).getWidth)(lines[i], font), maxWidth);
            width = maxWidth;
        }
        return {
            lines: lines,
            height: height,
            outerHeight: outerHeight,
            lineHeight: lineHeight,
            calculatedLineHeight: calculatedLineHeight,
            contentHeight: contentHeight,
            width: width
        };
    }
    var $c72f3dec0993863b$var$RichTextToken = function() {
        function RichTextToken() {}
        return RichTextToken;
    }();
    var $c72f3dec0993863b$var$RichTextLine = function() {
        function RichTextLine(tokens) {
            this.tokens = [];
            if (tokens) this.tokens = tokens;
        }
        return RichTextLine;
    }();
    var $c72f3dec0993863b$export$ca607d3c98caaf7e = function() {
        function RichTextContentBlock() {
            this.width = 0;
            this.height = 0;
            this.contentWidth = 0;
            this.contentHeight = 0;
            this.outerWidth = 0;
            this.outerHeight = 0;
            this.lines = [];
        }
        return RichTextContentBlock;
    }();
    function $c72f3dec0993863b$export$15ec9472ff2d721(text, style) {
        var contentBlock = new $c72f3dec0993863b$export$ca607d3c98caaf7e();
        text != null && (text += '');
        if (!text) return contentBlock;
        var topWidth = style.width;
        var topHeight = style.height;
        var overflow = style.overflow;
        var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
            width: topWidth,
            accumWidth: 0,
            breakAll: overflow === 'breakAll'
        } : null;
        var lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex = 0;
        var result;
        while((result = $c72f3dec0993863b$var$STYLE_REG.exec(text)) != null){
            var matchedIndex = result.index;
            if (matchedIndex > lastIndex) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
            $c72f3dec0993863b$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
            lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex;
        }
        if (lastIndex < text.length) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
        var pendingList = [];
        var calculatedHeight = 0;
        var calculatedWidth = 0;
        var stlPadding = style.padding;
        var truncate = overflow === 'truncate';
        var truncateLine = style.lineOverflow === 'truncate';
        function finishLine(line, lineWidth, lineHeight) {
            line.width = lineWidth;
            line.lineHeight = lineHeight;
            calculatedHeight += lineHeight;
            calculatedWidth = Math.max(calculatedWidth, lineWidth);
        }
        outer: for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var lineHeight = 0;
            var lineWidth = 0;
            for(var j = 0; j < line.tokens.length; j++){
                var token = line.tokens[j];
                var tokenStyle = token.styleName && style.rich[token.styleName] || {};
                var textPadding = token.textPadding = tokenStyle.padding;
                var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
                var font = token.font = tokenStyle.font || style.font;
                token.contentHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
                var tokenHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.height, token.contentHeight);
                token.innerHeight = tokenHeight;
                textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
                token.height = tokenHeight;
                token.lineHeight = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
                token.align = tokenStyle && tokenStyle.align || style.align;
                token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
                if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                    if (j > 0) {
                        line.tokens = line.tokens.slice(0, j);
                        finishLine(line, lineWidth, lineHeight);
                        contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                    } else contentBlock.lines = contentBlock.lines.slice(0, i);
                    break outer;
                }
                var styleTokenWidth = tokenStyle.width;
                var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
                if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                    token.percentWidth = styleTokenWidth;
                    pendingList.push(token);
                    token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                } else {
                    if (tokenWidthNotSpecified) {
                        var textBackgroundColor = tokenStyle.backgroundColor;
                        var bgImg = textBackgroundColor && textBackgroundColor.image;
                        if (bgImg) {
                            bgImg = (0, parcelRequire("63nvx")).findExistImage(bgImg);
                            if ((0, parcelRequire("63nvx")).isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                        }
                    }
                    var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                    if (remainTruncWidth != null && remainTruncWidth < token.width) {
                        if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                            token.text = '';
                            token.width = token.contentWidth = 0;
                        } else {
                            token.text = $c72f3dec0993863b$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                                minChar: style.truncateMinChar
                            });
                            token.width = token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                        }
                    } else token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                }
                token.width += paddingH;
                lineWidth += token.width;
                tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
            }
            finishLine(line, lineWidth, lineHeight);
        }
        contentBlock.outerWidth = contentBlock.width = (0, (0, parcelRequire("bahqM")).retrieve2)(topWidth, calculatedWidth);
        contentBlock.outerHeight = contentBlock.height = (0, (0, parcelRequire("bahqM")).retrieve2)(topHeight, calculatedHeight);
        contentBlock.contentHeight = calculatedHeight;
        contentBlock.contentWidth = calculatedWidth;
        if (stlPadding) {
            contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
            contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
        }
        for(var i = 0; i < pendingList.length; i++){
            var token = pendingList[i];
            var percentWidth = token.percentWidth;
            token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
        }
        return contentBlock;
    }
    function $c72f3dec0993863b$var$pushTokens(block, str, style, wrapInfo, styleName) {
        var isEmptyStr = str === '';
        var tokenStyle = styleName && style.rich[styleName] || {};
        var lines = block.lines;
        var font = tokenStyle.font || style.font;
        var newLine = false;
        var strLines;
        var linesWidths;
        if (wrapInfo) {
            var tokenPadding = tokenStyle.padding;
            var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
            if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
                var outerWidth_1 = (0, (0, parcelRequire("b7ZX8")).parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
                if (lines.length > 0) {
                    if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                        strLines = str.split('\n');
                        newLine = true;
                    }
                }
                wrapInfo.accumWidth = outerWidth_1;
            } else {
                var res = $c72f3dec0993863b$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
                wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
                linesWidths = res.linesWidths;
                strLines = res.lines;
            }
        } else strLines = str.split('\n');
        for(var i = 0; i < strLines.length; i++){
            var text = strLines[i];
            var token = new $c72f3dec0993863b$var$RichTextToken();
            token.styleName = styleName;
            token.text = text;
            token.isLineHolder = !text && !isEmptyStr;
            if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
            else token.width = linesWidths ? linesWidths[i] : (0, (0, parcelRequire("b7ZX8")).getWidth)(text, font);
            if (!i && !newLine) {
                var tokens = (lines[lines.length - 1] || (lines[0] = new $c72f3dec0993863b$var$RichTextLine())).tokens;
                var tokensLen = tokens.length;
                tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
            } else lines.push(new $c72f3dec0993863b$var$RichTextLine([
                token
            ]));
        }
    }
    function $c72f3dec0993863b$var$isLatin(ch) {
        var code = ch.charCodeAt(0);
        return code >= 0x21 && code <= 0xFF;
    }
    var $c72f3dec0993863b$var$breakCharMap = (0, (0, parcelRequire("bahqM")).reduce)(',&?/;] '.split(''), function(obj, ch) {
        obj[ch] = true;
        return obj;
    }, {});
    function $c72f3dec0993863b$var$isWordBreakChar(ch) {
        if ($c72f3dec0993863b$var$isLatin(ch)) {
            if ($c72f3dec0993863b$var$breakCharMap[ch]) return true;
            return false;
        }
        return true;
    }
    function $c72f3dec0993863b$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
        var lines = [];
        var linesWidths = [];
        var line = '';
        var currentWord = '';
        var currentWordWidth = 0;
        var accumWidth = 0;
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch === '\n') {
                if (currentWord) {
                    line += currentWord;
                    accumWidth += currentWordWidth;
                }
                lines.push(line);
                linesWidths.push(accumWidth);
                line = '';
                currentWord = '';
                currentWordWidth = 0;
                accumWidth = 0;
                continue;
            }
            var chWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ch, font);
            var inWord = isBreakAll ? false : !$c72f3dec0993863b$var$isWordBreakChar(ch);
            if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
                if (!accumWidth) {
                    if (inWord) {
                        lines.push(currentWord);
                        linesWidths.push(currentWordWidth);
                        currentWord = ch;
                        currentWordWidth = chWidth;
                    } else {
                        lines.push(ch);
                        linesWidths.push(chWidth);
                    }
                } else if (line || currentWord) {
                    if (inWord) {
                        if (!line) {
                            line = currentWord;
                            currentWord = '';
                            currentWordWidth = 0;
                            accumWidth = currentWordWidth;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth - currentWordWidth);
                        currentWord += ch;
                        currentWordWidth += chWidth;
                        line = '';
                        accumWidth = currentWordWidth;
                    } else {
                        if (currentWord) {
                            line += currentWord;
                            accumWidth += currentWordWidth;
                            currentWord = '';
                            currentWordWidth = 0;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth);
                        line = ch;
                        accumWidth = chWidth;
                    }
                }
                continue;
            }
            accumWidth += chWidth;
            if (inWord) {
                currentWord += ch;
                currentWordWidth += chWidth;
            } else {
                if (currentWord) {
                    line += currentWord;
                    currentWord = '';
                    currentWordWidth = 0;
                }
                line += ch;
            }
        }
        if (!lines.length && !line) {
            line = text;
            currentWord = '';
            currentWordWidth = 0;
        }
        if (currentWord) line += currentWord;
        if (line) {
            lines.push(line);
            linesWidths.push(accumWidth);
        }
        if (lines.length === 1) accumWidth += lastAccumWidth;
        return {
            accumWidth: accumWidth,
            lines: lines,
            linesWidths: linesWidths
        };
    }
});
parcelRegister("63nvx", function(module, exports) {
    $parcel$export(module.exports, "findExistImage", ()=>$468542031e7bbc2a$export$1b614f30ac2c8867);
    $parcel$export(module.exports, "createOrUpdateImage", ()=>$468542031e7bbc2a$export$46c791b69ff9a0f);
    $parcel$export(module.exports, "isImageReady", ()=>$468542031e7bbc2a$export$37ca7dd901d0236d);
    var $h4RuA;
    var $468542031e7bbc2a$var$globalImageCache = new (0, (0, parcelRequire("h4RuA")).default)(50);
    function $468542031e7bbc2a$export$1b614f30ac2c8867(newImageOrSrc) {
        if (typeof newImageOrSrc === 'string') {
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            return cachedImgObj && cachedImgObj.image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
        if (!newImageOrSrc) return image;
        else if (typeof newImageOrSrc === 'string') {
            if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            var pendingWrap = {
                hostEl: hostEl,
                cb: onload,
                cbPayload: cbPayload
            };
            if (cachedImgObj) {
                image = cachedImgObj.image;
                !$468542031e7bbc2a$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
            } else {
                image = new Image();
                image.onload = image.onerror = $468542031e7bbc2a$var$imageOnLoad;
                $468542031e7bbc2a$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                    image: image,
                    pending: [
                        pendingWrap
                    ]
                });
                image.src = image.__zrImageSrc = newImageOrSrc;
            }
            return image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$var$imageOnLoad() {
        var cachedImgObj = this.__cachedImgObj;
        this.onload = this.onerror = this.__cachedImgObj = null;
        for(var i = 0; i < cachedImgObj.pending.length; i++){
            var pendingWrap = cachedImgObj.pending[i];
            var cb = pendingWrap.cb;
            cb && cb(this, pendingWrap.cbPayload);
            pendingWrap.hostEl.dirty();
        }
        cachedImgObj.pending.length = 0;
    }
    function $468542031e7bbc2a$export$37ca7dd901d0236d(image) {
        return image && image.width && image.height;
    }
});
parcelRegister("h4RuA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ec4ddc95ccc3f1$export$2e2bcd8739ae039);
    var $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59 = function() {
        function Entry(val) {
            this.value = val;
        }
        return Entry;
    }();
    var $c6ec4ddc95ccc3f1$export$f0ef28713f767754 = function() {
        function LinkedList() {
            this._len = 0;
        }
        LinkedList.prototype.insert = function(val) {
            var entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(val);
            this.insertEntry(entry);
            return entry;
        };
        LinkedList.prototype.insertEntry = function(entry) {
            if (!this.head) this.head = this.tail = entry;
            else {
                this.tail.next = entry;
                entry.prev = this.tail;
                entry.next = null;
                this.tail = entry;
            }
            this._len++;
        };
        LinkedList.prototype.remove = function(entry) {
            var prev = entry.prev;
            var next = entry.next;
            if (prev) prev.next = next;
            else this.head = next;
            if (next) next.prev = prev;
            else this.tail = prev;
            entry.next = entry.prev = null;
            this._len--;
        };
        LinkedList.prototype.len = function() {
            return this._len;
        };
        LinkedList.prototype.clear = function() {
            this.head = this.tail = null;
            this._len = 0;
        };
        return LinkedList;
    }();
    var $c6ec4ddc95ccc3f1$var$LRU = function() {
        function LRU(maxSize) {
            this._list = new $c6ec4ddc95ccc3f1$export$f0ef28713f767754();
            this._maxSize = 10;
            this._map = {};
            this._maxSize = maxSize;
        }
        LRU.prototype.put = function(key, value) {
            var list = this._list;
            var map = this._map;
            var removed = null;
            if (map[key] == null) {
                var len = list.len();
                var entry = this._lastRemovedEntry;
                if (len >= this._maxSize && len > 0) {
                    var leastUsedEntry = list.head;
                    list.remove(leastUsedEntry);
                    delete map[leastUsedEntry.key];
                    removed = leastUsedEntry.value;
                    this._lastRemovedEntry = leastUsedEntry;
                }
                if (entry) entry.value = value;
                else entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(value);
                entry.key = key;
                list.insertEntry(entry);
                map[key] = entry;
            }
            return removed;
        };
        LRU.prototype.get = function(key) {
            var entry = this._map[key];
            var list = this._list;
            if (entry != null) {
                if (entry !== list.tail) {
                    list.remove(entry);
                    list.insertEntry(entry);
                }
                return entry.value;
            }
        };
        LRU.prototype.clear = function() {
            this._list.clear();
            this._map = {};
        };
        LRU.prototype.len = function() {
            return this._list.len();
        };
        return LRU;
    }();
    var $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039 = $c6ec4ddc95ccc3f1$var$LRU;
});
parcelRegister("b7ZX8", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_FONT", ()=>$81a067b5a1d9459c$export$7d7a232b6d2cc80c);
    $parcel$export(module.exports, "getWidth", ()=>$81a067b5a1d9459c$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getLineHeight", ()=>$81a067b5a1d9459c$export$56204a27a2958a55);
    $parcel$export(module.exports, "adjustTextX", ()=>$81a067b5a1d9459c$export$eb5a525ef00ef9a4);
    $parcel$export(module.exports, "adjustTextY", ()=>$81a067b5a1d9459c$export$bf7d6802d2badd9);
    $parcel$export(module.exports, "getBoundingRect", ()=>$81a067b5a1d9459c$export$c381147bfed79d9f);
    $parcel$export(module.exports, "parsePercent", ()=>$81a067b5a1d9459c$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "calculateTextPosition", ()=>$81a067b5a1d9459c$export$eee3603b512feab7);
    var $1E3E8;
    var $bahqM;
    var $h4RuA;
    var $81a067b5a1d9459c$var$textWidthCache = {};
    var $81a067b5a1d9459c$export$7d7a232b6d2cc80c = '12px sans-serif';
    var $81a067b5a1d9459c$var$_ctx;
    var $81a067b5a1d9459c$var$_cachedFont;
    function $81a067b5a1d9459c$var$defaultMeasureText(text, font) {
        if (!$81a067b5a1d9459c$var$_ctx) $81a067b5a1d9459c$var$_ctx = (0, (0, parcelRequire("bahqM")).createCanvas)().getContext('2d');
        if ($81a067b5a1d9459c$var$_cachedFont !== font) $81a067b5a1d9459c$var$_cachedFont = $81a067b5a1d9459c$var$_ctx.font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        return $81a067b5a1d9459c$var$_ctx.measureText(text);
    }
    var $81a067b5a1d9459c$var$methods = {
        measureText: $81a067b5a1d9459c$var$defaultMeasureText
    };
    function $81a067b5a1d9459c$export$d35a04b83ea6803e(name, fn) {
        $81a067b5a1d9459c$var$methods[name] = fn;
    }
    function $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font) {
        font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        var cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font];
        if (!cacheOfFont) cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font] = new (0, (0, parcelRequire("h4RuA")).default)(500);
        var width = cacheOfFont.get(text);
        if (width == null) {
            width = $81a067b5a1d9459c$var$methods.measureText(text, font).width;
            cacheOfFont.put(text, width);
        }
        return width;
    }
    function $81a067b5a1d9459c$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
        var width = $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font);
        var height = $81a067b5a1d9459c$export$56204a27a2958a55(font);
        var x = $81a067b5a1d9459c$export$eb5a525ef00ef9a4(0, width, textAlign);
        var y = $81a067b5a1d9459c$export$bf7d6802d2badd9(0, height, textBaseline);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        return rect;
    }
    function $81a067b5a1d9459c$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
        var textLines = ((text || '') + '').split('\n');
        var len = textLines.length;
        if (len === 1) return $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
        else {
            var uniondRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            for(var i = 0; i < textLines.length; i++){
                var rect = $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
                i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
            }
            return uniondRect;
        }
    }
    function $81a067b5a1d9459c$export$eb5a525ef00ef9a4(x, width, textAlign) {
        if (textAlign === 'right') x -= width;
        else if (textAlign === 'center') x -= width / 2;
        return x;
    }
    function $81a067b5a1d9459c$export$bf7d6802d2badd9(y, height, verticalAlign) {
        if (verticalAlign === 'middle') y -= height / 2;
        else if (verticalAlign === 'bottom') y -= height;
        return y;
    }
    function $81a067b5a1d9459c$export$56204a27a2958a55(font) {
        return $81a067b5a1d9459c$export$3c49c185de0c2bfc("\u56FD", font);
    }
    function $81a067b5a1d9459c$export$866cc30a33805630(text, font) {
        return $81a067b5a1d9459c$var$methods.measureText(text, font);
    }
    function $81a067b5a1d9459c$export$e8514cb5a5e2b40f(value, maxValue) {
        if (typeof value === 'string') {
            if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
            return parseFloat(value);
        }
        return value;
    }
    function $81a067b5a1d9459c$export$eee3603b512feab7(out, opts, rect) {
        var textPosition = opts.position || 'inside';
        var distance = opts.distance != null ? opts.distance : 5;
        var height = rect.height;
        var width = rect.width;
        var halfHeight = height / 2;
        var x = rect.x;
        var y = rect.y;
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        if (textPosition instanceof Array) {
            x += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
            y += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
            textAlign = null;
            textVerticalAlign = null;
        } else switch(textPosition){
            case 'left':
                x -= distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'right':
                x += distance + width;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'top':
                x += width / 2;
                y -= distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'bottom':
                x += width / 2;
                y += height + distance;
                textAlign = 'center';
                break;
            case 'inside':
                x += width / 2;
                y += halfHeight;
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'insideLeft':
                x += distance;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'insideRight':
                x += width - distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideTop':
                x += width / 2;
                y += distance;
                textAlign = 'center';
                break;
            case 'insideBottom':
                x += width / 2;
                y += height - distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideTopLeft':
                x += distance;
                y += distance;
                break;
            case 'insideTopRight':
                x += width - distance;
                y += distance;
                textAlign = 'right';
                break;
            case 'insideBottomLeft':
                x += distance;
                y += height - distance;
                textVerticalAlign = 'bottom';
                break;
            case 'insideBottomRight':
                x += width - distance;
                y += height - distance;
                textAlign = 'right';
                textVerticalAlign = 'bottom';
                break;
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    }
});
parcelRegister("1E3E8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$132c5af5562dffd4$export$2e2bcd8739ae039);
    var $izqgC;
    var $bMDnR;
    var $132c5af5562dffd4$var$mathMin = Math.min;
    var $132c5af5562dffd4$var$mathMax = Math.max;
    var $132c5af5562dffd4$var$lt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$lb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$BoundingRect = function() {
        function BoundingRect(x, y, width, height) {
            if (width < 0) {
                x = x + width;
                width = -width;
            }
            if (height < 0) {
                y = y + height;
                height = -height;
            }
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        }
        BoundingRect.prototype.union = function(other) {
            var x = $132c5af5562dffd4$var$mathMin(other.x, this.x);
            var y = $132c5af5562dffd4$var$mathMin(other.y, this.y);
            if (isFinite(this.x) && isFinite(this.width)) this.width = $132c5af5562dffd4$var$mathMax(other.x + other.width, this.x + this.width) - x;
            else this.width = other.width;
            if (isFinite(this.y) && isFinite(this.height)) this.height = $132c5af5562dffd4$var$mathMax(other.y + other.height, this.y + this.height) - y;
            else this.height = other.height;
            this.x = x;
            this.y = y;
        };
        BoundingRect.prototype.applyTransform = function(m) {
            BoundingRect.applyTransform(this, this, m);
        };
        BoundingRect.prototype.calculateTransform = function(b) {
            var a = this;
            var sx = b.width / a.width;
            var sy = b.height / a.height;
            var m = (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).translate(m, m, [
                -a.x,
                -a.y
            ]);
            (0, parcelRequire("izqgC")).scale(m, m, [
                sx,
                sy
            ]);
            (0, parcelRequire("izqgC")).translate(m, m, [
                b.x,
                b.y
            ]);
            return m;
        };
        BoundingRect.prototype.intersect = function(b, mtv) {
            if (!b) return false;
            if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
            var a = this;
            var ax0 = a.x;
            var ax1 = a.x + a.width;
            var ay0 = a.y;
            var ay1 = a.y + a.height;
            var bx0 = b.x;
            var bx1 = b.x + b.width;
            var by0 = b.y;
            var by1 = b.y + b.height;
            var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
            if (mtv) {
                var dMin = Infinity;
                var dMax = 0;
                var d0 = Math.abs(ax1 - bx0);
                var d1 = Math.abs(bx1 - ax0);
                var d2 = Math.abs(ay1 - by0);
                var d3 = Math.abs(by1 - ay0);
                var dx = Math.min(d0, d1);
                var dy = Math.min(d2, d3);
                if (ax1 < bx0 || bx1 < ax0) {
                    if (dx > dMax) {
                        dMax = dx;
                        if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, -d0, 0);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, d1, 0);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, d0, 0);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, -d1, 0);
                }
                if (ay1 < by0 || by1 < ay0) {
                    if (dy > dMax) {
                        dMax = dy;
                        if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, -d2);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, d3);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, d2);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, -d3);
                }
            }
            if (mtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlap ? $132c5af5562dffd4$var$minTv : $132c5af5562dffd4$var$maxTv);
            return overlap;
        };
        BoundingRect.prototype.contain = function(x, y) {
            var rect = this;
            return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
        };
        BoundingRect.prototype.clone = function() {
            return new BoundingRect(this.x, this.y, this.width, this.height);
        };
        BoundingRect.prototype.copy = function(other) {
            BoundingRect.copy(this, other);
        };
        BoundingRect.prototype.plain = function() {
            return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height
            };
        };
        BoundingRect.prototype.isFinite = function() {
            return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
        };
        BoundingRect.prototype.isZero = function() {
            return this.width === 0 || this.height === 0;
        };
        BoundingRect.create = function(rect) {
            return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
        };
        BoundingRect.copy = function(target, source) {
            target.x = source.x;
            target.y = source.y;
            target.width = source.width;
            target.height = source.height;
        };
        BoundingRect.applyTransform = function(target, source, m) {
            if (!m) {
                if (target !== source) BoundingRect.copy(target, source);
                return;
            }
            if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
                var sx = m[0];
                var sy = m[3];
                var tx = m[4];
                var ty = m[5];
                target.x = source.x * sx + tx;
                target.y = source.y * sy + ty;
                target.width = source.width * sx;
                target.height = source.height * sy;
                if (target.width < 0) {
                    target.x += target.width;
                    target.width = -target.width;
                }
                if (target.height < 0) {
                    target.y += target.height;
                    target.height = -target.height;
                }
                return;
            }
            $132c5af5562dffd4$var$lt.x = $132c5af5562dffd4$var$lb.x = source.x;
            $132c5af5562dffd4$var$lt.y = $132c5af5562dffd4$var$rt.y = source.y;
            $132c5af5562dffd4$var$rb.x = $132c5af5562dffd4$var$rt.x = source.x + source.width;
            $132c5af5562dffd4$var$rb.y = $132c5af5562dffd4$var$lb.y = source.y + source.height;
            $132c5af5562dffd4$var$lt.transform(m);
            $132c5af5562dffd4$var$rt.transform(m);
            $132c5af5562dffd4$var$rb.transform(m);
            $132c5af5562dffd4$var$lb.transform(m);
            target.x = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            target.y = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            var maxX = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            var maxY = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            target.width = maxX - target.x;
            target.height = maxY - target.y;
        };
        return BoundingRect;
    }();
    var $132c5af5562dffd4$export$2e2bcd8739ae039 = $132c5af5562dffd4$var$BoundingRect;
});
parcelRegister("izqgC", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$d84fdef7d2e904e1$export$185802fd694ee1f5);
    $parcel$export(module.exports, "identity", ()=>$d84fdef7d2e904e1$export$f0954fd7d5368655);
    $parcel$export(module.exports, "copy", ()=>$d84fdef7d2e904e1$export$784d13d8ee351f07);
    $parcel$export(module.exports, "mul", ()=>$d84fdef7d2e904e1$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "translate", ()=>$d84fdef7d2e904e1$export$d73ee8ef04f5226a);
    $parcel$export(module.exports, "rotate", ()=>$d84fdef7d2e904e1$export$bb628a54ab399bc9);
    $parcel$export(module.exports, "scale", ()=>$d84fdef7d2e904e1$export$dcdf75081b88279d);
    $parcel$export(module.exports, "invert", ()=>$d84fdef7d2e904e1$export$6897c284b6f9f4dc);
    $parcel$export(module.exports, "clone", ()=>$d84fdef7d2e904e1$export$9cd59f9826255e47);
    function $d84fdef7d2e904e1$export$185802fd694ee1f5() {
        return [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    function $d84fdef7d2e904e1$export$f0954fd7d5368655(out) {
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 1;
        out[4] = 0;
        out[5] = 0;
        return out;
    }
    function $d84fdef7d2e904e1$export$784d13d8ee351f07(out, m) {
        out[0] = m[0];
        out[1] = m[1];
        out[2] = m[2];
        out[3] = m[3];
        out[4] = m[4];
        out[5] = m[5];
        return out;
    }
    function $d84fdef7d2e904e1$export$6e3a27864ab166fe(out, m1, m2) {
        var out0 = m1[0] * m2[0] + m1[2] * m2[1];
        var out1 = m1[1] * m2[0] + m1[3] * m2[1];
        var out2 = m1[0] * m2[2] + m1[2] * m2[3];
        var out3 = m1[1] * m2[2] + m1[3] * m2[3];
        var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
        var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
        out[0] = out0;
        out[1] = out1;
        out[2] = out2;
        out[3] = out3;
        out[4] = out4;
        out[5] = out5;
        return out;
    }
    function $d84fdef7d2e904e1$export$d73ee8ef04f5226a(out, a, v) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[4] = a[4] + v[0];
        out[5] = a[5] + v[1];
        return out;
    }
    function $d84fdef7d2e904e1$export$bb628a54ab399bc9(out, a, rad) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var st = Math.sin(rad);
        var ct = Math.cos(rad);
        out[0] = aa * ct + ab * st;
        out[1] = -aa * st + ab * ct;
        out[2] = ac * ct + ad * st;
        out[3] = -ac * st + ct * ad;
        out[4] = ct * atx + st * aty;
        out[5] = ct * aty - st * atx;
        return out;
    }
    function $d84fdef7d2e904e1$export$dcdf75081b88279d(out, a, v) {
        var vx = v[0];
        var vy = v[1];
        out[0] = a[0] * vx;
        out[1] = a[1] * vy;
        out[2] = a[2] * vx;
        out[3] = a[3] * vy;
        out[4] = a[4] * vx;
        out[5] = a[5] * vy;
        return out;
    }
    function $d84fdef7d2e904e1$export$6897c284b6f9f4dc(out, a) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var det = aa * ad - ab * ac;
        if (!det) return null;
        det = 1.0 / det;
        out[0] = ad * det;
        out[1] = -ab * det;
        out[2] = -ac * det;
        out[3] = aa * det;
        out[4] = (ac * aty - ad * atx) * det;
        out[5] = (ab * atx - aa * aty) * det;
        return out;
    }
    function $d84fdef7d2e904e1$export$9cd59f9826255e47(a) {
        var b = $d84fdef7d2e904e1$export$185802fd694ee1f5();
        $d84fdef7d2e904e1$export$784d13d8ee351f07(b, a);
        return b;
    }
});
parcelRegister("bMDnR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8942ba3a66d599f1$export$2e2bcd8739ae039);
    var $8942ba3a66d599f1$var$Point = function() {
        function Point(x, y) {
            this.x = x || 0;
            this.y = y || 0;
        }
        Point.prototype.copy = function(other) {
            this.x = other.x;
            this.y = other.y;
            return this;
        };
        Point.prototype.clone = function() {
            return new Point(this.x, this.y);
        };
        Point.prototype.set = function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        };
        Point.prototype.equal = function(other) {
            return other.x === this.x && other.y === this.y;
        };
        Point.prototype.add = function(other) {
            this.x += other.x;
            this.y += other.y;
            return this;
        };
        Point.prototype.scale = function(scalar) {
            this.x *= scalar;
            this.y *= scalar;
        };
        Point.prototype.scaleAndAdd = function(other, scalar) {
            this.x += other.x * scalar;
            this.y += other.y * scalar;
        };
        Point.prototype.sub = function(other) {
            this.x -= other.x;
            this.y -= other.y;
            return this;
        };
        Point.prototype.dot = function(other) {
            return this.x * other.x + this.y * other.y;
        };
        Point.prototype.len = function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        };
        Point.prototype.lenSquare = function() {
            return this.x * this.x + this.y * this.y;
        };
        Point.prototype.normalize = function() {
            var len = this.len();
            this.x /= len;
            this.y /= len;
            return this;
        };
        Point.prototype.distance = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return Math.sqrt(dx * dx + dy * dy);
        };
        Point.prototype.distanceSquare = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return dx * dx + dy * dy;
        };
        Point.prototype.negate = function() {
            this.x = -this.x;
            this.y = -this.y;
            return this;
        };
        Point.prototype.transform = function(m) {
            if (!m) return;
            var x = this.x;
            var y = this.y;
            this.x = m[0] * x + m[2] * y + m[4];
            this.y = m[1] * x + m[3] * y + m[5];
            return this;
        };
        Point.prototype.toArray = function(out) {
            out[0] = this.x;
            out[1] = this.y;
            return out;
        };
        Point.prototype.fromArray = function(input) {
            this.x = input[0];
            this.y = input[1];
        };
        Point.set = function(p, x, y) {
            p.x = x;
            p.y = y;
        };
        Point.copy = function(p, p2) {
            p.x = p2.x;
            p.y = p2.y;
        };
        Point.len = function(p) {
            return Math.sqrt(p.x * p.x + p.y * p.y);
        };
        Point.lenSquare = function(p) {
            return p.x * p.x + p.y * p.y;
        };
        Point.dot = function(p0, p1) {
            return p0.x * p1.x + p0.y * p1.y;
        };
        Point.add = function(out, p0, p1) {
            out.x = p0.x + p1.x;
            out.y = p0.y + p1.y;
        };
        Point.sub = function(out, p0, p1) {
            out.x = p0.x - p1.x;
            out.y = p0.y - p1.y;
        };
        Point.scale = function(out, p0, scalar) {
            out.x = p0.x * scalar;
            out.y = p0.y * scalar;
        };
        Point.scaleAndAdd = function(out, p0, p1, scalar) {
            out.x = p0.x + p1.x * scalar;
            out.y = p0.y + p1.y * scalar;
        };
        Point.lerp = function(out, p0, p1, t) {
            var onet = 1 - t;
            out.x = onet * p0.x + t * p1.x;
            out.y = onet * p0.y + t * p1.y;
        };
        return Point;
    }();
    var $8942ba3a66d599f1$export$2e2bcd8739ae039 = $8942ba3a66d599f1$var$Point;
});
parcelRegister("45jlh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f96a200e6d0cf38$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $b7ZX8;
    var $ghQ8v;
    var $bahqM;
    var $2f96a200e6d0cf38$export$5fbb6d98091bcb56 = (0, (0, parcelRequire("bahqM")).defaults)({
        strokeFirst: true,
        font: (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT),
        x: 0,
        y: 0,
        textAlign: 'left',
        textBaseline: 'top',
        miterLimit: 2
    }, (0, (0, parcelRequire("ghQ8v")).DEFAULT_PATH_STYLE));
    var $2f96a200e6d0cf38$var$TSpan = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TSpan, _super);
        function TSpan() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TSpan.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return stroke != null && stroke !== 'none' && style.lineWidth > 0;
        };
        TSpan.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        TSpan.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($2f96a200e6d0cf38$export$5fbb6d98091bcb56, obj);
        };
        TSpan.prototype.setBoundingRect = function(rect) {
            this._rect = rect;
        };
        TSpan.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) {
                var text = style.text;
                text != null ? text += '' : text = '';
                var rect = (0, (0, parcelRequire("b7ZX8")).getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
                rect.x += style.x || 0;
                rect.y += style.y || 0;
                if (this.hasStroke()) {
                    var w = style.lineWidth;
                    rect.x -= w / 2;
                    rect.y -= w / 2;
                    rect.width += w;
                    rect.height += w;
                }
                this._rect = rect;
            }
            return this._rect;
        };
        TSpan.initDefaultProps = function() {
            var tspanProto = TSpan.prototype;
            tspanProto.dirtyRectTolerance = 10;
        }();
        return TSpan;
    }((0, (0, parcelRequire("lBQ88")).default));
    $2f96a200e6d0cf38$var$TSpan.prototype.type = 'tspan';
    var $2f96a200e6d0cf38$export$2e2bcd8739ae039 = $2f96a200e6d0cf38$var$TSpan;
});
parcelRegister("lBQ88", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_COMMON_STYLE", ()=>$fbb57da3b649c75e$export$737672163db00fe3);
    $parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", ()=>$fbb57da3b649c75e$export$9908943fb57fbe51);
    $parcel$export(module.exports, "default", ()=>$fbb57da3b649c75e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7KVc5;
    var $1E3E8;
    var $bahqM;
    var $aVawM;
    var $fbb57da3b649c75e$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
    var $fbb57da3b649c75e$export$737672163db00fe3 = {
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: '#000',
        opacity: 1,
        blend: 'source-over'
    };
    var $fbb57da3b649c75e$export$9908943fb57fbe51 = {
        style: {
            shadowBlur: true,
            shadowOffsetX: true,
            shadowOffsetY: true,
            shadowColor: true,
            opacity: true
        }
    };
    $fbb57da3b649c75e$export$737672163db00fe3[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY] = true;
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS = [
        'z',
        'z2',
        'invisible'
    ];
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
        'invisible'
    ];
    var $fbb57da3b649c75e$var$Displayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Displayable, _super);
        function Displayable(props) {
            return _super.call(this, props) || this;
        }
        Displayable.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                if (key === 'style') this.useStyle(props[key]);
                else _super.prototype.attrKV.call(this, key, props[key]);
            }
            if (!this.style) this.useStyle({});
        };
        Displayable.prototype.beforeBrush = function() {};
        Displayable.prototype.afterBrush = function() {};
        Displayable.prototype.innerBeforeBrush = function() {};
        Displayable.prototype.innerAfterBrush = function() {};
        Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
            var m = this.transform;
            if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $fbb57da3b649c75e$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
            if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
                if (this.__clipPaths[i].isZeroArea()) return false;
            }
            if (considerAncestors && this.parent) {
                var parent_1 = this.parent;
                while(parent_1){
                    if (parent_1.ignore) return false;
                    parent_1 = parent_1.parent;
                }
            }
            return true;
        };
        Displayable.prototype.contain = function(x, y) {
            return this.rectContain(x, y);
        };
        Displayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        Displayable.prototype.rectContain = function(x, y) {
            var coord = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            return rect.contain(coord[0], coord[1]);
        };
        Displayable.prototype.getPaintRect = function() {
            var rect = this._paintRect;
            if (!this._paintRect || this.__dirty) {
                var transform = this.transform;
                var elRect = this.getBoundingRect();
                var style = this.style;
                var shadowSize = style.shadowBlur || 0;
                var shadowOffsetX = style.shadowOffsetX || 0;
                var shadowOffsetY = style.shadowOffsetY || 0;
                rect = this._paintRect || (this._paintRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0));
                if (transform) (0, (0, parcelRequire("1E3E8")).default).applyTransform(rect, elRect, transform);
                else rect.copy(elRect);
                if (shadowSize || shadowOffsetX || shadowOffsetY) {
                    rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                    rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                    rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                    rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
                }
                var tolerance = this.dirtyRectTolerance;
                if (!rect.isZero()) {
                    rect.x = Math.floor(rect.x - tolerance);
                    rect.y = Math.floor(rect.y - tolerance);
                    rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                    rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
                }
            }
            return rect;
        };
        Displayable.prototype.setPrevPaintRect = function(paintRect) {
            if (paintRect) {
                this._prevPaintRect = this._prevPaintRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                this._prevPaintRect.copy(paintRect);
            } else this._prevPaintRect = null;
        };
        Displayable.prototype.getPrevPaintRect = function() {
            return this._prevPaintRect;
        };
        Displayable.prototype.animateStyle = function(loop) {
            return this.animate('style', loop);
        };
        Displayable.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else this.markRedraw();
        };
        Displayable.prototype.attrKV = function(key, value) {
            if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
            else if (!this.style) this.useStyle(value);
            else this.setStyle(value);
        };
        Displayable.prototype.setStyle = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(this.style, keyOrObj);
            this.dirtyStyle();
            return this;
        };
        Displayable.prototype.dirtyStyle = function(notRedraw) {
            if (!notRedraw) this.markRedraw();
            this.__dirty |= (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
            if (this._rect) this._rect = null;
        };
        Displayable.prototype.dirty = function() {
            this.dirtyStyle();
        };
        Displayable.prototype.styleChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT));
        };
        Displayable.prototype.styleUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        };
        Displayable.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($fbb57da3b649c75e$export$737672163db00fe3, obj);
        };
        Displayable.prototype.useStyle = function(obj) {
            if (!obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
            if (this.__inHover) this.__hoverStyle = obj;
            else this.style = obj;
            this.dirtyStyle();
        };
        Displayable.prototype.isStyleObject = function(obj) {
            return obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY];
        };
        Displayable.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
            this._savePrimaryToNormal(toState, normalState, $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS);
        };
        Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetStyle;
            if (state && state.style) {
                if (transition) {
                    if (keepCurrentStates) targetStyle = state.style;
                    else {
                        targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                        this._mergeStyle(targetStyle, state.style);
                    }
                } else {
                    targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else if (needsRestoreToNormal) targetStyle = normalState.style;
            if (targetStyle) {
                if (transition) {
                    var sourceStyle = this.style;
                    this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                    if (needsRestoreToNormal) {
                        var changedKeys = (0, (0, parcelRequire("bahqM")).keys)(sourceStyle);
                        for(var i = 0; i < changedKeys.length; i++){
                            var key = changedKeys[i];
                            if (key in targetStyle) {
                                targetStyle[key] = targetStyle[key];
                                this.style[key] = sourceStyle[key];
                            }
                        }
                    }
                    var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(targetStyle);
                    for(var i = 0; i < targetKeys.length; i++){
                        var key = targetKeys[i];
                        this.style[key] = this.style[key];
                    }
                    this._transitionState(stateName, {
                        style: targetStyle
                    }, animationCfg, this.getAnimationStyleProps());
                } else this.useStyle(targetStyle);
            }
            var statesKeys = this.__inHover ? $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        };
        Displayable.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedStyle;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.style) {
                    mergedStyle = mergedStyle || {};
                    this._mergeStyle(mergedStyle, state.style);
                }
            }
            if (mergedStyle) mergedState.style = mergedStyle;
            return mergedState;
        };
        Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            return targetStyle;
        };
        Displayable.prototype.getAnimationStyleProps = function() {
            return $fbb57da3b649c75e$export$9908943fb57fbe51;
        };
        Displayable.initDefaultProps = function() {
            var dispProto = Displayable.prototype;
            dispProto.type = 'displayable';
            dispProto.invisible = false;
            dispProto.z = 0;
            dispProto.z2 = 0;
            dispProto.zlevel = 0;
            dispProto.culling = false;
            dispProto.cursor = 'pointer';
            dispProto.rectHover = false;
            dispProto.incremental = false;
            dispProto._rect = null;
            dispProto.dirtyRectTolerance = 0;
            dispProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        }();
        return Displayable;
    }((0, (0, parcelRequire("7KVc5")).default));
    var $fbb57da3b649c75e$var$tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $fbb57da3b649c75e$var$viewRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    function $fbb57da3b649c75e$var$isDisplayableCulled(el, width, height) {
        $fbb57da3b649c75e$var$tmpRect.copy(el.getBoundingRect());
        if (el.transform) $fbb57da3b649c75e$var$tmpRect.applyTransform(el.transform);
        $fbb57da3b649c75e$var$viewRect.width = width;
        $fbb57da3b649c75e$var$viewRect.height = height;
        return !$fbb57da3b649c75e$var$tmpRect.intersect($fbb57da3b649c75e$var$viewRect);
    }
    var $fbb57da3b649c75e$export$2e2bcd8739ae039 = $fbb57da3b649c75e$var$Displayable;
});
parcelRegister("7KVc5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a5931cff6ff005a$export$2e2bcd8739ae039);
    var $e6gef;
    var $hb2y5;
    var $1E3E8;
    var $bRKv5;
    var $b7ZX8;
    var $bahqM;
    var $7y1my;
    var $d6udH;
    var $hZfwb;
    var $aVawM;
    var $5a5931cff6ff005a$export$97b5e845c7286801 = '__zr_normal__';
    var $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS = [
        'x',
        'y',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'rotation',
        'ignore'
    ];
    var $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP = {
        x: true,
        y: true,
        scaleX: true,
        scaleY: true,
        originX: true,
        originY: true,
        rotation: true,
        ignore: false
    };
    var $5a5931cff6ff005a$var$tmpTextPosCalcRes = {};
    var $5a5931cff6ff005a$var$tmpBoundingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $5a5931cff6ff005a$var$Element = function() {
        function Element(props) {
            this.id = (0, (0, parcelRequire("bahqM")).guid)();
            this.animators = [];
            this.currentStates = [];
            this.states = {};
            this._init(props);
        }
        Element.prototype._init = function(props) {
            this.attr(props);
        };
        Element.prototype.drift = function(dx, dy, e) {
            switch(this.draggable){
                case 'horizontal':
                    dy = 0;
                    break;
                case 'vertical':
                    dx = 0;
                    break;
            }
            var m = this.transform;
            if (!m) m = this.transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ];
            m[4] += dx;
            m[5] += dy;
            this.decomposeTransform();
            this.markRedraw();
        };
        Element.prototype.beforeUpdate = function() {};
        Element.prototype.afterUpdate = function() {};
        Element.prototype.update = function() {
            this.updateTransform();
            if (this.__dirty) this.updateInnerText();
        };
        Element.prototype.updateInnerText = function(forceUpdate) {
            var textEl = this._textContent;
            if (textEl && (!textEl.ignore || forceUpdate)) {
                if (!this.textConfig) this.textConfig = {};
                var textConfig = this.textConfig;
                var isLocal = textConfig.local;
                var innerTransformable = textEl.innerTransformable;
                var textAlign = void 0;
                var textVerticalAlign = void 0;
                var textStyleChanged = false;
                innerTransformable.parent = isLocal ? this : null;
                var innerOrigin = false;
                innerTransformable.copyTransform(textEl);
                if (textConfig.position != null) {
                    var layoutRect = $5a5931cff6ff005a$var$tmpBoundingRect;
                    if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                    else layoutRect.copy(this.getBoundingRect());
                    if (!isLocal) layoutRect.applyTransform(this.transform);
                    if (this.calculateTextPosition) this.calculateTextPosition($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    else (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    innerTransformable.x = $5a5931cff6ff005a$var$tmpTextPosCalcRes.x;
                    innerTransformable.y = $5a5931cff6ff005a$var$tmpTextPosCalcRes.y;
                    textAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.align;
                    textVerticalAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.verticalAlign;
                    var textOrigin = textConfig.origin;
                    if (textOrigin && textConfig.rotation != null) {
                        var relOriginX = void 0;
                        var relOriginY = void 0;
                        if (textOrigin === 'center') {
                            relOriginX = layoutRect.width * 0.5;
                            relOriginY = layoutRect.height * 0.5;
                        } else {
                            relOriginX = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[0], layoutRect.width);
                            relOriginY = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[1], layoutRect.height);
                        }
                        innerOrigin = true;
                        innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                        innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                    }
                }
                if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
                var textOffset = textConfig.offset;
                if (textOffset) {
                    innerTransformable.x += textOffset[0];
                    innerTransformable.y += textOffset[1];
                    if (!innerOrigin) {
                        innerTransformable.originX = -textOffset[0];
                        innerTransformable.originY = -textOffset[1];
                    }
                }
                var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
                var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
                var textFill = void 0;
                var textStroke = void 0;
                var autoStroke = void 0;
                if (isInside && this.canBeInsideText()) {
                    textFill = textConfig.insideFill;
                    textStroke = textConfig.insideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getInsideTextStroke(textFill);
                        autoStroke = true;
                    }
                } else {
                    textFill = textConfig.outsideFill;
                    textStroke = textConfig.outsideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getOutsideStroke(textFill);
                        autoStroke = true;
                    }
                }
                textFill = textFill || '#000';
                if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                    textStyleChanged = true;
                    innerTextDefaultStyle.fill = textFill;
                    innerTextDefaultStyle.stroke = textStroke;
                    innerTextDefaultStyle.autoStroke = autoStroke;
                    innerTextDefaultStyle.align = textAlign;
                    innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                    textEl.setDefaultTextStyle(innerTextDefaultStyle);
                }
                textEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                if (textStyleChanged) textEl.dirtyStyle(true);
            }
        };
        Element.prototype.canBeInsideText = function() {
            return true;
        };
        Element.prototype.getInsideTextFill = function() {
            return '#fff';
        };
        Element.prototype.getInsideTextStroke = function(textFill) {
            return '#000';
        };
        Element.prototype.getOutsideFill = function() {
            return this.__zr && this.__zr.isDarkMode() ? (0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR) : (0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR);
        };
        Element.prototype.getOutsideStroke = function(textFill) {
            var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
            var colorArr = typeof backgroundColor === 'string' && (0, (0, parcelRequire("d6udH")).parse)(backgroundColor);
            if (!colorArr) colorArr = [
                255,
                255,
                255,
                1
            ];
            var alpha = colorArr[3];
            var isDark = this.__zr.isDarkMode();
            for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
            colorArr[3] = 1;
            return (0, (0, parcelRequire("d6udH")).stringify)(colorArr, 'rgba');
        };
        Element.prototype.traverse = function(cb, context) {};
        Element.prototype.attrKV = function(key, value) {
            if (key === 'textConfig') this.setTextConfig(value);
            else if (key === 'textContent') this.setTextContent(value);
            else if (key === 'clipPath') this.setClipPath(value);
            else if (key === 'extra') {
                this.extra = this.extra || {};
                (0, (0, parcelRequire("bahqM")).extend)(this.extra, value);
            } else this[key] = value;
        };
        Element.prototype.hide = function() {
            this.ignore = true;
            this.markRedraw();
        };
        Element.prototype.show = function() {
            this.ignore = false;
            this.markRedraw();
        };
        Element.prototype.attr = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
            else if ((0, (0, parcelRequire("bahqM")).isObject)(keyOrObj)) {
                var obj = keyOrObj;
                var keysArr = (0, (0, parcelRequire("bahqM")).keys)(obj);
                for(var i = 0; i < keysArr.length; i++){
                    var key = keysArr[i];
                    this.attrKV(key, keyOrObj[key]);
                }
            }
            this.markRedraw();
            return this;
        };
        Element.prototype.saveCurrentToNormalState = function(toState) {
            this._innerSaveToNormal(toState);
            var normalState = this._normalState;
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var fromStateTransition = animator.__fromStateTransition;
                if (fromStateTransition && fromStateTransition !== $5a5931cff6ff005a$export$97b5e845c7286801) continue;
                var targetName = animator.targetName;
                var target = targetName ? normalState[targetName] : normalState;
                animator.saveFinalToTarget(target);
            }
        };
        Element.prototype._innerSaveToNormal = function(toState) {
            var normalState = this._normalState;
            if (!normalState) normalState = this._normalState = {};
            if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
            this._savePrimaryToNormal(toState, normalState, $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS);
        };
        Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
            for(var i = 0; i < primaryKeys.length; i++){
                var key = primaryKeys[i];
                if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
            }
        };
        Element.prototype.hasState = function() {
            return this.currentStates.length > 0;
        };
        Element.prototype.getState = function(name) {
            return this.states[name];
        };
        Element.prototype.ensureState = function(name) {
            var states = this.states;
            if (!states[name]) states[name] = {};
            return states[name];
        };
        Element.prototype.clearStates = function(noAnimation) {
            this.useState($5a5931cff6ff005a$export$97b5e845c7286801, false, noAnimation);
        };
        Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
            var toNormalState = stateName === $5a5931cff6ff005a$export$97b5e845c7286801;
            var hasStates = this.hasState();
            if (!hasStates && toNormalState) return;
            var currentStates = this.currentStates;
            var animationCfg = this.stateTransition;
            if ((0, (0, parcelRequire("bahqM")).indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
            var state;
            if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
            if (!state) state = this.states && this.states[stateName];
            if (!state && !toNormalState) {
                (0, (0, parcelRequire("bahqM")).logError)("State " + stateName + " not exists.");
                return;
            }
            if (!toNormalState) this.saveCurrentToNormalState(state);
            var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (toNormalState) {
                this.currentStates = [];
                this._normalState = {};
            } else if (!keepCurrentStates) this.currentStates = [
                stateName
            ];
            else this.currentStates.push(stateName);
            this._updateAnimationTargets();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            }
            return state;
        };
        Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
            if (!states.length) this.clearStates();
            else {
                var stateObjects = [];
                var currentStates = this.currentStates;
                var len = states.length;
                var notChange = len === currentStates.length;
                if (notChange) {
                    for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                        notChange = false;
                        break;
                    }
                }
                if (notChange) return;
                for(var i = 0; i < len; i++){
                    var stateName = states[i];
                    var stateObj = void 0;
                    if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                    if (!stateObj) stateObj = this.states[stateName];
                    if (stateObj) stateObjects.push(stateObj);
                }
                var lastStateObj = stateObjects[len - 1];
                var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
                if (useHoverLayer) this._toggleHoverLayerFlag(true);
                var mergedState = this._mergeStates(stateObjects);
                var animationCfg = this.stateTransition;
                this.saveCurrentToNormalState(mergedState);
                this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
                var textContent = this._textContent;
                var textGuide = this._textGuide;
                if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
                if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
                this._updateAnimationTargets();
                this.currentStates = states.slice();
                this.markRedraw();
                if (!useHoverLayer && this.__inHover) {
                    this._toggleHoverLayerFlag(false);
                    this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                }
            }
        };
        Element.prototype._updateAnimationTargets = function() {
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                if (animator.targetName) animator.changeTarget(this[animator.targetName]);
            }
        };
        Element.prototype.removeState = function(state) {
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(this.currentStates, state);
            if (idx >= 0) {
                var currentStates = this.currentStates.slice();
                currentStates.splice(idx, 1);
                this.useStates(currentStates);
            }
        };
        Element.prototype.replaceState = function(oldState, newState, forceAdd) {
            var currentStates = this.currentStates.slice();
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, oldState);
            var newStateExists = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, newState) >= 0;
            if (idx >= 0) {
                if (!newStateExists) currentStates[idx] = newState;
                else currentStates.splice(idx, 1);
            } else if (forceAdd && !newStateExists) currentStates.push(newState);
            this.useStates(currentStates);
        };
        Element.prototype.toggleState = function(state, enable) {
            if (enable) this.useState(state, true);
            else this.removeState(state);
        };
        Element.prototype._mergeStates = function(states) {
            var mergedState = {};
            var mergedTextConfig;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                (0, (0, parcelRequire("bahqM")).extend)(mergedState, state);
                if (state.textConfig) {
                    mergedTextConfig = mergedTextConfig || {};
                    (0, (0, parcelRequire("bahqM")).extend)(mergedTextConfig, state.textConfig);
                }
            }
            if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
            return mergedState;
        };
        Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            var needsRestoreToNormal = !(state && keepCurrentStates);
            if (state && state.textConfig) {
                this.textConfig = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
                (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, state.textConfig);
            } else if (needsRestoreToNormal) {
                if (normalState.textConfig) this.textConfig = normalState.textConfig;
            }
            var transitionTarget = {};
            var hasTransition = false;
            for(var i = 0; i < $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS.length; i++){
                var key = $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS[i];
                var propNeedsTransition = transition && $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP[key];
                if (state && state[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = state[key];
                    } else this[key] = state[key];
                } else if (needsRestoreToNormal) {
                    if (normalState[key] != null) {
                        if (propNeedsTransition) {
                            hasTransition = true;
                            transitionTarget[key] = normalState[key];
                        } else this[key] = normalState[key];
                    }
                }
            }
            if (!transition) for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var targetName = animator.targetName;
                animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
            }
            if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
        };
        Element.prototype._attachComponent = function(componentEl) {
            if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            if (componentEl === this) throw new Error('Recursive component attachment.');
            var zr = this.__zr;
            if (zr) componentEl.addSelfToZr(zr);
            componentEl.__zr = zr;
            componentEl.__hostTarget = this;
        };
        Element.prototype._detachComponent = function(componentEl) {
            if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
            componentEl.__zr = null;
            componentEl.__hostTarget = null;
        };
        Element.prototype.getClipPath = function() {
            return this._clipPath;
        };
        Element.prototype.setClipPath = function(clipPath) {
            if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
            this._attachComponent(clipPath);
            this._clipPath = clipPath;
            this.markRedraw();
        };
        Element.prototype.removeClipPath = function() {
            var clipPath = this._clipPath;
            if (clipPath) {
                this._detachComponent(clipPath);
                this._clipPath = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextContent = function() {
            return this._textContent;
        };
        Element.prototype.setTextContent = function(textEl) {
            var previousTextContent = this._textContent;
            if (previousTextContent === textEl) return;
            if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
            if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            textEl.innerTransformable = new (0, (0, parcelRequire("e6gef")).default)();
            this._attachComponent(textEl);
            this._textContent = textEl;
            this.markRedraw();
        };
        Element.prototype.setTextConfig = function(cfg) {
            if (!this.textConfig) this.textConfig = {};
            (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, cfg);
            this.markRedraw();
        };
        Element.prototype.removeTextConfig = function() {
            this.textConfig = null;
            this.markRedraw();
        };
        Element.prototype.removeTextContent = function() {
            var textEl = this._textContent;
            if (textEl) {
                textEl.innerTransformable = null;
                this._detachComponent(textEl);
                this._textContent = null;
                this._innerTextDefaultStyle = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextGuideLine = function() {
            return this._textGuide;
        };
        Element.prototype.setTextGuideLine = function(guideLine) {
            if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
            this._attachComponent(guideLine);
            this._textGuide = guideLine;
            this.markRedraw();
        };
        Element.prototype.removeTextGuideLine = function() {
            var textGuide = this._textGuide;
            if (textGuide) {
                this._detachComponent(textGuide);
                this._textGuide = null;
                this.markRedraw();
            }
        };
        Element.prototype.markRedraw = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var zr = this.__zr;
            if (zr) {
                if (this.__inHover) zr.refreshHover();
                else zr.refresh();
            }
            if (this.__hostTarget) this.__hostTarget.markRedraw();
        };
        Element.prototype.dirty = function() {
            this.markRedraw();
        };
        Element.prototype._toggleHoverLayerFlag = function(inHover) {
            this.__inHover = inHover;
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.__inHover = inHover;
            if (textGuide) textGuide.__inHover = inHover;
        };
        Element.prototype.addSelfToZr = function(zr) {
            if (this.__zr === zr) return;
            this.__zr = zr;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
            if (this._clipPath) this._clipPath.addSelfToZr(zr);
            if (this._textContent) this._textContent.addSelfToZr(zr);
            if (this._textGuide) this._textGuide.addSelfToZr(zr);
        };
        Element.prototype.removeSelfFromZr = function(zr) {
            if (!this.__zr) return;
            this.__zr = null;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
            if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
            if (this._textContent) this._textContent.removeSelfFromZr(zr);
            if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
        };
        Element.prototype.animate = function(key, loop) {
            var target = key ? this[key] : this;
            if (!target) {
                (0, (0, parcelRequire("bahqM")).logError)('Property "' + key + '" is not existed in element ' + this.id);
                return;
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, loop);
            this.addAnimator(animator, key);
            return animator;
        };
        Element.prototype.addAnimator = function(animator, key) {
            var zr = this.__zr;
            var el = this;
            animator.during(function() {
                el.updateDuringAnimation(key);
            }).done(function() {
                var animators = el.animators;
                var idx = (0, (0, parcelRequire("bahqM")).indexOf)(animators, animator);
                if (idx >= 0) animators.splice(idx, 1);
            });
            this.animators.push(animator);
            if (zr) zr.animation.addAnimator(animator);
            zr && zr.wakeUp();
        };
        Element.prototype.updateDuringAnimation = function(key) {
            this.markRedraw();
        };
        Element.prototype.stopAnimation = function(scope, forwardToLast) {
            var animators = this.animators;
            var len = animators.length;
            var leftAnimators = [];
            for(var i = 0; i < len; i++){
                var animator = animators[i];
                if (!scope || scope === animator.scope) animator.stop(forwardToLast);
                else leftAnimators.push(animator);
            }
            this.animators = leftAnimators;
            return this;
        };
        Element.prototype.animateTo = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
        };
        Element.prototype.animateFrom = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps, true);
        };
        Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
            var animators = $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
            for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
        };
        Element.prototype.getBoundingRect = function() {
            return null;
        };
        Element.prototype.getPaintRect = function() {
            return null;
        };
        Element.initDefaultProps = function() {
            var elProto = Element.prototype;
            elProto.type = 'element';
            elProto.name = '';
            elProto.ignore = false;
            elProto.silent = false;
            elProto.isGroup = false;
            elProto.draggable = false;
            elProto.dragging = false;
            elProto.ignoreClip = false;
            elProto.__inHover = false;
            elProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var logs = {};
            function logDeprecatedError(key, xKey, yKey) {
                if (!logs[key + xKey + yKey]) {
                    console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                    logs[key + xKey + yKey] = true;
                }
            }
            function createLegacyProperty(key, privateKey, xKey, yKey) {
                Object.defineProperty(elProto, key, {
                    get: function() {
                        logDeprecatedError(key, xKey, yKey);
                        if (!this[privateKey]) {
                            var pos = this[privateKey] = [];
                            enhanceArray(this, pos);
                        }
                        return this[privateKey];
                    },
                    set: function(pos) {
                        logDeprecatedError(key, xKey, yKey);
                        this[xKey] = pos[0];
                        this[yKey] = pos[1];
                        this[privateKey] = pos;
                        enhanceArray(this, pos);
                    }
                });
                function enhanceArray(self, pos) {
                    Object.defineProperty(pos, 0, {
                        get: function() {
                            return self[xKey];
                        },
                        set: function(val) {
                            self[xKey] = val;
                        }
                    });
                    Object.defineProperty(pos, 1, {
                        get: function() {
                            return self[yKey];
                        },
                        set: function(val) {
                            self[yKey] = val;
                        }
                    });
                }
            }
            if (Object.defineProperty && (!(0, (0, parcelRequire("hZfwb")).default).browser.ie || (0, (0, parcelRequire("hZfwb")).default).browser.version > 8)) {
                createLegacyProperty('position', '_legacyPos', 'x', 'y');
                createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
                createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
            }
        }();
        return Element;
    }();
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("bRKv5")).default));
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("e6gef")).default));
    function $5a5931cff6ff005a$var$animateTo(animatable, target, cfg, animationProps, reverse) {
        cfg = cfg || {};
        var animators = [];
        $5a5931cff6ff005a$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
        var finishCount = animators.length;
        var doneHappened = false;
        var cfgDone = cfg.done;
        var cfgAborted = cfg.aborted;
        var doneCb = function() {
            doneHappened = true;
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        var abortedCb = function() {
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        if (!finishCount) cfgDone && cfgDone();
        if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
            cfg.during(percent);
        });
        for(var i = 0; i < animators.length; i++){
            var animator = animators[i];
            if (doneCb) animator.done(doneCb);
            if (abortedCb) animator.aborted(abortedCb);
            animator.start(cfg.easing, cfg.force);
        }
        return animators;
    }
    function $5a5931cff6ff005a$var$copyArrShallow(source, target, len) {
        for(var i = 0; i < len; i++)source[i] = target[i];
    }
    function $5a5931cff6ff005a$var$is2DArray(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value[0]);
    }
    function $5a5931cff6ff005a$var$copyValue(target, source, key) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(source[key])) {
            if (!(0, (0, parcelRequire("bahqM")).isArrayLike)(target[key])) target[key] = [];
            if ((0, (0, parcelRequire("bahqM")).isTypedArray)(source[key])) {
                var len = source[key].length;
                if (target[key].length !== len) {
                    target[key] = new source[key].constructor(len);
                    $5a5931cff6ff005a$var$copyArrShallow(target[key], source[key], len);
                }
            } else {
                var sourceArr = source[key];
                var targetArr = target[key];
                var len0 = sourceArr.length;
                if ($5a5931cff6ff005a$var$is2DArray(sourceArr)) {
                    var len1 = sourceArr[0].length;
                    for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                    else $5a5931cff6ff005a$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
                } else $5a5931cff6ff005a$var$copyArrShallow(targetArr, sourceArr, len0);
                targetArr.length = sourceArr.length;
            }
        } else target[key] = source[key];
    }
    function $5a5931cff6ff005a$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
        var animatableKeys = [];
        var changedKeys = [];
        var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(target);
        var duration = cfg.duration;
        var delay = cfg.delay;
        var additive = cfg.additive;
        var setToFinal = cfg.setToFinal;
        var animateAll = !(0, (0, parcelRequire("bahqM")).isObject)(animationProps);
        for(var k = 0; k < targetKeys.length; k++){
            var innerKey = targetKeys[k];
            if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
                if ((0, (0, parcelRequire("bahqM")).isObject)(target[innerKey]) && !(0, (0, parcelRequire("bahqM")).isArrayLike)(target[innerKey])) {
                    if (topKey) {
                        if (!reverse) {
                            source[innerKey] = target[innerKey];
                            animatable.updateDuringAnimation(topKey);
                        }
                        continue;
                    }
                    $5a5931cff6ff005a$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
                } else {
                    animatableKeys.push(innerKey);
                    changedKeys.push(innerKey);
                }
            } else if (!reverse) {
                source[innerKey] = target[innerKey];
                animatable.updateDuringAnimation(topKey);
                changedKeys.push(innerKey);
            }
        }
        var keyLen = animatableKeys.length;
        if (keyLen > 0 || cfg.force && !animators.length) {
            var existsAnimators = animatable.animators;
            var existsAnimatorsOnSameTarget = [];
            for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
            if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
                var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
                if (allAborted) {
                    var idx = (0, (0, parcelRequire("bahqM")).indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                    existsAnimators.splice(idx, 1);
                }
            }
            var revertedSource = void 0;
            var reversedTarget = void 0;
            var sourceClone = void 0;
            if (reverse) {
                reversedTarget = {};
                if (setToFinal) revertedSource = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    reversedTarget[innerKey] = source[innerKey];
                    if (setToFinal) revertedSource[innerKey] = target[innerKey];
                    else source[innerKey] = target[innerKey];
                }
            } else if (setToFinal) {
                sourceClone = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    sourceClone[innerKey] = (0, (0, parcelRequire("hb2y5")).cloneValue)(source[innerKey]);
                    $5a5931cff6ff005a$var$copyValue(source, target, innerKey);
                }
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
            animator.targetName = topKey;
            if (cfg.scope) animator.scope = cfg.scope;
            if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
            if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
            animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
            animatable.addAnimator(animator, topKey);
            animators.push(animator);
        }
    }
    var $5a5931cff6ff005a$export$2e2bcd8739ae039 = $5a5931cff6ff005a$var$Element;
});
parcelRegister("e6gef", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a43e36ee3f294c25$export$2e2bcd8739ae039);
    var $izqgC;
    var $eLEew;
    var $a43e36ee3f294c25$var$mIdentity = (0, parcelRequire("izqgC")).identity;
    var $a43e36ee3f294c25$var$EPSILON = 5e-5;
    function $a43e36ee3f294c25$var$isNotAroundZero(val) {
        return val > $a43e36ee3f294c25$var$EPSILON || val < -$a43e36ee3f294c25$var$EPSILON;
    }
    var $a43e36ee3f294c25$var$scaleTmp = [];
    var $a43e36ee3f294c25$var$tmpTransform = [];
    var $a43e36ee3f294c25$var$originTransform = (0, parcelRequire("izqgC")).create();
    var $a43e36ee3f294c25$var$abs = Math.abs;
    var $a43e36ee3f294c25$var$Transformable = function() {
        function Transformable() {}
        Transformable.prototype.getLocalTransform = function(m) {
            return Transformable.getLocalTransform(this, m);
        };
        Transformable.prototype.setPosition = function(arr) {
            this.x = arr[0];
            this.y = arr[1];
        };
        Transformable.prototype.setScale = function(arr) {
            this.scaleX = arr[0];
            this.scaleY = arr[1];
        };
        Transformable.prototype.setSkew = function(arr) {
            this.skewX = arr[0];
            this.skewY = arr[1];
        };
        Transformable.prototype.setOrigin = function(arr) {
            this.originX = arr[0];
            this.originY = arr[1];
        };
        Transformable.prototype.needLocalTransform = function() {
            return $a43e36ee3f294c25$var$isNotAroundZero(this.rotation) || $a43e36ee3f294c25$var$isNotAroundZero(this.x) || $a43e36ee3f294c25$var$isNotAroundZero(this.y) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleX - 1) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleY - 1);
        };
        Transformable.prototype.updateTransform = function() {
            var parentTransform = this.parent && this.parent.transform;
            var needLocalTransform = this.needLocalTransform();
            var m = this.transform;
            if (!(needLocalTransform || parentTransform)) {
                m && $a43e36ee3f294c25$var$mIdentity(m);
                return;
            }
            m = m || (0, parcelRequire("izqgC")).create();
            if (needLocalTransform) this.getLocalTransform(m);
            else $a43e36ee3f294c25$var$mIdentity(m);
            if (parentTransform) {
                if (needLocalTransform) (0, parcelRequire("izqgC")).mul(m, parentTransform, m);
                else (0, parcelRequire("izqgC")).copy(m, parentTransform);
            }
            this.transform = m;
            this._resolveGlobalScaleRatio(m);
        };
        Transformable.prototype._resolveGlobalScaleRatio = function(m) {
            var globalScaleRatio = this.globalScaleRatio;
            if (globalScaleRatio != null && globalScaleRatio !== 1) {
                this.getGlobalScale($a43e36ee3f294c25$var$scaleTmp);
                var relX = $a43e36ee3f294c25$var$scaleTmp[0] < 0 ? -1 : 1;
                var relY = $a43e36ee3f294c25$var$scaleTmp[1] < 0 ? -1 : 1;
                var sx = (($a43e36ee3f294c25$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a43e36ee3f294c25$var$scaleTmp[0] || 0;
                var sy = (($a43e36ee3f294c25$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a43e36ee3f294c25$var$scaleTmp[1] || 0;
                m[0] *= sx;
                m[1] *= sx;
                m[2] *= sy;
                m[3] *= sy;
            }
            this.invTransform = this.invTransform || (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).invert(this.invTransform, m);
        };
        Transformable.prototype.getComputedTransform = function() {
            var transformNode = this;
            var ancestors = [];
            while(transformNode){
                ancestors.push(transformNode);
                transformNode = transformNode.parent;
            }
            while(transformNode = ancestors.pop())transformNode.updateTransform();
            return this.transform;
        };
        Transformable.prototype.setLocalTransform = function(m) {
            if (!m) return;
            var sx = m[0] * m[0] + m[1] * m[1];
            var sy = m[2] * m[2] + m[3] * m[3];
            var rotation = Math.atan2(m[1], m[0]);
            var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
            sy = Math.sqrt(sy) * Math.cos(shearX);
            sx = Math.sqrt(sx);
            this.skewX = shearX;
            this.skewY = 0;
            this.rotation = -rotation;
            this.x = +m[4];
            this.y = +m[5];
            this.scaleX = sx;
            this.scaleY = sy;
            this.originX = 0;
            this.originY = 0;
        };
        Transformable.prototype.decomposeTransform = function() {
            if (!this.transform) return;
            var parent = this.parent;
            var m = this.transform;
            if (parent && parent.transform) {
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, parent.invTransform, m);
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            var ox = this.originX;
            var oy = this.originY;
            if (ox || oy) {
                $a43e36ee3f294c25$var$originTransform[4] = ox;
                $a43e36ee3f294c25$var$originTransform[5] = oy;
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, m, $a43e36ee3f294c25$var$originTransform);
                $a43e36ee3f294c25$var$tmpTransform[4] -= ox;
                $a43e36ee3f294c25$var$tmpTransform[5] -= oy;
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            this.setLocalTransform(m);
        };
        Transformable.prototype.getGlobalScale = function(out) {
            var m = this.transform;
            out = out || [];
            if (!m) {
                out[0] = 1;
                out[1] = 1;
                return out;
            }
            out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
            out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
            if (m[0] < 0) out[0] = -out[0];
            if (m[3] < 0) out[1] = -out[1];
            return out;
        };
        Transformable.prototype.transformCoordToLocal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var invTransform = this.invTransform;
            if (invTransform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, invTransform);
            return v2;
        };
        Transformable.prototype.transformCoordToGlobal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var transform = this.transform;
            if (transform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, transform);
            return v2;
        };
        Transformable.prototype.getLineScale = function() {
            var m = this.transform;
            return m && $a43e36ee3f294c25$var$abs(m[0] - 1) > 1e-10 && $a43e36ee3f294c25$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a43e36ee3f294c25$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
        };
        Transformable.prototype.copyTransform = function(source) {
            var target = this;
            for(var i = 0; i < $a43e36ee3f294c25$export$98ab6203ec3396e2.length; i++){
                var propName = $a43e36ee3f294c25$export$98ab6203ec3396e2[i];
                target[propName] = source[propName];
            }
        };
        Transformable.getLocalTransform = function(target, m) {
            m = m || [];
            var ox = target.originX || 0;
            var oy = target.originY || 0;
            var sx = target.scaleX;
            var sy = target.scaleY;
            var rotation = target.rotation || 0;
            var x = target.x;
            var y = target.y;
            var skewX = target.skewX ? Math.tan(target.skewX) : 0;
            var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
            if (ox || oy) {
                m[4] = -ox * sx - skewX * oy * sy;
                m[5] = -oy * sy - skewY * ox * sx;
            } else m[4] = m[5] = 0;
            m[0] = sx;
            m[3] = sy;
            m[1] = skewY * sx;
            m[2] = skewX * sy;
            rotation && (0, parcelRequire("izqgC")).rotate(m, m, rotation);
            m[4] += ox + x;
            m[5] += oy + y;
            return m;
        };
        Transformable.initDefaultProps = function() {
            var proto = Transformable.prototype;
            proto.x = 0;
            proto.y = 0;
            proto.scaleX = 1;
            proto.scaleY = 1;
            proto.originX = 0;
            proto.originY = 0;
            proto.skewX = 0;
            proto.skewY = 0;
            proto.rotation = 0;
            proto.globalScaleRatio = 1;
        }();
        return Transformable;
    }();
    var $a43e36ee3f294c25$export$98ab6203ec3396e2 = [
        'x',
        'y',
        'originX',
        'originY',
        'rotation',
        'scaleX',
        'scaleY',
        'skewX',
        'skewY'
    ];
    var $a43e36ee3f294c25$export$2e2bcd8739ae039 = $a43e36ee3f294c25$var$Transformable;
});
parcelRegister("eLEew", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$ac04a9f644701697$export$185802fd694ee1f5);
    $parcel$export(module.exports, "copy", ()=>$ac04a9f644701697$export$784d13d8ee351f07);
    $parcel$export(module.exports, "clone", ()=>$ac04a9f644701697$export$9cd59f9826255e47);
    $parcel$export(module.exports, "set", ()=>$ac04a9f644701697$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "add", ()=>$ac04a9f644701697$export$e16d8520af44a096);
    $parcel$export(module.exports, "scaleAndAdd", ()=>$ac04a9f644701697$export$19cedf1da84ba854);
    $parcel$export(module.exports, "sub", ()=>$ac04a9f644701697$export$f93b5905241a7cca);
    $parcel$export(module.exports, "len", ()=>$ac04a9f644701697$export$fc1400facf92c78);
    $parcel$export(module.exports, "lenSquare", ()=>$ac04a9f644701697$export$48e33bc611e4c25a);
    $parcel$export(module.exports, "length", ()=>$ac04a9f644701697$export$f24224f1c91d8156);
    $parcel$export(module.exports, "lengthSquare", ()=>$ac04a9f644701697$export$2f106540dd9a5136);
    $parcel$export(module.exports, "mul", ()=>$ac04a9f644701697$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "div", ()=>$ac04a9f644701697$export$159d9494db57879b);
    $parcel$export(module.exports, "dot", ()=>$ac04a9f644701697$export$94132a0e348806d4);
    $parcel$export(module.exports, "scale", ()=>$ac04a9f644701697$export$dcdf75081b88279d);
    $parcel$export(module.exports, "normalize", ()=>$ac04a9f644701697$export$a3295358bff77e);
    $parcel$export(module.exports, "distance", ()=>$ac04a9f644701697$export$9f17032d917177de);
    $parcel$export(module.exports, "dist", ()=>$ac04a9f644701697$export$6c4a311cc157c764);
    $parcel$export(module.exports, "distanceSquare", ()=>$ac04a9f644701697$export$137c0a69d1ff4a79);
    $parcel$export(module.exports, "distSquare", ()=>$ac04a9f644701697$export$c68db45a034c13b0);
    $parcel$export(module.exports, "negate", ()=>$ac04a9f644701697$export$aef51622e549b8b0);
    $parcel$export(module.exports, "lerp", ()=>$ac04a9f644701697$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "applyTransform", ()=>$ac04a9f644701697$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "min", ()=>$ac04a9f644701697$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$ac04a9f644701697$export$8960430cfd85939f);
    function $ac04a9f644701697$export$185802fd694ee1f5(x, y) {
        if (x == null) x = 0;
        if (y == null) y = 0;
        return [
            x,
            y
        ];
    }
    function $ac04a9f644701697$export$784d13d8ee351f07(out, v) {
        out[0] = v[0];
        out[1] = v[1];
        return out;
    }
    function $ac04a9f644701697$export$9cd59f9826255e47(v) {
        return [
            v[0],
            v[1]
        ];
    }
    function $ac04a9f644701697$export$adaa4cf7ef1b65be(out, a, b) {
        out[0] = a;
        out[1] = b;
        return out;
    }
    function $ac04a9f644701697$export$e16d8520af44a096(out, v1, v2) {
        out[0] = v1[0] + v2[0];
        out[1] = v1[1] + v2[1];
        return out;
    }
    function $ac04a9f644701697$export$19cedf1da84ba854(out, v1, v2, a) {
        out[0] = v1[0] + v2[0] * a;
        out[1] = v1[1] + v2[1] * a;
        return out;
    }
    function $ac04a9f644701697$export$f93b5905241a7cca(out, v1, v2) {
        out[0] = v1[0] - v2[0];
        out[1] = v1[1] - v2[1];
        return out;
    }
    function $ac04a9f644701697$export$fc1400facf92c78(v) {
        return Math.sqrt($ac04a9f644701697$export$48e33bc611e4c25a(v));
    }
    var $ac04a9f644701697$export$f24224f1c91d8156 = $ac04a9f644701697$export$fc1400facf92c78;
    function $ac04a9f644701697$export$48e33bc611e4c25a(v) {
        return v[0] * v[0] + v[1] * v[1];
    }
    var $ac04a9f644701697$export$2f106540dd9a5136 = $ac04a9f644701697$export$48e33bc611e4c25a;
    function $ac04a9f644701697$export$6e3a27864ab166fe(out, v1, v2) {
        out[0] = v1[0] * v2[0];
        out[1] = v1[1] * v2[1];
        return out;
    }
    function $ac04a9f644701697$export$159d9494db57879b(out, v1, v2) {
        out[0] = v1[0] / v2[0];
        out[1] = v1[1] / v2[1];
        return out;
    }
    function $ac04a9f644701697$export$94132a0e348806d4(v1, v2) {
        return v1[0] * v2[0] + v1[1] * v2[1];
    }
    function $ac04a9f644701697$export$dcdf75081b88279d(out, v, s) {
        out[0] = v[0] * s;
        out[1] = v[1] * s;
        return out;
    }
    function $ac04a9f644701697$export$a3295358bff77e(out, v) {
        var d = $ac04a9f644701697$export$fc1400facf92c78(v);
        if (d === 0) {
            out[0] = 0;
            out[1] = 0;
        } else {
            out[0] = v[0] / d;
            out[1] = v[1] / d;
        }
        return out;
    }
    function $ac04a9f644701697$export$9f17032d917177de(v1, v2) {
        return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
    }
    var $ac04a9f644701697$export$6c4a311cc157c764 = $ac04a9f644701697$export$9f17032d917177de;
    function $ac04a9f644701697$export$137c0a69d1ff4a79(v1, v2) {
        return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
    }
    var $ac04a9f644701697$export$c68db45a034c13b0 = $ac04a9f644701697$export$137c0a69d1ff4a79;
    function $ac04a9f644701697$export$aef51622e549b8b0(out, v) {
        out[0] = -v[0];
        out[1] = -v[1];
        return out;
    }
    function $ac04a9f644701697$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
        out[0] = v1[0] + t * (v2[0] - v1[0]);
        out[1] = v1[1] + t * (v2[1] - v1[1]);
        return out;
    }
    function $ac04a9f644701697$export$9f9dcb98c894b623(out, v, m) {
        var x = v[0];
        var y = v[1];
        out[0] = m[0] * x + m[2] * y + m[4];
        out[1] = m[1] * x + m[3] * y + m[5];
        return out;
    }
    function $ac04a9f644701697$export$96ec731ed4dcb222(out, v1, v2) {
        out[0] = Math.min(v1[0], v2[0]);
        out[1] = Math.min(v1[1], v2[1]);
        return out;
    }
    function $ac04a9f644701697$export$8960430cfd85939f(out, v1, v2) {
        out[0] = Math.max(v1[0], v2[0]);
        out[1] = Math.max(v1[1], v2[1]);
        return out;
    }
});
parcelRegister("hb2y5", function(module, exports) {
    $parcel$export(module.exports, "interpolateNumber", ()=>$c81570e1f313cc39$export$d871d53bd7eeb390);
    $parcel$export(module.exports, "cloneValue", ()=>$c81570e1f313cc39$export$c5e92b7f105af84e);
    $parcel$export(module.exports, "default", ()=>$c81570e1f313cc39$export$2e2bcd8739ae039);
    var $kj9w6;
    var $d6udH;
    var $bahqM;
    var $c81570e1f313cc39$var$arraySlice = Array.prototype.slice;
    function $c81570e1f313cc39$export$d871d53bd7eeb390(p0, p1, percent) {
        return (p1 - p0) * percent + p0;
    }
    function $c81570e1f313cc39$export$35d34bc0ed591a92(p0, p1, percent) {
        return percent > 0.5 ? p1 : p0;
    }
    function $c81570e1f313cc39$export$f8938d924b05a6eb(out, p0, p1, percent) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i], p1[i], percent);
    }
    function $c81570e1f313cc39$export$3297a85eaaa37024(out, p0, p1, percent) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
        }
    }
    function $c81570e1f313cc39$var$add1DArray(out, p0, p1, sign) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
        return out;
    }
    function $c81570e1f313cc39$var$add2DArray(out, p0, p1, sign) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
        }
        return out;
    }
    function $c81570e1f313cc39$var$fillArray(val0, val1, arrDim) {
        var arr0 = val0;
        var arr1 = val1;
        if (!arr0.push || !arr1.push) return;
        var arr0Len = arr0.length;
        var arr1Len = arr1.length;
        if (arr0Len !== arr1Len) {
            var isPreviousLarger = arr0Len > arr1Len;
            if (isPreviousLarger) arr0.length = arr1Len;
            else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $c81570e1f313cc39$var$arraySlice.call(arr1[i]));
        }
        var len2 = arr0[0] && arr0[0].length;
        for(var i = 0; i < arr0.length; i++){
            if (arrDim === 1) {
                if (isNaN(arr0[i])) arr0[i] = arr1[i];
            } else {
                for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
            }
        }
    }
    function $c81570e1f313cc39$var$is1DArraySame(arr0, arr1) {
        var len = arr0.length;
        if (len !== arr1.length) return false;
        for(var i = 0; i < len; i++){
            if (arr0[i] !== arr1[i]) return false;
        }
        return true;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        var len2 = p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[1] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
        }
    }
    function $c81570e1f313cc39$export$c5e92b7f105af84e(value) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
            var len = value.length;
            if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value[0])) {
                var ret = [];
                for(var i = 0; i < len; i++)ret.push($c81570e1f313cc39$var$arraySlice.call(value[i]));
                return ret;
            }
            return $c81570e1f313cc39$var$arraySlice.call(value);
        }
        return value;
    }
    function $c81570e1f313cc39$var$rgba2String(rgba) {
        rgba[0] = Math.floor(rgba[0]);
        rgba[1] = Math.floor(rgba[1]);
        rgba[2] = Math.floor(rgba[2]);
        return 'rgba(' + rgba.join(',') + ')';
    }
    function $c81570e1f313cc39$var$guessArrayDim(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value && value[0]) ? 2 : 1;
    }
    var $c81570e1f313cc39$var$tmpRgba = [
        0,
        0,
        0,
        0
    ];
    var $c81570e1f313cc39$var$Track = function() {
        function Track(propName) {
            this.keyframes = [];
            this.maxTime = 0;
            this.arrDim = 0;
            this.interpolable = true;
            this._needsSort = false;
            this._isAllValueEqual = true;
            this._lastFrame = 0;
            this._lastFramePercent = 0;
            this.propName = propName;
        }
        Track.prototype.isFinished = function() {
            return this._finished;
        };
        Track.prototype.setFinished = function() {
            this._finished = true;
            if (this._additiveTrack) this._additiveTrack.setFinished();
        };
        Track.prototype.needsAnimate = function() {
            return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
        };
        Track.prototype.getAdditiveTrack = function() {
            return this._additiveTrack;
        };
        Track.prototype.addKeyframe = function(time, value) {
            if (time >= this.maxTime) this.maxTime = time;
            else this._needsSort = true;
            var keyframes = this.keyframes;
            var len = keyframes.length;
            if (this.interpolable) {
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
                    var arrayDim = $c81570e1f313cc39$var$guessArrayDim(value);
                    if (len > 0 && this.arrDim !== arrayDim) {
                        this.interpolable = false;
                        return;
                    }
                    if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                        this.interpolable = false;
                        return;
                    }
                    if (len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this._isAllValueEqual) {
                            if (arrayDim === 1) {
                                if (!$c81570e1f313cc39$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                            } else this._isAllValueEqual = false;
                        }
                    }
                    this.arrDim = arrayDim;
                } else {
                    if (this.arrDim > 0) {
                        this.interpolable = false;
                        return;
                    }
                    if (typeof value === 'string') {
                        var colorArray = (0, parcelRequire("d6udH")).parse(value);
                        if (colorArray) {
                            value = colorArray;
                            this.isValueColor = true;
                        } else this.interpolable = false;
                    } else if (typeof value !== 'number' || isNaN(value)) {
                        this.interpolable = false;
                        return;
                    }
                    if (this._isAllValueEqual && len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this.isValueColor && !$c81570e1f313cc39$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                        else if (lastFrame.value !== value) this._isAllValueEqual = false;
                    }
                }
            }
            var kf = {
                time: time,
                value: value,
                percent: 0
            };
            this.keyframes.push(kf);
            return kf;
        };
        Track.prototype.prepare = function(additiveTrack) {
            var kfs = this.keyframes;
            if (this._needsSort) kfs.sort(function(a, b) {
                return a.time - b.time;
            });
            var arrDim = this.arrDim;
            var kfsLen = kfs.length;
            var lastKf = kfs[kfsLen - 1];
            for(var i = 0; i < kfsLen; i++){
                kfs[i].percent = kfs[i].time / this.maxTime;
                if (arrDim > 0 && i !== kfsLen - 1) $c81570e1f313cc39$var$fillArray(kfs[i].value, lastKf.value, arrDim);
            }
            if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
                this._additiveTrack = additiveTrack;
                var startValue = kfs[0].value;
                for(var i = 0; i < kfsLen; i++){
                    if (arrDim === 0) {
                        if (this.isValueColor) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                        else kfs[i].additiveValue = kfs[i].value - startValue;
                    } else if (arrDim === 1) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                    else if (arrDim === 2) kfs[i].additiveValue = $c81570e1f313cc39$var$add2DArray([], kfs[i].value, startValue, -1);
                }
            }
        };
        Track.prototype.step = function(target, percent) {
            if (this._finished) return;
            if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
            var isAdditive = this._additiveTrack != null;
            var valueKey = isAdditive ? 'additiveValue' : 'value';
            var keyframes = this.keyframes;
            var kfsNum = this.keyframes.length;
            var propName = this.propName;
            var arrDim = this.arrDim;
            var isValueColor = this.isValueColor;
            var frameIdx;
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFramePercent) {
                var start = Math.min(this._lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = Math.min(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
            }
            var nextFrame = keyframes[frameIdx + 1];
            var frame = keyframes[frameIdx];
            if (!(frame && nextFrame)) return;
            this._lastFrame = frameIdx;
            this._lastFramePercent = percent;
            var range = nextFrame.percent - frame.percent;
            if (range === 0) return;
            var w = (percent - frame.percent) / range;
            var targetArr = isAdditive ? this._additiveValue : isValueColor ? $c81570e1f313cc39$var$tmpRgba : target[propName];
            if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
            if (this.useSpline) {
                var p1 = keyframes[frameIdx][valueKey];
                var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
                var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
                var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $c81570e1f313cc39$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                else if (isValueColor) {
                    $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = p2;
                    else value = $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            } else {
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $c81570e1f313cc39$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
                else if (isValueColor) {
                    $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = $c81570e1f313cc39$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                    else value = $c81570e1f313cc39$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            }
            if (isAdditive) this._addToTarget(target);
        };
        Track.prototype._addToTarget = function(target) {
            var arrDim = this.arrDim;
            var propName = this.propName;
            var additiveValue = this._additiveValue;
            if (arrDim === 0) {
                if (this.isValueColor) {
                    (0, parcelRequire("d6udH")).parse(target[propName], $c81570e1f313cc39$var$tmpRgba);
                    $c81570e1f313cc39$var$add1DArray($c81570e1f313cc39$var$tmpRgba, $c81570e1f313cc39$var$tmpRgba, additiveValue, 1);
                    target[propName] = $c81570e1f313cc39$var$rgba2String($c81570e1f313cc39$var$tmpRgba);
                } else target[propName] = target[propName] + additiveValue;
            } else if (arrDim === 1) $c81570e1f313cc39$var$add1DArray(target[propName], target[propName], additiveValue, 1);
            else if (arrDim === 2) $c81570e1f313cc39$var$add2DArray(target[propName], target[propName], additiveValue, 1);
        };
        return Track;
    }();
    var $c81570e1f313cc39$var$Animator = function() {
        function Animator(target, loop, additiveTo) {
            this._tracks = {};
            this._trackKeys = [];
            this._delay = 0;
            this._maxTime = 0;
            this._paused = false;
            this._started = 0;
            this._clip = null;
            this._target = target;
            this._loop = loop;
            if (loop && additiveTo) {
                (0, (0, parcelRequire("bahqM")).logError)('Can\' use additive animation on looped animation.');
                return;
            }
            this._additiveAnimators = additiveTo;
        }
        Animator.prototype.getTarget = function() {
            return this._target;
        };
        Animator.prototype.changeTarget = function(target) {
            this._target = target;
        };
        Animator.prototype.when = function(time, props) {
            return this.whenWithKeys(time, props, (0, (0, parcelRequire("bahqM")).keys)(props));
        };
        Animator.prototype.whenWithKeys = function(time, props, propNames) {
            var tracks = this._tracks;
            for(var i = 0; i < propNames.length; i++){
                var propName = propNames[i];
                var track = tracks[propName];
                if (!track) {
                    track = tracks[propName] = new $c81570e1f313cc39$var$Track(propName);
                    var initialValue = void 0;
                    var additiveTrack = this._getAdditiveTrack(propName);
                    if (additiveTrack) {
                        var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                        initialValue = lastFinalKf && lastFinalKf.value;
                        if (additiveTrack.isValueColor && initialValue) initialValue = $c81570e1f313cc39$var$rgba2String(initialValue);
                    } else initialValue = this._target[propName];
                    if (initialValue == null) continue;
                    if (time !== 0) track.addKeyframe(0, $c81570e1f313cc39$export$c5e92b7f105af84e(initialValue));
                    this._trackKeys.push(propName);
                }
                track.addKeyframe(time, $c81570e1f313cc39$export$c5e92b7f105af84e(props[propName]));
            }
            this._maxTime = Math.max(this._maxTime, time);
            return this;
        };
        Animator.prototype.pause = function() {
            this._clip.pause();
            this._paused = true;
        };
        Animator.prototype.resume = function() {
            this._clip.resume();
            this._paused = false;
        };
        Animator.prototype.isPaused = function() {
            return !!this._paused;
        };
        Animator.prototype._doneCallback = function() {
            this._setTracksFinished();
            this._clip = null;
            var doneList = this._doneCbs;
            if (doneList) {
                var len = doneList.length;
                for(var i = 0; i < len; i++)doneList[i].call(this);
            }
        };
        Animator.prototype._abortedCallback = function() {
            this._setTracksFinished();
            var animation = this.animation;
            var abortedList = this._abortedCbs;
            if (animation) animation.removeClip(this._clip);
            this._clip = null;
            if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
        };
        Animator.prototype._setTracksFinished = function() {
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
        };
        Animator.prototype._getAdditiveTrack = function(trackName) {
            var additiveTrack;
            var additiveAnimators = this._additiveAnimators;
            if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
                var track = additiveAnimators[i].getTrack(trackName);
                if (track) additiveTrack = track;
            }
            return additiveTrack;
        };
        Animator.prototype.start = function(easing, forceAnimate) {
            if (this._started > 0) return;
            this._started = 1;
            var self = this;
            var tracks = [];
            for(var i = 0; i < this._trackKeys.length; i++){
                var propName = this._trackKeys[i];
                var track = this._tracks[propName];
                var additiveTrack = this._getAdditiveTrack(propName);
                var kfs = track.keyframes;
                track.prepare(additiveTrack);
                if (track.needsAnimate()) tracks.push(track);
                else if (!track.interpolable) {
                    var lastKf = kfs[kfs.length - 1];
                    if (lastKf) self._target[track.propName] = lastKf.value;
                }
            }
            if (tracks.length || forceAnimate) {
                var clip = new (0, (0, parcelRequire("kj9w6")).default)({
                    life: this._maxTime,
                    loop: this._loop,
                    delay: this._delay,
                    onframe: function(percent) {
                        self._started = 2;
                        var additiveAnimators = self._additiveAnimators;
                        if (additiveAnimators) {
                            var stillHasAdditiveAnimator = false;
                            for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                                stillHasAdditiveAnimator = true;
                                break;
                            }
                            if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                        }
                        for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                        var onframeList = self._onframeCbs;
                        if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                    },
                    ondestroy: function() {
                        self._doneCallback();
                    }
                });
                this._clip = clip;
                if (this.animation) this.animation.addClip(clip);
                if (easing && easing !== 'spline') clip.easing = easing;
            } else this._doneCallback();
            return this;
        };
        Animator.prototype.stop = function(forwardToLast) {
            if (!this._clip) return;
            var clip = this._clip;
            if (forwardToLast) clip.onframe(1);
            this._abortedCallback();
        };
        Animator.prototype.delay = function(time) {
            this._delay = time;
            return this;
        };
        Animator.prototype.during = function(cb) {
            if (cb) {
                if (!this._onframeCbs) this._onframeCbs = [];
                this._onframeCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.done = function(cb) {
            if (cb) {
                if (!this._doneCbs) this._doneCbs = [];
                this._doneCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.aborted = function(cb) {
            if (cb) {
                if (!this._abortedCbs) this._abortedCbs = [];
                this._abortedCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.getClip = function() {
            return this._clip;
        };
        Animator.prototype.getTrack = function(propName) {
            return this._tracks[propName];
        };
        Animator.prototype.stopTracks = function(propNames, forwardToLast) {
            if (!propNames.length || !this._clip) return true;
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < propNames.length; i++){
                var track = tracks[propNames[i]];
                if (track) {
                    if (forwardToLast) track.step(this._target, 1);
                    else if (this._started === 1) track.step(this._target, 0);
                    track.setFinished();
                }
            }
            var allAborted = true;
            for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
                allAborted = false;
                break;
            }
            if (allAborted) this._abortedCallback();
            return allAborted;
        };
        Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
            if (!target) return;
            trackKeys = trackKeys || this._trackKeys;
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track || track.isFinished()) continue;
                var kfs = track.keyframes;
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) {
                    var val = $c81570e1f313cc39$export$c5e92b7f105af84e(lastKf.value);
                    if (track.isValueColor) val = $c81570e1f313cc39$var$rgba2String(val);
                    target[propName] = val;
                }
            }
        };
        Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
            trackKeys = trackKeys || (0, (0, parcelRequire("bahqM")).keys)(finalProps);
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track) continue;
                var kfs = track.keyframes;
                if (kfs.length > 1) {
                    var lastKf = kfs.pop();
                    track.addKeyframe(lastKf.time, finalProps[propName]);
                    track.prepare(track.getAdditiveTrack());
                }
            }
        };
        return Animator;
    }();
    var $c81570e1f313cc39$export$2e2bcd8739ae039 = $c81570e1f313cc39$var$Animator;
});
parcelRegister("kj9w6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec8cf6d19967f888$export$2e2bcd8739ae039);
    var $2yJbE;
    var $ec8cf6d19967f888$var$Clip = function() {
        function Clip(opts) {
            this._initialized = false;
            this._startTime = 0;
            this._pausedTime = 0;
            this._paused = false;
            this._life = opts.life || 1000;
            this._delay = opts.delay || 0;
            this.loop = opts.loop == null ? false : opts.loop;
            this.gap = opts.gap || 0;
            this.easing = opts.easing || 'linear';
            this.onframe = opts.onframe;
            this.ondestroy = opts.ondestroy;
            this.onrestart = opts.onrestart;
        }
        Clip.prototype.step = function(globalTime, deltaTime) {
            if (!this._initialized) {
                this._startTime = globalTime + this._delay;
                this._initialized = true;
            }
            if (this._paused) {
                this._pausedTime += deltaTime;
                return;
            }
            var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
            if (percent < 0) percent = 0;
            percent = Math.min(percent, 1);
            var easing = this.easing;
            var easingFunc = typeof easing === 'string' ? (0, (0, parcelRequire("2yJbE")).default)[easing] : easing;
            var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
            this.onframe && this.onframe(schedule);
            if (percent === 1) {
                if (this.loop) {
                    this._restart(globalTime);
                    this.onrestart && this.onrestart();
                } else return true;
            }
            return false;
        };
        Clip.prototype._restart = function(globalTime) {
            var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
            this._startTime = globalTime - remainder + this.gap;
            this._pausedTime = 0;
        };
        Clip.prototype.pause = function() {
            this._paused = true;
        };
        Clip.prototype.resume = function() {
            this._paused = false;
        };
        return Clip;
    }();
    var $ec8cf6d19967f888$export$2e2bcd8739ae039 = $ec8cf6d19967f888$var$Clip;
});
parcelRegister("2yJbE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dd1cef375de2720$export$2e2bcd8739ae039);
    var $1dd1cef375de2720$var$easing = {
        linear: function(k) {
            return k;
        },
        quadraticIn: function(k) {
            return k * k;
        },
        quadraticOut: function(k) {
            return k * (2 - k);
        },
        quadraticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k;
            return -0.5 * (--k * (k - 2) - 1);
        },
        cubicIn: function(k) {
            return k * k * k;
        },
        cubicOut: function(k) {
            return --k * k * k + 1;
        },
        cubicInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k;
            return 0.5 * ((k -= 2) * k * k + 2);
        },
        quarticIn: function(k) {
            return k * k * k * k;
        },
        quarticOut: function(k) {
            return 1 - --k * k * k * k;
        },
        quarticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k;
            return -0.5 * ((k -= 2) * k * k * k - 2);
        },
        quinticIn: function(k) {
            return k * k * k * k * k;
        },
        quinticOut: function(k) {
            return --k * k * k * k * k + 1;
        },
        quinticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
            return 0.5 * ((k -= 2) * k * k * k * k + 2);
        },
        sinusoidalIn: function(k) {
            return 1 - Math.cos(k * Math.PI / 2);
        },
        sinusoidalOut: function(k) {
            return Math.sin(k * Math.PI / 2);
        },
        sinusoidalInOut: function(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        },
        exponentialIn: function(k) {
            return k === 0 ? 0 : Math.pow(1024, k - 1);
        },
        exponentialOut: function(k) {
            return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        },
        exponentialInOut: function(k) {
            if (k === 0) return 0;
            if (k === 1) return 1;
            if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
            return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
        },
        circularIn: function(k) {
            return 1 - Math.sqrt(1 - k * k);
        },
        circularOut: function(k) {
            return Math.sqrt(1 - --k * k);
        },
        circularInOut: function(k) {
            if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
            return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
        },
        elasticIn: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        },
        elasticOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
        },
        elasticInOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        backIn: function(k) {
            var s = 1.70158;
            return k * k * ((s + 1) * k - s);
        },
        backOut: function(k) {
            var s = 1.70158;
            return --k * k * ((s + 1) * k + s) + 1;
        },
        backInOut: function(k) {
            var s = 2.5949095;
            if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
            return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
        },
        bounceIn: function(k) {
            return 1 - $1dd1cef375de2720$var$easing.bounceOut(1 - k);
        },
        bounceOut: function(k) {
            if (k < 1 / 2.75) return 7.5625 * k * k;
            else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
            else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
            else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
        },
        bounceInOut: function(k) {
            if (k < 0.5) return $1dd1cef375de2720$var$easing.bounceIn(k * 2) * 0.5;
            return $1dd1cef375de2720$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
        }
    };
    var $1dd1cef375de2720$export$2e2bcd8739ae039 = $1dd1cef375de2720$var$easing;
});
parcelRegister("d6udH", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>$98a346fa71cc3009$export$98e6a39c04603d36);
    $parcel$export(module.exports, "lift", ()=>$98a346fa71cc3009$export$590e8b2c435046d9);
    $parcel$export(module.exports, "stringify", ()=>$98a346fa71cc3009$export$fac44ee5b035f737);
    $parcel$export(module.exports, "toHex", ()=>$98a346fa71cc3009$export$7ea66e3774a60b67);
    $parcel$export(module.exports, "fastLerp", ()=>$98a346fa71cc3009$export$66cb3c0e9efc61c8);
    $parcel$export(module.exports, "fastMapToColor", ()=>$98a346fa71cc3009$export$daa5a65daad5df58);
    $parcel$export(module.exports, "lerp", ()=>$98a346fa71cc3009$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "mapToColor", ()=>$98a346fa71cc3009$export$296e08242b78a3ec);
    $parcel$export(module.exports, "modifyHSL", ()=>$98a346fa71cc3009$export$d898ae866e27bf18);
    $parcel$export(module.exports, "modifyAlpha", ()=>$98a346fa71cc3009$export$ab4754bf42583a26);
    $parcel$export(module.exports, "lum", ()=>$98a346fa71cc3009$export$16c0ec21a6f9ef95);
    $parcel$export(module.exports, "random", ()=>$98a346fa71cc3009$export$4385e60b38654f68);
    var $h4RuA;
    var $98a346fa71cc3009$var$kCSSColorTable = {
        'transparent': [
            0,
            0,
            0,
            0
        ],
        'aliceblue': [
            240,
            248,
            255,
            1
        ],
        'antiquewhite': [
            250,
            235,
            215,
            1
        ],
        'aqua': [
            0,
            255,
            255,
            1
        ],
        'aquamarine': [
            127,
            255,
            212,
            1
        ],
        'azure': [
            240,
            255,
            255,
            1
        ],
        'beige': [
            245,
            245,
            220,
            1
        ],
        'bisque': [
            255,
            228,
            196,
            1
        ],
        'black': [
            0,
            0,
            0,
            1
        ],
        'blanchedalmond': [
            255,
            235,
            205,
            1
        ],
        'blue': [
            0,
            0,
            255,
            1
        ],
        'blueviolet': [
            138,
            43,
            226,
            1
        ],
        'brown': [
            165,
            42,
            42,
            1
        ],
        'burlywood': [
            222,
            184,
            135,
            1
        ],
        'cadetblue': [
            95,
            158,
            160,
            1
        ],
        'chartreuse': [
            127,
            255,
            0,
            1
        ],
        'chocolate': [
            210,
            105,
            30,
            1
        ],
        'coral': [
            255,
            127,
            80,
            1
        ],
        'cornflowerblue': [
            100,
            149,
            237,
            1
        ],
        'cornsilk': [
            255,
            248,
            220,
            1
        ],
        'crimson': [
            220,
            20,
            60,
            1
        ],
        'cyan': [
            0,
            255,
            255,
            1
        ],
        'darkblue': [
            0,
            0,
            139,
            1
        ],
        'darkcyan': [
            0,
            139,
            139,
            1
        ],
        'darkgoldenrod': [
            184,
            134,
            11,
            1
        ],
        'darkgray': [
            169,
            169,
            169,
            1
        ],
        'darkgreen': [
            0,
            100,
            0,
            1
        ],
        'darkgrey': [
            169,
            169,
            169,
            1
        ],
        'darkkhaki': [
            189,
            183,
            107,
            1
        ],
        'darkmagenta': [
            139,
            0,
            139,
            1
        ],
        'darkolivegreen': [
            85,
            107,
            47,
            1
        ],
        'darkorange': [
            255,
            140,
            0,
            1
        ],
        'darkorchid': [
            153,
            50,
            204,
            1
        ],
        'darkred': [
            139,
            0,
            0,
            1
        ],
        'darksalmon': [
            233,
            150,
            122,
            1
        ],
        'darkseagreen': [
            143,
            188,
            143,
            1
        ],
        'darkslateblue': [
            72,
            61,
            139,
            1
        ],
        'darkslategray': [
            47,
            79,
            79,
            1
        ],
        'darkslategrey': [
            47,
            79,
            79,
            1
        ],
        'darkturquoise': [
            0,
            206,
            209,
            1
        ],
        'darkviolet': [
            148,
            0,
            211,
            1
        ],
        'deeppink': [
            255,
            20,
            147,
            1
        ],
        'deepskyblue': [
            0,
            191,
            255,
            1
        ],
        'dimgray': [
            105,
            105,
            105,
            1
        ],
        'dimgrey': [
            105,
            105,
            105,
            1
        ],
        'dodgerblue': [
            30,
            144,
            255,
            1
        ],
        'firebrick': [
            178,
            34,
            34,
            1
        ],
        'floralwhite': [
            255,
            250,
            240,
            1
        ],
        'forestgreen': [
            34,
            139,
            34,
            1
        ],
        'fuchsia': [
            255,
            0,
            255,
            1
        ],
        'gainsboro': [
            220,
            220,
            220,
            1
        ],
        'ghostwhite': [
            248,
            248,
            255,
            1
        ],
        'gold': [
            255,
            215,
            0,
            1
        ],
        'goldenrod': [
            218,
            165,
            32,
            1
        ],
        'gray': [
            128,
            128,
            128,
            1
        ],
        'green': [
            0,
            128,
            0,
            1
        ],
        'greenyellow': [
            173,
            255,
            47,
            1
        ],
        'grey': [
            128,
            128,
            128,
            1
        ],
        'honeydew': [
            240,
            255,
            240,
            1
        ],
        'hotpink': [
            255,
            105,
            180,
            1
        ],
        'indianred': [
            205,
            92,
            92,
            1
        ],
        'indigo': [
            75,
            0,
            130,
            1
        ],
        'ivory': [
            255,
            255,
            240,
            1
        ],
        'khaki': [
            240,
            230,
            140,
            1
        ],
        'lavender': [
            230,
            230,
            250,
            1
        ],
        'lavenderblush': [
            255,
            240,
            245,
            1
        ],
        'lawngreen': [
            124,
            252,
            0,
            1
        ],
        'lemonchiffon': [
            255,
            250,
            205,
            1
        ],
        'lightblue': [
            173,
            216,
            230,
            1
        ],
        'lightcoral': [
            240,
            128,
            128,
            1
        ],
        'lightcyan': [
            224,
            255,
            255,
            1
        ],
        'lightgoldenrodyellow': [
            250,
            250,
            210,
            1
        ],
        'lightgray': [
            211,
            211,
            211,
            1
        ],
        'lightgreen': [
            144,
            238,
            144,
            1
        ],
        'lightgrey': [
            211,
            211,
            211,
            1
        ],
        'lightpink': [
            255,
            182,
            193,
            1
        ],
        'lightsalmon': [
            255,
            160,
            122,
            1
        ],
        'lightseagreen': [
            32,
            178,
            170,
            1
        ],
        'lightskyblue': [
            135,
            206,
            250,
            1
        ],
        'lightslategray': [
            119,
            136,
            153,
            1
        ],
        'lightslategrey': [
            119,
            136,
            153,
            1
        ],
        'lightsteelblue': [
            176,
            196,
            222,
            1
        ],
        'lightyellow': [
            255,
            255,
            224,
            1
        ],
        'lime': [
            0,
            255,
            0,
            1
        ],
        'limegreen': [
            50,
            205,
            50,
            1
        ],
        'linen': [
            250,
            240,
            230,
            1
        ],
        'magenta': [
            255,
            0,
            255,
            1
        ],
        'maroon': [
            128,
            0,
            0,
            1
        ],
        'mediumaquamarine': [
            102,
            205,
            170,
            1
        ],
        'mediumblue': [
            0,
            0,
            205,
            1
        ],
        'mediumorchid': [
            186,
            85,
            211,
            1
        ],
        'mediumpurple': [
            147,
            112,
            219,
            1
        ],
        'mediumseagreen': [
            60,
            179,
            113,
            1
        ],
        'mediumslateblue': [
            123,
            104,
            238,
            1
        ],
        'mediumspringgreen': [
            0,
            250,
            154,
            1
        ],
        'mediumturquoise': [
            72,
            209,
            204,
            1
        ],
        'mediumvioletred': [
            199,
            21,
            133,
            1
        ],
        'midnightblue': [
            25,
            25,
            112,
            1
        ],
        'mintcream': [
            245,
            255,
            250,
            1
        ],
        'mistyrose': [
            255,
            228,
            225,
            1
        ],
        'moccasin': [
            255,
            228,
            181,
            1
        ],
        'navajowhite': [
            255,
            222,
            173,
            1
        ],
        'navy': [
            0,
            0,
            128,
            1
        ],
        'oldlace': [
            253,
            245,
            230,
            1
        ],
        'olive': [
            128,
            128,
            0,
            1
        ],
        'olivedrab': [
            107,
            142,
            35,
            1
        ],
        'orange': [
            255,
            165,
            0,
            1
        ],
        'orangered': [
            255,
            69,
            0,
            1
        ],
        'orchid': [
            218,
            112,
            214,
            1
        ],
        'palegoldenrod': [
            238,
            232,
            170,
            1
        ],
        'palegreen': [
            152,
            251,
            152,
            1
        ],
        'paleturquoise': [
            175,
            238,
            238,
            1
        ],
        'palevioletred': [
            219,
            112,
            147,
            1
        ],
        'papayawhip': [
            255,
            239,
            213,
            1
        ],
        'peachpuff': [
            255,
            218,
            185,
            1
        ],
        'peru': [
            205,
            133,
            63,
            1
        ],
        'pink': [
            255,
            192,
            203,
            1
        ],
        'plum': [
            221,
            160,
            221,
            1
        ],
        'powderblue': [
            176,
            224,
            230,
            1
        ],
        'purple': [
            128,
            0,
            128,
            1
        ],
        'red': [
            255,
            0,
            0,
            1
        ],
        'rosybrown': [
            188,
            143,
            143,
            1
        ],
        'royalblue': [
            65,
            105,
            225,
            1
        ],
        'saddlebrown': [
            139,
            69,
            19,
            1
        ],
        'salmon': [
            250,
            128,
            114,
            1
        ],
        'sandybrown': [
            244,
            164,
            96,
            1
        ],
        'seagreen': [
            46,
            139,
            87,
            1
        ],
        'seashell': [
            255,
            245,
            238,
            1
        ],
        'sienna': [
            160,
            82,
            45,
            1
        ],
        'silver': [
            192,
            192,
            192,
            1
        ],
        'skyblue': [
            135,
            206,
            235,
            1
        ],
        'slateblue': [
            106,
            90,
            205,
            1
        ],
        'slategray': [
            112,
            128,
            144,
            1
        ],
        'slategrey': [
            112,
            128,
            144,
            1
        ],
        'snow': [
            255,
            250,
            250,
            1
        ],
        'springgreen': [
            0,
            255,
            127,
            1
        ],
        'steelblue': [
            70,
            130,
            180,
            1
        ],
        'tan': [
            210,
            180,
            140,
            1
        ],
        'teal': [
            0,
            128,
            128,
            1
        ],
        'thistle': [
            216,
            191,
            216,
            1
        ],
        'tomato': [
            255,
            99,
            71,
            1
        ],
        'turquoise': [
            64,
            224,
            208,
            1
        ],
        'violet': [
            238,
            130,
            238,
            1
        ],
        'wheat': [
            245,
            222,
            179,
            1
        ],
        'white': [
            255,
            255,
            255,
            1
        ],
        'whitesmoke': [
            245,
            245,
            245,
            1
        ],
        'yellow': [
            255,
            255,
            0,
            1
        ],
        'yellowgreen': [
            154,
            205,
            50,
            1
        ]
    };
    function $98a346fa71cc3009$var$clampCssByte(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 255 ? 255 : i;
    }
    function $98a346fa71cc3009$var$clampCssAngle(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 360 ? 360 : i;
    }
    function $98a346fa71cc3009$var$clampCssFloat(f) {
        return f < 0 ? 0 : f > 1 ? 1 : f;
    }
    function $98a346fa71cc3009$var$parseCssInt(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssByte(parseFloat(str) / 100 * 255);
        return $98a346fa71cc3009$var$clampCssByte(parseInt(str, 10));
    }
    function $98a346fa71cc3009$var$parseCssFloat(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str) / 100);
        return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str));
    }
    function $98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) {
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
        if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
        if (h * 2 < 1) return m2;
        if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
        return m1;
    }
    function $98a346fa71cc3009$var$lerpNumber(a, b, p) {
        return a + (b - a) * p;
    }
    function $98a346fa71cc3009$var$setRgba(out, r, g, b, a) {
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    function $98a346fa71cc3009$var$copyRgba(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    var $98a346fa71cc3009$var$colorCache = new (0, (0, parcelRequire("h4RuA")).default)(20);
    var $98a346fa71cc3009$var$lastRemovedArr = null;
    function $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr) {
        if ($98a346fa71cc3009$var$lastRemovedArr) $98a346fa71cc3009$var$copyRgba($98a346fa71cc3009$var$lastRemovedArr, rgbaArr);
        $98a346fa71cc3009$var$lastRemovedArr = $98a346fa71cc3009$var$colorCache.put(colorStr, $98a346fa71cc3009$var$lastRemovedArr || rgbaArr.slice());
    }
    function $98a346fa71cc3009$export$98e6a39c04603d36(colorStr, rgbaArr) {
        if (!colorStr) return;
        rgbaArr = rgbaArr || [];
        var cached = $98a346fa71cc3009$var$colorCache.get(colorStr);
        if (cached) return $98a346fa71cc3009$var$copyRgba(rgbaArr, cached);
        colorStr = colorStr + '';
        var str = colorStr.replace(/ /g, '').toLowerCase();
        if (str in $98a346fa71cc3009$var$kCSSColorTable) {
            $98a346fa71cc3009$var$copyRgba(rgbaArr, $98a346fa71cc3009$var$kCSSColorTable[str]);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        var strLen = str.length;
        if (str.charAt(0) === '#') {
            if (strLen === 4 || strLen === 5) {
                var iv = parseInt(str.slice(1, 4), 16);
                if (!(iv >= 0 && iv <= 0xfff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            } else if (strLen === 7 || strLen === 9) {
                var iv = parseInt(str.slice(1, 7), 16);
                if (!(iv >= 0 && iv <= 0xffffff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            }
            return;
        }
        var op = str.indexOf('(');
        var ep = str.indexOf(')');
        if (op !== -1 && ep + 1 === strLen) {
            var fname = str.substr(0, op);
            var params = str.substr(op + 1, ep - (op + 1)).split(',');
            var alpha = 1;
            switch(fname){
                case 'rgba':
                    if (params.length !== 4) return params.length === 3 ? $98a346fa71cc3009$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    alpha = $98a346fa71cc3009$var$parseCssFloat(params.pop());
                case 'rgb':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$setRgba(rgbaArr, $98a346fa71cc3009$var$parseCssInt(params[0]), $98a346fa71cc3009$var$parseCssInt(params[1]), $98a346fa71cc3009$var$parseCssInt(params[2]), alpha);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsla':
                    if (params.length !== 4) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    params[3] = $98a346fa71cc3009$var$parseCssFloat(params[3]);
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsl':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                default:
                    return;
            }
        }
        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
        return;
    }
    function $98a346fa71cc3009$var$hsla2rgba(hsla, rgba) {
        var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
        var s = $98a346fa71cc3009$var$parseCssFloat(hsla[1]);
        var l = $98a346fa71cc3009$var$parseCssFloat(hsla[2]);
        var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var m1 = l * 2 - m2;
        rgba = rgba || [];
        $98a346fa71cc3009$var$setRgba(rgba, $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
        if (hsla.length === 4) rgba[3] = hsla[3];
        return rgba;
    }
    function $98a346fa71cc3009$var$rgba2hsla(rgba) {
        if (!rgba) return;
        var R = rgba[0] / 255;
        var G = rgba[1] / 255;
        var B = rgba[2] / 255;
        var vMin = Math.min(R, G, B);
        var vMax = Math.max(R, G, B);
        var delta = vMax - vMin;
        var L = (vMax + vMin) / 2;
        var H;
        var S;
        if (delta === 0) {
            H = 0;
            S = 0;
        } else {
            if (L < 0.5) S = delta / (vMax + vMin);
            else S = delta / (2 - vMax - vMin);
            var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
            var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
            var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
            if (R === vMax) H = deltaB - deltaG;
            else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
            else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
            if (H < 0) H += 1;
            if (H > 1) H -= 1;
        }
        var hsla = [
            H * 360,
            S,
            L
        ];
        if (rgba[3] != null) hsla.push(rgba[3]);
        return hsla;
    }
    function $98a346fa71cc3009$export$590e8b2c435046d9(color, level) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) {
            for(var i = 0; i < 3; i++){
                if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
                else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
                if (colorArr[i] > 255) colorArr[i] = 255;
                else if (colorArr[i] < 0) colorArr[i] = 0;
            }
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
        }
    }
    function $98a346fa71cc3009$export$7ea66e3774a60b67(color) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
    }
    function $98a346fa71cc3009$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        out = out || [];
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = colors[leftIndex];
        var rightColor = colors[rightIndex];
        var dv = value - leftIndex;
        out[0] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv));
        out[1] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv));
        out[2] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv));
        out[3] = $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv));
        return out;
    }
    var $98a346fa71cc3009$export$daa5a65daad5df58 = $98a346fa71cc3009$export$66cb3c0e9efc61c8;
    function $98a346fa71cc3009$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[leftIndex]);
        var rightColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[rightIndex]);
        var dv = value - leftIndex;
        var color = $98a346fa71cc3009$export$fac44ee5b035f737([
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv)),
            $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv))
        ], 'rgba');
        return fullOutput ? {
            color: color,
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            value: value
        } : color;
    }
    var $98a346fa71cc3009$export$296e08242b78a3ec = $98a346fa71cc3009$export$3a89f8d6f6bf6c9f;
    function $98a346fa71cc3009$export$d898ae866e27bf18(color, h, s, l) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (color) {
            colorArr = $98a346fa71cc3009$var$rgba2hsla(colorArr);
            h != null && (colorArr[0] = $98a346fa71cc3009$var$clampCssAngle(h));
            s != null && (colorArr[1] = $98a346fa71cc3009$var$parseCssFloat(s));
            l != null && (colorArr[2] = $98a346fa71cc3009$var$parseCssFloat(l));
            return $98a346fa71cc3009$export$fac44ee5b035f737($98a346fa71cc3009$var$hsla2rgba(colorArr), 'rgba');
        }
    }
    function $98a346fa71cc3009$export$ab4754bf42583a26(color, alpha) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr && alpha != null) {
            colorArr[3] = $98a346fa71cc3009$var$clampCssFloat(alpha);
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, 'rgba');
        }
    }
    function $98a346fa71cc3009$export$fac44ee5b035f737(arrColor, type) {
        if (!arrColor || !arrColor.length) return;
        var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
        if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
        return type + '(' + colorStr + ')';
    }
    function $98a346fa71cc3009$export$16c0ec21a6f9ef95(color, backgroundLum) {
        var arr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
    }
    function $98a346fa71cc3009$export$4385e60b38654f68() {
        var r = Math.round(Math.random() * 255);
        var g = Math.round(Math.random() * 255);
        var b = Math.round(Math.random() * 255);
        return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
});
parcelRegister("bRKv5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a38b6f95cbd6cc6$export$2e2bcd8739ae039);
    var $8a38b6f95cbd6cc6$var$Eventful = function() {
        function Eventful(eventProcessors) {
            if (eventProcessors) this._$eventProcessor = eventProcessors;
        }
        Eventful.prototype.on = function(event, query, handler, context) {
            if (!this._$handlers) this._$handlers = {};
            var _h = this._$handlers;
            if (typeof query === 'function') {
                context = handler;
                handler = query;
                query = null;
            }
            if (!handler || !event) return this;
            var eventProcessor = this._$eventProcessor;
            if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
            if (!_h[event]) _h[event] = [];
            for(var i = 0; i < _h[event].length; i++){
                if (_h[event][i].h === handler) return this;
            }
            var wrap = {
                h: handler,
                query: query,
                ctx: context || this,
                callAtLast: handler.zrEventfulCallAtLast
            };
            var lastIndex = _h[event].length - 1;
            var lastWrap = _h[event][lastIndex];
            lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
            return this;
        };
        Eventful.prototype.isSilent = function(eventName) {
            var _h = this._$handlers;
            return !_h || !_h[eventName] || !_h[eventName].length;
        };
        Eventful.prototype.off = function(eventType, handler) {
            var _h = this._$handlers;
            if (!_h) return this;
            if (!eventType) {
                this._$handlers = {};
                return this;
            }
            if (handler) {
                if (_h[eventType]) {
                    var newList = [];
                    for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                    _h[eventType] = newList;
                }
                if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
            } else delete _h[eventType];
            return this;
        };
        Eventful.prototype.trigger = function(eventType) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[eventType];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(hItem.ctx);
                            break;
                        case 1:
                            hItem.h.call(hItem.ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(hItem.ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(hItem.ctx, args);
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
            return this;
        };
        Eventful.prototype.triggerWithContext = function(type) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[type];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var ctx = args[argLen - 1];
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(ctx);
                            break;
                        case 1:
                            hItem.h.call(ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(ctx, args.slice(1, argLen - 1));
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
            return this;
        };
        return Eventful;
    }();
    var $8a38b6f95cbd6cc6$export$2e2bcd8739ae039 = $8a38b6f95cbd6cc6$var$Eventful;
});
parcelRegister("7y1my", function(module, exports) {
    $parcel$export(module.exports, "devicePixelRatio", ()=>$57ecc3ffeb61d50b$export$508f096bfcdaac40);
    $parcel$export(module.exports, "DARK_MODE_THRESHOLD", ()=>$57ecc3ffeb61d50b$export$fd81e7ebc7dae256);
    $parcel$export(module.exports, "DARK_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$f8ce94761f39398d);
    $parcel$export(module.exports, "LIGHT_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$3c6e95f318c8369b);
    $parcel$export(module.exports, "LIGHTER_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$27682248795c3c6b);
    var $57ecc3ffeb61d50b$var$dpr = 1;
    if (typeof window !== 'undefined') $57ecc3ffeb61d50b$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
    var $57ecc3ffeb61d50b$export$7cdcde344c85339c = 0;
    var $57ecc3ffeb61d50b$export$508f096bfcdaac40 = $57ecc3ffeb61d50b$var$dpr;
    var $57ecc3ffeb61d50b$export$fd81e7ebc7dae256 = 0.4;
    var $57ecc3ffeb61d50b$export$f8ce94761f39398d = '#333';
    var $57ecc3ffeb61d50b$export$3c6e95f318c8369b = '#ccc';
    var $57ecc3ffeb61d50b$export$27682248795c3c6b = '#eee';
});
parcelRegister("aVawM", function(module, exports) {
    $parcel$export(module.exports, "REDRAW_BIT", ()=>$7f3764d4456adf3b$export$a7b6db622c6c7dbd);
    $parcel$export(module.exports, "STYLE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$ada8b2beb3d76671);
    $parcel$export(module.exports, "SHAPE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$f75fe89a33ebe115);
    var $7f3764d4456adf3b$export$a7b6db622c6c7dbd = 1;
    var $7f3764d4456adf3b$export$ada8b2beb3d76671 = 2;
    var $7f3764d4456adf3b$export$f75fe89a33ebe115 = 4;
});
parcelRegister("ghQ8v", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_PATH_STYLE", ()=>$bdb6ad049d5f8c6b$export$deade517576e293a);
    $parcel$export(module.exports, "default", ()=>$bdb6ad049d5f8c6b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $aA4Ws;
    var $k3yEY;
    var $bahqM;
    var $d6udH;
    var $7y1my;
    var $aVawM;
    var $bdb6ad049d5f8c6b$export$deade517576e293a = (0, (0, parcelRequire("bahqM")).defaults)({
        fill: '#000',
        stroke: null,
        strokePercent: 1,
        fillOpacity: 1,
        strokeOpacity: 1,
        lineDashOffset: 0,
        lineWidth: 1,
        lineCap: 'butt',
        miterLimit: 10,
        strokeNoScale: false,
        strokeFirst: false
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            strokePercent: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineDashOffset: true,
            lineWidth: true,
            miterLimit: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $bdb6ad049d5f8c6b$var$pathCopyParams = [
        'x',
        'y',
        'rotation',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'invisible',
        'culling',
        'z',
        'z2',
        'zlevel',
        'parent'
    ];
    var $bdb6ad049d5f8c6b$var$Path = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Path, _super);
        function Path(opts) {
            return _super.call(this, opts) || this;
        }
        Path.prototype.update = function() {
            var _this = this;
            _super.prototype.update.call(this);
            var style = this.style;
            if (style.decal) {
                var decalEl = this._decalEl = this._decalEl || new Path();
                if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                    _this.buildPath(ctx, _this.shape);
                };
                decalEl.silent = true;
                var decalElStyle = decalEl.style;
                for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
                decalElStyle.fill = style.fill ? style.decal : null;
                decalElStyle.decal = null;
                decalElStyle.shadowColor = null;
                style.strokeFirst && (decalElStyle.stroke = null);
                for(var i = 0; i < $bdb6ad049d5f8c6b$var$pathCopyParams.length; ++i)decalEl[$bdb6ad049d5f8c6b$var$pathCopyParams[i]] = this[$bdb6ad049d5f8c6b$var$pathCopyParams[i]];
                decalEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            } else if (this._decalEl) this._decalEl = null;
        };
        Path.prototype.getDecalElement = function() {
            return this._decalEl;
        };
        Path.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            this.shape = this.getDefaultShape();
            var defaultStyle = this.getDefaultStyle();
            if (defaultStyle) this.useStyle(defaultStyle);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                var value = props[key];
                if (key === 'style') {
                    if (!this.style) this.useStyle(value);
                    else (0, (0, parcelRequire("bahqM")).extend)(this.style, value);
                } else if (key === 'shape') (0, (0, parcelRequire("bahqM")).extend)(this.shape, value);
                else _super.prototype.attrKV.call(this, key, value);
            }
            if (!this.style) this.useStyle({});
        };
        Path.prototype.getDefaultStyle = function() {
            return null;
        };
        Path.prototype.getDefaultShape = function() {
            return {};
        };
        Path.prototype.canBeInsideText = function() {
            return this.hasFill();
        };
        Path.prototype.getInsideTextFill = function() {
            var pathFill = this.style.fill;
            if (pathFill !== 'none') {
                if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                    var fillLum = (0, (0, parcelRequire("d6udH")).lum)(pathFill, 0);
                    if (fillLum > 0.5) return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
                    else if (fillLum > 0.2) return 0, (0, parcelRequire("7y1my")).LIGHTER_LABEL_COLOR;
                    return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
                } else if (pathFill) return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
            }
            return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
        };
        Path.prototype.getInsideTextStroke = function(textFill) {
            var pathFill = this.style.fill;
            if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                var zr = this.__zr;
                var isDarkMode = !!(zr && zr.isDarkMode());
                var isDarkLabel = (0, (0, parcelRequire("d6udH")).lum)(textFill, 0) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
                if (isDarkMode === isDarkLabel) return pathFill;
            }
        };
        Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
        Path.prototype.pathUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        };
        Path.prototype.getUpdatedPathProxy = function(inBatch) {
            !this.path && this.createPathProxy();
            this.path.beginPath();
            this.buildPath(this.path, this.shape, inBatch);
            return this.path;
        };
        Path.prototype.createPathProxy = function() {
            this.path = new (0, (0, parcelRequire("aA4Ws")).default)(false);
        };
        Path.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
        };
        Path.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        Path.prototype.getBoundingRect = function() {
            var rect = this._rect;
            var style = this.style;
            var needsUpdateRect = !rect;
            if (needsUpdateRect) {
                var firstInvoke = false;
                if (!this.path) {
                    firstInvoke = true;
                    this.createPathProxy();
                }
                var path = this.path;
                if (firstInvoke || this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT)) {
                    path.beginPath();
                    this.buildPath(path, this.shape, false);
                    this.pathUpdated();
                }
                rect = path.getBoundingRect();
            }
            this._rect = rect;
            if (this.hasStroke() && this.path && this.path.len() > 0) {
                var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
                if (this.__dirty || needsUpdateRect) {
                    rectWithStroke.copy(rect);
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    var w = style.lineWidth;
                    if (!this.hasFill()) {
                        var strokeContainThreshold = this.strokeContainThreshold;
                        w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                    }
                    if (lineScale > 1e-10) {
                        rectWithStroke.width += w / lineScale;
                        rectWithStroke.height += w / lineScale;
                        rectWithStroke.x -= w / lineScale / 2;
                        rectWithStroke.y -= w / lineScale / 2;
                    }
                }
                return rectWithStroke;
            }
            return rect;
        };
        Path.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            var style = this.style;
            x = localPos[0];
            y = localPos[1];
            if (rect.contain(x, y)) {
                var pathProxy = this.path;
                if (this.hasStroke()) {
                    var lineWidth = style.lineWidth;
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    if (lineScale > 1e-10) {
                        if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                        if ((0, parcelRequire("k3yEY")).containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                    }
                }
                if (this.hasFill()) return (0, parcelRequire("k3yEY")).contain(pathProxy, x, y);
            }
            return false;
        };
        Path.prototype.dirtyShape = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
            if (this._rect) this._rect = null;
            if (this._decalEl) this._decalEl.dirtyShape();
            this.markRedraw();
        };
        Path.prototype.dirty = function() {
            this.dirtyStyle();
            this.dirtyShape();
        };
        Path.prototype.animateShape = function(loop) {
            return this.animate('shape', loop);
        };
        Path.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else if (targetKey === 'shape') this.dirtyShape();
            else this.markRedraw();
        };
        Path.prototype.attrKV = function(key, value) {
            if (key === 'shape') this.setShape(value);
            else _super.prototype.attrKV.call(this, key, value);
        };
        Path.prototype.setShape = function(keyOrObj, value) {
            var shape = this.shape;
            if (!shape) shape = this.shape = {};
            if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(shape, keyOrObj);
            this.dirtyShape();
            return this;
        };
        Path.prototype.shapeChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT));
        };
        Path.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bdb6ad049d5f8c6b$export$deade517576e293a, obj);
        };
        Path.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.shape && !normalState.shape) normalState.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
        };
        Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetShape;
            if (state && state.shape) {
                if (transition) {
                    if (keepCurrentStates) targetShape = state.shape;
                    else {
                        targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, normalState.shape);
                        (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                    }
                } else {
                    targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                    (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                }
            } else if (needsRestoreToNormal) targetShape = normalState.shape;
            if (targetShape) {
                if (transition) {
                    this.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
                    var targetShapePrimaryProps = {};
                    var shapeKeys = (0, (0, parcelRequire("bahqM")).keys)(targetShape);
                    for(var i = 0; i < shapeKeys.length; i++){
                        var key = shapeKeys[i];
                        if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                        else targetShapePrimaryProps[key] = targetShape[key];
                    }
                    this._transitionState(stateName, {
                        shape: targetShapePrimaryProps
                    }, animationCfg);
                } else {
                    this.shape = targetShape;
                    this.dirtyShape();
                }
            }
        };
        Path.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedShape;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.shape) {
                    mergedShape = mergedShape || {};
                    this._mergeStyle(mergedShape, state.shape);
                }
            }
            if (mergedShape) mergedState.shape = mergedShape;
            return mergedState;
        };
        Path.prototype.getAnimationStyleProps = function() {
            return $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5;
        };
        Path.prototype.isZeroArea = function() {
            return false;
        };
        Path.extend = function(defaultProps) {
            var Sub = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
                function Sub(opts) {
                    var _this = _super.call(this, opts) || this;
                    defaultProps.init && defaultProps.init.call(_this, opts);
                    return _this;
                }
                Sub.prototype.getDefaultStyle = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.style);
                };
                Sub.prototype.getDefaultShape = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.shape);
                };
                return Sub;
            }(Path);
            for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
            return Sub;
        };
        Path.initDefaultProps = function() {
            var pathProto = Path.prototype;
            pathProto.type = 'path';
            pathProto.strokeContainThreshold = 5;
            pathProto.segmentIgnoreThreshold = 0;
            pathProto.subPixelOptimize = false;
            pathProto.autoBatch = false;
            pathProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT) | (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        }();
        return Path;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $bdb6ad049d5f8c6b$export$2e2bcd8739ae039 = $bdb6ad049d5f8c6b$var$Path;
});
parcelRegister("aA4Ws", function(module, exports) {
    $parcel$export(module.exports, "normalizeArcAngles", ()=>$7b4119855d2b5b91$export$bc668021e937022a);
    $parcel$export(module.exports, "default", ()=>$7b4119855d2b5b91$export$2e2bcd8739ae039);
    var $eLEew;
    var $1E3E8;
    var $7y1my;
    var $13I82;
    var $dr1jo;
    var $7b4119855d2b5b91$var$CMD = {
        M: 1,
        L: 2,
        C: 3,
        Q: 4,
        A: 5,
        Z: 6,
        R: 7
    };
    var $7b4119855d2b5b91$var$tmpOutX = [];
    var $7b4119855d2b5b91$var$tmpOutY = [];
    var $7b4119855d2b5b91$var$min = [];
    var $7b4119855d2b5b91$var$max = [];
    var $7b4119855d2b5b91$var$min2 = [];
    var $7b4119855d2b5b91$var$max2 = [];
    var $7b4119855d2b5b91$var$mathMin = Math.min;
    var $7b4119855d2b5b91$var$mathMax = Math.max;
    var $7b4119855d2b5b91$var$mathCos = Math.cos;
    var $7b4119855d2b5b91$var$mathSin = Math.sin;
    var $7b4119855d2b5b91$var$mathSqrt = Math.sqrt;
    var $7b4119855d2b5b91$var$mathAbs = Math.abs;
    var $7b4119855d2b5b91$var$PI = Math.PI;
    var $7b4119855d2b5b91$var$PI2 = $7b4119855d2b5b91$var$PI * 2;
    var $7b4119855d2b5b91$var$hasTypedArray = typeof Float32Array !== 'undefined';
    var $7b4119855d2b5b91$var$tmpAngles = [];
    function $7b4119855d2b5b91$var$modPI2(radian) {
        var n = Math.round(radian / $7b4119855d2b5b91$var$PI * 1e8) / 1e8;
        return n % 2 * $7b4119855d2b5b91$var$PI;
    }
    function $7b4119855d2b5b91$export$bc668021e937022a(angles, anticlockwise) {
        var newStartAngle = $7b4119855d2b5b91$var$modPI2(angles[0]);
        if (newStartAngle < 0) newStartAngle += $7b4119855d2b5b91$var$PI2;
        var delta = newStartAngle - angles[0];
        var newEndAngle = angles[1];
        newEndAngle += delta;
        if (!anticlockwise && newEndAngle - newStartAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle + $7b4119855d2b5b91$var$PI2;
        else if (anticlockwise && newStartAngle - newEndAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle - $7b4119855d2b5b91$var$PI2;
        else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newStartAngle - newEndAngle));
        else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newEndAngle - newStartAngle));
        angles[0] = newStartAngle;
        angles[1] = newEndAngle;
    }
    var $7b4119855d2b5b91$var$PathProxy = function() {
        function PathProxy(notSaveData) {
            this.dpr = 1;
            this._xi = 0;
            this._yi = 0;
            this._x0 = 0;
            this._y0 = 0;
            this._len = 0;
            if (notSaveData) this._saveData = false;
            if (this._saveData) this.data = [];
        }
        PathProxy.prototype.increaseVersion = function() {
            this._version++;
        };
        PathProxy.prototype.getVersion = function() {
            return this._version;
        };
        PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
            segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
            if (segmentIgnoreThreshold > 0) {
                this._ux = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sx) || 0;
                this._uy = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sy) || 0;
            }
        };
        PathProxy.prototype.setDPR = function(dpr) {
            this.dpr = dpr;
        };
        PathProxy.prototype.setContext = function(ctx) {
            this._ctx = ctx;
        };
        PathProxy.prototype.getContext = function() {
            return this._ctx;
        };
        PathProxy.prototype.beginPath = function() {
            this._ctx && this._ctx.beginPath();
            this.reset();
            return this;
        };
        PathProxy.prototype.reset = function() {
            if (this._saveData) this._len = 0;
            if (this._lineDash) {
                this._lineDash = null;
                this._dashOffset = 0;
            }
            if (this._pathSegLen) {
                this._pathSegLen = null;
                this._pathLen = 0;
            }
            this._version++;
        };
        PathProxy.prototype.moveTo = function(x, y) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.M, x, y);
            this._ctx && this._ctx.moveTo(x, y);
            this._x0 = x;
            this._y0 = y;
            this._xi = x;
            this._yi = y;
            return this;
        };
        PathProxy.prototype.lineTo = function(x, y) {
            var dx = $7b4119855d2b5b91$var$mathAbs(x - this._xi);
            var dy = $7b4119855d2b5b91$var$mathAbs(y - this._yi);
            var exceedUnit = dx > this._ux || dy > this._uy;
            this.addData($7b4119855d2b5b91$var$CMD.L, x, y);
            if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
            if (exceedUnit) {
                this._xi = x;
                this._yi = y;
                this._pendingPtDist = 0;
            } else {
                var d2 = dx * dx + dy * dy;
                if (d2 > this._pendingPtDist) {
                    this._pendingPtX = x;
                    this._pendingPtY = y;
                    this._pendingPtDist = d2;
                }
            }
            return this;
        };
        PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.C, x1, y1, x2, y2, x3, y3);
            if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
            this._xi = x3;
            this._yi = y3;
            return this;
        };
        PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Q, x1, y1, x2, y2);
            if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
            this._xi = x2;
            this._yi = y2;
            return this;
        };
        PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
            this._drawPendingPt();
            $7b4119855d2b5b91$var$tmpAngles[0] = startAngle;
            $7b4119855d2b5b91$var$tmpAngles[1] = endAngle;
            $7b4119855d2b5b91$export$bc668021e937022a($7b4119855d2b5b91$var$tmpAngles, anticlockwise);
            startAngle = $7b4119855d2b5b91$var$tmpAngles[0];
            endAngle = $7b4119855d2b5b91$var$tmpAngles[1];
            var delta = endAngle - startAngle;
            this.addData($7b4119855d2b5b91$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
            this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
            this._xi = $7b4119855d2b5b91$var$mathCos(endAngle) * r + cx;
            this._yi = $7b4119855d2b5b91$var$mathSin(endAngle) * r + cy;
            return this;
        };
        PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
            this._drawPendingPt();
            if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
            return this;
        };
        PathProxy.prototype.rect = function(x, y, w, h) {
            this._drawPendingPt();
            this._ctx && this._ctx.rect(x, y, w, h);
            this.addData($7b4119855d2b5b91$var$CMD.R, x, y, w, h);
            return this;
        };
        PathProxy.prototype.closePath = function() {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Z);
            var ctx = this._ctx;
            var x0 = this._x0;
            var y0 = this._y0;
            if (ctx) {
                this._needsDash && this._dashedLineTo(x0, y0);
                ctx.closePath();
            }
            this._xi = x0;
            this._yi = y0;
            return this;
        };
        PathProxy.prototype.fill = function(ctx) {
            ctx && ctx.fill();
            this.toStatic();
        };
        PathProxy.prototype.stroke = function(ctx) {
            ctx && ctx.stroke();
            this.toStatic();
        };
        PathProxy.prototype.setLineDash = function(lineDash) {
            if (lineDash instanceof Array) {
                this._lineDash = lineDash;
                this._dashIdx = 0;
                var lineDashSum = 0;
                for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
                this._dashSum = lineDashSum;
                this._needsDash = true;
            } else {
                this._lineDash = null;
                this._needsDash = false;
            }
            return this;
        };
        PathProxy.prototype.setLineDashOffset = function(offset) {
            this._dashOffset = offset;
            return this;
        };
        PathProxy.prototype.len = function() {
            return this._len;
        };
        PathProxy.prototype.setData = function(data) {
            var len = data.length;
            if (!(this.data && this.data.length === len) && $7b4119855d2b5b91$var$hasTypedArray) this.data = new Float32Array(len);
            for(var i = 0; i < len; i++)this.data[i] = data[i];
            this._len = len;
        };
        PathProxy.prototype.appendPath = function(path) {
            if (!(path instanceof Array)) path = [
                path
            ];
            var len = path.length;
            var appendSize = 0;
            var offset = this._len;
            for(var i = 0; i < len; i++)appendSize += path[i].len();
            if ($7b4119855d2b5b91$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
            for(var i = 0; i < len; i++){
                var appendPathData = path[i].data;
                for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
            }
            this._len = offset;
        };
        PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
            if (!this._saveData) return;
            var data = this.data;
            if (this._len + arguments.length > data.length) {
                this._expandData();
                data = this.data;
            }
            for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
        };
        PathProxy.prototype._drawPendingPt = function() {
            if (this._pendingPtDist > 0) {
                this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
                this._pendingPtDist = 0;
            }
        };
        PathProxy.prototype._expandData = function() {
            if (!(this.data instanceof Array)) {
                var newData = [];
                for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
                this.data = newData;
            }
        };
        PathProxy.prototype._dashedLineTo = function(x1, y1) {
            var dashSum = this._dashSum;
            var lineDash = this._lineDash;
            var ctx = this._ctx;
            var offset = this._dashOffset;
            var x0 = this._xi;
            var y0 = this._yi;
            var dx = x1 - x0;
            var dy = y1 - y0;
            var dist = $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            var x = x0;
            var y = y0;
            var nDash = lineDash.length;
            var dash;
            var idx;
            dx /= dist;
            dy /= dist;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            x -= offset * dx;
            y -= offset * dy;
            while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
                idx = this._dashIdx;
                dash = lineDash[idx];
                x += dx * dash;
                y += dy * dash;
                this._dashIdx = (idx + 1) % nDash;
                if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
                ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $7b4119855d2b5b91$var$mathMin(x, x1) : $7b4119855d2b5b91$var$mathMax(x, x1), dy >= 0 ? $7b4119855d2b5b91$var$mathMin(y, y1) : $7b4119855d2b5b91$var$mathMax(y, y1));
            }
            dx = x - x1;
            dy = y - y1;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
            var ctx = this._ctx;
            var dashSum = this._dashSum;
            var offset = this._dashOffset;
            var lineDash = this._lineDash;
            var x0 = this._xi;
            var y0 = this._yi;
            var bezierLen = 0;
            var idx = this._dashIdx;
            var nDash = lineDash.length;
            var t;
            var dx;
            var dy;
            var x;
            var y;
            var tmpLen = 0;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            for(t = 0; t < 1; t += 0.1){
                dx = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                dy = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                bezierLen += $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            }
            for(; idx < nDash; idx++){
                tmpLen += lineDash[idx];
                if (tmpLen > offset) break;
            }
            t = (tmpLen - offset) / bezierLen;
            while(t <= 1){
                x = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                y = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                t += lineDash[idx] / bezierLen;
                idx = (idx + 1) % nDash;
            }
            idx % 2 !== 0 && ctx.lineTo(x3, y3);
            dx = x3 - x;
            dy = y3 - y;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
            var x3 = x2;
            var y3 = y2;
            x2 = (x2 + 2 * x1) / 3;
            y2 = (y2 + 2 * y1) / 3;
            x1 = (this._xi + 2 * x1) / 3;
            y1 = (this._yi + 2 * y1) / 3;
            this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
        };
        PathProxy.prototype.toStatic = function() {
            if (!this._saveData) return;
            this._drawPendingPt();
            var data = this.data;
            if (data instanceof Array) {
                data.length = this._len;
                if ($7b4119855d2b5b91$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
            }
        };
        PathProxy.prototype.getBoundingRect = function() {
            $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$min2[0] = $7b4119855d2b5b91$var$min2[1] = Number.MAX_VALUE;
            $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = $7b4119855d2b5b91$var$max2[0] = $7b4119855d2b5b91$var$max2[1] = -Number.MAX_VALUE;
            var data = this.data;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            var i;
            for(i = 0; i < this._len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        $7b4119855d2b5b91$var$min2[0] = x0;
                        $7b4119855d2b5b91$var$min2[1] = y0;
                        $7b4119855d2b5b91$var$max2[0] = x0;
                        $7b4119855d2b5b91$var$max2[1] = y0;
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        (0, (0, parcelRequire("13I82")).fromLine)(xi, yi, data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        (0, (0, parcelRequire("13I82")).fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        (0, (0, parcelRequire("13I82")).fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var endAngle = data[i++] + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        (0, (0, parcelRequire("13I82")).fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        (0, (0, parcelRequire("13I82")).fromLine)(x0, y0, x0 + width, y0 + height, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        xi = x0;
                        yi = y0;
                        break;
                }
                (0, parcelRequire("eLEew")).min($7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min2);
                (0, parcelRequire("eLEew")).max($7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max2);
            }
            if (i === 0) $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = 0;
            return new (0, (0, parcelRequire("1E3E8")).default)($7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$min[1], $7b4119855d2b5b91$var$max[0] - $7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$max[1] - $7b4119855d2b5b91$var$min[1]);
        };
        PathProxy.prototype._calculateLength = function() {
            var data = this.data;
            var len = this._len;
            var ux = this._ux;
            var uy = this._uy;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            if (!this._pathSegLen) this._pathSegLen = [];
            var pathSegLen = this._pathSegLen;
            var pathTotalLen = 0;
            var segCount = 0;
            for(var i = 0; i < len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                var l = -1;
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var dx = x2 - xi;
                        var dy = y2 - yi;
                        if ($7b4119855d2b5b91$var$mathAbs(dx) > ux || $7b4119855d2b5b91$var$mathAbs(dy) > uy || i === len - 1) {
                            l = Math.sqrt(dx * dx + dy * dy);
                            xi = x2;
                            yi = y2;
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var x3 = data[i++];
                        var y3 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var delta = data[i++];
                        var endAngle = delta + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        l = $7b4119855d2b5b91$var$mathMax(rx, ry) * $7b4119855d2b5b91$var$mathMin($7b4119855d2b5b91$var$PI2, Math.abs(delta));
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        l = width * 2 + height * 2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        var dx = x0 - xi;
                        var dy = y0 - yi;
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x0;
                        yi = y0;
                        break;
                }
                if (l >= 0) {
                    pathSegLen[segCount++] = l;
                    pathTotalLen += l;
                }
            }
            this._pathLen = pathTotalLen;
            return pathTotalLen;
        };
        PathProxy.prototype.rebuildPath = function(ctx, percent) {
            var d = this.data;
            var ux = this._ux;
            var uy = this._uy;
            var len = this._len;
            var x0;
            var y0;
            var xi;
            var yi;
            var x;
            var y;
            var drawPart = percent < 1;
            var pathSegLen;
            var pathTotalLen;
            var accumLength = 0;
            var segCount = 0;
            var displayedLength;
            var pendingPtDist = 0;
            var pendingPtX;
            var pendingPtY;
            if (drawPart) {
                if (!this._pathSegLen) this._calculateLength();
                pathSegLen = this._pathSegLen;
                pathTotalLen = this._pathLen;
                displayedLength = percent * pathTotalLen;
                if (!displayedLength) return;
            }
            lo: for(var i = 0; i < len;){
                var cmd = d[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = d[i];
                    yi = d[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                if (cmd !== $7b4119855d2b5b91$var$CMD.L && pendingPtDist > 0) {
                    ctx.lineTo(pendingPtX, pendingPtY);
                    pendingPtDist = 0;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        x0 = xi = d[i++];
                        y0 = yi = d[i++];
                        ctx.moveTo(xi, yi);
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        x = d[i++];
                        y = d[i++];
                        var dx = $7b4119855d2b5b91$var$mathAbs(x - xi);
                        var dy = $7b4119855d2b5b91$var$mathAbs(y - yi);
                        if (dx > ux || dy > uy) {
                            if (drawPart) {
                                var l = pathSegLen[segCount++];
                                if (accumLength + l > displayedLength) {
                                    var t = (displayedLength - accumLength) / l;
                                    ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                    break lo;
                                }
                                accumLength += l;
                            }
                            ctx.lineTo(x, y);
                            xi = x;
                            yi = y;
                            pendingPtDist = 0;
                        } else {
                            var d2 = dx * dx + dy * dy;
                            if (d2 > pendingPtDist) {
                                pendingPtX = x;
                                pendingPtY = y;
                                pendingPtDist = d2;
                            }
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        var x3 = d[i++];
                        var y3 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(xi, x1, x2, x3, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(yi, y1, y2, y3, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.bezierCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2], $7b4119855d2b5b91$var$tmpOutX[3], $7b4119855d2b5b91$var$tmpOutY[3]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(xi, x1, x2, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(yi, y1, y2, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.quadraticCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.quadraticCurveTo(x1, y1, x2, y2);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = d[i++];
                        var cy = d[i++];
                        var rx = d[i++];
                        var ry = d[i++];
                        var startAngle = d[i++];
                        var delta = d[i++];
                        var psi = d[i++];
                        var anticlockwise = !d[i++];
                        var r = rx > ry ? rx : ry;
                        var isEllipse = $7b4119855d2b5b91$var$mathAbs(rx - ry) > 1e-3;
                        var endAngle = startAngle + delta;
                        var breakBuild = false;
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                                breakBuild = true;
                            }
                            accumLength += l;
                        }
                        if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                        else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                        if (breakBuild) break lo;
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = d[i];
                        y0 = yi = d[i + 1];
                        x = d[i++];
                        y = d[i++];
                        var width = d[i++];
                        var height = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var d_1 = displayedLength - accumLength;
                                ctx.moveTo(x, y);
                                ctx.lineTo(x + $7b4119855d2b5b91$var$mathMin(d_1, width), y);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x + width, y + $7b4119855d2b5b91$var$mathMin(d_1, height));
                                d_1 -= height;
                                if (d_1 > 0) ctx.lineTo(x + $7b4119855d2b5b91$var$mathMax(width - d_1, 0), y + height);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x, y + $7b4119855d2b5b91$var$mathMax(height - d_1, 0));
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.rect(x, y, width, height);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.closePath();
                        xi = x0;
                        yi = y0;
                }
            }
        };
        PathProxy.prototype.clone = function() {
            var newProxy = new PathProxy();
            var data = this.data;
            newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
            newProxy._len = this._len;
            return newProxy;
        };
        PathProxy.CMD = $7b4119855d2b5b91$var$CMD;
        PathProxy.initDefaultProps = function() {
            var proto = PathProxy.prototype;
            proto._saveData = true;
            proto._needsDash = false;
            proto._dashOffset = 0;
            proto._dashIdx = 0;
            proto._dashSum = 0;
            proto._ux = 0;
            proto._uy = 0;
            proto._pendingPtDist = 0;
            proto._version = 0;
        }();
        return PathProxy;
    }();
    var $7b4119855d2b5b91$export$2e2bcd8739ae039 = $7b4119855d2b5b91$var$PathProxy;
});
parcelRegister("13I82", function(module, exports) {
    $parcel$export(module.exports, "fromPoints", ()=>$0c584d4e3f9e2fa0$export$188c3cd07b4129dd);
    $parcel$export(module.exports, "fromLine", ()=>$0c584d4e3f9e2fa0$export$d2b1491e4450bf2c);
    $parcel$export(module.exports, "fromCubic", ()=>$0c584d4e3f9e2fa0$export$c1bc6be456bb6609);
    $parcel$export(module.exports, "fromQuadratic", ()=>$0c584d4e3f9e2fa0$export$16fbe795323a1f4c);
    $parcel$export(module.exports, "fromArc", ()=>$0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49);
    var $eLEew;
    var $dr1jo;
    var $0c584d4e3f9e2fa0$var$mathMin = Math.min;
    var $0c584d4e3f9e2fa0$var$mathMax = Math.max;
    var $0c584d4e3f9e2fa0$var$mathSin = Math.sin;
    var $0c584d4e3f9e2fa0$var$mathCos = Math.cos;
    var $0c584d4e3f9e2fa0$var$PI2 = Math.PI * 2;
    var $0c584d4e3f9e2fa0$var$start = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$end = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$extremity = (0, parcelRequire("eLEew")).create();
    function $0c584d4e3f9e2fa0$export$188c3cd07b4129dd(points, min, max) {
        if (points.length === 0) return;
        var p = points[0];
        var left = p[0];
        var right = p[0];
        var top = p[1];
        var bottom = p[1];
        for(var i = 1; i < points.length; i++){
            p = points[i];
            left = $0c584d4e3f9e2fa0$var$mathMin(left, p[0]);
            right = $0c584d4e3f9e2fa0$var$mathMax(right, p[0]);
            top = $0c584d4e3f9e2fa0$var$mathMin(top, p[1]);
            bottom = $0c584d4e3f9e2fa0$var$mathMax(bottom, p[1]);
        }
        min[0] = left;
        min[1] = top;
        max[0] = right;
        max[1] = bottom;
    }
    function $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x1);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y1);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x1);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y1);
    }
    var $0c584d4e3f9e2fa0$var$xDim = [];
    var $0c584d4e3f9e2fa0$var$yDim = [];
    function $0c584d4e3f9e2fa0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
        var cubicExtrema = (0, parcelRequire("dr1jo")).cubicExtrema;
        var cubicAt = (0, parcelRequire("dr1jo")).cubicAt;
        var n = cubicExtrema(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim);
        min[0] = Infinity;
        min[1] = Infinity;
        max[0] = -Infinity;
        max[1] = -Infinity;
        for(var i = 0; i < n; i++){
            var x = cubicAt(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim[i]);
            min[0] = $0c584d4e3f9e2fa0$var$mathMin(x, min[0]);
            max[0] = $0c584d4e3f9e2fa0$var$mathMax(x, max[0]);
        }
        n = cubicExtrema(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim);
        for(var i = 0; i < n; i++){
            var y = cubicAt(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim[i]);
            min[1] = $0c584d4e3f9e2fa0$var$mathMin(y, min[1]);
            max[1] = $0c584d4e3f9e2fa0$var$mathMax(y, max[1]);
        }
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, max[0]);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x3, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x3, max[0]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, max[1]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y3, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y3, max[1]);
    }
    function $0c584d4e3f9e2fa0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
        var quadraticExtremum = (0, parcelRequire("dr1jo")).quadraticExtremum;
        var quadraticAt = (0, parcelRequire("dr1jo")).quadraticAt;
        var tx = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
        var ty = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
        var x = quadraticAt(x0, x1, x2, tx);
        var y = quadraticAt(y0, y1, y2, ty);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x2, x);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y2, y);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x2, x);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y2, y);
    }
    function $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
        var vec2Min = (0, parcelRequire("eLEew")).min;
        var vec2Max = (0, parcelRequire("eLEew")).max;
        var diff = Math.abs(startAngle - endAngle);
        if (diff % $0c584d4e3f9e2fa0$var$PI2 < 1e-4 && diff > 1e-4) {
            min[0] = x - rx;
            min[1] = y - ry;
            max[0] = x + rx;
            max[1] = y + ry;
            return;
        }
        $0c584d4e3f9e2fa0$var$start[0] = $0c584d4e3f9e2fa0$var$mathCos(startAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$start[1] = $0c584d4e3f9e2fa0$var$mathSin(startAngle) * ry + y;
        $0c584d4e3f9e2fa0$var$end[0] = $0c584d4e3f9e2fa0$var$mathCos(endAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$end[1] = $0c584d4e3f9e2fa0$var$mathSin(endAngle) * ry + y;
        vec2Min(min, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        vec2Max(max, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        startAngle = startAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle < 0) startAngle = startAngle + $0c584d4e3f9e2fa0$var$PI2;
        endAngle = endAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (endAngle < 0) endAngle = endAngle + $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle > endAngle && !anticlockwise) endAngle += $0c584d4e3f9e2fa0$var$PI2;
        else if (startAngle < endAngle && anticlockwise) startAngle += $0c584d4e3f9e2fa0$var$PI2;
        if (anticlockwise) {
            var tmp = endAngle;
            endAngle = startAngle;
            startAngle = tmp;
        }
        for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
            $0c584d4e3f9e2fa0$var$extremity[0] = $0c584d4e3f9e2fa0$var$mathCos(angle) * rx + x;
            $0c584d4e3f9e2fa0$var$extremity[1] = $0c584d4e3f9e2fa0$var$mathSin(angle) * ry + y;
            vec2Min(min, $0c584d4e3f9e2fa0$var$extremity, min);
            vec2Max(max, $0c584d4e3f9e2fa0$var$extremity, max);
        }
    }
});
parcelRegister("dr1jo", function(module, exports) {
    $parcel$export(module.exports, "cubicAt", ()=>$9c7ed07589dafe64$export$547c21de482bbcb2);
    $parcel$export(module.exports, "cubicDerivativeAt", ()=>$9c7ed07589dafe64$export$55fce925c60b6271);
    $parcel$export(module.exports, "cubicRootAt", ()=>$9c7ed07589dafe64$export$ca5d13faa10b167e);
    $parcel$export(module.exports, "cubicExtrema", ()=>$9c7ed07589dafe64$export$df1a172f100d0457);
    $parcel$export(module.exports, "cubicSubdivide", ()=>$9c7ed07589dafe64$export$a2ee23a0567039da);
    $parcel$export(module.exports, "cubicProjectPoint", ()=>$9c7ed07589dafe64$export$dbaa3801d1284367);
    $parcel$export(module.exports, "cubicLength", ()=>$9c7ed07589dafe64$export$af1875d576f60d7c);
    $parcel$export(module.exports, "quadraticAt", ()=>$9c7ed07589dafe64$export$af17094a950f5073);
    $parcel$export(module.exports, "quadraticDerivativeAt", ()=>$9c7ed07589dafe64$export$7e161e77e6fff8cb);
    $parcel$export(module.exports, "quadraticRootAt", ()=>$9c7ed07589dafe64$export$fd895ac7ee764967);
    $parcel$export(module.exports, "quadraticExtremum", ()=>$9c7ed07589dafe64$export$752e1f8c6e7f7e11);
    $parcel$export(module.exports, "quadraticSubdivide", ()=>$9c7ed07589dafe64$export$117c659e21a7a060);
    $parcel$export(module.exports, "quadraticProjectPoint", ()=>$9c7ed07589dafe64$export$81915a594fe10dee);
    $parcel$export(module.exports, "quadraticLength", ()=>$9c7ed07589dafe64$export$8a68adee46f3cf55);
    var $eLEew;
    var $9c7ed07589dafe64$var$mathPow = Math.pow;
    var $9c7ed07589dafe64$var$mathSqrt = Math.sqrt;
    var $9c7ed07589dafe64$var$EPSILON = 1e-8;
    var $9c7ed07589dafe64$var$EPSILON_NUMERIC = 1e-4;
    var $9c7ed07589dafe64$var$THREE_SQRT = $9c7ed07589dafe64$var$mathSqrt(3);
    var $9c7ed07589dafe64$var$ONE_THIRD = 1 / 3;
    var $9c7ed07589dafe64$var$_v0 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v1 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v2 = (0, (0, parcelRequire("eLEew")).create)();
    function $9c7ed07589dafe64$var$isAroundZero(val) {
        return val > -$9c7ed07589dafe64$var$EPSILON && val < $9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$var$isNotAroundZero(val) {
        return val > $9c7ed07589dafe64$var$EPSILON || val < -$9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
    }
    function $9c7ed07589dafe64$export$55fce925c60b6271(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
    }
    function $9c7ed07589dafe64$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
        var a = p3 + 3 * (p1 - p2) - p0;
        var b = 3 * (p2 - p1 * 2 + p0);
        var c = 3 * (p1 - p0);
        var d = p0 - val;
        var A = b * b - 3 * a * c;
        var B = b * c - 9 * a * d;
        var C = c * c - 3 * b * d;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(A) && $9c7ed07589dafe64$var$isAroundZero(B)) {
            if ($9c7ed07589dafe64$var$isAroundZero(b)) roots[0] = 0;
            else {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = B * B - 4 * A * C;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var K = B / A;
                var t1 = -b / a + K;
                var t2 = -K / 2;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var Y1 = A * b + 1.5 * a * (-B + discSqrt);
                var Y2 = A * b + 1.5 * a * (-B - discSqrt);
                if (Y1 < 0) Y1 = -$9c7ed07589dafe64$var$mathPow(-Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y1 = $9c7ed07589dafe64$var$mathPow(Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                if (Y2 < 0) Y2 = -$9c7ed07589dafe64$var$mathPow(-Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y2 = $9c7ed07589dafe64$var$mathPow(Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                var t1 = (-b - (Y1 + Y2)) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else {
                var T = (2 * A * b - 3 * a * B) / (2 * $9c7ed07589dafe64$var$mathSqrt(A * A * A));
                var theta = Math.acos(T) / 3;
                var ASqrt = $9c7ed07589dafe64$var$mathSqrt(A);
                var tmp = Math.cos(theta);
                var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
                var t2 = (-b + ASqrt * (tmp + $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                var t3 = (-b + ASqrt * (tmp - $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
                if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
        var b = 6 * p2 - 12 * p1 + 6 * p0;
        var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
        var c = 3 * p1 - 3 * p0;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
            else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
                if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p23 = (p3 - p2) * t + p2;
        var p012 = (p12 - p01) * t + p01;
        var p123 = (p23 - p12) * t + p12;
        var p0123 = (p123 - p012) * t + p012;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p0123;
        out[4] = p0123;
        out[5] = p123;
        out[6] = p23;
        out[7] = p3;
    }
    function $9c7ed07589dafe64$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        var prev;
        var next;
        var d1;
        var d2;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            prev = t - interval;
            next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, next);
                d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            out[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            var y = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
    function $9c7ed07589dafe64$export$af17094a950f5073(p0, p1, p2, t) {
        var onet = 1 - t;
        return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
    }
    function $9c7ed07589dafe64$export$7e161e77e6fff8cb(p0, p1, p2, t) {
        return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
    }
    function $9c7ed07589dafe64$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
        var a = p0 - 2 * p1 + p2;
        var b = 2 * (p1 - p0);
        var c = p0 - val;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var t1 = -b / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$752e1f8c6e7f7e11(p0, p1, p2) {
        var divider = p0 + p2 - 2 * p1;
        if (divider === 0) return 0.5;
        else return (p0 - p1) / divider;
    }
    function $9c7ed07589dafe64$export$117c659e21a7a060(p0, p1, p2, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p012 = (p12 - p01) * t + p01;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p012;
        out[4] = p12;
        out[5] = p2;
    }
    function $9c7ed07589dafe64$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, _t);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            var prev = t - interval;
            var next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, prev);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, next);
                var d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            out[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            var y = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
});
parcelRegister("k3yEY", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$e99ef93372091697$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "containStroke", ()=>$e99ef93372091697$export$8d36b1b5d19157c5);
    var $aA4Ws;
    var $1oALq;
    var $bTFCK;
    var $1nzVA;
    var $69jpm;
    var $dr1jo;
    var $3Ytji;
    var $e99ef93372091697$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $e99ef93372091697$var$PI2 = Math.PI * 2;
    var $e99ef93372091697$var$EPSILON = 1e-4;
    function $e99ef93372091697$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $e99ef93372091697$var$EPSILON;
    }
    var $e99ef93372091697$var$roots = [
        -1,
        -1,
        -1
    ];
    var $e99ef93372091697$var$extrema = [
        -1,
        -1
    ];
    function $e99ef93372091697$var$swapExtrema() {
        var tmp = $e99ef93372091697$var$extrema[0];
        $e99ef93372091697$var$extrema[0] = $e99ef93372091697$var$extrema[1];
        $e99ef93372091697$var$extrema[1] = tmp;
    }
    function $e99ef93372091697$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
        if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).cubicRootAt(y0, y1, y2, y3, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var w = 0;
            var nExtrema = -1;
            var y0_ = void 0;
            var y1_ = void 0;
            for(var i = 0; i < nRoots; i++){
                var t = $e99ef93372091697$var$roots[i];
                var unit = t === 0 || t === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).cubicAt(x0, x1, x2, x3, t);
                if (x_ < x) continue;
                if (nExtrema < 0) {
                    nExtrema = (0, parcelRequire("dr1jo")).cubicExtrema(y0, y1, y2, y3, $e99ef93372091697$var$extrema);
                    if ($e99ef93372091697$var$extrema[1] < $e99ef93372091697$var$extrema[0] && nExtrema > 1) $e99ef93372091697$var$swapExtrema();
                    y0_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[0]);
                    if (nExtrema > 1) y1_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[1]);
                }
                if (nExtrema === 2) {
                    if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                    else if (t < $e99ef93372091697$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                    else w += y3 < y1_ ? unit : -unit;
                } else if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else w += y3 < y0_ ? unit : -unit;
            }
            return w;
        }
    }
    function $e99ef93372091697$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
        if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).quadraticRootAt(y0, y1, y2, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var t = (0, parcelRequire("dr1jo")).quadraticExtremum(y0, y1, y2);
            if (t >= 0 && t <= 1) {
                var w = 0;
                var y_ = (0, parcelRequire("dr1jo")).quadraticAt(y0, y1, y2, t);
                for(var i = 0; i < nRoots; i++){
                    var unit = $e99ef93372091697$var$roots[i] === 0 || $e99ef93372091697$var$roots[i] === 1 ? 0.5 : 1;
                    var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[i]);
                    if (x_ < x) continue;
                    if ($e99ef93372091697$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                    else w += y2 < y_ ? unit : -unit;
                }
                return w;
            } else {
                var unit = $e99ef93372091697$var$roots[0] === 0 || $e99ef93372091697$var$roots[0] === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[0]);
                if (x_ < x) return 0;
                return y2 < y0 ? unit : -unit;
            }
        }
    }
    function $e99ef93372091697$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
        y -= cy;
        if (y > r || y < -r) return 0;
        var tmp = Math.sqrt(r * r - y * y);
        $e99ef93372091697$var$roots[0] = -tmp;
        $e99ef93372091697$var$roots[1] = tmp;
        var dTheta = Math.abs(startAngle - endAngle);
        if (dTheta < 1e-4) return 0;
        if (dTheta >= $e99ef93372091697$var$PI2 - 1e-4) {
            startAngle = 0;
            endAngle = $e99ef93372091697$var$PI2;
            var dir = anticlockwise ? 1 : -1;
            if (x >= $e99ef93372091697$var$roots[0] + cx && x <= $e99ef93372091697$var$roots[1] + cx) return dir;
            else return 0;
        }
        if (startAngle > endAngle) {
            var tmp_1 = startAngle;
            startAngle = endAngle;
            endAngle = tmp_1;
        }
        if (startAngle < 0) {
            startAngle += $e99ef93372091697$var$PI2;
            endAngle += $e99ef93372091697$var$PI2;
        }
        var w = 0;
        for(var i = 0; i < 2; i++){
            var x_ = $e99ef93372091697$var$roots[i];
            if (x_ + cx > x) {
                var angle = Math.atan2(y, x_);
                var dir = anticlockwise ? 1 : -1;
                if (angle < 0) angle = $e99ef93372091697$var$PI2 + angle;
                if (angle >= startAngle && angle <= endAngle || angle + $e99ef93372091697$var$PI2 >= startAngle && angle + $e99ef93372091697$var$PI2 <= endAngle) {
                    if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                    w += dir;
                }
            }
        }
        return w;
    }
    function $e99ef93372091697$var$containPath(path, lineWidth, isStroke, x, y) {
        var data = path.data;
        var len = path.len();
        var w = 0;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (cmd === $e99ef93372091697$var$CMD.M && i > 1) {
                if (!isStroke) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
            }
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $e99ef93372091697$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $e99ef93372091697$var$CMD.L:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.C:
                    if (isStroke) {
                        if ((0, parcelRequire("bTFCK")).containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.Q:
                    if (isStroke) {
                        if ((0, parcelRequire("1nzVA")).containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (!isFirst) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x1, y1, x, y);
                    else {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    if (isStroke) {
                        if ((0, parcelRequire("69jpm")).containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                    } else w += $e99ef93372091697$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $e99ef93372091697$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    x1 = x0 + width;
                    y1 = y0 + height;
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(x0, y0, x1, y0, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y0, x1, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y1, x0, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                    } else {
                        w += (0, (0, parcelRequire("3Ytji")).default)(x1, y0, x1, y1, x, y);
                        w += (0, (0, parcelRequire("3Ytji")).default)(x0, y1, x0, y0, x, y);
                    }
                    break;
                case $e99ef93372091697$var$CMD.Z:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
                    xi = x0;
                    yi = y0;
                    break;
            }
        }
        if (!isStroke && !$e99ef93372091697$var$isAroundEqual(yi, y0)) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y) || 0;
        return w !== 0;
    }
    function $e99ef93372091697$export$8893e2b90ba10d92(pathProxy, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, 0, false, x, y);
    }
    function $e99ef93372091697$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, lineWidth, true, x, y);
    }
});
parcelRegister("1oALq", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$10448ce251a929f8$export$8d36b1b5d19157c5);
    function $10448ce251a929f8$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        var _a = 0;
        var _b = x0;
        if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
        if (x0 !== x1) {
            _a = (y0 - y1) / (x0 - x1);
            _b = (x0 * y1 - x1 * y0) / (x0 - x1);
        } else return Math.abs(x - x0) <= _l / 2;
        var tmp = _a * x - y + _b;
        var _s = tmp * tmp / (_a * _a + 1);
        return _s <= _l / 2 * _l / 2;
    }
});
parcelRegister("bTFCK", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$8a951e6f66d6987a$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $8a951e6f66d6987a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
        var d = (0, parcelRequire("dr1jo")).cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("1nzVA", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$1013ceeba79e2375$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $1013ceeba79e2375$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
        var d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("69jpm", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$47a2a3596d9bac74$export$8d36b1b5d19157c5);
    var $kvt3T;
    var $47a2a3596d9bac74$var$PI2 = Math.PI * 2;
    function $47a2a3596d9bac74$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        if (d - _l > r || d + _l < r) return false;
        if (Math.abs(startAngle - endAngle) % $47a2a3596d9bac74$var$PI2 < 1e-4) return true;
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $47a2a3596d9bac74$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $47a2a3596d9bac74$var$PI2;
        return angle >= startAngle && angle <= endAngle || angle + $47a2a3596d9bac74$var$PI2 >= startAngle && angle + $47a2a3596d9bac74$var$PI2 <= endAngle;
    }
});
parcelRegister("kvt3T", function(module, exports) {
    $parcel$export(module.exports, "normalizeRadian", ()=>$eedd3ef967ea7890$export$d44861331f213635);
    var $eedd3ef967ea7890$var$PI2 = Math.PI * 2;
    function $eedd3ef967ea7890$export$d44861331f213635(angle) {
        angle %= $eedd3ef967ea7890$var$PI2;
        if (angle < 0) angle += $eedd3ef967ea7890$var$PI2;
        return angle;
    }
});
parcelRegister("3Ytji", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4db612d32f7532$export$2e2bcd8739ae039);
    function $2e4db612d32f7532$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
        if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
        if (y1 === y0) return 0;
        var t = (y - y0) / (y1 - y0);
        var dir = y1 < y0 ? 1 : -1;
        if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
        var x_ = t * (x1 - x0) + x0;
        return x_ === x ? Infinity : x_ > x ? dir : 0;
    }
});
parcelRegister("gcbBH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bca6c53e2dabf533$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $bahqM;
    var $bca6c53e2dabf533$export$8993f922aeeac642 = (0, (0, parcelRequire("bahqM")).defaults)({
        x: 0,
        y: 0
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bca6c53e2dabf533$export$4aba8ad70847a488 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            x: true,
            y: true,
            width: true,
            height: true,
            sx: true,
            sy: true,
            sWidth: true,
            sHeight: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    function $bca6c53e2dabf533$var$isImageLike(source) {
        return !!(source && typeof source !== 'string' && source.width && source.height);
    }
    var $bca6c53e2dabf533$var$ZRImage = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRImage, _super);
        function ZRImage() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ZRImage.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bca6c53e2dabf533$export$8993f922aeeac642, obj);
        };
        ZRImage.prototype._getSize = function(dim) {
            var style = this.style;
            var size = style[dim];
            if (size != null) return size;
            var imageSource = $bca6c53e2dabf533$var$isImageLike(style.image) ? style.image : this.__image;
            if (!imageSource) return 0;
            var otherDim = dim === 'width' ? 'height' : 'width';
            var otherDimSize = style[otherDim];
            if (otherDimSize == null) return imageSource[dim];
            else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
        };
        ZRImage.prototype.getWidth = function() {
            return this._getSize('width');
        };
        ZRImage.prototype.getHeight = function() {
            return this._getSize('height');
        };
        ZRImage.prototype.getAnimationStyleProps = function() {
            return $bca6c53e2dabf533$export$4aba8ad70847a488;
        };
        ZRImage.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) this._rect = new (0, (0, parcelRequire("1E3E8")).default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
            return this._rect;
        };
        return ZRImage;
    }((0, (0, parcelRequire("lBQ88")).default));
    $bca6c53e2dabf533$var$ZRImage.prototype.type = 'image';
    var $bca6c53e2dabf533$export$2e2bcd8739ae039 = $bca6c53e2dabf533$var$ZRImage;
});
parcelRegister("7Tw7u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bf695c646bd738a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $7AySl;
    var $2az2p;
    var $5bf695c646bd738a$export$51140d6b71bb4ed5 = function() {
        function RectShape() {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
        }
        return RectShape;
    }();
    var $5bf695c646bd738a$var$subPixelOptimizeOutputShape = {};
    var $5bf695c646bd738a$var$Rect = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Rect, _super);
        function Rect(opts) {
            return _super.call(this, opts) || this;
        }
        Rect.prototype.getDefaultShape = function() {
            return new $5bf695c646bd738a$export$51140d6b71bb4ed5();
        };
        Rect.prototype.buildPath = function(ctx, shape) {
            var x;
            var y;
            var width;
            var height;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeRect)($5bf695c646bd738a$var$subPixelOptimizeOutputShape, shape, this.style);
                x = optimizedShape.x;
                y = optimizedShape.y;
                width = optimizedShape.width;
                height = optimizedShape.height;
                optimizedShape.r = shape.r;
                shape = optimizedShape;
            } else {
                x = shape.x;
                y = shape.y;
                width = shape.width;
                height = shape.height;
            }
            if (!shape.r) ctx.rect(x, y, width, height);
            else (0, parcelRequire("7AySl")).buildPath(ctx, shape);
        };
        Rect.prototype.isZeroArea = function() {
            return !this.shape.width || !this.shape.height;
        };
        return Rect;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $5bf695c646bd738a$var$Rect.prototype.type = 'rect';
    var $5bf695c646bd738a$export$2e2bcd8739ae039 = $5bf695c646bd738a$var$Rect;
});
parcelRegister("7AySl", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$5866f2ba314594b2$export$5cc7f731b5937e99);
    function $5866f2ba314594b2$export$5cc7f731b5937e99(ctx, shape) {
        var x = shape.x;
        var y = shape.y;
        var width = shape.width;
        var height = shape.height;
        var r = shape.r;
        var r1;
        var r2;
        var r3;
        var r4;
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
        else if (r instanceof Array) {
            if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
            else if (r.length === 2) {
                r1 = r3 = r[0];
                r2 = r4 = r[1];
            } else if (r.length === 3) {
                r1 = r[0];
                r2 = r4 = r[1];
                r3 = r[2];
            } else {
                r1 = r[0];
                r2 = r[1];
                r3 = r[2];
                r4 = r[3];
            }
        } else r1 = r2 = r3 = r4 = 0;
        var total;
        if (r1 + r2 > width) {
            total = r1 + r2;
            r1 *= width / total;
            r2 *= width / total;
        }
        if (r3 + r4 > width) {
            total = r3 + r4;
            r3 *= width / total;
            r4 *= width / total;
        }
        if (r2 + r3 > height) {
            total = r2 + r3;
            r2 *= height / total;
            r3 *= height / total;
        }
        if (r1 + r4 > height) {
            total = r1 + r4;
            r1 *= height / total;
            r4 *= height / total;
        }
        ctx.moveTo(x + r1, y);
        ctx.lineTo(x + width - r2, y);
        r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
        ctx.lineTo(x + width, y + height - r3);
        r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
        ctx.lineTo(x + r4, y + height);
        r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
        ctx.lineTo(x, y + r1);
        r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    }
});
parcelRegister("2az2p", function(module, exports) {
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$1947b1c1b6b500f1$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$1947b1c1b6b500f1$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$1947b1c1b6b500f1$export$60e2aa74957d0b9d);
    var $1947b1c1b6b500f1$var$round = Math.round;
    function $1947b1c1b6b500f1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
        if (!inputShape) return;
        var x1 = inputShape.x1;
        var x2 = inputShape.x2;
        var y1 = inputShape.y1;
        var y2 = inputShape.y2;
        outputShape.x1 = x1;
        outputShape.x2 = x2;
        outputShape.y1 = y1;
        outputShape.y2 = y2;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        if ($1947b1c1b6b500f1$var$round(x1 * 2) === $1947b1c1b6b500f1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
        if ($1947b1c1b6b500f1$var$round(y1 * 2) === $1947b1c1b6b500f1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
        if (!inputShape) return;
        var originX = inputShape.x;
        var originY = inputShape.y;
        var originWidth = inputShape.width;
        var originHeight = inputShape.height;
        outputShape.x = originX;
        outputShape.y = originY;
        outputShape.width = originWidth;
        outputShape.height = originHeight;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        outputShape.x = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
        outputShape.y = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
        outputShape.width = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
        outputShape.height = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
        if (!lineWidth) return position;
        var doubledPosition = $1947b1c1b6b500f1$var$round(position * 2);
        return (doubledPosition + $1947b1c1b6b500f1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
    }
});
parcelRegister("fIXXx", function(module, exports) {
    $parcel$export(module.exports, "HOVER_STATE_BLUR", ()=>$b72979b7cd946cce$export$1307d6a87d56baa);
    $parcel$export(module.exports, "HOVER_STATE_EMPHASIS", ()=>$b72979b7cd946cce$export$f0f2bee145debb31);
    $parcel$export(module.exports, "SPECIAL_STATES", ()=>$b72979b7cd946cce$export$151308dceb52d5b);
    $parcel$export(module.exports, "DISPLAY_STATES", ()=>$b72979b7cd946cce$export$57ee5306b85ad7d5);
    $parcel$export(module.exports, "Z2_EMPHASIS_LIFT", ()=>$b72979b7cd946cce$export$1cb9fc6ed5b9836c);
    $parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$df035d873a9de64f);
    $parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", ()=>$b72979b7cd946cce$export$f8a2f7807cc185ea);
    $parcel$export(module.exports, "SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$89616263e7d38fe9);
    $parcel$export(module.exports, "UNSELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$7636ad95c0f68a79);
    $parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$1e90ed8a25542516);
    $parcel$export(module.exports, "setStatesFlag", ()=>$b72979b7cd946cce$export$868ba38adffa9e39);
    $parcel$export(module.exports, "setDefaultStateProxy", ()=>$b72979b7cd946cce$export$20f39bbe322fb9ab);
    $parcel$export(module.exports, "enterEmphasis", ()=>$b72979b7cd946cce$export$b2d02638cc34c042);
    $parcel$export(module.exports, "leaveEmphasis", ()=>$b72979b7cd946cce$export$11be6f716239ac55);
    $parcel$export(module.exports, "enterBlur", ()=>$b72979b7cd946cce$export$207f9cb3e1099375);
    $parcel$export(module.exports, "leaveBlur", ()=>$b72979b7cd946cce$export$fd4a9ec75456d3c1);
    $parcel$export(module.exports, "enterSelect", ()=>$b72979b7cd946cce$export$252d028dda8ef765);
    $parcel$export(module.exports, "leaveSelect", ()=>$b72979b7cd946cce$export$ea9a904bd6e32bd3);
    $parcel$export(module.exports, "allLeaveBlur", ()=>$b72979b7cd946cce$export$b2a593c7b5243584);
    $parcel$export(module.exports, "blurComponent", ()=>$b72979b7cd946cce$export$569da03256c8a55f);
    $parcel$export(module.exports, "blurSeriesFromHighlightPayload", ()=>$b72979b7cd946cce$export$64f1fd4daefef21b);
    $parcel$export(module.exports, "findComponentHighDownDispatchers", ()=>$b72979b7cd946cce$export$f31a644ccca0ef23);
    $parcel$export(module.exports, "handleGlobalMouseOverForHighDown", ()=>$b72979b7cd946cce$export$416765b6198234ff);
    $parcel$export(module.exports, "handleGlboalMouseOutForHighDown", ()=>$b72979b7cd946cce$export$2cbc9e6f4b583c84);
    $parcel$export(module.exports, "toggleSelectionFromPayload", ()=>$b72979b7cd946cce$export$1c7d489f62372d73);
    $parcel$export(module.exports, "isSelectChangePayload", ()=>$b72979b7cd946cce$export$72aea10e60e45351);
    $parcel$export(module.exports, "updateSeriesElementSelection", ()=>$b72979b7cd946cce$export$e4ea08ef52e0a73);
    $parcel$export(module.exports, "getAllSelectedIndices", ()=>$b72979b7cd946cce$export$c529643b619af6b3);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>$b72979b7cd946cce$export$5f393df0b5aee2e7);
    $parcel$export(module.exports, "setAsHighDownDispatcher", ()=>$b72979b7cd946cce$export$9ba15aea1e048d48);
    $parcel$export(module.exports, "enableHoverFocus", ()=>$b72979b7cd946cce$export$24972466b2b62ac2);
    $parcel$export(module.exports, "setStatesStylesFromModel", ()=>$b72979b7cd946cce$export$48b68047d330bbc9);
    $parcel$export(module.exports, "isHighDownDispatcher", ()=>$b72979b7cd946cce$export$77d1445f699c58b5);
    $parcel$export(module.exports, "enableComponentHighDownFeatures", ()=>$b72979b7cd946cce$export$4da05a9639f01954);
    $parcel$export(module.exports, "getHighlightDigit", ()=>$b72979b7cd946cce$export$824af40eb714530d);
    $parcel$export(module.exports, "isHighDownPayload", ()=>$b72979b7cd946cce$export$aebe71265c1b77bf);
    $parcel$export(module.exports, "savePathStates", ()=>$b72979b7cd946cce$export$9fe78019e6f395b6);
    var $h4RuA;
    var $bahqM;
    var $7QjoM;
    var $d6udH;
    var $eaKsF;
    var $ghQ8v;
    var $b72979b7cd946cce$var$_highlightNextDigit = 1;
    var $b72979b7cd946cce$var$_highlightKeyMap = {};
    var $b72979b7cd946cce$var$getSavedStates = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b72979b7cd946cce$export$5542daa30722333e = 0;
    var $b72979b7cd946cce$export$1307d6a87d56baa = 1;
    var $b72979b7cd946cce$export$f0f2bee145debb31 = 2;
    var $b72979b7cd946cce$export$151308dceb52d5b = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$57ee5306b85ad7d5 = [
        'normal',
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$1cb9fc6ed5b9836c = 10;
    var $b72979b7cd946cce$export$3a2f97d39514bbc = 9;
    var $b72979b7cd946cce$export$df035d873a9de64f = 'highlight';
    var $b72979b7cd946cce$export$f8a2f7807cc185ea = 'downplay';
    var $b72979b7cd946cce$export$89616263e7d38fe9 = 'select';
    var $b72979b7cd946cce$export$7636ad95c0f68a79 = 'unselect';
    var $b72979b7cd946cce$export$1e90ed8a25542516 = 'toggleSelect';
    function $b72979b7cd946cce$var$hasFillOrStroke(fillOrStroke) {
        return fillOrStroke != null && fillOrStroke !== 'none';
    }
    var $b72979b7cd946cce$var$liftedColorCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    function $b72979b7cd946cce$var$liftColor(color) {
        if (typeof color !== 'string') return color;
        var liftedColor = $b72979b7cd946cce$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = (0, parcelRequire("d6udH")).lift(color, -0.1);
            $b72979b7cd946cce$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    }
    function $b72979b7cd946cce$var$doChangeHoverState(el, stateName, hoverStateEnum) {
        if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
        el.hoverState = hoverStateEnum;
    }
    function $b72979b7cd946cce$var$singleEnterEmphasis(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'emphasis', $b72979b7cd946cce$export$f0f2bee145debb31);
    }
    function $b72979b7cd946cce$var$singleLeaveEmphasis(el) {
        if (el.hoverState === $b72979b7cd946cce$export$f0f2bee145debb31) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterBlur(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'blur', $b72979b7cd946cce$export$1307d6a87d56baa);
    }
    function $b72979b7cd946cce$var$singleLeaveBlur(el) {
        if (el.hoverState === $b72979b7cd946cce$export$1307d6a87d56baa) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterSelect(el) {
        el.selected = true;
    }
    function $b72979b7cd946cce$var$singleLeaveSelect(el) {
        el.selected = false;
    }
    function $b72979b7cd946cce$var$updateElementState(el, updater, commonParam) {
        updater(el, commonParam);
    }
    function $b72979b7cd946cce$var$traverseUpdateState(el, updater, commonParam) {
        $b72979b7cd946cce$var$updateElementState(el, updater, commonParam);
        el.isGroup && el.traverse(function(child) {
            $b72979b7cd946cce$var$updateElementState(child, updater, commonParam);
        });
    }
    function $b72979b7cd946cce$export$868ba38adffa9e39(el, stateName) {
        switch(stateName){
            case 'emphasis':
                el.hoverState = $b72979b7cd946cce$export$f0f2bee145debb31;
                break;
            case 'normal':
                el.hoverState = $b72979b7cd946cce$export$5542daa30722333e;
                break;
            case 'blur':
                el.hoverState = $b72979b7cd946cce$export$1307d6a87d56baa;
                break;
            case 'select':
                el.selected = true;
        }
    }
    function $b72979b7cd946cce$export$35330f949342a669(el) {
        if (el.isGroup) el.traverse(function(child) {
            child.clearStates();
        });
        else el.clearStates();
    }
    function $b72979b7cd946cce$var$getFromStateStyle(el, props, toStateName, defaultValue) {
        var style = el.style;
        var fromState = {};
        for(var i = 0; i < props.length; i++){
            var propName = props[i];
            var val = style[propName];
            fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
        }
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
        }
        return fromState;
    }
    function $b72979b7cd946cce$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
        var hasSelect = targetStates && (0, (0, parcelRequire("bahqM")).indexOf)(targetStates, 'select') >= 0;
        var cloned = false;
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            var store = $b72979b7cd946cce$var$getSavedStates(el);
            var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
            var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
            if ($b72979b7cd946cce$var$hasFillOrStroke(fromFill) || $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                state = state || {};
                var emphasisStyle = state.style || {};
                if (emphasisStyle.fill === 'inherit') {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = fromFill;
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.fill) && $b72979b7cd946cce$var$hasFillOrStroke(fromFill)) {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = $b72979b7cd946cce$var$liftColor(fromFill);
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.stroke) && $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                    if (!cloned) {
                        state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                        emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    }
                    emphasisStyle.stroke = $b72979b7cd946cce$var$liftColor(fromStroke);
                }
                state.style = emphasisStyle;
            }
        }
        if (state) {
            if (state.z2 == null) {
                if (!cloned) state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2EmphasisLift = el.z2EmphasisLift;
                state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createSelectDefaultState(el, stateName, state) {
        if (state) {
            if (state.z2 == null) {
                state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2SelectLift = el.z2SelectLift;
                state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b72979b7cd946cce$export$3a2f97d39514bbc);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createBlurDefaultState(el, stateName, state) {
        var hasBlur = (0, (0, parcelRequire("bahqM")).indexOf)(el.currentStates, stateName) >= 0;
        var currentOpacity = el.style.opacity;
        var fromState = !hasBlur ? $b72979b7cd946cce$var$getFromStateStyle(el, [
            'opacity'
        ], stateName, {
            opacity: 1
        }) : null;
        state = state || {};
        var blurStyle = state.style || {};
        if (blurStyle.opacity == null) {
            state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
            blurStyle = (0, (0, parcelRequire("bahqM")).extend)({
                opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
            }, blurStyle);
            state.style = blurStyle;
        }
        return state;
    }
    function $b72979b7cd946cce$var$elementStateProxy(stateName, targetStates) {
        var state = this.states[stateName];
        if (this.style) {
            if (stateName === 'emphasis') return $b72979b7cd946cce$var$createEmphasisDefaultState(this, stateName, targetStates, state);
            else if (stateName === 'blur') return $b72979b7cd946cce$var$createBlurDefaultState(this, stateName, state);
            else if (stateName === 'select') return $b72979b7cd946cce$var$createSelectDefaultState(this, stateName, state);
        }
        return state;
    }
    function $b72979b7cd946cce$export$20f39bbe322fb9ab(el) {
        el.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        var textContent = el.getTextContent();
        var textGuide = el.getTextGuideLine();
        if (textContent) textContent.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        if (textGuide) textGuide.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    }
    function $b72979b7cd946cce$export$d899507e2598e4ae(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$784cba1f7fe58cca(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$b2d02638cc34c042(el, highlightDigit) {
        el.__highByOuter |= 1 << (highlightDigit || 0);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$11be6f716239ac55(el, highlightDigit) {
        !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$207f9cb3e1099375(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterBlur);
    }
    function $b72979b7cd946cce$export$fd4a9ec75456d3c1(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveBlur);
    }
    function $b72979b7cd946cce$export$252d028dda8ef765(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterSelect);
    }
    function $b72979b7cd946cce$export$ea9a904bd6e32bd3(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveSelect);
    }
    function $b72979b7cd946cce$var$shouldSilent(el, e) {
        return el.__highDownSilentOnTouch && e.zrByTouch;
    }
    function $b72979b7cd946cce$export$b2a593c7b5243584(api) {
        var model = api.getModel();
        model.eachComponent(function(componentType, componentModel) {
            var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
            view.group.traverse(function(child) {
                $b72979b7cd946cce$var$singleLeaveBlur(child);
            });
        });
    }
    function $b72979b7cd946cce$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
        var ecModel = api.getModel();
        blurScope = blurScope || 'coordinateSystem';
        function leaveBlurOfIndices(data, dataIndices) {
            for(var i = 0; i < dataIndices.length; i++){
                var itemEl = data.getItemGraphicEl(dataIndices[i]);
                itemEl && $b72979b7cd946cce$export$fd4a9ec75456d3c1(itemEl);
            }
        }
        if (targetSeriesIndex == null) return;
        if (!focus || focus === 'none') return;
        var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
        var targetCoordSys = targetSeriesModel.coordinateSystem;
        if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
        var blurredSeries = [];
        ecModel.eachSeries(function(seriesModel) {
            var sameSeries = targetSeriesModel === seriesModel;
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.master) coordSys = coordSys.master;
            var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries;
            if (!(blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
                var view = api.getViewOfSeriesModel(seriesModel);
                view.group.traverse(function(child) {
                    $b72979b7cd946cce$var$singleEnterBlur(child);
                });
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
                else if ((0, (0, parcelRequire("bahqM")).isObject)(focus)) {
                    var dataTypes = (0, (0, parcelRequire("bahqM")).keys)(focus);
                    for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
                }
                blurredSeries.push(seriesModel);
            }
        });
        ecModel.eachComponent(function(componentType, componentModel) {
            if (componentType === 'series') return;
            var view = api.getViewOfComponentModel(componentModel);
            if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
        });
    }
    function $b72979b7cd946cce$export$569da03256c8a55f(componentMainType, componentIndex, api) {
        if (componentMainType == null || componentIndex == null) return;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.focusBlurEnabled) return;
        view.group.traverse(function(child) {
            $b72979b7cd946cce$var$singleEnterBlur(child);
        });
    }
    function $b72979b7cd946cce$export$64f1fd4daefef21b(seriesModel, payload, api) {
        var seriesIndex = seriesModel.seriesIndex;
        var data = seriesModel.getData(payload.dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        dataIndex = ((0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
        var el = data.getItemGraphicEl(dataIndex);
        if (!el) {
            var count = data.count();
            var current = 0;
            while(!el && current < count)el = data.getItemGraphicEl(current++);
        }
        if (el) {
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
        } else {
            var focus_1 = seriesModel.get([
                'emphasis',
                'focus'
            ]);
            var blurScope = seriesModel.get([
                'emphasis',
                'blurScope'
            ]);
            if (focus_1 != null) $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
        }
    }
    function $b72979b7cd946cce$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
        var ret = {
            focusSelf: false,
            dispatchers: null
        };
        if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return ret;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.findHighDownDispatchers) return ret;
        var dispatchers = view.findHighDownDispatchers(name);
        var focusSelf;
        for(var i = 0; i < dispatchers.length; i++)if ((0, (0, parcelRequire("7QjoM")).getECData)(dispatchers[i]).focus === 'self') {
            focusSelf = true;
            break;
        }
        return {
            focusSelf: focusSelf,
            dispatchers: dispatchers
        };
    }
    function $b72979b7cd946cce$export$416765b6198234ff(dispatcher, e, api) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var _a = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
        if (dispatchers) {
            if (focusSelf) $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                return $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
            });
        } else {
            $b72979b7cd946cce$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
            if (ecData.focus === 'self') $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
        }
    }
    function $b72979b7cd946cce$export$2cbc9e6f4b583c84(dispatcher, e, api) {
        $b72979b7cd946cce$export$b2a593c7b5243584(api);
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var dispatchers = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
        if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
            return $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
        });
        else $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
    }
    function $b72979b7cd946cce$export$1c7d489f62372d73(seriesModel, payload, api) {
        if (!$b72979b7cd946cce$export$72aea10e60e45351(payload)) return;
        var dataType = payload.dataType;
        var data = seriesModel.getData(dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        if (!(0, (0, parcelRequire("bahqM")).isArray)(dataIndex)) dataIndex = [
            dataIndex
        ];
        seriesModel[payload.type === $b72979b7cd946cce$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b72979b7cd946cce$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
    }
    function $b72979b7cd946cce$export$e4ea08ef52e0a73(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            data.eachItemGraphicEl(function(el, idx) {
                seriesModel.isSelected(idx, type) ? $b72979b7cd946cce$export$252d028dda8ef765(el) : $b72979b7cd946cce$export$ea9a904bd6e32bd3(el);
            });
        });
    }
    function $b72979b7cd946cce$export$c529643b619af6b3(ecModel) {
        var ret = [];
        ecModel.eachSeries(function(seriesModel) {
            var allData = seriesModel.getAllData();
            (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
                var data = _a.data, type = _a.type;
                var dataIndices = seriesModel.getSelectedDataIndices();
                if (dataIndices.length > 0) {
                    var item = {
                        dataIndex: dataIndices,
                        seriesIndex: seriesModel.seriesIndex
                    };
                    if (type != null) item.dataType = type;
                    ret.push(item);
                }
            });
        });
        return ret;
    }
    function $b72979b7cd946cce$export$5f393df0b5aee2e7(el, focus, blurScope) {
        $b72979b7cd946cce$export$9ba15aea1e048d48(el, true);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$export$20f39bbe322fb9ab);
        $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope);
    }
    function $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        if (focus != null) {
            ecData.focus = focus;
            ecData.blurScope = blurScope;
        } else if (ecData.focus) ecData.focus = null;
    }
    var $b72979b7cd946cce$var$OTHER_STATES = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$var$defaultStyleGetterMap = {
        itemStyle: 'getItemStyle',
        lineStyle: 'getLineStyle',
        areaStyle: 'getAreaStyle'
    };
    function $b72979b7cd946cce$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
        styleType = styleType || 'itemStyle';
        for(var i = 0; i < $b72979b7cd946cce$var$OTHER_STATES.length; i++){
            var stateName = $b72979b7cd946cce$var$OTHER_STATES[i];
            var model = itemModel.getModel([
                stateName,
                styleType
            ]);
            var state = el.ensureState(stateName);
            state.style = getter ? getter(model) : model[$b72979b7cd946cce$var$defaultStyleGetterMap[styleType]]();
        }
    }
    function $b72979b7cd946cce$export$9ba15aea1e048d48(el, asDispatcher) {
        var disable = asDispatcher === false;
        var extendedEl = el;
        if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
        if (!disable || extendedEl.__highDownDispatcher) {
            extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
            extendedEl.__highDownDispatcher = !disable;
        }
    }
    function $b72979b7cd946cce$export$77d1445f699c58b5(el) {
        return !!(el && el.__highDownDispatcher);
    }
    function $b72979b7cd946cce$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        ecData.componentMainType = componentModel.mainType;
        ecData.componentIndex = componentModel.componentIndex;
        ecData.componentHighDownName = componentHighDownName;
    }
    function $b72979b7cd946cce$export$824af40eb714530d(highlightKey) {
        var highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey];
        if (highlightDigit == null && $b72979b7cd946cce$var$_highlightNextDigit <= 32) highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey] = $b72979b7cd946cce$var$_highlightNextDigit++;
        return highlightDigit;
    }
    function $b72979b7cd946cce$export$72aea10e60e45351(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$89616263e7d38fe9 || payloadType === $b72979b7cd946cce$export$7636ad95c0f68a79 || payloadType === $b72979b7cd946cce$export$1e90ed8a25542516;
    }
    function $b72979b7cd946cce$export$aebe71265c1b77bf(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$df035d873a9de64f || payloadType === $b72979b7cd946cce$export$f8a2f7807cc185ea;
    }
    function $b72979b7cd946cce$export$9fe78019e6f395b6(el) {
        var store = $b72979b7cd946cce$var$getSavedStates(el);
        store.normalFill = el.style.fill;
        store.normalStroke = el.style.stroke;
        var selectState = el.states.select || {};
        store.selectFill = selectState.style && selectState.style.fill || null;
        store.selectStroke = selectState.style && selectState.style.stroke || null;
    }
});
parcelRegister("7QjoM", function(module, exports) {
    $parcel$export(module.exports, "getECData", ()=>$5b5c6fe297852166$export$b1c39b2bacd1ddc2);
    $parcel$export(module.exports, "setCommonECData", ()=>$5b5c6fe297852166$export$30d6736ebb8e18d5);
    var $eaKsF;
    var $5b5c6fe297852166$export$b1c39b2bacd1ddc2 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $5b5c6fe297852166$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
        if (el) {
            var ecData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(el);
            ecData.dataIndex = dataIdx;
            ecData.dataType = dataType;
            ecData.seriesIndex = seriesIndex;
            if (el.type === 'group') el.traverse(function(child) {
                var childECData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(child);
                childECData.seriesIndex = seriesIndex;
                childECData.dataIndex = dataIdx;
                childECData.dataType = dataType;
            });
        }
    };
});
parcelRegister("eaKsF", function(module, exports) {
    $parcel$export(module.exports, "normalizeToArray", ()=>$a5160a25a687d9b6$export$4f07b212a02c8051);
    $parcel$export(module.exports, "defaultEmphasis", ()=>$a5160a25a687d9b6$export$abdcc6a26372f94b);
    $parcel$export(module.exports, "TEXT_STYLE_OPTIONS", ()=>$a5160a25a687d9b6$export$df45610347a602ad);
    $parcel$export(module.exports, "getDataItemValue", ()=>$a5160a25a687d9b6$export$2c944e12edb48d4b);
    $parcel$export(module.exports, "isDataItemOption", ()=>$a5160a25a687d9b6$export$3e1a543f33ef6883);
    $parcel$export(module.exports, "mappingToExists", ()=>$a5160a25a687d9b6$export$574f818966e4da87);
    $parcel$export(module.exports, "isComponentIdInternal", ()=>$a5160a25a687d9b6$export$feece3e7d52a102b);
    $parcel$export(module.exports, "convertOptionIdName", ()=>$a5160a25a687d9b6$export$fb1a222ba5dd6e51);
    $parcel$export(module.exports, "isNameSpecified", ()=>$a5160a25a687d9b6$export$beae19a2652b3368);
    $parcel$export(module.exports, "makeInternalComponentId", ()=>$a5160a25a687d9b6$export$1753133c42e665e8);
    $parcel$export(module.exports, "setComponentTypeToKeyInfo", ()=>$a5160a25a687d9b6$export$5ac61aca2ba0282d);
    $parcel$export(module.exports, "compressBatches", ()=>$a5160a25a687d9b6$export$6d12cabb0c9bf8e3);
    $parcel$export(module.exports, "queryDataIndex", ()=>$a5160a25a687d9b6$export$42b26cae8b8d10);
    $parcel$export(module.exports, "makeInner", ()=>$a5160a25a687d9b6$export$64df9f8d92ae083f);
    $parcel$export(module.exports, "parseFinder", ()=>$a5160a25a687d9b6$export$95de80076abac814);
    $parcel$export(module.exports, "preParseFinder", ()=>$a5160a25a687d9b6$export$fe600815775d9400);
    $parcel$export(module.exports, "queryReferringComponents", ()=>$a5160a25a687d9b6$export$dc741340f7e5f186);
    $parcel$export(module.exports, "SINGLE_REFERRING", ()=>$a5160a25a687d9b6$export$f076738ec84e693c);
    $parcel$export(module.exports, "MULTIPLE_REFERRING", ()=>$a5160a25a687d9b6$export$48d598924ce4892c);
    $parcel$export(module.exports, "setAttribute", ()=>$a5160a25a687d9b6$export$9fec4d97f1922e0b);
    $parcel$export(module.exports, "getAttribute", ()=>$a5160a25a687d9b6$export$735ee1799fd02602);
    $parcel$export(module.exports, "getTooltipRenderMode", ()=>$a5160a25a687d9b6$export$cc0a17a5d27b4e17);
    $parcel$export(module.exports, "groupData", ()=>$a5160a25a687d9b6$export$7ab5bda43e13168f);
    $parcel$export(module.exports, "interpolateRawValues", ()=>$a5160a25a687d9b6$export$bd0439821a1869f3);
    var $bahqM;
    var $hZfwb;
    var $jmSNG;
    var $hb2y5;
    var $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
    var $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
    function $a5160a25a687d9b6$export$4f07b212a02c8051(value) {
        return value instanceof Array ? value : value == null ? [] : [
            value
        ];
    }
    function $a5160a25a687d9b6$export$abdcc6a26372f94b(opt, key, subOpts) {
        if (opt) {
            opt[key] = opt[key] || {};
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[key] = opt.emphasis[key] || {};
            for(var i = 0, len = subOpts.length; i < len; i++){
                var subOptName = subOpts[i];
                if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
            }
        }
    }
    var $a5160a25a687d9b6$export$df45610347a602ad = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'rich',
        'tag',
        'color',
        'textBorderColor',
        'textBorderWidth',
        'width',
        'height',
        'lineHeight',
        'align',
        'verticalAlign',
        'baseline',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY',
        'backgroundColor',
        'borderColor',
        'borderWidth',
        'borderRadius',
        'padding'
    ];
    function $a5160a25a687d9b6$export$2c944e12edb48d4b(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(0, (0, parcelRequire("bahqM")).isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
    }
    function $a5160a25a687d9b6$export$3e1a543f33ef6883(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(dataItem instanceof Array);
    }
    function $a5160a25a687d9b6$export$574f818966e4da87(existings, newCmptOptions, mode) {
        var isNormalMergeMode = mode === 'normalMerge';
        var isReplaceMergeMode = mode === 'replaceMerge';
        var isReplaceAllMode = mode === 'replaceAll';
        existings = existings || [];
        newCmptOptions = (newCmptOptions || []).slice();
        var existingIdIdxMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(cmptOption)) {
                newCmptOptions[index] = null;
                return;
            }
        });
        var result = $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
        if (isNormalMergeMode) $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
        else if (isReplaceAllMode) $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions);
        $a5160a25a687d9b6$var$makeIdAndName(result);
        return result;
    }
    function $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode) {
        var result = [];
        if (mode === 'replaceAll') return result;
        for(var index = 0; index < existings.length; index++){
            var existing = existings[index];
            if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
            result.push({
                existing: mode === 'replaceMerge' || $a5160a25a687d9b6$export$feece3e7d52a102b(existing) ? null : existing,
                newOption: null,
                keyInfo: null,
                brandNew: null
            });
        }
        return result;
    }
    function $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.id == null) return;
            var optionId = $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id);
            var existingIdx = existingIdIdxMap.get(optionId);
            if (existingIdx != null) {
                var resultItem = result[existingIdx];
                (0, (0, parcelRequire("bahqM")).assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
                resultItem.newOption = cmptOption;
                resultItem.existing = existings[existingIdx];
                newCmptOptions[index] = null;
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.name == null) return;
            for(var i = 0; i < result.length; i++){
                var existing = result[i].existing;
                if (!result[i].newOption && existing && (existing.id == null || cmptOption.id == null) && !$a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) && !$a5160a25a687d9b6$export$feece3e7d52a102b(existing) && $a5160a25a687d9b6$var$keyExistAndEqual('name', existing, cmptOption)) {
                    result[i].newOption = cmptOption;
                    newCmptOptions[index] = null;
                    return;
                }
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, brandNew) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            if (!cmptOption) return;
            var resultItem;
            var nextIdx = 0;
            while((resultItem = result[nextIdx]) && (resultItem.newOption || $a5160a25a687d9b6$export$feece3e7d52a102b(resultItem.existing) || resultItem.existing && cmptOption.id != null && !$a5160a25a687d9b6$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
            if (resultItem) {
                resultItem.newOption = cmptOption;
                resultItem.brandNew = brandNew;
            } else result.push({
                newOption: cmptOption,
                brandNew: brandNew,
                existing: null,
                keyInfo: null
            });
            nextIdx++;
        });
    }
    function $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            result.push({
                newOption: cmptOption,
                brandNew: true,
                existing: null,
                keyInfo: null
            });
        });
    }
    function $a5160a25a687d9b6$var$makeIdAndName(mapResult) {
        var idMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var existing = item.existing;
            existing && idMap.set(existing.id, item);
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var opt = item.newOption;
            (0, (0, parcelRequire("bahqM")).assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
            opt && opt.id != null && idMap.set(opt.id, item);
            !item.keyInfo && (item.keyInfo = {});
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item, index) {
            var existing = item.existing;
            var opt = item.newOption;
            var keyInfo = item.keyInfo;
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) return;
            keyInfo.name = opt.name != null ? $a5160a25a687d9b6$var$makeComparableKey(opt.name) : existing ? existing.name : $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
            if (existing) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(existing.id);
            else if (opt.id != null) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(opt.id);
            else {
                var idNum = 0;
                do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
                while (idMap.get(keyInfo.id))
            }
            idMap.set(keyInfo.id, item);
        });
    }
    function $a5160a25a687d9b6$var$keyExistAndEqual(attr, obj1, obj2) {
        var key1 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj1[attr], null);
        var key2 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj2[attr], null);
        return key1 != null && key2 != null && key1 === key2;
    }
    function $a5160a25a687d9b6$var$makeComparableKey(val) {
        return $a5160a25a687d9b6$export$fb1a222ba5dd6e51(val, '');
    }
    function $a5160a25a687d9b6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
        if (idOrName == null) return defaultValue;
        var type = typeof idOrName;
        return type === 'string' ? idOrName : type === 'number' || (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
    }
    function $a5160a25a687d9b6$var$warnInvalidateIdOrName(idOrName) {}
    function $a5160a25a687d9b6$var$isValidIdOrName(idOrName) {
        return (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) || (0, (0, parcelRequire("jmSNG")).isNumeric)(idOrName);
    }
    function $a5160a25a687d9b6$export$beae19a2652b3368(componentModel) {
        var name = componentModel.name;
        return !!(name && name.indexOf($a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX));
    }
    function $a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) {
        return cmptOption && cmptOption.id != null && $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id).indexOf($a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
    }
    function $a5160a25a687d9b6$export$1753133c42e665e8(idSuffix) {
        return $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
    }
    function $a5160a25a687d9b6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
        (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(item) {
            var newOption = item.newOption;
            if ((0, (0, parcelRequire("bahqM")).isObject)(newOption)) {
                item.keyInfo.mainType = mainType;
                item.keyInfo.subType = $a5160a25a687d9b6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
            }
        });
    }
    function $a5160a25a687d9b6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
        var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
        return subType;
    }
    function $a5160a25a687d9b6$export$6d12cabb0c9bf8e3(batchA, batchB) {
        var mapA = {};
        var mapB = {};
        makeMap(batchA || [], mapA);
        makeMap(batchB || [], mapB, mapA);
        return [
            mapToArray(mapA),
            mapToArray(mapB)
        ];
        function makeMap(sourceBatch, map, otherMap) {
            for(var i = 0, len = sourceBatch.length; i < len; i++){
                var seriesId = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
                if (seriesId == null) return;
                var dataIndices = $a5160a25a687d9b6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
                var otherDataIndices = otherMap && otherMap[seriesId];
                for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                    var dataIndex = dataIndices[j];
                    if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                    else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
                }
            }
        }
        function mapToArray(map, isData) {
            var result = [];
            for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
                if (isData) result.push(+i);
                else {
                    var dataIndices = mapToArray(map[i], true);
                    dataIndices.length && result.push({
                        seriesId: i,
                        dataIndex: dataIndices
                    });
                }
            }
            return result;
        }
    }
    function $a5160a25a687d9b6$export$42b26cae8b8d10(data, payload) {
        if (payload.dataIndexInside != null) return payload.dataIndexInside;
        else if (payload.dataIndex != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.dataIndex) ? (0, (0, parcelRequire("bahqM")).map)(payload.dataIndex, function(value) {
            return data.indexOfRawIndex(value);
        }) : data.indexOfRawIndex(payload.dataIndex);
        else if (payload.name != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.name) ? (0, (0, parcelRequire("bahqM")).map)(payload.name, function(value) {
            return data.indexOfName(value);
        }) : data.indexOfName(payload.name);
    }
    function $a5160a25a687d9b6$export$64df9f8d92ae083f() {
        var key = '__ec_inner_' + $a5160a25a687d9b6$var$innerUniqueIndex++;
        return function(hostObj) {
            return hostObj[key] || (hostObj[key] = {});
        };
    }
    var $a5160a25a687d9b6$var$innerUniqueIndex = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
    function $a5160a25a687d9b6$export$95de80076abac814(ecModel, finderInput, opt) {
        var _a = $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
        var result = others;
        var defaultMainType = opt ? opt.defaultMainType : null;
        if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
        queryOptionMap.each(function(queryOption, mainType) {
            var queryResult = $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
                useDefault: defaultMainType === mainType,
                enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
                enableNone: opt && opt.enableNone != null ? opt.enableNone : true
            });
            result[mainType + 'Models'] = queryResult.models;
            result[mainType + 'Model'] = queryResult.models[0];
        });
        return result;
    }
    function $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt) {
        var finder;
        if ((0, (0, parcelRequire("bahqM")).isString)(finderInput)) {
            var obj = {};
            obj[finderInput + 'Index'] = 0;
            finder = obj;
        } else finder = finderInput;
        var queryOptionMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var others = {};
        var mainTypeSpecified = false;
        (0, (0, parcelRequire("bahqM")).each)(finder, function(value, key) {
            if (key === 'dataIndex' || key === 'dataIndexInside') {
                others[key] = value;
                return;
            }
            var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
            var mainType = parsedKey[1];
            var queryType = (parsedKey[2] || '').toLowerCase();
            if (!mainType || !queryType || opt && opt.includeMainTypes && (0, (0, parcelRequire("bahqM")).indexOf)(opt.includeMainTypes, mainType) < 0) return;
            mainTypeSpecified = mainTypeSpecified || !!mainType;
            var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
            queryOption[queryType] = value;
        });
        return {
            mainTypeSpecified: mainTypeSpecified,
            queryOptionMap: queryOptionMap,
            others: others
        };
    }
    var $a5160a25a687d9b6$export$f076738ec84e693c = {
        useDefault: true,
        enableAll: false,
        enableNone: false
    };
    var $a5160a25a687d9b6$export$48d598924ce4892c = {
        useDefault: false,
        enableAll: true,
        enableNone: true
    };
    function $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
        opt = opt || $a5160a25a687d9b6$export$f076738ec84e693c;
        var indexOption = userOption.index;
        var idOption = userOption.id;
        var nameOption = userOption.name;
        var result = {
            models: null,
            specified: indexOption != null || idOption != null || nameOption != null
        };
        if (!result.specified) {
            var firstCmpt = void 0;
            result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
                firstCmpt
            ] : [];
            return result;
        }
        if (indexOption === 'none' || indexOption === false) {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
            result.models = [];
            return result;
        }
        if (indexOption === 'all') {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
            indexOption = idOption = nameOption = null;
        }
        result.models = ecModel.queryComponents({
            mainType: mainType,
            index: indexOption,
            id: idOption,
            name: nameOption
        });
        return result;
    }
    function $a5160a25a687d9b6$export$9fec4d97f1922e0b(dom, key, value) {
        dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
    }
    function $a5160a25a687d9b6$export$735ee1799fd02602(dom, key) {
        return dom.getAttribute ? dom.getAttribute(key) : dom[key];
    }
    function $a5160a25a687d9b6$export$cc0a17a5d27b4e17(renderModeOption) {
        if (renderModeOption === 'auto') return (0, (0, parcelRequire("hZfwb")).default).domSupported ? 'html' : 'richText';
        else return renderModeOption || 'html';
    }
    function $a5160a25a687d9b6$export$7ab5bda43e13168f(array, getKey) {
        var buckets = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var keys = [];
        (0, (0, parcelRequire("bahqM")).each)(array, function(item) {
            var key = getKey(item);
            (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
        });
        return {
            keys: keys,
            buckets: buckets
        };
    }
    function $a5160a25a687d9b6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
        var isAutoPrecision = precision == null || precision === 'auto';
        if (targetValue == null) return targetValue;
        if (typeof targetValue === 'number') {
            var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(sourceValue || 0, targetValue, percent);
            return (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(sourceValue || 0), (0, (0, parcelRequire("jmSNG")).getPrecision)(targetValue)) : precision);
        } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
        else {
            var interpolated = [];
            var leftArr = sourceValue;
            var rightArr = targetValue;
            var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
            for(var i = 0; i < length_1; ++i){
                var info = data.getDimensionInfo(i);
                if (info && info.type === 'ordinal') interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
                else {
                    var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                    var rightVal = rightArr[i];
                    var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(leftVal, rightVal, percent);
                    interpolated[i] = (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(leftVal), (0, (0, parcelRequire("jmSNG")).getPrecision)(rightVal)) : precision);
                }
            }
            return interpolated;
        }
    }
});
parcelRegister("jmSNG", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>$e19a9495965944b5$export$d3f68fbaa670562);
    $parcel$export(module.exports, "parsePercent", ()=>$e19a9495965944b5$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "round", ()=>$e19a9495965944b5$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "asc", ()=>$e19a9495965944b5$export$debe6e778e0a6d32);
    $parcel$export(module.exports, "getPrecision", ()=>$e19a9495965944b5$export$e0c74b50bbd10f68);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>$e19a9495965944b5$export$6d86ba4ca4984d31);
    $parcel$export(module.exports, "getPixelPrecision", ()=>$e19a9495965944b5$export$666260d9a2dda8a7);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>$e19a9495965944b5$export$70cc11b075afeb90);
    $parcel$export(module.exports, "addSafe", ()=>$e19a9495965944b5$export$d3389a301c3a5706);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>$e19a9495965944b5$export$18510406f204a1b9);
    $parcel$export(module.exports, "remRadian", ()=>$e19a9495965944b5$export$2ca6dd70a288b1c3);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>$e19a9495965944b5$export$d1df570aea2868f);
    $parcel$export(module.exports, "parseDate", ()=>$e19a9495965944b5$export$6b862160d295c8e);
    $parcel$export(module.exports, "quantity", ()=>$e19a9495965944b5$export$82dd68b83a44b253);
    $parcel$export(module.exports, "quantityExponent", ()=>$e19a9495965944b5$export$97256a17b20a0c24);
    $parcel$export(module.exports, "nice", ()=>$e19a9495965944b5$export$7a695fe44258210b);
    $parcel$export(module.exports, "quantile", ()=>$e19a9495965944b5$export$651fb4afdb6caa4b);
    $parcel$export(module.exports, "reformIntervals", ()=>$e19a9495965944b5$export$12f7386070bc380a);
    $parcel$export(module.exports, "numericToNumber", ()=>$e19a9495965944b5$export$8b4007b942b45a96);
    $parcel$export(module.exports, "isNumeric", ()=>$e19a9495965944b5$export$e90fb89750dba83f);
    $parcel$export(module.exports, "getRandomIdBase", ()=>$e19a9495965944b5$export$474d2ec9aa44a22);
    $parcel$export(module.exports, "getLeastCommonMultiple", ()=>$e19a9495965944b5$export$680a45b749323f49);
    var $bahqM;
    var $e19a9495965944b5$var$RADIAN_EPSILON = 1e-4;
    var $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
    function $e19a9495965944b5$var$_trim(str) {
        return str.replace(/^\s+|\s+$/g, '');
    }
    function $e19a9495965944b5$export$d3f68fbaa670562(val, domain, range, clamp) {
        var d0 = domain[0];
        var d1 = domain[1];
        var r0 = range[0];
        var r1 = range[1];
        var subDomain = d1 - d0;
        var subRange = r1 - r0;
        if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
        if (clamp) {
            if (subDomain > 0) {
                if (val <= d0) return r0;
                else if (val >= d1) return r1;
            } else {
                if (val >= d0) return r0;
                else if (val <= d1) return r1;
            }
        } else {
            if (val === d0) return r0;
            if (val === d1) return r1;
        }
        return (val - d0) / subDomain * subRange + r0;
    }
    function $e19a9495965944b5$export$e8514cb5a5e2b40f(percent, all) {
        switch(percent){
            case 'center':
            case 'middle':
                percent = '50%';
                break;
            case 'left':
            case 'top':
                percent = '0%';
                break;
            case 'right':
            case 'bottom':
                percent = '100%';
                break;
        }
        if (typeof percent === 'string') {
            if ($e19a9495965944b5$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
            return parseFloat(percent);
        }
        return percent == null ? NaN : +percent;
    }
    function $e19a9495965944b5$export$2077e0241d6afd3c(x, precision, returnStr) {
        if (precision == null) precision = 10;
        precision = Math.min(Math.max(0, precision), $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX);
        x = (+x).toFixed(precision);
        return returnStr ? x : +x;
    }
    function $e19a9495965944b5$export$debe6e778e0a6d32(arr) {
        arr.sort(function(a, b) {
            return a - b;
        });
        return arr;
    }
    function $e19a9495965944b5$export$e0c74b50bbd10f68(val) {
        val = +val;
        if (isNaN(val)) return 0;
        if (val > 1e-14) {
            var e = 1;
            for(var i = 0; i < 15; i++, e *= 10){
                if (Math.round(val * e) / e === val) return i;
            }
        }
        return $e19a9495965944b5$export$6d86ba4ca4984d31(val);
    }
    function $e19a9495965944b5$export$6d86ba4ca4984d31(val) {
        var str = val.toString().toLowerCase();
        var eIndex = str.indexOf('e');
        var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
        var significandPartLen = eIndex > 0 ? eIndex : str.length;
        var dotIndex = str.indexOf('.');
        var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
        return Math.max(0, decimalPartLen - exp);
    }
    function $e19a9495965944b5$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
        var log = Math.log;
        var LN10 = Math.LN10;
        var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
        var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
        var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
        return !isFinite(precision) ? 20 : precision;
    }
    function $e19a9495965944b5$export$70cc11b075afeb90(valueList, idx, precision) {
        if (!valueList[idx]) return 0;
        var sum = (0, parcelRequire("bahqM")).reduce(valueList, function(acc, val) {
            return acc + (isNaN(val) ? 0 : val);
        }, 0);
        if (sum === 0) return 0;
        var digits = Math.pow(10, precision);
        var votesPerQuota = (0, parcelRequire("bahqM")).map(valueList, function(val) {
            return (isNaN(val) ? 0 : val) / sum * digits * 100;
        });
        var targetSeats = digits * 100;
        var seats = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes) {
            return Math.floor(votes);
        });
        var currentSum = (0, parcelRequire("bahqM")).reduce(seats, function(acc, val) {
            return acc + val;
        }, 0);
        var remainder = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes, idx) {
            return votes - seats[idx];
        });
        while(currentSum < targetSeats){
            var max = Number.NEGATIVE_INFINITY;
            var maxId = null;
            for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
                max = remainder[i];
                maxId = i;
            }
            ++seats[maxId];
            remainder[maxId] = 0;
            ++currentSum;
        }
        return seats[idx] / digits;
    }
    function $e19a9495965944b5$export$d3389a301c3a5706(val0, val1) {
        var maxPrecision = Math.max($e19a9495965944b5$export$e0c74b50bbd10f68(val0), $e19a9495965944b5$export$e0c74b50bbd10f68(val1));
        var sum = val0 + val1;
        return maxPrecision > $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $e19a9495965944b5$export$2077e0241d6afd3c(sum, maxPrecision);
    }
    var $e19a9495965944b5$export$18510406f204a1b9 = 9007199254740991;
    function $e19a9495965944b5$export$2ca6dd70a288b1c3(radian) {
        var pi2 = Math.PI * 2;
        return (radian % pi2 + pi2) % pi2;
    }
    function $e19a9495965944b5$export$d1df570aea2868f(val) {
        return val > -$e19a9495965944b5$var$RADIAN_EPSILON && val < $e19a9495965944b5$var$RADIAN_EPSILON;
    }
    var $e19a9495965944b5$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;
    function $e19a9495965944b5$export$6b862160d295c8e(value) {
        if (value instanceof Date) return value;
        else if (typeof value === 'string') {
            var match = $e19a9495965944b5$var$TIME_REG.exec(value);
            if (!match) return new Date(NaN);
            if (!match[8]) return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
            else {
                var hour = +match[4] || 0;
                if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
                return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
            }
        } else if (value == null) return new Date(NaN);
        return new Date(Math.round(value));
    }
    function $e19a9495965944b5$export$82dd68b83a44b253(val) {
        return Math.pow(10, $e19a9495965944b5$export$97256a17b20a0c24(val));
    }
    function $e19a9495965944b5$export$97256a17b20a0c24(val) {
        if (val === 0) return 0;
        var exp = Math.floor(Math.log(val) / Math.LN10);
        if (val / Math.pow(10, exp) >= 10) exp++;
        return exp;
    }
    function $e19a9495965944b5$export$7a695fe44258210b(val, round) {
        var exponent = $e19a9495965944b5$export$97256a17b20a0c24(val);
        var exp10 = Math.pow(10, exponent);
        var f = val / exp10;
        var nf;
        if (round) {
            if (f < 1.5) nf = 1;
            else if (f < 2.5) nf = 2;
            else if (f < 4) nf = 3;
            else if (f < 7) nf = 5;
            else nf = 10;
        } else {
            if (f < 1) nf = 1;
            else if (f < 2) nf = 2;
            else if (f < 3) nf = 3;
            else if (f < 5) nf = 5;
            else nf = 10;
        }
        val = nf * exp10;
        return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
    }
    function $e19a9495965944b5$export$651fb4afdb6caa4b(ascArr, p) {
        var H = (ascArr.length - 1) * p + 1;
        var h = Math.floor(H);
        var v = +ascArr[h - 1];
        var e = H - h;
        return e ? v + e * (ascArr[h] - v) : v;
    }
    function $e19a9495965944b5$export$12f7386070bc380a(list) {
        list.sort(function(a, b) {
            return littleThan(a, b, 0) ? -1 : 1;
        });
        var curr = -Infinity;
        var currClose = 1;
        for(var i = 0; i < list.length;){
            var interval = list[i].interval;
            var close_1 = list[i].close;
            for(var lg = 0; lg < 2; lg++){
                if (interval[lg] <= curr) {
                    interval[lg] = curr;
                    close_1[lg] = !lg ? 1 - currClose : 1;
                }
                curr = interval[lg];
                currClose = close_1[lg];
            }
            if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
            else i++;
        }
        return list;
        function littleThan(a, b, lg) {
            return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
        }
    }
    function $e19a9495965944b5$export$8b4007b942b45a96(val) {
        var valFloat = parseFloat(val);
        return valFloat == val && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0) ? valFloat : NaN;
    }
    function $e19a9495965944b5$export$e90fb89750dba83f(val) {
        return !isNaN($e19a9495965944b5$export$8b4007b942b45a96(val));
    }
    function $e19a9495965944b5$export$474d2ec9aa44a22() {
        return Math.round(Math.random() * 9);
    }
    function $e19a9495965944b5$export$a368fd580c0d0fe4(a, b) {
        if (b === 0) return a;
        return $e19a9495965944b5$export$a368fd580c0d0fe4(b, a % b);
    }
    function $e19a9495965944b5$export$680a45b749323f49(a, b) {
        if (a == null) return b;
        if (b == null) return a;
        return a * b / $e19a9495965944b5$export$a368fd580c0d0fe4(a, b);
    }
});
parcelRegister("eYgMC", function(module, exports) {
    $parcel$export(module.exports, "getAnimationConfig", ()=>$ae63b016ce1bd907$export$5cc7add7ab591d0a);
    $parcel$export(module.exports, "updateProps", ()=>$ae63b016ce1bd907$export$c8dce3c08436e91e);
    $parcel$export(module.exports, "initProps", ()=>$ae63b016ce1bd907$export$a121566aadcfe021);
    $parcel$export(module.exports, "isElementRemoved", ()=>$ae63b016ce1bd907$export$5b89d4b643713034);
    $parcel$export(module.exports, "removeElement", ()=>$ae63b016ce1bd907$export$f883456a56996078);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>$ae63b016ce1bd907$export$6d0fd725cb4aee8a);
    $parcel$export(module.exports, "saveOldStyle", ()=>$ae63b016ce1bd907$export$bca7290a9faf0ec9);
    $parcel$export(module.exports, "getOldStyle", ()=>$ae63b016ce1bd907$export$ccb1f1e4d2fa86ac);
    var $bahqM;
    var $eaKsF;
    var $ae63b016ce1bd907$export$ae7433df314f6ec3 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
        var animationPayload;
        if (animatableModel && animatableModel.ecModel) {
            var updatePayload = animatableModel.ecModel.getUpdatePayload();
            animationPayload = updatePayload && updatePayload.animation;
        }
        var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
        var isUpdate = animationType === 'update';
        if (animationEnabled) {
            var duration = void 0;
            var easing = void 0;
            var delay = void 0;
            if (extraOpts) {
                duration = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.duration, 200);
                easing = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.easing, 'cubicOut');
                delay = 0;
            } else {
                duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
                easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
                delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
            }
            if (animationPayload) {
                animationPayload.duration != null && (duration = animationPayload.duration);
                animationPayload.easing != null && (easing = animationPayload.easing);
                animationPayload.delay != null && (delay = animationPayload.delay);
            }
            if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
            if (typeof duration === 'function') duration = duration(dataIndex);
            var config = {
                duration: duration || 0,
                delay: delay,
                easing: easing
            };
            return config;
        } else return null;
    }
    function $ae63b016ce1bd907$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
        var isFrom = false;
        var removeOpt;
        if (typeof dataIndex === 'function') {
            during = cb;
            cb = dataIndex;
            dataIndex = null;
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(dataIndex)) {
            cb = dataIndex.cb;
            during = dataIndex.during;
            isFrom = dataIndex.isFrom;
            removeOpt = dataIndex.removeOpt;
            dataIndex = dataIndex.dataIndex;
        }
        var isRemove = animationType === 'remove';
        if (!isRemove) el.stopAnimation('remove');
        var animationConfig = $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
        if (animationConfig && animationConfig.duration > 0) {
            var duration = animationConfig.duration;
            var animationDelay = animationConfig.delay;
            var animationEasing = animationConfig.easing;
            var animateConfig = {
                duration: duration,
                delay: animationDelay || 0,
                easing: animationEasing,
                done: cb,
                force: !!cb || !!during,
                setToFinal: !isRemove,
                scope: animationType,
                during: during
            };
            isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
        } else {
            el.stopAnimation();
            !isFrom && el.attr(props);
            during && during(1);
            cb && cb();
        }
    }
    function $ae63b016ce1bd907$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$5b89d4b643713034(el) {
        if (!el.__zr) return true;
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.scope === 'remove') return true;
        }
        return false;
    }
    function $ae63b016ce1bd907$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
        if ($ae63b016ce1bd907$export$5b89d4b643713034(el)) return;
        $ae63b016ce1bd907$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
        el.removeTextContent();
        el.removeTextGuideLine();
        $ae63b016ce1bd907$export$f883456a56996078(el, {
            style: {
                opacity: 0
            }
        }, animatableModel, dataIndex, done);
    }
    function $ae63b016ce1bd907$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
        function doRemove() {
            el.parent && el.parent.remove(el);
        }
        if (!el.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
        else el.traverse(function(disp) {
            if (!disp.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
        });
    }
    function $ae63b016ce1bd907$export$bca7290a9faf0ec9(el) {
        $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle = el.style;
    }
    function $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac(el) {
        return $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle;
    }
});
parcelRegister("fHITF", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>$b6edb2bb66445620$export$d0d5398c9d612037);
    $parcel$export(module.exports, "extendPath", ()=>$b6edb2bb66445620$export$53b54a3137026af0);
    $parcel$export(module.exports, "registerShape", ()=>$b6edb2bb66445620$export$2b95b62e3aaf6fdd);
    $parcel$export(module.exports, "getShapeClass", ()=>$b6edb2bb66445620$export$51df4b5565a58189);
    $parcel$export(module.exports, "makePath", ()=>$b6edb2bb66445620$export$aa9bab72412f5613);
    $parcel$export(module.exports, "resizePath", ()=>$b6edb2bb66445620$export$566dbf1c62b04fc7);
    $parcel$export(module.exports, "makeImage", ()=>$b6edb2bb66445620$export$7a2bdede98851ac5);
    $parcel$export(module.exports, "mergePath", ()=>$b6edb2bb66445620$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$b6edb2bb66445620$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$b6edb2bb66445620$export$60e2aa74957d0b9d);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$b6edb2bb66445620$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "getTransform", ()=>$b6edb2bb66445620$export$fce0c6cfca85ed96);
    $parcel$export(module.exports, "applyTransform", ()=>$b6edb2bb66445620$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "transformDirection", ()=>$b6edb2bb66445620$export$fff94e9792354cfa);
    $parcel$export(module.exports, "groupTransition", ()=>$b6edb2bb66445620$export$64fcab7860c216ae);
    $parcel$export(module.exports, "clipPointsByRect", ()=>$b6edb2bb66445620$export$e2f409471bbbc1dc);
    $parcel$export(module.exports, "clipRectByRect", ()=>$b6edb2bb66445620$export$d0d3709202b8b2a);
    $parcel$export(module.exports, "createIcon", ()=>$b6edb2bb66445620$export$274edc73af1ae9c8);
    $parcel$export(module.exports, "linePolygonIntersect", ()=>$b6edb2bb66445620$export$4f47c855a5e9ae9);
    $parcel$export(module.exports, "lineLineIntersect", ()=>$b6edb2bb66445620$export$6c0a70ea1d8d158b);
    $parcel$export(module.exports, "setTooltipConfig", ()=>$b6edb2bb66445620$export$fc6410d97fab306c);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "removeElement", ()=>(parcelRequire("eYgMC")).removeElement);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>(parcelRequire("eYgMC")).removeElementWithFadeOut);
    $parcel$export(module.exports, "isElementRemoved", ()=>(parcelRequire("eYgMC")).isElementRemoved);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    $parcel$export(module.exports, "OrientedBoundingRect", ()=>(parcelRequire("lM5Gp")).default);
    $parcel$export(module.exports, "Point", ()=>(parcelRequire("bMDnR")).default);
    $parcel$export(module.exports, "Path", ()=>(parcelRequire("ghQ8v")).default);
    var $id1Rd;
    var $izqgC;
    var $eLEew;
    var $ghQ8v;
    var $e6gef;
    var $gcbBH;
    var $4KVOr;
    var $4gEFv;
    var $jjfok;
    var $kVeV8;
    var $elGBV;
    var $LCHOw;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $cZb1F;
    var $04gw0;
    var $ixXaU;
    var $eGltS;
    var $9J7f8;
    var $faICo;
    var $1E3E8;
    var $lM5Gp;
    var $bMDnR;
    var $6sllV;
    var $2az2p;
    var $bahqM;
    var $7QjoM;
    var $eYgMC;
    var $b6edb2bb66445620$var$mathMax = Math.max;
    var $b6edb2bb66445620$var$mathMin = Math.min;
    var $b6edb2bb66445620$var$_customShapeMap = {};
    function $b6edb2bb66445620$export$d0d5398c9d612037(opts) {
        return (0, (0, parcelRequire("ghQ8v")).default).extend(opts);
    }
    var $b6edb2bb66445620$var$extendPathFromString = (0, parcelRequire("id1Rd")).extendFromString;
    function $b6edb2bb66445620$export$53b54a3137026af0(pathData, opts) {
        return $b6edb2bb66445620$var$extendPathFromString(pathData, opts);
    }
    function $b6edb2bb66445620$export$2b95b62e3aaf6fdd(name, ShapeClass) {
        $b6edb2bb66445620$var$_customShapeMap[name] = ShapeClass;
    }
    function $b6edb2bb66445620$export$51df4b5565a58189(name) {
        if ($b6edb2bb66445620$var$_customShapeMap.hasOwnProperty(name)) return $b6edb2bb66445620$var$_customShapeMap[name];
    }
    function $b6edb2bb66445620$export$aa9bab72412f5613(pathData, opts, rect, layout) {
        var path = (0, parcelRequire("id1Rd")).createFromString(pathData, opts);
        if (rect) {
            if (layout === 'center') rect = $b6edb2bb66445620$var$centerGraphic(rect, path.getBoundingRect());
            $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect);
        }
        return path;
    }
    function $b6edb2bb66445620$export$7a2bdede98851ac5(imageUrl, rect, layout) {
        var zrImg = new (0, (0, parcelRequire("gcbBH")).default)({
            style: {
                image: imageUrl,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height
            },
            onload: function(img) {
                if (layout === 'center') {
                    var boundingRect = {
                        width: img.width,
                        height: img.height
                    };
                    zrImg.setStyle($b6edb2bb66445620$var$centerGraphic(rect, boundingRect));
                }
            }
        });
        return zrImg;
    }
    function $b6edb2bb66445620$var$centerGraphic(rect, boundingRect) {
        var aspect = boundingRect.width / boundingRect.height;
        var width = rect.height * aspect;
        var height;
        if (width <= rect.width) height = rect.height;
        else {
            width = rect.width;
            height = width / aspect;
        }
        var cx = rect.x + rect.width / 2;
        var cy = rect.y + rect.height / 2;
        return {
            x: cx - width / 2,
            y: cy - height / 2,
            width: width,
            height: height
        };
    }
    var $b6edb2bb66445620$export$7b1dd269fbc4e903 = (0, parcelRequire("id1Rd")).mergePath;
    function $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect) {
        if (!path.applyTransform) return;
        var pathRect = path.getBoundingRect();
        var m = pathRect.calculateTransform(rect);
        path.applyTransform(m);
    }
    function $b6edb2bb66445620$export$8b4b620d7f4aad1b(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeLine(param.shape, param.shape, param.style);
        return param;
    }
    function $b6edb2bb66445620$export$60e2aa74957d0b9d(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeRect(param.shape, param.shape, param.style);
        return param;
    }
    var $b6edb2bb66445620$export$72c4fd4c1b8fcb10 = (0, parcelRequire("2az2p")).subPixelOptimize;
    function $b6edb2bb66445620$export$fce0c6cfca85ed96(target, ancestor) {
        var mat = (0, parcelRequire("izqgC")).identity([]);
        while(target && target !== ancestor){
            (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        return mat;
    }
    function $b6edb2bb66445620$export$9f9dcb98c894b623(target, transform, invert) {
        if (transform && !(0, (0, parcelRequire("bahqM")).isArrayLike)(transform)) transform = (0, (0, parcelRequire("e6gef")).default).getLocalTransform(transform);
        if (invert) transform = (0, parcelRequire("izqgC")).invert([], transform);
        return (0, parcelRequire("eLEew")).applyTransform([], target, transform);
    }
    function $b6edb2bb66445620$export$fff94e9792354cfa(direction, transform, invert) {
        var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
        var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
        var vertex = [
            direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
            direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
        ];
        vertex = $b6edb2bb66445620$export$9f9dcb98c894b623(vertex, transform, invert);
        return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
    }
    function $b6edb2bb66445620$var$isNotGroup(el) {
        return !el.isGroup;
    }
    function $b6edb2bb66445620$var$isPath(el) {
        return el.shape != null;
    }
    function $b6edb2bb66445620$export$64fcab7860c216ae(g1, g2, animatableModel) {
        if (!g1 || !g2) return;
        function getElMap(g) {
            var elMap = {};
            g.traverse(function(el) {
                if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
            });
            return elMap;
        }
        function getAnimatableProps(el) {
            var obj = {
                x: el.x,
                y: el.y,
                rotation: el.rotation
            };
            if ($b6edb2bb66445620$var$isPath(el)) obj.shape = (0, (0, parcelRequire("bahqM")).extend)({}, el.shape);
            return obj;
        }
        var elMap1 = getElMap(g1);
        g2.traverse(function(el) {
            if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) {
                var oldEl = elMap1[el.anid];
                if (oldEl) {
                    var newProp = getAnimatableProps(el);
                    el.attr(getAnimatableProps(oldEl));
                    (0, (0, parcelRequire("eYgMC")).updateProps)(el, newProp, animatableModel, (0, (0, parcelRequire("7QjoM")).getECData)(el).dataIndex);
                }
            }
        });
    }
    function $b6edb2bb66445620$export$e2f409471bbbc1dc(points, rect) {
        return (0, (0, parcelRequire("bahqM")).map)(points, function(point) {
            var x = point[0];
            x = $b6edb2bb66445620$var$mathMax(x, rect.x);
            x = $b6edb2bb66445620$var$mathMin(x, rect.x + rect.width);
            var y = point[1];
            y = $b6edb2bb66445620$var$mathMax(y, rect.y);
            y = $b6edb2bb66445620$var$mathMin(y, rect.y + rect.height);
            return [
                x,
                y
            ];
        });
    }
    function $b6edb2bb66445620$export$d0d3709202b8b2a(targetRect, rect) {
        var x = $b6edb2bb66445620$var$mathMax(targetRect.x, rect.x);
        var x2 = $b6edb2bb66445620$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
        var y = $b6edb2bb66445620$var$mathMax(targetRect.y, rect.y);
        var y2 = $b6edb2bb66445620$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
        if (x2 >= x && y2 >= y) return {
            x: x,
            y: y,
            width: x2 - x,
            height: y2 - y
        };
    }
    function $b6edb2bb66445620$export$274edc73af1ae9c8(iconStr, opt, rect) {
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({
            rectHover: true
        }, opt);
        var style = innerOpts.style = {
            strokeNoScale: true
        };
        rect = rect || {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        };
        if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, (0, parcelRequire("bahqM")).defaults)(style, rect), new (0, (0, parcelRequire("gcbBH")).default)(innerOpts)) : $b6edb2bb66445620$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
    }
    function $b6edb2bb66445620$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
        for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
            var p = points[i];
            if ($b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
            p2 = p;
        }
    }
    function $b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
        var mx = a2x - a1x;
        var my = a2y - a1y;
        var nx = b2x - b1x;
        var ny = b2y - b1y;
        var nmCrossProduct = $b6edb2bb66445620$var$crossProduct2d(nx, ny, mx, my);
        if ($b6edb2bb66445620$var$nearZero(nmCrossProduct)) return false;
        var b1a1x = a1x - b1x;
        var b1a1y = a1y - b1y;
        var q = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
        if (q < 0 || q > 1) return false;
        var p = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
        if (p < 0 || p > 1) return false;
        return true;
    }
    function $b6edb2bb66445620$var$crossProduct2d(x1, y1, x2, y2) {
        return x1 * y2 - x2 * y1;
    }
    function $b6edb2bb66445620$var$nearZero(val) {
        return val <= 1e-6 && val >= -0.000001;
    }
    function $b6edb2bb66445620$export$fc6410d97fab306c(opt) {
        var itemTooltipOption = opt.itemTooltipOption;
        var componentModel = opt.componentModel;
        var itemName = opt.itemName;
        var itemTooltipOptionObj = (0, (0, parcelRequire("bahqM")).isString)(itemTooltipOption) ? {
            formatter: itemTooltipOption
        } : itemTooltipOption;
        var mainType = componentModel.mainType;
        var componentIndex = componentModel.componentIndex;
        var formatterParams = {
            componentType: mainType,
            name: itemName,
            $vars: [
                'name'
            ]
        };
        formatterParams[mainType + 'Index'] = componentIndex;
        var formatterParamsExtra = opt.formatterParamsExtra;
        if (formatterParamsExtra) (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("bahqM")).keys)(formatterParamsExtra), function(key) {
            if (!(0, (0, parcelRequire("bahqM")).hasOwn)(formatterParams, key)) {
                formatterParams[key] = formatterParamsExtra[key];
                formatterParams.$vars.push(key);
            }
        });
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(opt.el);
        ecData.componentMainType = mainType;
        ecData.componentIndex = componentIndex;
        ecData.tooltipConfig = {
            name: itemName,
            option: (0, (0, parcelRequire("bahqM")).defaults)({
                content: itemName,
                formatterParams: formatterParams
            }, itemTooltipOptionObj)
        };
    }
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('circle', (0, (0, parcelRequire("jjfok")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ellipse', (0, (0, parcelRequire("kVeV8")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('sector', (0, (0, parcelRequire("elGBV")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ring', (0, (0, parcelRequire("LCHOw")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polygon', (0, (0, parcelRequire("lQwBc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polyline', (0, (0, parcelRequire("32bXc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('rect', (0, (0, parcelRequire("7Tw7u")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('line', (0, (0, parcelRequire("cZb1F")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('bezierCurve', (0, (0, parcelRequire("04gw0")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('arc', (0, (0, parcelRequire("ixXaU")).default));
});
parcelRegister("id1Rd", function(module, exports) {
    $parcel$export(module.exports, "createFromString", ()=>$d41ae1bdee61ce18$export$ae5b259626f00aeb);
    $parcel$export(module.exports, "extendFromString", ()=>$d41ae1bdee61ce18$export$68e3a51ba2ed417c);
    $parcel$export(module.exports, "mergePath", ()=>$d41ae1bdee61ce18$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "clonePath", ()=>$d41ae1bdee61ce18$export$18711d956bf1c3eb);
    var $3VFsf;
    var $ghQ8v;
    var $aA4Ws;
    var $cTDbe;
    var $bahqM;
    var $d41ae1bdee61ce18$var$mathSqrt = Math.sqrt;
    var $d41ae1bdee61ce18$var$mathSin = Math.sin;
    var $d41ae1bdee61ce18$var$mathCos = Math.cos;
    var $d41ae1bdee61ce18$var$PI = Math.PI;
    function $d41ae1bdee61ce18$var$vMag(v) {
        return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    }
    function $d41ae1bdee61ce18$var$vRatio(u, v) {
        return (u[0] * v[0] + u[1] * v[1]) / ($d41ae1bdee61ce18$var$vMag(u) * $d41ae1bdee61ce18$var$vMag(v));
    }
    function $d41ae1bdee61ce18$var$vAngle(u, v) {
        return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($d41ae1bdee61ce18$var$vRatio(u, v));
    }
    function $d41ae1bdee61ce18$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
        var psi = psiDeg * ($d41ae1bdee61ce18$var$PI / 180.0);
        var xp = $d41ae1bdee61ce18$var$mathCos(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * $d41ae1bdee61ce18$var$mathSin(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
            ry *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
        }
        var f = (fa === fs ? -1 : 1) * $d41ae1bdee61ce18$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * cxp - $d41ae1bdee61ce18$var$mathSin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * cxp + $d41ae1bdee61ce18$var$mathCos(psi) * cyp;
        var theta = $d41ae1bdee61ce18$var$vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = $d41ae1bdee61ce18$var$vAngle(u, v);
        if ($d41ae1bdee61ce18$var$vRatio(u, v) <= -1) dTheta = $d41ae1bdee61ce18$var$PI;
        if ($d41ae1bdee61ce18$var$vRatio(u, v) >= 1) dTheta = 0;
        if (dTheta < 0) {
            var n = Math.round(dTheta / $d41ae1bdee61ce18$var$PI * 1e6) / 1e6;
            dTheta = $d41ae1bdee61ce18$var$PI * 2 + n % 2 * $d41ae1bdee61ce18$var$PI;
        }
        path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
    }
    var $d41ae1bdee61ce18$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
    var $d41ae1bdee61ce18$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $d41ae1bdee61ce18$var$createPathProxyFromString(data) {
        var path = new (0, (0, parcelRequire("aA4Ws")).default)();
        if (!data) return path;
        var cpx = 0;
        var cpy = 0;
        var subpathX = cpx;
        var subpathY = cpy;
        var prevCmd;
        var CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
        var cmdList = data.match($d41ae1bdee61ce18$var$commandReg);
        if (!cmdList) return path;
        for(var l = 0; l < cmdList.length; l++){
            var cmdText = cmdList[l];
            var cmdStr = cmdText.charAt(0);
            var cmd = void 0;
            var p = cmdText.match($d41ae1bdee61ce18$var$numberReg) || [];
            var pLen = p.length;
            for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
            var off = 0;
            while(off < pLen){
                var ctlPtx = void 0;
                var ctlPty = void 0;
                var rx = void 0;
                var ry = void 0;
                var psi = void 0;
                var fa = void 0;
                var fs = void 0;
                var x1 = cpx;
                var y1 = cpy;
                var len = void 0;
                var pathData = void 0;
                switch(cmdStr){
                    case 'l':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'L':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'm':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'l';
                        break;
                    case 'M':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'L';
                        break;
                    case 'h':
                        cpx += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'H':
                        cpx = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'v':
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'V':
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'C':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                        cpx = p[off - 2];
                        cpy = p[off - 1];
                        break;
                    case 'c':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                        cpx += p[off - 2];
                        cpy += p[off - 1];
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = cpx + p[off++];
                        y1 = cpy + p[off++];
                        cpx += p[off++];
                        cpy += p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 'Q':
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'q':
                        x1 = p[off++] + cpx;
                        y1 = p[off++] + cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                    case 'a':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                }
            }
            if (cmdStr === 'z' || cmdStr === 'Z') {
                cmd = CMD.Z;
                path.addData(cmd);
                cpx = subpathX;
                cpy = subpathY;
            }
            prevCmd = cmd;
        }
        path.toStatic();
        return path;
    }
    var $d41ae1bdee61ce18$var$SVGPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SVGPath, _super);
        function SVGPath() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SVGPath.prototype.applyTransform = function(m) {};
        return SVGPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    function $d41ae1bdee61ce18$var$isPathProxy(path) {
        return path.setData != null;
    }
    function $d41ae1bdee61ce18$var$createPathOptions(str, opts) {
        var pathProxy = $d41ae1bdee61ce18$var$createPathProxyFromString(str);
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({}, opts);
        innerOpts.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.setData(pathProxy.data);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            } else {
                var ctx = path;
                pathProxy.rebuildPath(ctx, 1);
            }
        };
        innerOpts.applyTransform = function(m) {
            (0, (0, parcelRequire("cTDbe")).default)(pathProxy, m);
            this.dirtyShape();
        };
        return innerOpts;
    }
    function $d41ae1bdee61ce18$export$ae5b259626f00aeb(str, opts) {
        return new $d41ae1bdee61ce18$var$SVGPath($d41ae1bdee61ce18$var$createPathOptions(str, opts));
    }
    function $d41ae1bdee61ce18$export$68e3a51ba2ed417c(str, defaultOpts) {
        var innerOpts = $d41ae1bdee61ce18$var$createPathOptions(str, defaultOpts);
        var Sub = function(_super) {
            (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                _this.applyTransform = innerOpts.applyTransform;
                _this.buildPath = innerOpts.buildPath;
                return _this;
            }
            return Sub;
        }($d41ae1bdee61ce18$var$SVGPath);
        return Sub;
    }
    function $d41ae1bdee61ce18$export$7b1dd269fbc4e903(pathEls, opts) {
        var pathList = [];
        var len = pathEls.length;
        for(var i = 0; i < len; i++){
            var pathEl = pathEls[i];
            pathList.push(pathEl.getUpdatedPathProxy(true));
        }
        var pathBundle = new (0, (0, parcelRequire("ghQ8v")).default)(opts);
        pathBundle.createPathProxy();
        pathBundle.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.appendPath(pathList);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            }
        };
        return pathBundle;
    }
    function $d41ae1bdee61ce18$export$18711d956bf1c3eb(sourcePath, opts) {
        opts = opts || {};
        var path = new (0, (0, parcelRequire("ghQ8v")).default)();
        if (sourcePath.shape) path.setShape(sourcePath.shape);
        path.setStyle(sourcePath.style);
        if (opts.bakeTransform) (0, (0, parcelRequire("cTDbe")).default)(path.path, sourcePath.getComputedTransform());
        else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
        else path.copyTransform(sourcePath);
        path.buildPath = sourcePath.buildPath;
        path.applyTransform = path.applyTransform;
        path.z = sourcePath.z;
        path.z2 = sourcePath.z2;
        path.zlevel = sourcePath.zlevel;
        return path;
    }
});
parcelRegister("cTDbe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96390378868b6806$export$2e2bcd8739ae039);
    var $aA4Ws;
    var $eLEew;
    var $96390378868b6806$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $96390378868b6806$var$points = [
        [],
        [],
        []
    ];
    var $96390378868b6806$var$mathSqrt = Math.sqrt;
    var $96390378868b6806$var$mathAtan2 = Math.atan2;
    function $96390378868b6806$export$2e2bcd8739ae039(path, m) {
        if (!m) return;
        var data = path.data;
        var len = path.len();
        var cmd;
        var nPoint;
        var i;
        var j;
        var k;
        var p;
        var M = $96390378868b6806$var$CMD.M;
        var C = $96390378868b6806$var$CMD.C;
        var L = $96390378868b6806$var$CMD.L;
        var R = $96390378868b6806$var$CMD.R;
        var A = $96390378868b6806$var$CMD.A;
        var Q = $96390378868b6806$var$CMD.Q;
        for(i = 0, j = 0; i < len;){
            cmd = data[i++];
            j = i;
            nPoint = 0;
            switch(cmd){
                case M:
                    nPoint = 1;
                    break;
                case L:
                    nPoint = 1;
                    break;
                case C:
                    nPoint = 3;
                    break;
                case Q:
                    nPoint = 2;
                    break;
                case A:
                    var x = m[4];
                    var y = m[5];
                    var sx = $96390378868b6806$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                    var sy = $96390378868b6806$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                    var angle = $96390378868b6806$var$mathAtan2(-m[1] / sy, m[0] / sx);
                    data[i] *= sx;
                    data[i++] += x;
                    data[i] *= sy;
                    data[i++] += y;
                    data[i++] *= sx;
                    data[i++] *= sy;
                    data[i++] += angle;
                    data[i++] += angle;
                    i += 2;
                    j = i;
                    break;
                case R:
                    p[0] = data[i++];
                    p[1] = data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
                    p[0] += data[i++];
                    p[1] += data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
            }
            for(k = 0; k < nPoint; k++){
                var p_1 = $96390378868b6806$var$points[k];
                p_1[0] = data[i++];
                p_1[1] = data[i++];
                (0, (0, parcelRequire("eLEew")).applyTransform)(p_1, p_1, m);
                data[j++] = p_1[0];
                data[j++] = p_1[1];
            }
        }
        path.increaseVersion();
    }
});
parcelRegister("4KVOr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37684daaaf15bf3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $7KVc5;
    var $1E3E8;
    var $37684daaaf15bf3f$var$Group = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Group, _super);
        function Group(opts) {
            var _this = _super.call(this) || this;
            _this.isGroup = true;
            _this._children = [];
            _this.attr(opts);
            return _this;
        }
        Group.prototype.childrenRef = function() {
            return this._children;
        };
        Group.prototype.children = function() {
            return this._children.slice();
        };
        Group.prototype.childAt = function(idx) {
            return this._children[idx];
        };
        Group.prototype.childOfName = function(name) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                if (children[i].name === name) return children[i];
            }
        };
        Group.prototype.childCount = function() {
            return this._children.length;
        };
        Group.prototype.add = function(child) {
            if (child) {
                if (child !== this && child.parent !== this) {
                    this._children.push(child);
                    this._doAdd(child);
                }
                if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
            }
            return this;
        };
        Group.prototype.addBefore = function(child, nextSibling) {
            if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
                var children = this._children;
                var idx = children.indexOf(nextSibling);
                if (idx >= 0) {
                    children.splice(idx, 0, child);
                    this._doAdd(child);
                }
            }
            return this;
        };
        Group.prototype.replace = function(oldChild, newChild) {
            var idx = (0, parcelRequire("bahqM")).indexOf(this._children, oldChild);
            if (idx >= 0) this.replaceAt(newChild, idx);
            return this;
        };
        Group.prototype.replaceAt = function(child, index) {
            var children = this._children;
            var old = children[index];
            if (child && child !== this && child.parent !== this && child !== old) {
                children[index] = child;
                old.parent = null;
                var zr = this.__zr;
                if (zr) old.removeSelfFromZr(zr);
                this._doAdd(child);
            }
            return this;
        };
        Group.prototype._doAdd = function(child) {
            if (child.parent) child.parent.remove(child);
            child.parent = this;
            var zr = this.__zr;
            if (zr && zr !== child.__zr) child.addSelfToZr(zr);
            zr && zr.refresh();
        };
        Group.prototype.remove = function(child) {
            var zr = this.__zr;
            var children = this._children;
            var idx = (0, parcelRequire("bahqM")).indexOf(children, child);
            if (idx < 0) return this;
            children.splice(idx, 1);
            child.parent = null;
            if (zr) child.removeSelfFromZr(zr);
            zr && zr.refresh();
            return this;
        };
        Group.prototype.removeAll = function() {
            var children = this._children;
            var zr = this.__zr;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (zr) child.removeSelfFromZr(zr);
                child.parent = null;
            }
            children.length = 0;
            return this;
        };
        Group.prototype.eachChild = function(cb, context) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                cb.call(context, child, i);
            }
            return this;
        };
        Group.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                var stopped = cb.call(context, child);
                if (child.isGroup && !stopped) child.traverse(cb, context);
            }
            return this;
        };
        Group.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.addSelfToZr(zr);
            }
        };
        Group.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.removeSelfFromZr(zr);
            }
        };
        Group.prototype.getBoundingRect = function(includeChildren) {
            var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            var children = includeChildren || this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.ignore || child.invisible) continue;
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    (0, (0, parcelRequire("1E3E8")).default).applyTransform(tmpRect, childRect, transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            return rect || tmpRect;
        };
        return Group;
    }((0, (0, parcelRequire("7KVc5")).default));
    $37684daaaf15bf3f$var$Group.prototype.type = 'group';
    var $37684daaaf15bf3f$export$2e2bcd8739ae039 = $37684daaaf15bf3f$var$Group;
});
parcelRegister("jjfok", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0ebbb12e4687e45$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $e0ebbb12e4687e45$export$2c0b65c9c7b57845 = function() {
        function CircleShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
        }
        return CircleShape;
    }();
    var $e0ebbb12e4687e45$var$Circle = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Circle, _super);
        function Circle(opts) {
            return _super.call(this, opts) || this;
        }
        Circle.prototype.getDefaultShape = function() {
            return new $e0ebbb12e4687e45$export$2c0b65c9c7b57845();
        };
        Circle.prototype.buildPath = function(ctx, shape, inBundle) {
            if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
            ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
        };
        return Circle;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $e0ebbb12e4687e45$var$Circle.prototype.type = 'circle';
    var $e0ebbb12e4687e45$export$2e2bcd8739ae039 = $e0ebbb12e4687e45$var$Circle;
});
parcelRegister("kVeV8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3b4b46f050115c8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $f3b4b46f050115c8$export$817919dfe2806d31 = function() {
        function EllipseShape() {
            this.cx = 0;
            this.cy = 0;
            this.rx = 0;
            this.ry = 0;
        }
        return EllipseShape;
    }();
    var $f3b4b46f050115c8$var$Ellipse = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ellipse, _super);
        function Ellipse(opts) {
            return _super.call(this, opts) || this;
        }
        Ellipse.prototype.getDefaultShape = function() {
            return new $f3b4b46f050115c8$export$817919dfe2806d31();
        };
        Ellipse.prototype.buildPath = function(ctx, shape) {
            var k = 0.5522848;
            var x = shape.cx;
            var y = shape.cy;
            var a = shape.rx;
            var b = shape.ry;
            var ox = a * k;
            var oy = b * k;
            ctx.moveTo(x - a, y);
            ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
            ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
            ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
            ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
            ctx.closePath();
        };
        return Ellipse;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $f3b4b46f050115c8$var$Ellipse.prototype.type = 'ellipse';
    var $f3b4b46f050115c8$export$2e2bcd8739ae039 = $f3b4b46f050115c8$var$Ellipse;
});
parcelRegister("elGBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a724147a13426864$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $3kXtf;
    var $a724147a13426864$export$98af62de8a972c99 = function() {
        function SectorShape() {
            this.cx = 0;
            this.cy = 0;
            this.r0 = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
            this.cornerRadius = 0;
            this.innerCornerRadius = 0;
        }
        return SectorShape;
    }();
    var $a724147a13426864$var$Sector = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Sector, _super);
        function Sector(opts) {
            return _super.call(this, opts) || this;
        }
        Sector.prototype.getDefaultShape = function() {
            return new $a724147a13426864$export$98af62de8a972c99();
        };
        Sector.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("3kXtf")).buildPath(ctx, shape);
        };
        Sector.prototype.isZeroArea = function() {
            return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
        };
        return Sector;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $a724147a13426864$var$Sector.prototype.type = 'sector';
    var $a724147a13426864$export$2e2bcd8739ae039 = $a724147a13426864$var$Sector;
});
parcelRegister("3kXtf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$26e15f024d5166f6$export$5cc7f731b5937e99);
    var $aA4Ws;
    var $26e15f024d5166f6$var$PI = Math.PI;
    var $26e15f024d5166f6$var$PI2 = $26e15f024d5166f6$var$PI * 2;
    var $26e15f024d5166f6$var$mathSin = Math.sin;
    var $26e15f024d5166f6$var$mathCos = Math.cos;
    var $26e15f024d5166f6$var$mathACos = Math.acos;
    var $26e15f024d5166f6$var$mathATan2 = Math.atan2;
    var $26e15f024d5166f6$var$mathAbs = Math.abs;
    var $26e15f024d5166f6$var$mathSqrt = Math.sqrt;
    var $26e15f024d5166f6$var$mathMax = Math.max;
    var $26e15f024d5166f6$var$mathMin = Math.min;
    var $26e15f024d5166f6$var$e = 1e-4;
    function $26e15f024d5166f6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0;
        var y10 = y1 - y0;
        var x32 = x3 - x2;
        var y32 = y3 - y2;
        var t = y32 * x10 - x32 * y10;
        if (t * t < $26e15f024d5166f6$var$e) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    function $26e15f024d5166f6$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
        var x01 = x0 - x1;
        var y01 = y0 - y1;
        var lo = (clockwise ? cr : -cr) / $26e15f024d5166f6$var$mathSqrt(x01 * x01 + y01 * y01);
        var ox = lo * y01;
        var oy = -lo * x01;
        var x11 = x0 + ox;
        var y11 = y0 + oy;
        var x10 = x1 + ox;
        var y10 = y1 + oy;
        var x00 = (x11 + x10) / 2;
        var y00 = (y11 + y10) / 2;
        var dx = x10 - x11;
        var dy = y10 - y11;
        var d2 = dx * dx + dy * dy;
        var r = radius - cr;
        var s = x11 * y10 - x10 * y11;
        var d = (dy < 0 ? -1 : 1) * $26e15f024d5166f6$var$mathSqrt($26e15f024d5166f6$var$mathMax(0, r * r * d2 - s * s));
        var cx0 = (s * dy - dx * d) / d2;
        var cy0 = (-s * dx - dy * d) / d2;
        var cx1 = (s * dy + dx * d) / d2;
        var cy1 = (-s * dx + dy * d) / d2;
        var dx0 = cx0 - x00;
        var dy0 = cy0 - y00;
        var dx1 = cx1 - x00;
        var dy1 = cy1 - y00;
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
            cx0 = cx1;
            cy0 = cy1;
        }
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (radius / r - 1),
            y11: cy0 * (radius / r - 1)
        };
    }
    function $26e15f024d5166f6$export$5cc7f731b5937e99(ctx, shape) {
        var radius = $26e15f024d5166f6$var$mathMax(shape.r, 0);
        var innerRadius = $26e15f024d5166f6$var$mathMax(shape.r0 || 0, 0);
        var hasRadius = radius > 0;
        var hasInnerRadius = innerRadius > 0;
        if (!hasRadius && !hasInnerRadius) return;
        if (!hasRadius) {
            radius = innerRadius;
            innerRadius = 0;
        }
        if (innerRadius > radius) {
            var tmp = radius;
            radius = innerRadius;
            innerRadius = tmp;
        }
        var clockwise = !!shape.clockwise;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var arc;
        if (startAngle === endAngle) arc = 0;
        else {
            var tmpAngles = [
                startAngle,
                endAngle
            ];
            (0, (0, parcelRequire("aA4Ws")).normalizeArcAngles)(tmpAngles, !clockwise);
            arc = $26e15f024d5166f6$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
        }
        var x = shape.cx;
        var y = shape.cy;
        var cornerRadius = shape.cornerRadius || 0;
        var innerCornerRadius = shape.innerCornerRadius || 0;
        if (!(radius > $26e15f024d5166f6$var$e)) ctx.moveTo(x, y);
        else if (arc > $26e15f024d5166f6$var$PI2 - $26e15f024d5166f6$var$e) {
            ctx.moveTo(x + radius * $26e15f024d5166f6$var$mathCos(startAngle), y + radius * $26e15f024d5166f6$var$mathSin(startAngle));
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            if (innerRadius > $26e15f024d5166f6$var$e) {
                ctx.moveTo(x + innerRadius * $26e15f024d5166f6$var$mathCos(endAngle), y + innerRadius * $26e15f024d5166f6$var$mathSin(endAngle));
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        } else {
            var halfRd = $26e15f024d5166f6$var$mathAbs(radius - innerRadius) / 2;
            var cr = $26e15f024d5166f6$var$mathMin(halfRd, cornerRadius);
            var icr = $26e15f024d5166f6$var$mathMin(halfRd, innerCornerRadius);
            var cr0 = icr;
            var cr1 = cr;
            var xrs = radius * $26e15f024d5166f6$var$mathCos(startAngle);
            var yrs = radius * $26e15f024d5166f6$var$mathSin(startAngle);
            var xire = innerRadius * $26e15f024d5166f6$var$mathCos(endAngle);
            var yire = innerRadius * $26e15f024d5166f6$var$mathSin(endAngle);
            var xre = void 0;
            var yre = void 0;
            var xirs = void 0;
            var yirs = void 0;
            if (cr > $26e15f024d5166f6$var$e || icr > $26e15f024d5166f6$var$e) {
                xre = radius * $26e15f024d5166f6$var$mathCos(endAngle);
                yre = radius * $26e15f024d5166f6$var$mathSin(endAngle);
                xirs = innerRadius * $26e15f024d5166f6$var$mathCos(startAngle);
                yirs = innerRadius * $26e15f024d5166f6$var$mathSin(startAngle);
                if (arc < $26e15f024d5166f6$var$PI) {
                    var it_1 = $26e15f024d5166f6$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $26e15f024d5166f6$var$mathSin($26e15f024d5166f6$var$mathACos((x0 * x1 + y0 * y1) / ($26e15f024d5166f6$var$mathSqrt(x0 * x0 + y0 * y0) * $26e15f024d5166f6$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $26e15f024d5166f6$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        cr0 = $26e15f024d5166f6$var$mathMin(icr, (innerRadius - b) / (a - 1));
                        cr1 = $26e15f024d5166f6$var$mathMin(cr, (radius - b) / (a + 1));
                    }
                }
            }
            if (!(arc > $26e15f024d5166f6$var$e)) ctx.moveTo(x + xrs, y + yrs);
            else if (cr1 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
                ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, radius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.moveTo(x + xrs, y + yrs);
                ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            }
            if (!(innerRadius > $26e15f024d5166f6$var$e) || !(arc > $26e15f024d5166f6$var$e)) ctx.lineTo(x + xire, y + yire);
            else if (cr0 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
                ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, innerRadius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.lineTo(x + xire, y + yire);
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        }
        ctx.closePath();
    }
});
parcelRegister("LCHOw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08f26a0aa2f0a2fd$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db = function() {
        function RingShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.r0 = 0;
        }
        return RingShape;
    }();
    var $08f26a0aa2f0a2fd$var$Ring = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ring, _super);
        function Ring(opts) {
            return _super.call(this, opts) || this;
        }
        Ring.prototype.getDefaultShape = function() {
            return new $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db();
        };
        Ring.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var PI2 = Math.PI * 2;
            ctx.moveTo(x + shape.r, y);
            ctx.arc(x, y, shape.r, 0, PI2, false);
            ctx.moveTo(x + shape.r0, y);
            ctx.arc(x, y, shape.r0, 0, PI2, true);
        };
        return Ring;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $08f26a0aa2f0a2fd$var$Ring.prototype.type = 'ring';
    var $08f26a0aa2f0a2fd$export$2e2bcd8739ae039 = $08f26a0aa2f0a2fd$var$Ring;
});
parcelRegister("lQwBc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe77bdccf816487a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $fe77bdccf816487a$export$a34d87b9aaeedd46 = function() {
        function PolygonShape() {
            this.points = null;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolygonShape;
    }();
    var $fe77bdccf816487a$var$Polygon = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polygon, _super);
        function Polygon(opts) {
            return _super.call(this, opts) || this;
        }
        Polygon.prototype.getDefaultShape = function() {
            return new $fe77bdccf816487a$export$a34d87b9aaeedd46();
        };
        Polygon.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, true);
        };
        return Polygon;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $fe77bdccf816487a$var$Polygon.prototype.type = 'polygon';
    var $fe77bdccf816487a$export$2e2bcd8739ae039 = $fe77bdccf816487a$var$Polygon;
});
parcelRegister("gLMXf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$c357027dbb0e6a00$export$5cc7f731b5937e99);
    var $bEkQR;
    var $4Fmqi;
    function $c357027dbb0e6a00$export$5cc7f731b5937e99(ctx, shape, closePath) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (points && points.length >= 2) {
            if (smooth && smooth !== 'spline') {
                var controlPoints = (0, (0, parcelRequire("4Fmqi")).default)(points, smooth, closePath, shape.smoothConstraint);
                ctx.moveTo(points[0][0], points[0][1]);
                var len = points.length;
                for(var i = 0; i < (closePath ? len : len - 1); i++){
                    var cp1 = controlPoints[i * 2];
                    var cp2 = controlPoints[i * 2 + 1];
                    var p = points[(i + 1) % len];
                    ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
                }
            } else {
                if (smooth === 'spline') points = (0, (0, parcelRequire("bEkQR")).default)(points, closePath);
                ctx.moveTo(points[0][0], points[0][1]);
                for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
            }
            closePath && ctx.closePath();
        }
    }
});
parcelRegister("bEkQR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b39ad613612da7$export$2e2bcd8739ae039);
    var $eLEew;
    function $87b39ad613612da7$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $87b39ad613612da7$export$2e2bcd8739ae039(points, isLoop) {
        var len = points.length;
        var ret = [];
        var distance = 0;
        for(var i = 1; i < len; i++)distance += (0, (0, parcelRequire("eLEew")).distance)(points[i - 1], points[i]);
        var segs = distance / 2;
        segs = segs < len ? len : segs;
        for(var i = 0; i < segs; i++){
            var pos = i / (segs - 1) * (isLoop ? len : len - 1);
            var idx = Math.floor(pos);
            var w = pos - idx;
            var p0 = void 0;
            var p1 = points[idx % len];
            var p2 = void 0;
            var p3 = void 0;
            if (!isLoop) {
                p0 = points[idx === 0 ? idx : idx - 1];
                p2 = points[idx > len - 2 ? len - 1 : idx + 1];
                p3 = points[idx > len - 3 ? len - 1 : idx + 2];
            } else {
                p0 = points[(idx - 1 + len) % len];
                p2 = points[(idx + 1) % len];
                p3 = points[(idx + 2) % len];
            }
            var w2 = w * w;
            var w3 = w * w2;
            ret.push([
                $87b39ad613612da7$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
                $87b39ad613612da7$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
            ]);
        }
        return ret;
    }
});
parcelRegister("4Fmqi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$365c6287f8cf6aea$export$2e2bcd8739ae039);
    var $eLEew;
    function $365c6287f8cf6aea$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
        var cps = [];
        var v = [];
        var v1 = [];
        var v2 = [];
        var prevPoint;
        var nextPoint;
        var min;
        var max;
        if (constraint) {
            min = [
                Infinity,
                Infinity
            ];
            max = [
                -Infinity,
                -Infinity
            ];
            for(var i = 0, len = points.length; i < len; i++){
                (0, (0, parcelRequire("eLEew")).min)(min, min, points[i]);
                (0, (0, parcelRequire("eLEew")).max)(max, max, points[i]);
            }
            (0, (0, parcelRequire("eLEew")).min)(min, min, constraint[0]);
            (0, (0, parcelRequire("eLEew")).max)(max, max, constraint[1]);
        }
        for(var i = 0, len = points.length; i < len; i++){
            var point = points[i];
            if (isLoop) {
                prevPoint = points[i ? i - 1 : len - 1];
                nextPoint = points[(i + 1) % len];
            } else if (i === 0 || i === len - 1) {
                cps.push((0, (0, parcelRequire("eLEew")).clone)(points[i]));
                continue;
            } else {
                prevPoint = points[i - 1];
                nextPoint = points[i + 1];
            }
            (0, (0, parcelRequire("eLEew")).sub)(v, nextPoint, prevPoint);
            (0, (0, parcelRequire("eLEew")).scale)(v, v, smooth);
            var d0 = (0, (0, parcelRequire("eLEew")).distance)(point, prevPoint);
            var d1 = (0, (0, parcelRequire("eLEew")).distance)(point, nextPoint);
            var sum = d0 + d1;
            if (sum !== 0) {
                d0 /= sum;
                d1 /= sum;
            }
            (0, (0, parcelRequire("eLEew")).scale)(v1, v, -d0);
            (0, (0, parcelRequire("eLEew")).scale)(v2, v, d1);
            var cp0 = (0, (0, parcelRequire("eLEew")).add)([], point, v1);
            var cp1 = (0, (0, parcelRequire("eLEew")).add)([], point, v2);
            if (constraint) {
                (0, (0, parcelRequire("eLEew")).max)(cp0, cp0, min);
                (0, (0, parcelRequire("eLEew")).min)(cp0, cp0, max);
                (0, (0, parcelRequire("eLEew")).max)(cp1, cp1, min);
                (0, (0, parcelRequire("eLEew")).min)(cp1, cp1, max);
            }
            cps.push(cp0);
            cps.push(cp1);
        }
        if (isLoop) cps.push(cps.shift());
        return cps;
    }
});
parcelRegister("32bXc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$235ad4ce0d26a4ed$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $235ad4ce0d26a4ed$export$e9e5cc3985e19d11 = function() {
        function PolylineShape() {
            this.points = null;
            this.percent = 1;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolylineShape;
    }();
    var $235ad4ce0d26a4ed$var$Polyline = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polyline, _super);
        function Polyline(opts) {
            return _super.call(this, opts) || this;
        }
        Polyline.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Polyline.prototype.getDefaultShape = function() {
            return new $235ad4ce0d26a4ed$export$e9e5cc3985e19d11();
        };
        Polyline.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, false);
        };
        return Polyline;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $235ad4ce0d26a4ed$var$Polyline.prototype.type = 'polyline';
    var $235ad4ce0d26a4ed$export$2e2bcd8739ae039 = $235ad4ce0d26a4ed$var$Polyline;
});
parcelRegister("cZb1F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9743bc0ad02b6789$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $2az2p;
    var $9743bc0ad02b6789$var$subPixelOptimizeOutputShape = {};
    var $9743bc0ad02b6789$export$64b674d0815308 = function() {
        function LineShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.percent = 1;
        }
        return LineShape;
    }();
    var $9743bc0ad02b6789$var$Line = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Line, _super);
        function Line(opts) {
            return _super.call(this, opts) || this;
        }
        Line.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Line.prototype.getDefaultShape = function() {
            return new $9743bc0ad02b6789$export$64b674d0815308();
        };
        Line.prototype.buildPath = function(ctx, shape) {
            var x1;
            var y1;
            var x2;
            var y2;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeLine)($9743bc0ad02b6789$var$subPixelOptimizeOutputShape, shape, this.style);
                x1 = optimizedShape.x1;
                y1 = optimizedShape.y1;
                x2 = optimizedShape.x2;
                y2 = optimizedShape.y2;
            } else {
                x1 = shape.x1;
                y1 = shape.y1;
                x2 = shape.x2;
                y2 = shape.y2;
            }
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (percent < 1) {
                x2 = x1 * (1 - percent) + x2 * percent;
                y2 = y1 * (1 - percent) + y2 * percent;
            }
            ctx.lineTo(x2, y2);
        };
        Line.prototype.pointAt = function(p) {
            var shape = this.shape;
            return [
                shape.x1 * (1 - p) + shape.x2 * p,
                shape.y1 * (1 - p) + shape.y2 * p
            ];
        };
        return Line;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $9743bc0ad02b6789$var$Line.prototype.type = 'line';
    var $9743bc0ad02b6789$export$2e2bcd8739ae039 = $9743bc0ad02b6789$var$Line;
});
parcelRegister("04gw0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00cd2f675f351e5a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $eLEew;
    var $dr1jo;
    var $00cd2f675f351e5a$var$out = [];
    var $00cd2f675f351e5a$export$e10089729fef29aa = function() {
        function BezierCurveShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.cpx1 = 0;
            this.cpy1 = 0;
            this.percent = 1;
        }
        return BezierCurveShape;
    }();
    function $00cd2f675f351e5a$var$someVectorAt(shape, t, isTangent) {
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        if (cpx2 === null || cpy2 === null) return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
        ];
        else return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
        ];
    }
    var $00cd2f675f351e5a$var$BezierCurve = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BezierCurve, _super);
        function BezierCurve(opts) {
            return _super.call(this, opts) || this;
        }
        BezierCurve.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        BezierCurve.prototype.getDefaultShape = function() {
            return new $00cd2f675f351e5a$export$e10089729fef29aa();
        };
        BezierCurve.prototype.buildPath = function(ctx, shape) {
            var x1 = shape.x1;
            var y1 = shape.y1;
            var x2 = shape.x2;
            var y2 = shape.y2;
            var cpx1 = shape.cpx1;
            var cpy1 = shape.cpy1;
            var cpx2 = shape.cpx2;
            var cpy2 = shape.cpy2;
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (cpx2 == null || cpy2 == null) {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(x1, cpx1, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    x2 = $00cd2f675f351e5a$var$out[2];
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(y1, cpy1, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    y2 = $00cd2f675f351e5a$var$out[2];
                }
                ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
            } else {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    cpx2 = $00cd2f675f351e5a$var$out[2];
                    x2 = $00cd2f675f351e5a$var$out[3];
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    cpy2 = $00cd2f675f351e5a$var$out[2];
                    y2 = $00cd2f675f351e5a$var$out[3];
                }
                ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
            }
        };
        BezierCurve.prototype.pointAt = function(t) {
            return $00cd2f675f351e5a$var$someVectorAt(this.shape, t, false);
        };
        BezierCurve.prototype.tangentAt = function(t) {
            var p = $00cd2f675f351e5a$var$someVectorAt(this.shape, t, true);
            return (0, parcelRequire("eLEew")).normalize(p, p);
        };
        return BezierCurve;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $00cd2f675f351e5a$var$BezierCurve.prototype.type = 'bezier-curve';
    var $00cd2f675f351e5a$export$2e2bcd8739ae039 = $00cd2f675f351e5a$var$BezierCurve;
});
parcelRegister("ixXaU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80935fda1e22f1c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $d80935fda1e22f1c$export$a259dbdc51948277 = function() {
        function ArcShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
        }
        return ArcShape;
    }();
    var $d80935fda1e22f1c$var$Arc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Arc, _super);
        function Arc(opts) {
            return _super.call(this, opts) || this;
        }
        Arc.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Arc.prototype.getDefaultShape = function() {
            return new $d80935fda1e22f1c$export$a259dbdc51948277();
        };
        Arc.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var r = Math.max(shape.r, 0);
            var startAngle = shape.startAngle;
            var endAngle = shape.endAngle;
            var clockwise = shape.clockwise;
            var unitX = Math.cos(startAngle);
            var unitY = Math.sin(startAngle);
            ctx.moveTo(unitX * r + x, unitY * r + y);
            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        };
        return Arc;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $d80935fda1e22f1c$var$Arc.prototype.type = 'arc';
    var $d80935fda1e22f1c$export$2e2bcd8739ae039 = $d80935fda1e22f1c$var$Arc;
});
parcelRegister("eGltS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab05a69c83088c4b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $ab05a69c83088c4b$var$CompoundPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CompoundPath, _super);
        function CompoundPath() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'compound';
            return _this;
        }
        CompoundPath.prototype._updatePathDirty = function() {
            var paths = this.shape.paths;
            var dirtyPath = this.shapeChanged();
            for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
            if (dirtyPath) this.dirtyShape();
        };
        CompoundPath.prototype.beforeBrush = function() {
            this._updatePathDirty();
            var paths = this.shape.paths || [];
            var scale = this.getGlobalScale();
            for(var i = 0; i < paths.length; i++){
                if (!paths[i].path) paths[i].createPathProxy();
                paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
            }
        };
        CompoundPath.prototype.buildPath = function(ctx, shape) {
            var paths = shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
        };
        CompoundPath.prototype.afterBrush = function() {
            var paths = this.shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
        };
        CompoundPath.prototype.getBoundingRect = function() {
            this._updatePathDirty.call(this);
            return (0, (0, parcelRequire("ghQ8v")).default).prototype.getBoundingRect.call(this);
        };
        return CompoundPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $ab05a69c83088c4b$export$2e2bcd8739ae039 = $ab05a69c83088c4b$var$CompoundPath;
});
parcelRegister("9J7f8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714def5c08e9d5ff$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $714def5c08e9d5ff$var$LinearGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinearGradient, _super);
        function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0 : x;
            _this.y = y == null ? 0 : y;
            _this.x2 = x2 == null ? 1 : x2;
            _this.y2 = y2 == null ? 0 : y2;
            _this.type = 'linear';
            _this.global = globalCoord || false;
            return _this;
        }
        return LinearGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $714def5c08e9d5ff$export$2e2bcd8739ae039 = $714def5c08e9d5ff$var$LinearGradient;
});
parcelRegister("jnhEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1addc27dbc63739$export$2e2bcd8739ae039);
    var $e1addc27dbc63739$var$Gradient = function() {
        function Gradient(colorStops) {
            this.colorStops = colorStops || [];
        }
        Gradient.prototype.addColorStop = function(offset, color) {
            this.colorStops.push({
                offset: offset,
                color: color
            });
        };
        return Gradient;
    }();
    var $e1addc27dbc63739$export$2e2bcd8739ae039 = $e1addc27dbc63739$var$Gradient;
});
parcelRegister("faICo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0ba666d3a488180$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $b0ba666d3a488180$var$RadialGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RadialGradient, _super);
        function RadialGradient(x, y, r, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0.5 : x;
            _this.y = y == null ? 0.5 : y;
            _this.r = r == null ? 0.5 : r;
            _this.type = 'radial';
            _this.global = globalCoord || false;
            return _this;
        }
        return RadialGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $b0ba666d3a488180$export$2e2bcd8739ae039 = $b0ba666d3a488180$var$RadialGradient;
});
parcelRegister("lM5Gp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fda27d30e90880c7$export$2e2bcd8739ae039);
    var $bMDnR;
    var $fda27d30e90880c7$var$extent = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$extent2 = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$OrientedBoundingRect = function() {
        function OrientedBoundingRect(rect, transform) {
            this._corners = [];
            this._axes = [];
            this._origin = [
                0,
                0
            ];
            for(var i = 0; i < 4; i++)this._corners[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            for(var i = 0; i < 2; i++)this._axes[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            if (rect) this.fromBoundingRect(rect, transform);
        }
        OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
            var corners = this._corners;
            var axes = this._axes;
            var x = rect.x;
            var y = rect.y;
            var x2 = x + rect.width;
            var y2 = y + rect.height;
            corners[0].set(x, y);
            corners[1].set(x2, y);
            corners[2].set(x2, y2);
            corners[3].set(x, y2);
            if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[0], corners[1], corners[0]);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[1], corners[3], corners[0]);
            axes[0].normalize();
            axes[1].normalize();
            for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
        };
        OrientedBoundingRect.prototype.intersect = function(other, mtv) {
            var overlapped = true;
            var noMtv = !mtv;
            $fda27d30e90880c7$var$minTv.set(Infinity, Infinity);
            $fda27d30e90880c7$var$maxTv.set(0, 0);
            if (!this._intersectCheckOneSide(this, other, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, 1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!this._intersectCheckOneSide(other, this, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, -1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!noMtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlapped ? $fda27d30e90880c7$var$minTv : $fda27d30e90880c7$var$maxTv);
            return overlapped;
        };
        OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
            var overlapped = true;
            for(var i = 0; i < 2; i++){
                var axis = this._axes[i];
                this._getProjMinMaxOnAxis(i, self._corners, $fda27d30e90880c7$var$extent);
                this._getProjMinMaxOnAxis(i, other._corners, $fda27d30e90880c7$var$extent2);
                if ($fda27d30e90880c7$var$extent[1] < $fda27d30e90880c7$var$extent2[0] || $fda27d30e90880c7$var$extent[0] > $fda27d30e90880c7$var$extent2[1]) {
                    overlapped = false;
                    if (noMtv) return overlapped;
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) > maxTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, -dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, dist1 * inverse);
                    }
                } else if (minTv) {
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) < minTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, -dist1 * inverse);
                    }
                }
            }
            return overlapped;
        };
        OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
            var axis = this._axes[dim];
            var origin = this._origin;
            var proj = corners[0].dot(axis) + origin[dim];
            var min = proj;
            var max = proj;
            for(var i = 1; i < corners.length; i++){
                var proj_1 = corners[i].dot(axis) + origin[dim];
                min = Math.min(proj_1, min);
                max = Math.max(proj_1, max);
            }
            out[0] = min;
            out[1] = max;
        };
        return OrientedBoundingRect;
    }();
    var $fda27d30e90880c7$export$2e2bcd8739ae039 = $fda27d30e90880c7$var$OrientedBoundingRect;
});
parcelRegister("6sllV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b35ebcb0b796fce$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $4b35ebcb0b796fce$var$m = [];
    var $4b35ebcb0b796fce$var$IncrementalDisplayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IncrementalDisplayable, _super);
        function IncrementalDisplayable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.notClear = true;
            _this.incremental = true;
            _this._displayables = [];
            _this._temporaryDisplayables = [];
            _this._cursor = 0;
            return _this;
        }
        IncrementalDisplayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        IncrementalDisplayable.prototype.useStyle = function() {
            this.style = {};
        };
        IncrementalDisplayable.prototype.getCursor = function() {
            return this._cursor;
        };
        IncrementalDisplayable.prototype.innerAfterBrush = function() {
            this._cursor = this._displayables.length;
        };
        IncrementalDisplayable.prototype.clearDisplaybles = function() {
            this._displayables = [];
            this._temporaryDisplayables = [];
            this._cursor = 0;
            this.markRedraw();
            this.notClear = false;
        };
        IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
            this._temporaryDisplayables = [];
        };
        IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
            if (notPersistent) this._temporaryDisplayables.push(displayable);
            else this._displayables.push(displayable);
            this.markRedraw();
        };
        IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
            notPersistent = notPersistent || false;
            for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
        };
        IncrementalDisplayable.prototype.getDisplayables = function() {
            return this._displayables;
        };
        IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
            return this._temporaryDisplayables;
        };
        IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
            for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
            for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
        };
        IncrementalDisplayable.prototype.update = function() {
            this.updateTransform();
            for(var i = this._cursor; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
            for(var i = 0; i < this._temporaryDisplayables.length; i++){
                var displayable = this._temporaryDisplayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
        };
        IncrementalDisplayable.prototype.getBoundingRect = function() {
            if (!this._rect) {
                var rect = new (0, (0, parcelRequire("1E3E8")).default)(Infinity, Infinity, -Infinity, -Infinity);
                for(var i = 0; i < this._displayables.length; i++){
                    var displayable = this._displayables[i];
                    var childRect = displayable.getBoundingRect().clone();
                    if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4b35ebcb0b796fce$var$m));
                    rect.union(childRect);
                }
                this._rect = rect;
            }
            return this._rect;
        };
        IncrementalDisplayable.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                if (displayable.contain(x, y)) return true;
            }
            return false;
        };
        return IncrementalDisplayable;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $4b35ebcb0b796fce$export$2e2bcd8739ae039 = $4b35ebcb0b796fce$var$IncrementalDisplayable;
});
parcelRegister("46U6E", function(module, exports) {
    $parcel$export(module.exports, "LINE_STYLE_KEY_MAP", ()=>$2fe33e7a8dd518cd$export$9f34de5b59222949);
    $parcel$export(module.exports, "LineStyleMixin", ()=>$2fe33e7a8dd518cd$export$91eeeeed4a69a7e7);
    var $1BJbl;
    var $2fe33e7a8dd518cd$export$9f34de5b59222949 = [
        [
            'lineWidth',
            'width'
        ],
        [
            'stroke',
            'color'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'type'
        ],
        [
            'lineDashOffset',
            'dashOffset'
        ],
        [
            'lineCap',
            'cap'
        ],
        [
            'lineJoin',
            'join'
        ],
        [
            'miterLimit'
        ]
    ];
    var $2fe33e7a8dd518cd$var$getLineStyle = (0, (0, parcelRequire("1BJbl")).default)($2fe33e7a8dd518cd$export$9f34de5b59222949);
    var $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7 = function() {
        function LineStyleMixin() {}
        LineStyleMixin.prototype.getLineStyle = function(excludes) {
            return $2fe33e7a8dd518cd$var$getLineStyle(this, excludes);
        };
        return LineStyleMixin;
    }();
});
parcelRegister("4rldO", function(module, exports) {
    $parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", ()=>$33ba2539bbc4d618$export$ffb0bba5dde0130b);
    $parcel$export(module.exports, "ItemStyleMixin", ()=>$33ba2539bbc4d618$export$e4f01e48d6fda412);
    var $1BJbl;
    var $33ba2539bbc4d618$export$ffb0bba5dde0130b = [
        [
            'fill',
            'color'
        ],
        [
            'stroke',
            'borderColor'
        ],
        [
            'lineWidth',
            'borderWidth'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'borderType'
        ],
        [
            'lineDashOffset',
            'borderDashOffset'
        ],
        [
            'lineCap',
            'borderCap'
        ],
        [
            'lineJoin',
            'borderJoin'
        ],
        [
            'miterLimit',
            'borderMiterLimit'
        ]
    ];
    var $33ba2539bbc4d618$var$getItemStyle = (0, (0, parcelRequire("1BJbl")).default)($33ba2539bbc4d618$export$ffb0bba5dde0130b);
    var $33ba2539bbc4d618$export$e4f01e48d6fda412 = function() {
        function ItemStyleMixin() {}
        ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
            return $33ba2539bbc4d618$var$getItemStyle(this, excludes, includes);
        };
        return ItemStyleMixin;
    }();
});
parcelRegister("4wWkb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34c7649bb9fc460b$export$2e2bcd8739ae039);
    function $34c7649bb9fc460b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
        return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
    }
    function $34c7649bb9fc460b$var$defaultKeyGetter(item) {
        return item;
    }
    var $34c7649bb9fc460b$var$DataDiffer = function() {
        function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
            this._old = oldArr;
            this._new = newArr;
            this._oldKeyGetter = oldKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this._newKeyGetter = newKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this.context = context;
            this._diffModeMultiple = diffMode === 'multiple';
        }
        DataDiffer.prototype.add = function(func) {
            this._add = func;
            return this;
        };
        DataDiffer.prototype.update = function(func) {
            this._update = func;
            return this;
        };
        DataDiffer.prototype.updateManyToOne = function(func) {
            this._updateManyToOne = func;
            return this;
        };
        DataDiffer.prototype.updateOneToMany = function(func) {
            this._updateOneToMany = func;
            return this;
        };
        DataDiffer.prototype.updateManyToMany = function(func) {
            this._updateManyToMany = func;
            return this;
        };
        DataDiffer.prototype.remove = function(func) {
            this._remove = func;
            return this;
        };
        DataDiffer.prototype.execute = function() {
            this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
        };
        DataDiffer.prototype._executeOneToOne = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var newDataIndexMap = {};
            var oldDataKeyArr = new Array(oldArr.length);
            var newDataKeyArr = new Array(newArr.length);
            this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (newIdxMapValLen > 1) {
                    var newIdx = newIdxMapVal.shift();
                    if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                    this._update && this._update(newIdx, i);
                } else if (newIdxMapValLen === 1) {
                    newDataIndexMap[oldKey] = null;
                    this._update && this._update(newIdxMapVal, i);
                } else this._remove && this._remove(i);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._executeMultiple = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var oldDataIndexMap = {};
            var newDataIndexMap = {};
            var oldDataKeyArr = [];
            var newDataKeyArr = [];
            this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldDataKeyArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var oldIdxMapVal = oldDataIndexMap[oldKey];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var oldIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(oldIdxMapVal);
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                    this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                    this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                    this._update && this._update(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                    this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
                else this._remove && this._remove(oldIdxMapVal);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
            for(var i = 0; i < newDataKeyArr.length; i++){
                var newKey = newDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[newKey];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
                else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
                newDataIndexMap[newKey] = null;
            }
        };
        DataDiffer.prototype._initIndexMap = function(arr, map, keyArr, keyGetterName) {
            var cbModeMultiple = this._diffModeMultiple;
            for(var i = 0; i < arr.length; i++){
                var key = '_ec_' + this[keyGetterName](arr[i], i);
                if (!cbModeMultiple) keyArr[i] = key;
                if (!map) continue;
                var idxMapVal = map[key];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(idxMapVal);
                if (idxMapValLen === 0) {
                    map[key] = i;
                    if (cbModeMultiple) keyArr.push(key);
                } else if (idxMapValLen === 1) map[key] = [
                    idxMapVal,
                    i
                ];
                else idxMapVal.push(i);
            }
        };
        return DataDiffer;
    }();
    var $34c7649bb9fc460b$export$2e2bcd8739ae039 = $34c7649bb9fc460b$var$DataDiffer;
});
parcelRegister("9OHWG", function(module, exports) {
    $parcel$export(module.exports, "DefaultDataProvider", ()=>$725adf3ea01375e6$export$b900d7c4c3952a40);
    $parcel$export(module.exports, "getRawSourceItemGetter", ()=>$725adf3ea01375e6$export$92c8ea8642b3957d);
    $parcel$export(module.exports, "getRawSourceDataCounter", ()=>$725adf3ea01375e6$export$803742e832f4b52c);
    $parcel$export(module.exports, "getRawSourceValueGetter", ()=>$725adf3ea01375e6$export$1752de8084789a14);
    $parcel$export(module.exports, "retrieveRawValue", ()=>$725adf3ea01375e6$export$cde9373da9aad801);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $2Rbm1;
    var $725adf3ea01375e6$var$_a, $725adf3ea01375e6$var$_b, $725adf3ea01375e6$var$_c;
    var $725adf3ea01375e6$var$providerMethods;
    var $725adf3ea01375e6$var$mountMethods;
    var $725adf3ea01375e6$export$b900d7c4c3952a40 = function() {
        function DefaultDataProvider(sourceParam, dimSize) {
            var source = !(0, (0, parcelRequire("20liu")).isSourceInstance)(sourceParam) ? (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceParam) : sourceParam;
            this._source = source;
            var data = this._data = source.data;
            if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                this._offset = 0;
                this._dimSize = dimSize;
                this._data = data;
            }
            $725adf3ea01375e6$var$mountMethods(this, data, source);
        }
        DefaultDataProvider.prototype.getSource = function() {
            return this._source;
        };
        DefaultDataProvider.prototype.count = function() {
            return 0;
        };
        DefaultDataProvider.prototype.getItem = function(idx, out) {
            return;
        };
        DefaultDataProvider.prototype.appendData = function(newData) {};
        DefaultDataProvider.prototype.clean = function() {};
        DefaultDataProvider.protoInitialize = function() {
            var proto = DefaultDataProvider.prototype;
            proto.pure = false;
            proto.persistent = true;
        }();
        DefaultDataProvider.internalField = function() {
            var _a;
            $725adf3ea01375e6$var$mountMethods = function(provider, data, source) {
                var sourceFormat = source.sourceFormat;
                var seriesLayoutBy = source.seriesLayoutBy;
                var startIndex = source.startIndex;
                var dimsDef = source.dimensionsDefine;
                var methods = $725adf3ea01375e6$var$providerMethods[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
                (0, (0, parcelRequire("bahqM")).extend)(provider, methods);
                if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                    provider.getItem = getItemForTypedArray;
                    provider.count = countForTypedArray;
                    provider.fillStorage = fillStorageForTypedArray;
                } else {
                    var rawItemGetter = $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                    provider.getItem = (0, (0, parcelRequire("bahqM")).bind)(rawItemGetter, null, data, startIndex, dimsDef);
                    var rawCounter = $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                    provider.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, startIndex, dimsDef);
                }
            };
            var getItemForTypedArray = function(idx, out) {
                idx = idx - this._offset;
                out = out || [];
                var data = this._data;
                var dimSize = this._dimSize;
                var offset = dimSize * idx;
                for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
                return out;
            };
            var fillStorageForTypedArray = function(start, end, storage, extent) {
                var data = this._data;
                var dimSize = this._dimSize;
                for(var dim = 0; dim < dimSize; dim++){
                    var dimExtent = extent[dim];
                    var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                    var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                    var count = end - start;
                    var arr = storage[dim];
                    for(var i = 0; i < count; i++){
                        var val = data[i * dimSize + dim];
                        arr[start + i] = val;
                        val < min && (min = val);
                        val > max && (max = val);
                    }
                    dimExtent[0] = min;
                    dimExtent[1] = max;
                }
            };
            var countForTypedArray = function() {
                return this._data ? this._data.length / this._dimSize : 0;
            };
            $725adf3ea01375e6$var$providerMethods = (_a = {}, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = {
                pure: true,
                appendData: function() {
                    throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = {
                pure: true,
                appendData: function(newData) {
                    var data = this._data;
                    (0, (0, parcelRequire("bahqM")).each)(newData, function(newCol, key) {
                        var oldCol = data[key] || (data[key] = []);
                        for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                    });
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = {
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = {
                persistent: false,
                pure: true,
                appendData: function(newData) {
                    this._data = newData;
                },
                clean: function() {
                    this._offset += this.count();
                    this._data = null;
                }
            }, _a);
            function appendDataSimply(newData) {
                for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
            }
        }();
        return DefaultDataProvider;
    }();
    var $725adf3ea01375e6$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx];
    };
    var $725adf3ea01375e6$var$rawSourceItemGetterMap = ($725adf3ea01375e6$var$_a = {}, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx + startIndex];
    }, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
        idx += startIndex;
        var item = out || [];
        var data = rawData;
        for(var i = 0; i < data.length; i++){
            var row = data[i];
            item[i] = row ? row[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
        var item = out || [];
        for(var i = 0; i < dimsDef.length; i++){
            var dimName = dimsDef[i].name;
            var col = rawData[dimName];
            item[i] = col ? col[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a);
    function $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceItemGetterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$countSimply = function(rawData, startIndex, dimsDef) {
        return rawData.length;
    };
    var $725adf3ea01375e6$var$rawSourceDataCounterMap = ($725adf3ea01375e6$var$_b = {}, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
        return Math.max(0, rawData.length - startIndex);
    }, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
        var row = rawData[0];
        return row ? Math.max(0, row.length - startIndex) : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
        var dimName = dimsDef[0].name;
        var col = rawData[dimName];
        return col ? col.length : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b);
    function $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceDataCounterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$getRawValueSimply = function(dataItem, dimIndex, property) {
        return dataItem[dimIndex];
    };
    var $725adf3ea01375e6$var$rawSourceValueGetterMap = ($725adf3ea01375e6$var$_c = {}, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
        return dataItem[property];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
        var value = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
        return !(value instanceof Array) ? value : value[dimIndex];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c);
    function $725adf3ea01375e6$export$1752de8084789a14(sourceFormat) {
        var method = $725adf3ea01375e6$var$rawSourceValueGetterMap[sourceFormat];
        return method;
    }
    function $725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
    }
    function $725adf3ea01375e6$export$cde9373da9aad801(data, dataIndex, dim) {
        if (!data) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (dataItem == null) return;
        var store = data.getStore();
        var sourceFormat = store.getSource().sourceFormat;
        if (dim != null) {
            var dimIndex = data.getDimensionIndex(dim);
            var property = store.getDimensionProperty(dimIndex);
            return $725adf3ea01375e6$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
        } else {
            var result = dataItem;
            if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) result = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
            return result;
        }
    }
    function $725adf3ea01375e6$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
        if (!data) return;
        var sourceFormat = data.getStore().getSource().sourceFormat;
        if (sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && !(0, (0, parcelRequire("bahqM")).isObject)(dataItem)) dataItem = null;
        if (dataItem) return dataItem[attr];
    }
});
parcelRegister("20liu", function(module, exports) {
    $parcel$export(module.exports, "isSourceInstance", ()=>$175c1a118c738be0$export$22b808bc02a60488);
    $parcel$export(module.exports, "createSource", ()=>$175c1a118c738be0$export$1921362e86c73c88);
    $parcel$export(module.exports, "detectSourceFormat", ()=>$175c1a118c738be0$export$52a469afa4653e57);
    $parcel$export(module.exports, "createSourceFromSeriesDataOption", ()=>$175c1a118c738be0$export$75aef3f97c0a5edf);
    $parcel$export(module.exports, "cloneSourceShallow", ()=>$175c1a118c738be0$export$e0365e7e3555ddd4);
    $parcel$export(module.exports, "shouldRetrieveDataByName", ()=>$175c1a118c738be0$export$8911336b527f8517);
    var $bahqM;
    var $2Rbm1;
    var $eaKsF;
    var $cNGs8;
    var $175c1a118c738be0$var$SourceImpl = function() {
        function SourceImpl(fields) {
            this.data = fields.data || (fields.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
            this.sourceFormat = fields.sourceFormat || (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
            this.seriesLayoutBy = fields.seriesLayoutBy || (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN);
            this.startIndex = fields.startIndex || 0;
            this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
            this.metaRawOption = fields.metaRawOption;
            var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
            if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
                var dim = dimensionsDefine[i];
                if (dim.type == null) {
                    if ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(this, i) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must) dim.type = 'ordinal';
                }
            }
        }
        return SourceImpl;
    }();
    function $175c1a118c738be0$export$22b808bc02a60488(val) {
        return val instanceof $175c1a118c738be0$var$SourceImpl;
    }
    function $175c1a118c738be0$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
        sourceFormat = sourceFormat || $175c1a118c738be0$export$52a469afa4653e57(sourceData);
        var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
        var determined = $175c1a118c738be0$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
        var source = new $175c1a118c738be0$var$SourceImpl({
            data: sourceData,
            sourceFormat: sourceFormat,
            seriesLayoutBy: seriesLayoutBy,
            dimensionsDefine: determined.dimensionsDefine,
            startIndex: determined.startIndex,
            dimensionsDetectedCount: determined.dimensionsDetectedCount,
            metaRawOption: (0, (0, parcelRequire("bahqM")).clone)(thisMetaRawOption)
        });
        return source;
    }
    function $175c1a118c738be0$export$75aef3f97c0a5edf(data) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: data,
            sourceFormat: (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)
        });
    }
    function $175c1a118c738be0$export$e0365e7e3555ddd4(source) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: source.data,
            sourceFormat: source.sourceFormat,
            seriesLayoutBy: source.seriesLayoutBy,
            dimensionsDefine: (0, (0, parcelRequire("bahqM")).clone)(source.dimensionsDefine),
            startIndex: source.startIndex,
            dimensionsDetectedCount: source.dimensionsDetectedCount
        });
    }
    function $175c1a118c738be0$export$52a469afa4653e57(data) {
        var sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY);
        else if ((0, (0, parcelRequire("bahqM")).isArray)(data)) {
            if (data.length === 0) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
            for(var i = 0, len = data.length; i < len; i++){
                var item = data[i];
                if (item == null) continue;
                else if ((0, (0, parcelRequire("bahqM")).isArray)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
                    break;
                } else if ((0, (0, parcelRequire("bahqM")).isObject)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
                    break;
                }
            }
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(data)) {
            for(var key in data)if ((0, (0, parcelRequire("bahqM")).hasOwn)(data, key) && (0, (0, parcelRequire("bahqM")).isArrayLike)(data[key])) {
                sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
                break;
            }
        }
        return sourceFormat;
    }
    function $175c1a118c738be0$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
        var dimensionsDetectedCount;
        var startIndex;
        if (!data) return {
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            startIndex: startIndex,
            dimensionsDetectedCount: dimensionsDetectedCount
        };
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (sourceHeader === 'auto' || sourceHeader == null) $175c1a118c738be0$var$arrayRowsTravelFirst(function(val) {
                if (val != null && val !== '-') {
                    if ((0, (0, parcelRequire("bahqM")).isString)(val)) startIndex == null && (startIndex = 1);
                    else startIndex = 0;
                }
            }, seriesLayoutBy, dataArrayRows, 10);
            else startIndex = (0, (0, parcelRequire("bahqM")).isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
            if (!dimensionsDefine && startIndex === 1) {
                dimensionsDefine = [];
                $175c1a118c738be0$var$arrayRowsTravelFirst(function(val, index) {
                    dimensionsDefine[index] = val != null ? val + '' : '';
                }, seriesLayoutBy, dataArrayRows, Infinity);
            }
            dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            if (!dimensionsDefine) dimensionsDefine = $175c1a118c738be0$var$objectRowsCollectDimensions(data);
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            if (!dimensionsDefine) {
                dimensionsDefine = [];
                (0, (0, parcelRequire("bahqM")).each)(data, function(colArr, key) {
                    dimensionsDefine.push(key);
                });
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var value0 = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(data[0]);
            dimensionsDetectedCount = (0, (0, parcelRequire("bahqM")).isArray)(value0) && value0.length || 1;
        }
        return {
            startIndex: startIndex,
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            dimensionsDetectedCount: dimensionsDetectedCount
        };
    }
    function $175c1a118c738be0$var$objectRowsCollectDimensions(data) {
        var firstIndex = 0;
        var obj;
        while(firstIndex < data.length && !(obj = data[firstIndex++]));
        if (obj) {
            var dimensions_1 = [];
            (0, (0, parcelRequire("bahqM")).each)(obj, function(value, key) {
                dimensions_1.push(key);
            });
            return dimensions_1;
        }
    }
    function $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine) {
        if (!dimensionsDefine) return;
        var nameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        return (0, (0, parcelRequire("bahqM")).map)(dimensionsDefine, function(rawItem, index) {
            rawItem = (0, (0, parcelRequire("bahqM")).isObject)(rawItem) ? rawItem : {
                name: rawItem
            };
            var item = {
                name: rawItem.name,
                displayName: rawItem.displayName,
                type: rawItem.type
            };
            if (item.name == null) return item;
            item.name += '';
            if (item.displayName == null) item.displayName = item.name;
            var exist = nameMap.get(item.name);
            if (!exist) nameMap.set(item.name, {
                count: 1
            });
            else item.name += '-' + exist.count++;
            return item;
        });
    }
    function $175c1a118c738be0$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
        if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
        else {
            var value0 = data[0] || [];
            for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
        }
    }
    function $175c1a118c738be0$export$8911336b527f8517(source) {
        var sourceFormat = source.sourceFormat;
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
    }
});
parcelRegister("2Rbm1", function(module, exports) {
    $parcel$export(module.exports, "VISUAL_DIMENSIONS", ()=>$214956bc17bbe3d3$export$cd51b5ca77f6f0e4);
    $parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", ()=>$214956bc17bbe3d3$export$2823037fb9d8f0c6);
    $parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", ()=>$214956bc17bbe3d3$export$fcd62ebf51387903);
    $parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", ()=>$214956bc17bbe3d3$export$703ae8a2d83f441);
    $parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", ()=>$214956bc17bbe3d3$export$6a32b42c754a3cb8);
    $parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", ()=>$214956bc17bbe3d3$export$a918cb016a382d45);
    $parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", ()=>$214956bc17bbe3d3$export$c78f1330778d30d);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", ()=>$214956bc17bbe3d3$export$7b3f3c6551b4949b);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", ()=>$214956bc17bbe3d3$export$d55da1467cdf7804);
    var $bahqM;
    var $214956bc17bbe3d3$export$cd51b5ca77f6f0e4 = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'tooltip',
        'label',
        'itemName',
        'itemId',
        'itemGroupId',
        'seriesName'
    ]);
    var $214956bc17bbe3d3$export$2823037fb9d8f0c6 = 'original';
    var $214956bc17bbe3d3$export$fcd62ebf51387903 = 'arrayRows';
    var $214956bc17bbe3d3$export$703ae8a2d83f441 = 'objectRows';
    var $214956bc17bbe3d3$export$6a32b42c754a3cb8 = 'keyedColumns';
    var $214956bc17bbe3d3$export$a918cb016a382d45 = 'typedArray';
    var $214956bc17bbe3d3$export$c78f1330778d30d = 'unknown';
    var $214956bc17bbe3d3$export$7b3f3c6551b4949b = 'column';
    var $214956bc17bbe3d3$export$d55da1467cdf7804 = 'row';
});
parcelRegister("cNGs8", function(module, exports) {
    $parcel$export(module.exports, "BE_ORDINAL", ()=>$951afdda7935b9af$export$328749e9c5b40760);
    $parcel$export(module.exports, "resetSourceDefaulter", ()=>$951afdda7935b9af$export$b30cdea50aa00e6);
    $parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", ()=>$951afdda7935b9af$export$37682b8fdd2e83d);
    $parcel$export(module.exports, "querySeriesUpstreamDatasetModel", ()=>$951afdda7935b9af$export$8da66f73a1eda454);
    $parcel$export(module.exports, "makeSeriesEncodeForNameBased", ()=>$951afdda7935b9af$export$60b8a57d1f2fed26);
    $parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", ()=>$951afdda7935b9af$export$397ba553479711e7);
    $parcel$export(module.exports, "guessOrdinal", ()=>$951afdda7935b9af$export$c51adf1a2be01b9c);
    var $eaKsF;
    var $bahqM;
    var $2Rbm1;
    var $951afdda7935b9af$export$328749e9c5b40760 = {
        Must: 1,
        Might: 2,
        Not: 3
    };
    var $951afdda7935b9af$var$innerGlobalModel = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $951afdda7935b9af$export$b30cdea50aa00e6(ecModel) {
        $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    }
    function $951afdda7935b9af$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel || !coordDimensions) return encode;
        var encodeItemName = [];
        var encodeSeriesName = [];
        var ecModel = seriesModel.ecModel;
        var datasetMap = $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap;
        var key = datasetModel.uid + '_' + source.seriesLayoutBy;
        var baseCategoryDimIndex;
        var categoryWayValueDimStart;
        coordDimensions = coordDimensions.slice();
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
            var coordDimInfo = (0, (0, parcelRequire("bahqM")).isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
                name: coordDimInfoLoose
            };
            if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
                baseCategoryDimIndex = coordDimIdx;
                categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
            }
            encode[coordDimInfo.name] = [];
        });
        var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
            categoryWayDim: categoryWayValueDimStart,
            valueWayDim: 0
        });
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
            var coordDimName = coordDimInfo.name;
            var count = getDataDimCountOnCoordDim(coordDimInfo);
            if (baseCategoryDimIndex == null) {
                var start = datasetRecord.valueWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.valueWayDim += count;
            } else if (baseCategoryDimIndex === coordDimIdx) {
                pushDim(encode[coordDimName], 0, count);
                pushDim(encodeItemName, 0, count);
            } else {
                var start = datasetRecord.categoryWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.categoryWayDim += count;
            }
        });
        function pushDim(dimIdxArr, idxFrom, idxCount) {
            for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
        }
        function getDataDimCountOnCoordDim(coordDimInfo) {
            var dimsDef = coordDimInfo.dimsDef;
            return dimsDef ? dimsDef.length : 1;
        }
        encodeItemName.length && (encode.itemName = encodeItemName);
        encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
        return encode;
    }
    function $951afdda7935b9af$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel) return encode;
        var sourceFormat = source.sourceFormat;
        var dimensionsDefine = source.dimensionsDefine;
        var potentialNameDimIndex;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) (0, (0, parcelRequire("bahqM")).each)(dimensionsDefine, function(dim, idx) {
            if (((0, (0, parcelRequire("bahqM")).isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
        });
        var idxResult = function() {
            var idxRes0 = {};
            var idxRes1 = {};
            var guessRecords = [];
            for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
                var guessResult = $951afdda7935b9af$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
                guessRecords.push(guessResult);
                var isPureNumber = guessResult === $951afdda7935b9af$export$328749e9c5b40760.Not;
                if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
                if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $951afdda7935b9af$export$328749e9c5b40760.Not) idxRes0.n = i;
                if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $951afdda7935b9af$export$328749e9c5b40760.Not) return idxRes0;
                if (!isPureNumber) {
                    if (guessResult === $951afdda7935b9af$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                    if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
                }
            }
            function fulfilled(idxResult) {
                return idxResult.v != null && idxResult.n != null;
            }
            return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
        }();
        if (idxResult) {
            encode.value = [
                idxResult.v
            ];
            var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
            encode.itemName = [
                nameDimIndex
            ];
            encode.seriesName = [
                nameDimIndex
            ];
        }
        return encode;
    }
    function $951afdda7935b9af$export$8da66f73a1eda454(seriesModel) {
        var thisData = seriesModel.get('data', true);
        if (!thisData) return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(seriesModel.ecModel, 'dataset', {
            index: seriesModel.get('datasetIndex', true),
            id: seriesModel.get('datasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
    }
    function $951afdda7935b9af$export$397ba553479711e7(datasetModel) {
        if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
        return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(datasetModel.ecModel, 'dataset', {
            index: datasetModel.get('fromDatasetIndex', true),
            id: datasetModel.get('fromDatasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models;
    }
    function $951afdda7935b9af$export$c51adf1a2be01b9c(source, dimIndex) {
        return $951afdda7935b9af$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
    }
    function $951afdda7935b9af$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
        var result;
        var maxLoop = 5;
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        var dimName;
        var dimType;
        if (dimensionsDefine) {
            var dimDefItem = dimensionsDefine[dimIndex];
            if ((0, (0, parcelRequire("bahqM")).isObject)(dimDefItem)) {
                dimName = dimDefItem.name;
                dimType = dimDefItem.type;
            } else if ((0, (0, parcelRequire("bahqM")).isString)(dimDefItem)) dimName = dimDefItem;
        }
        if (dimType != null) return dimType === 'ordinal' ? $951afdda7935b9af$export$328749e9c5b40760.Must : $951afdda7935b9af$export$328749e9c5b40760.Not;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) {
                var sample = dataArrayRows[dimIndex];
                for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                    if ((result = detectValue(sample[startIndex + i])) != null) return result;
                }
            } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
                var row = dataArrayRows[startIndex + i];
                if (row && (result = detectValue(row[dimIndex])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var dataObjectRows = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
                var item = dataObjectRows[i];
                if (item && (result = detectValue(item[dimName])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            var dataKeyedColumns = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            var sample = dataKeyedColumns[dimName];
            if (!sample || (0, (0, parcelRequire("bahqM")).isTypedArray)(sample)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < sample.length && i < maxLoop; i++){
                if ((result = detectValue(sample[i])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var dataOriginal = data;
            for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
                var item = dataOriginal[i];
                var val = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(item);
                if (!(0, (0, parcelRequire("bahqM")).isArray)(val)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
                if ((result = detectValue(val[dimIndex])) != null) return result;
            }
        }
        function detectValue(val) {
            var beStr = (0, (0, parcelRequire("bahqM")).isString)(val);
            if (val != null && isFinite(val) && val !== '') return beStr ? $951afdda7935b9af$export$328749e9c5b40760.Might : $951afdda7935b9af$export$328749e9c5b40760.Not;
            else if (beStr && val !== '-') return $951afdda7935b9af$export$328749e9c5b40760.Must;
        }
        return $951afdda7935b9af$export$328749e9c5b40760.Not;
    }
});
parcelRegister("bnVGB", function(module, exports) {
    $parcel$export(module.exports, "summarizeDimensions", ()=>$849e96f8af2f129f$export$505a22c3734846f1);
    $parcel$export(module.exports, "getDimensionTypeByAxis", ()=>$849e96f8af2f129f$export$af1622903e71278e);
    var $bahqM;
    var $2Rbm1;
    var $849e96f8af2f129f$var$DimensionUserOuput = function() {
        function DimensionUserOuput(encode, dimRequest) {
            this._encode = encode;
            this._schema = dimRequest;
        }
        DimensionUserOuput.prototype.get = function() {
            return {
                fullDimensions: this._getFullDimensionNames(),
                encode: this._encode
            };
        };
        DimensionUserOuput.prototype._getFullDimensionNames = function() {
            if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
            return this._cachedDimNames;
        };
        return DimensionUserOuput;
    }();
    function $849e96f8af2f129f$export$505a22c3734846f1(data, schema) {
        var summary = {};
        var encode = summary.encode = {};
        var notExtraCoordDimMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var defaultedLabel = [];
        var defaultedTooltip = [];
        var userOutputEncode = {};
        (0, (0, parcelRequire("bahqM")).each)(data.dimensions, function(dimName) {
            var dimItem = data.getDimensionInfo(dimName);
            var coordDim = dimItem.coordDim;
            if (coordDim) {
                var coordDimIndex = dimItem.coordDimIndex;
                $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
                if (!dimItem.isExtraCoord) {
                    notExtraCoordDimMap.set(coordDim, 1);
                    if ($849e96f8af2f129f$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                    $849e96f8af2f129f$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
                }
                if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
            }
            (0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).each(function(v, otherDim) {
                var encodeArr = $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, otherDim);
                var dimIndex = dimItem.otherDims[otherDim];
                if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
            });
        });
        var dataDimsOnCoord = [];
        var encodeFirstDimNotExtra = {};
        notExtraCoordDimMap.each(function(v, coordDim) {
            var dimArr = encode[coordDim];
            encodeFirstDimNotExtra[coordDim] = dimArr[0];
            dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
        });
        summary.dataDimsOnCoord = dataDimsOnCoord;
        summary.dataDimIndicesOnCoord = (0, (0, parcelRequire("bahqM")).map)(dataDimsOnCoord, function(dimName) {
            return data.getDimensionInfo(dimName).storeDimIndex;
        });
        summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
        var encodeLabel = encode.label;
        if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
        var encodeTooltip = encode.tooltip;
        if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
        else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
        encode.defaultedLabel = defaultedLabel;
        encode.defaultedTooltip = defaultedTooltip;
        summary.userOutput = new $849e96f8af2f129f$var$DimensionUserOuput(userOutputEncode, schema);
        return summary;
    }
    function $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, dim) {
        if (!encode.hasOwnProperty(dim)) encode[dim] = [];
        return encode[dim];
    }
    function $849e96f8af2f129f$export$af1622903e71278e(axisType) {
        return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
    }
    function $849e96f8af2f129f$var$mayLabelDimType(dimType) {
        return !(dimType === 'ordinal' || dimType === 'time');
    }
});
parcelRegister("dhxbO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ab69ba7880d9dc2$export$2e2bcd8739ae039);
    var $bahqM;
    var $9ab69ba7880d9dc2$var$SeriesDimensionDefine = function() {
        function SeriesDimensionDefine(opt) {
            this.otherDims = {};
            if (opt != null) (0, parcelRequire("bahqM")).extend(this, opt);
        }
        return SeriesDimensionDefine;
    }();
    var $9ab69ba7880d9dc2$export$2e2bcd8739ae039 = $9ab69ba7880d9dc2$var$SeriesDimensionDefine;
});
parcelRegister("8c3gC", function(module, exports) {
    $parcel$export(module.exports, "CtorInt32Array", ()=>$5f71fa7e68f8e2cf$export$b60d945128546f53);
    $parcel$export(module.exports, "default", ()=>$5f71fa7e68f8e2cf$export$2e2bcd8739ae039);
    var $bahqM;
    var $2G90t;
    var $20liu;
    var $5f71fa7e68f8e2cf$var$UNDEFINED = 'undefined';
    var $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 = typeof Uint32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint32Array;
    var $5f71fa7e68f8e2cf$export$78cf73566f32c185 = typeof Uint16Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint16Array;
    var $5f71fa7e68f8e2cf$export$b60d945128546f53 = typeof Int32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Int32Array;
    var $5f71fa7e68f8e2cf$export$365b104db51a490a = typeof Float64Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Float64Array;
    var $5f71fa7e68f8e2cf$var$dataCtors = {
        'float': $5f71fa7e68f8e2cf$export$365b104db51a490a,
        'int': $5f71fa7e68f8e2cf$export$b60d945128546f53,
        'ordinal': Array,
        'number': Array,
        'time': $5f71fa7e68f8e2cf$export$365b104db51a490a
    };
    var $5f71fa7e68f8e2cf$var$defaultDimValueGetters;
    function $5f71fa7e68f8e2cf$var$getIndicesCtor(rawCount) {
        return rawCount > 65535 ? $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 : $5f71fa7e68f8e2cf$export$78cf73566f32c185;
    }
    function $5f71fa7e68f8e2cf$var$getInitialExtent() {
        return [
            Infinity,
            -Infinity
        ];
    }
    function $5f71fa7e68f8e2cf$var$cloneChunk(originalChunk) {
        var Ctor = originalChunk.constructor;
        return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
    }
    function $5f71fa7e68f8e2cf$var$prepareStore(store, dimIdx, dimType, end, append) {
        var DataCtor = $5f71fa7e68f8e2cf$var$dataCtors[dimType || 'float'];
        if (append) {
            var oldStore = store[dimIdx];
            var oldLen = oldStore && oldStore.length;
            if (!(oldLen === end)) {
                var newStore = new DataCtor(end);
                for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
                store[dimIdx] = newStore;
            }
        } else store[dimIdx] = new DataCtor(end);
    }
    var $5f71fa7e68f8e2cf$var$DataStore = function() {
        function DataStore() {
            this._chunks = [];
            this._rawExtent = [];
            this._extent = [];
            this._count = 0;
            this._rawCount = 0;
            this._calcDimNameToIdx = (0, (0, parcelRequire("bahqM")).createHashMap)();
        }
        DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
            this._provider = provider;
            this._chunks = [];
            this._indices = null;
            this.getRawIndex = this._getRawIdxIdentity;
            var source = provider.getSource();
            var defaultGetter = this.defaultDimValueGetter = $5f71fa7e68f8e2cf$var$defaultDimValueGetters[source.sourceFormat];
            this._dimValueGetter = dimValueGetter || defaultGetter;
            this._rawExtent = [];
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(source);
            this._dimensions = (0, (0, parcelRequire("bahqM")).map)(inputDimensions, function(dim) {
                return {
                    type: dim.type,
                    property: dim.property
                };
            });
            this._initDataFromProvider(0, provider.count());
        };
        DataStore.prototype.getProvider = function() {
            return this._provider;
        };
        DataStore.prototype.getSource = function() {
            return this._provider.getSource();
        };
        DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
            var calcDimNameToIdx = this._calcDimNameToIdx;
            var dimensions = this._dimensions;
            var calcDimIdx = calcDimNameToIdx.get(dimName);
            if (calcDimIdx != null) {
                if (dimensions[calcDimIdx].type === type) return calcDimIdx;
            } else calcDimIdx = dimensions.length;
            dimensions[calcDimIdx] = {
                type: type
            };
            calcDimNameToIdx.set(dimName, calcDimIdx);
            this._chunks[calcDimIdx] = new $5f71fa7e68f8e2cf$var$dataCtors[type || 'float'](this._rawCount);
            this._rawExtent[calcDimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            return calcDimIdx;
        };
        DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
            var chunk = this._chunks[dimIdx];
            var dim = this._dimensions[dimIdx];
            var rawExtents = this._rawExtent;
            var offset = dim.ordinalOffset || 0;
            var len = chunk.length;
            if (offset === 0) rawExtents[dimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var dimRawExtent = rawExtents[dimIdx];
            for(var i = offset; i < len; i++){
                var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
            dim.ordinalMeta = ordinalMeta;
            dim.ordinalOffset = len;
            dim.type = 'ordinal';
        };
        DataStore.prototype.getOrdinalMeta = function(dimIdx) {
            var dimInfo = this._dimensions[dimIdx];
            var ordinalMeta = dimInfo.ordinalMeta;
            return ordinalMeta;
        };
        DataStore.prototype.getDimensionProperty = function(dimIndex) {
            var item = this._dimensions[dimIndex];
            return item && item.property;
        };
        DataStore.prototype.appendData = function(data) {
            var provider = this._provider;
            var start = this.count();
            provider.appendData(data);
            var end = provider.count();
            if (!provider.persistent) end += start;
            if (start < end) this._initDataFromProvider(start, end, true);
            return [
                start,
                end
            ];
        };
        DataStore.prototype.appendValues = function(values, minFillLen) {
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var start = this.count();
            var end = start + Math.max(values.length, minFillLen || 0);
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, true);
            }
            var emptyDataItem = [];
            for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dim = dimensions[dimIdx];
                    var val = $5f71fa7e68f8e2cf$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                    chunks[dimIdx][idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
            this._rawCount = this._count = end;
            return {
                start: start,
                end: end
            };
        };
        DataStore.prototype._initDataFromProvider = function(start, end, append) {
            var provider = this._provider;
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var dimNames = (0, (0, parcelRequire("bahqM")).map)(dimensions, function(dim) {
                return dim.property;
            });
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                if (!rawExtent[i]) rawExtent[i] = $5f71fa7e68f8e2cf$var$getInitialExtent();
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, append);
            }
            if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
            else {
                var dataItem = [];
                for(var idx = start; idx < end; idx++){
                    dataItem = provider.getItem(idx, dataItem);
                    for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                        var dimStorage = chunks[dimIdx];
                        var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                        dimStorage[idx] = val;
                        var dimRawExtent = rawExtent[dimIdx];
                        val < dimRawExtent[0] && (dimRawExtent[0] = val);
                        val > dimRawExtent[1] && (dimRawExtent[1] = val);
                    }
                }
            }
            if (!provider.persistent && provider.clean) provider.clean();
            this._rawCount = this._count = end;
            this._extent = [];
        };
        DataStore.prototype.count = function() {
            return this._count;
        };
        DataStore.prototype.get = function(dim, idx) {
            if (!(idx >= 0 && idx < this._count)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
        };
        DataStore.prototype.getValues = function(dimensions, idx) {
            var values = [];
            var dimArr = [];
            if (idx == null) {
                idx = dimensions;
                dimensions = [];
                for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
            } else dimArr = dimensions;
            for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
            return values;
        };
        DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
            if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[rawIdx] : NaN;
        };
        DataStore.prototype.getSum = function(dim) {
            var dimData = this._chunks[dim];
            var sum = 0;
            if (dimData) for(var i = 0, len = this.count(); i < len; i++){
                var value = this.get(dim, i);
                if (!isNaN(value)) sum += value;
            }
            return sum;
        };
        DataStore.prototype.getMedian = function(dim) {
            var dimDataArray = [];
            this.each([
                dim
            ], function(val) {
                if (!isNaN(val)) dimDataArray.push(val);
            });
            var sortedDimDataArray = dimDataArray.sort(function(a, b) {
                return a - b;
            });
            var len = this.count();
            return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
        };
        DataStore.prototype.indexOfRawIndex = function(rawIndex) {
            if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
            if (!this._indices) return rawIndex;
            var indices = this._indices;
            var rawDataIndex = indices[rawIndex];
            if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
            var left = 0;
            var right = this._count - 1;
            while(left <= right){
                var mid = (left + right) / 2 | 0;
                if (indices[mid] < rawIndex) left = mid + 1;
                else if (indices[mid] > rawIndex) right = mid - 1;
                else return mid;
            }
            return -1;
        };
        DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            var chunks = this._chunks;
            var dimData = chunks[dim];
            var nearestIndices = [];
            if (!dimData) return nearestIndices;
            if (maxDistance == null) maxDistance = Infinity;
            var minDist = Infinity;
            var minDiff = -1;
            var nearestIndicesLen = 0;
            for(var i = 0, len = this.count(); i < len; i++){
                var dataIndex = this.getRawIndex(i);
                var diff = value - dimData[dataIndex];
                var dist = Math.abs(diff);
                if (dist <= maxDistance) {
                    if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                        minDist = dist;
                        minDiff = diff;
                        nearestIndicesLen = 0;
                    }
                    if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
                }
            }
            nearestIndices.length = nearestIndicesLen;
            return nearestIndices;
        };
        DataStore.prototype.getIndices = function() {
            var newIndices;
            var indices = this._indices;
            if (indices) {
                var Ctor = indices.constructor;
                var thisCount = this._count;
                if (Ctor === Array) {
                    newIndices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
                } else newIndices = new Ctor(indices.buffer, 0, thisCount);
            } else {
                var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount);
                newIndices = new Ctor(this.count());
                for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
            }
            return newIndices;
        };
        DataStore.prototype.filter = function(dims, cb) {
            if (!this._count) return this;
            var newStore = this.clone();
            var count = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(count);
            var value = [];
            var dimSize = dims.length;
            var offset = 0;
            var dim0 = dims[0];
            var chunks = newStore._chunks;
            for(var i = 0; i < count; i++){
                var keep = void 0;
                var rawIdx = newStore.getRawIndex(i);
                if (dimSize === 0) keep = cb(i);
                else if (dimSize === 1) {
                    var val = chunks[dim0][rawIdx];
                    keep = cb(val, i);
                } else {
                    var k = 0;
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    value[k] = i;
                    keep = cb.apply(null, value);
                }
                if (keep) newIndices[offset++] = rawIdx;
            }
            if (offset < count) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.selectRange = function(range) {
            var newStore = this.clone();
            var len = newStore._count;
            if (!len) return this;
            var dims = (0, (0, parcelRequire("bahqM")).keys)(range);
            var dimSize = dims.length;
            if (!dimSize) return this;
            var originalCount = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(originalCount);
            var offset = 0;
            var dim0 = dims[0];
            var min = range[dim0][0];
            var max = range[dim0][1];
            var storeArr = newStore._chunks;
            var quickFinished = false;
            if (!newStore._indices) {
                var idx = 0;
                if (dimSize === 1) {
                    var dimStorage = storeArr[dims[0]];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                } else if (dimSize === 2) {
                    var dimStorage = storeArr[dims[0]];
                    var dimStorage2 = storeArr[dims[1]];
                    var min2 = range[dims[1]][0];
                    var max2 = range[dims[1]][1];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        var val2 = dimStorage2[i];
                        if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                }
            }
            if (!quickFinished) {
                if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                    var rawIndex = newStore.getRawIndex(i);
                    var val = storeArr[dims[0]][rawIndex];
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
                }
                else for(var i = 0; i < originalCount; i++){
                    var keep = true;
                    var rawIndex = newStore.getRawIndex(i);
                    for(var k = 0; k < dimSize; k++){
                        var dimk = dims[k];
                        var val = storeArr[dimk][rawIndex];
                        if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                    }
                    if (keep) newIndices[offset++] = newStore.getRawIndex(i);
                }
            }
            if (offset < originalCount) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.map = function(dims, cb) {
            var target = this.clone(dims);
            this._updateDims(target, dims, cb);
            return target;
        };
        DataStore.prototype.modify = function(dims, cb) {
            this._updateDims(this, dims, cb);
        };
        DataStore.prototype._updateDims = function(target, dims, cb) {
            var targetChunks = target._chunks;
            var tmpRetValue = [];
            var dimSize = dims.length;
            var dataCount = target.count();
            var values = [];
            var rawExtent = target._rawExtent;
            for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
                var rawIndex = target.getRawIndex(dataIndex);
                for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
                values[dimSize] = dataIndex;
                var retValue = cb && cb.apply(null, values);
                if (retValue != null) {
                    if (typeof retValue !== 'object') {
                        tmpRetValue[0] = retValue;
                        retValue = tmpRetValue;
                    }
                    for(var i = 0; i < retValue.length; i++){
                        var dim = dims[i];
                        var val = retValue[i];
                        var rawExtentOnDim = rawExtent[dim];
                        var dimStore = targetChunks[dim];
                        if (dimStore) dimStore[rawIndex] = val;
                        if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                        if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                    }
                }
            }
        };
        DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
            var target = this.clone([
                valueDimension
            ], true);
            var targetStorage = target._chunks;
            var dimStore = targetStorage[valueDimension];
            var len = this.count();
            var sampledIndex = 0;
            var frameSize = Math.floor(1 / rate);
            var currentRawIndex = this.getRawIndex(0);
            var maxArea;
            var area;
            var nextRawIndex;
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2);
            newIndices[sampledIndex++] = currentRawIndex;
            for(var i = 1; i < len - 1; i += frameSize){
                var nextFrameStart = Math.min(i + frameSize, len - 1);
                var nextFrameEnd = Math.min(i + frameSize * 2, len);
                var avgX = (nextFrameEnd + nextFrameStart) / 2;
                var avgY = 0;
                for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    avgY += y;
                }
                avgY /= nextFrameEnd - nextFrameStart;
                var frameStart = i;
                var frameEnd = Math.min(i + frameSize, len);
                var pointAX = i - 1;
                var pointAY = dimStore[currentRawIndex];
                maxArea = -1;
                nextRawIndex = frameStart;
                for(var idx = frameStart; idx < frameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                    if (area > maxArea) {
                        maxArea = area;
                        nextRawIndex = rawIndex;
                    }
                }
                newIndices[sampledIndex++] = nextRawIndex;
                currentRawIndex = nextRawIndex;
            }
            newIndices[sampledIndex++] = this.getRawIndex(len - 1);
            target._count = sampledIndex;
            target._indices = newIndices;
            target.getRawIndex = this._getRawIdx;
            return target;
        };
        DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var target = this.clone([
                dimension
            ], true);
            var targetStorage = target._chunks;
            var frameValues = [];
            var frameSize = Math.floor(1 / rate);
            var dimStore = targetStorage[dimension];
            var len = this.count();
            var rawExtentOnDim = target._rawExtent[dimension] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
            var offset = 0;
            for(var i = 0; i < len; i += frameSize){
                if (frameSize > len - i) {
                    frameSize = len - i;
                    frameValues.length = frameSize;
                }
                for(var k = 0; k < frameSize; k++){
                    var dataIdx = this.getRawIndex(i + k);
                    frameValues[k] = dimStore[dataIdx];
                }
                var value = sampleValue(frameValues);
                var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
                dimStore[sampleFrameIdx] = value;
                if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
                if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
                newIndices[offset++] = sampleFrameIdx;
            }
            target._count = offset;
            target._indices = newIndices;
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype.each = function(dims, cb) {
            if (!this._count) return;
            var dimSize = dims.length;
            var chunks = this._chunks;
            for(var i = 0, len = this.count(); i < len; i++){
                var rawIdx = this.getRawIndex(i);
                switch(dimSize){
                    case 0:
                        cb(i);
                        break;
                    case 1:
                        cb(chunks[dims[0]][rawIdx], i);
                        break;
                    case 2:
                        cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                        break;
                    default:
                        var k = 0;
                        var value = [];
                        for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                        value[k] = i;
                        cb.apply(null, value);
                }
            }
        };
        DataStore.prototype.getDataExtent = function(dim) {
            var dimData = this._chunks[dim];
            var initialExtent = $5f71fa7e68f8e2cf$var$getInitialExtent();
            if (!dimData) return initialExtent;
            var currEnd = this.count();
            var useRaw = !this._indices;
            var dimExtent;
            if (useRaw) return this._rawExtent[dim].slice();
            dimExtent = this._extent[dim];
            if (dimExtent) return dimExtent.slice();
            dimExtent = initialExtent;
            var min = dimExtent[0];
            var max = dimExtent[1];
            for(var i = 0; i < currEnd; i++){
                var rawIdx = this.getRawIndex(i);
                var value = dimData[rawIdx];
                value < min && (min = value);
                value > max && (max = value);
            }
            dimExtent = [
                min,
                max
            ];
            this._extent[dim] = dimExtent;
            return dimExtent;
        };
        DataStore.prototype.getRawDataItem = function(idx) {
            var rawIdx = this.getRawIndex(idx);
            if (!this._provider.persistent) {
                var val = [];
                var chunks = this._chunks;
                for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
                return val;
            } else return this._provider.getItem(rawIdx);
        };
        DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
            var target = new DataStore();
            var chunks = this._chunks;
            var clonedDimsMap = clonedDims && (0, (0, parcelRequire("bahqM")).reduce)(clonedDims, function(obj, dimIdx) {
                obj[dimIdx] = true;
                return obj;
            }, {});
            if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $5f71fa7e68f8e2cf$var$cloneChunk(chunks[i]);
            else target._chunks = chunks;
            this._copyCommonProps(target);
            if (!ignoreIndices) target._indices = this._cloneIndices();
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype._copyCommonProps = function(target) {
            target._count = this._count;
            target._rawCount = this._rawCount;
            target._provider = this._provider;
            target._dimensions = this._dimensions;
            target._extent = (0, (0, parcelRequire("bahqM")).clone)(this._extent);
            target._rawExtent = (0, (0, parcelRequire("bahqM")).clone)(this._rawExtent);
        };
        DataStore.prototype._cloneIndices = function() {
            if (this._indices) {
                var Ctor = this._indices.constructor;
                var indices = void 0;
                if (Ctor === Array) {
                    var thisCount = this._indices.length;
                    indices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
                } else indices = new Ctor(this._indices);
                return indices;
            }
            return null;
        };
        DataStore.prototype._getRawIdxIdentity = function(idx) {
            return idx;
        };
        DataStore.prototype._getRawIdx = function(idx) {
            if (idx < this._count && idx >= 0) return this._indices[idx];
            return -1;
        };
        DataStore.prototype._updateGetRawIdx = function() {
            this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
        };
        DataStore.internalField = function() {
            function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
                return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
            }
            $5f71fa7e68f8e2cf$var$defaultDimValueGetters = {
                arrayRows: getDimValueSimply,
                objectRows: function(dataItem, property, dataIndex, dimIndex) {
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
                },
                keyedColumns: getDimValueSimply,
                original: function(dataItem, property, dataIndex, dimIndex) {
                    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
                },
                typedArray: function(dataItem, property, dataIndex, dimIndex) {
                    return dataItem[dimIndex];
                }
            };
        }();
        return DataStore;
    }();
    var $5f71fa7e68f8e2cf$export$2e2bcd8739ae039 = $5f71fa7e68f8e2cf$var$DataStore;
});
parcelRegister("2G90t", function(module, exports) {
    $parcel$export(module.exports, "parseDataValue", ()=>$1f367d921e7af2c3$export$cc7175145baad076);
    $parcel$export(module.exports, "getRawValueParser", ()=>$1f367d921e7af2c3$export$c88237b7c265b36b);
    $parcel$export(module.exports, "SortOrderComparator", ()=>$1f367d921e7af2c3$export$ed75a5d7b0144167);
    $parcel$export(module.exports, "createFilterComparator", ()=>$1f367d921e7af2c3$export$f2644c3485f94c4e);
    var $jmSNG;
    var $bahqM;
    var $2cFRc;
    function $1f367d921e7af2c3$export$cc7175145baad076(value, opt) {
        var dimType = opt && opt.type;
        if (dimType === 'ordinal') return value;
        if (dimType === 'time' && typeof value !== 'number' && value != null && value !== '-') value = +(0, (0, parcelRequire("jmSNG")).parseDate)(value);
        return value == null || value === '' ? NaN : +value;
    }
    var $1f367d921e7af2c3$var$valueParserMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
        'number': function(val) {
            return parseFloat(val);
        },
        'time': function(val) {
            return +(0, (0, parcelRequire("jmSNG")).parseDate)(val);
        },
        'trim': function(val) {
            return typeof val === 'string' ? (0, (0, parcelRequire("bahqM")).trim)(val) : val;
        }
    });
    function $1f367d921e7af2c3$export$c88237b7c265b36b(type) {
        return $1f367d921e7af2c3$var$valueParserMap.get(type);
    }
    var $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP = {
        lt: function(lval, rval) {
            return lval < rval;
        },
        lte: function(lval, rval) {
            return lval <= rval;
        },
        gt: function(lval, rval) {
            return lval > rval;
        },
        gte: function(lval, rval) {
            return lval >= rval;
        }
    };
    var $1f367d921e7af2c3$var$FilterOrderComparator = function() {
        function FilterOrderComparator(op, rval) {
            if (typeof rval !== 'number') {
                var errMsg = '';
                (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            }
            this._opFn = $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP[op];
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterOrderComparator.prototype.evaluate = function(lval) {
            return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, (0, parcelRequire("jmSNG")).numericToNumber)(lval), this._rvalFloat);
        };
        return FilterOrderComparator;
    }();
    var $1f367d921e7af2c3$export$ed75a5d7b0144167 = function() {
        function SortOrderComparator(order, incomparable) {
            var isDesc = order === 'desc';
            this._resultLT = isDesc ? 1 : -1;
            if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
            this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
        }
        SortOrderComparator.prototype.evaluate = function(lval, rval) {
            var lvalTypeof = typeof lval;
            var rvalTypeof = typeof rval;
            var lvalFloat = lvalTypeof === 'number' ? lval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval);
            var rvalFloat = rvalTypeof === 'number' ? rval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
            var lvalNotNumeric = isNaN(lvalFloat);
            var rvalNotNumeric = isNaN(rvalFloat);
            if (lvalNotNumeric) lvalFloat = this._incomparable;
            if (rvalNotNumeric) rvalFloat = this._incomparable;
            if (lvalNotNumeric && rvalNotNumeric) {
                var lvalIsStr = lvalTypeof === 'string';
                var rvalIsStr = rvalTypeof === 'string';
                if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
                if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
            }
            return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
        };
        return SortOrderComparator;
    }();
    var $1f367d921e7af2c3$var$FilterEqualityComparator = function() {
        function FilterEqualityComparator(isEq, rval) {
            this._rval = rval;
            this._isEQ = isEq;
            this._rvalTypeof = typeof rval;
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterEqualityComparator.prototype.evaluate = function(lval) {
            var eqResult = lval === this._rval;
            if (!eqResult) {
                var lvalTypeof = typeof lval;
                if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval) === this._rvalFloat;
            }
            return this._isEQ ? eqResult : !eqResult;
        };
        return FilterEqualityComparator;
    }();
    function $1f367d921e7af2c3$export$f2644c3485f94c4e(op, rval) {
        return op === 'eq' || op === 'ne' ? new $1f367d921e7af2c3$var$FilterEqualityComparator(op === 'eq', rval) : (0, (0, parcelRequire("bahqM")).hasOwn)($1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP, op) ? new $1f367d921e7af2c3$var$FilterOrderComparator(op, rval) : null;
    }
});
parcelRegister("2cFRc", function(module, exports) {
    $parcel$export(module.exports, "warn", ()=>$19ad2baf23da1928$export$c106dd0671a0fc2d);
    $parcel$export(module.exports, "error", ()=>$19ad2baf23da1928$export$a3bc9b8ed74fc);
    $parcel$export(module.exports, "deprecateLog", ()=>$19ad2baf23da1928$export$4a9c0b74eb885aa1);
    $parcel$export(module.exports, "throwError", ()=>$19ad2baf23da1928$export$8bf7aba4a9e09055);
    var $19ad2baf23da1928$var$ECHARTS_PREFIX = '[ECharts] ';
    var $19ad2baf23da1928$var$storedLogs = {};
    var $19ad2baf23da1928$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
    function $19ad2baf23da1928$export$bef1f36f5486a6a3(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.log($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$c106dd0671a0fc2d(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.warn($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$a3bc9b8ed74fc(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.error($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$4a9c0b74eb885aa1(str) {}
    function $19ad2baf23da1928$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
    function $19ad2baf23da1928$export$c3747c611a35af25() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    }
    function $19ad2baf23da1928$export$a68bb8b222a6bd43() {
        var hintInfo = [];
        for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
        var msg = '';
        var makePrintableStringIfPossible_1;
        return msg;
    }
    function $19ad2baf23da1928$export$8bf7aba4a9e09055(msg) {
        throw new Error(msg);
    }
});
parcelRegister("2Om11", function(module, exports) {
    $parcel$export(module.exports, "SeriesDataSchema", ()=>$20c1541ff90227ce$export$a1ef064685775f3e);
    $parcel$export(module.exports, "ensureSourceDimNameMap", ()=>$20c1541ff90227ce$export$be39ae17310c33f7);
    $parcel$export(module.exports, "shouldOmitUnusedDimensions", ()=>$20c1541ff90227ce$export$238b87930d825d87);
    $parcel$export(module.exports, "isSeriesDataSchema", ()=>$20c1541ff90227ce$export$fafbc856132a3a0e);
    $parcel$export(module.exports, "createDimNameMap", ()=>$20c1541ff90227ce$export$a477f5bebfd07944);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $20c1541ff90227ce$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $20c1541ff90227ce$var$dimTypeShort = {
        float: 'f',
        int: 'i',
        ordinal: 'o',
        number: 'n',
        time: 't'
    };
    var $20c1541ff90227ce$export$a1ef064685775f3e = function() {
        function SeriesDataSchema(opt) {
            this.dimensions = opt.dimensions;
            this._dimOmitted = opt.dimensionOmitted;
            this.source = opt.source;
            this._fullDimCount = opt.fullDimensionCount;
            this._updateDimOmitted(opt.dimensionOmitted);
        }
        SeriesDataSchema.prototype.isDimensionOmitted = function() {
            return this._dimOmitted;
        };
        SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
            this._dimOmitted = dimensionOmitted;
            if (!dimensionOmitted) return;
            if (!this._dimNameMap) this._dimNameMap = $20c1541ff90227ce$export$be39ae17310c33f7(this.source);
        };
        SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
            return (0, (0, parcelRequire("bahqM")).retrieve2)(this._dimNameMap.get(dimName), -1);
        };
        SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
            var dimensionsDefine = this.source.dimensionsDefine;
            if (dimensionsDefine) return dimensionsDefine[dimIndex];
        };
        SeriesDataSchema.prototype.makeStoreSchema = function() {
            var dimCount = this._fullDimCount;
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(this.source);
            var makeHashStrict = !$20c1541ff90227ce$export$238b87930d825d87(dimCount);
            var dimHash = '';
            var dims = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
                var property = void 0;
                var type = void 0;
                var ordinalMeta = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    property = willRetrieveDataByName ? seriesDimDef.name : null;
                    type = seriesDimDef.type;
                    ordinalMeta = seriesDimDef.ordinalMeta;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) {
                        property = willRetrieveDataByName ? sourceDimDef.name : null;
                        type = sourceDimDef.type;
                    }
                }
                dims.push({
                    property: property,
                    type: type,
                    ordinalMeta: ordinalMeta
                });
                if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
                dimHash += '$';
                dimHash += $20c1541ff90227ce$var$dimTypeShort[type] || 'f';
                if (ordinalMeta) dimHash += ordinalMeta.uid;
                dimHash += '$';
            }
            var source = this.source;
            var hash = [
                source.seriesLayoutBy,
                source.startIndex,
                dimHash
            ].join('$$');
            return {
                dimensions: dims,
                hash: hash
            };
        };
        SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
            var result = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
                var name_1 = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) name_1 = sourceDimDef.name;
                }
                result.push(name_1);
            }
            return result;
        };
        SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
            this.dimensions.push(dimDef);
            dimDef.isCalculationCoord = true;
            this._fullDimCount++;
            this._updateDimOmitted(true);
        };
        return SeriesDataSchema;
    }();
    function $20c1541ff90227ce$export$fafbc856132a3a0e(schema) {
        return schema instanceof $20c1541ff90227ce$export$a1ef064685775f3e;
    }
    function $20c1541ff90227ce$export$a477f5bebfd07944(dimsDef) {
        var dataDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < (dimsDef || []).length; i++){
            var dimDefItemRaw = dimsDef[i];
            var userDimName = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
            if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
        }
        return dataDimNameMap;
    }
    function $20c1541ff90227ce$export$be39ae17310c33f7(source) {
        var innerSource = $20c1541ff90227ce$var$inner(source);
        return innerSource.dimNameMap || (innerSource.dimNameMap = $20c1541ff90227ce$export$a477f5bebfd07944(source.dimensionsDefine));
    }
    function $20c1541ff90227ce$export$238b87930d825d87(dimCount) {
        return dimCount > 30;
    }
});
parcelRegister("h9jiS", function(module, exports) {
    $parcel$export(module.exports, "createDimensions", ()=>$c7c240344387234c$export$8066c1b52b2e9504);
    $parcel$export(module.exports, "default", ()=>$c7c240344387234c$export$2e2bcd8739ae039);
    var $2Rbm1;
    var $dhxbO;
    var $bahqM;
    var $20liu;
    var $8c3gC;
    var $eaKsF;
    var $cNGs8;
    var $2Om11;
    function $c7c240344387234c$export$8066c1b52b2e9504(source, opt) {
        return $c7c240344387234c$export$2e2bcd8739ae039(source, opt).dimensions;
    }
    function $c7c240344387234c$export$2e2bcd8739ae039(source, opt) {
        if (!(0, (0, parcelRequire("20liu")).isSourceInstance)(source)) source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(source);
        opt = opt || {};
        var sysDims = opt.coordDimensions || [];
        var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
        var coordDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var resultList = [];
        var dimCount = $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
        var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, (0, parcelRequire("2Om11")).shouldOmitUnusedDimensions)(dimCount);
        var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
        var dataDimNameMap = isUsingSourceDimensionsDef ? (0, (0, parcelRequire("2Om11")).ensureSourceDimNameMap)(source) : (0, (0, parcelRequire("2Om11")).createDimNameMap)(dimsDef);
        var encodeDef = opt.encodeDefine;
        if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
        var encodeDefMap = (0, (0, parcelRequire("bahqM")).createHashMap)(encodeDef);
        var indicesMap = new (0, (0, parcelRequire("8c3gC")).CtorInt32Array)(dimCount);
        for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
        function getResultItem(dimIdx) {
            var idx = indicesMap[dimIdx];
            if (idx < 0) {
                var dimDefItemRaw = dimsDef[dimIdx];
                var dimDefItem = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                    name: dimDefItemRaw
                };
                var resultItem = new (0, (0, parcelRequire("dhxbO")).default)();
                var userDimName = dimDefItem.name;
                if (userDimName != null && dataDimNameMap.get(userDimName) != null) resultItem.name = resultItem.displayName = userDimName;
                dimDefItem.type != null && (resultItem.type = dimDefItem.type);
                dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
                var newIdx = resultList.length;
                indicesMap[dimIdx] = newIdx;
                resultItem.storeDimIndex = dimIdx;
                resultList.push(resultItem);
                return resultItem;
            }
            return resultList[idx];
        }
        if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
        encodeDefMap.each(function(dataDimsRaw, coordDim) {
            var dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDimsRaw).slice();
            if (dataDims.length === 1 && !(0, (0, parcelRequire("bahqM")).isString)(dataDims[0]) && dataDims[0] < 0) {
                encodeDefMap.set(coordDim, false);
                return;
            }
            var validDataDims = encodeDefMap.set(coordDim, []);
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdxOrName, idx) {
                var resultDimIdx = (0, (0, parcelRequire("bahqM")).isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
                if (resultDimIdx != null && resultDimIdx < dimCount) {
                    validDataDims[idx] = resultDimIdx;
                    applyDim(getResultItem(resultDimIdx), coordDim, idx);
                }
            });
        });
        var availDimIdx = 0;
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItemRaw) {
            var coordDim;
            var sysDimItemDimsDef;
            var sysDimItemOtherDims;
            var sysDimItem;
            if ((0, (0, parcelRequire("bahqM")).isString)(sysDimItemRaw)) {
                coordDim = sysDimItemRaw;
                sysDimItem = {};
            } else {
                sysDimItem = sysDimItemRaw;
                coordDim = sysDimItem.name;
                var ordinalMeta = sysDimItem.ordinalMeta;
                sysDimItem.ordinalMeta = null;
                sysDimItem = (0, (0, parcelRequire("bahqM")).extend)({}, sysDimItem);
                sysDimItem.ordinalMeta = ordinalMeta;
                sysDimItemDimsDef = sysDimItem.dimsDef;
                sysDimItemOtherDims = sysDimItem.otherDims;
                sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
            }
            var dataDims = encodeDefMap.get(coordDim);
            if (dataDims === false) return;
            dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDims);
            if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
                while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
                availDimIdx < dimCount && dataDims.push(availDimIdx++);
            }
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdx, coordDimIndex) {
                var resultItem = getResultItem(resultDimIdx);
                if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
                applyDim((0, (0, parcelRequire("bahqM")).defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
                if (resultItem.name == null && sysDimItemDimsDef) {
                    var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                    !(0, (0, parcelRequire("bahqM")).isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                        name: sysDimItemDimsDefItem
                    });
                    resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                    resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
                }
                sysDimItemOtherDims && (0, (0, parcelRequire("bahqM")).defaults)(resultItem.otherDims, sysDimItemOtherDims);
            });
        });
        function applyDim(resultItem, coordDim, coordDimIndex) {
            if ((0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
            else {
                resultItem.coordDim = coordDim;
                resultItem.coordDimIndex = coordDimIndex;
                coordDimNameMap.set(coordDim, true);
            }
        }
        var generateCoord = opt.generateCoord;
        var generateCoordCount = opt.generateCoordCount;
        var fromZero = generateCoordCount != null;
        generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
        var extra = generateCoord || 'value';
        function ifNoNameFillWithCoordName(resultItem) {
            if (resultItem.name == null) resultItem.name = resultItem.coordDim;
        }
        if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
            var resultItem = getResultItem(resultDimIdx);
            var coordDim = resultItem.coordDim;
            if (coordDim == null) {
                resultItem.coordDim = $c7c240344387234c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
                resultItem.coordDimIndex = 0;
                if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
                generateCoordCount--;
            }
            ifNoNameFillWithCoordName(resultItem);
            if (resultItem.type == null && ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(source, resultDimIdx) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
        }
        else {
            (0, (0, parcelRequire("bahqM")).each)(resultList, function(resultItem) {
                ifNoNameFillWithCoordName(resultItem);
            });
            resultList.sort(function(item0, item1) {
                return item0.storeDimIndex - item1.storeDimIndex;
            });
        }
        $c7c240344387234c$var$removeDuplication(resultList);
        return new (0, (0, parcelRequire("2Om11")).SeriesDataSchema)({
            source: source,
            dimensions: resultList,
            fullDimensionCount: dimCount,
            dimensionOmitted: omitUnusedDimensions
        });
    }
    function $c7c240344387234c$var$removeDuplication(result) {
        var duplicationMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < result.length; i++){
            var dim = result[i];
            var dimOriginalName = dim.name;
            var count = duplicationMap.get(dimOriginalName) || 0;
            if (count > 0) dim.name = dimOriginalName + (count - 1);
            count++;
            duplicationMap.set(dimOriginalName, count);
        }
    }
    function $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
        var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItem) {
            var sysDimItemDimsDef;
            if ((0, (0, parcelRequire("bahqM")).isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
        });
        return dimCount;
    }
    function $c7c240344387234c$var$genCoordDimName(name, map, fromZero) {
        var mapData = map.data;
        if (fromZero || mapData.hasOwnProperty(name)) {
            var i = 0;
            while(mapData.hasOwnProperty(name + i))i++;
            name += i;
        }
        map.set(name, true);
        return name;
    }
});
parcelRegister("gyhNQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0cda1a15c9ef40a$export$2e2bcd8739ae039);
    var $bahqM;
    var $c0cda1a15c9ef40a$var$coordinateSystemCreators = {};
    var $c0cda1a15c9ef40a$var$CoordinateSystemManager = function() {
        function CoordinateSystemManager() {
            this._coordinateSystems = [];
        }
        CoordinateSystemManager.prototype.create = function(ecModel, api) {
            var coordinateSystems = [];
            (0, parcelRequire("bahqM")).each($c0cda1a15c9ef40a$var$coordinateSystemCreators, function(creater, type) {
                var list = creater.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            this._coordinateSystems = coordinateSystems;
        };
        CoordinateSystemManager.prototype.update = function(ecModel, api) {
            (0, parcelRequire("bahqM")).each(this._coordinateSystems, function(coordSys) {
                coordSys.update && coordSys.update(ecModel, api);
            });
        };
        CoordinateSystemManager.prototype.getCoordinateSystems = function() {
            return this._coordinateSystems.slice();
        };
        CoordinateSystemManager.register = function(type, creator) {
            $c0cda1a15c9ef40a$var$coordinateSystemCreators[type] = creator;
        };
        CoordinateSystemManager.get = function(type) {
            return $c0cda1a15c9ef40a$var$coordinateSystemCreators[type];
        };
        return CoordinateSystemManager;
    }();
    var $c0cda1a15c9ef40a$export$2e2bcd8739ae039 = $c0cda1a15c9ef40a$var$CoordinateSystemManager;
});
parcelRegister("lhMGv", function(module, exports) {
    $parcel$export(module.exports, "getCoordSysInfoBySeries", ()=>$f7f0f3461c4b4907$export$f2befeb2f4933656);
    var $bahqM;
    var $eaKsF;
    var $f7f0f3461c4b4907$var$CoordSysInfo = function() {
        function CoordSysInfo(coordSysName) {
            this.coordSysDims = [];
            this.axisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.categoryAxisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.coordSysName = coordSysName;
        }
        return CoordSysInfo;
    }();
    function $f7f0f3461c4b4907$export$f2befeb2f4933656(seriesModel) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var result = new $f7f0f3461c4b4907$var$CoordSysInfo(coordSysName);
        var fetch = $f7f0f3461c4b4907$var$fetchers[coordSysName];
        if (fetch) {
            fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
            return result;
        }
    }
    var $f7f0f3461c4b4907$var$fetchers = {
        cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
            var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'x',
                'y'
            ];
            axisMap.set('x', xAxisModel);
            axisMap.set('y', yAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(xAxisModel)) {
                categoryAxisMap.set('x', xAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(yAxisModel)) {
                categoryAxisMap.set('y', yAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'single'
            ];
            axisMap.set('single', singleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(singleAxisModel)) {
                categoryAxisMap.set('single', singleAxisModel);
                result.firstCategoryDimIndex = 0;
            }
        },
        polar: function(seriesModel, result, axisMap, categoryAxisMap) {
            var polarModel = seriesModel.getReferringComponents('polar', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            result.coordSysDims = [
                'radius',
                'angle'
            ];
            axisMap.set('radius', radiusAxisModel);
            axisMap.set('angle', angleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(radiusAxisModel)) {
                categoryAxisMap.set('radius', radiusAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(angleAxisModel)) {
                categoryAxisMap.set('angle', angleAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        geo: function(seriesModel, result, axisMap, categoryAxisMap) {
            result.coordSysDims = [
                'lng',
                'lat'
            ];
        },
        parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
            var ecModel = seriesModel.ecModel;
            var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
            var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
            (0, (0, parcelRequire("bahqM")).each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
                var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
                var axisDim = coordSysDims[index];
                axisMap.set(axisDim, axisModel);
                if ($f7f0f3461c4b4907$var$isCategory(axisModel)) {
                    categoryAxisMap.set(axisDim, axisModel);
                    if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
                }
            });
        }
    };
    function $f7f0f3461c4b4907$var$isCategory(axisModel) {
        return axisModel.get('type') === 'category';
    }
});
parcelRegister("5R8Hi", function(module, exports) {
    $parcel$export(module.exports, "enableDataStack", ()=>$4438a61210f14409$export$f2165f9e8499b278);
    $parcel$export(module.exports, "isDimensionStacked", ()=>$4438a61210f14409$export$1dedc39359ae35c);
    $parcel$export(module.exports, "getStackedDimension", ()=>$4438a61210f14409$export$909db2be4938fbdf);
    var $bahqM;
    var $2Om11;
    function $4438a61210f14409$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
        opt = opt || {};
        var byIndex = opt.byIndex;
        var stackedCoordDimension = opt.stackedCoordDimension;
        var dimensionDefineList;
        var schema;
        var store;
        if ($4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
        else {
            schema = dimensionsInput.schema;
            dimensionDefineList = schema.dimensions;
            store = dimensionsInput.store;
        }
        var mayStack = !!(seriesModel && seriesModel.get('stack'));
        var stackedByDimInfo;
        var stackedDimInfo;
        var stackResultDimension;
        var stackedOverDimension;
        (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo, index) {
            if ((0, (0, parcelRequire("bahqM")).isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
                name: dimensionInfo
            };
            if (mayStack && !dimensionInfo.isExtraCoord) {
                if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
                if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
            }
        });
        if (stackedDimInfo && !byIndex && !stackedByDimInfo) byIndex = true;
        if (stackedDimInfo) {
            stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
            stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
            if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
            var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
            var stackedDimType = stackedDimInfo.type;
            var stackedDimCoordIndex_1 = 0;
            (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo) {
                if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
            });
            var stackedOverDimensionDefine = {
                name: stackResultDimension,
                coordDim: stackedDimCoordDim_1,
                coordDimIndex: stackedDimCoordIndex_1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length
            };
            var stackResultDimensionDefine = {
                name: stackedOverDimension,
                coordDim: stackedOverDimension,
                coordDimIndex: stackedDimCoordIndex_1 + 1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length + 1
            };
            if (schema) {
                if (store) {
                    stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                    stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
                }
                schema.appendCalculationDimension(stackedOverDimensionDefine);
                schema.appendCalculationDimension(stackResultDimensionDefine);
            } else {
                dimensionDefineList.push(stackedOverDimensionDefine);
                dimensionDefineList.push(stackResultDimensionDefine);
            }
        }
        return {
            stackedDimension: stackedDimInfo && stackedDimInfo.name,
            stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
            isStackedByIndex: byIndex,
            stackedOverDimension: stackedOverDimension,
            stackResultDimension: stackResultDimension
        };
    }
    function $4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput) {
        return !(0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput.schema);
    }
    function $4438a61210f14409$export$1dedc39359ae35c(data, stackedDim) {
        return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
    }
    function $4438a61210f14409$export$909db2be4938fbdf(data, targetDim) {
        return $4438a61210f14409$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
    }
});
parcelRegister("1O7Ua", function(module, exports) {
    $parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", ()=>$151097b3612ce5ca$export$e960441116ae2799);
    $parcel$export(module.exports, "default", ()=>$151097b3612ce5ca$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $h4UlH;
    var $aCu4v;
    var $guzSc;
    var $65MS1;
    var $92IK1;
    var $aLwh0;
    var $jTNWo;
    var $d88IV;
    var $151097b3612ce5ca$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    function $151097b3612ce5ca$var$getSelectionKey(data, dataIndex) {
        return data.getName(dataIndex) || data.getId(dataIndex);
    }
    var $151097b3612ce5ca$export$e960441116ae2799 = '__universalTransitionEnabled';
    var $151097b3612ce5ca$var$SeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SeriesModel, _super);
        function SeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._selectedDataIndicesMap = {};
            return _this;
        }
        SeriesModel.prototype.init = function(option, parentModel, ecModel) {
            this.seriesIndex = this.componentIndex;
            this.dataTask = (0, (0, parcelRequire("92IK1")).createTask)({
                count: $151097b3612ce5ca$var$dataTaskCount,
                reset: $151097b3612ce5ca$var$dataTaskReset
            });
            this.dataTask.context = {
                model: this
            };
            this.mergeDefaultAndTheme(option, ecModel);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager = new (0, (0, parcelRequire("jTNWo")).SourceManager)(this);
            sourceManager.prepareSource();
            var data = this.getInitialData(option, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
            var themeSubType = this.subType;
            if ((0, (0, parcelRequire("h4UlH")).default).hasClass(themeSubType)) themeSubType += 'Series';
            (0, parcelRequire("bahqM")).merge(option, ecModel.getTheme().get(this.subType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            (0, parcelRequire("eaKsF")).defaultEmphasis(option, 'label', [
                'show'
            ]);
            this.fillDataTextStyle(option.data);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
        };
        SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
            newSeriesOption = (0, parcelRequire("bahqM")).merge(this.option, newSeriesOption, true);
            this.fillDataTextStyle(newSeriesOption.data);
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager;
            sourceManager.dirty();
            sourceManager.prepareSource();
            var data = this.getInitialData(newSeriesOption, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.dirty();
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.fillDataTextStyle = function(data) {
            if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) {
                var props = [
                    'show'
                ];
                for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) (0, parcelRequire("eaKsF")).defaultEmphasis(data[i], 'label', props);
            }
        };
        SeriesModel.prototype.getInitialData = function(option, ecModel) {
            return;
        };
        SeriesModel.prototype.appendData = function(params) {
            var data = this.getRawData();
            data.appendData(params.data);
        };
        SeriesModel.prototype.getData = function(dataType) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var data = task.context.data;
                return dataType == null ? data : data.getLinkedData(dataType);
            } else return $151097b3612ce5ca$var$inner(this).data;
        };
        SeriesModel.prototype.getAllData = function() {
            var mainData = this.getData();
            return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
                {
                    data: mainData
                }
            ];
        };
        SeriesModel.prototype.setData = function(data) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var context = task.context;
                context.outputData = data;
                if (task !== this.dataTask) context.data = data;
            }
            $151097b3612ce5ca$var$inner(this).data = data;
        };
        SeriesModel.prototype.getEncode = function() {
            var encode = this.get('encode', true);
            if (encode) return (0, parcelRequire("bahqM")).createHashMap(encode);
        };
        SeriesModel.prototype.getSourceManager = function() {
            return $151097b3612ce5ca$var$inner(this).sourceManager;
        };
        SeriesModel.prototype.getSource = function() {
            return this.getSourceManager().getSource();
        };
        SeriesModel.prototype.getRawData = function() {
            return $151097b3612ce5ca$var$inner(this).dataBeforeProcessed;
        };
        SeriesModel.prototype.getColorBy = function() {
            var colorBy = this.get('colorBy');
            return colorBy || 'series';
        };
        SeriesModel.prototype.isColorBySeries = function() {
            return this.getColorBy() === 'series';
        };
        SeriesModel.prototype.getBaseAxis = function() {
            var coordSys = this.coordinateSystem;
            return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
        };
        SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return (0, (0, parcelRequire("d88IV")).defaultSeriesFormatTooltip)({
                series: this,
                dataIndex: dataIndex,
                multipleSeries: multipleSeries
            });
        };
        SeriesModel.prototype.isAnimationEnabled = function() {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return false;
            var animationEnabled = this.getShallow('animation');
            if (animationEnabled) {
                if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
            }
            return !!animationEnabled;
        };
        SeriesModel.prototype.restoreData = function() {
            this.dataTask.dirty();
        };
        SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
            var ecModel = this.ecModel;
            var color = (0, (0, parcelRequire("aCu4v")).PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
            if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
            return color;
        };
        SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
            return this.getRawData().mapDimensionsAll(coordDim);
        };
        SeriesModel.prototype.getProgressive = function() {
            return this.get('progressive');
        };
        SeriesModel.prototype.getProgressiveThreshold = function() {
            return this.get('progressiveThreshold');
        };
        SeriesModel.prototype.select = function(innerDataIndices, dataType) {
            this._innerSelect(this.getData(dataType), innerDataIndices);
        };
        SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return;
            var data = this.getData(dataType);
            for(var i = 0; i < innerDataIndices.length; i++){
                var dataIndex = innerDataIndices[i];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = false;
                this._selectedDataIndicesMap[nameOrId] = -1;
            }
        };
        SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
            var tmpArr = [];
            for(var i = 0; i < innerDataIndices.length; i++){
                tmpArr[0] = innerDataIndices[i];
                this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
            }
        };
        SeriesModel.prototype.getSelectedDataIndices = function() {
            var selectedDataIndicesMap = this._selectedDataIndicesMap;
            var nameOrIds = (0, parcelRequire("bahqM")).keys(selectedDataIndicesMap);
            var dataIndices = [];
            for(var i = 0; i < nameOrIds.length; i++){
                var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
                if (dataIndex >= 0) dataIndices.push(dataIndex);
            }
            return dataIndices;
        };
        SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return false;
            var data = this.getData(dataType);
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
            return selectedMap[nameOrId] || false;
        };
        SeriesModel.prototype.isUniversalTransitionEnabled = function() {
            if (this[$151097b3612ce5ca$export$e960441116ae2799]) return true;
            var universalTransitionOpt = this.option.universalTransition;
            if (!universalTransitionOpt) return false;
            if (universalTransitionOpt === true) return true;
            return universalTransitionOpt && universalTransitionOpt.enabled;
        };
        SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
            var _a, _b;
            var selectedMode = this.option.selectedMode;
            var len = innerDataIndices.length;
            if (!selectedMode || !len) return;
            if (selectedMode === 'multiple') {
                var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
                for(var i = 0; i < len; i++){
                    var dataIndex = innerDataIndices[i];
                    var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                    selectedMap[nameOrId] = true;
                    this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
                }
            } else if (selectedMode === 'single' || selectedMode === true) {
                var lastDataIndex = innerDataIndices[len - 1];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, lastDataIndex);
                this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
                this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
            }
        };
        SeriesModel.prototype._initSelectedMapFromData = function(data) {
            if (this.option.selectedMap) return;
            var dataIndices = [];
            if (data.hasItemOption) data.each(function(idx) {
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem.selected) dataIndices.push(idx);
            });
            if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
        };
        SeriesModel.registerClass = function(clz) {
            return (0, (0, parcelRequire("h4UlH")).default).registerClass(clz);
        };
        SeriesModel.protoInitialize = function() {
            var proto = SeriesModel.prototype;
            proto.type = 'series.__base__';
            proto.seriesIndex = 0;
            proto.ignoreStyleOnData = false;
            proto.hasSymbolVisual = false;
            proto.defaultSymbol = 'circle';
            proto.visualStyleAccessPath = 'itemStyle';
            proto.visualDrawType = 'fill';
        }();
        return SeriesModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("guzSc")).DataFormatMixin));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("h4UlH")).default));
    function $151097b3612ce5ca$var$autoSeriesName(seriesModel) {
        var name = seriesModel.name;
        if (!(0, parcelRequire("eaKsF")).isNameSpecified(seriesModel)) seriesModel.name = $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) || name;
    }
    function $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) {
        var data = seriesModel.getRawData();
        var dataDims = data.mapDimensionsAll('seriesName');
        var nameArr = [];
        (0, parcelRequire("bahqM")).each(dataDims, function(dataDim) {
            var dimInfo = data.getDimensionInfo(dataDim);
            dimInfo.displayName && nameArr.push(dimInfo.displayName);
        });
        return nameArr.join(' ');
    }
    function $151097b3612ce5ca$var$dataTaskCount(context) {
        return context.model.getRawData().count();
    }
    function $151097b3612ce5ca$var$dataTaskReset(context) {
        var seriesModel = context.model;
        seriesModel.setData(seriesModel.getRawData().cloneShallow());
        return $151097b3612ce5ca$var$dataTaskProgress;
    }
    function $151097b3612ce5ca$var$dataTaskProgress(param, context) {
        if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
    }
    function $151097b3612ce5ca$var$wrapData(data, seriesModel) {
        (0, parcelRequire("bahqM")).each((0, parcelRequire("bahqM")).concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
            data.wrapMethod(methodName, (0, parcelRequire("bahqM")).curry($151097b3612ce5ca$var$onDataChange, seriesModel));
        });
    }
    function $151097b3612ce5ca$var$onDataChange(seriesModel, newList) {
        var task = $151097b3612ce5ca$var$getCurrentTask(seriesModel);
        if (task) task.setOutputEnd((newList || this).count());
        return newList;
    }
    function $151097b3612ce5ca$var$getCurrentTask(seriesModel) {
        var scheduler = (seriesModel.ecModel || {}).scheduler;
        var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
        if (pipeline) {
            var task = pipeline.currentTask;
            if (task) {
                var agentStubMap = task.agentStubMap;
                if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
            }
            return task;
        }
    }
    var $151097b3612ce5ca$export$2e2bcd8739ae039 = $151097b3612ce5ca$var$SeriesModel;
});
parcelRegister("h4UlH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ee8520f4778ed8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $gaMkj;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $65MS1;
    var $c6ee8520f4778ed8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $c6ee8520f4778ed8$var$ComponentModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ComponentModel, _super);
        function ComponentModel(option, parentModel, ecModel) {
            var _this = _super.call(this, option, parentModel, ecModel) || this;
            _this.uid = (0, parcelRequire("jvo6O")).getUID('ec_cpt_model');
            return _this;
        }
        ComponentModel.prototype.init = function(option, parentModel, ecModel) {
            this.mergeDefaultAndTheme(option, ecModel);
        };
        ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            var inputPositionParams = layoutMode ? (0, parcelRequire("65MS1")).getLayoutParams(option) : {};
            var themeModel = ecModel.getTheme();
            (0, parcelRequire("bahqM")).merge(option, themeModel.get(this.mainType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(option, inputPositionParams, layoutMode);
        };
        ComponentModel.prototype.mergeOption = function(option, ecModel) {
            (0, parcelRequire("bahqM")).merge(this.option, option, true);
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(this.option, option, layoutMode);
        };
        ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
        ComponentModel.prototype.getDefaultOption = function() {
            var ctor = this.constructor;
            if (!(0, (0, parcelRequire("aLwh0")).isExtendedClass)(ctor)) return ctor.defaultOption;
            var fields = $c6ee8520f4778ed8$var$inner(this);
            if (!fields.defaultOption) {
                var optList = [];
                var clz = ctor;
                while(clz){
                    var opt = clz.prototype.defaultOption;
                    opt && optList.push(opt);
                    clz = clz.superClass;
                }
                var defaultOption = {};
                for(var i = optList.length - 1; i >= 0; i--)defaultOption = (0, parcelRequire("bahqM")).merge(defaultOption, optList[i], true);
                fields.defaultOption = defaultOption;
            }
            return fields.defaultOption;
        };
        ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
            var indexKey = mainType + 'Index';
            var idKey = mainType + 'Id';
            return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(this.ecModel, mainType, {
                index: this.get(indexKey, true),
                id: this.get(idKey, true)
            }, opt);
        };
        ComponentModel.prototype.getBoxLayoutParams = function() {
            var boxLayoutModel = this;
            return {
                left: boxLayoutModel.get('left'),
                top: boxLayoutModel.get('top'),
                right: boxLayoutModel.get('right'),
                bottom: boxLayoutModel.get('bottom'),
                width: boxLayoutModel.get('width'),
                height: boxLayoutModel.get('height')
            };
        };
        ComponentModel.protoInitialize = function() {
            var proto = ComponentModel.prototype;
            proto.type = 'component';
            proto.id = '';
            proto.name = '';
            proto.mainType = '';
            proto.subType = '';
            proto.componentIndex = 0;
        }();
        return ComponentModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($c6ee8520f4778ed8$var$ComponentModel, (0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).enableClassManagement)($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableSubTypeDefaulter($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableTopologicalTravel($c6ee8520f4778ed8$var$ComponentModel, $c6ee8520f4778ed8$var$getDependencies);
    function $c6ee8520f4778ed8$var$getDependencies(componentType) {
        var deps = [];
        (0, parcelRequire("bahqM")).each($c6ee8520f4778ed8$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
            deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
        });
        deps = (0, parcelRequire("bahqM")).map(deps, function(type) {
            return (0, (0, parcelRequire("aLwh0")).parseClassType)(type).main;
        });
        if (componentType !== 'dataset' && (0, parcelRequire("bahqM")).indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
        return deps;
    }
    var $c6ee8520f4778ed8$export$2e2bcd8739ae039 = $c6ee8520f4778ed8$var$ComponentModel;
});
parcelRegister("jvo6O", function(module, exports) {
    $parcel$export(module.exports, "getUID", ()=>$e3339d183aa6ce79$export$6d2b3473b0986646);
    $parcel$export(module.exports, "enableSubTypeDefaulter", ()=>$e3339d183aa6ce79$export$b9faf30b7d655a6f);
    $parcel$export(module.exports, "enableTopologicalTravel", ()=>$e3339d183aa6ce79$export$ce592d345a3ec040);
    $parcel$export(module.exports, "inheritDefaultOption", ()=>$e3339d183aa6ce79$export$68acc510e46fef2);
    var $bahqM;
    var $aLwh0;
    var $e3339d183aa6ce79$var$base = Math.round(Math.random() * 10);
    function $e3339d183aa6ce79$export$6d2b3473b0986646(type) {
        return [
            type || '',
            $e3339d183aa6ce79$var$base++
        ].join('_');
    }
    function $e3339d183aa6ce79$export$b9faf30b7d655a6f(target) {
        var subTypeDefaulters = {};
        target.registerSubTypeDefaulter = function(componentType, defaulter) {
            var componentTypeInfo = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType);
            subTypeDefaulters[componentTypeInfo.main] = defaulter;
        };
        target.determineSubType = function(componentType, option) {
            var type = option.type;
            if (!type) {
                var componentTypeMain = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType).main;
                if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
            }
            return type;
        };
    }
    function $e3339d183aa6ce79$export$ce592d345a3ec040(entity, dependencyGetter) {
        entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
            if (!targetNameList.length) return;
            var result = makeDepndencyGraph(fullNameList);
            var graph = result.graph;
            var noEntryList = result.noEntryList;
            var targetNameSet = {};
            (0, parcelRequire("bahqM")).each(targetNameList, function(name) {
                targetNameSet[name] = true;
            });
            while(noEntryList.length){
                var currComponentType = noEntryList.pop();
                var currVertex = graph[currComponentType];
                var isInTargetNameSet = !!targetNameSet[currComponentType];
                if (isInTargetNameSet) {
                    callback.call(context, currComponentType, currVertex.originalDeps.slice());
                    delete targetNameSet[currComponentType];
                }
                (0, parcelRequire("bahqM")).each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
            }
            (0, parcelRequire("bahqM")).each(targetNameSet, function() {
                var errMsg = '';
                throw new Error(errMsg);
            });
            function removeEdge(succComponentType) {
                graph[succComponentType].entryCount--;
                if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
            }
            function removeEdgeAndAdd(succComponentType) {
                targetNameSet[succComponentType] = true;
                removeEdge(succComponentType);
            }
        };
        function makeDepndencyGraph(fullNameList) {
            var graph = {};
            var noEntryList = [];
            (0, parcelRequire("bahqM")).each(fullNameList, function(name) {
                var thisItem = createDependencyGraphItem(graph, name);
                var originalDeps = thisItem.originalDeps = dependencyGetter(name);
                var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
                thisItem.entryCount = availableDeps.length;
                if (thisItem.entryCount === 0) noEntryList.push(name);
                (0, parcelRequire("bahqM")).each(availableDeps, function(dependentName) {
                    if ((0, parcelRequire("bahqM")).indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                    var thatItem = createDependencyGraphItem(graph, dependentName);
                    if ((0, parcelRequire("bahqM")).indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
                });
            });
            return {
                graph: graph,
                noEntryList: noEntryList
            };
        }
        function createDependencyGraphItem(graph, name) {
            if (!graph[name]) graph[name] = {
                predecessor: [],
                successor: []
            };
            return graph[name];
        }
        function getAvailableDependencies(originalDeps, fullNameList) {
            var availableDeps = [];
            (0, parcelRequire("bahqM")).each(originalDeps, function(dep) {
                (0, parcelRequire("bahqM")).indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
            });
            return availableDeps;
        }
    }
    function $e3339d183aa6ce79$export$68acc510e46fef2(superOption, subOption) {
        return (0, parcelRequire("bahqM")).merge((0, parcelRequire("bahqM")).merge({}, superOption, true), subOption, true);
    }
});
parcelRegister("65MS1", function(module, exports) {
    $parcel$export(module.exports, "LOCATION_PARAMS", ()=>$46f91e567ea0ce35$export$a9aa2cc018afbed);
    $parcel$export(module.exports, "box", ()=>$46f91e567ea0ce35$export$827f4ee28efc37);
    $parcel$export(module.exports, "getAvailableSize", ()=>$46f91e567ea0ce35$export$145a8938a85a22b1);
    $parcel$export(module.exports, "getLayoutRect", ()=>$46f91e567ea0ce35$export$4517a5ca639a7293);
    $parcel$export(module.exports, "positionElement", ()=>$46f91e567ea0ce35$export$74054bd96b5eeef1);
    $parcel$export(module.exports, "sizeCalculable", ()=>$46f91e567ea0ce35$export$7ede609e8ebc9650);
    $parcel$export(module.exports, "fetchLayoutMode", ()=>$46f91e567ea0ce35$export$3968a28a7cbd6063);
    $parcel$export(module.exports, "mergeLayoutParam", ()=>$46f91e567ea0ce35$export$1754cb91f16ca028);
    $parcel$export(module.exports, "getLayoutParams", ()=>$46f91e567ea0ce35$export$4b0d20af19c9875e);
    $parcel$export(module.exports, "copyLayoutParams", ()=>$46f91e567ea0ce35$export$7438999faea9b6cc);
    var $bahqM;
    var $1E3E8;
    var $jmSNG;
    var $dCJrM;
    var $46f91e567ea0ce35$var$each = (0, parcelRequire("bahqM")).each;
    var $46f91e567ea0ce35$export$a9aa2cc018afbed = [
        'left',
        'right',
        'top',
        'bottom',
        'width',
        'height'
    ];
    var $46f91e567ea0ce35$export$d7fd4338c7b20804 = [
        [
            'width',
            'left',
            'right'
        ],
        [
            'height',
            'top',
            'bottom'
        ]
    ];
    function $46f91e567ea0ce35$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
        var x = 0;
        var y = 0;
        if (maxWidth == null) maxWidth = Infinity;
        if (maxHeight == null) maxHeight = Infinity;
        var currentLineMaxSize = 0;
        group.eachChild(function(child, idx) {
            var rect = child.getBoundingRect();
            var nextChild = group.childAt(idx + 1);
            var nextChildRect = nextChild && nextChild.getBoundingRect();
            var nextX;
            var nextY;
            if (orient === 'horizontal') {
                var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
                nextX = x + moveX;
                if (nextX > maxWidth || child.newline) {
                    x = 0;
                    nextX = moveX;
                    y += currentLineMaxSize + gap;
                    currentLineMaxSize = rect.height;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
            } else {
                var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
                nextY = y + moveY;
                if (nextY > maxHeight || child.newline) {
                    x += currentLineMaxSize + gap;
                    y = 0;
                    nextY = moveY;
                    currentLineMaxSize = rect.width;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
            }
            if (child.newline) return;
            child.x = x;
            child.y = y;
            child.markRedraw();
            orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
        });
    }
    var $46f91e567ea0ce35$export$827f4ee28efc37 = $46f91e567ea0ce35$var$boxLayout;
    var $46f91e567ea0ce35$export$be20d9158c17374c = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'vertical');
    var $46f91e567ea0ce35$export$ae65a483d943e7a7 = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'horizontal');
    function $46f91e567ea0ce35$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var x = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var y = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var x2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var y2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
        (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
        (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
        (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        return {
            width: Math.max(x2 - x - margin[1] - margin[3], 0),
            height: Math.max(y2 - y - margin[0] - margin[2], 0)
        };
    }
    function $46f91e567ea0ce35$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var left = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var top = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var right = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var bottom = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        var width = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.width, containerWidth);
        var height = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.height, containerHeight);
        var verticalMargin = margin[2] + margin[0];
        var horizontalMargin = margin[1] + margin[3];
        var aspect = positionInfo.aspect;
        if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
        if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
        if (aspect != null) {
            if (isNaN(width) && isNaN(height)) {
                if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
                else height = containerHeight * 0.8;
            }
            if (isNaN(width)) width = aspect * height;
            if (isNaN(height)) height = width / aspect;
        }
        if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
        if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
        switch(positionInfo.left || positionInfo.right){
            case 'center':
                left = containerWidth / 2 - width / 2 - margin[3];
                break;
            case 'right':
                left = containerWidth - width - horizontalMargin;
                break;
        }
        switch(positionInfo.top || positionInfo.bottom){
            case 'middle':
            case 'center':
                top = containerHeight / 2 - height / 2 - margin[0];
                break;
            case 'bottom':
                top = containerHeight - height - verticalMargin;
                break;
        }
        left = left || 0;
        top = top || 0;
        if (isNaN(width)) width = containerWidth - horizontalMargin - left - (right || 0);
        if (isNaN(height)) height = containerHeight - verticalMargin - top - (bottom || 0);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(left + margin[3], top + margin[0], width, height);
        rect.margin = margin;
        return rect;
    }
    function $46f91e567ea0ce35$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
        var h = !opt || !opt.hv || opt.hv[0];
        var v = !opt || !opt.hv || opt.hv[1];
        var boundingMode = opt && opt.boundingMode || 'all';
        if (!h && !v) return;
        var rect;
        if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, (0, parcelRequire("1E3E8")).default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
        else {
            rect = el.getBoundingRect();
            if (el.needLocalTransform()) {
                var transform = el.getLocalTransform();
                rect = rect.clone();
                rect.applyTransform(transform);
            }
        }
        var layoutRect = $46f91e567ea0ce35$export$4517a5ca639a7293((0, parcelRequire("bahqM")).defaults({
            width: rect.width,
            height: rect.height
        }, positionInfo), containerRect, margin);
        var dx = h ? layoutRect.x - rect.x : 0;
        var dy = v ? layoutRect.y - rect.y : 0;
        if (boundingMode === 'raw') {
            el.x = dx;
            el.y = dy;
        } else {
            el.x += dx;
            el.y += dy;
        }
        el.markRedraw();
    }
    function $46f91e567ea0ce35$export$7ede609e8ebc9650(option, hvIdx) {
        return option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][2]] != null;
    }
    function $46f91e567ea0ce35$export$3968a28a7cbd6063(ins) {
        var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
        return (0, parcelRequire("bahqM")).isObject(layoutMode) ? layoutMode : layoutMode ? {
            type: layoutMode
        } : null;
    }
    function $46f91e567ea0ce35$export$1754cb91f16ca028(targetOption, newOption, opt) {
        var ignoreSize = opt && opt.ignoreSize;
        !(0, parcelRequire("bahqM")).isArray(ignoreSize) && (ignoreSize = [
            ignoreSize,
            ignoreSize
        ]);
        var hResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[0], 0);
        var vResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[1], 1);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[0], targetOption, hResult);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[1], targetOption, vResult);
        function merge(names, hvIdx) {
            var newParams = {};
            var newValueCount = 0;
            var merged = {};
            var mergedValueCount = 0;
            var enoughParamNumber = 2;
            $46f91e567ea0ce35$var$each(names, function(name) {
                merged[name] = targetOption[name];
            });
            $46f91e567ea0ce35$var$each(names, function(name) {
                hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
                hasValue(newParams, name) && newValueCount++;
                hasValue(merged, name) && mergedValueCount++;
            });
            if (ignoreSize[hvIdx]) {
                if (hasValue(newOption, names[1])) merged[names[2]] = null;
                else if (hasValue(newOption, names[2])) merged[names[1]] = null;
                return merged;
            }
            if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
            else if (newValueCount >= enoughParamNumber) return newParams;
            else {
                for(var i = 0; i < names.length; i++){
                    var name_1 = names[i];
                    if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                        newParams[name_1] = targetOption[name_1];
                        break;
                    }
                }
                return newParams;
            }
        }
        function hasProp(obj, name) {
            return obj.hasOwnProperty(name);
        }
        function hasValue(obj, name) {
            return obj[name] != null && obj[name] !== 'auto';
        }
        function copy(names, target, source) {
            $46f91e567ea0ce35$var$each(names, function(name) {
                target[name] = source[name];
            });
        }
    }
    function $46f91e567ea0ce35$export$4b0d20af19c9875e(source) {
        return $46f91e567ea0ce35$export$7438999faea9b6cc({}, source);
    }
    function $46f91e567ea0ce35$export$7438999faea9b6cc(target, source) {
        source && target && $46f91e567ea0ce35$var$each($46f91e567ea0ce35$export$a9aa2cc018afbed, function(name) {
            source.hasOwnProperty(name) && (target[name] = source[name]);
        });
        return target;
    }
});
parcelRegister("dCJrM", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>$9eb213cc0c822e32$export$b6fe44657ce35c42);
    $parcel$export(module.exports, "toCamelCase", ()=>$9eb213cc0c822e32$export$86f54f62aa7a7514);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$9eb213cc0c822e32$export$f3a38102c49f4268);
    $parcel$export(module.exports, "encodeHTML", ()=>$9eb213cc0c822e32$export$f9d6449b9af28dc1);
    $parcel$export(module.exports, "makeValueReadable", ()=>$9eb213cc0c822e32$export$3cd8db88714decfc);
    $parcel$export(module.exports, "formatTpl", ()=>$9eb213cc0c822e32$export$2028496a35766e41);
    $parcel$export(module.exports, "formatTplSimple", ()=>$9eb213cc0c822e32$export$2fa08233ee42f8e1);
    $parcel$export(module.exports, "getTooltipMarker", ()=>$9eb213cc0c822e32$export$1987a3dbdf3c45ca);
    $parcel$export(module.exports, "formatTime", ()=>$9eb213cc0c822e32$export$3203edd9e5edd663);
    $parcel$export(module.exports, "capitalFirst", ()=>$9eb213cc0c822e32$export$38a1e7552f497c0e);
    $parcel$export(module.exports, "convertToColorString", ()=>$9eb213cc0c822e32$export$cda04d03233e5555);
    $parcel$export(module.exports, "windowOpen", ()=>$9eb213cc0c822e32$export$13e13f9b96dbe8fa);
    var $bahqM;
    var $jmSNG;
    var $bc1Ad;
    var $h6fMM;
    var $2emZ2;
    function $9eb213cc0c822e32$export$b6fe44657ce35c42(x) {
        if (!(0, (0, parcelRequire("jmSNG")).isNumeric)(x)) return (0, parcelRequire("bahqM")).isString(x) ? x : '-';
        var parts = (x + '').split('.');
        return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
    }
    function $9eb213cc0c822e32$export$86f54f62aa7a7514(str, upperCaseFirst) {
        str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
            return group1.toUpperCase();
        });
        if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
        return str;
    }
    var $9eb213cc0c822e32$export$f3a38102c49f4268 = (0, parcelRequire("bahqM")).normalizeCssArray;
    var $9eb213cc0c822e32$var$replaceReg = /([&<>"'])/g;
    var $9eb213cc0c822e32$var$replaceMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;'
    };
    function $9eb213cc0c822e32$export$f9d6449b9af28dc1(source) {
        return source == null ? '' : (source + '').replace($9eb213cc0c822e32$var$replaceReg, function(str, c) {
            return $9eb213cc0c822e32$var$replaceMap[c];
        });
    }
    function $9eb213cc0c822e32$export$3cd8db88714decfc(value, valueType, useUTC) {
        var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
        function stringToUserReadable(str) {
            return str && (0, parcelRequire("bahqM")).trim(str) ? str : '-';
        }
        function isNumberUserReadable(num) {
            return !!(num != null && !isNaN(num) && isFinite(num));
        }
        var isTypeTime = valueType === 'time';
        var isValueDate = value instanceof Date;
        if (isTypeTime || isValueDate) {
            var date = isTypeTime ? (0, (0, parcelRequire("jmSNG")).parseDate)(value) : value;
            if (!isNaN(+date)) return (0, (0, parcelRequire("bc1Ad")).format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
            else if (isValueDate) return '-';
        }
        if (valueType === 'ordinal') return (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : (0, parcelRequire("bahqM")).isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
        var numericResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(value);
        return isNumberUserReadable(numericResult) ? $9eb213cc0c822e32$export$b6fe44657ce35c42(numericResult) : (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : '-';
    }
    var $9eb213cc0c822e32$var$TPL_VAR_ALIAS = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g'
    ];
    var $9eb213cc0c822e32$var$wrapVar = function(varName, seriesIdx) {
        return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
    };
    function $9eb213cc0c822e32$export$2028496a35766e41(tpl, paramsList, encode) {
        if (!(0, parcelRequire("bahqM")).isArray(paramsList)) paramsList = [
            paramsList
        ];
        var seriesLen = paramsList.length;
        if (!seriesLen) return '';
        var $vars = paramsList[0].$vars || [];
        for(var i = 0; i < $vars.length; i++){
            var alias = $9eb213cc0c822e32$var$TPL_VAR_ALIAS[i];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar(alias), $9eb213cc0c822e32$var$wrapVar(alias, 0));
        }
        for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
            var val = paramsList[seriesIdx][$vars[k]];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar($9eb213cc0c822e32$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(val) : val);
        }
        return tpl;
    }
    function $9eb213cc0c822e32$export$2fa08233ee42f8e1(tpl, param, encode) {
        (0, parcelRequire("bahqM")).each(param, function(value, key) {
            tpl = tpl.replace('{' + key + '}', encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(value) : value);
        });
        return tpl;
    }
    function $9eb213cc0c822e32$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
        var opt = (0, parcelRequire("bahqM")).isString(inOpt) ? {
            color: inOpt,
            extraCssText: extraCssText
        } : inOpt || {};
        var color = opt.color;
        var type = opt.type;
        extraCssText = opt.extraCssText;
        var renderMode = opt.renderMode || 'html';
        if (!color) return '';
        if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
        else {
            var markerId = opt.markerId || 'markerX';
            return {
                renderMode: renderMode,
                content: '{' + markerId + '|}  ',
                style: type === 'subItem' ? {
                    width: 4,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: color
                } : {
                    width: 10,
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: color
                }
            };
        }
    }
    function $9eb213cc0c822e32$export$3203edd9e5edd663(tpl, value, isUTC) {
        if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
        var date = (0, (0, parcelRequire("jmSNG")).parseDate)(value);
        var utc = isUTC ? 'UTC' : '';
        var y = date['get' + utc + 'FullYear']();
        var M = date['get' + utc + 'Month']() + 1;
        var d = date['get' + utc + 'Date']();
        var h = date['get' + utc + 'Hours']();
        var m = date['get' + utc + 'Minutes']();
        var s = date['get' + utc + 'Seconds']();
        var S = date['get' + utc + 'Milliseconds']();
        tpl = tpl.replace('MM', (0, (0, parcelRequire("bc1Ad")).pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, (0, parcelRequire("bc1Ad")).pad)(d, 2)).replace('d', d).replace('hh', (0, (0, parcelRequire("bc1Ad")).pad)(h, 2)).replace('h', h).replace('mm', (0, (0, parcelRequire("bc1Ad")).pad)(m, 2)).replace('m', m).replace('ss', (0, (0, parcelRequire("bc1Ad")).pad)(s, 2)).replace('s', s).replace('SSS', (0, (0, parcelRequire("bc1Ad")).pad)(S, 3));
        return tpl;
    }
    function $9eb213cc0c822e32$export$38a1e7552f497c0e(str) {
        return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
    }
    function $9eb213cc0c822e32$export$cda04d03233e5555(color, defaultColor) {
        defaultColor = defaultColor || 'transparent';
        return (0, parcelRequire("bahqM")).isString(color) ? color : (0, parcelRequire("bahqM")).isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
    }
    function $9eb213cc0c822e32$export$13e13f9b96dbe8fa(link, target) {
        if (target === '_blank' || target === 'blank') {
            var blank = window.open();
            blank.opener = null;
            blank.location.href = link;
        } else window.open(link, target);
    }
});
parcelRegister("bc1Ad", function(module, exports) {
    $parcel$export(module.exports, "ONE_SECOND", ()=>$82620b17ee17a85a$export$32c0454ceff7f92d);
    $parcel$export(module.exports, "ONE_MINUTE", ()=>$82620b17ee17a85a$export$35acaebf644db34e);
    $parcel$export(module.exports, "ONE_HOUR", ()=>$82620b17ee17a85a$export$82541edf19e5e3b0);
    $parcel$export(module.exports, "ONE_DAY", ()=>$82620b17ee17a85a$export$a97a1358cbb650ab);
    $parcel$export(module.exports, "ONE_YEAR", ()=>$82620b17ee17a85a$export$99cafda57477293d);
    $parcel$export(module.exports, "fullLeveledFormatter", ()=>$82620b17ee17a85a$export$445bdbd8d2334e40);
    $parcel$export(module.exports, "timeUnits", ()=>$82620b17ee17a85a$export$833c398a55654bb7);
    $parcel$export(module.exports, "pad", ()=>$82620b17ee17a85a$export$5d04458e2a6c373e);
    $parcel$export(module.exports, "getPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$1da4b91a25d7e1c8);
    $parcel$export(module.exports, "isPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$beb5920b69c13da);
    $parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", ()=>$82620b17ee17a85a$export$124c820721c4f66b);
    $parcel$export(module.exports, "format", ()=>$82620b17ee17a85a$export$d9468344d3651243);
    $parcel$export(module.exports, "fullYearGetterName", ()=>$82620b17ee17a85a$export$8d046fefed9a548e);
    $parcel$export(module.exports, "monthGetterName", ()=>$82620b17ee17a85a$export$5c242a801a23eec7);
    $parcel$export(module.exports, "dateGetterName", ()=>$82620b17ee17a85a$export$4189e6cbc9753260);
    $parcel$export(module.exports, "hoursGetterName", ()=>$82620b17ee17a85a$export$8b40b55b3c06cbe2);
    $parcel$export(module.exports, "minutesGetterName", ()=>$82620b17ee17a85a$export$8807847c5c71eded);
    $parcel$export(module.exports, "secondsGetterName", ()=>$82620b17ee17a85a$export$8f49e73e2eebd168);
    $parcel$export(module.exports, "millisecondsGetterName", ()=>$82620b17ee17a85a$export$312207a92d041116);
    $parcel$export(module.exports, "leveledFormat", ()=>$82620b17ee17a85a$export$fe777b6293828b5d);
    $parcel$export(module.exports, "getUnitValue", ()=>$82620b17ee17a85a$export$e04e41a1e24ffd3f);
    $parcel$export(module.exports, "fullYearSetterName", ()=>$82620b17ee17a85a$export$43fbeac90913b151);
    $parcel$export(module.exports, "monthSetterName", ()=>$82620b17ee17a85a$export$233f59998ed71c09);
    $parcel$export(module.exports, "dateSetterName", ()=>$82620b17ee17a85a$export$82fd379a67f37fa0);
    $parcel$export(module.exports, "hoursSetterName", ()=>$82620b17ee17a85a$export$b6f943e8d23c15bb);
    $parcel$export(module.exports, "minutesSetterName", ()=>$82620b17ee17a85a$export$50303078793fc7d);
    $parcel$export(module.exports, "secondsSetterName", ()=>$82620b17ee17a85a$export$a4a908acda9c3118);
    $parcel$export(module.exports, "millisecondsSetterName", ()=>$82620b17ee17a85a$export$c047afab75f6d84);
    var $bahqM;
    var $jmSNG;
    var $3OMoQ;
    var $gaMkj;
    var $82620b17ee17a85a$export$32c0454ceff7f92d = 1000;
    var $82620b17ee17a85a$export$35acaebf644db34e = $82620b17ee17a85a$export$32c0454ceff7f92d * 60;
    var $82620b17ee17a85a$export$82541edf19e5e3b0 = $82620b17ee17a85a$export$35acaebf644db34e * 60;
    var $82620b17ee17a85a$export$a97a1358cbb650ab = $82620b17ee17a85a$export$82541edf19e5e3b0 * 24;
    var $82620b17ee17a85a$export$99cafda57477293d = $82620b17ee17a85a$export$a97a1358cbb650ab * 365;
    var $82620b17ee17a85a$export$f7854271ddbda64e = {
        year: '{yyyy}',
        month: '{MMM}',
        day: '{d}',
        hour: '{HH}:{mm}',
        minute: '{HH}:{mm}',
        second: '{HH}:{mm}:{ss}',
        millisecond: '{HH}:{mm}:{ss} {SSS}',
        none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
    };
    var $82620b17ee17a85a$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
    var $82620b17ee17a85a$export$445bdbd8d2334e40 = {
        year: '{yyyy}',
        month: '{yyyy}-{MM}',
        day: $82620b17ee17a85a$var$fullDayFormatter,
        hour: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.hour,
        minute: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.minute,
        second: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.second,
        millisecond: $82620b17ee17a85a$export$f7854271ddbda64e.none
    };
    var $82620b17ee17a85a$export$87100da04d711986 = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    var $82620b17ee17a85a$export$833c398a55654bb7 = [
        'year',
        'half-year',
        'quarter',
        'month',
        'week',
        'half-week',
        'day',
        'half-day',
        'quarter-day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function $82620b17ee17a85a$export$5d04458e2a6c373e(str, len) {
        str += '';
        return '0000'.substr(0, len - str.length) + str;
    }
    function $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit) {
        switch(timeUnit){
            case 'half-year':
            case 'quarter':
                return 'month';
            case 'week':
            case 'half-week':
                return 'day';
            case 'half-day':
            case 'quarter-day':
                return 'hour';
            default:
                return timeUnit;
        }
    }
    function $82620b17ee17a85a$export$beb5920b69c13da(timeUnit) {
        return timeUnit === $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit);
    }
    function $82620b17ee17a85a$export$124c820721c4f66b(timeUnit) {
        switch(timeUnit){
            case 'year':
            case 'month':
                return 'day';
            case 'millisecond':
                return 'millisecond';
            default:
                return 'second';
        }
    }
    function $82620b17ee17a85a$export$d9468344d3651243(time, template, isUTC, lang) {
        var date = (0, parcelRequire("jmSNG")).parseDate(time);
        var y = date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var q = Math.floor((M - 1) / 4) + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
        var H = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var h = (H - 1) % 12 + 1;
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var localeModel = lang instanceof (0, (0, parcelRequire("gaMkj")).default) ? lang : (0, (0, parcelRequire("3OMoQ")).getLocaleModel)(lang || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG)) || (0, (0, parcelRequire("3OMoQ")).getDefaultLocaleModel)();
        var timeModel = localeModel.getModel('time');
        var month = timeModel.get('month');
        var monthAbbr = timeModel.get('monthAbbr');
        var dayOfWeek = timeModel.get('dayOfWeek');
        var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
        return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
    }
    function $82620b17ee17a85a$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
        var template = null;
        if (typeof formatter === 'string') template = formatter;
        else if (typeof formatter === 'function') template = formatter(tick.value, idx, {
            level: tick.level
        });
        else {
            var defaults = (0, parcelRequire("bahqM")).extend({}, $82620b17ee17a85a$export$f7854271ddbda64e);
            if (tick.level > 0) for(var i = 0; i < $82620b17ee17a85a$export$87100da04d711986.length; ++i)defaults[$82620b17ee17a85a$export$87100da04d711986[i]] = "{primary|" + defaults[$82620b17ee17a85a$export$87100da04d711986[i]] + "}";
            var mergedFormatter = formatter ? formatter.inherit === false ? formatter : (0, parcelRequire("bahqM")).defaults(formatter, defaults) : defaults;
            var unit = $82620b17ee17a85a$export$4dfb0417ad6555b7(tick.value, isUTC);
            if (mergedFormatter[unit]) template = mergedFormatter[unit];
            else if (mergedFormatter.inherit) {
                var targetId = $82620b17ee17a85a$export$833c398a55654bb7.indexOf(unit);
                for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                    template = mergedFormatter[unit];
                    break;
                }
                template = template || defaults.none;
            }
            if ((0, parcelRequire("bahqM")).isArray(template)) {
                var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
                levelId = Math.min(levelId, template.length - 1);
                template = template[levelId];
            }
        }
        return $82620b17ee17a85a$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
    }
    function $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC) {
        var date = (0, parcelRequire("jmSNG")).parseDate(value);
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var h = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var isSecond = S === 0;
        var isMinute = isSecond && s === 0;
        var isHour = isMinute && m === 0;
        var isDay = isHour && h === 0;
        var isMonth = isDay && d === 1;
        var isYear = isMonth && M === 1;
        if (isYear) return 'year';
        else if (isMonth) return 'month';
        else if (isDay) return 'day';
        else if (isHour) return 'hour';
        else if (isMinute) return 'minute';
        else if (isSecond) return 'second';
        else return 'millisecond';
    }
    function $82620b17ee17a85a$export$e04e41a1e24ffd3f(value, unit, isUTC) {
        var date = typeof value === 'number' ? (0, parcelRequire("jmSNG")).parseDate(value) : value;
        unit = unit || $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC);
        switch(unit){
            case 'year':
                return date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
            case 'half-year':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
            case 'quarter':
                return Math.floor((date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
            case 'month':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]();
            case 'day':
                return date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
            case 'half-day':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]() / 24;
            case 'hour':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
            case 'minute':
                return date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
            case 'second':
                return date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
            case 'millisecond':
                return date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        }
    }
    function $82620b17ee17a85a$export$8d046fefed9a548e(isUTC) {
        return isUTC ? 'getUTCFullYear' : 'getFullYear';
    }
    function $82620b17ee17a85a$export$5c242a801a23eec7(isUTC) {
        return isUTC ? 'getUTCMonth' : 'getMonth';
    }
    function $82620b17ee17a85a$export$4189e6cbc9753260(isUTC) {
        return isUTC ? 'getUTCDate' : 'getDate';
    }
    function $82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC) {
        return isUTC ? 'getUTCHours' : 'getHours';
    }
    function $82620b17ee17a85a$export$8807847c5c71eded(isUTC) {
        return isUTC ? 'getUTCMinutes' : 'getMinutes';
    }
    function $82620b17ee17a85a$export$8f49e73e2eebd168(isUTC) {
        return isUTC ? 'getUTCSeconds' : 'getSeconds';
    }
    function $82620b17ee17a85a$export$312207a92d041116(isUTC) {
        return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
    }
    function $82620b17ee17a85a$export$43fbeac90913b151(isUTC) {
        return isUTC ? 'setUTCFullYear' : 'setFullYear';
    }
    function $82620b17ee17a85a$export$233f59998ed71c09(isUTC) {
        return isUTC ? 'setUTCMonth' : 'setMonth';
    }
    function $82620b17ee17a85a$export$82fd379a67f37fa0(isUTC) {
        return isUTC ? 'setUTCDate' : 'setDate';
    }
    function $82620b17ee17a85a$export$b6f943e8d23c15bb(isUTC) {
        return isUTC ? 'setUTCHours' : 'setHours';
    }
    function $82620b17ee17a85a$export$50303078793fc7d(isUTC) {
        return isUTC ? 'setUTCMinutes' : 'setMinutes';
    }
    function $82620b17ee17a85a$export$a4a908acda9c3118(isUTC) {
        return isUTC ? 'setUTCSeconds' : 'setSeconds';
    }
    function $82620b17ee17a85a$export$c047afab75f6d84(isUTC) {
        return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
    }
});
parcelRegister("3OMoQ", function(module, exports) {
    $parcel$export(module.exports, "SYSTEM_LANG", ()=>$2c7b95ca3b098ed0$export$9a2147b3808d4c6b);
    $parcel$export(module.exports, "registerLocale", ()=>$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd);
    $parcel$export(module.exports, "createLocaleObject", ()=>$2c7b95ca3b098ed0$export$ddc371781a6af754);
    $parcel$export(module.exports, "getLocaleModel", ()=>$2c7b95ca3b098ed0$export$37cc638e0e11865f);
    $parcel$export(module.exports, "getDefaultLocaleModel", ()=>$2c7b95ca3b098ed0$export$1188f179b2597821);
    var $gaMkj;
    var $hZfwb;
    var $dHSx1;
    var $1VLoR;
    var $bahqM;
    var $2c7b95ca3b098ed0$var$LOCALE_ZH = 'ZH';
    var $2c7b95ca3b098ed0$var$LOCALE_EN = 'EN';
    var $2c7b95ca3b098ed0$var$DEFAULT_LOCALE = $2c7b95ca3b098ed0$var$LOCALE_EN;
    var $2c7b95ca3b098ed0$var$localeStorage = {};
    var $2c7b95ca3b098ed0$var$localeModels = {};
    var $2c7b95ca3b098ed0$export$9a2147b3808d4c6b = !(0, (0, parcelRequire("hZfwb")).default).domSupported ? $2c7b95ca3b098ed0$var$DEFAULT_LOCALE : function() {
        var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
        return langStr.indexOf($2c7b95ca3b098ed0$var$LOCALE_ZH) > -1 ? $2c7b95ca3b098ed0$var$LOCALE_ZH : $2c7b95ca3b098ed0$var$DEFAULT_LOCALE;
    }();
    function $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd(locale, localeObj) {
        locale = locale.toUpperCase();
        $2c7b95ca3b098ed0$var$localeModels[locale] = new (0, (0, parcelRequire("gaMkj")).default)(localeObj);
        $2c7b95ca3b098ed0$var$localeStorage[locale] = localeObj;
    }
    function $2c7b95ca3b098ed0$export$ddc371781a6af754(locale) {
        if ((0, (0, parcelRequire("bahqM")).isString)(locale)) {
            var localeObj = $2c7b95ca3b098ed0$var$localeStorage[locale.toUpperCase()] || {};
            if (locale === $2c7b95ca3b098ed0$var$LOCALE_ZH || locale === $2c7b95ca3b098ed0$var$LOCALE_EN) return (0, (0, parcelRequire("bahqM")).clone)(localeObj);
            else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(localeObj), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
        } else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(locale), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
    }
    function $2c7b95ca3b098ed0$export$37cc638e0e11865f(lang) {
        return $2c7b95ca3b098ed0$var$localeModels[lang];
    }
    function $2c7b95ca3b098ed0$export$1188f179b2597821() {
        return $2c7b95ca3b098ed0$var$localeModels[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE];
    }
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_EN, (0, (0, parcelRequire("dHSx1")).default));
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_ZH, (0, (0, parcelRequire("1VLoR")).default));
});
parcelRegister("dHSx1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fa9975bdbfffeb9$export$2e2bcd8739ae039);
    var $9fa9975bdbfffeb9$export$2e2bcd8739ae039 = {
        time: {
            month: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            monthAbbr: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            dayOfWeek: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            dayOfWeekAbbr: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ]
        },
        legend: {
            selector: {
                all: 'All',
                inverse: 'Inv'
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: 'Box Select',
                    polygon: 'Lasso Select',
                    lineX: 'Horizontally Select',
                    lineY: 'Vertically Select',
                    keep: 'Keep Selections',
                    clear: 'Clear Selections'
                }
            },
            dataView: {
                title: 'Data View',
                lang: [
                    'Data View',
                    'Close',
                    'Refresh'
                ]
            },
            dataZoom: {
                title: {
                    zoom: 'Zoom',
                    back: 'Zoom Reset'
                }
            },
            magicType: {
                title: {
                    line: 'Switch to Line Chart',
                    bar: 'Switch to Bar Chart',
                    stack: 'Stack',
                    tiled: 'Tile'
                }
            },
            restore: {
                title: 'Restore'
            },
            saveAsImage: {
                title: 'Save as Image',
                lang: [
                    'Right Click to Save Image'
                ]
            }
        },
        series: {
            typeNames: {
                pie: 'Pie chart',
                bar: 'Bar chart',
                line: 'Line chart',
                scatter: 'Scatter plot',
                effectScatter: 'Ripple scatter plot',
                radar: 'Radar chart',
                tree: 'Tree',
                treemap: 'Treemap',
                boxplot: 'Boxplot',
                candlestick: 'Candlestick',
                k: 'K line chart',
                heatmap: 'Heat map',
                map: 'Map',
                parallel: 'Parallel coordinate map',
                lines: 'Line graph',
                graph: 'Relationship graph',
                sankey: 'Sankey diagram',
                funnel: 'Funnel chart',
                gauge: 'Gauge',
                pictorialBar: 'Pictorial bar',
                themeRiver: 'Theme River Map',
                sunburst: 'Sunburst'
            }
        },
        aria: {
            general: {
                withTitle: 'This is a chart about "{title}"',
                withoutTitle: 'This is a chart'
            },
            series: {
                single: {
                    prefix: '',
                    withName: ' with type {seriesType} named {seriesName}.',
                    withoutName: ' with type {seriesType}.'
                },
                multiple: {
                    prefix: '. It consists of {seriesCount} series count.',
                    withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                    withoutName: ' The {seriesId} series is a {seriesType}.',
                    separator: {
                        middle: '',
                        end: ''
                    }
                }
            },
            data: {
                allData: 'The data is as follows: ',
                partialData: 'The first {displayCnt} items are: ',
                withName: 'the data for {name} is {value}',
                withoutName: '{value}',
                separator: {
                    middle: ', ',
                    end: '. '
                }
            }
        }
    };
});
parcelRegister("1VLoR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$167fe1fc3be0ec4c$export$2e2bcd8739ae039);
    var $167fe1fc3be0ec4c$export$2e2bcd8739ae039 = {
        time: {
            month: [
                "\u4E00\u6708",
                "\u4E8C\u6708",
                "\u4E09\u6708",
                "\u56DB\u6708",
                "\u4E94\u6708",
                "\u516D\u6708",
                "\u4E03\u6708",
                "\u516B\u6708",
                "\u4E5D\u6708",
                "\u5341\u6708",
                "\u5341\u4E00\u6708",
                "\u5341\u4E8C\u6708"
            ],
            monthAbbr: [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            dayOfWeek: [
                "\u661F\u671F\u65E5",
                "\u661F\u671F\u4E00",
                "\u661F\u671F\u4E8C",
                "\u661F\u671F\u4E09",
                "\u661F\u671F\u56DB",
                "\u661F\u671F\u4E94",
                "\u661F\u671F\u516D"
            ],
            dayOfWeekAbbr: [
                "\u65E5",
                "\u4E00",
                "\u4E8C",
                "\u4E09",
                "\u56DB",
                "\u4E94",
                "\u516D"
            ]
        },
        legend: {
            selector: {
                all: "\u5168\u9009",
                inverse: "\u53CD\u9009"
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: "\u77E9\u5F62\u9009\u62E9",
                    polygon: "\u5708\u9009",
                    lineX: "\u6A2A\u5411\u9009\u62E9",
                    lineY: "\u7EB5\u5411\u9009\u62E9",
                    keep: "\u4FDD\u6301\u9009\u62E9",
                    clear: "\u6E05\u9664\u9009\u62E9"
                }
            },
            dataView: {
                title: "\u6570\u636E\u89C6\u56FE",
                lang: [
                    "\u6570\u636E\u89C6\u56FE",
                    "\u5173\u95ED",
                    "\u5237\u65B0"
                ]
            },
            dataZoom: {
                title: {
                    zoom: "\u533A\u57DF\u7F29\u653E",
                    back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
                }
            },
            magicType: {
                title: {
                    line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                    bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                    stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                    tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
                }
            },
            restore: {
                title: "\u8FD8\u539F"
            },
            saveAsImage: {
                title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
                lang: [
                    "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
                ]
            }
        },
        series: {
            typeNames: {
                pie: "\u997C\u56FE",
                bar: "\u67F1\u72B6\u56FE",
                line: "\u6298\u7EBF\u56FE",
                scatter: "\u6563\u70B9\u56FE",
                effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
                radar: "\u96F7\u8FBE\u56FE",
                tree: "\u6811\u56FE",
                treemap: "\u77E9\u5F62\u6811\u56FE",
                boxplot: "\u7BB1\u578B\u56FE",
                candlestick: "K\u7EBF\u56FE",
                k: "K\u7EBF\u56FE",
                heatmap: "\u70ED\u529B\u56FE",
                map: "\u5730\u56FE",
                parallel: "\u5E73\u884C\u5750\u6807\u56FE",
                lines: "\u7EBF\u56FE",
                graph: "\u5173\u7CFB\u56FE",
                sankey: "\u6851\u57FA\u56FE",
                funnel: "\u6F0F\u6597\u56FE",
                gauge: "\u4EEA\u8868\u76D8\u56FE",
                pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
                themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
                sunburst: "\u65ED\u65E5\u56FE"
            }
        },
        aria: {
            general: {
                withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
                withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
            },
            series: {
                single: {
                    prefix: '',
                    withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                    withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
                },
                multiple: {
                    prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                    withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                    withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                    separator: {
                        middle: "\uFF1B",
                        end: "\u3002"
                    }
                }
            },
            data: {
                allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
                partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
                withName: "{name}\u7684\u6570\u636E\u662F{value}",
                withoutName: '{value}',
                separator: {
                    middle: "\uFF0C",
                    end: ''
                }
            }
        }
    };
});
parcelRegister("2emZ2", function(module, exports) {
    $parcel$export(module.exports, "getTextRect", ()=>$19feb79b579d02ba$export$372ffda650a6e70d);
    var $4gEFv;
    var $2cFRc;
    function $19feb79b579d02ba$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('getTextRect is deprecated.');
        var textEl = new (0, (0, parcelRequire("4gEFv")).default)({
            style: {
                text: text,
                font: font,
                align: align,
                verticalAlign: verticalAlign,
                padding: padding,
                rich: rich,
                overflow: truncate ? 'truncate' : null,
                lineHeight: lineHeight
            }
        });
        return textEl.getBoundingRect();
    }
});
parcelRegister("aCu4v", function(module, exports) {
    $parcel$export(module.exports, "PaletteMixin", ()=>$7bb4c79f78d718b0$export$55a3c39e852b90f4);
    $parcel$export(module.exports, "getDecalFromPalette", ()=>$7bb4c79f78d718b0$export$e4d892222945a227);
    var $eaKsF;
    var $7bb4c79f78d718b0$var$innerColor = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$var$innerDecal = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$export$55a3c39e852b90f4 = function() {
        function PaletteMixin() {}
        PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
            var defaultPalette = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(this.get('color', true));
            var layeredPalette = this.get('colorLayer', true);
            return $7bb4c79f78d718b0$var$getFromPalette(this, $7bb4c79f78d718b0$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
        };
        PaletteMixin.prototype.clearColorPalette = function() {
            $7bb4c79f78d718b0$var$clearPalette(this, $7bb4c79f78d718b0$var$innerColor);
        };
        return PaletteMixin;
    }();
    function $7bb4c79f78d718b0$export$e4d892222945a227(ecModel, name, scope, requestNum) {
        var defaultDecals = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(ecModel.get([
            'aria',
            'decal',
            'decals'
        ]));
        return $7bb4c79f78d718b0$var$getFromPalette(ecModel, $7bb4c79f78d718b0$var$innerDecal, defaultDecals, null, name, scope, requestNum);
    }
    function $7bb4c79f78d718b0$var$getNearestPalette(palettes, requestColorNum) {
        var paletteNum = palettes.length;
        for(var i = 0; i < paletteNum; i++){
            if (palettes[i].length > requestColorNum) return palettes[i];
        }
        return palettes[paletteNum - 1];
    }
    function $7bb4c79f78d718b0$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
        scope = scope || that;
        var scopeFields = inner(scope);
        var paletteIdx = scopeFields.paletteIdx || 0;
        var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
        if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
        var palette = requestNum == null || !layeredPalette ? defaultPalette : $7bb4c79f78d718b0$var$getNearestPalette(layeredPalette, requestNum);
        palette = palette || defaultPalette;
        if (!palette || !palette.length) return;
        var pickedPaletteItem = palette[paletteIdx];
        if (name) paletteNameMap[name] = pickedPaletteItem;
        scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
        return pickedPaletteItem;
    }
    function $7bb4c79f78d718b0$var$clearPalette(that, inner) {
        inner(that).paletteIdx = 0;
        inner(that).paletteNameMap = {};
    }
});
parcelRegister("guzSc", function(module, exports) {
    $parcel$export(module.exports, "DataFormatMixin", ()=>$c01b465ef25e12c0$export$f23396ae04ea95a7);
    $parcel$export(module.exports, "normalizeTooltipFormatResult", ()=>$c01b465ef25e12c0$export$2d16fa82a50c4741);
    var $bahqM;
    var $9OHWG;
    var $dCJrM;
    var $c01b465ef25e12c0$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
    var $c01b465ef25e12c0$export$f23396ae04ea95a7 = function() {
        function DataFormatMixin() {}
        DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
            var data = this.getData(dataType);
            var rawValue = this.getRawValue(dataIndex, dataType);
            var rawDataIndex = data.getRawIndex(dataIndex);
            var name = data.getName(dataIndex);
            var itemOpt = data.getRawDataItem(dataIndex);
            var style = data.getItemVisual(dataIndex, 'style');
            var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
            var borderColor = style && style.stroke;
            var mainType = this.mainType;
            var isSeries = mainType === 'series';
            var userOutput = data.userOutput && data.userOutput.get();
            return {
                componentType: mainType,
                componentSubType: this.subType,
                componentIndex: this.componentIndex,
                seriesType: isSeries ? this.subType : null,
                seriesIndex: this.seriesIndex,
                seriesId: isSeries ? this.id : null,
                seriesName: isSeries ? this.name : null,
                name: name,
                dataIndex: rawDataIndex,
                data: itemOpt,
                dataType: dataType,
                value: rawValue,
                color: color,
                borderColor: borderColor,
                dimensionNames: userOutput ? userOutput.fullDimensions : null,
                encode: userOutput ? userOutput.encode : null,
                $vars: [
                    'seriesName',
                    'name',
                    'value'
                ]
            };
        };
        DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
            status = status || 'normal';
            var data = this.getData(dataType);
            var params = this.getDataParams(dataIndex, dataType);
            if (extendParams) params.value = extendParams.interpolatedValue;
            if (labelDimIndex != null && (0, parcelRequire("bahqM")).isArray(params.value)) params.value = params.value[labelDimIndex];
            if (!formatter) {
                var itemModel = data.getItemModel(dataIndex);
                formatter = itemModel.get(status === 'normal' ? [
                    'label',
                    'formatter'
                ] : [
                    status,
                    'label',
                    'formatter'
                ]);
            }
            if (typeof formatter === 'function') {
                params.status = status;
                params.dimensionIndex = labelDimIndex;
                return formatter(params);
            } else if (typeof formatter === 'string') {
                var str = (0, (0, parcelRequire("dCJrM")).formatTpl)(formatter, params);
                return str.replace($c01b465ef25e12c0$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                    var len = dimStr.length;
                    var dimLoose = dimStr;
                    if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1);
                    var val = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dimLoose);
                    if (extendParams && (0, parcelRequire("bahqM")).isArray(extendParams.interpolatedValue)) {
                        var dimIndex = data.getDimensionIndex(dimLoose);
                        if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                    }
                    return val != null ? val + '' : '';
                });
            }
        };
        DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
            return (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(this.getData(dataType), idx);
        };
        DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return;
        };
        return DataFormatMixin;
    }();
    function $c01b465ef25e12c0$export$2d16fa82a50c4741(result) {
        var markupText;
        var markupFragment;
        if ((0, parcelRequire("bahqM")).isObject(result)) {
            if (result.type) markupFragment = result;
        } else markupText = result;
        return {
            markupText: markupText,
            markupFragment: markupFragment
        };
    }
});
parcelRegister("92IK1", function(module, exports) {
    $parcel$export(module.exports, "createTask", ()=>$6957019fc0d13ee5$export$f7292ab7796be73c);
    var $bahqM;
    function $6957019fc0d13ee5$export$f7292ab7796be73c(define) {
        return new $6957019fc0d13ee5$export$2dea7024bcdd7731(define);
    }
    var $6957019fc0d13ee5$export$2dea7024bcdd7731 = function() {
        function Task(define) {
            define = define || {};
            this._reset = define.reset;
            this._plan = define.plan;
            this._count = define.count;
            this._onDirty = define.onDirty;
            this._dirty = true;
        }
        Task.prototype.perform = function(performArgs) {
            var upTask = this._upstream;
            var skip = performArgs && performArgs.skip;
            if (this._dirty && upTask) {
                var context = this.context;
                context.data = context.outputData = upTask.context.outputData;
            }
            if (this.__pipeline) this.__pipeline.currentTask = this;
            var planResult;
            if (this._plan && !skip) planResult = this._plan(this.context);
            var lastModBy = normalizeModBy(this._modBy);
            var lastModDataCount = this._modDataCount || 0;
            var modBy = normalizeModBy(performArgs && performArgs.modBy);
            var modDataCount = performArgs && performArgs.modDataCount || 0;
            if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
            function normalizeModBy(val) {
                !(val >= 1) && (val = 1);
                return val;
            }
            var forceFirstProgress;
            if (this._dirty || planResult === 'reset') {
                this._dirty = false;
                forceFirstProgress = this._doReset(skip);
            }
            this._modBy = modBy;
            this._modDataCount = modDataCount;
            var step = performArgs && performArgs.step;
            if (upTask) this._dueEnd = upTask._outputDueEnd;
            else this._dueEnd = this._count ? this._count(this.context) : Infinity;
            if (this._progress) {
                var start = this._dueIndex;
                var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
                if (!skip && (forceFirstProgress || start < end)) {
                    var progress = this._progress;
                    if ((0, (0, parcelRequire("bahqM")).isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                    else this._doProgress(progress, start, end, modBy, modDataCount);
                }
                this._dueIndex = end;
                var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
                this._outputDueEnd = outputDueEnd;
            } else this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
            return this.unfinished();
        };
        Task.prototype.dirty = function() {
            this._dirty = true;
            this._onDirty && this._onDirty(this.context);
        };
        Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
            $6957019fc0d13ee5$var$iterator.reset(start, end, modBy, modDataCount);
            this._callingProgress = progress;
            this._callingProgress({
                start: start,
                end: end,
                count: end - start,
                next: $6957019fc0d13ee5$var$iterator.next
            }, this.context);
        };
        Task.prototype._doReset = function(skip) {
            this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
            this._settedOutputEnd = null;
            var progress;
            var forceFirstProgress;
            if (!skip && this._reset) {
                progress = this._reset(this.context);
                if (progress && progress.progress) {
                    forceFirstProgress = progress.forceFirstProgress;
                    progress = progress.progress;
                }
                if ((0, (0, parcelRequire("bahqM")).isArray)(progress) && !progress.length) progress = null;
            }
            this._progress = progress;
            this._modBy = this._modDataCount = null;
            var downstream = this._downstream;
            downstream && downstream.dirty();
            return forceFirstProgress;
        };
        Task.prototype.unfinished = function() {
            return this._progress && this._dueIndex < this._dueEnd;
        };
        Task.prototype.pipe = function(downTask) {
            if (this._downstream !== downTask || this._dirty) {
                this._downstream = downTask;
                downTask._upstream = this;
                downTask.dirty();
            }
        };
        Task.prototype.dispose = function() {
            if (this._disposed) return;
            this._upstream && (this._upstream._downstream = null);
            this._downstream && (this._downstream._upstream = null);
            this._dirty = false;
            this._disposed = true;
        };
        Task.prototype.getUpstream = function() {
            return this._upstream;
        };
        Task.prototype.getDownstream = function() {
            return this._downstream;
        };
        Task.prototype.setOutputEnd = function(end) {
            this._outputDueEnd = this._settedOutputEnd = end;
        };
        return Task;
    }();
    var $6957019fc0d13ee5$var$iterator = function() {
        var end;
        var current;
        var modBy;
        var modDataCount;
        var winCount;
        var it = {
            reset: function(s, e, sStep, sCount) {
                current = s;
                end = e;
                modBy = sStep;
                modDataCount = sCount;
                winCount = Math.ceil(modDataCount / modBy);
                it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
            }
        };
        return it;
        function sequentialNext() {
            return current < end ? current++ : null;
        }
        function modNext() {
            var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
            var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
            current++;
            return result;
        }
    }();
});
parcelRegister("jTNWo", function(module, exports) {
    $parcel$export(module.exports, "SourceManager", ()=>$e7c9e4985e212cda$export$af4db9ec7e200ea2);
    $parcel$export(module.exports, "disableTransformOptionMerge", ()=>$e7c9e4985e212cda$export$9451f4e9047441ec);
    var $bahqM;
    var $20liu;
    var $2Rbm1;
    var $cNGs8;
    var $05ab4;
    var $8c3gC;
    var $9OHWG;
    var $e7c9e4985e212cda$export$af4db9ec7e200ea2 = function() {
        function SourceManager(sourceHost) {
            this._sourceList = [];
            this._storeList = [];
            this._upstreamSignList = [];
            this._versionSignBase = 0;
            this._dirty = true;
            this._sourceHost = sourceHost;
        }
        SourceManager.prototype.dirty = function() {
            this._setLocalSource([], []);
            this._storeList = [];
            this._dirty = true;
        };
        SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
            this._sourceList = sourceList;
            this._upstreamSignList = upstreamSignList;
            this._versionSignBase++;
            if (this._versionSignBase > 9e10) this._versionSignBase = 0;
        };
        SourceManager.prototype._getVersionSign = function() {
            return this._sourceHost.uid + '_' + this._versionSignBase;
        };
        SourceManager.prototype.prepareSource = function() {
            if (this._isDirty()) {
                this._createSource();
                this._dirty = false;
            }
        };
        SourceManager.prototype._createSource = function() {
            this._setLocalSource([], []);
            var sourceHost = this._sourceHost;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            var hasUpstream = !!upSourceMgrList.length;
            var resultSourceList;
            var upstreamSignList;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var seriesModel = sourceHost;
                var data = void 0;
                var sourceFormat = void 0;
                var upSource = void 0;
                if (hasUpstream) {
                    var upSourceMgr = upSourceMgrList[0];
                    upSourceMgr.prepareSource();
                    upSource = upSourceMgr.getSource();
                    data = upSource.data;
                    sourceFormat = upSource.sourceFormat;
                    upstreamSignList = [
                        upSourceMgr._getVersionSign()
                    ];
                } else {
                    data = seriesModel.get('data', true);
                    sourceFormat = (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
                    upstreamSignList = [];
                }
                var newMetaRawOption = this._getSourceMetaRawOption() || {};
                var upMetaRawOption = upSource && upSource.metaRawOption || {};
                var seriesLayoutBy = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
                var sourceHeader = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null;
                var dimensions = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
                var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
                resultSourceList = needsCreateSource ? [
                    (0, (0, parcelRequire("20liu")).createSource)(data, {
                        seriesLayoutBy: seriesLayoutBy,
                        sourceHeader: sourceHeader,
                        dimensions: dimensions
                    }, sourceFormat)
                ] : [];
            } else {
                var datasetModel = sourceHost;
                if (hasUpstream) {
                    var result = this._applyTransform(upSourceMgrList);
                    resultSourceList = result.sourceList;
                    upstreamSignList = result.upstreamSignList;
                } else {
                    var sourceData = datasetModel.get('source', true);
                    resultSourceList = [
                        (0, (0, parcelRequire("20liu")).createSource)(sourceData, this._getSourceMetaRawOption(), null)
                    ];
                    upstreamSignList = [];
                }
            }
            this._setLocalSource(resultSourceList, upstreamSignList);
        };
        SourceManager.prototype._applyTransform = function(upMgrList) {
            var datasetModel = this._sourceHost;
            var transformOption = datasetModel.get('transform', true);
            var fromTransformResult = datasetModel.get('fromTransformResult', true);
            if (fromTransformResult != null) {
                var errMsg = '';
                if (upMgrList.length !== 1) $e7c9e4985e212cda$var$doThrow(errMsg);
            }
            var sourceList;
            var upSourceList = [];
            var upstreamSignList = [];
            (0, (0, parcelRequire("bahqM")).each)(upMgrList, function(upMgr) {
                upMgr.prepareSource();
                var upSource = upMgr.getSource(fromTransformResult || 0);
                var errMsg = '';
                if (fromTransformResult != null && !upSource) $e7c9e4985e212cda$var$doThrow(errMsg);
                upSourceList.push(upSource);
                upstreamSignList.push(upMgr._getVersionSign());
            });
            if (transformOption) sourceList = (0, (0, parcelRequire("05ab4")).applyDataTransform)(transformOption, upSourceList, {
                datasetIndex: datasetModel.componentIndex
            });
            else if (fromTransformResult != null) sourceList = [
                (0, (0, parcelRequire("20liu")).cloneSourceShallow)(upSourceList[0])
            ];
            return {
                sourceList: sourceList,
                upstreamSignList: upstreamSignList
            };
        };
        SourceManager.prototype._isDirty = function() {
            if (this._dirty) return true;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            for(var i = 0; i < upSourceMgrList.length; i++){
                var upSrcMgr = upSourceMgrList[i];
                if (upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
            }
        };
        SourceManager.prototype.getSource = function(sourceIndex) {
            sourceIndex = sourceIndex || 0;
            var source = this._sourceList[sourceIndex];
            if (!source) {
                var upSourceMgrList = this._getUpstreamSourceManagers();
                return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
            }
            return source;
        };
        SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
            var schema = seriesDimRequest.makeStoreSchema();
            return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
        };
        SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
            var sourceIndex = 0;
            var storeList = this._storeList;
            var cachedStoreMap = storeList[sourceIndex];
            if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
            var cachedStore = cachedStoreMap[sourceReadKey];
            if (!cachedStore) {
                var upSourceMgr = this._getUpstreamSourceManagers()[0];
                if ($e7c9e4985e212cda$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
                else {
                    cachedStore = new (0, (0, parcelRequire("8c3gC")).default)();
                    cachedStore.initData(new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
                }
                cachedStoreMap[sourceReadKey] = cachedStore;
            }
            return cachedStore;
        };
        SourceManager.prototype._getUpstreamSourceManagers = function() {
            var sourceHost = this._sourceHost;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var datasetModel = (0, (0, parcelRequire("cNGs8")).querySeriesUpstreamDatasetModel)(sourceHost);
                return !datasetModel ? [] : [
                    datasetModel.getSourceManager()
                ];
            } else return (0, (0, parcelRequire("bahqM")).map)((0, (0, parcelRequire("cNGs8")).queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
                return datasetModel.getSourceManager();
            });
        };
        SourceManager.prototype._getSourceMetaRawOption = function() {
            var sourceHost = this._sourceHost;
            var seriesLayoutBy;
            var sourceHeader;
            var dimensions;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
                sourceHeader = sourceHost.get('sourceHeader', true);
                dimensions = sourceHost.get('dimensions', true);
            } else if (!this._getUpstreamSourceManagers().length) {
                var model = sourceHost;
                seriesLayoutBy = model.get('seriesLayoutBy', true);
                sourceHeader = model.get('sourceHeader', true);
                dimensions = model.get('dimensions', true);
            }
            return {
                seriesLayoutBy: seriesLayoutBy,
                sourceHeader: sourceHeader,
                dimensions: dimensions
            };
        };
        return SourceManager;
    }();
    function $e7c9e4985e212cda$export$9451f4e9047441ec(datasetModel) {
        var transformOption = datasetModel.option.transform;
        transformOption && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(datasetModel.option.transform);
    }
    function $e7c9e4985e212cda$var$isSeries(sourceHost) {
        return sourceHost.mainType === 'series';
    }
    function $e7c9e4985e212cda$var$doThrow(errMsg) {
        throw new Error(errMsg);
    }
});
parcelRegister("05ab4", function(module, exports) {
    $parcel$export(module.exports, "registerExternalTransform", ()=>$00f85ccb3288f539$export$92c96c6d8b255b7d);
    $parcel$export(module.exports, "applyDataTransform", ()=>$00f85ccb3288f539$export$42a68f09db16803f);
    var $2Rbm1;
    var $eaKsF;
    var $bahqM;
    var $9OHWG;
    var $2G90t;
    var $2cFRc;
    var $20liu;
    var $00f85ccb3288f539$export$ffc19e40a21f08eb = function() {
        function ExternalSource() {}
        ExternalSource.prototype.getRawData = function() {
            throw new Error('not supported');
        };
        ExternalSource.prototype.getRawDataItem = function(dataIndex) {
            throw new Error('not supported');
        };
        ExternalSource.prototype.cloneRawData = function() {
            return;
        };
        ExternalSource.prototype.getDimensionInfo = function(dim) {
            return;
        };
        ExternalSource.prototype.cloneAllDimensionInfo = function() {
            return;
        };
        ExternalSource.prototype.count = function() {
            return;
        };
        ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
            return;
        };
        ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
            return;
        };
        ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(rawVal, dimInfo);
        };
        return ExternalSource;
    }();
    function $00f85ccb3288f539$var$createExternalSource(internalSource, externalTransform) {
        var extSource = new $00f85ccb3288f539$export$ffc19e40a21f08eb();
        var data = internalSource.data;
        var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
        var sourceHeaderCount = internalSource.startIndex;
        var errMsg = '';
        if (internalSource.seriesLayoutBy !== (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var dimensions = [];
        var dimsByName = {};
        var dimsDef = internalSource.dimensionsDefine;
        if (dimsDef) (0, (0, parcelRequire("bahqM")).each)(dimsDef, function(dimDef, idx) {
            var name = dimDef.name;
            var dimDefExt = {
                index: idx,
                name: name,
                displayName: dimDef.displayName
            };
            dimensions.push(dimDefExt);
            if (name != null) {
                var errMsg_1 = '';
                if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, name)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg_1);
                dimsByName[name] = dimDefExt;
            }
        });
        else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)dimensions.push({
            index: i
        });
        var rawItemGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceItemGetter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        if (externalTransform.__isBuiltIn) {
            extSource.getRawDataItem = function(dataIndex) {
                return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            };
            extSource.getRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getRawData, null, internalSource);
        }
        extSource.cloneRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneRawData, null, internalSource);
        var rawCounter = (0, (0, parcelRequire("9OHWG")).getRawSourceDataCounter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        extSource.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
        var rawValueGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceValueGetter)(sourceFormat);
        extSource.retrieveValue = function(dataIndex, dimIndex) {
            var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            return retrieveValueFromItem(rawItem, dimIndex);
        };
        var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
            if (dataItem == null) return;
            var dimDef = dimensions[dimIndex];
            if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
        };
        extSource.getDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getDimensionInfo, null, dimensions, dimsByName);
        extSource.cloneAllDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneAllDimensionInfo, null, dimensions);
        return extSource;
    }
    function $00f85ccb3288f539$var$getRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        return upstream.data;
    }
    function $00f85ccb3288f539$var$cloneRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        var data = upstream.data;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push(data[i].slice());
            return result;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push((0, (0, parcelRequire("bahqM")).extend)({}, data[i]));
            return result;
        }
    }
    function $00f85ccb3288f539$var$getDimensionInfo(dimensions, dimsByName, dim) {
        if (dim == null) return;
        if (typeof dim === 'number' || !isNaN(dim) && !(0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimensions[dim];
        else if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimsByName[dim];
    }
    function $00f85ccb3288f539$var$cloneAllDimensionInfo(dimensions) {
        return (0, (0, parcelRequire("bahqM")).clone)(dimensions);
    }
    var $00f85ccb3288f539$var$externalTransformMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $00f85ccb3288f539$export$92c96c6d8b255b7d(externalTransform) {
        externalTransform = (0, (0, parcelRequire("bahqM")).clone)(externalTransform);
        var type = externalTransform.type;
        var errMsg = '';
        if (!type) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var typeParsed = type.split(':');
        if (typeParsed.length !== 2) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var isBuiltIn = false;
        if (typeParsed[0] === 'echarts') {
            type = typeParsed[1];
            isBuiltIn = true;
        }
        externalTransform.__isBuiltIn = isBuiltIn;
        $00f85ccb3288f539$var$externalTransformMap.set(type, externalTransform);
    }
    function $00f85ccb3288f539$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
        var pipedTransOption = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawTransOption);
        var pipeLen = pipedTransOption.length;
        var errMsg = '';
        if (!pipeLen) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        for(var i = 0, len = pipeLen; i < len; i++){
            var transOption = pipedTransOption[i];
            sourceList = $00f85ccb3288f539$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
            if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
        }
        return sourceList;
    }
    function $00f85ccb3288f539$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
        var errMsg = '';
        if (!upSourceList.length) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        if (!(0, (0, parcelRequire("bahqM")).isObject)(transOption)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var transType = transOption.type;
        var externalTransform = $00f85ccb3288f539$var$externalTransformMap.get(transType);
        if (!externalTransform) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var extUpSourceList = (0, (0, parcelRequire("bahqM")).map)(upSourceList, function(upSource) {
            return $00f85ccb3288f539$var$createExternalSource(upSource, externalTransform);
        });
        var resultList = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(externalTransform.transform({
            upstream: extUpSourceList[0],
            upstreamList: extUpSourceList,
            config: (0, (0, parcelRequire("bahqM")).clone)(transOption.config)
        }));
        var printStrArr;
        return (0, (0, parcelRequire("bahqM")).map)(resultList, function(result, resultIndex) {
            var errMsg = '';
            if (!(0, (0, parcelRequire("bahqM")).isObject)(result)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            if (!result.data) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var sourceFormat = (0, (0, parcelRequire("20liu")).detectSourceFormat)(result.data);
            if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var resultMetaRawOption;
            var firstUpSource = upSourceList[0];
            if (firstUpSource && resultIndex === 0 && !result.dimensions) {
                var startIndex = firstUpSource.startIndex;
                if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
                resultMetaRawOption = {
                    seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                    sourceHeader: startIndex,
                    dimensions: firstUpSource.metaRawOption.dimensions
                };
            } else resultMetaRawOption = {
                seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: 0,
                dimensions: result.dimensions
            };
            return (0, (0, parcelRequire("20liu")).createSource)(result.data, resultMetaRawOption, null);
        });
    }
    function $00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
    }
});
parcelRegister("d88IV", function(module, exports) {
    $parcel$export(module.exports, "defaultSeriesFormatTooltip", ()=>$98f2ca07d9209b02$export$3a110b9fb5c88b34);
    var $bahqM;
    var $j5lKL;
    var $9OHWG;
    var $eaKsF;
    function $98f2ca07d9209b02$export$3a110b9fb5c88b34(opt) {
        var series = opt.series;
        var dataIndex = opt.dataIndex;
        var multipleSeries = opt.multipleSeries;
        var data = series.getData();
        var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
        var tooltipDimLen = tooltipDims.length;
        var value = series.getRawValue(dataIndex);
        var isValueArr = (0, (0, parcelRequire("bahqM")).isArray)(value);
        var markerColor = (0, (0, parcelRequire("j5lKL")).retrieveVisualColorForTooltipMarker)(series, dataIndex);
        var inlineValue;
        var inlineValueType;
        var subBlocks;
        var sortParam;
        if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
            var formatArrResult = $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
            inlineValue = formatArrResult.inlineValues;
            inlineValueType = formatArrResult.inlineValueTypes;
            subBlocks = formatArrResult.blocks;
            sortParam = formatArrResult.inlineValues[0];
        } else if (tooltipDimLen) {
            var dimInfo = data.getDimensionInfo(tooltipDims[0]);
            sortParam = inlineValue = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, tooltipDims[0]);
            inlineValueType = dimInfo.type;
        } else sortParam = inlineValue = isValueArr ? value[0] : value;
        var seriesNameSpecified = (0, (0, parcelRequire("eaKsF")).isNameSpecified)(series);
        var seriesName = seriesNameSpecified && series.name || '';
        var itemName = data.getName(dataIndex);
        var inlineName = multipleSeries ? seriesName : itemName;
        return (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
            header: seriesName,
            noHeader: multipleSeries || !seriesNameSpecified,
            sortParam: sortParam,
            blocks: [
                (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                    markerType: 'item',
                    markerColor: markerColor,
                    name: inlineName,
                    noName: !(0, (0, parcelRequire("bahqM")).trim)(inlineName),
                    value: inlineValue,
                    valueType: inlineValueType
                })
            ].concat(subBlocks || [])
        });
    }
    function $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
        var data = series.getData();
        var isValueMultipleLine = (0, (0, parcelRequire("bahqM")).reduce)(value, function(isValueMultipleLine, val, idx) {
            var dimItem = data.getDimensionInfo(idx);
            return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
        }, false);
        var inlineValues = [];
        var inlineValueTypes = [];
        var blocks = [];
        tooltipDims.length ? (0, (0, parcelRequire("bahqM")).each)(tooltipDims, function(dim) {
            setEachItem((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dim), dim);
        }) : (0, (0, parcelRequire("bahqM")).each)(value, setEachItem);
        function setEachItem(val, dim) {
            var dimInfo = data.getDimensionInfo(dim);
            if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
            if (isValueMultipleLine) blocks.push((0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                markerType: 'subItem',
                markerColor: colorStr,
                name: dimInfo.displayName,
                value: val,
                valueType: dimInfo.type
            }));
            else {
                inlineValues.push(val);
                inlineValueTypes.push(dimInfo.type);
            }
        }
        return {
            inlineValues: inlineValues,
            inlineValueTypes: inlineValueTypes,
            blocks: blocks
        };
    }
});
parcelRegister("j5lKL", function(module, exports) {
    $parcel$export(module.exports, "createTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$cf63b23ce77d1921);
    $parcel$export(module.exports, "buildTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$6969ffb02c1cb49a);
    $parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", ()=>$de4f5bb7bbbcf45e$export$ea15628039c0fa93);
    $parcel$export(module.exports, "getPaddingFromTooltipModel", ()=>$de4f5bb7bbbcf45e$export$3048212c802df496);
    $parcel$export(module.exports, "TooltipMarkupStyleCreator", ()=>$de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18);
    var $dCJrM;
    var $bahqM;
    var $2G90t;
    var $jmSNG;
    var $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
    function $de4f5bb7bbbcf45e$var$getTooltipTextStyle(textStyle, renderMode) {
        var nameFontColor = textStyle.color || '#6e7079';
        var nameFontSize = textStyle.fontSize || 12;
        var nameFontWeight = textStyle.fontWeight || '400';
        var valueFontColor = textStyle.color || '#464646';
        var valueFontSize = textStyle.fontSize || 14;
        var valueFontWeight = textStyle.fontWeight || '900';
        if (renderMode === 'html') return {
            nameStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontWeight + ''),
            valueStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontWeight + '')
        };
        else return {
            nameStyle: {
                fontSize: nameFontSize,
                fill: nameFontColor,
                fontWeight: nameFontWeight
            },
            valueStyle: {
                fontSize: valueFontSize,
                fill: valueFontColor,
                fontWeight: valueFontWeight
            }
        };
    }
    var $de4f5bb7bbbcf45e$var$HTML_GAPS = [
        0,
        10,
        20,
        30
    ];
    var $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS = [
        '',
        '\n',
        '\n\n',
        '\n\n\n'
    ];
    function $de4f5bb7bbbcf45e$export$cf63b23ce77d1921(type, option) {
        option.type = type;
        return option;
    }
    function $de4f5bb7bbbcf45e$var$getBuilder(fragment) {
        return (0, (0, parcelRequire("bahqM")).hasOwn)($de4f5bb7bbbcf45e$var$builderMap, fragment.type) && $de4f5bb7bbbcf45e$var$builderMap[fragment.type];
    }
    var $de4f5bb7bbbcf45e$var$builderMap = {
        section: {
            planLayout: function(fragment) {
                var subBlockLen = fragment.blocks.length;
                var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
                var thisGapLevelBetweenSubBlocks = 0;
                (0, (0, parcelRequire("bahqM")).each)(fragment.blocks, function(subBlock) {
                    $de4f5bb7bbbcf45e$var$getBuilder(subBlock).planLayout(subBlock);
                    var subGapLevel = subBlock.__gapLevelBetweenSubBlocks;
                    if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
                });
                fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var noHeader = fragment.noHeader;
                var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
                var subMarkupText = $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
                if (noHeader) return subMarkupText;
                var displayableHeader = (0, (0, parcelRequire("dCJrM")).makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
                var nameStyle = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
                if (ctx.renderMode === 'richText') return $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
                else return $de4f5bb7bbbcf45e$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
            }
        },
        nameValue: {
            planLayout: function(fragment) {
                fragment.__gapLevelBetweenSubBlocks = 0;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var renderMode = ctx.renderMode;
                var noName = fragment.noName;
                var noValue = fragment.noValue;
                var noMarker = !fragment.markerType;
                var name = fragment.name;
                var value = fragment.value;
                var useUTC = ctx.useUTC;
                if (noName && noValue) return;
                var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
                var readableName = noName ? '' : (0, (0, parcelRequire("dCJrM")).makeValueReadable)(name, 'ordinal', useUTC);
                var valueTypeOption = fragment.valueType;
                var readableValueList = noValue ? [] : (0, (0, parcelRequire("bahqM")).isArray)(value) ? (0, (0, parcelRequire("bahqM")).map)(value, function(val, idx) {
                    return (0, (0, parcelRequire("dCJrM")).makeValueReadable)(val, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
                }) : [
                    (0, (0, parcelRequire("dCJrM")).makeValueReadable)(value, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
                ];
                var valueAlignRight = !noMarker || !noName;
                var valueCloseToMarker = !noMarker && noName;
                var _a = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
                return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $de4f5bb7bbbcf45e$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
            }
        }
    };
    function $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
        var subMarkupTextList = [];
        var subBlocks = fragment.blocks || [];
        (0, (0, parcelRequire("bahqM")).assert)(!subBlocks || (0, (0, parcelRequire("bahqM")).isArray)(subBlocks));
        subBlocks = subBlocks || [];
        var orderMode = ctx.orderMode;
        if (fragment.sortBlocks && orderMode) {
            subBlocks = subBlocks.slice();
            var orderMap = {
                valueAsc: 'asc',
                valueDesc: 'desc'
            };
            if ((0, (0, parcelRequire("bahqM")).hasOwn)(orderMap, orderMode)) {
                var comparator_1 = new (0, (0, parcelRequire("2G90t")).SortOrderComparator)(orderMap[orderMode], null);
                subBlocks.sort(function(a, b) {
                    return comparator_1.evaluate(a.sortParam, b.sortParam);
                });
            } else if (orderMode === 'seriesDesc') subBlocks.reverse();
        }
        var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
        (0, (0, parcelRequire("bahqM")).each)(subBlocks, function(subBlock, idx) {
            var subMarkupText = $de4f5bb7bbbcf45e$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
            subMarkupText != null && subMarkupTextList.push(subMarkupText);
        });
        if (!subMarkupTextList.length) return;
        return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $de4f5bb7bbbcf45e$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
    }
    function $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
        if (!fragment) return;
        var builder = $de4f5bb7bbbcf45e$var$getBuilder(fragment);
        builder.planLayout(fragment);
        var ctx = {
            useUTC: useUTC,
            renderMode: renderMode,
            orderMode: orderMode,
            markupStyleCreator: markupStyleCreator
        };
        return builder.build(ctx, fragment, 0, toolTipTextStyle);
    }
    function $de4f5bb7bbbcf45e$var$getGap(fragment) {
        var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
        return {
            html: $de4f5bb7bbbcf45e$var$HTML_GAPS[gapLevelBetweenSubBlocks],
            richText: $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
        };
    }
    function $de4f5bb7bbbcf45e$var$wrapBlockHTML(encodedContent, topGap) {
        var clearfix = '<div style="clear:both"></div>';
        var marginCSS = "margin: " + topGap + "px 0 0";
        return "<div style=\"" + marginCSS + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(name, leftHasMarker, style) {
        var marginCss = leftHasMarker ? 'margin-left:2px' : '';
        return "<span style=\"" + style + ";" + marginCss + "\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(name) + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
        var paddingStr = valueCloseToMarker ? '10px' : '20px';
        var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
        return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, (0, parcelRequire("bahqM")).map)(valueList, function(value) {
            return (0, (0, parcelRequire("dCJrM")).encodeHTML)(value);
        }).join('&nbsp;&nbsp;') + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, name, style) {
        return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
        var styles = [
            style
        ];
        var paddingLeft = valueCloseToMarker ? 10 : 20;
        alignRight && styles.push({
            padding: [
                0,
                0,
                0,
                paddingLeft
            ],
            align: 'right'
        });
        return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
    }
    function $de4f5bb7bbbcf45e$export$ea15628039c0fa93(series, dataIndex) {
        var style = series.getData().getItemVisual(dataIndex, 'style');
        var color = style[series.visualDrawType];
        return (0, (0, parcelRequire("dCJrM")).convertToColorString)(color);
    }
    function $de4f5bb7bbbcf45e$export$3048212c802df496(model, renderMode) {
        var padding = model.get('padding');
        return padding != null ? padding : renderMode === 'richText' ? [
            8,
            10
        ] : 10;
    }
    var $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18 = function() {
        function TooltipMarkupStyleCreator() {
            this.richTextStyles = {};
            this._nextStyleNameId = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
        }
        TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
            return '__EC_aUTo_' + this._nextStyleNameId++;
        };
        TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
            var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
            var marker = (0, (0, parcelRequire("dCJrM")).getTooltipMarker)({
                color: colorStr,
                type: markerType,
                renderMode: renderMode,
                markerId: markerId
            });
            if ((0, (0, parcelRequire("bahqM")).isString)(marker)) return marker;
            else {
                this.richTextStyles[markerId] = marker.style;
                return marker.content;
            }
        };
        TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
            var finalStl = {};
            if ((0, (0, parcelRequire("bahqM")).isArray)(styles)) (0, (0, parcelRequire("bahqM")).each)(styles, function(stl) {
                return (0, (0, parcelRequire("bahqM")).extend)(finalStl, stl);
            });
            else (0, (0, parcelRequire("bahqM")).extend)(finalStl, styles);
            var styleName = this._generateStyleName();
            this.richTextStyles[styleName] = finalStl;
            return "{" + styleName + "|" + text + "}";
        };
        return TooltipMarkupStyleCreator;
    }();
});
parcelRegister("7yklO", function(module, exports) {
    $parcel$export(module.exports, "symbolBuildProxies", ()=>$57fb7e9c020cd915$export$33fc3b478d332725);
    $parcel$export(module.exports, "createSymbol", ()=>$57fb7e9c020cd915$export$af050e04da3a02e8);
    $parcel$export(module.exports, "normalizeSymbolSize", ()=>$57fb7e9c020cd915$export$a84524f03e8e8dfb);
    $parcel$export(module.exports, "normalizeSymbolOffset", ()=>$57fb7e9c020cd915$export$e3e292895c033f6d);
    var $bahqM;
    parcelRequire("fHITF");
    var $jjfok;
    var $cZb1F;
    var $fHITF;
    var $ghQ8v;
    var $7Tw7u;
    var $1E3E8;
    var $b7ZX8;
    var $jmSNG;
    var $57fb7e9c020cd915$var$Triangle = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'triangle',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy + height);
            path.lineTo(cx - width, cy + height);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Diamond = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'diamond',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy);
            path.lineTo(cx, cy + height);
            path.lineTo(cx - width, cy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Pin = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'pin',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var x = shape.x;
            var y = shape.y;
            var w = shape.width / 5 * 3;
            var h = Math.max(w, shape.height);
            var r = w / 2;
            var dy = r * r / (h - r);
            var cy = y - h + r + dy;
            var angle = Math.asin(dy / r);
            var dx = Math.cos(angle) * r;
            var tanX = Math.sin(angle);
            var tanY = Math.cos(angle);
            var cpLen = r * 0.6;
            var cpLen2 = r * 0.7;
            path.moveTo(x - dx, cy + dy);
            path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
            path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
            path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Arrow = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'arrow',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(ctx, shape) {
            var height = shape.height;
            var width = shape.width;
            var x = shape.x;
            var y = shape.y;
            var dx = width / 3 * 2;
            ctx.moveTo(x, y);
            ctx.lineTo(x + dx, y + height);
            ctx.lineTo(x, y + height / 4 * 3);
            ctx.lineTo(x - dx, y + height);
            ctx.lineTo(x, y);
            ctx.closePath();
        }
    });
    var $57fb7e9c020cd915$var$symbolCtors = {
        line: (0, parcelRequire("cZb1F")).default,
        rect: (0, parcelRequire("7Tw7u")).default,
        roundRect: (0, parcelRequire("7Tw7u")).default,
        square: (0, parcelRequire("7Tw7u")).default,
        circle: (0, parcelRequire("jjfok")).default,
        diamond: $57fb7e9c020cd915$var$Diamond,
        pin: $57fb7e9c020cd915$var$Pin,
        arrow: $57fb7e9c020cd915$var$Arrow,
        triangle: $57fb7e9c020cd915$var$Triangle
    };
    var $57fb7e9c020cd915$var$symbolShapeMakers = {
        line: function(x, y, w, h, shape) {
            shape.x1 = x;
            shape.y1 = y + h / 2;
            shape.x2 = x + w;
            shape.y2 = y + h / 2;
        },
        rect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
        },
        roundRect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
            shape.r = Math.min(w, h) / 4;
        },
        square: function(x, y, w, h, shape) {
            var size = Math.min(w, h);
            shape.x = x;
            shape.y = y;
            shape.width = size;
            shape.height = size;
        },
        circle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.r = Math.min(w, h) / 2;
        },
        diamond: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        pin: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        arrow: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        triangle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        }
    };
    var $57fb7e9c020cd915$export$33fc3b478d332725 = {};
    (0, (0, parcelRequire("bahqM")).each)($57fb7e9c020cd915$var$symbolCtors, function(Ctor, name) {
        $57fb7e9c020cd915$export$33fc3b478d332725[name] = new Ctor();
    });
    var $57fb7e9c020cd915$var$SymbolClz = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'symbol',
        shape: {
            symbolType: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        calculateTextPosition: function(out, config, rect) {
            var res = (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, config, rect);
            var shape = this.shape;
            if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
            return res;
        },
        buildPath: function(ctx, shape, inBundle) {
            var symbolType = shape.symbolType;
            if (symbolType !== 'none') {
                var proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                if (!proxySymbol) {
                    symbolType = 'rect';
                    proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                }
                $57fb7e9c020cd915$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
                proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
            }
        }
    });
    function $57fb7e9c020cd915$var$symbolPathSetColor(color, innerColor) {
        if (this.type !== 'image') {
            var symbolStyle = this.style;
            if (this.__isEmptyBrush) {
                symbolStyle.stroke = color;
                symbolStyle.fill = innerColor || '#fff';
                symbolStyle.lineWidth = 2;
            } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
            else symbolStyle.fill = color;
            this.markRedraw();
        }
    }
    function $57fb7e9c020cd915$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
        var isEmpty = symbolType.indexOf('empty') === 0;
        if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
        var symbolPath;
        if (symbolType.indexOf('image://') === 0) symbolPath = (0, parcelRequire("fHITF")).makeImage(symbolType.slice(8), new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else if (symbolType.indexOf('path://') === 0) symbolPath = (0, parcelRequire("fHITF")).makePath(symbolType.slice(7), {}, new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else symbolPath = new $57fb7e9c020cd915$var$SymbolClz({
            shape: {
                symbolType: symbolType,
                x: x,
                y: y,
                width: w,
                height: h
            }
        });
        symbolPath.__isEmptyBrush = isEmpty;
        symbolPath.setColor = $57fb7e9c020cd915$var$symbolPathSetColor;
        if (color) symbolPath.setColor(color);
        return symbolPath;
    }
    function $57fb7e9c020cd915$export$a84524f03e8e8dfb(symbolSize) {
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolSize)) symbolSize = [
            +symbolSize,
            +symbolSize
        ];
        return [
            symbolSize[0] || 0,
            symbolSize[1] || 0
        ];
    }
    function $57fb7e9c020cd915$export$e3e292895c033f6d(symbolOffset, symbolSize) {
        if (symbolOffset == null) return;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        return [
            (0, (0, parcelRequire("jmSNG")).parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
            (0, (0, parcelRequire("jmSNG")).parsePercent)((0, (0, parcelRequire("bahqM")).retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
        ];
    }
});
parcelRegister("cDBtZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$933633d411d7f701$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $5DXGq;
    var $lUzII;
    var $7HTYE;
    var $4KVOr;
    var $eYgMC;
    var $9J7f8;
    var $4gEFv;
    parcelRequire("fHITF");
    var $eYgMC;
    var $eaKsF;
    var $jconq;
    var $loerw;
    var $JBb7Y;
    var $5fMzf;
    var $40dMe;
    var $fIXXx;
    var $gvLUt;
    var $5MLZz;
    var $7QjoM;
    var $8fK8Y;
    var $dCJrM;
    var $d6udH;
    function $933633d411d7f701$var$isPointsSame(points1, points2) {
        if (points1.length !== points2.length) return;
        for(var i = 0; i < points1.length; i++){
            if (points1[i] !== points2[i]) return;
        }
        return true;
    }
    function $933633d411d7f701$var$bboxFromPoints(points) {
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (!isNaN(x)) {
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
            }
            if (!isNaN(y)) {
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
        }
        return [
            [
                minX,
                minY
            ],
            [
                maxX,
                maxY
            ]
        ];
    }
    function $933633d411d7f701$var$getBoundingDiff(points1, points2) {
        var _a = $933633d411d7f701$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
        var _b = $933633d411d7f701$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
        return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
    }
    function $933633d411d7f701$var$getSmooth(smooth) {
        return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
    }
    function $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
        if (!dataCoordInfo.valueDim) return [];
        var len = data.count();
        var points = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len * 2);
        for(var idx = 0; idx < len; idx++){
            var pt = (0, (0, parcelRequire("JBb7Y")).getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
            points[idx * 2] = pt[0];
            points[idx * 2 + 1] = pt[1];
        }
        return points;
    }
    function $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
        var baseAxis = coordSys.getBaseAxis();
        var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
        var stepPoints = [];
        var i = 0;
        var stepPt = [];
        var pt = [];
        var nextPt = [];
        for(; i < points.length - 2; i += 2){
            nextPt[0] = points[i + 2];
            nextPt[1] = points[i + 3];
            pt[0] = points[i];
            pt[1] = points[i + 1];
            stepPoints.push(pt[0], pt[1]);
            switch(stepTurnAt){
                case 'end':
                    stepPt[baseIndex] = nextPt[baseIndex];
                    stepPt[1 - baseIndex] = pt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
                    break;
                case 'middle':
                    var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                    var stepPt2 = [];
                    stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                    stepPt[1 - baseIndex] = pt[1 - baseIndex];
                    stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
                    stepPoints.push(stepPt2[0], stepPt2[1]);
                    break;
                default:
                    stepPt[baseIndex] = pt[baseIndex];
                    stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                    stepPoints.push(stepPt[0], stepPt[1]);
            }
        }
        stepPoints.push(points[i++], points[i++]);
        return stepPoints;
    }
    function $933633d411d7f701$var$clipColorStops(colorStops, maxSize) {
        var newColorStops = [];
        var len = colorStops.length;
        var prevOutOfRangeColorStop;
        var prevInRangeColorStop;
        function lerpStop(stop0, stop1, clippedCoord) {
            var coord0 = stop0.coord;
            var p = (clippedCoord - coord0) / (stop1.coord - coord0);
            var color = (0, (0, parcelRequire("d6udH")).lerp)(p, [
                stop0.color,
                stop1.color
            ]);
            return {
                coord: clippedCoord,
                color: color
            };
        }
        for(var i = 0; i < len; i++){
            var stop_1 = colorStops[i];
            var coord = stop_1.coord;
            if (coord < 0) prevOutOfRangeColorStop = stop_1;
            else if (coord > maxSize) {
                if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
                break;
            } else {
                if (prevOutOfRangeColorStop) {
                    newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                    prevOutOfRangeColorStop = null;
                }
                newColorStops.push(stop_1);
                prevInRangeColorStop = stop_1;
            }
        }
        return newColorStops;
    }
    function $933633d411d7f701$var$getVisualGradient(data, coordSys, api) {
        var visualMetaList = data.getVisual('visualMeta');
        if (!visualMetaList || !visualMetaList.length || !data.count()) return;
        if (coordSys.type !== 'cartesian2d') return;
        var coordDim;
        var visualMeta;
        for(var i = visualMetaList.length - 1; i >= 0; i--){
            var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
            coordDim = dimInfo && dimInfo.coordDim;
            if (coordDim === 'x' || coordDim === 'y') {
                visualMeta = visualMetaList[i];
                break;
            }
        }
        if (!visualMeta) return;
        var axis = coordSys.getAxis(coordDim);
        var colorStops = (0, parcelRequire("bahqM")).map(visualMeta.stops, function(stop) {
            return {
                coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
                color: stop.color
            };
        });
        var stopLen = colorStops.length;
        var outerColors = visualMeta.outerColors.slice();
        if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
            colorStops.reverse();
            outerColors.reverse();
        }
        var colorStopsInRange = $933633d411d7f701$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
        var inRangeStopLen = colorStopsInRange.length;
        if (!inRangeStopLen && stopLen) return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
        var tinyExtent = 0;
        var minCoord = colorStopsInRange[0].coord - tinyExtent;
        var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
        var coordSpan = maxCoord - minCoord;
        if (coordSpan < 1e-3) return 'transparent';
        (0, parcelRequire("bahqM")).each(colorStopsInRange, function(stop) {
            stop.offset = (stop.coord - minCoord) / coordSpan;
        });
        colorStopsInRange.push({
            offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
            color: outerColors[1] || 'transparent'
        });
        colorStopsInRange.unshift({
            offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
            color: outerColors[0] || 'transparent'
        });
        var gradient = new (0, parcelRequire("9J7f8")).default(0, 0, 0, 0, colorStopsInRange, true);
        gradient[coordDim] = minCoord;
        gradient[coordDim + '2'] = maxCoord;
        return gradient;
    }
    function $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
        var showAllSymbol = seriesModel.get('showAllSymbol');
        var isAuto = showAllSymbol === 'auto';
        if (showAllSymbol && !isAuto) return;
        var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
        if (!categoryAxis) return;
        if (isAuto && $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
        var categoryDataDim = data.mapDimension(categoryAxis.dim);
        var labelMap = {};
        (0, parcelRequire("bahqM")).each(categoryAxis.getViewLabels(), function(labelItem) {
            var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
            labelMap[ordinalNumber] = 1;
        });
        return function(dataIndex) {
            return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
        };
    }
    function $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data) {
        var axisExtent = categoryAxis.getExtent();
        var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
        isNaN(availSize) && (availSize = 0);
        var dataLen = data.count();
        var step = Math.max(1, Math.round(dataLen / 5));
        for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
            if ((0, (0, parcelRequire("lUzII")).default).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
        }
        return true;
    }
    function $933633d411d7f701$var$isPointNull(x, y) {
        return isNaN(x) || isNaN(y);
    }
    function $933633d411d7f701$var$getLastIndexNotNull(points) {
        var len = points.length / 2;
        for(; len > 0; len--){
            if (!$933633d411d7f701$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
        }
        return len - 1;
    }
    function $933633d411d7f701$var$getPointAtIndex(points, idx) {
        return [
            points[idx * 2],
            points[idx * 2 + 1]
        ];
    }
    function $933633d411d7f701$var$getIndexRange(points, xOrY, dim) {
        var len = points.length / 2;
        var dimIdx = dim === 'x' ? 0 : 1;
        var a;
        var b;
        var prevIndex = 0;
        var nextIndex = -1;
        for(var i = 0; i < len; i++){
            b = points[i * 2 + dimIdx];
            if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
            if (i === 0) {
                a = b;
                continue;
            }
            if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
                nextIndex = i;
                break;
            }
            prevIndex = i;
            a = b;
        }
        return {
            range: [
                prevIndex,
                nextIndex
            ],
            t: (xOrY - a) / (b - a)
        };
    }
    function $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) {
        if (seriesModel.get([
            'endLabel',
            'show'
        ])) return true;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            if (seriesModel.get([
                (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i],
                'endLabel',
                'show'
            ])) return true;
        }
        return false;
    }
    function $933633d411d7f701$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            var endLabelModel_1 = seriesModel.getModel('endLabel');
            var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
            var data_1 = seriesModel.getData();
            var labelAnimationRecord_1 = {
                lastFrameIndex: 0
            };
            var during = $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
                lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
            } : null;
            var isHorizontal = coordSys.getBaseAxis().isHorizontal();
            var clipPath = (0, (0, parcelRequire("5fMzf")).createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
                var endLabel = lineView._endLabel;
                if (endLabel && hasAnimation) {
                    if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                        x: labelAnimationRecord_1.originalX,
                        y: labelAnimationRecord_1.originalY
                    });
                }
            }, during);
            if (!seriesModel.get('clip', true)) {
                var rectShape = clipPath.shape;
                var expandSize = Math.max(rectShape.width, rectShape.height);
                if (isHorizontal) {
                    rectShape.y -= expandSize;
                    rectShape.height += expandSize * 2;
                } else {
                    rectShape.x -= expandSize;
                    rectShape.width += expandSize * 2;
                }
            }
            if (during) during(1, clipPath);
            return clipPath;
        } else return (0, (0, parcelRequire("5fMzf")).createPolarClipPath)(coordSys, hasAnimation, seriesModel);
    }
    function $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
        var baseAxis = coordSys.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isBaseInversed = baseAxis.inverse;
        var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
        var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
        return {
            normal: {
                align: endLabelModel.get('align') || align,
                verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
            }
        };
    }
    var $933633d411d7f701$var$LineView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LineView, _super);
        function LineView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LineView.prototype.init = function() {
            var lineGroup = new (0, parcelRequire("4KVOr")).default();
            var symbolDraw = new (0, (0, parcelRequire("5DXGq")).default)();
            this.group.add(symbolDraw.group);
            this._symbolDraw = symbolDraw;
            this._lineGroup = lineGroup;
        };
        LineView.prototype.render = function(seriesModel, ecModel, api) {
            var _this = this;
            var coordSys = seriesModel.coordinateSystem;
            var group = this.group;
            var data = seriesModel.getData();
            var lineStyleModel = seriesModel.getModel('lineStyle');
            var areaStyleModel = seriesModel.getModel('areaStyle');
            var points = data.getLayout('points') || [];
            var isCoordSysPolar = coordSys.type === 'polar';
            var prevCoordSys = this._coordSys;
            var symbolDraw = this._symbolDraw;
            var polyline = this._polyline;
            var polygon = this._polygon;
            var lineGroup = this._lineGroup;
            var hasAnimation = seriesModel.get('animation');
            var isAreaChart = !areaStyleModel.isEmpty();
            var valueOrigin = areaStyleModel.get('origin');
            var dataCoordInfo = (0, (0, parcelRequire("JBb7Y")).prepareDataCoordInfo)(coordSys, data, valueOrigin);
            var stackedOnPoints = isAreaChart && $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
            var showSymbol = seriesModel.get('showSymbol');
            var isIgnoreFunc = showSymbol && !isCoordSysPolar && $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys);
            var oldData = this._data;
            oldData && oldData.eachItemGraphicEl(function(el, idx) {
                if (el.__temp) {
                    group.remove(el);
                    oldData.setItemGraphicEl(idx, null);
                }
            });
            if (!showSymbol) symbolDraw.remove();
            group.add(lineGroup);
            var step = !isCoordSysPolar ? seriesModel.get('step') : false;
            var clipShapeForSymbol;
            if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
                clipShapeForSymbol = coordSys.getArea();
                if (clipShapeForSymbol.width != null) {
                    clipShapeForSymbol.x -= 0.1;
                    clipShapeForSymbol.y -= 0.1;
                    clipShapeForSymbol.width += 0.2;
                    clipShapeForSymbol.height += 0.2;
                } else if (clipShapeForSymbol.r0) {
                    clipShapeForSymbol.r0 -= 0.5;
                    clipShapeForSymbol.r += 0.5;
                }
            }
            this._clipShapeForSymbol = clipShapeForSymbol;
            var visualColor = $933633d411d7f701$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
            if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
                showSymbol && symbolDraw.updateData(data, {
                    isIgnore: isIgnoreFunc,
                    clipShape: clipShapeForSymbol,
                    disableAnimation: true,
                    getSymbolPoint: function(idx) {
                        return [
                            points[idx * 2],
                            points[idx * 2 + 1]
                        ];
                    }
                });
                hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
                if (step) {
                    points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                    if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                }
                polyline = this._newPolyline(points);
                if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
                if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, (0, parcelRequire("dCJrM")).convertToColorString)(visualColor));
                lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
            } else {
                if (isAreaChart && !polygon) polygon = this._newPolygon(points, stackedOnPoints);
                else if (polygon && !isAreaChart) {
                    lineGroup.remove(polygon);
                    polygon = this._polygon = null;
                }
                if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, (0, parcelRequire("dCJrM")).convertToColorString)(visualColor));
                var oldClipPath = lineGroup.getClipPath();
                if (oldClipPath) {
                    var newClipPath = $933633d411d7f701$var$createLineClipPath(this, coordSys, false, seriesModel);
                    (0, parcelRequire("eYgMC")).initProps(oldClipPath, {
                        shape: newClipPath.shape
                    }, seriesModel);
                } else lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
                showSymbol && symbolDraw.updateData(data, {
                    isIgnore: isIgnoreFunc,
                    clipShape: clipShapeForSymbol,
                    disableAnimation: true,
                    getSymbolPoint: function(idx) {
                        return [
                            points[idx * 2],
                            points[idx * 2 + 1]
                        ];
                    }
                });
                if (!$933633d411d7f701$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$933633d411d7f701$var$isPointsSame(this._points, points)) {
                    if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                    else {
                        if (step) {
                            points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                            if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                        }
                        polyline.setShape({
                            points: points
                        });
                        polygon && polygon.setShape({
                            points: points,
                            stackedOnPoints: stackedOnPoints
                        });
                    }
                }
            }
            var focus = seriesModel.get([
                'emphasis',
                'focus'
            ]);
            var blurScope = seriesModel.get([
                'emphasis',
                'blurScope'
            ]);
            polyline.useStyle((0, parcelRequire("bahqM")).defaults(lineStyleModel.getLineStyle(), {
                fill: 'none',
                stroke: visualColor,
                lineJoin: 'bevel'
            }));
            (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
            if (polyline.style.lineWidth > 0 && seriesModel.get([
                'emphasis',
                'lineStyle',
                'width'
            ]) === 'bolder') {
                var emphasisLineStyle = polyline.getState('emphasis').style;
                emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
            }
            (0, (0, parcelRequire("7QjoM")).getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(polyline, focus, blurScope);
            var smooth = $933633d411d7f701$var$getSmooth(seriesModel.get('smooth'));
            var smoothMonotone = seriesModel.get('smoothMonotone');
            var connectNulls = seriesModel.get('connectNulls');
            polyline.setShape({
                smooth: smooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            if (polygon) {
                var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
                var stackedOnSmooth = 0;
                polygon.useStyle((0, parcelRequire("bahqM")).defaults(areaStyleModel.getAreaStyle(), {
                    fill: visualColor,
                    opacity: 0.7,
                    lineJoin: 'bevel',
                    decal: data.getVisual('style').decal
                }));
                if (stackedOnSeries) stackedOnSmooth = $933633d411d7f701$var$getSmooth(stackedOnSeries.get('smooth'));
                polygon.setShape({
                    smooth: smooth,
                    stackedOnSmooth: stackedOnSmooth,
                    smoothMonotone: smoothMonotone,
                    connectNulls: connectNulls
                });
                (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle');
                (0, (0, parcelRequire("7QjoM")).getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
                (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(polygon, focus, blurScope);
            }
            var changePolyState = function(toState) {
                _this._changePolyState(toState);
            };
            data.eachItemGraphicEl(function(el) {
                el && (el.onHoverStateChange = changePolyState);
            });
            this._polyline.onHoverStateChange = changePolyState;
            this._data = data;
            this._coordSys = coordSys;
            this._stackedOnPoints = stackedOnPoints;
            this._points = points;
            this._step = step;
            this._valueOrigin = valueOrigin;
        };
        LineView.prototype.dispose = function() {};
        LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
            var data = seriesModel.getData();
            var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
            this._changePolyState('emphasis');
            if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
                var points = data.getLayout('points');
                var symbol = data.getItemGraphicEl(dataIndex);
                if (!symbol) {
                    var x = points[dataIndex * 2];
                    var y = points[dataIndex * 2 + 1];
                    if (isNaN(x) || isNaN(y)) return;
                    if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                    var zlevel = seriesModel.get('zlevel');
                    var z = seriesModel.get('z');
                    symbol = new (0, (0, parcelRequire("lUzII")).default)(data, dataIndex);
                    symbol.x = x;
                    symbol.y = y;
                    symbol.setZ(zlevel, z);
                    var symbolLabel = symbol.getSymbolPath().getTextContent();
                    if (symbolLabel) {
                        symbolLabel.zlevel = zlevel;
                        symbolLabel.z = z;
                        symbolLabel.z2 = this._polyline.z2 + 1;
                    }
                    symbol.__temp = true;
                    data.setItemGraphicEl(dataIndex, symbol);
                    symbol.stopSymbolAnimation(true);
                    this.group.add(symbol);
                }
                symbol.highlight();
            } else (0, (0, parcelRequire("loerw")).default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
        };
        LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
            var data = seriesModel.getData();
            var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
            this._changePolyState('normal');
            if (dataIndex != null && dataIndex >= 0) {
                var symbol = data.getItemGraphicEl(dataIndex);
                if (symbol) {
                    if (symbol.__temp) {
                        data.setItemGraphicEl(dataIndex, null);
                        this.group.remove(symbol);
                    } else symbol.downplay();
                }
            } else (0, (0, parcelRequire("loerw")).default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
        };
        LineView.prototype._changePolyState = function(toState) {
            var polygon = this._polygon;
            (0, (0, parcelRequire("fIXXx")).setStatesFlag)(this._polyline, toState);
            polygon && (0, (0, parcelRequire("fIXXx")).setStatesFlag)(polygon, toState);
        };
        LineView.prototype._newPolyline = function(points) {
            var polyline = this._polyline;
            if (polyline) this._lineGroup.remove(polyline);
            polyline = new (0, (0, parcelRequire("jconq")).ECPolyline)({
                shape: {
                    points: points
                },
                segmentIgnoreThreshold: 2,
                z2: 10
            });
            this._lineGroup.add(polyline);
            this._polyline = polyline;
            return polyline;
        };
        LineView.prototype._newPolygon = function(points, stackedOnPoints) {
            var polygon = this._polygon;
            if (polygon) this._lineGroup.remove(polygon);
            polygon = new (0, (0, parcelRequire("jconq")).ECPolygon)({
                shape: {
                    points: points,
                    stackedOnPoints: stackedOnPoints
                },
                segmentIgnoreThreshold: 2
            });
            this._lineGroup.add(polygon);
            this._polygon = polygon;
            return polygon;
        };
        LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
            var isHorizontalOrRadial;
            var isCoordSysPolar;
            var baseAxis = coordSys.getBaseAxis();
            var isAxisInverse = baseAxis.inverse;
            if (coordSys.type === 'cartesian2d') {
                isHorizontalOrRadial = baseAxis.isHorizontal();
                isCoordSysPolar = false;
            } else if (coordSys.type === 'polar') {
                isHorizontalOrRadial = baseAxis.dim === 'angle';
                isCoordSysPolar = true;
            }
            var seriesModel = data.hostModel;
            var seriesDuration = seriesModel.get('animationDuration');
            if (typeof seriesDuration === 'function') seriesDuration = seriesDuration(null);
            var seriesDalay = seriesModel.get('animationDelay') || 0;
            var seriesDalayValue = typeof seriesDalay === 'function' ? seriesDalay(null) : seriesDalay;
            data.eachItemGraphicEl(function(symbol, idx) {
                var el = symbol;
                if (el) {
                    var point = [
                        symbol.x,
                        symbol.y
                    ];
                    var start = void 0;
                    var end = void 0;
                    var current = void 0;
                    if (clipShape) {
                        if (isCoordSysPolar) {
                            var polarClip = clipShape;
                            var coord = coordSys.pointToCoord(point);
                            if (isHorizontalOrRadial) {
                                start = polarClip.startAngle;
                                end = polarClip.endAngle;
                                current = -coord[1] / 180 * Math.PI;
                            } else {
                                start = polarClip.r0;
                                end = polarClip.r;
                                current = coord[0];
                            }
                        } else {
                            var gridClip = clipShape;
                            if (isHorizontalOrRadial) {
                                start = gridClip.x;
                                end = gridClip.x + gridClip.width;
                                current = symbol.x;
                            } else {
                                start = gridClip.y + gridClip.height;
                                end = gridClip.y;
                                current = symbol.y;
                            }
                        }
                    }
                    var ratio = end === start ? 0 : (current - start) / (end - start);
                    if (isAxisInverse) ratio = 1 - ratio;
                    var delay = typeof seriesDalay === 'function' ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
                    var symbolPath = el.getSymbolPath();
                    var text = symbolPath.getTextContent();
                    el.attr({
                        scaleX: 0,
                        scaleY: 0
                    });
                    el.animateTo({
                        scaleX: 1,
                        scaleY: 1
                    }, {
                        duration: 200,
                        setToFinal: true,
                        delay: delay
                    });
                    if (text) text.animateFrom({
                        style: {
                            opacity: 0
                        }
                    }, {
                        duration: 300,
                        delay: delay
                    });
                    symbolPath.disableLabelAnimation = true;
                }
            });
        };
        LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
            var endLabelModel = seriesModel.getModel('endLabel');
            if ($933633d411d7f701$var$anyStateShowEndLabel(seriesModel)) {
                var data_2 = seriesModel.getData();
                var polyline = this._polyline;
                var endLabel = this._endLabel;
                if (!endLabel) {
                    endLabel = this._endLabel = new (0, parcelRequire("4gEFv")).default({
                        z2: 200
                    });
                    endLabel.ignoreClip = true;
                    polyline.setTextContent(this._endLabel);
                    polyline.disableLabelAnimation = true;
                }
                var dataIndex = $933633d411d7f701$var$getLastIndexNotNull(data_2.getLayout('points'));
                if (dataIndex >= 0) {
                    (0, (0, parcelRequire("gvLUt")).setLabelStyle)(polyline, (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(seriesModel, 'endLabel'), {
                        inheritColor: inheritColor,
                        labelFetcher: seriesModel,
                        labelDataIndex: dataIndex,
                        defaultText: function(dataIndex, opt, interpolatedValue) {
                            return interpolatedValue != null ? (0, (0, parcelRequire("5MLZz")).getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(data_2, dataIndex);
                        },
                        enableTextSetter: true
                    }, $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                    polyline.textConfig.position = null;
                }
            } else if (this._endLabel) {
                this._polyline.removeTextContent();
                this._endLabel = null;
            }
        };
        LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
            var endLabel = this._endLabel;
            var polyline = this._polyline;
            if (endLabel) {
                if (percent < 1 && animationRecord.originalX == null) {
                    animationRecord.originalX = endLabel.x;
                    animationRecord.originalY = endLabel.y;
                }
                var points = data.getLayout('points');
                var seriesModel = data.hostModel;
                var connectNulls = seriesModel.get('connectNulls');
                var precision = endLabelModel.get('precision');
                var distance = endLabelModel.get('distance') || 0;
                var baseAxis = coordSys.getBaseAxis();
                var isHorizontal = baseAxis.isHorizontal();
                var isBaseInversed = baseAxis.inverse;
                var clipShape = clipRect.shape;
                var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
                var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
                var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
                var dim = isHorizontal ? 'x' : 'y';
                var dataIndexRange = $933633d411d7f701$var$getIndexRange(points, xOrY, dim);
                var indices = dataIndexRange.range;
                var diff = indices[1] - indices[0];
                var value = void 0;
                if (diff >= 1) {
                    if (diff > 1 && !connectNulls) {
                        var pt = $933633d411d7f701$var$getPointAtIndex(points, indices[0]);
                        endLabel.attr({
                            x: pt[0] + distanceX,
                            y: pt[1] + distanceY
                        });
                        valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                    } else {
                        var pt = polyline.getPointOn(xOrY, dim);
                        pt && endLabel.attr({
                            x: pt[0] + distanceX,
                            y: pt[1] + distanceY
                        });
                        var startValue = seriesModel.getRawValue(indices[0]);
                        var endValue = seriesModel.getRawValue(indices[1]);
                        valueAnimation && (value = (0, parcelRequire("eaKsF")).interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                    }
                    animationRecord.lastFrameIndex = indices[0];
                } else {
                    var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                    var pt = $933633d411d7f701$var$getPointAtIndex(points, idx);
                    valueAnimation && (value = seriesModel.getRawValue(idx));
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                }
                if (valueAnimation) (0, (0, parcelRequire("gvLUt")).labelInner)(endLabel).setLabelText(value);
            }
        };
        LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
            var polyline = this._polyline;
            var polygon = this._polygon;
            var seriesModel = data.hostModel;
            var diff = (0, (0, parcelRequire("7HTYE")).default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
            var current = diff.current;
            var stackedOnCurrent = diff.stackedOnCurrent;
            var next = diff.next;
            var stackedOnNext = diff.stackedOnNext;
            if (step) {
                current = $933633d411d7f701$var$turnPointsIntoStep(diff.current, coordSys, step);
                stackedOnCurrent = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
                next = $933633d411d7f701$var$turnPointsIntoStep(diff.next, coordSys, step);
                stackedOnNext = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
            }
            if ($933633d411d7f701$var$getBoundingDiff(current, next) > 3000 || polygon && $933633d411d7f701$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
                polyline.stopAnimation();
                polyline.setShape({
                    points: next
                });
                if (polygon) {
                    polygon.stopAnimation();
                    polygon.setShape({
                        points: next,
                        stackedOnPoints: stackedOnNext
                    });
                }
                return;
            }
            polyline.shape.__points = diff.current;
            polyline.shape.points = current;
            var target = {
                shape: {
                    points: next
                }
            };
            if (diff.current !== current) target.shape.__points = diff.next;
            polyline.stopAnimation();
            (0, parcelRequire("eYgMC")).updateProps(polyline, target, seriesModel);
            if (polygon) {
                polygon.setShape({
                    points: current,
                    stackedOnPoints: stackedOnCurrent
                });
                polygon.stopAnimation();
                (0, parcelRequire("eYgMC")).updateProps(polygon, {
                    shape: {
                        stackedOnPoints: stackedOnNext
                    }
                }, seriesModel);
                if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
            }
            var updatedDataInfo = [];
            var diffStatus = diff.status;
            for(var i = 0; i < diffStatus.length; i++){
                var cmd = diffStatus[i].cmd;
                if (cmd === '=') {
                    var el = data.getItemGraphicEl(diffStatus[i].idx1);
                    if (el) updatedDataInfo.push({
                        el: el,
                        ptIdx: i
                    });
                }
            }
            if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
                polygon && polygon.dirtyShape();
                var points = polyline.shape.__points;
                for(var i = 0; i < updatedDataInfo.length; i++){
                    var el = updatedDataInfo[i].el;
                    var offset = updatedDataInfo[i].ptIdx * 2;
                    el.x = points[offset];
                    el.y = points[offset + 1];
                    el.markRedraw();
                }
            });
        };
        LineView.prototype.remove = function(ecModel) {
            var group = this.group;
            var oldData = this._data;
            this._lineGroup.removeAll();
            this._symbolDraw.remove(true);
            oldData && oldData.eachItemGraphicEl(function(el, idx) {
                if (el.__temp) {
                    group.remove(el);
                    oldData.setItemGraphicEl(idx, null);
                }
            });
            this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
        };
        LineView.type = 'line';
        return LineView;
    }((0, (0, parcelRequire("loerw")).default));
    var $933633d411d7f701$export$2e2bcd8739ae039 = $933633d411d7f701$var$LineView;
});
parcelRegister("5DXGq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41bee41b01adf88e$export$2e2bcd8739ae039);
    var $4KVOr;
    parcelRequire("fHITF");
    var $eYgMC;
    var $lUzII;
    var $bahqM;
    var $gvLUt;
    function $41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt) {
        return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
    }
    function $41bee41b01adf88e$var$normalizeUpdateOpt(opt) {
        if (opt != null && !(0, (0, parcelRequire("bahqM")).isObject)(opt)) opt = {
            isIgnore: opt
        };
        return opt || {};
    }
    function $41bee41b01adf88e$var$makeSeriesScope(data) {
        var seriesModel = data.hostModel;
        var emphasisModel = seriesModel.getModel('emphasis');
        return {
            emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
            blurItemStyle: seriesModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle(),
            selectItemStyle: seriesModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle(),
            focus: emphasisModel.get('focus'),
            blurScope: emphasisModel.get('blurScope'),
            hoverScale: emphasisModel.get('scale'),
            labelStatesModels: (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(seriesModel),
            cursorStyle: seriesModel.get('cursor')
        };
    }
    var $41bee41b01adf88e$var$SymbolDraw = function() {
        function SymbolDraw(SymbolCtor) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this._SymbolCtor = SymbolCtor || (0, (0, parcelRequire("lUzII")).default);
        }
        SymbolDraw.prototype.updateData = function(data, opt) {
            opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
            var group = this.group;
            var seriesModel = data.hostModel;
            var oldData = this._data;
            var SymbolCtor = this._SymbolCtor;
            var disableAnimation = opt.disableAnimation;
            var seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
            var symbolUpdateOpt = {
                disableAnimation: disableAnimation
            };
            var getSymbolPoint = opt.getSymbolPoint || function(idx) {
                return data.getItemLayout(idx);
            };
            if (!oldData) group.removeAll();
            data.diff(oldData).add(function(newIdx) {
                var point = getSymbolPoint(newIdx);
                if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                    var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                    symbolEl.setPosition(point);
                    data.setItemGraphicEl(newIdx, symbolEl);
                    group.add(symbolEl);
                }
            }).update(function(newIdx, oldIdx) {
                var symbolEl = oldData.getItemGraphicEl(oldIdx);
                var point = getSymbolPoint(newIdx);
                if (!$41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                    group.remove(symbolEl);
                    return;
                }
                var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
                var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
                if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                    group.remove(symbolEl);
                    symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                    symbolEl.setPosition(point);
                } else {
                    symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                    var target = {
                        x: point[0],
                        y: point[1]
                    };
                    disableAnimation ? symbolEl.attr(target) : (0, parcelRequire("eYgMC")).updateProps(symbolEl, target, seriesModel);
                }
                group.add(symbolEl);
                data.setItemGraphicEl(newIdx, symbolEl);
            }).remove(function(oldIdx) {
                var el = oldData.getItemGraphicEl(oldIdx);
                el && el.fadeOut(function() {
                    group.remove(el);
                });
            }).execute();
            this._getSymbolPoint = getSymbolPoint;
            this._data = data;
        };
        SymbolDraw.prototype.isPersistent = function() {
            return true;
        };
        SymbolDraw.prototype.updateLayout = function() {
            var _this = this;
            var data = this._data;
            if (data) data.eachItemGraphicEl(function(el, idx) {
                var point = _this._getSymbolPoint(idx);
                el.setPosition(point);
                el.markRedraw();
            });
        };
        SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
            this._seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
            this._data = null;
            this.group.removeAll();
        };
        SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
            opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
            function updateIncrementalAndHover(el) {
                if (!el.isGroup) {
                    el.incremental = true;
                    el.ensureState('emphasis').hoverLayer = true;
                }
            }
            for(var idx = taskParams.start; idx < taskParams.end; idx++){
                var point = data.getItemLayout(idx);
                if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt)) {
                    var el = new this._SymbolCtor(data, idx, this._seriesScope);
                    el.traverse(updateIncrementalAndHover);
                    el.setPosition(point);
                    this.group.add(el);
                    data.setItemGraphicEl(idx, el);
                }
            }
        };
        SymbolDraw.prototype.remove = function(enableAnimation) {
            var group = this.group;
            var data = this._data;
            if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
                el.fadeOut(function() {
                    group.remove(el);
                });
            });
            else group.removeAll();
        };
        return SymbolDraw;
    }();
    var $41bee41b01adf88e$export$2e2bcd8739ae039 = $41bee41b01adf88e$var$SymbolDraw;
});
parcelRegister("lUzII", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff3a893c22158f47$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7yklO;
    var $4KVOr;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $5MLZz;
    var $bahqM;
    var $gvLUt;
    var $gcbBH;
    var $eYgMC;
    var $ff3a893c22158f47$var$Symbol = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Symbol, _super);
        function Symbol(data, idx, seriesScope, opts) {
            var _this = _super.call(this) || this;
            _this.updateData(data, idx, seriesScope, opts);
            return _this;
        }
        Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
            this.removeAll();
            var symbolPath = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
            symbolPath.attr({
                z2: 100,
                culling: true,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            });
            symbolPath.drift = $ff3a893c22158f47$var$driftSymbol;
            this._symbolType = symbolType;
            this.add(symbolPath);
        };
        Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
            this.childAt(0).stopAnimation(null, toLastFrame);
        };
        Symbol.prototype.getSymbolType = function() {
            return this._symbolType;
        };
        Symbol.prototype.getSymbolPath = function() {
            return this.childAt(0);
        };
        Symbol.prototype.highlight = function() {
            (0, (0, parcelRequire("fIXXx")).enterEmphasis)(this.childAt(0));
        };
        Symbol.prototype.downplay = function() {
            (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(this.childAt(0));
        };
        Symbol.prototype.setZ = function(zlevel, z) {
            var symbolPath = this.childAt(0);
            symbolPath.zlevel = zlevel;
            symbolPath.z = z;
        };
        Symbol.prototype.setDraggable = function(draggable) {
            var symbolPath = this.childAt(0);
            symbolPath.draggable = draggable;
            symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
        };
        Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
            this.silent = false;
            var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
            var seriesModel = data.hostModel;
            var symbolSize = Symbol.getSymbolSize(data, idx);
            var isInit = symbolType !== this._symbolType;
            var disableAnimation = opts && opts.disableAnimation;
            if (isInit) {
                var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
                this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
            } else {
                var symbolPath = this.childAt(0);
                symbolPath.silent = false;
                var target = {
                    scaleX: symbolSize[0] / 2,
                    scaleY: symbolSize[1] / 2
                };
                disableAnimation ? symbolPath.attr(target) : (0, parcelRequire("eYgMC")).updateProps(symbolPath, target, seriesModel, idx);
                (0, (0, parcelRequire("eYgMC")).saveOldStyle)(symbolPath);
            }
            this._updateCommon(data, idx, symbolSize, seriesScope, opts);
            if (isInit) {
                var symbolPath = this.childAt(0);
                if (!disableAnimation) {
                    var target = {
                        scaleX: this._sizeX,
                        scaleY: this._sizeY,
                        style: {
                            opacity: symbolPath.style.opacity
                        }
                    };
                    symbolPath.scaleX = symbolPath.scaleY = 0;
                    symbolPath.style.opacity = 0;
                    (0, parcelRequire("eYgMC")).initProps(symbolPath, target, seriesModel, idx);
                }
            }
            if (disableAnimation) this.childAt(0).stopAnimation('remove');
            this._seriesModel = seriesModel;
        };
        Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
            var symbolPath = this.childAt(0);
            var seriesModel = data.hostModel;
            var emphasisItemStyle;
            var blurItemStyle;
            var selectItemStyle;
            var focus;
            var blurScope;
            var labelStatesModels;
            var hoverScale;
            var cursorStyle;
            if (seriesScope) {
                emphasisItemStyle = seriesScope.emphasisItemStyle;
                blurItemStyle = seriesScope.blurItemStyle;
                selectItemStyle = seriesScope.selectItemStyle;
                focus = seriesScope.focus;
                blurScope = seriesScope.blurScope;
                labelStatesModels = seriesScope.labelStatesModels;
                hoverScale = seriesScope.hoverScale;
                cursorStyle = seriesScope.cursorStyle;
            }
            if (!seriesScope || data.hasItemOption) {
                var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
                var emphasisModel = itemModel.getModel('emphasis');
                emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
                selectItemStyle = itemModel.getModel([
                    'select',
                    'itemStyle'
                ]).getItemStyle();
                blurItemStyle = itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]).getItemStyle();
                focus = emphasisModel.get('focus');
                blurScope = emphasisModel.get('blurScope');
                labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
                hoverScale = emphasisModel.getShallow('scale');
                cursorStyle = itemModel.getShallow('cursor');
            }
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
            symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
            var symbolOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
            if (symbolOffset) {
                symbolPath.x = symbolOffset[0];
                symbolPath.y = symbolOffset[1];
            }
            cursorStyle && symbolPath.attr('cursor', cursorStyle);
            var symbolStyle = data.getItemVisual(idx, 'style');
            var visualColor = symbolStyle.fill;
            if (symbolPath instanceof (0, (0, parcelRequire("gcbBH")).default)) {
                var pathStyle = symbolPath.style;
                symbolPath.useStyle((0, (0, parcelRequire("bahqM")).extend)({
                    image: pathStyle.image,
                    x: pathStyle.x,
                    y: pathStyle.y,
                    width: pathStyle.width,
                    height: pathStyle.height
                }, symbolStyle));
            } else {
                if (symbolPath.__isEmptyBrush) symbolPath.useStyle((0, (0, parcelRequire("bahqM")).extend)({}, symbolStyle));
                else symbolPath.useStyle(symbolStyle);
                symbolPath.style.decal = null;
                symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
                symbolPath.style.strokeNoScale = true;
            }
            var liftZ = data.getItemVisual(idx, 'liftZ');
            var z2Origin = this._z2;
            if (liftZ != null) {
                if (z2Origin == null) {
                    this._z2 = symbolPath.z2;
                    symbolPath.z2 += liftZ;
                }
            } else if (z2Origin != null) {
                symbolPath.z2 = z2Origin;
                this._z2 = null;
            }
            var useNameLabel = opts && opts.useNameLabel;
            (0, (0, parcelRequire("gvLUt")).setLabelStyle)(symbolPath, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultText: getLabelDefaultText,
                inheritColor: visualColor,
                defaultOpacity: symbolStyle.opacity
            });
            function getLabelDefaultText(idx) {
                return useNameLabel ? data.getName(idx) : (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(data, idx);
            }
            this._sizeX = symbolSize[0] / 2;
            this._sizeY = symbolSize[1] / 2;
            var emphasisState = symbolPath.ensureState('emphasis');
            emphasisState.style = emphasisItemStyle;
            symbolPath.ensureState('select').style = selectItemStyle;
            symbolPath.ensureState('blur').style = blurItemStyle;
            if (hoverScale) {
                var scaleRatio = Math.max(1.1, 3 / this._sizeY);
                emphasisState.scaleX = this._sizeX * scaleRatio;
                emphasisState.scaleY = this._sizeY * scaleRatio;
            }
            this.setSymbolScale(1);
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this, focus, blurScope);
        };
        Symbol.prototype.setSymbolScale = function(scale) {
            this.scaleX = this.scaleY = scale;
        };
        Symbol.prototype.fadeOut = function(cb, opt) {
            var symbolPath = this.childAt(0);
            var seriesModel = this._seriesModel;
            var dataIndex = (0, (0, parcelRequire("7QjoM")).getECData)(this).dataIndex;
            var animationOpt = opt && opt.animation;
            this.silent = symbolPath.silent = true;
            if (opt && opt.fadeLabel) {
                var textContent = symbolPath.getTextContent();
                if (textContent) (0, parcelRequire("eYgMC")).removeElement(textContent, {
                    style: {
                        opacity: 0
                    }
                }, seriesModel, {
                    dataIndex: dataIndex,
                    removeOpt: animationOpt,
                    cb: function() {
                        symbolPath.removeTextContent();
                    }
                });
            } else symbolPath.removeTextContent();
            (0, parcelRequire("eYgMC")).removeElement(symbolPath, {
                style: {
                    opacity: 0
                },
                scaleX: 0,
                scaleY: 0
            }, seriesModel, {
                dataIndex: dataIndex,
                cb: cb,
                removeOpt: animationOpt
            });
        };
        Symbol.getSymbolSize = function(data, idx) {
            return (0, (0, parcelRequire("7yklO")).normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
        };
        return Symbol;
    }((0, parcelRequire("4KVOr")).default);
    function $ff3a893c22158f47$var$driftSymbol(dx, dy) {
        this.parent.drift(dx, dy);
    }
    var $ff3a893c22158f47$export$2e2bcd8739ae039 = $ff3a893c22158f47$var$Symbol;
});
parcelRegister("5MLZz", function(module, exports) {
    $parcel$export(module.exports, "getDefaultLabel", ()=>$4366a9b1a430c1e7$export$5ff20667590927ed);
    $parcel$export(module.exports, "getDefaultInterpolatedLabel", ()=>$4366a9b1a430c1e7$export$5f84815e91ca6775);
    var $9OHWG;
    var $bahqM;
    function $4366a9b1a430c1e7$export$5ff20667590927ed(data, dataIndex) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        var len = labelDims.length;
        if (len === 1) {
            var rawVal = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[0]);
            return rawVal != null ? rawVal + '' : null;
        } else if (len) {
            var vals = [];
            for(var i = 0; i < labelDims.length; i++)vals.push((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[i]));
            return vals.join(' ');
        }
    }
    function $4366a9b1a430c1e7$export$5f84815e91ca6775(data, interpolatedValue) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        if (!(0, (0, parcelRequire("bahqM")).isArray)(interpolatedValue)) return interpolatedValue + '';
        var vals = [];
        for(var i = 0; i < labelDims.length; i++){
            var dimIndex = data.getDimensionIndex(labelDims[i]);
            if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
        }
        return vals.join(' ');
    }
});
parcelRegister("7HTYE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59c7f87717a036e4$export$2e2bcd8739ae039);
    var $JBb7Y;
    var $8fK8Y;
    function $59c7f87717a036e4$var$diffData(oldData, newData) {
        var diffResult = [];
        newData.diff(oldData).add(function(idx) {
            diffResult.push({
                cmd: '+',
                idx: idx
            });
        }).update(function(newIdx, oldIdx) {
            diffResult.push({
                cmd: '=',
                idx: oldIdx,
                idx1: newIdx
            });
        }).remove(function(idx) {
            diffResult.push({
                cmd: '-',
                idx: idx
            });
        }).execute();
        return diffResult;
    }
    function $59c7f87717a036e4$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
        var diff = $59c7f87717a036e4$var$diffData(oldData, newData);
        var currPoints = [];
        var nextPoints = [];
        var currStackedPoints = [];
        var nextStackedPoints = [];
        var status = [];
        var sortedIndices = [];
        var rawIndices = [];
        var newDataOldCoordInfo = (0, (0, parcelRequire("JBb7Y")).prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin);
        var oldPoints = oldData.getLayout('points') || [];
        var newPoints = newData.getLayout('points') || [];
        for(var i = 0; i < diff.length; i++){
            var diffItem = diff[i];
            var pointAdded = true;
            var oldIdx2 = void 0;
            var newIdx2 = void 0;
            switch(diffItem.cmd){
                case '=':
                    oldIdx2 = diffItem.idx * 2;
                    newIdx2 = diffItem.idx1 * 2;
                    var currentX = oldPoints[oldIdx2];
                    var currentY = oldPoints[oldIdx2 + 1];
                    var nextX = newPoints[newIdx2];
                    var nextY = newPoints[newIdx2 + 1];
                    if (isNaN(currentX) || isNaN(currentY)) {
                        currentX = nextX;
                        currentY = nextY;
                    }
                    currPoints.push(currentX, currentY);
                    nextPoints.push(nextX, nextY);
                    currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                    nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                    rawIndices.push(newData.getRawIndex(diffItem.idx1));
                    break;
                case '+':
                    var newIdx = diffItem.idx;
                    var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                    var oldPt = oldCoordSys.dataToPoint([
                        newData.get(newDataDimsForPoint[0], newIdx),
                        newData.get(newDataDimsForPoint[1], newIdx)
                    ]);
                    newIdx2 = newIdx * 2;
                    currPoints.push(oldPt[0], oldPt[1]);
                    nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                    var stackedOnPoint = (0, (0, parcelRequire("JBb7Y")).getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                    currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                    nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                    rawIndices.push(newData.getRawIndex(newIdx));
                    break;
                case '-':
                    pointAdded = false;
            }
            if (pointAdded) {
                status.push(diffItem);
                sortedIndices.push(sortedIndices.length);
            }
        }
        sortedIndices.sort(function(a, b) {
            return rawIndices[a] - rawIndices[b];
        });
        var len = currPoints.length;
        var sortedCurrPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedNextPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedCurrStackedPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedNextStackedPoints = (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(len);
        var sortedStatus = [];
        for(var i = 0; i < sortedIndices.length; i++){
            var idx = sortedIndices[i];
            var i2 = i * 2;
            var idx2 = idx * 2;
            sortedCurrPoints[i2] = currPoints[idx2];
            sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
            sortedNextPoints[i2] = nextPoints[idx2];
            sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
            sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
            sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
            sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
            sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
            sortedStatus[i] = status[idx];
        }
        return {
            current: sortedCurrPoints,
            next: sortedNextPoints,
            stackedOnCurrent: sortedCurrStackedPoints,
            stackedOnNext: sortedNextStackedPoints,
            status: sortedStatus
        };
    }
});
parcelRegister("JBb7Y", function(module, exports) {
    $parcel$export(module.exports, "prepareDataCoordInfo", ()=>$08910af48116f194$export$b488a529581b37e);
    $parcel$export(module.exports, "getStackedOnPoint", ()=>$08910af48116f194$export$c1601aa630e7b5f8);
    var $5R8Hi;
    var $bahqM;
    function $08910af48116f194$export$b488a529581b37e(coordSys, data, valueOrigin) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var valueStart = $08910af48116f194$var$getValueStart(valueAxis, valueOrigin);
        var baseAxisDim = baseAxis.dim;
        var valueAxisDim = valueAxis.dim;
        var valueDim = data.mapDimension(valueAxisDim);
        var baseDim = data.mapDimension(baseAxisDim);
        var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
        var dims = (0, (0, parcelRequire("bahqM")).map)(coordSys.dimensions, function(coordDim) {
            return data.mapDimension(coordDim);
        });
        var stacked = false;
        var stackResultDim = data.getCalculationInfo('stackResultDimension');
        if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[0])) {
            stacked = true;
            dims[0] = stackResultDim;
        }
        if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[1])) {
            stacked = true;
            dims[1] = stackResultDim;
        }
        return {
            dataDimsForPoint: dims,
            valueStart: valueStart,
            valueAxisDim: valueAxisDim,
            baseAxisDim: baseAxisDim,
            stacked: !!stacked,
            valueDim: valueDim,
            baseDim: baseDim,
            baseDataOffset: baseDataOffset,
            stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
        };
    }
    function $08910af48116f194$var$getValueStart(valueAxis, valueOrigin) {
        var valueStart = 0;
        var extent = valueAxis.scale.getExtent();
        if (valueOrigin === 'start') valueStart = extent[0];
        else if (valueOrigin === 'end') valueStart = extent[1];
        else {
            if (extent[0] > 0) valueStart = extent[0];
            else if (extent[1] < 0) valueStart = extent[1];
        }
        return valueStart;
    }
    function $08910af48116f194$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
        var value = NaN;
        if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
        if (isNaN(value)) value = dataCoordInfo.valueStart;
        var baseDataOffset = dataCoordInfo.baseDataOffset;
        var stackedData = [];
        stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
        stackedData[1 - baseDataOffset] = value;
        return coordSys.dataToPoint(stackedData);
    }
});
parcelRegister("8fK8Y", function(module, exports) {
    $parcel$export(module.exports, "createFloat32Array", ()=>$602384a5ad582433$export$21d2298f3f56bbaf);
    var $bahqM;
    var $602384a5ad582433$var$supportFloat32Array = typeof Float32Array !== 'undefined';
    var $602384a5ad582433$var$Float32ArrayCtor = !$602384a5ad582433$var$supportFloat32Array ? Array : Float32Array;
    function $602384a5ad582433$export$21d2298f3f56bbaf(arg) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(arg)) return $602384a5ad582433$var$supportFloat32Array ? new Float32Array(arg) : arg;
        return new $602384a5ad582433$var$Float32ArrayCtor(arg);
    }
});
parcelRegister("jconq", function(module, exports) {
    $parcel$export(module.exports, "ECPolyline", ()=>$dfa20c0939f7b781$export$bf7c0585b8f7d00f);
    $parcel$export(module.exports, "ECPolygon", ()=>$dfa20c0939f7b781$export$6042a400d113f2bd);
    var $3VFsf;
    var $ghQ8v;
    var $aA4Ws;
    var $dr1jo;
    var $dfa20c0939f7b781$var$mathMin = Math.min;
    var $dfa20c0939f7b781$var$mathMax = Math.max;
    function $dfa20c0939f7b781$var$isPointNull(x, y) {
        return isNaN(x) || isNaN(y);
    }
    function $dfa20c0939f7b781$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
        var prevX;
        var prevY;
        var cpx0;
        var cpy0;
        var cpx1;
        var cpy1;
        var idx = start;
        var k = 0;
        for(; k < segLen; k++){
            var x = points[idx * 2];
            var y = points[idx * 2 + 1];
            if (idx >= allLen || idx < 0) break;
            if ($dfa20c0939f7b781$var$isPointNull(x, y)) {
                if (connectNulls) {
                    idx += dir;
                    continue;
                }
                break;
            }
            if (idx === start) {
                ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
                cpx0 = x;
                cpy0 = y;
            } else {
                var dx = x - prevX;
                var dy = y - prevY;
                if (dx * dx + dy * dy < 0.5) {
                    idx += dir;
                    continue;
                }
                if (smooth > 0) {
                    var nextIdx = idx + dir;
                    var nextX = points[nextIdx * 2];
                    var nextY = points[nextIdx * 2 + 1];
                    var tmpK = k + 1;
                    if (connectNulls) while($dfa20c0939f7b781$var$isPointNull(nextX, nextY) && tmpK < segLen){
                        tmpK++;
                        nextIdx += dir;
                        nextX = points[nextIdx * 2];
                        nextY = points[nextIdx * 2 + 1];
                    }
                    var ratioNextSeg = 0.5;
                    var vx = 0;
                    var vy = 0;
                    var nextCpx0 = void 0;
                    var nextCpy0 = void 0;
                    if (tmpK >= segLen || $dfa20c0939f7b781$var$isPointNull(nextX, nextY)) {
                        cpx1 = x;
                        cpy1 = y;
                    } else {
                        vx = nextX - prevX;
                        vy = nextY - prevY;
                        var dx0 = x - prevX;
                        var dx1 = nextX - x;
                        var dy0 = y - prevY;
                        var dy1 = nextY - y;
                        var lenPrevSeg = void 0;
                        var lenNextSeg = void 0;
                        if (smoothMonotone === 'x') {
                            lenPrevSeg = Math.abs(dx0);
                            lenNextSeg = Math.abs(dx1);
                            cpx1 = x - lenPrevSeg * smooth;
                            cpy1 = y;
                            nextCpx0 = x + lenPrevSeg * smooth;
                            nextCpy0 = y;
                        } else if (smoothMonotone === 'y') {
                            lenPrevSeg = Math.abs(dy0);
                            lenNextSeg = Math.abs(dy1);
                            cpx1 = x;
                            cpy1 = y - lenPrevSeg * smooth;
                            nextCpx0 = x;
                            nextCpy0 = y + lenPrevSeg * smooth;
                        } else {
                            lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                            lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                            ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                            cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                            cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                            nextCpx0 = x + vx * smooth * ratioNextSeg;
                            nextCpy0 = y + vy * smooth * ratioNextSeg;
                            nextCpx0 = $dfa20c0939f7b781$var$mathMin(nextCpx0, $dfa20c0939f7b781$var$mathMax(nextX, x));
                            nextCpy0 = $dfa20c0939f7b781$var$mathMin(nextCpy0, $dfa20c0939f7b781$var$mathMax(nextY, y));
                            nextCpx0 = $dfa20c0939f7b781$var$mathMax(nextCpx0, $dfa20c0939f7b781$var$mathMin(nextX, x));
                            nextCpy0 = $dfa20c0939f7b781$var$mathMax(nextCpy0, $dfa20c0939f7b781$var$mathMin(nextY, y));
                            vx = nextCpx0 - x;
                            vy = nextCpy0 - y;
                            cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                            cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                            cpx1 = $dfa20c0939f7b781$var$mathMin(cpx1, $dfa20c0939f7b781$var$mathMax(prevX, x));
                            cpy1 = $dfa20c0939f7b781$var$mathMin(cpy1, $dfa20c0939f7b781$var$mathMax(prevY, y));
                            cpx1 = $dfa20c0939f7b781$var$mathMax(cpx1, $dfa20c0939f7b781$var$mathMin(prevX, x));
                            cpy1 = $dfa20c0939f7b781$var$mathMax(cpy1, $dfa20c0939f7b781$var$mathMin(prevY, y));
                            vx = x - cpx1;
                            vy = y - cpy1;
                            nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                            nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                        }
                    }
                    ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                    cpx0 = nextCpx0;
                    cpy0 = nextCpy0;
                } else ctx.lineTo(x, y);
            }
            prevX = x;
            prevY = y;
            idx += dir;
        }
        return k;
    }
    var $dfa20c0939f7b781$var$ECPolylineShape = function() {
        function ECPolylineShape() {
            this.smooth = 0;
            this.smoothConstraint = true;
        }
        return ECPolylineShape;
    }();
    var $dfa20c0939f7b781$export$bf7c0585b8f7d00f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolyline, _super);
        function ECPolyline(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-polyline';
            return _this;
        }
        ECPolyline.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        ECPolyline.prototype.getDefaultShape = function() {
            return new $dfa20c0939f7b781$var$ECPolylineShape();
        };
        ECPolyline.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var i = 0;
            var len = points.length / 2;
            if (shape.connectNulls) {
                for(; len > 0; len--){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
                }
                for(; i < len; i++){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
                }
            }
            while(i < len)i += $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
        };
        ECPolyline.prototype.getPointOn = function(xOrY, dim) {
            if (!this.path) {
                this.createPathProxy();
                this.buildPath(this.path, this.shape);
            }
            var path = this.path;
            var data = path.data;
            var CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
            var x0;
            var y0;
            var isDimX = dim === 'x';
            var roots = [];
            for(var i = 0; i < data.length;){
                var cmd = data[i++];
                var x = void 0;
                var y = void 0;
                var x2 = void 0;
                var y2 = void 0;
                var x3 = void 0;
                var y3 = void 0;
                var t = void 0;
                switch(cmd){
                    case CMD.M:
                        x0 = data[i++];
                        y0 = data[i++];
                        break;
                    case CMD.L:
                        x = data[i++];
                        y = data[i++];
                        t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                        if (t <= 1 && t >= 0) {
                            var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                        x0 = x;
                        y0 = y;
                        break;
                    case CMD.C:
                        x = data[i++];
                        y = data[i++];
                        x2 = data[i++];
                        y2 = data[i++];
                        x3 = data[i++];
                        y3 = data[i++];
                        var nRoot = isDimX ? (0, (0, parcelRequire("dr1jo")).cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, (0, parcelRequire("dr1jo")).cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                        if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                            var t_1 = roots[i_1];
                            if (t_1 <= 1 && t_1 >= 0) {
                                var val = isDimX ? (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y, y2, y3, t_1) : (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x, x2, x3, t_1);
                                return isDimX ? [
                                    xOrY,
                                    val
                                ] : [
                                    val,
                                    xOrY
                                ];
                            }
                        }
                        x0 = x3;
                        y0 = y3;
                        break;
                }
            }
        };
        return ECPolyline;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $dfa20c0939f7b781$var$ECPolygonShape = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolygonShape, _super);
        function ECPolygonShape() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return ECPolygonShape;
    }($dfa20c0939f7b781$var$ECPolylineShape);
    var $dfa20c0939f7b781$export$6042a400d113f2bd = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECPolygon, _super);
        function ECPolygon(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-polygon';
            return _this;
        }
        ECPolygon.prototype.getDefaultShape = function() {
            return new $dfa20c0939f7b781$var$ECPolygonShape();
        };
        ECPolygon.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var stackedOnPoints = shape.stackedOnPoints;
            var i = 0;
            var len = points.length / 2;
            var smoothMonotone = shape.smoothMonotone;
            if (shape.connectNulls) {
                for(; len > 0; len--){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
                }
                for(; i < len; i++){
                    if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
                }
            }
            while(i < len){
                var k = $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
                $dfa20c0939f7b781$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
                i += k + 1;
                ctx.closePath();
            }
        };
        return ECPolygon;
    }((0, (0, parcelRequire("ghQ8v")).default));
});
parcelRegister("loerw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9270aeb44680e6f$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $fIXXx;
    var $92IK1;
    var $9irlK;
    var $f9270aeb44680e6f$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    var $f9270aeb44680e6f$var$renderPlanner = (0, (0, parcelRequire("9irlK")).default)();
    var $f9270aeb44680e6f$var$ChartView = function() {
        function ChartView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewChart');
            this.renderTask = (0, (0, parcelRequire("92IK1")).createTask)({
                plan: $f9270aeb44680e6f$var$renderTaskPlan,
                reset: $f9270aeb44680e6f$var$renderTaskReset
            });
            this.renderTask.context = {
                view: this
            };
        }
        ChartView.prototype.init = function(ecModel, api) {};
        ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
        ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
        };
        ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
        };
        ChartView.prototype.remove = function(ecModel, api) {
            this.group.removeAll();
        };
        ChartView.prototype.dispose = function(ecModel, api) {};
        ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.markUpdateMethod = function(payload, methodName) {
            $f9270aeb44680e6f$var$inner(payload).updateMethod = methodName;
        };
        ChartView.protoInitialize = function() {
            var proto = ChartView.prototype;
            proto.type = 'chart';
        }();
        return ChartView;
    }();
    function $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit) {
        if (el) (state === 'emphasis' ? (0, (0, parcelRequire("fIXXx")).enterEmphasis) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis))(el, highlightDigit);
    }
    function $f9270aeb44680e6f$var$toggleHighlight(data, payload, state) {
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
        var highlightDigit = payload && payload.highlightKey != null ? (0, (0, parcelRequire("fIXXx")).getHighlightDigit)(payload.highlightKey) : null;
        if (dataIndex != null) (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(dataIndex), function(dataIdx) {
            $f9270aeb44680e6f$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
        });
        else data.eachItemGraphicEl(function(el) {
            $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit);
        });
    }
    (0, parcelRequire("aLwh0")).enableClassExtend($f9270aeb44680e6f$var$ChartView, [
        'dispose'
    ]);
    (0, parcelRequire("aLwh0")).enableClassManagement($f9270aeb44680e6f$var$ChartView);
    function $f9270aeb44680e6f$var$renderTaskPlan(context) {
        return $f9270aeb44680e6f$var$renderPlanner(context.model);
    }
    function $f9270aeb44680e6f$var$renderTaskReset(context) {
        var seriesModel = context.model;
        var ecModel = context.ecModel;
        var api = context.api;
        var payload = context.payload;
        var progressiveRender = seriesModel.pipelineContext.progressiveRender;
        var view = context.view;
        var updateMethod = payload && $f9270aeb44680e6f$var$inner(payload).updateMethod;
        var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
        if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
        return $f9270aeb44680e6f$var$progressMethodMap[methodName];
    }
    var $f9270aeb44680e6f$var$progressMethodMap = {
        incrementalPrepareRender: {
            progress: function(params, context) {
                context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
            }
        },
        render: {
            forceFirstProgress: true,
            progress: function(params, context) {
                context.view.render(context.model, context.ecModel, context.api, context.payload);
            }
        }
    };
    var $f9270aeb44680e6f$export$2e2bcd8739ae039 = $f9270aeb44680e6f$var$ChartView;
});
parcelRegister("9irlK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c4b0292c57cf773$export$2e2bcd8739ae039);
    var $eaKsF;
    function $6c4b0292c57cf773$export$2e2bcd8739ae039() {
        var inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
        return function(seriesModel) {
            var fields = inner(seriesModel);
            var pipelineContext = seriesModel.pipelineContext;
            var originalLarge = !!fields.large;
            var originalProgressive = !!fields.progressiveRender;
            var large = fields.large = !!(pipelineContext && pipelineContext.large);
            var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
            return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
        };
    }
});
parcelRegister("5fMzf", function(module, exports) {
    $parcel$export(module.exports, "createGridClipPath", ()=>$3d3406f7f3673e0b$export$83958787eb658d14);
    $parcel$export(module.exports, "createPolarClipPath", ()=>$3d3406f7f3673e0b$export$13dc2b2230df3cb5);
    $parcel$export(module.exports, "createClipPath", ()=>$3d3406f7f3673e0b$export$e0fe5081209d01c9);
    var $eYgMC;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $elGBV;
    var $jmSNG;
    function $3d3406f7f3673e0b$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
        var rect = cartesian.getArea();
        var x = rect.x;
        var y = rect.y;
        var width = rect.width;
        var height = rect.height;
        var lineWidth = seriesModel.get([
            'lineStyle',
            'width'
        ]) || 2;
        x -= lineWidth / 2;
        y -= lineWidth / 2;
        width += lineWidth;
        height += lineWidth;
        x = Math.floor(x);
        width = Math.round(width);
        var clipPath = new (0, parcelRequire("7Tw7u")).default({
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            }
        });
        if (hasAnimation) {
            var baseAxis = cartesian.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isAxisInversed = baseAxis.inverse;
            if (isHorizontal) {
                if (isAxisInversed) clipPath.shape.x += width;
                clipPath.shape.width = 0;
            } else {
                if (!isAxisInversed) clipPath.shape.y += height;
                clipPath.shape.height = 0;
            }
            var duringCb = typeof during === 'function' ? function(percent) {
                during(percent, clipPath);
            } : null;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                }
            }, seriesModel, null, done, duringCb);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
        var sectorArea = polar.getArea();
        var r0 = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r0, 1);
        var r = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r, 1);
        var clipPath = new (0, parcelRequire("elGBV")).default({
            shape: {
                cx: (0, (0, parcelRequire("jmSNG")).round)(polar.cx, 1),
                cy: (0, (0, parcelRequire("jmSNG")).round)(polar.cy, 1),
                r0: r0,
                r: r,
                startAngle: sectorArea.startAngle,
                endAngle: sectorArea.endAngle,
                clockwise: sectorArea.clockwise
            }
        });
        if (hasAnimation) {
            var isRadial = polar.getBaseAxis().dim === 'angle';
            if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
            else clipPath.shape.r = r0;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    endAngle: sectorArea.endAngle,
                    r: r
                }
            }, seriesModel);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
        if (!coordSys) return null;
        else if (coordSys.type === 'polar') return $3d3406f7f3673e0b$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
        else if (coordSys.type === 'cartesian2d') return $3d3406f7f3673e0b$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
        return null;
    }
});
parcelRegister("40dMe", function(module, exports) {
    $parcel$export(module.exports, "isCoordinateSystemType", ()=>$2ea1d953c3a29c60$export$8567506e6336616);
    function $2ea1d953c3a29c60$export$8567506e6336616(coordSys, type) {
        return coordSys.type === type;
    }
});
parcelRegister("5xgWc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$407d2c4ef7fb34bc$export$2e2bcd8739ae039);
    var $bahqM;
    var $9irlK;
    var $5R8Hi;
    var $8fK8Y;
    function $407d2c4ef7fb34bc$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
        return {
            seriesType: seriesType,
            plan: (0, (0, parcelRequire("9irlK")).default)(),
            reset: function(seriesModel) {
                var data = seriesModel.getData();
                var coordSys = seriesModel.coordinateSystem;
                var pipelineContext = seriesModel.pipelineContext;
                var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
                if (!coordSys) return;
                var dims = (0, (0, parcelRequire("bahqM")).map)(coordSys.dimensions, function(dim) {
                    return data.mapDimension(dim);
                }).slice(0, 2);
                var dimLen = dims.length;
                var stackResultDim = data.getCalculationInfo('stackResultDimension');
                if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
                if ((0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
                var store = data.getStore();
                var dimIdx0 = data.getDimensionIndex(dims[0]);
                var dimIdx1 = data.getDimensionIndex(dims[1]);
                return dimLen && {
                    progress: function(params, data) {
                        var segCount = params.end - params.start;
                        var points = useTypedArray && (0, (0, parcelRequire("8fK8Y")).createFloat32Array)(segCount * dimLen);
                        var tmpIn = [];
                        var tmpOut = [];
                        for(var i = params.start, offset = 0; i < params.end; i++){
                            var point = void 0;
                            if (dimLen === 1) {
                                var x = store.get(dimIdx0, i);
                                point = coordSys.dataToPoint(x, null, tmpOut);
                            } else {
                                tmpIn[0] = store.get(dimIdx0, i);
                                tmpIn[1] = store.get(dimIdx1, i);
                                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                            }
                            if (useTypedArray) {
                                points[offset++] = point[0];
                                points[offset++] = point[1];
                            } else data.setItemLayout(i, point.slice());
                        }
                        useTypedArray && data.setLayout('points', points);
                    }
                };
            }
        };
    }
});
parcelRegister("7jcIW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55242d779d1fe9b5$export$2e2bcd8739ae039);
    var $55242d779d1fe9b5$var$samplers = {
        average: function(frame) {
            var sum = 0;
            var count = 0;
            for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
                sum += frame[i];
                count++;
            }
            return count === 0 ? NaN : sum / count;
        },
        sum: function(frame) {
            var sum = 0;
            for(var i = 0; i < frame.length; i++)sum += frame[i] || 0;
            return sum;
        },
        max: function(frame) {
            var max = -Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
            return isFinite(max) ? max : NaN;
        },
        min: function(frame) {
            var min = Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
            return isFinite(min) ? min : NaN;
        },
        nearest: function(frame) {
            return frame[0];
        }
    };
    var $55242d779d1fe9b5$var$indexSampler = function(frame) {
        return Math.round(frame.length / 2);
    };
    function $55242d779d1fe9b5$export$2e2bcd8739ae039(seriesType) {
        return {
            seriesType: seriesType,
            reset: function(seriesModel, ecModel, api) {
                var data = seriesModel.getData();
                var sampling = seriesModel.get('sampling');
                var coordSys = seriesModel.coordinateSystem;
                var count = data.count();
                if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                    var baseAxis = coordSys.getBaseAxis();
                    var valueAxis = coordSys.getOtherAxis(baseAxis);
                    var extent = baseAxis.getExtent();
                    var dpr = api.getDevicePixelRatio();
                    var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                    var rate = Math.round(count / size);
                    if (rate > 1) {
                        if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                        var sampler = void 0;
                        if (typeof sampling === 'string') sampler = $55242d779d1fe9b5$var$samplers[sampling];
                        else if (typeof sampling === 'function') sampler = sampling;
                        if (sampler) seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $55242d779d1fe9b5$var$indexSampler));
                    }
                }
            }
        };
    }
});
parcelRegister("6OGL8", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$4f6894ac64afab25$export$4b3e715f166fdd78);
    var $iWOYl;
    var $hi3Y7;
    var $alpND;
    function $4f6894ac64afab25$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("iWOYl")).install));
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("hi3Y7")).install));
    }
});
parcelRegister("iWOYl", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$dcb52eca8f57248f$export$4b3e715f166fdd78);
    var $3VFsf;
    var $fkskt;
    var $9sf2Q;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $bahqM;
    var $1UrP6;
    var $aLiaH;
    var $1xCHp;
    var $2rHnA;
    var $dcb52eca8f57248f$var$GridView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridView, _super);
        function GridView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'grid';
            return _this;
        }
        GridView.prototype.render = function(gridModel, ecModel) {
            this.group.removeAll();
            if (gridModel.get('show')) this.group.add(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: gridModel.coordinateSystem.getRect(),
                style: (0, (0, parcelRequire("bahqM")).defaults)({
                    fill: gridModel.get('backgroundColor')
                }, gridModel.getItemStyle()),
                silent: true,
                z2: -1
            }));
        };
        GridView.type = 'grid';
        return GridView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $dcb52eca8f57248f$var$extraOption = {
        offset: 0
    };
    function $dcb52eca8f57248f$export$4b3e715f166fdd78(registers) {
        registers.registerComponentView($dcb52eca8f57248f$var$GridView);
        registers.registerComponentModel((0, (0, parcelRequire("9sf2Q")).default));
        registers.registerCoordinateSystem('cartesian2d', (0, (0, parcelRequire("1xCHp")).default));
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'x', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'y', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianXAxisView));
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianYAxisView));
        registers.registerPreprocessor(function(option) {
            if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
        });
    }
});
parcelRegister("fkskt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b28eb2e2a247a7d9$export$2e2bcd8739ae039);
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $b28eb2e2a247a7d9$var$ComponentView = function() {
        function ComponentView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewComponent');
        }
        ComponentView.prototype.init = function(ecModel, api) {};
        ComponentView.prototype.render = function(model, ecModel, api, payload) {};
        ComponentView.prototype.dispose = function(ecModel, api) {};
        ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
        ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
        return ComponentView;
    }();
    (0, parcelRequire("aLwh0")).enableClassExtend($b28eb2e2a247a7d9$var$ComponentView);
    (0, parcelRequire("aLwh0")).enableClassManagement($b28eb2e2a247a7d9$var$ComponentView);
    var $b28eb2e2a247a7d9$export$2e2bcd8739ae039 = $b28eb2e2a247a7d9$var$ComponentView;
});
parcelRegister("9sf2Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e226630804759b0$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $6e226630804759b0$var$GridModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridModel, _super);
        function GridModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GridModel.type = 'grid';
        GridModel.dependencies = [
            'xAxis',
            'yAxis'
        ];
        GridModel.layoutMode = 'box';
        GridModel.defaultOption = {
            show: false,
            zlevel: 0,
            z: 0,
            left: '10%',
            top: 60,
            right: '10%',
            bottom: 70,
            containLabel: false,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 1,
            borderColor: '#ccc'
        };
        return GridModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $6e226630804759b0$export$2e2bcd8739ae039 = $6e226630804759b0$var$GridModel;
});
parcelRegister("1UrP6", function(module, exports) {
    $parcel$export(module.exports, "CartesianAxisModel", ()=>$16409a80acd4e1a4$export$483dc37e6ad83a3c);
    var $3VFsf;
    var $bahqM;
    var $h4UlH;
    var $5pBRm;
    var $eaKsF;
    var $16409a80acd4e1a4$export$483dc37e6ad83a3c = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisModel, _super);
        function CartesianAxisModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisModel.prototype.getCoordSysModel = function() {
            return this.getReferringComponents('grid', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
        };
        CartesianAxisModel.type = 'cartesian2dAxis';
        return CartesianAxisModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($16409a80acd4e1a4$export$483dc37e6ad83a3c, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    var $16409a80acd4e1a4$export$2e2bcd8739ae039 = $16409a80acd4e1a4$export$483dc37e6ad83a3c;
});
parcelRegister("5pBRm", function(module, exports) {
    $parcel$export(module.exports, "AxisModelCommonMixin", ()=>$3f0ca7b2a67ba541$export$5c54b224726edb5a);
    var $3f0ca7b2a67ba541$export$5c54b224726edb5a = function() {
        function AxisModelCommonMixin() {}
        AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
            var option = this.option;
            return !option.scale;
        };
        AxisModelCommonMixin.prototype.getCoordSysModel = function() {
            return;
        };
        return AxisModelCommonMixin;
    }();
});
parcelRegister("aLiaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d5c63a9e257cb04$export$2e2bcd8739ae039);
    var $3VFsf;
    var $erX9x;
    var $65MS1;
    var $6Vrdy;
    var $7vTvv;
    var $bahqM;
    function $7d5c63a9e257cb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
        (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("7vTvv")).AXIS_TYPES), function(v, axisType) {
            var defaultOption = (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).merge)({}, (0, (0, parcelRequire("erX9x")).default)[axisType], true), extraDefaultOption, true);
            var AxisModel = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(AxisModel, _super);
                function AxisModel() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.type = axisName + 'Axis.' + axisType;
                    return _this;
                }
                AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                    var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
                    var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
                    var themeModel = ecModel.getTheme();
                    (0, (0, parcelRequire("bahqM")).merge)(option, themeModel.get(axisType + 'Axis'));
                    (0, (0, parcelRequire("bahqM")).merge)(option, this.getDefaultOption());
                    option.type = $7d5c63a9e257cb04$var$getAxisType(option);
                    if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
                };
                AxisModel.prototype.optionUpdated = function() {
                    var thisOption = this.option;
                    if (thisOption.type === 'category') this.__ordinalMeta = (0, (0, parcelRequire("6Vrdy")).default).createByAxisModel(this);
                };
                AxisModel.prototype.getCategories = function(rawData) {
                    var option = this.option;
                    if (option.type === 'category') {
                        if (rawData) return option.data;
                        return this.__ordinalMeta.categories;
                    }
                };
                AxisModel.prototype.getOrdinalMeta = function() {
                    return this.__ordinalMeta;
                };
                AxisModel.type = axisName + 'Axis.' + axisType;
                AxisModel.defaultOption = defaultOption;
                return AxisModel;
            }(BaseAxisModelClass);
            registers.registerComponentModel(AxisModel);
        });
        registers.registerSubTypeDefaulter(axisName + 'Axis', $7d5c63a9e257cb04$var$getAxisType);
    }
    function $7d5c63a9e257cb04$var$getAxisType(option) {
        return option.type || (option.data ? 'category' : 'value');
    }
});
parcelRegister("erX9x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a85178cf0b0fc4bc$export$2e2bcd8739ae039);
    var $bahqM;
    var $a85178cf0b0fc4bc$var$defaultOption = {
        show: true,
        zlevel: 0,
        z: 0,
        inverse: false,
        name: '',
        nameLocation: 'end',
        nameRotate: null,
        nameTruncate: {
            maxWidth: null,
            ellipsis: '...',
            placeholder: '.'
        },
        nameTextStyle: {},
        nameGap: 15,
        silent: false,
        triggerEvent: false,
        tooltip: {
            show: false
        },
        axisPointer: {},
        axisLine: {
            show: true,
            onZero: true,
            onZeroAxisIndex: null,
            lineStyle: {
                color: '#6E7079',
                width: 1,
                type: 'solid'
            },
            symbol: [
                'none',
                'none'
            ],
            symbolSize: [
                10,
                15
            ]
        },
        axisTick: {
            show: true,
            inside: false,
            length: 5,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            inside: false,
            rotate: 0,
            showMinLabel: null,
            showMaxLabel: null,
            margin: 8,
            fontSize: 12
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: [
                    '#E0E6F1'
                ],
                width: 1,
                type: 'solid'
            }
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: [
                    'rgba(250,250,250,0.2)',
                    'rgba(210,219,238,0.2)'
                ]
            }
        }
    };
    var $a85178cf0b0fc4bc$var$categoryAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: true,
        deduplication: null,
        splitLine: {
            show: false
        },
        axisTick: {
            alignWithLabel: false,
            interval: 'auto'
        },
        axisLabel: {
            interval: 'auto'
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$valueAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: [
            0,
            0
        ],
        axisLine: {
            show: 'auto'
        },
        axisTick: {
            show: 'auto'
        },
        splitNumber: 5,
        minorTick: {
            show: false,
            splitNumber: 5,
            length: 3,
            lineStyle: {}
        },
        minorSplitLine: {
            show: false,
            lineStyle: {
                color: '#F4F7FD',
                width: 1
            }
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$timeAxis = (0, parcelRequire("bahqM")).merge({
        scale: true,
        splitNumber: 6,
        axisLabel: {
            showMinLabel: false,
            showMaxLabel: false,
            rich: {
                primary: {
                    fontWeight: 'bold'
                }
            }
        },
        splitLine: {
            show: false
        }
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$var$logAxis = (0, parcelRequire("bahqM")).defaults({
        scale: true,
        logBase: 10
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$export$2e2bcd8739ae039 = {
        category: $a85178cf0b0fc4bc$var$categoryAxis,
        value: $a85178cf0b0fc4bc$var$valueAxis,
        time: $a85178cf0b0fc4bc$var$timeAxis,
        log: $a85178cf0b0fc4bc$var$logAxis
    };
});
parcelRegister("6Vrdy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50ad2dcdb048637a$export$2e2bcd8739ae039);
    var $bahqM;
    var $50ad2dcdb048637a$var$uidBase = 0;
    var $50ad2dcdb048637a$var$OrdinalMeta = function() {
        function OrdinalMeta(opt) {
            this.categories = opt.categories || [];
            this._needCollect = opt.needCollect;
            this._deduplication = opt.deduplication;
            this.uid = ++$50ad2dcdb048637a$var$uidBase;
        }
        OrdinalMeta.createByAxisModel = function(axisModel) {
            var option = axisModel.option;
            var data = option.data;
            var categories = data && (0, (0, parcelRequire("bahqM")).map)(data, $50ad2dcdb048637a$var$getName);
            return new OrdinalMeta({
                categories: categories,
                needCollect: !categories,
                deduplication: option.dedplication !== false
            });
        };
        OrdinalMeta.prototype.getOrdinal = function(category) {
            return this._getOrCreateMap().get(category);
        };
        OrdinalMeta.prototype.parseAndCollect = function(category) {
            var index;
            var needCollect = this._needCollect;
            if (typeof category !== 'string' && !needCollect) return category;
            if (needCollect && !this._deduplication) {
                index = this.categories.length;
                this.categories[index] = category;
                return index;
            }
            var map = this._getOrCreateMap();
            index = map.get(category);
            if (index == null) {
                if (needCollect) {
                    index = this.categories.length;
                    this.categories[index] = category;
                    map.set(category, index);
                } else index = NaN;
            }
            return index;
        };
        OrdinalMeta.prototype._getOrCreateMap = function() {
            return this._map || (this._map = (0, (0, parcelRequire("bahqM")).createHashMap)(this.categories));
        };
        return OrdinalMeta;
    }();
    function $50ad2dcdb048637a$var$getName(obj) {
        if ((0, (0, parcelRequire("bahqM")).isObject)(obj) && obj.value != null) return obj.value;
        else return obj + '';
    }
    var $50ad2dcdb048637a$export$2e2bcd8739ae039 = $50ad2dcdb048637a$var$OrdinalMeta;
});
parcelRegister("7vTvv", function(module, exports) {
    $parcel$export(module.exports, "AXIS_TYPES", ()=>$57867c39181fdac2$export$2e0057d176d6f690);
    var $57867c39181fdac2$export$2e0057d176d6f690 = {
        value: 1,
        category: 1,
        time: 1,
        log: 1
    };
});
parcelRegister("1xCHp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11f6e45ff2a10529$export$2e2bcd8739ae039);
    var $bahqM;
    var $65MS1;
    var $3GIoT;
    var $SsPct;
    var $kBKMx;
    var $eaKsF;
    var $dBIJY;
    var $11f6e45ff2a10529$var$Grid = function() {
        function Grid(gridModel, ecModel, api) {
            this.type = 'grid';
            this._coordsMap = {};
            this._coordsList = [];
            this._axesMap = {};
            this._axesList = [];
            this.axisPointerEnabled = true;
            this.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
            this._initCartesian(gridModel, ecModel, api);
            this.model = gridModel;
        }
        Grid.prototype.getRect = function() {
            return this._rect;
        };
        Grid.prototype.update = function(ecModel, api) {
            var axesMap = this._axesMap;
            this._updateScale(ecModel, this.model);
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(xAxis.scale, xAxis.model);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(yAxis.scale, yAxis.model);
            });
            var onZeroRecords = {};
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
            });
            this.resize(this.model, api);
        };
        Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
            var boxLayoutParams = gridModel.getBoxLayoutParams();
            var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
            var gridRect = (0, (0, parcelRequire("65MS1")).getLayoutRect)(boxLayoutParams, {
                width: api.getWidth(),
                height: api.getHeight()
            });
            this._rect = gridRect;
            var axesList = this._axesList;
            adjustAxes();
            if (isContainLabel) {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    if (!axis.model.get([
                        'axisLabel',
                        'inside'
                    ])) {
                        var labelUnionRect = (0, (0, parcelRequire("3GIoT")).estimateLabelUnionRect)(axis);
                        if (labelUnionRect) {
                            var dim = axis.isHorizontal() ? 'height' : 'width';
                            var margin = axis.model.get([
                                'axisLabel',
                                'margin'
                            ]);
                            gridRect[dim] -= labelUnionRect[dim] + margin;
                            if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                            else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                        }
                    }
                });
                adjustAxes();
            }
            (0, (0, parcelRequire("bahqM")).each)(this._coordsList, function(coord) {
                coord.calcAffineTransform();
            });
            function adjustAxes() {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    var isHorizontal = axis.isHorizontal();
                    var extent = isHorizontal ? [
                        0,
                        gridRect.width
                    ] : [
                        0,
                        gridRect.height
                    ];
                    var idx = axis.inverse ? 1 : 0;
                    axis.setExtent(extent[idx], extent[1 - idx]);
                    $11f6e45ff2a10529$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
                });
            }
        };
        Grid.prototype.getAxis = function(dim, axisIndex) {
            var axesMapOnDim = this._axesMap[dim];
            if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
        };
        Grid.prototype.getAxes = function() {
            return this._axesList.slice();
        };
        Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
            if (xAxisIndex != null && yAxisIndex != null) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                return this._coordsMap[key];
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(xAxisIndex)) {
                yAxisIndex = xAxisIndex.yAxisIndex;
                xAxisIndex = xAxisIndex.xAxisIndex;
            }
            for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
                if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
            }
        };
        Grid.prototype.getCartesians = function() {
            return this._coordsList.slice();
        };
        Grid.prototype.convertToPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
        };
        Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
        };
        Grid.prototype._findConvertTarget = function(finder) {
            var seriesModel = finder.seriesModel;
            var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var gridModel = finder.gridModel;
            var coordsList = this._coordsList;
            var cartesian;
            var axis;
            if (seriesModel) {
                cartesian = seriesModel.coordinateSystem;
                (0, (0, parcelRequire("bahqM")).indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
            } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
            else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
            else if (gridModel) {
                var grid = gridModel.coordinateSystem;
                if (grid === this) cartesian = this._coordsList[0];
            }
            return {
                cartesian: cartesian,
                axis: axis
            };
        };
        Grid.prototype.containPoint = function(point) {
            var coord = this._coordsList[0];
            if (coord) return coord.containPoint(point);
        };
        Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
            var _this = this;
            var grid = this;
            var axisPositionUsed = {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
            var axesMap = {
                x: {},
                y: {}
            };
            var axesCount = {
                x: 0,
                y: 0
            };
            ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
            ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
            if (!axesCount.x || !axesCount.y) {
                this._axesMap = {};
                this._axesList = [];
                return;
            }
            this._axesMap = axesMap;
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis, xAxisIndex) {
                (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis, yAxisIndex) {
                    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                    var cartesian = new (0, (0, parcelRequire("SsPct")).default)(key);
                    cartesian.master = _this;
                    cartesian.model = gridModel;
                    _this._coordsMap[key] = cartesian;
                    _this._coordsList.push(cartesian);
                    cartesian.addAxis(xAxis);
                    cartesian.addAxis(yAxis);
                });
            });
            function createAxisCreator(dimName) {
                return function(axisModel, idx) {
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                    var axisPosition = axisModel.get('position');
                    if (dimName === 'x') {
                        if (axisPosition !== 'top' && axisPosition !== 'bottom') axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                    } else if (axisPosition !== 'left' && axisPosition !== 'right') axisPosition = axisPositionUsed.left ? 'right' : 'left';
                    axisPositionUsed[axisPosition] = true;
                    var axis = new (0, (0, parcelRequire("kBKMx")).default)(dimName, (0, (0, parcelRequire("3GIoT")).createScaleByModel)(axisModel), [
                        0,
                        0
                    ], axisModel.get('type'), axisPosition);
                    var isCategory = axis.type === 'category';
                    axis.onBand = isCategory && axisModel.get('boundaryGap');
                    axis.inverse = axisModel.get('inverse');
                    axisModel.axis = axis;
                    axis.model = axisModel;
                    axis.grid = grid;
                    axis.index = idx;
                    grid._axesList.push(axis);
                    axesMap[dimName][idx] = axis;
                    axesCount[dimName]++;
                };
            }
        };
        Grid.prototype._updateScale = function(ecModel, gridModel) {
            (0, (0, parcelRequire("bahqM")).each)(this._axesList, function(axis) {
                axis.scale.setExtent(Infinity, -Infinity);
                if (axis.type === 'category') {
                    var categorySortInfo = axis.model.get('categorySortInfo');
                    axis.scale.setSortInfo(categorySortInfo);
                }
            });
            ecModel.eachSeries(function(seriesModel) {
                if ((0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) {
                    var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                    var xAxisModel = axesModelMap.xAxisModel;
                    var yAxisModel = axesModelMap.yAxisModel;
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$11f6e45ff2a10529$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                    var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                    var data = seriesModel.getData();
                    var xAxis = cartesian.getAxis('x');
                    var yAxis = cartesian.getAxis('y');
                    if (data.type === 'list') {
                        unionExtent(data, xAxis);
                        unionExtent(data, yAxis);
                    }
                }
            }, this);
            function unionExtent(data, axis) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("3GIoT")).getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                    axis.scale.unionExtentFromData(data, dim);
                });
            }
        };
        Grid.prototype.getTooltipAxes = function(dim) {
            var baseAxes = [];
            var otherAxes = [];
            (0, (0, parcelRequire("bahqM")).each)(this.getCartesians(), function(cartesian) {
                var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
                var otherAxis = cartesian.getOtherAxis(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
            });
            return {
                baseAxes: baseAxes,
                otherAxes: otherAxes
            };
        };
        Grid.create = function(ecModel, api) {
            var grids = [];
            ecModel.eachComponent('grid', function(gridModel, idx) {
                var grid = new Grid(gridModel, ecModel, api);
                grid.name = 'grid_' + idx;
                grid.resize(gridModel, api, true);
                gridModel.coordinateSystem = grid;
                grids.push(grid);
            });
            ecModel.eachSeries(function(seriesModel) {
                if (!(0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) return;
                var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            });
            return grids;
        };
        Grid.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
        return Grid;
    }();
    function $11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel) {
        return axisModel.getCoordSysModel() === gridModel;
    }
    function $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
        axis.getAxesOnZeroOf = function() {
            return otherAxisOnZeroOf ? [
                otherAxisOnZeroOf
            ] : [];
        };
        var otherAxes = axesMap[otherAxisDim];
        var otherAxisOnZeroOf;
        var axisModel = axis.model;
        var onZero = axisModel.get([
            'axisLine',
            'onZero'
        ]);
        var onZeroAxisIndex = axisModel.get([
            'axisLine',
            'onZeroAxisIndex'
        ]);
        if (!onZero) return;
        if (onZeroAxisIndex != null) {
            if ($11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
        } else {
            for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
                otherAxisOnZeroOf = otherAxes[idx];
                break;
            }
        }
        if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
        function getOnZeroRecordKey(axis) {
            return axis.dim + '_' + axis.index;
        }
    }
    function $11f6e45ff2a10529$var$canOnZeroToAxis(axis) {
        return axis && axis.type !== 'category' && axis.type !== 'time' && (0, (0, parcelRequire("3GIoT")).ifAxisCrossZero)(axis);
    }
    function $11f6e45ff2a10529$var$updateAxisTransform(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var axisExtentSum = axisExtent[0] + axisExtent[1];
        axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
        axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
    }
    var $11f6e45ff2a10529$export$2e2bcd8739ae039 = $11f6e45ff2a10529$var$Grid;
});
parcelRegister("3GIoT", function(module, exports) {
    $parcel$export(module.exports, "getScaleExtent", ()=>$2af7bc5b57211b12$export$9c0ba8df7eb7b328);
    $parcel$export(module.exports, "niceScaleExtent", ()=>$2af7bc5b57211b12$export$51f3e70a54405d5a);
    $parcel$export(module.exports, "createScaleByModel", ()=>$2af7bc5b57211b12$export$8941c4cacdc8f5a5);
    $parcel$export(module.exports, "ifAxisCrossZero", ()=>$2af7bc5b57211b12$export$3eac36a69f37d52);
    $parcel$export(module.exports, "makeLabelFormatter", ()=>$2af7bc5b57211b12$export$742f19a75415b2ae);
    $parcel$export(module.exports, "getAxisRawValue", ()=>$2af7bc5b57211b12$export$a5a32f324c1fa457);
    $parcel$export(module.exports, "estimateLabelUnionRect", ()=>$2af7bc5b57211b12$export$fef1c7f0af0b48d);
    $parcel$export(module.exports, "getOptionCategoryInterval", ()=>$2af7bc5b57211b12$export$6d0bc2429155c088);
    $parcel$export(module.exports, "shouldShowAllLabels", ()=>$2af7bc5b57211b12$export$c2911c025243d6a6);
    $parcel$export(module.exports, "getDataDimensionsOnAxis", ()=>$2af7bc5b57211b12$export$e4cf30b1e74cd69d);
    $parcel$export(module.exports, "unionAxisExtentFromData", ()=>$2af7bc5b57211b12$export$635fe7f20d0f4c70);
    var $bahqM;
    var $acOy6;
    var $6kObD;
    var $fEgWg;
    var $eL4bi;
    var $1E3E8;
    var $1MU9l;
    var $73kgw;
    var $5R8Hi;
    var $lo2Vo;
    function $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model) {
        var scaleType = scale.type;
        var rawExtentResult = (0, (0, parcelRequire("lo2Vo")).ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
        scale.setBlank(rawExtentResult.isBlank);
        var min = rawExtentResult.min;
        var max = rawExtentResult.max;
        var ecModel = model.ecModel;
        if (ecModel && scaleType === 'time') {
            var barSeriesModels = (0, (0, parcelRequire("eL4bi")).prepareLayoutBarSeries)('bar', ecModel);
            var isBaseAxisAndHasBarSeries_1 = false;
            (0, parcelRequire("bahqM")).each(barSeriesModels, function(seriesModel) {
                isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
            });
            if (isBaseAxisAndHasBarSeries_1) {
                var barWidthAndOffset = (0, (0, parcelRequire("eL4bi")).makeColumnLayout)(barSeriesModels);
                var adjustedScale = $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
                min = adjustedScale.min;
                max = adjustedScale.max;
            }
        }
        return {
            extent: [
                min,
                max
            ],
            fixMin: rawExtentResult.minFixed,
            fixMax: rawExtentResult.maxFixed
        };
    }
    function $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
        var axisExtent = model.axis.getExtent();
        var axisLength = axisExtent[1] - axisExtent[0];
        var barsOnCurrentAxis = (0, (0, parcelRequire("eL4bi")).retrieveColumnLayout)(barWidthAndOffset, model.axis);
        if (barsOnCurrentAxis === undefined) return {
            min: min,
            max: max
        };
        var minOverflow = Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            minOverflow = Math.min(item.offset, minOverflow);
        });
        var maxOverflow = -Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            maxOverflow = Math.max(item.offset + item.width, maxOverflow);
        });
        minOverflow = Math.abs(minOverflow);
        maxOverflow = Math.abs(maxOverflow);
        var totalOverFlow = minOverflow + maxOverflow;
        var oldRange = max - min;
        var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
        var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
        max += overflowBuffer * (maxOverflow / totalOverFlow);
        min -= overflowBuffer * (minOverflow / totalOverFlow);
        return {
            min: min,
            max: max
        };
    }
    function $2af7bc5b57211b12$export$51f3e70a54405d5a(scale, inModel) {
        var model = inModel;
        var extentInfo = $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model);
        var extent = extentInfo.extent;
        var splitNumber = model.get('splitNumber');
        if (scale instanceof (0, (0, parcelRequire("73kgw")).default)) scale.base = model.get('logBase');
        var scaleType = scale.type;
        scale.setExtent(extent[0], extent[1]);
        scale.niceExtent({
            splitNumber: splitNumber,
            fixMin: extentInfo.fixMin,
            fixMax: extentInfo.fixMax,
            minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
            maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
        });
        var interval = model.get('interval');
        if (interval != null) scale.setInterval && scale.setInterval(interval);
    }
    function $2af7bc5b57211b12$export$8941c4cacdc8f5a5(model, axisType) {
        axisType = axisType || model.get('type');
        if (axisType) switch(axisType){
            case 'category':
                return new (0, (0, parcelRequire("acOy6")).default)({
                    ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                    extent: [
                        Infinity,
                        -Infinity
                    ]
                });
            case 'time':
                return new (0, (0, parcelRequire("1MU9l")).default)({
                    locale: model.ecModel.getLocaleModel(),
                    useUTC: model.ecModel.get('useUTC')
                });
            default:
                return new ((0, (0, parcelRequire("fEgWg")).default).getClass(axisType) || (0, (0, parcelRequire("6kObD")).default))();
        }
    }
    function $2af7bc5b57211b12$export$3eac36a69f37d52(axis) {
        var dataExtent = axis.scale.getExtent();
        var min = dataExtent[0];
        var max = dataExtent[1];
        return !(min > 0 && max > 0 || min < 0 && max < 0);
    }
    function $2af7bc5b57211b12$export$742f19a75415b2ae(axis) {
        var labelFormatter = axis.getLabelModel().get('formatter');
        var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
        if (axis.scale.type === 'time') return function(tpl) {
            return function(tick, idx) {
                return axis.scale.getFormattedLabel(tick, idx, tpl);
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'string') return function(tpl) {
            return function(tick) {
                var label = axis.scale.getLabel(tick);
                var text = tpl.replace('{value}', label != null ? label : '');
                return text;
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'function') return function(cb) {
            return function(tick, idx) {
                if (categoryTickStart != null) idx = tick.value - categoryTickStart;
                return cb($2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                    level: tick.level
                } : null);
            };
        }(labelFormatter);
        else return function(tick) {
            return axis.scale.getLabel(tick);
        };
    }
    function $2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick) {
        return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
    }
    function $2af7bc5b57211b12$export$fef1c7f0af0b48d(axis) {
        var axisModel = axis.model;
        var scale = axis.scale;
        if (!axisModel.get([
            'axisLabel',
            'show'
        ]) || scale.isBlank()) return;
        var realNumberScaleTicks;
        var tickCount;
        var categoryScaleExtent = scale.getExtent();
        if (scale instanceof (0, (0, parcelRequire("acOy6")).default)) tickCount = scale.count();
        else {
            realNumberScaleTicks = scale.getTicks();
            tickCount = realNumberScaleTicks.length;
        }
        var axisLabelModel = axis.getLabelModel();
        var labelFormatter = $2af7bc5b57211b12$export$742f19a75415b2ae(axis);
        var rect;
        var step = 1;
        if (tickCount > 40) step = Math.ceil(tickCount / 40);
        for(var i = 0; i < tickCount; i += step){
            var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
                value: categoryScaleExtent[0] + i
            };
            var label = labelFormatter(tick, i);
            var unrotatedSingleRect = axisLabelModel.getTextRect(label);
            var singleRect = $2af7bc5b57211b12$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
            rect ? rect.union(singleRect) : rect = singleRect;
        }
        return rect;
    }
    function $2af7bc5b57211b12$var$rotateTextRect(textRect, rotate) {
        var rotateRadians = rotate * Math.PI / 180;
        var beforeWidth = textRect.width;
        var beforeHeight = textRect.height;
        var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
        var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
        var rotatedRect = new (0, (0, parcelRequire("1E3E8")).default)(textRect.x, textRect.y, afterWidth, afterHeight);
        return rotatedRect;
    }
    function $2af7bc5b57211b12$export$6d0bc2429155c088(model) {
        var interval = model.get('interval');
        return interval == null ? 'auto' : interval;
    }
    function $2af7bc5b57211b12$export$c2911c025243d6a6(axis) {
        return axis.type === 'category' && $2af7bc5b57211b12$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
    }
    function $2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim) {
        var dataDimMap = {};
        (0, parcelRequire("bahqM")).each(data.mapDimensionsAll(axisDim), function(dataDim) {
            dataDimMap[(0, (0, parcelRequire("5R8Hi")).getStackedDimension)(data, dataDim)] = true;
        });
        return (0, parcelRequire("bahqM")).keys(dataDimMap);
    }
    function $2af7bc5b57211b12$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
        if (data) (0, parcelRequire("bahqM")).each($2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
            var seriesExtent = data.getApproximateExtent(dim);
            seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
            seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
        });
    }
});
parcelRegister("acOy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76e23c609ca21282$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fEgWg;
    var $6Vrdy;
    var $32MHg;
    var $bahqM;
    var $76e23c609ca21282$var$OrdinalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OrdinalScale, _super);
        function OrdinalScale(setting) {
            var _this = _super.call(this, setting) || this;
            _this.type = 'ordinal';
            var ordinalMeta = _this.getSetting('ordinalMeta');
            if (!ordinalMeta) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({});
            if ((0, (0, parcelRequire("bahqM")).isArray)(ordinalMeta)) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({
                categories: (0, (0, parcelRequire("bahqM")).map)(ordinalMeta, function(item) {
                    return (0, (0, parcelRequire("bahqM")).isObject)(item) ? item.value : item;
                })
            });
            _this._ordinalMeta = ordinalMeta;
            _this._extent = _this.getSetting('extent') || [
                0,
                ordinalMeta.categories.length - 1
            ];
            return _this;
        }
        OrdinalScale.prototype.parse = function(val) {
            return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
        };
        OrdinalScale.prototype.contain = function(rank) {
            rank = this.parse(rank);
            return (0, parcelRequire("32MHg")).contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
        };
        OrdinalScale.prototype.normalize = function(val) {
            val = this._getTickNumber(this.parse(val));
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        OrdinalScale.prototype.scale = function(val) {
            val = Math.round((0, parcelRequire("32MHg")).scale(val, this._extent));
            return this.getRawOrdinalNumber(val);
        };
        OrdinalScale.prototype.getTicks = function() {
            var ticks = [];
            var extent = this._extent;
            var rank = extent[0];
            while(rank <= extent[1]){
                ticks.push({
                    value: rank
                });
                rank++;
            }
            return ticks;
        };
        OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
            return;
        };
        OrdinalScale.prototype.setSortInfo = function(info) {
            if (info == null) {
                this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
                return;
            }
            var infoOrdinalNumbers = info.ordinalNumbers;
            var ordinalsByTick = this._ordinalNumbersByTick = [];
            var ticksByOrdinal = this._ticksByOrdinalNumber = [];
            var tickNum = 0;
            var allCategoryLen = this._ordinalMeta.categories.length;
            for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
                var ordinalNumber = infoOrdinalNumbers[tickNum];
                ordinalsByTick[tickNum] = ordinalNumber;
                ticksByOrdinal[ordinalNumber] = tickNum;
            }
            var unusedOrdinal = 0;
            for(; tickNum < allCategoryLen; ++tickNum){
                while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
                ordinalsByTick.push(unusedOrdinal);
                ticksByOrdinal[unusedOrdinal] = tickNum;
            }
        };
        OrdinalScale.prototype._getTickNumber = function(ordinal) {
            var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
            return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
        };
        OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
            var ordinalNumbersByTick = this._ordinalNumbersByTick;
            return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
        };
        OrdinalScale.prototype.getLabel = function(tick) {
            if (!this.isBlank()) {
                var ordinalNumber = this.getRawOrdinalNumber(tick.value);
                var cateogry = this._ordinalMeta.categories[ordinalNumber];
                return cateogry == null ? '' : cateogry + '';
            }
        };
        OrdinalScale.prototype.count = function() {
            return this._extent[1] - this._extent[0] + 1;
        };
        OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        OrdinalScale.prototype.isInExtentRange = function(value) {
            value = this._getTickNumber(value);
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        OrdinalScale.prototype.getOrdinalMeta = function() {
            return this._ordinalMeta;
        };
        OrdinalScale.prototype.niceTicks = function() {};
        OrdinalScale.prototype.niceExtent = function() {};
        OrdinalScale.type = 'ordinal';
        return OrdinalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($76e23c609ca21282$var$OrdinalScale);
    var $76e23c609ca21282$export$2e2bcd8739ae039 = $76e23c609ca21282$var$OrdinalScale;
});
parcelRegister("fEgWg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b647bb1e30834d31$export$2e2bcd8739ae039);
    var $aLwh0;
    var $b647bb1e30834d31$var$Scale = function() {
        function Scale(setting) {
            this._setting = setting || {};
            this._extent = [
                Infinity,
                -Infinity
            ];
        }
        Scale.prototype.getSetting = function(name) {
            return this._setting[name];
        };
        Scale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
        };
        Scale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        Scale.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Scale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = start;
            if (!isNaN(end)) thisExtent[1] = end;
        };
        Scale.prototype.isInExtentRange = function(value) {
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        Scale.prototype.isBlank = function() {
            return this._isBlank;
        };
        Scale.prototype.setBlank = function(isBlank) {
            this._isBlank = isBlank;
        };
        return Scale;
    }();
    (0, parcelRequire("aLwh0")).enableClassManagement($b647bb1e30834d31$var$Scale);
    var $b647bb1e30834d31$export$2e2bcd8739ae039 = $b647bb1e30834d31$var$Scale;
});
parcelRegister("32MHg", function(module, exports) {
    $parcel$export(module.exports, "intervalScaleNiceTicks", ()=>$2377552e030bbd2b$export$eeea879a611eb991);
    $parcel$export(module.exports, "getIntervalPrecision", ()=>$2377552e030bbd2b$export$86a060b060d3d31a);
    $parcel$export(module.exports, "contain", ()=>$2377552e030bbd2b$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "normalize", ()=>$2377552e030bbd2b$export$a3295358bff77e);
    $parcel$export(module.exports, "scale", ()=>$2377552e030bbd2b$export$dcdf75081b88279d);
    var $jmSNG;
    var $2377552e030bbd2b$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    function $2377552e030bbd2b$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
        var result = {};
        var span = extent[1] - extent[0];
        var interval = result.interval = (0, parcelRequire("jmSNG")).nice(span / splitNumber, true);
        if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
        if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
        var precision = result.intervalPrecision = $2377552e030bbd2b$export$86a060b060d3d31a(interval);
        var niceTickExtent = result.niceTickExtent = [
            $2377552e030bbd2b$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
            $2377552e030bbd2b$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
        ];
        $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent);
        return result;
    }
    function $2377552e030bbd2b$export$86a060b060d3d31a(interval) {
        return (0, parcelRequire("jmSNG")).getPrecision(interval) + 2;
    }
    function $2377552e030bbd2b$var$clamp(niceTickExtent, idx, extent) {
        niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
    }
    function $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent) {
        !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
        !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 0, extent);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 1, extent);
        if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
    }
    function $2377552e030bbd2b$export$8893e2b90ba10d92(val, extent) {
        return val >= extent[0] && val <= extent[1];
    }
    function $2377552e030bbd2b$export$a3295358bff77e(val, extent) {
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    }
    function $2377552e030bbd2b$export$dcdf75081b88279d(val, extent) {
        return val * (extent[1] - extent[0]) + extent[0];
    }
});
parcelRegister("6kObD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49cb8a61b3174199$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $dCJrM;
    var $fEgWg;
    var $32MHg;
    var $49cb8a61b3174199$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    var $49cb8a61b3174199$var$IntervalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IntervalScale, _super);
        function IntervalScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'interval';
            _this._interval = 0;
            _this._intervalPrecision = 2;
            return _this;
        }
        IntervalScale.prototype.parse = function(val) {
            return val;
        };
        IntervalScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        IntervalScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        IntervalScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        IntervalScale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = parseFloat(start);
            if (!isNaN(end)) thisExtent[1] = parseFloat(end);
        };
        IntervalScale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
            this.setExtent(extent[0], extent[1]);
        };
        IntervalScale.prototype.getInterval = function() {
            return this._interval;
        };
        IntervalScale.prototype.setInterval = function(interval) {
            this._interval = interval;
            this._niceExtent = this._extent.slice();
            this._intervalPrecision = (0, parcelRequire("32MHg")).getIntervalPrecision(interval);
        };
        IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var niceTickExtent = this._niceExtent;
            var intervalPrecision = this._intervalPrecision;
            var ticks = [];
            if (!interval) return ticks;
            var safeLimit = 10000;
            if (extent[0] < niceTickExtent[0]) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[0]
                });
            }
            var tick = niceTickExtent[0];
            while(tick <= niceTickExtent[1]){
                ticks.push({
                    value: tick
                });
                tick = $49cb8a61b3174199$var$roundNumber(tick + interval, intervalPrecision);
                if (tick === ticks[ticks.length - 1].value) break;
                if (ticks.length > safeLimit) return [];
            }
            var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
            if (extent[1] > lastNiceTick) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(lastNiceTick + interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[1]
                });
            }
            return ticks;
        };
        IntervalScale.prototype.getMinorTicks = function(splitNumber) {
            var ticks = this.getTicks(true);
            var minorTicks = [];
            var extent = this.getExtent();
            for(var i = 1; i < ticks.length; i++){
                var nextTick = ticks[i];
                var prevTick = ticks[i - 1];
                var count = 0;
                var minorTicksGroup = [];
                var interval = nextTick.value - prevTick.value;
                var minorInterval = interval / splitNumber;
                while(count < splitNumber - 1){
                    var minorTick = $49cb8a61b3174199$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                    if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                    count++;
                }
                minorTicks.push(minorTicksGroup);
            }
            return minorTicks;
        };
        IntervalScale.prototype.getLabel = function(data, opt) {
            if (data == null) return '';
            var precision = opt && opt.precision;
            if (precision == null) precision = (0, parcelRequire("jmSNG")).getPrecision(data.value) || 0;
            else if (precision === 'auto') precision = this._intervalPrecision;
            var dataNum = $49cb8a61b3174199$var$roundNumber(data.value, precision, true);
            return (0, parcelRequire("dCJrM")).addCommas(dataNum);
        };
        IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
            splitNumber = splitNumber || 5;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (!isFinite(span)) return;
            if (span < 0) {
                span = -span;
                extent.reverse();
            }
            var result = (0, parcelRequire("32MHg")).intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
            this._intervalPrecision = result.intervalPrecision;
            this._interval = result.interval;
            this._niceExtent = result.niceTickExtent;
        };
        IntervalScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                if (extent[0] !== 0) {
                    var expandSize = extent[0];
                    if (!opt.fixMax) {
                        extent[1] += expandSize / 2;
                        extent[0] -= expandSize / 2;
                    } else extent[0] -= expandSize / 2;
                } else extent[1] = 1;
            }
            var span = extent[1] - extent[0];
            if (!isFinite(span)) {
                extent[0] = 0;
                extent[1] = 1;
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
            var interval = this._interval;
            if (!opt.fixMin) extent[0] = $49cb8a61b3174199$var$roundNumber(Math.floor(extent[0] / interval) * interval);
            if (!opt.fixMax) extent[1] = $49cb8a61b3174199$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
        };
        IntervalScale.type = 'interval';
        return IntervalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($49cb8a61b3174199$var$IntervalScale);
    var $49cb8a61b3174199$export$2e2bcd8739ae039 = $49cb8a61b3174199$var$IntervalScale;
});
parcelRegister("eL4bi", function(module, exports) {
    $parcel$export(module.exports, "getLayoutOnAxis", ()=>$abe8b2c5f70c8df4$export$658df087977b9e84);
    $parcel$export(module.exports, "prepareLayoutBarSeries", ()=>$abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4);
    $parcel$export(module.exports, "makeColumnLayout", ()=>$abe8b2c5f70c8df4$export$20769dafc84e0299);
    $parcel$export(module.exports, "retrieveColumnLayout", ()=>$abe8b2c5f70c8df4$export$35920bb6556da1c2);
    $parcel$export(module.exports, "layout", ()=>$abe8b2c5f70c8df4$export$b3219800bda33a1f);
    $parcel$export(module.exports, "largeLayout", ()=>$abe8b2c5f70c8df4$export$1fcd87ee6628f095);
    var $bahqM;
    var $jmSNG;
    var $5R8Hi;
    var $9irlK;
    var $abe8b2c5f70c8df4$var$STACK_PREFIX = '__ec_stack_';
    var $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH = 0.5;
    var $abe8b2c5f70c8df4$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
    function $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel) {
        return seriesModel.get('stack') || $abe8b2c5f70c8df4$var$STACK_PREFIX + seriesModel.seriesIndex;
    }
    function $abe8b2c5f70c8df4$var$getAxisKey(axis) {
        return axis.dim + axis.index;
    }
    function $abe8b2c5f70c8df4$export$658df087977b9e84(opt) {
        var params = [];
        var baseAxis = opt.axis;
        var axisKey = 'axis0';
        if (baseAxis.type !== 'category') return;
        var bandWidth = baseAxis.getBandWidth();
        for(var i = 0; i < opt.count || 0; i++)params.push((0, parcelRequire("bahqM")).defaults({
            bandWidth: bandWidth,
            axisKey: axisKey,
            stackId: $abe8b2c5f70c8df4$var$STACK_PREFIX + i
        }, opt));
        var widthAndOffsets = $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(params);
        var result = [];
        for(var i = 0; i < opt.count; i++){
            var item = widthAndOffsets[axisKey][$abe8b2c5f70c8df4$var$STACK_PREFIX + i];
            item.offsetCenter = item.offset + item.width / 2;
            result.push(item);
        }
        return result;
    }
    function $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
        var seriesModels = [];
        ecModel.eachSeriesByType(seriesType, function(seriesModel) {
            if ($abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) && !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
        });
        return seriesModels;
    }
    function $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries) {
        var axisValues = {};
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
            var data = seriesModel.getData();
            var key = baseAxis.dim + '_' + baseAxis.index;
            var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var store = data.getStore();
            for(var i = 0, cnt = store.count(); i < cnt; ++i){
                var value = store.get(dimIdx, i);
                if (!axisValues[key]) axisValues[key] = [
                    value
                ];
                else axisValues[key].push(value);
            }
        });
        var axisMinGaps = {};
        for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
            var valuesInAxis = axisValues[key];
            if (valuesInAxis) {
                valuesInAxis.sort(function(a, b) {
                    return a - b;
                });
                var min = null;
                for(var j = 1; j < valuesInAxis.length; ++j){
                    var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                    if (delta > 0) min = min === null ? delta : Math.min(min, delta);
                }
                axisMinGaps[key] = min;
            }
        }
        return axisMinGaps;
    }
    function $abe8b2c5f70c8df4$export$20769dafc84e0299(barSeries) {
        var axisMinGaps = $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries);
        var seriesInfoList = [];
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var axisExtent = baseAxis.getExtent();
            var bandWidth;
            if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
            else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                var minGap = axisMinGaps[key];
                var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
                var scale = baseAxis.scale.getExtent();
                var scaleSpan = Math.abs(scale[1] - scale[0]);
                bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan;
            } else {
                var data = seriesModel.getData();
                bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
            }
            var barWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barWidth'), bandWidth);
            var barMaxWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
            var barMinWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMinWidth') || 1, bandWidth);
            var barGap = seriesModel.get('barGap');
            var barCategoryGap = seriesModel.get('barCategoryGap');
            seriesInfoList.push({
                bandWidth: bandWidth,
                barWidth: barWidth,
                barMaxWidth: barMaxWidth,
                barMinWidth: barMinWidth,
                barGap: barGap,
                barCategoryGap: barCategoryGap,
                axisKey: $abe8b2c5f70c8df4$var$getAxisKey(baseAxis),
                stackId: $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)
            });
        });
        return $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList);
    }
    function $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList) {
        var columnsMap = {};
        (0, parcelRequire("bahqM")).each(seriesInfoList, function(seriesInfo, idx) {
            var axisKey = seriesInfo.axisKey;
            var bandWidth = seriesInfo.bandWidth;
            var columnsOnAxis = columnsMap[axisKey] || {
                bandWidth: bandWidth,
                remainedWidth: bandWidth,
                autoWidthCount: 0,
                categoryGap: null,
                gap: '20%',
                stacks: {}
            };
            var stacks = columnsOnAxis.stacks;
            columnsMap[axisKey] = columnsOnAxis;
            var stackId = seriesInfo.stackId;
            if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
            stacks[stackId] = stacks[stackId] || {
                width: 0,
                maxWidth: 0
            };
            var barWidth = seriesInfo.barWidth;
            if (barWidth && !stacks[stackId].width) {
                stacks[stackId].width = barWidth;
                barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
                columnsOnAxis.remainedWidth -= barWidth;
            }
            var barMaxWidth = seriesInfo.barMaxWidth;
            barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
            var barMinWidth = seriesInfo.barMinWidth;
            barMinWidth && (stacks[stackId].minWidth = barMinWidth);
            var barGap = seriesInfo.barGap;
            barGap != null && (columnsOnAxis.gap = barGap);
            var barCategoryGap = seriesInfo.barCategoryGap;
            barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
        });
        var result = {};
        (0, parcelRequire("bahqM")).each(columnsMap, function(columnsOnAxis, coordSysName) {
            result[coordSysName] = {};
            var stacks = columnsOnAxis.stacks;
            var bandWidth = columnsOnAxis.bandWidth;
            var categoryGapPercent = columnsOnAxis.categoryGap;
            if (categoryGapPercent == null) {
                var columnCount = (0, parcelRequire("bahqM")).keys(stacks).length;
                categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
            }
            var categoryGap = (0, (0, parcelRequire("jmSNG")).parsePercent)(categoryGapPercent, bandWidth);
            var barGapPercent = (0, (0, parcelRequire("jmSNG")).parsePercent)(columnsOnAxis.gap, 1);
            var remainedWidth = columnsOnAxis.remainedWidth;
            var autoWidthCount = columnsOnAxis.autoWidthCount;
            var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            (0, parcelRequire("bahqM")).each(stacks, function(column) {
                var maxWidth = column.maxWidth;
                var minWidth = column.minWidth;
                if (!column.width) {
                    var finalWidth = autoWidth;
                    if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                    if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                    if (finalWidth !== autoWidth) {
                        column.width = finalWidth;
                        remainedWidth -= finalWidth + barGapPercent * finalWidth;
                        autoWidthCount--;
                    }
                } else {
                    var finalWidth = column.width;
                    if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                    if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            });
            autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            var widthSum = 0;
            var lastColumn;
            (0, parcelRequire("bahqM")).each(stacks, function(column, idx) {
                if (!column.width) column.width = autoWidth;
                lastColumn = column;
                widthSum += column.width * (1 + barGapPercent);
            });
            if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
            var offset = -widthSum / 2;
            (0, parcelRequire("bahqM")).each(stacks, function(column, stackId) {
                result[coordSysName][stackId] = result[coordSysName][stackId] || {
                    bandWidth: bandWidth,
                    offset: offset,
                    width: column.width
                };
                offset += column.width * (1 + barGapPercent);
            });
        });
        return result;
    }
    function $abe8b2c5f70c8df4$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
        if (barWidthAndOffset && axis) {
            var result = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(axis)];
            if (result != null && seriesModel != null) return result[$abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)];
            return result;
        }
    }
    function $abe8b2c5f70c8df4$export$b3219800bda33a1f(seriesType, ecModel) {
        var seriesModels = $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
        var barWidthAndOffset = $abe8b2c5f70c8df4$export$20769dafc84e0299(seriesModels);
        var lastStackCoords = {};
        (0, parcelRequire("bahqM")).each(seriesModels, function(seriesModel) {
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var stackId = $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel);
            var columnLayoutInfo = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(baseAxis)][stackId];
            var columnOffset = columnLayoutInfo.offset;
            var columnWidth = columnLayoutInfo.width;
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            lastStackCoords[stackId] = lastStackCoords[stackId] || [];
            data.setLayout({
                bandWidth: columnLayoutInfo.bandWidth,
                offset: columnOffset,
                size: columnWidth
            });
            var valueDim = data.mapDimension(valueAxis.dim);
            var baseDim = data.mapDimension(baseAxis.dim);
            var stacked = (0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, valueDim);
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked);
            var store = data.getStore();
            var valueDimIdx = data.getDimensionIndex(valueDim);
            var baseDimIdx = data.getDimensionIndex(baseDim);
            for(var idx = 0, len = store.count(); idx < len; idx++){
                var value = store.get(valueDimIdx, idx);
                var baseValue = store.get(baseDimIdx, idx);
                var sign = value >= 0 ? 'p' : 'n';
                var baseCoord = valueAxisStart;
                if (stacked) {
                    if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                        p: valueAxisStart,
                        n: valueAxisStart
                    };
                    baseCoord = lastStackCoords[stackId][baseValue][sign];
                }
                var x = void 0;
                var y = void 0;
                var width = void 0;
                var height = void 0;
                if (isValueAxisH) {
                    var coord = cartesian.dataToPoint([
                        value,
                        baseValue
                    ]);
                    x = baseCoord;
                    y = coord[1] + columnOffset;
                    width = coord[0] - valueAxisStart;
                    height = columnWidth;
                    if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
                } else {
                    var coord = cartesian.dataToPoint([
                        baseValue,
                        value
                    ]);
                    x = coord[0] + columnOffset;
                    y = baseCoord;
                    width = columnWidth;
                    height = coord[1] - valueAxisStart;
                    if (Math.abs(height) < barMinHeight) height = (height <= 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
                }
                data.setItemLayout(idx, {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        });
    }
    var $abe8b2c5f70c8df4$export$1fcd87ee6628f095 = {
        seriesType: 'bar',
        plan: (0, (0, parcelRequire("9irlK")).default)(),
        reset: function(seriesModel) {
            if (!$abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) || !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var coordLayout = cartesian.master.getRect();
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var valueAxisHorizontal = valueAxis.isHorizontal();
            var valueDimIdx = valueAxisHorizontal ? 0 : 1;
            var barWidth = $abe8b2c5f70c8df4$export$35920bb6556da1c2($abe8b2c5f70c8df4$export$20769dafc84e0299([
                seriesModel
            ]), baseAxis, seriesModel).width;
            if (!(barWidth > $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH)) barWidth = $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH;
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeBackgroundPoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeDataIndices = new $abe8b2c5f70c8df4$var$LargeArr(count);
                    var dataIndex;
                    var coord = [];
                    var valuePair = [];
                    var pointsOffset = 0;
                    var idxOffset = 0;
                    var store = data.getStore();
                    while((dataIndex = params.next()) != null){
                        valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                        valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                        coord = cartesian.dataToPoint(valuePair, null);
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                        largePoints[pointsOffset++] = coord[0];
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                        largePoints[pointsOffset++] = coord[1];
                        largeDataIndices[idxOffset++] = dataIndex;
                    }
                    data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        barWidth: barWidth,
                        valueAxisStart: $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, false),
                        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                        valueAxisHorizontal: valueAxisHorizontal
                    });
                }
            };
        }
    };
    function $abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) {
        return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
    }
    function $abe8b2c5f70c8df4$var$isInLargeMode(seriesModel) {
        return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
    }
    function $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
        return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
    }
});
parcelRegister("1MU9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14d5d447dd592e99$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $bc1Ad;
    var $32MHg;
    var $6kObD;
    var $fEgWg;
    var $bahqM;
    var $14d5d447dd592e99$var$bisect = function(a, x, lo, hi) {
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (a[mid][1] < x) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    };
    var $14d5d447dd592e99$var$TimeScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TimeScale, _super);
        function TimeScale(settings) {
            var _this = _super.call(this, settings) || this;
            _this.type = 'time';
            return _this;
        }
        TimeScale.prototype.getLabel = function(tick) {
            var useUTC = this.getSetting('useUTC');
            return (0, (0, parcelRequire("bc1Ad")).format)(tick.value, (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter)[(0, (0, parcelRequire("bc1Ad")).getDefaultFormatPrecisionOfInterval)((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(this._minLevelUnit))] || (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
        };
        TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
            var isUTC = this.getSetting('useUTC');
            var lang = this.getSetting('locale');
            return (0, (0, parcelRequire("bc1Ad")).leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
        };
        TimeScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var ticks = [];
            if (!interval) return ticks;
            ticks.push({
                value: extent[0],
                level: 0
            });
            var useUTC = this.getSetting('useUTC');
            var innerTicks = $14d5d447dd592e99$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
            ticks = ticks.concat(innerTicks);
            ticks.push({
                value: extent[1],
                level: 0
            });
            return ticks;
        };
        TimeScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                extent[0] -= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
                extent[1] += (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            if (extent[1] === -Infinity && extent[0] === Infinity) {
                var d = new Date();
                extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
                extent[0] = extent[1] - (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        };
        TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            this._approxInterval = span / approxTickNum;
            if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
            if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
            var scaleIntervalsLen = $14d5d447dd592e99$var$scaleIntervals.length;
            var idx = Math.min($14d5d447dd592e99$var$bisect($14d5d447dd592e99$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
            this._interval = $14d5d447dd592e99$var$scaleIntervals[idx][1];
            this._minLevelUnit = $14d5d447dd592e99$var$scaleIntervals[Math.max(idx - 1, 0)][0];
        };
        TimeScale.prototype.parse = function(val) {
            return typeof val === 'number' ? val : +(0, parcelRequire("jmSNG")).parseDate(val);
        };
        TimeScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(this.parse(val), this._extent);
        };
        TimeScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(this.parse(val), this._extent);
        };
        TimeScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        TimeScale.type = 'time';
        return TimeScale;
    }((0, (0, parcelRequire("6kObD")).default));
    var $14d5d447dd592e99$var$scaleIntervals = [
        [
            'second',
            (0, (0, parcelRequire("bc1Ad")).ONE_SECOND)
        ],
        [
            'minute',
            (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE)
        ],
        [
            'hour',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR)
        ],
        [
            'quarter-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 6
        ],
        [
            'half-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 12
        ],
        [
            'day',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 1.2
        ],
        [
            'half-week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 3.5
        ],
        [
            'week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 7
        ],
        [
            'month',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 31
        ],
        [
            'quarter',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 95
        ],
        [
            'half-year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR) / 2
        ],
        [
            'year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR)
        ]
    ];
    function $14d5d447dd592e99$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
        var dateA = (0, parcelRequire("jmSNG")).parseDate(valueA);
        var dateB = (0, parcelRequire("jmSNG")).parseDate(valueB);
        var isSame = function(unit) {
            return (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateA, unit, isUTC) === (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateB, unit, isUTC);
        };
        var isSameYear = function() {
            return isSame('year');
        };
        var isSameMonth = function() {
            return isSameYear() && isSame('month');
        };
        var isSameDay = function() {
            return isSameMonth() && isSame('day');
        };
        var isSameHour = function() {
            return isSameDay() && isSame('hour');
        };
        var isSameMinute = function() {
            return isSameHour() && isSame('minute');
        };
        var isSameSecond = function() {
            return isSameMinute() && isSame('second');
        };
        var isSameMilliSecond = function() {
            return isSameSecond() && isSame('millisecond');
        };
        switch(unit){
            case 'year':
                return isSameYear();
            case 'month':
                return isSameMonth();
            case 'day':
                return isSameDay();
            case 'hour':
                return isSameHour();
            case 'minute':
                return isSameMinute();
            case 'second':
                return isSameSecond();
            case 'millisecond':
                return isSameMilliSecond();
        }
    }
    function $14d5d447dd592e99$var$getDateInterval(approxInterval, daysInMonth) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMonthInterval(approxInterval) {
        var APPROX_ONE_MONTH = 30 * (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        approxInterval /= APPROX_ONE_MONTH;
        return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getHourInterval(approxInterval) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_HOUR);
        return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
        approxInterval /= isMinutes ? (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE) : (0, (0, parcelRequire("bc1Ad")).ONE_SECOND);
        return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval) {
        return (0, parcelRequire("jmSNG")).nice(approxInterval, true);
    }
    function $14d5d447dd592e99$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
        var outDate = new Date(date);
        switch((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName)){
            case 'year':
            case 'month':
                outDate[(0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC)](0);
            case 'day':
                outDate[(0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC)](1);
            case 'hour':
                outDate[(0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC)](0);
            case 'minute':
                outDate[(0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC)](0);
            case 'second':
                outDate[(0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC)](0);
                outDate[(0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC)](0);
        }
        return outDate.getTime();
    }
    function $14d5d447dd592e99$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
        var safeLimit = 10000;
        var unitNames = (0, (0, parcelRequire("bc1Ad")).timeUnits);
        var iter = 0;
        function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
            var date = new Date(minTimestamp);
            var dateTime = minTimestamp;
            var d = date[getMethodName]();
            while(dateTime < maxTimestamp && dateTime <= extent[1]){
                out.push({
                    value: dateTime
                });
                d += interval;
                date[setMethodName](d);
                dateTime = date.getTime();
            }
            out.push({
                value: dateTime,
                notAdd: true
            });
        }
        function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
            var newAddedTicks = [];
            var isFirstLevel = !lastLevelTicks.length;
            if ($14d5d447dd592e99$var$isUnitValueSame((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
            if (isFirstLevel) lastLevelTicks = [
                {
                    value: $14d5d447dd592e99$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
                },
                {
                    value: extent[1]
                }
            ];
            for(var i = 0; i < lastLevelTicks.length - 1; i++){
                var startTick = lastLevelTicks[i].value;
                var endTick = lastLevelTicks[i + 1].value;
                if (startTick === endTick) continue;
                var interval = void 0;
                var getterName = void 0;
                var setterName = void 0;
                var isDate = false;
                switch(unitName){
                    case 'year':
                        interval = Math.max(1, Math.round(approxInterval / (0, (0, parcelRequire("bc1Ad")).ONE_DAY) / 365));
                        getterName = (0, (0, parcelRequire("bc1Ad")).fullYearGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).fullYearSetterName)(isUTC);
                        break;
                    case 'half-year':
                    case 'quarter':
                    case 'month':
                        interval = $14d5d447dd592e99$var$getMonthInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).monthGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC);
                        break;
                    case 'week':
                    case 'half-week':
                    case 'day':
                        interval = $14d5d447dd592e99$var$getDateInterval(approxInterval, 31);
                        getterName = (0, (0, parcelRequire("bc1Ad")).dateGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC);
                        isDate = true;
                        break;
                    case 'half-day':
                    case 'quarter-day':
                    case 'hour':
                        interval = $14d5d447dd592e99$var$getHourInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).hoursGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC);
                        break;
                    case 'minute':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, true);
                        getterName = (0, (0, parcelRequire("bc1Ad")).minutesGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC);
                        break;
                    case 'second':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, false);
                        getterName = (0, (0, parcelRequire("bc1Ad")).secondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC);
                        break;
                    case 'millisecond':
                        interval = $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).millisecondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC);
                        break;
                }
                addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
                if (unitName === 'year' && levelTicks.length > 1 && i === 0) levelTicks.unshift({
                    value: levelTicks[0].value - interval
                });
            }
            for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
            return newAddedTicks;
        }
        var levelsTicks = [];
        var currentLevelTicks = [];
        var tickCount = 0;
        var lastLevelTickCount = 0;
        for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
            var primaryTimeUnit = (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i]);
            if (!(0, (0, parcelRequire("bc1Ad")).isPrimaryTimeUnit)(unitNames[i])) continue;
            addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
            var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i + 1]) : null;
            if (primaryTimeUnit !== nextPrimaryTimeUnit) {
                if (currentLevelTicks.length) {
                    lastLevelTickCount = tickCount;
                    currentLevelTicks.sort(function(a, b) {
                        return a.value - b.value;
                    });
                    var levelTicksRemoveDuplicated = [];
                    for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                        var tickValue = currentLevelTicks[i_1].value;
                        if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                            levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                            if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                        }
                    }
                    var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                    if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                    levelsTicks.push(levelTicksRemoveDuplicated);
                    if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
                }
                currentLevelTicks = [];
            }
        }
        var levelsTicksInExtent = (0, (0, parcelRequire("bahqM")).filter)((0, (0, parcelRequire("bahqM")).map)(levelsTicks, function(levelTicks) {
            return (0, (0, parcelRequire("bahqM")).filter)(levelTicks, function(tick) {
                return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
            });
        }), function(levelTicks) {
            return levelTicks.length > 0;
        });
        var ticks = [];
        var maxLevel = levelsTicksInExtent.length - 1;
        for(var i = 0; i < levelsTicksInExtent.length; ++i){
            var levelTicks = levelsTicksInExtent[i];
            for(var k = 0; k < levelTicks.length; ++k)ticks.push({
                value: levelTicks[k].value,
                level: maxLevel - i
            });
        }
        ticks.sort(function(a, b) {
            return a.value - b.value;
        });
        var result = [];
        for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
        return result;
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($14d5d447dd592e99$var$TimeScale);
    var $14d5d447dd592e99$export$2e2bcd8739ae039 = $14d5d447dd592e99$var$TimeScale;
});
parcelRegister("73kgw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5228888966b0d10c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $fEgWg;
    var $jmSNG;
    var $32MHg;
    var $6kObD;
    var $5228888966b0d10c$var$scaleProto = (0, (0, parcelRequire("fEgWg")).default).prototype;
    var $5228888966b0d10c$var$intervalScaleProto = (0, (0, parcelRequire("6kObD")).default).prototype;
    var $5228888966b0d10c$var$roundingErrorFix = (0, parcelRequire("jmSNG")).round;
    var $5228888966b0d10c$var$mathFloor = Math.floor;
    var $5228888966b0d10c$var$mathCeil = Math.ceil;
    var $5228888966b0d10c$var$mathPow = Math.pow;
    var $5228888966b0d10c$var$mathLog = Math.log;
    var $5228888966b0d10c$var$LogScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LogScale, _super);
        function LogScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'log';
            _this.base = 10;
            _this._originalScale = new (0, (0, parcelRequire("6kObD")).default)();
            _this._interval = 0;
            return _this;
        }
        LogScale.prototype.getTicks = function(expandToNicedExtent) {
            var originalScale = this._originalScale;
            var extent = this._extent;
            var originalExtent = originalScale.getExtent();
            var ticks = $5228888966b0d10c$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
            return (0, parcelRequire("bahqM")).map(ticks, function(tick) {
                var val = tick.value;
                var powVal = (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathPow(this.base, val));
                powVal = val === extent[0] && this._fixMin ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
                powVal = val === extent[1] && this._fixMax ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
                return {
                    value: powVal
                };
            }, this);
        };
        LogScale.prototype.setExtent = function(start, end) {
            var base = this.base;
            start = $5228888966b0d10c$var$mathLog(start) / $5228888966b0d10c$var$mathLog(base);
            end = $5228888966b0d10c$var$mathLog(end) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$intervalScaleProto.setExtent.call(this, start, end);
        };
        LogScale.prototype.getExtent = function() {
            var base = this.base;
            var extent = $5228888966b0d10c$var$scaleProto.getExtent.call(this);
            extent[0] = $5228888966b0d10c$var$mathPow(base, extent[0]);
            extent[1] = $5228888966b0d10c$var$mathPow(base, extent[1]);
            var originalScale = this._originalScale;
            var originalExtent = originalScale.getExtent();
            this._fixMin && (extent[0] = $5228888966b0d10c$var$fixRoundingError(extent[0], originalExtent[0]));
            this._fixMax && (extent[1] = $5228888966b0d10c$var$fixRoundingError(extent[1], originalExtent[1]));
            return extent;
        };
        LogScale.prototype.unionExtent = function(extent) {
            this._originalScale.unionExtent(extent);
            var base = this.base;
            extent[0] = $5228888966b0d10c$var$mathLog(extent[0]) / $5228888966b0d10c$var$mathLog(base);
            extent[1] = $5228888966b0d10c$var$mathLog(extent[1]) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$scaleProto.unionExtent.call(this, extent);
        };
        LogScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        LogScale.prototype.niceTicks = function(approxTickNum) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (span === Infinity || span <= 0) return;
            var interval = (0, parcelRequire("jmSNG")).quantity(span);
            var err = approxTickNum / span * interval;
            if (err <= 0.5) interval *= 10;
            while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
            var niceExtent = [
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathCeil(extent[0] / interval) * interval),
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathFloor(extent[1] / interval) * interval)
            ];
            this._interval = interval;
            this._niceExtent = niceExtent;
        };
        LogScale.prototype.niceExtent = function(opt) {
            $5228888966b0d10c$var$intervalScaleProto.niceExtent.call(this, opt);
            this._fixMin = opt.fixMin;
            this._fixMax = opt.fixMax;
        };
        LogScale.prototype.parse = function(val) {
            return val;
        };
        LogScale.prototype.contain = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        LogScale.prototype.normalize = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        LogScale.prototype.scale = function(val) {
            val = (0, parcelRequire("32MHg")).scale(val, this._extent);
            return $5228888966b0d10c$var$mathPow(this.base, val);
        };
        LogScale.type = 'log';
        return LogScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    var $5228888966b0d10c$var$proto = $5228888966b0d10c$var$LogScale.prototype;
    $5228888966b0d10c$var$proto.getMinorTicks = $5228888966b0d10c$var$intervalScaleProto.getMinorTicks;
    $5228888966b0d10c$var$proto.getLabel = $5228888966b0d10c$var$intervalScaleProto.getLabel;
    function $5228888966b0d10c$var$fixRoundingError(val, originalVal) {
        return $5228888966b0d10c$var$roundingErrorFix(val, (0, parcelRequire("jmSNG")).getPrecision(originalVal));
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($5228888966b0d10c$var$LogScale);
    var $5228888966b0d10c$export$2e2bcd8739ae039 = $5228888966b0d10c$var$LogScale;
});
parcelRegister("lo2Vo", function(module, exports) {
    $parcel$export(module.exports, "parseAxisModelMinMax", ()=>$f91e1bac53937426$export$d02f2e65dfc3c2b);
    $parcel$export(module.exports, "ensureScaleRawExtentInfo", ()=>$f91e1bac53937426$export$5c3dbcbeb9ce7f5a);
    var $bahqM;
    var $b7ZX8;
    var $f91e1bac53937426$export$c35454f678e99c82 = function() {
        function ScaleRawExtentInfo(scale, model, originalExtent) {
            this._prepareParams(scale, model, originalExtent);
        }
        ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
            if (dataExtent[1] < dataExtent[0]) dataExtent = [
                NaN,
                NaN
            ];
            this._dataMin = dataExtent[0];
            this._dataMax = dataExtent[1];
            var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
            this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
            var modelMinRaw = this._modelMinRaw = model.get('min', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMinRaw)) this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMinRaw !== 'dataMin') this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw);
            var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMaxRaw)) this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
            if (isOrdinal) this._axisDataLen = model.getCategories().length;
            else {
                var boundaryGap = model.get('boundaryGap');
                var boundaryGapArr = (0, (0, parcelRequire("bahqM")).isArray)(boundaryGap) ? boundaryGap : [
                    boundaryGap || 0,
                    boundaryGap || 0
                ];
                if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                    0,
                    0
                ];
                else this._boundaryGapInner = [
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[0], 1),
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[1], 1)
                ];
            }
        };
        ScaleRawExtentInfo.prototype.calculate = function() {
            var isOrdinal = this._isOrdinal;
            var dataMin = this._dataMin;
            var dataMax = this._dataMax;
            var axisDataLen = this._axisDataLen;
            var boundaryGapInner = this._boundaryGapInner;
            var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
            var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
            var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
            var minFixed = min != null;
            var maxFixed = max != null;
            if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
            if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
            (min == null || !isFinite(min)) && (min = NaN);
            (max == null || !isFinite(max)) && (max = NaN);
            if (min > max) {
                min = NaN;
                max = NaN;
            }
            var isBlank = (0, (0, parcelRequire("bahqM")).eqNaN)(min) || (0, (0, parcelRequire("bahqM")).eqNaN)(max) || isOrdinal && !axisDataLen;
            if (this._needCrossZero) {
                if (min > 0 && max > 0 && !minFixed) min = 0;
                if (min < 0 && max < 0 && !maxFixed) max = 0;
            }
            var determinedMin = this._determinedMin;
            var determinedMax = this._determinedMax;
            if (determinedMin != null) {
                min = determinedMin;
                minFixed = true;
            }
            if (determinedMax != null) {
                max = determinedMax;
                maxFixed = true;
            }
            return {
                min: min,
                max: max,
                minFixed: minFixed,
                maxFixed: maxFixed,
                isBlank: isBlank
            };
        };
        ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
            this[$f91e1bac53937426$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
        };
        ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
            var attr = $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
            this[attr] = val;
        };
        ScaleRawExtentInfo.prototype.freeze = function() {
            this.frozen = true;
        };
        return ScaleRawExtentInfo;
    }();
    var $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR = {
        min: '_determinedMin',
        max: '_determinedMax'
    };
    var $f91e1bac53937426$var$DATA_MIN_MAX_ATTR = {
        min: '_dataMin',
        max: '_dataMax'
    };
    function $f91e1bac53937426$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
        var rawExtentInfo = scale.rawExtentInfo;
        if (rawExtentInfo) return rawExtentInfo;
        rawExtentInfo = new $f91e1bac53937426$export$c35454f678e99c82(scale, model, originalExtent);
        scale.rawExtentInfo = rawExtentInfo;
        return rawExtentInfo;
    }
    function $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, minMax) {
        return minMax == null ? null : (0, (0, parcelRequire("bahqM")).eqNaN)(minMax) ? NaN : scale.parse(minMax);
    }
});
parcelRegister("SsPct", function(module, exports) {
    $parcel$export(module.exports, "cartesian2DDimensions", ()=>$0a3b6744500b73ac$export$988a008d2b9120f4);
    $parcel$export(module.exports, "default", ()=>$0a3b6744500b73ac$export$2e2bcd8739ae039);
    var $3VFsf;
    var $1E3E8;
    var $7j9L9;
    var $izqgC;
    var $eLEew;
    var $0a3b6744500b73ac$export$988a008d2b9120f4 = [
        'x',
        'y'
    ];
    function $0a3b6744500b73ac$var$canCalculateAffineTransform(scale) {
        return scale.type === 'interval' || scale.type === 'time';
    }
    var $0a3b6744500b73ac$var$Cartesian2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Cartesian2D, _super);
        function Cartesian2D() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'cartesian2d';
            _this.dimensions = $0a3b6744500b73ac$export$988a008d2b9120f4;
            return _this;
        }
        Cartesian2D.prototype.calcAffineTransform = function() {
            this._transform = this._invTransform = null;
            var xAxisScale = this.getAxis('x').scale;
            var yAxisScale = this.getAxis('y').scale;
            if (!$0a3b6744500b73ac$var$canCalculateAffineTransform(xAxisScale) || !$0a3b6744500b73ac$var$canCalculateAffineTransform(yAxisScale)) return;
            var xScaleExtent = xAxisScale.getExtent();
            var yScaleExtent = yAxisScale.getExtent();
            var start = this.dataToPoint([
                xScaleExtent[0],
                yScaleExtent[0]
            ]);
            var end = this.dataToPoint([
                xScaleExtent[1],
                yScaleExtent[1]
            ]);
            var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
            var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
            if (!xScaleSpan || !yScaleSpan) return;
            var scaleX = (end[0] - start[0]) / xScaleSpan;
            var scaleY = (end[1] - start[1]) / yScaleSpan;
            var translateX = start[0] - xScaleExtent[0] * scaleX;
            var translateY = start[1] - yScaleExtent[0] * scaleY;
            var m = this._transform = [
                scaleX,
                0,
                0,
                scaleY,
                translateX,
                translateY
            ];
            this._invTransform = (0, (0, parcelRequire("izqgC")).invert)([], m);
        };
        Cartesian2D.prototype.getBaseAxis = function() {
            return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
        };
        Cartesian2D.prototype.containPoint = function(point) {
            var axisX = this.getAxis('x');
            var axisY = this.getAxis('y');
            return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
        };
        Cartesian2D.prototype.containData = function(data) {
            return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
        };
        Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
            out = out || [];
            var xVal = data[0];
            var yVal = data[1];
            if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, data, this._transform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
            out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
            return out;
        };
        Cartesian2D.prototype.clampData = function(data, out) {
            var xScale = this.getAxis('x').scale;
            var yScale = this.getAxis('y').scale;
            var xAxisExtent = xScale.getExtent();
            var yAxisExtent = yScale.getExtent();
            var x = xScale.parse(data[0]);
            var y = yScale.parse(data[1]);
            out = out || [];
            out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
            out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
            return out;
        };
        Cartesian2D.prototype.pointToData = function(point, clamp) {
            var out = [];
            if (this._invTransform) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, point, this._invTransform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
            out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
            return out;
        };
        Cartesian2D.prototype.getOtherAxis = function(axis) {
            return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
        };
        Cartesian2D.prototype.getArea = function() {
            var xExtent = this.getAxis('x').getGlobalExtent();
            var yExtent = this.getAxis('y').getGlobalExtent();
            var x = Math.min(xExtent[0], xExtent[1]);
            var y = Math.min(yExtent[0], yExtent[1]);
            var width = Math.max(xExtent[0], xExtent[1]) - x;
            var height = Math.max(yExtent[0], yExtent[1]) - y;
            return new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        };
        return Cartesian2D;
    }((0, (0, parcelRequire("7j9L9")).default));
    var $0a3b6744500b73ac$export$2e2bcd8739ae039 = $0a3b6744500b73ac$var$Cartesian2D;
});
parcelRegister("7j9L9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5521e0c9b22643f8$export$2e2bcd8739ae039);
    var $bahqM;
    var $5521e0c9b22643f8$var$Cartesian = function() {
        function Cartesian(name) {
            this.type = 'cartesian';
            this._dimList = [];
            this._axes = {};
            this.name = name || '';
        }
        Cartesian.prototype.getAxis = function(dim) {
            return this._axes[dim];
        };
        Cartesian.prototype.getAxes = function() {
            return (0, parcelRequire("bahqM")).map(this._dimList, function(dim) {
                return this._axes[dim];
            }, this);
        };
        Cartesian.prototype.getAxesByScale = function(scaleType) {
            scaleType = scaleType.toLowerCase();
            return (0, parcelRequire("bahqM")).filter(this.getAxes(), function(axis) {
                return axis.scale.type === scaleType;
            });
        };
        Cartesian.prototype.addAxis = function(axis) {
            var dim = axis.dim;
            this._axes[dim] = axis;
            this._dimList.push(dim);
        };
        return Cartesian;
    }();
    var $5521e0c9b22643f8$export$2e2bcd8739ae039 = $5521e0c9b22643f8$var$Cartesian;
});
parcelRegister("kBKMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f00b8d3b69958a3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $g6Gq1;
    var $f00b8d3b69958a3f$var$Axis2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Axis2D, _super);
        function Axis2D(dim, scale, coordExtent, axisType, position) {
            var _this = _super.call(this, dim, scale, coordExtent) || this;
            _this.index = 0;
            _this.type = axisType || 'value';
            _this.position = position || 'bottom';
            return _this;
        }
        Axis2D.prototype.isHorizontal = function() {
            var position = this.position;
            return position === 'top' || position === 'bottom';
        };
        Axis2D.prototype.getGlobalExtent = function(asc) {
            var ret = this.getExtent();
            ret[0] = this.toGlobalCoord(ret[0]);
            ret[1] = this.toGlobalCoord(ret[1]);
            asc && ret[0] > ret[1] && ret.reverse();
            return ret;
        };
        Axis2D.prototype.pointToData = function(point, clamp) {
            return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
        };
        Axis2D.prototype.setCategorySortInfo = function(info) {
            if (this.type !== 'category') return false;
            this.model.option.categorySortInfo = info;
            this.scale.setSortInfo(info);
        };
        return Axis2D;
    }((0, (0, parcelRequire("g6Gq1")).default));
    var $f00b8d3b69958a3f$export$2e2bcd8739ae039 = $f00b8d3b69958a3f$var$Axis2D;
});
parcelRegister("g6Gq1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb9e1c59fe00c8ac$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    var $ftAX6;
    var $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT = [
        0,
        1
    ];
    var $bb9e1c59fe00c8ac$var$Axis = function() {
        function Axis(dim, scale, extent) {
            this.onBand = false;
            this.inverse = false;
            this.dim = dim;
            this.scale = scale;
            this._extent = extent || [
                0,
                0
            ];
        }
        Axis.prototype.contain = function(coord) {
            var extent = this._extent;
            var min = Math.min(extent[0], extent[1]);
            var max = Math.max(extent[0], extent[1]);
            return coord >= min && coord <= max;
        };
        Axis.prototype.containData = function(data) {
            return this.scale.contain(data);
        };
        Axis.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Axis.prototype.getPixelPrecision = function(dataExtent) {
            return (0, (0, parcelRequire("jmSNG")).getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
        };
        Axis.prototype.setExtent = function(start, end) {
            var extent = this._extent;
            extent[0] = start;
            extent[1] = end;
        };
        Axis.prototype.dataToCoord = function(data, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            data = scale.normalize(data);
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            return (0, (0, parcelRequire("jmSNG")).linearMap)(data, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, extent, clamp);
        };
        Axis.prototype.coordToData = function(coord, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            var t = (0, (0, parcelRequire("jmSNG")).linearMap)(coord, extent, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, clamp);
            return this.scale.scale(t);
        };
        Axis.prototype.pointToData = function(point, clamp) {
            return;
        };
        Axis.prototype.getTicksCoords = function(opt) {
            opt = opt || {};
            var tickModel = opt.tickModel || this.getTickModel();
            var result = (0, (0, parcelRequire("ftAX6")).createAxisTicks)(this, tickModel);
            var ticks = result.ticks;
            var ticksCoords = (0, (0, parcelRequire("bahqM")).map)(ticks, function(tickVal) {
                return {
                    coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                    tickValue: tickVal
                };
            }, this);
            var alignWithLabel = tickModel.get('alignWithLabel');
            $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
            return ticksCoords;
        };
        Axis.prototype.getMinorTicksCoords = function() {
            if (this.scale.type === 'ordinal') return [];
            var minorTickModel = this.model.getModel('minorTick');
            var splitNumber = minorTickModel.get('splitNumber');
            if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
            var minorTicks = this.scale.getMinorTicks(splitNumber);
            var minorTicksCoords = (0, (0, parcelRequire("bahqM")).map)(minorTicks, function(minorTicksGroup) {
                return (0, (0, parcelRequire("bahqM")).map)(minorTicksGroup, function(minorTick) {
                    return {
                        coord: this.dataToCoord(minorTick),
                        tickValue: minorTick
                    };
                }, this);
            }, this);
            return minorTicksCoords;
        };
        Axis.prototype.getViewLabels = function() {
            return (0, (0, parcelRequire("ftAX6")).createAxisLabels)(this).labels;
        };
        Axis.prototype.getLabelModel = function() {
            return this.model.getModel('axisLabel');
        };
        Axis.prototype.getTickModel = function() {
            return this.model.getModel('axisTick');
        };
        Axis.prototype.getBandWidth = function() {
            var axisExtent = this._extent;
            var dataExtent = this.scale.getExtent();
            var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
            len === 0 && (len = 1);
            var size = Math.abs(axisExtent[1] - axisExtent[0]);
            return Math.abs(size) / len;
        };
        Axis.prototype.calculateCategoryInterval = function() {
            return (0, (0, parcelRequire("ftAX6")).calculateCategoryInterval)(this);
        };
        return Axis;
    }();
    function $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, nTick) {
        var size = extent[1] - extent[0];
        var len = nTick;
        var margin = size / len / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    function $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
        var ticksLen = ticksCoords.length;
        if (!axis.onBand || alignWithLabel || !ticksLen) return;
        var axisExtent = axis.getExtent();
        var last;
        var diffSize;
        if (ticksLen === 1) {
            ticksCoords[0].coord = axisExtent[0];
            last = ticksCoords[1] = {
                coord: axisExtent[0]
            };
        } else {
            var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
            var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
            (0, (0, parcelRequire("bahqM")).each)(ticksCoords, function(ticksItem) {
                ticksItem.coord -= shift_1 / 2;
            });
            var dataExtent = axis.scale.getExtent();
            diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
            last = {
                coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
            };
            ticksCoords.push(last);
        }
        var inverse = axisExtent[0] > axisExtent[1];
        if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
        if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
            coord: axisExtent[0]
        });
        if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
        if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
            coord: axisExtent[1]
        });
        function littleThan(a, b) {
            a = (0, (0, parcelRequire("jmSNG")).round)(a);
            b = (0, (0, parcelRequire("jmSNG")).round)(b);
            return inverse ? a > b : a < b;
        }
    }
    var $bb9e1c59fe00c8ac$export$2e2bcd8739ae039 = $bb9e1c59fe00c8ac$var$Axis;
});
parcelRegister("ftAX6", function(module, exports) {
    $parcel$export(module.exports, "createAxisLabels", ()=>$b4463a620840f7ae$export$10216ebd3e3e485e);
    $parcel$export(module.exports, "createAxisTicks", ()=>$b4463a620840f7ae$export$7cccf6836ae8323c);
    $parcel$export(module.exports, "calculateCategoryInterval", ()=>$b4463a620840f7ae$export$9ea1d3f146a5a65f);
    var $bahqM;
    var $b7ZX8;
    var $eaKsF;
    var $3GIoT;
    var $b4463a620840f7ae$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b4463a620840f7ae$export$10216ebd3e3e485e(axis) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryLabels(axis) : $b4463a620840f7ae$var$makeRealNumberLabels(axis);
    }
    function $b4463a620840f7ae$export$7cccf6836ae8323c(axis, tickModel) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) : {
            ticks: (0, parcelRequire("bahqM")).map(axis.scale.getTicks(), function(tick) {
                return tick.value;
            })
        };
    }
    function $b4463a620840f7ae$var$makeCategoryLabels(axis) {
        var labelModel = axis.getLabelModel();
        var result = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel);
        return !labelModel.get('show') || axis.scale.isBlank() ? {
            labels: [],
            labelCategoryInterval: result.labelCategoryInterval
        } : result;
    }
    function $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel) {
        var labelsCache = $b4463a620840f7ae$var$getListCache(axis, 'labels');
        var optionLabelInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(labelModel);
        var result = $b4463a620840f7ae$var$listCacheGet(labelsCache, optionLabelInterval);
        if (result) return result;
        var labels;
        var numericLabelInterval;
        if ((0, parcelRequire("bahqM")).isFunction(optionLabelInterval)) labels = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
        else {
            numericLabelInterval = optionLabelInterval === 'auto' ? $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
            labels = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
        }
        return $b4463a620840f7ae$var$listCacheSet(labelsCache, optionLabelInterval, {
            labels: labels,
            labelCategoryInterval: numericLabelInterval
        });
    }
    function $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) {
        var ticksCache = $b4463a620840f7ae$var$getListCache(axis, 'ticks');
        var optionTickInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(tickModel);
        var result = $b4463a620840f7ae$var$listCacheGet(ticksCache, optionTickInterval);
        if (result) return result;
        var ticks;
        var tickCategoryInterval;
        if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
        if ((0, parcelRequire("bahqM")).isFunction(optionTickInterval)) ticks = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
        else if (optionTickInterval === 'auto') {
            var labelsResult = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
            tickCategoryInterval = labelsResult.labelCategoryInterval;
            ticks = (0, parcelRequire("bahqM")).map(labelsResult.labels, function(labelItem) {
                return labelItem.tickValue;
            });
        } else {
            tickCategoryInterval = optionTickInterval;
            ticks = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
        }
        return $b4463a620840f7ae$var$listCacheSet(ticksCache, optionTickInterval, {
            ticks: ticks,
            tickCategoryInterval: tickCategoryInterval
        });
    }
    function $b4463a620840f7ae$var$makeRealNumberLabels(axis) {
        var ticks = axis.scale.getTicks();
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        return {
            labels: (0, parcelRequire("bahqM")).map(ticks, function(tick, idx) {
                return {
                    level: tick.level,
                    formattedLabel: labelFormatter(tick, idx),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: tick.value
                };
            })
        };
    }
    function $b4463a620840f7ae$var$getListCache(axis, prop) {
        return $b4463a620840f7ae$var$inner(axis)[prop] || ($b4463a620840f7ae$var$inner(axis)[prop] = []);
    }
    function $b4463a620840f7ae$var$listCacheGet(cache, key) {
        for(var i = 0; i < cache.length; i++){
            if (cache[i].key === key) return cache[i].value;
        }
    }
    function $b4463a620840f7ae$var$listCacheSet(cache, key, value) {
        cache.push({
            key: key,
            value: value
        });
        return value;
    }
    function $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) {
        var result = $b4463a620840f7ae$var$inner(axis).autoInterval;
        return result != null ? result : $b4463a620840f7ae$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
    }
    function $b4463a620840f7ae$export$9ea1d3f146a5a65f(axis) {
        var params = $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis);
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var step = 1;
        if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitW = Math.abs(unitSpan * Math.cos(rotation));
        var unitH = Math.abs(unitSpan * Math.sin(rotation));
        var maxW = 0;
        var maxH = 0;
        for(; tickValue <= ordinalExtent[1]; tickValue += step){
            var width = 0;
            var height = 0;
            var rect = (0, parcelRequire("b7ZX8")).getBoundingRect(labelFormatter({
                value: tickValue
            }), params.font, 'center', 'top');
            width = rect.width * 1.3;
            height = rect.height * 1.3;
            maxW = Math.max(maxW, width, 7);
            maxH = Math.max(maxH, height, 7);
        }
        var dw = maxW / unitW;
        var dh = maxH / unitH;
        isNaN(dw) && (dw = Infinity);
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
        var cache = $b4463a620840f7ae$var$inner(axis.model);
        var axisExtent = axis.getExtent();
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
            cache.axisExtent0 = axisExtent[0];
            cache.axisExtent1 = axisExtent[1];
        }
        return interval;
    }
    function $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis) {
        var labelModel = axis.getLabelModel();
        return {
            axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
            labelRotate: labelModel.get('rotate') || 0,
            font: labelModel.getFont()
        };
    }
    function $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var labelModel = axis.getLabelModel();
        var result = [];
        var step = Math.max((categoryInterval || 0) + 1, 1);
        var startTick = ordinalExtent[0];
        var tickCount = ordinalScale.count();
        if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
        var showAllLabel = (0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axis);
        var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
        var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
        if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
        var tickValue = startTick;
        for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
        if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
        function addItem(tickValue) {
            var tickObj = {
                value: tickValue
            };
            result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tickObj),
                rawLabel: ordinalScale.getLabel(tickObj),
                tickValue: tickValue
            });
        }
        return result;
    }
    function $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
        var ordinalScale = axis.scale;
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var result = [];
        (0, parcelRequire("bahqM")).each(ordinalScale.getTicks(), function(tick) {
            var rawLabel = ordinalScale.getLabel(tick);
            var tickValue = tick.value;
            if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tick),
                rawLabel: rawLabel,
                tickValue: tickValue
            });
        });
        return result;
    }
});
parcelRegister("dBIJY", function(module, exports) {
    $parcel$export(module.exports, "layout", ()=>$9e816f987642cbea$export$b3219800bda33a1f);
    $parcel$export(module.exports, "isCartesian2DSeries", ()=>$9e816f987642cbea$export$c2a0b77974c5e35d);
    $parcel$export(module.exports, "findAxisModels", ()=>$9e816f987642cbea$export$8220131ac1d61d28);
    var $bahqM;
    var $eaKsF;
    function $9e816f987642cbea$export$b3219800bda33a1f(gridModel, axisModel, opt) {
        opt = opt || {};
        var grid = gridModel.coordinateSystem;
        var axis = axisModel.axis;
        var layout = {};
        var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
        var rawAxisPosition = axis.position;
        var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
        var axisDim = axis.dim;
        var rect = grid.getRect();
        var rectBound = [
            rect.x,
            rect.x + rect.width,
            rect.y,
            rect.y + rect.height
        ];
        var idx = {
            left: 0,
            right: 1,
            top: 0,
            bottom: 1,
            onZero: 2
        };
        var axisOffset = axisModel.get('offset') || 0;
        var posBound = axisDim === 'x' ? [
            rectBound[2] - axisOffset,
            rectBound[3] + axisOffset
        ] : [
            rectBound[0] - axisOffset,
            rectBound[1] + axisOffset
        ];
        if (otherAxisOnZeroOf) {
            var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
            posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
        }
        layout.position = [
            axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
            axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
        ];
        layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
        var dirMap = {
            top: -1,
            bottom: 1,
            left: -1,
            right: 1
        };
        layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
        layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
        if (axisModel.get([
            'axisTick',
            'inside'
        ])) layout.tickDirection = -layout.tickDirection;
        if ((0, parcelRequire("bahqM")).retrieve(opt.labelInside, axisModel.get([
            'axisLabel',
            'inside'
        ]))) layout.labelDirection = -layout.labelDirection;
        var labelRotate = axisModel.get([
            'axisLabel',
            'rotate'
        ]);
        layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
        layout.z2 = 1;
        return layout;
    }
    function $9e816f987642cbea$export$c2a0b77974c5e35d(seriesModel) {
        return seriesModel.get('coordinateSystem') === 'cartesian2d';
    }
    function $9e816f987642cbea$export$8220131ac1d61d28(seriesModel) {
        var axisModelMap = {
            xAxisModel: null,
            yAxisModel: null
        };
        (0, parcelRequire("bahqM")).each(axisModelMap, function(v, key) {
            var axisType = key.replace(/Model$/, '');
            var axisModel = seriesModel.getReferringComponents(axisType, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            axisModelMap[key] = axisModel;
        });
        return axisModelMap;
    }
});
parcelRegister("2rHnA", function(module, exports) {
    $parcel$export(module.exports, "CartesianXAxisView", ()=>$1c7fc0a7283d68cb$export$b6d40cd875b8a1c8);
    $parcel$export(module.exports, "CartesianYAxisView", ()=>$1c7fc0a7283d68cb$export$417e1bdd0616e0dc);
    var $3VFsf;
    var $bahqM;
    var $4KVOr;
    var $fHITF;
    var $cZb1F;
    var $asa08;
    var $atJL7;
    var $dBIJY;
    var $6dLRi;
    var $1c7fc0a7283d68cb$var$axisBuilderAttrs = [
        'axisLine',
        'axisTickLabel',
        'axisName'
    ];
    var $1c7fc0a7283d68cb$var$selfBuilderAttrs = [
        'splitArea',
        'splitLine',
        'minorSplitLine'
    ];
    var $1c7fc0a7283d68cb$var$CartesianAxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisView, _super);
        function CartesianAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianAxisView.type;
            _this.axisPointerClass = 'CartesianAxisPointer';
            return _this;
        }
        CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.group.removeAll();
            var oldAxisGroup = this._axisGroup;
            this._axisGroup = new (0, parcelRequire("4KVOr")).default();
            this.group.add(this._axisGroup);
            if (!axisModel.get('show')) return;
            var gridModel = axisModel.getCoordSysModel();
            var layout = (0, parcelRequire("dBIJY")).layout(gridModel, axisModel);
            var axisBuilder = new (0, (0, parcelRequire("asa08")).default)(axisModel, (0, parcelRequire("bahqM")).extend({
                handleAutoShown: function(elementType) {
                    var cartesians = gridModel.coordinateSystem.getCartesians();
                    for(var i = 0; i < cartesians.length; i++){
                        var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                        if (otherAxisType === 'value' || otherAxisType === 'log') return true;
                    }
                    return false;
                }
            }, layout));
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this._axisGroup.add(axisBuilder.getGroup());
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$selfBuilderAttrs, function(name) {
                if (axisModel.get([
                    name,
                    'show'
                ])) $1c7fc0a7283d68cb$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
            }, this);
            var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
            if (!isInitialSortFromBarRacing) (0, parcelRequire("fHITF")).groupTransition(oldAxisGroup, this._axisGroup, axisModel);
            _super.prototype.render.call(this, axisModel, ecModel, api, payload);
        };
        CartesianAxisView.prototype.remove = function() {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisHandleRemove)(this);
        };
        CartesianAxisView.type = 'cartesianAxis';
        return CartesianAxisView;
    }((0, (0, parcelRequire("atJL7")).default));
    var $1c7fc0a7283d68cb$var$axisElementBuilders = {
        splitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            if (axis.scale.isBlank()) return;
            var splitLineModel = axisModel.getModel('splitLine');
            var lineStyleModel = splitLineModel.getModel('lineStyle');
            var lineColors = lineStyleModel.get('color');
            lineColors = (0, parcelRequire("bahqM")).isArray(lineColors) ? lineColors : [
                lineColors
            ];
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var lineCount = 0;
            var ticksCoords = axis.getTicksCoords({
                tickModel: splitLineModel
            });
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < ticksCoords.length; i++){
                var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                var colorIndex = lineCount++ % lineColors.length;
                var tickValue = ticksCoords[i].tickValue;
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: (0, parcelRequire("bahqM")).defaults({
                        stroke: lineColors[colorIndex]
                    }, lineStyle),
                    silent: true
                }));
            }
        },
        minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            var minorSplitLineModel = axisModel.getModel('minorSplitLine');
            var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var minorTicksCoords = axis.getMinorTicksCoords();
            if (!minorTicksCoords.length) return;
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
                var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: lineStyle,
                    silent: true
                }));
            }
        },
        splitArea: function(axisView, axisGroup, axisModel, gridModel) {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
        }
    };
    var $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianXAxisView, _super);
        function CartesianXAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianXAxisView.type;
            return _this;
        }
        CartesianXAxisView.type = 'xAxis';
        return CartesianXAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$417e1bdd0616e0dc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianYAxisView, _super);
        function CartesianYAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8.type;
            return _this;
        }
        CartesianYAxisView.type = 'yAxis';
        return CartesianYAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$2e2bcd8739ae039 = $1c7fc0a7283d68cb$var$CartesianAxisView;
});
parcelRegister("asa08", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c446f32aef3809$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    parcelRequire("fHITF");
    var $cZb1F;
    var $fHITF;
    var $4gEFv;
    var $7QjoM;
    var $gvLUt;
    var $gaMkj;
    var $jmSNG;
    var $7yklO;
    var $izqgC;
    var $eLEew;
    var $3GIoT;
    var $3LB2b;
    var $79c446f32aef3809$var$PI = Math.PI;
    var $79c446f32aef3809$var$AxisBuilder = function() {
        function AxisBuilder(axisModel, opt) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this.opt = opt;
            this.axisModel = axisModel;
            (0, (0, parcelRequire("bahqM")).defaults)(opt, {
                labelOffset: 0,
                nameDirection: 1,
                tickDirection: 1,
                labelDirection: 1,
                silent: true,
                handleAutoShown: function() {
                    return true;
                }
            });
            var transformGroup = new (0, parcelRequire("4KVOr")).default({
                x: opt.position[0],
                y: opt.position[1],
                rotation: opt.rotation
            });
            transformGroup.updateTransform();
            this._transformGroup = transformGroup;
        }
        AxisBuilder.prototype.hasBuilder = function(name) {
            return !!$79c446f32aef3809$var$builders[name];
        };
        AxisBuilder.prototype.add = function(name) {
            $79c446f32aef3809$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
        };
        AxisBuilder.prototype.getGroup = function() {
            return this.group;
        };
        AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
            var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotation - axisRotation);
            var textAlign;
            var textVerticalAlign;
            if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff)) {
                textVerticalAlign = direction > 0 ? 'top' : 'bottom';
                textAlign = 'center';
            } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI)) {
                textVerticalAlign = direction > 0 ? 'bottom' : 'top';
                textAlign = 'center';
            } else {
                textVerticalAlign = 'middle';
                if (rotationDiff > 0 && rotationDiff < $79c446f32aef3809$var$PI) textAlign = direction > 0 ? 'right' : 'left';
                else textAlign = direction > 0 ? 'left' : 'right';
            }
            return {
                rotation: rotationDiff,
                textAlign: textAlign,
                textVerticalAlign: textVerticalAlign
            };
        };
        AxisBuilder.makeAxisEventDataBase = function(axisModel) {
            var eventData = {
                componentType: axisModel.mainType,
                componentIndex: axisModel.componentIndex
            };
            eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
            return eventData;
        };
        AxisBuilder.isLabelSilent = function(axisModel) {
            var tooltipOpt = axisModel.get('tooltip');
            return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
        };
        return AxisBuilder;
    }();
    var $79c446f32aef3809$var$builders = {
        axisLine: function(opt, axisModel, group, transformGroup) {
            var shown = axisModel.get([
                'axisLine',
                'show'
            ]);
            if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
            if (!shown) return;
            var extent = axisModel.axis.getExtent();
            var matrix = transformGroup.transform;
            var pt1 = [
                extent[0],
                0
            ];
            var pt2 = [
                extent[1],
                0
            ];
            if (matrix) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, matrix);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, matrix);
            }
            var lineStyle = (0, (0, parcelRequire("bahqM")).extend)({
                lineCap: 'round'
            }, axisModel.getModel([
                'axisLine',
                'lineStyle'
            ]).getLineStyle());
            var line = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: lineStyle,
                strokeContainThreshold: opt.strokeContainThreshold || 5,
                silent: true,
                z2: 1
            });
            line.anid = 'line';
            group.add(line);
            var arrows = axisModel.get([
                'axisLine',
                'symbol'
            ]);
            if (arrows != null) {
                var arrowSize = axisModel.get([
                    'axisLine',
                    'symbolSize'
                ]);
                if (typeof arrows === 'string') arrows = [
                    arrows,
                    arrows
                ];
                if (typeof arrowSize === 'string' || typeof arrowSize === 'number') arrowSize = [
                    arrowSize,
                    arrowSize
                ];
                var arrowOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(axisModel.get([
                    'axisLine',
                    'symbolOffset'
                ]) || 0, arrowSize);
                var symbolWidth_1 = arrowSize[0];
                var symbolHeight_1 = arrowSize[1];
                (0, (0, parcelRequire("bahqM")).each)([
                    {
                        rotate: opt.rotation + Math.PI / 2,
                        offset: arrowOffset[0],
                        r: 0
                    },
                    {
                        rotate: opt.rotation - Math.PI / 2,
                        offset: arrowOffset[1],
                        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                    }
                ], function(point, index) {
                    if (arrows[index] !== 'none' && arrows[index] != null) {
                        var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                        var r = point.r + point.offset;
                        symbol.attr({
                            rotation: point.rotate,
                            x: pt1[0] + r * Math.cos(opt.rotation),
                            y: pt1[1] - r * Math.sin(opt.rotation),
                            silent: true,
                            z2: 11
                        });
                        group.add(symbol);
                    }
                });
            }
        },
        axisTickLabel: function(opt, axisModel, group, transformGroup) {
            var ticksEls = $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
            var labelEls = $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt);
            $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
            $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
            if (axisModel.get([
                'axisLabel',
                'hideOverlap'
            ])) {
                var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)((0, (0, parcelRequire("bahqM")).map)(labelEls, function(label) {
                    return {
                        label: label,
                        priority: label.z2,
                        defaultAttr: {
                            ignore: label.ignore
                        }
                    };
                }));
                (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelList);
            }
        },
        axisName: function(opt, axisModel, group, transformGroup) {
            var name = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisName, axisModel.get('name'));
            if (!name) return;
            var nameLocation = axisModel.get('nameLocation');
            var nameDirection = opt.nameDirection;
            var textStyleModel = axisModel.getModel('nameTextStyle');
            var gap = axisModel.get('nameGap') || 0;
            var extent = axisModel.axis.getExtent();
            var gapSignal = extent[0] > extent[1] ? -1 : 1;
            var pos = [
                nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
                $79c446f32aef3809$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
            ];
            var labelLayout;
            var nameRotation = axisModel.get('nameRotate');
            if (nameRotation != null) nameRotation = nameRotation * $79c446f32aef3809$var$PI / 180;
            var axisNameAvailableWidth;
            if ($79c446f32aef3809$var$isNameLocationCenter(nameLocation)) labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
            else {
                labelLayout = $79c446f32aef3809$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
                axisNameAvailableWidth = opt.axisNameAvailableWidth;
                if (axisNameAvailableWidth != null) {
                    axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                    !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
                }
            }
            var textFont = textStyleModel.getFont();
            var truncateOpt = axisModel.get('nameTruncate', true) || {};
            var ellipsis = truncateOpt.ellipsis;
            var maxWidth = (0, (0, parcelRequire("bahqM")).retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: pos[0],
                y: pos[1],
                rotation: labelLayout.rotation,
                silent: $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, {
                    text: name,
                    font: textFont,
                    overflow: 'truncate',
                    width: maxWidth,
                    ellipsis: ellipsis,
                    fill: textStyleModel.getTextColor() || axisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    align: textStyleModel.get('align') || labelLayout.textAlign,
                    verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
                }),
                z2: 1
            });
            (0, parcelRequire("fHITF")).setTooltipConfig({
                el: textEl,
                componentModel: axisModel,
                itemName: name
            });
            textEl.__fullText = name;
            textEl.anid = 'name';
            if (axisModel.get('triggerEvent')) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisName';
                eventData.name = name;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            group.add(textEl);
            textEl.decomposeTransform();
        }
    };
    function $79c446f32aef3809$var$endTextLayout(rotation, textPosition, textRotate, extent) {
        var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotate - rotation);
        var textAlign;
        var textVerticalAlign;
        var inverse = extent[0] > extent[1];
        var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
        if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI / 2)) {
            textVerticalAlign = onLeft ? 'bottom' : 'top';
            textAlign = 'center';
        } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI * 1.5)) {
            textVerticalAlign = onLeft ? 'top' : 'bottom';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff < $79c446f32aef3809$var$PI * 1.5 && rotationDiff > $79c446f32aef3809$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
            else textAlign = onLeft ? 'right' : 'left';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    }
    function $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
        if ((0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axisModel.axis)) return;
        var showMinLabel = axisModel.get([
            'axisLabel',
            'showMinLabel'
        ]);
        var showMaxLabel = axisModel.get([
            'axisLabel',
            'showMaxLabel'
        ]);
        labelEls = labelEls || [];
        tickEls = tickEls || [];
        var firstLabel = labelEls[0];
        var nextLabel = labelEls[1];
        var lastLabel = labelEls[labelEls.length - 1];
        var prevLabel = labelEls[labelEls.length - 2];
        var firstTick = tickEls[0];
        var nextTick = tickEls[1];
        var lastTick = tickEls[tickEls.length - 1];
        var prevTick = tickEls[tickEls.length - 2];
        if (showMinLabel === false) {
            $79c446f32aef3809$var$ignoreEl(firstLabel);
            $79c446f32aef3809$var$ignoreEl(firstTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
            if (showMinLabel) {
                $79c446f32aef3809$var$ignoreEl(nextLabel);
                $79c446f32aef3809$var$ignoreEl(nextTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(firstLabel);
                $79c446f32aef3809$var$ignoreEl(firstTick);
            }
        }
        if (showMaxLabel === false) {
            $79c446f32aef3809$var$ignoreEl(lastLabel);
            $79c446f32aef3809$var$ignoreEl(lastTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
            if (showMaxLabel) {
                $79c446f32aef3809$var$ignoreEl(prevLabel);
                $79c446f32aef3809$var$ignoreEl(prevTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(lastLabel);
                $79c446f32aef3809$var$ignoreEl(lastTick);
            }
        }
    }
    function $79c446f32aef3809$var$ignoreEl(el) {
        el && (el.ignore = true);
    }
    function $79c446f32aef3809$var$isTwoLabelOverlapped(current, next) {
        var firstRect = current && current.getBoundingRect().clone();
        var nextRect = next && next.getBoundingRect().clone();
        if (!firstRect || !nextRect) return;
        var mRotationBack = (0, parcelRequire("izqgC")).identity([]);
        (0, parcelRequire("izqgC")).rotate(mRotationBack, mRotationBack, -current.rotation);
        firstRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, current.getLocalTransform()));
        nextRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, next.getLocalTransform()));
        return firstRect.intersect(nextRect);
    }
    function $79c446f32aef3809$var$isNameLocationCenter(nameLocation) {
        return nameLocation === 'middle' || nameLocation === 'center';
    }
    function $79c446f32aef3809$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
        var tickEls = [];
        var pt1 = [];
        var pt2 = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = ticksCoords[i].coord;
            pt1[0] = tickCoord;
            pt1[1] = 0;
            pt2[0] = tickCoord;
            pt2[1] = tickEndCoord;
            if (tickTransform) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, tickTransform);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, tickTransform);
            }
            var tickEl = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: tickLineStyle,
                z2: 2,
                autoBatch: true,
                silent: true
            });
            tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
            tickEls.push(tickEl);
        }
        return tickEls;
    }
    function $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var tickModel = axisModel.getModel('axisTick');
        var shown = tickModel.get('show');
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
        if (!shown || axis.scale.isBlank()) return;
        var lineStyleModel = tickModel.getModel('lineStyle');
        var tickEndCoord = opt.tickDirection * tickModel.get('length');
        var ticksCoords = axis.getTicksCoords();
        var ticksEls = $79c446f32aef3809$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }), 'ticks');
        for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
        return ticksEls;
    }
    function $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
        var axis = axisModel.axis;
        var minorTickModel = axisModel.getModel('minorTick');
        if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var lineStyleModel = minorTickModel.getModel('lineStyle');
        var tickEndCoord = tickDirection * minorTickModel.get('length');
        var minorTickLineStyle = (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), (0, (0, parcelRequire("bahqM")).defaults)(axisModel.getModel('axisTick').getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }));
        for(var i = 0; i < minorTicksCoords.length; i++){
            var minorTicksEls = $79c446f32aef3809$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
            for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
        }
    }
    function $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var show = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisLabelShow, axisModel.get([
            'axisLabel',
            'show'
        ]));
        if (!show || axis.scale.isBlank()) return;
        var labelModel = axisModel.getModel('axisLabel');
        var labelMargin = labelModel.get('margin');
        var labels = axis.getViewLabels();
        var labelRotation = ((0, (0, parcelRequire("bahqM")).retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $79c446f32aef3809$var$PI / 180;
        var labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
        var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
        var labelEls = [];
        var silent = $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel);
        var triggerEvent = axisModel.get('triggerEvent');
        (0, (0, parcelRequire("bahqM")).each)(labels, function(labelItem, index) {
            var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            var formattedLabel = labelItem.formattedLabel;
            var rawLabel = labelItem.rawLabel;
            var itemLabelModel = labelModel;
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ((0, (0, parcelRequire("bahqM")).isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, (0, parcelRequire("gaMkj")).default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
            }
            var textColor = itemLabelModel.getTextColor() || axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ]);
            var tickCoord = axis.dataToCoord(tickValue);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: tickCoord,
                y: opt.labelOffset + opt.labelDirection * labelMargin,
                rotation: labelLayout.rotation,
                silent: silent,
                z2: 10 + (labelItem.level || 0),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(itemLabelModel, {
                    text: formattedLabel,
                    align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                    verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                    fill: typeof textColor === 'function' ? textColor(axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
                })
            });
            textEl.anid = 'label_' + tickValue;
            if (triggerEvent) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = rawLabel;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            labelEls.push(textEl);
            group.add(textEl);
            textEl.decomposeTransform();
        });
        return labelEls;
    }
    var $79c446f32aef3809$export$2e2bcd8739ae039 = $79c446f32aef3809$var$AxisBuilder;
});
parcelRegister("3LB2b", function(module, exports) {
    $parcel$export(module.exports, "prepareLayoutList", ()=>$2be27d213439fed1$export$6c403cad1ae3e239);
    $parcel$export(module.exports, "shiftLayoutOnX", ()=>$2be27d213439fed1$export$b6b2b07f8ed32bd6);
    $parcel$export(module.exports, "shiftLayoutOnY", ()=>$2be27d213439fed1$export$118c25e0932528e4);
    $parcel$export(module.exports, "hideOverlap", ()=>$2be27d213439fed1$export$8ce774e164a49410);
    var $1E3E8;
    var $lM5Gp;
    function $2be27d213439fed1$export$6c403cad1ae3e239(input) {
        var list = [];
        for(var i = 0; i < input.length; i++){
            var rawItem = input[i];
            if (rawItem.defaultAttr.ignore) continue;
            var label = rawItem.label;
            var transform = label.getComputedTransform();
            var localRect = label.getBoundingRect();
            var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
            var minMargin = label.style.margin || 0;
            var globalRect = localRect.clone();
            globalRect.applyTransform(transform);
            globalRect.x -= minMargin / 2;
            globalRect.y -= minMargin / 2;
            globalRect.width += minMargin;
            globalRect.height += minMargin;
            var obb = isAxisAligned ? new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform) : null;
            list.push({
                label: label,
                labelLine: rawItem.labelLine,
                rect: globalRect,
                localRect: localRect,
                obb: obb,
                priority: rawItem.priority,
                defaultAttr: rawItem.defaultAttr,
                layoutOption: rawItem.computedLayoutOption,
                axisAligned: isAxisAligned,
                transform: transform
            });
        }
        return list;
    }
    function $2be27d213439fed1$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
        var len = list.length;
        if (len < 2) return;
        list.sort(function(a, b) {
            return a.rect[xyDim] - b.rect[xyDim];
        });
        var lastPos = 0;
        var delta;
        var adjusted = false;
        var shifts = [];
        var totalShifts = 0;
        for(var i = 0; i < len; i++){
            var item = list[i];
            var rect = item.rect;
            delta = rect[xyDim] - lastPos;
            if (delta < 0) {
                rect[xyDim] -= delta;
                item.label[xyDim] -= delta;
                adjusted = true;
            }
            var shift = Math.max(-delta, 0);
            shifts.push(shift);
            totalShifts += shift;
            lastPos = rect[xyDim] + rect[sizeDim];
        }
        if (totalShifts > 0 && balanceShift) shiftList(-totalShifts / len, 0, len);
        var first = list[0];
        var last = list[len - 1];
        var minGap;
        var maxGap;
        updateMinMaxGap();
        minGap < 0 && squeezeGaps(-minGap, 0.8);
        maxGap < 0 && squeezeGaps(maxGap, 0.8);
        updateMinMaxGap();
        takeBoundsGap(minGap, maxGap, 1);
        takeBoundsGap(maxGap, minGap, -1);
        updateMinMaxGap();
        if (minGap < 0) squeezeWhenBailout(-minGap);
        if (maxGap < 0) squeezeWhenBailout(maxGap);
        function updateMinMaxGap() {
            minGap = first.rect[xyDim] - minBound;
            maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
        }
        function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
            if (gapThisBound < 0) {
                var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
                if (moveFromMaxGap > 0) {
                    shiftList(moveFromMaxGap * moveDir, 0, len);
                    var remained = moveFromMaxGap + gapThisBound;
                    if (remained < 0) squeezeGaps(-remained * moveDir, 1);
                } else squeezeGaps(-gapThisBound * moveDir, 1);
            }
        }
        function shiftList(delta, start, end) {
            if (delta !== 0) adjusted = true;
            for(var i = start; i < end; i++){
                var item = list[i];
                var rect = item.rect;
                rect[xyDim] += delta;
                item.label[xyDim] += delta;
            }
        }
        function squeezeGaps(delta, maxSqeezePercent) {
            var gaps = [];
            var totalGaps = 0;
            for(var i = 1; i < len; i++){
                var prevItemRect = list[i - 1].rect;
                var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
                gaps.push(gap);
                totalGaps += gap;
            }
            if (!totalGaps) return;
            var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
            if (delta > 0) for(var i = 0; i < len - 1; i++){
                var movement = gaps[i] * squeezePercent;
                shiftList(movement, 0, i + 1);
            }
            else for(var i = len - 1; i > 0; i--){
                var movement = gaps[i - 1] * squeezePercent;
                shiftList(-movement, i, len);
            }
        }
        function squeezeWhenBailout(delta) {
            var dir = delta < 0 ? -1 : 1;
            delta = Math.abs(delta);
            var moveForEachLabel = Math.ceil(delta / (len - 1));
            for(var i = 0; i < len - 1; i++){
                if (dir > 0) shiftList(moveForEachLabel, 0, i + 1);
                else shiftList(-moveForEachLabel, len - i - 1, len);
                delta -= moveForEachLabel;
                if (delta <= 0) return;
            }
        }
        return adjusted;
    }
    function $2be27d213439fed1$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
    }
    function $2be27d213439fed1$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
    }
    function $2be27d213439fed1$export$8ce774e164a49410(labelList) {
        var displayedLabels = [];
        labelList.sort(function(a, b) {
            return b.priority - a.priority;
        });
        var globalRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
        function hideEl(el) {
            if (!el.ignore) {
                var emphasisState = el.ensureState('emphasis');
                if (emphasisState.ignore == null) emphasisState.ignore = false;
            }
            el.ignore = true;
        }
        for(var i = 0; i < labelList.length; i++){
            var labelItem = labelList[i];
            var isAxisAligned = labelItem.axisAligned;
            var localRect = labelItem.localRect;
            var transform = labelItem.transform;
            var label = labelItem.label;
            var labelLine = labelItem.labelLine;
            globalRect.copy(labelItem.rect);
            globalRect.width -= 0.1;
            globalRect.height -= 0.1;
            globalRect.x += 0.05;
            globalRect.y += 0.05;
            var obb = labelItem.obb;
            var overlapped = false;
            for(var j = 0; j < displayedLabels.length; j++){
                var existsTextCfg = displayedLabels[j];
                if (!globalRect.intersect(existsTextCfg.rect)) continue;
                if (isAxisAligned && existsTextCfg.axisAligned) {
                    overlapped = true;
                    break;
                }
                if (!existsTextCfg.obb) existsTextCfg.obb = new (0, (0, parcelRequire("lM5Gp")).default)(existsTextCfg.localRect, existsTextCfg.transform);
                if (!obb) obb = new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform);
                if (obb.intersect(existsTextCfg.obb)) {
                    overlapped = true;
                    break;
                }
            }
            if (overlapped) {
                hideEl(label);
                labelLine && hideEl(labelLine);
            } else {
                label.attr('ignore', labelItem.defaultAttr.ignore);
                labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
                displayedLabels.push(labelItem);
            }
        }
    }
});
parcelRegister("atJL7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a101b97b7710a5f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $8QSpd;
    var $fkskt;
    var $7a101b97b7710a5f$var$axisPointerClazz = {};
    var $7a101b97b7710a5f$var$AxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisView, _super);
        function AxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisView.type;
            return _this;
        }
        AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.axisPointerClass && (0, parcelRequire("8QSpd")).fixValue(axisModel);
            _super.prototype.render.apply(this, arguments);
            this._doUpdateAxisPointerClass(axisModel, api, true);
        };
        AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
            this._doUpdateAxisPointerClass(axisModel, api, false);
        };
        AxisView.prototype.remove = function(ecModel, api) {
            var axisPointer = this._axisPointer;
            axisPointer && axisPointer.remove(api);
        };
        AxisView.prototype.dispose = function(ecModel, api) {
            this._disposeAxisPointer(api);
            _super.prototype.dispose.apply(this, arguments);
        };
        AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
            var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
            if (!Clazz) return;
            var axisPointerModel = (0, parcelRequire("8QSpd")).getAxisPointerModel(axisModel);
            axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
        };
        AxisView.prototype._disposeAxisPointer = function(api) {
            this._axisPointer && this._axisPointer.dispose(api);
            this._axisPointer = null;
        };
        AxisView.registerAxisPointerClass = function(type, clazz) {
            $7a101b97b7710a5f$var$axisPointerClazz[type] = clazz;
        };
        AxisView.getAxisPointerClass = function(type) {
            return type && $7a101b97b7710a5f$var$axisPointerClazz[type];
        };
        AxisView.type = 'axis';
        return AxisView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $7a101b97b7710a5f$export$2e2bcd8739ae039 = $7a101b97b7710a5f$var$AxisView;
});
parcelRegister("8QSpd", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$671d61e645e8595c$export$bb44f104e3c54dae);
    $parcel$export(module.exports, "makeKey", ()=>$671d61e645e8595c$export$d01b444bafb1a792);
    $parcel$export(module.exports, "fixValue", ()=>$671d61e645e8595c$export$f5ea32e3629d8043);
    $parcel$export(module.exports, "getAxisInfo", ()=>$671d61e645e8595c$export$bd39458db76002ab);
    $parcel$export(module.exports, "getAxisPointerModel", ()=>$671d61e645e8595c$export$3b06fce3f68b734);
    var $gaMkj;
    var $bahqM;
    function $671d61e645e8595c$export$bb44f104e3c54dae(ecModel, api) {
        var result = {
            axesInfo: {},
            seriesInvolved: false,
            coordSysAxesInfo: {},
            coordSysMap: {}
        };
        $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api);
        result.seriesInvolved && $671d61e645e8595c$var$collectSeriesInfo(result, ecModel);
        return result;
    }
    function $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var globalAxisPointerModel = ecModel.getComponent('axisPointer');
        var linksOption = globalAxisPointerModel.get('link', true) || [];
        var linkGroups = [];
        (0, (0, parcelRequire("bahqM")).each)(api.getCoordinateSystems(), function(coordSys) {
            if (!coordSys.axisPointerEnabled) return;
            var coordSysKey = $671d61e645e8595c$export$d01b444bafb1a792(coordSys.model);
            var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
            result.coordSysMap[coordSysKey] = coordSys;
            var coordSysModel = coordSys.model;
            var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
            (0, (0, parcelRequire("bahqM")).each)(coordSys.getAxes(), (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, false, null));
            if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
                var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
                var cross = baseTooltipModel.get([
                    'axisPointer',
                    'type'
                ]) === 'cross';
                var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                    'axisPointer',
                    'axis'
                ]));
                if (triggerAxis || cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.baseAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
                if (cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.otherAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, 'cross', false));
            }
            function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
                var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
                var axisPointerShow = axisPointerModel.get('show');
                if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$671d61e645e8595c$var$isHandleTrigger(axisPointerModel)) return;
                if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
                axisPointerModel = fromTooltip ? $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
                var snap = axisPointerModel.get('snap');
                var axisKey = $671d61e645e8595c$export$d01b444bafb1a792(axis.model);
                var involveSeries = triggerTooltip || snap || axis.type === 'category';
                var axisInfo = result.axesInfo[axisKey] = {
                    key: axisKey,
                    axis: axis,
                    coordSys: coordSys,
                    axisPointerModel: axisPointerModel,
                    triggerTooltip: triggerTooltip,
                    involveSeries: involveSeries,
                    snap: snap,
                    useHandle: $671d61e645e8595c$var$isHandleTrigger(axisPointerModel),
                    seriesModels: [],
                    linkGroup: null
                };
                axesInfoInCoordSys[axisKey] = axisInfo;
                result.seriesInvolved = result.seriesInvolved || involveSeries;
                var groupIndex = $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis);
                if (groupIndex != null) {
                    var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                        axesInfo: {}
                    });
                    linkGroup.axesInfo[axisKey] = axisInfo;
                    linkGroup.mapper = linksOption[groupIndex].mapper;
                    axisInfo.linkGroup = linkGroup;
                }
            }
        });
    }
    function $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
        var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
        var fields = [
            'type',
            'snap',
            'lineStyle',
            'shadowStyle',
            'label',
            'animation',
            'animationDurationUpdate',
            'animationEasingUpdate',
            'z'
        ];
        var volatileOption = {};
        (0, (0, parcelRequire("bahqM")).each)(fields, function(field) {
            volatileOption[field] = (0, (0, parcelRequire("bahqM")).clone)(tooltipAxisPointerModel.get(field));
        });
        volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
        if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
        var labelOption = volatileOption.label || (volatileOption.label = {});
        labelOption.show == null && (labelOption.show = false);
        if (fromTooltip === 'cross') {
            var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
                'label',
                'show'
            ]);
            labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
            if (!triggerTooltip) {
                var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
                crossStyle && (0, (0, parcelRequire("bahqM")).defaults)(labelOption, crossStyle.textStyle);
            }
        }
        return axis.model.getModel('axisPointer', new (0, (0, parcelRequire("gaMkj")).default)(volatileOption, globalAxisPointerModel, ecModel));
    }
    function $671d61e645e8595c$var$collectSeriesInfo(result, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesTooltipTrigger = seriesModel.get([
                'tooltip',
                'trigger'
            ], true);
            var seriesTooltipShow = seriesModel.get([
                'tooltip',
                'show'
            ], true);
            if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
                'axisPointer',
                'show'
            ], true) === false) return;
            (0, (0, parcelRequire("bahqM")).each)(result.coordSysAxesInfo[$671d61e645e8595c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
                var axis = axisInfo.axis;
                if (coordSys.getAxis(axis.dim) === axis) {
                    axisInfo.seriesModels.push(seriesModel);
                    axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                    axisInfo.seriesDataCount += seriesModel.getData().count();
                }
            });
        });
    }
    function $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis) {
        var axisModel = axis.model;
        var dim = axis.dim;
        for(var i = 0; i < linksOption.length; i++){
            var linkOption = linksOption[i] || {};
            if ($671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
        }
    }
    function $671d61e645e8595c$var$checkPropInLink(linkPropValue, axisPropValue) {
        return linkPropValue === 'all' || (0, (0, parcelRequire("bahqM")).isArray)(linkPropValue) && (0, (0, parcelRequire("bahqM")).indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
    }
    function $671d61e645e8595c$export$f5ea32e3629d8043(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        if (!axisInfo) return;
        var axisPointerModel = axisInfo.axisPointerModel;
        var scale = axisInfo.axis.scale;
        var option = axisPointerModel.option;
        var status = axisPointerModel.get('status');
        var value = axisPointerModel.get('value');
        if (value != null) value = scale.parse(value);
        var useHandle = $671d61e645e8595c$var$isHandleTrigger(axisPointerModel);
        if (status == null) option.status = useHandle ? 'show' : 'hide';
        var extent = scale.getExtent().slice();
        extent[0] > extent[1] && extent.reverse();
        if (value == null || value > extent[1]) value = extent[1];
        if (value < extent[0]) value = extent[0];
        option.value = value;
        if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
    }
    function $671d61e645e8595c$export$bd39458db76002ab(axisModel) {
        var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
        return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$671d61e645e8595c$export$d01b444bafb1a792(axisModel)];
    }
    function $671d61e645e8595c$export$3b06fce3f68b734(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        return axisInfo && axisInfo.axisPointerModel;
    }
    function $671d61e645e8595c$var$isHandleTrigger(axisPointerModel) {
        return !!axisPointerModel.get([
            'handle',
            'show'
        ]);
    }
    function $671d61e645e8595c$export$d01b444bafb1a792(model) {
        return model.type + '||' + model.id;
    }
});
parcelRegister("6dLRi", function(module, exports) {
    $parcel$export(module.exports, "rectCoordAxisBuildSplitArea", ()=>$487914b46b0b3c46$export$c80b7ef1527ec8c9);
    $parcel$export(module.exports, "rectCoordAxisHandleRemove", ()=>$487914b46b0b3c46$export$48ebf2d6ce8ad076);
    var $bahqM;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $eaKsF;
    var $487914b46b0b3c46$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $487914b46b0b3c46$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitAreaModel = axisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var gridRect = gridModel.coordinateSystem.getRect();
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitAreaModel,
            clamp: true
        });
        if (!ticksCoords.length) return;
        var areaColorsLen = areaColors.length;
        var lastSplitAreaColors = $487914b46b0b3c46$var$inner(axisView).splitAreaColors;
        var newSplitAreaColors = (0, parcelRequire("bahqM")).createHashMap();
        var colorIndex = 0;
        if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
            var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
            if (cIndex != null) {
                colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
                break;
            }
        }
        var prev = axis.toGlobalCoord(ticksCoords[0].coord);
        var areaStyle = areaStyleModel.getAreaStyle();
        areaColors = (0, parcelRequire("bahqM")).isArray(areaColors) ? areaColors : [
            areaColors
        ];
        for(var i = 1; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (axis.isHorizontal()) {
                x = prev;
                y = gridRect.y;
                width = tickCoord - x;
                height = gridRect.height;
                prev = x + width;
            } else {
                x = gridRect.x;
                y = prev;
                width = gridRect.width;
                height = tickCoord - y;
                prev = y + height;
            }
            var tickValue = ticksCoords[i - 1].tickValue;
            tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
            axisGroup.add(new (0, parcelRequire("7Tw7u")).default({
                anid: tickValue != null ? 'area_' + tickValue : null,
                shape: {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                },
                style: (0, parcelRequire("bahqM")).defaults({
                    fill: areaColors[colorIndex]
                }, areaStyle),
                autoBatch: true,
                silent: true
            }));
            colorIndex = (colorIndex + 1) % areaColorsLen;
        }
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = newSplitAreaColors;
    }
    function $487914b46b0b3c46$export$48ebf2d6ce8ad076(axisView) {
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = null;
    }
});
parcelRegister("hi3Y7", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$c9673230869c3336$export$4b3e715f166fdd78);
    var $atJL7;
    var $4SGoL;
    var $5UrR7;
    var $gPvBV;
    var $bahqM;
    var $8QSpd;
    var $5TxwA;
    function $c9673230869c3336$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("atJL7")).default).registerAxisPointerClass('CartesianAxisPointer', (0, (0, parcelRequire("4SGoL")).default));
        registers.registerComponentModel((0, (0, parcelRequire("5UrR7")).default));
        registers.registerComponentView((0, (0, parcelRequire("gPvBV")).default));
        registers.registerPreprocessor(function(option) {
            if (option) {
                (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
                var link = option.axisPointer.link;
                if (link && !(0, (0, parcelRequire("bahqM")).isArray)(link)) option.axisPointer.link = [
                    link
                ];
            }
        });
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
            ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, (0, parcelRequire("8QSpd")).collect)(ecModel, api);
        });
        registers.registerAction({
            type: 'updateAxisPointer',
            event: 'updateAxisPointer',
            update: ':updateAxisPointer'
        }, (0, (0, parcelRequire("5TxwA")).default));
    }
});
parcelRegister("4SGoL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38dd17fca85a901b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fOZs6;
    var $eSE0c;
    var $dBIJY;
    var $38dd17fca85a901b$var$CartesianAxisPointer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisPointer, _super);
        function CartesianAxisPointer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisPointerType = axisPointerModel.get('type');
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
            if (axisPointerType && axisPointerType !== 'none') {
                var elStyle = (0, parcelRequire("eSE0c")).buildElStyle(axisPointerModel);
                var pointerOption = $38dd17fca85a901b$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
                pointerOption.style = elStyle;
                elOption.graphicKey = pointerOption.type;
                elOption.pointer = pointerOption;
            }
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(grid.model, axisModel);
            (0, parcelRequire("eSE0c")).buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
        };
        CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(axisModel.axis.grid.model, axisModel, {
                labelInside: false
            });
            layoutInfo.labelMargin = axisPointerModel.get([
                'handle',
                'margin'
            ]);
            var pos = (0, parcelRequire("eSE0c")).getTransformedPosition(axisModel.axis, value, layoutInfo);
            return {
                x: pos[0],
                y: pos[1],
                rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
            };
        };
        CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisExtent = axis.getGlobalExtent(true);
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var dimIndex = axis.dim === 'x' ? 0 : 1;
            var currPosition = [
                transform.x,
                transform.y
            ];
            currPosition[dimIndex] += delta[dimIndex];
            currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
            currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
            var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
            var cursorPoint = [
                cursorOtherValue,
                cursorOtherValue
            ];
            cursorPoint[dimIndex] = currPosition[dimIndex];
            var tooltipOptions = [
                {
                    verticalAlign: 'middle'
                },
                {
                    align: 'center'
                }
            ];
            return {
                x: currPosition[0],
                y: currPosition[1],
                rotation: transform.rotation,
                cursorPoint: cursorPoint,
                tooltipOption: tooltipOptions[dimIndex]
            };
        };
        return CartesianAxisPointer;
    }((0, (0, parcelRequire("fOZs6")).default));
    function $38dd17fca85a901b$var$getCartesian(grid, axis) {
        var opt = {};
        opt[axis.dim + 'AxisIndex'] = axis.index;
        return grid.getCartesian(opt);
    }
    var $38dd17fca85a901b$var$pointerShapeBuilder = {
        line: function(axis, pixelValue, otherExtent) {
            var targetShape = (0, parcelRequire("eSE0c")).makeLineShape([
                pixelValue,
                otherExtent[0]
            ], [
                pixelValue,
                otherExtent[1]
            ], $38dd17fca85a901b$var$getAxisDimIndex(axis));
            return {
                type: 'Line',
                subPixelOptimize: true,
                shape: targetShape
            };
        },
        shadow: function(axis, pixelValue, otherExtent) {
            var bandWidth = Math.max(1, axis.getBandWidth());
            var span = otherExtent[1] - otherExtent[0];
            return {
                type: 'Rect',
                shape: (0, parcelRequire("eSE0c")).makeRectShape([
                    pixelValue - bandWidth / 2,
                    otherExtent[0]
                ], [
                    bandWidth,
                    span
                ], $38dd17fca85a901b$var$getAxisDimIndex(axis))
            };
        }
    };
    function $38dd17fca85a901b$var$getAxisDimIndex(axis) {
        return axis.dim === 'x' ? 0 : 1;
    }
    var $38dd17fca85a901b$export$2e2bcd8739ae039 = $38dd17fca85a901b$var$CartesianAxisPointer;
});
parcelRegister("fOZs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b84b31aa9defeeb8$export$2e2bcd8739ae039);
    var $bahqM;
    var $fHITF;
    var $8QSpd;
    var $65X4x;
    var $ljaBy;
    var $eaKsF;
    var $b84b31aa9defeeb8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b84b31aa9defeeb8$var$clone = (0, parcelRequire("bahqM")).clone;
    var $b84b31aa9defeeb8$var$bind = (0, parcelRequire("bahqM")).bind;
    var $b84b31aa9defeeb8$var$BaseAxisPointer = function() {
        function BaseAxisPointer() {
            this._dragging = false;
            this.animationThreshold = 15;
        }
        BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
            var value = axisPointerModel.get('value');
            var status = axisPointerModel.get('status');
            this._axisModel = axisModel;
            this._axisPointerModel = axisPointerModel;
            this._api = api;
            if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
            this._lastValue = value;
            this._lastStatus = status;
            var group = this._group;
            var handle = this._handle;
            if (!status || status === 'hide') {
                group && group.hide();
                handle && handle.hide();
                return;
            }
            group && group.show();
            handle && handle.show();
            var elOption = {};
            this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
            var graphicKey = elOption.graphicKey;
            if (graphicKey !== this._lastGraphicKey) this.clear(api);
            this._lastGraphicKey = graphicKey;
            var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
            if (!group) {
                group = this._group = new (0, parcelRequire("fHITF")).Group();
                this.createPointerEl(group, elOption, axisModel, axisPointerModel);
                this.createLabelEl(group, elOption, axisModel, axisPointerModel);
                api.getZr().add(group);
            } else {
                var doUpdateProps = (0, parcelRequire("bahqM")).curry($b84b31aa9defeeb8$var$updateProps, axisPointerModel, moveAnimation);
                this.updatePointerEl(group, elOption, doUpdateProps);
                this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, true);
            this._renderHandle(value);
        };
        BaseAxisPointer.prototype.remove = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.dispose = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
            var animation = axisPointerModel.get('animation');
            var axis = axisModel.axis;
            var isCategoryAxis = axis.type === 'category';
            var useSnap = axisPointerModel.get('snap');
            if (!useSnap && !isCategoryAxis) return false;
            if (animation === 'auto' || animation == null) {
                var animationThreshold = this.animationThreshold;
                if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
                if (useSnap) {
                    var seriesDataCount = (0, parcelRequire("8QSpd")).getAxisInfo(axisModel).seriesDataCount;
                    var axisExtent = axis.getExtent();
                    return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
                }
                return false;
            }
            return animation === true;
        };
        BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
        BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
            var pointerOption = elOption.pointer;
            if (pointerOption) {
                var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl = new (0, parcelRequire("fHITF"))[pointerOption.type]($b84b31aa9defeeb8$var$clone(elOption.pointer));
                group.add(pointerEl);
            }
        };
        BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
            if (elOption.label) {
                var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl = new (0, parcelRequire("fHITF")).Text($b84b31aa9defeeb8$var$clone(elOption.label));
                group.add(labelEl);
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
            var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl;
            if (pointerEl && elOption.pointer) {
                pointerEl.setStyle(elOption.pointer.style);
                updateProps(pointerEl, {
                    shape: elOption.pointer.shape
                });
            }
        };
        BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
            var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl;
            if (labelEl) {
                labelEl.setStyle(elOption.label.style);
                updateProps(labelEl, {
                    x: elOption.label.x,
                    y: elOption.label.y
                });
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype._renderHandle = function(value) {
            if (this._dragging || !this.updateHandleTransform) return;
            var axisPointerModel = this._axisPointerModel;
            var zr = this._api.getZr();
            var handle = this._handle;
            var handleModel = axisPointerModel.getModel('handle');
            var status = axisPointerModel.get('status');
            if (!handleModel.get('show') || !status || status === 'hide') {
                handle && zr.remove(handle);
                this._handle = null;
                return;
            }
            var isInit;
            if (!this._handle) {
                isInit = true;
                handle = this._handle = (0, parcelRequire("fHITF")).createIcon(handleModel.get('icon'), {
                    cursor: 'move',
                    draggable: true,
                    onmousemove: function(e) {
                        (0, parcelRequire("65X4x")).stop(e.event);
                    },
                    onmousedown: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this, 0, 0),
                    drift: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this),
                    ondragend: $b84b31aa9defeeb8$var$bind(this._onHandleDragEnd, this)
                });
                zr.add(handle);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(handle, axisPointerModel, false);
            handle.setStyle(handleModel.getItemStyle(null, [
                'color',
                'borderColor',
                'borderWidth',
                'opacity',
                'shadowColor',
                'shadowBlur',
                'shadowOffsetX',
                'shadowOffsetY'
            ]));
            var handleSize = handleModel.get('size');
            if (!(0, parcelRequire("bahqM")).isArray(handleSize)) handleSize = [
                handleSize,
                handleSize
            ];
            handle.scaleX = handleSize[0] / 2;
            handle.scaleY = handleSize[1] / 2;
            (0, parcelRequire("ljaBy")).createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
            this._moveHandleToValue(value, isInit);
        };
        BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
            $b84b31aa9defeeb8$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b84b31aa9defeeb8$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
        };
        BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
            var handle = this._handle;
            if (!handle) return;
            this._dragging = true;
            var trans = this.updateHandleTransform($b84b31aa9defeeb8$var$getHandleTransProps(handle), [
                dx,
                dy
            ], this._axisModel, this._axisPointerModel);
            this._payloadInfo = trans;
            handle.stopAnimation();
            handle.attr($b84b31aa9defeeb8$var$getHandleTransProps(trans));
            $b84b31aa9defeeb8$var$inner(handle).lastProp = null;
            this._doDispatchAxisPointer();
        };
        BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
            var handle = this._handle;
            if (!handle) return;
            var payloadInfo = this._payloadInfo;
            var axisModel = this._axisModel;
            this._api.dispatchAction({
                type: 'updateAxisPointer',
                x: payloadInfo.cursorPoint[0],
                y: payloadInfo.cursorPoint[1],
                tooltipOption: payloadInfo.tooltipOption,
                axesInfo: [
                    {
                        axisDim: axisModel.axis.dim,
                        axisIndex: axisModel.componentIndex
                    }
                ]
            });
        };
        BaseAxisPointer.prototype._onHandleDragEnd = function() {
            this._dragging = false;
            var handle = this._handle;
            if (!handle) return;
            var value = this._axisPointerModel.get('value');
            this._moveHandleToValue(value);
            this._api.dispatchAction({
                type: 'hideTip'
            });
        };
        BaseAxisPointer.prototype.clear = function(api) {
            this._lastValue = null;
            this._lastStatus = null;
            var zr = api.getZr();
            var group = this._group;
            var handle = this._handle;
            if (zr && group) {
                this._lastGraphicKey = null;
                group && zr.remove(group);
                handle && zr.remove(handle);
                this._group = null;
                this._handle = null;
                this._payloadInfo = null;
            }
        };
        BaseAxisPointer.prototype.doClear = function() {};
        BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
            xDimIndex = xDimIndex || 0;
            return {
                x: xy[xDimIndex],
                y: xy[1 - xDimIndex],
                width: wh[xDimIndex],
                height: wh[1 - xDimIndex]
            };
        };
        return BaseAxisPointer;
    }();
    function $b84b31aa9defeeb8$var$updateProps(animationModel, moveAnimation, el, props) {
        if (!$b84b31aa9defeeb8$var$propsEqual($b84b31aa9defeeb8$var$inner(el).lastProp, props)) {
            $b84b31aa9defeeb8$var$inner(el).lastProp = props;
            moveAnimation ? (0, parcelRequire("fHITF")).updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
        }
    }
    function $b84b31aa9defeeb8$var$propsEqual(lastProps, newProps) {
        if ((0, parcelRequire("bahqM")).isObject(lastProps) && (0, parcelRequire("bahqM")).isObject(newProps)) {
            var equals_1 = true;
            (0, parcelRequire("bahqM")).each(newProps, function(item, key) {
                equals_1 = equals_1 && $b84b31aa9defeeb8$var$propsEqual(lastProps[key], item);
            });
            return !!equals_1;
        } else return lastProps === newProps;
    }
    function $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel) {
        labelEl[axisPointerModel.get([
            'label',
            'show'
        ]) ? 'show' : 'hide']();
    }
    function $b84b31aa9defeeb8$var$getHandleTransProps(trans) {
        return {
            x: trans.x || 0,
            y: trans.y || 0,
            rotation: trans.rotation || 0
        };
    }
    function $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, silent) {
        var z = axisPointerModel.get('z');
        var zlevel = axisPointerModel.get('zlevel');
        group && group.traverse(function(el) {
            if (el.type !== 'group') {
                z != null && (el.z = z);
                zlevel != null && (el.zlevel = zlevel);
                el.silent = silent;
            }
        });
    }
    var $b84b31aa9defeeb8$export$2e2bcd8739ae039 = $b84b31aa9defeeb8$var$BaseAxisPointer;
});
parcelRegister("65X4x", function(module, exports) {
    $parcel$export(module.exports, "clientToLocal", ()=>$47010835ddffd941$export$7d5fecde839eee88);
    $parcel$export(module.exports, "getNativeEvent", ()=>$47010835ddffd941$export$4abe0e945399ac1d);
    $parcel$export(module.exports, "normalizeEvent", ()=>$47010835ddffd941$export$40fadb093aebad71);
    $parcel$export(module.exports, "addEventListener", ()=>$47010835ddffd941$export$3f65cefe8380dbea);
    $parcel$export(module.exports, "removeEventListener", ()=>$47010835ddffd941$export$8ff9f68337b520c0);
    $parcel$export(module.exports, "stop", ()=>$47010835ddffd941$export$fa6813432f753b0d);
    $parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", ()=>$47010835ddffd941$export$b7ae4cded3e71bd2);
    var $hZfwb;
    var $6AZf6;
    var $47010835ddffd941$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
    var $47010835ddffd941$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
    var $47010835ddffd941$var$_calcOut = [];
    function $47010835ddffd941$export$7d5fecde839eee88(el, e, out, calculate) {
        out = out || {};
        if (calculate || !(0, (0, parcelRequire("hZfwb")).default).canvasSupported) $47010835ddffd941$var$calculateZrXY(el, e, out);
        else if ((0, (0, parcelRequire("hZfwb")).default).browser.firefox && (0, (0, parcelRequire("hZfwb")).default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
            out.zrX = e.layerX;
            out.zrY = e.layerY;
        } else if (e.offsetX != null) {
            out.zrX = e.offsetX;
            out.zrY = e.offsetY;
        } else $47010835ddffd941$var$calculateZrXY(el, e, out);
        return out;
    }
    function $47010835ddffd941$var$calculateZrXY(el, e, out) {
        if ((0, (0, parcelRequire("hZfwb")).default).domSupported && el.getBoundingClientRect) {
            var ex = e.clientX;
            var ey = e.clientY;
            if ((0, (0, parcelRequire("6AZf6")).isCanvasEl)(el)) {
                var box = el.getBoundingClientRect();
                out.zrX = ex - box.left;
                out.zrY = ey - box.top;
                return;
            } else if ((0, (0, parcelRequire("6AZf6")).transformCoordWithViewport)($47010835ddffd941$var$_calcOut, el, ex, ey)) {
                out.zrX = $47010835ddffd941$var$_calcOut[0];
                out.zrY = $47010835ddffd941$var$_calcOut[1];
                return;
            }
        }
        out.zrX = out.zrY = 0;
    }
    function $47010835ddffd941$export$4abe0e945399ac1d(e) {
        return e || window.event;
    }
    function $47010835ddffd941$export$40fadb093aebad71(el, e, calculate) {
        e = $47010835ddffd941$export$4abe0e945399ac1d(e);
        if (e.zrX != null) return e;
        var eventType = e.type;
        var isTouch = eventType && eventType.indexOf('touch') >= 0;
        if (!isTouch) {
            $47010835ddffd941$export$7d5fecde839eee88(el, e, e, calculate);
            var wheelDelta = $47010835ddffd941$var$getWheelDeltaMayPolyfill(e);
            e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
        } else {
            var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
            touch && $47010835ddffd941$export$7d5fecde839eee88(el, touch, e, calculate);
        }
        var button = e.button;
        if (e.which == null && button !== undefined && $47010835ddffd941$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
        return e;
    }
    function $47010835ddffd941$var$getWheelDeltaMayPolyfill(e) {
        var rawWheelDelta = e.wheelDelta;
        if (rawWheelDelta) return rawWheelDelta;
        var deltaX = e.deltaX;
        var deltaY = e.deltaY;
        if (deltaX == null || deltaY == null) return rawWheelDelta;
        var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
        var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
        return 3 * delta * sign;
    }
    function $47010835ddffd941$export$3f65cefe8380dbea(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.addEventListener(name, handler, opt);
        else el.attachEvent('on' + name, handler);
    }
    function $47010835ddffd941$export$8ff9f68337b520c0(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.removeEventListener(name, handler, opt);
        else el.detachEvent('on' + name, handler);
    }
    var $47010835ddffd941$export$fa6813432f753b0d = $47010835ddffd941$var$isDomLevel2 ? function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.cancelBubble = true;
    } : function(e) {
        e.returnValue = false;
        e.cancelBubble = true;
    };
    function $47010835ddffd941$export$b7ae4cded3e71bd2(e) {
        return e.which === 2 || e.which === 3;
    }
    function $47010835ddffd941$export$a564e1c0090572c3(e) {
        return e.which > 1;
    }
});
parcelRegister("6AZf6", function(module, exports) {
    $parcel$export(module.exports, "transformLocalCoord", ()=>$4cd59c60322a6a09$export$8c5c02e118307e20);
    $parcel$export(module.exports, "transformCoordWithViewport", ()=>$4cd59c60322a6a09$export$1219648acc517df4);
    $parcel$export(module.exports, "isCanvasEl", ()=>$4cd59c60322a6a09$export$1b92e4fe606eff6d);
    var $hZfwb;
    var $8QVDM;
    var $4cd59c60322a6a09$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
    var $4cd59c60322a6a09$var$_calcOut = [];
    function $4cd59c60322a6a09$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
        return $4cd59c60322a6a09$export$1219648acc517df4($4cd59c60322a6a09$var$_calcOut, elFrom, inX, inY, true) && $4cd59c60322a6a09$export$1219648acc517df4(out, elTarget, $4cd59c60322a6a09$var$_calcOut[0], $4cd59c60322a6a09$var$_calcOut[1]);
    }
    function $4cd59c60322a6a09$export$1219648acc517df4(out, el, inX, inY, inverse) {
        if (el.getBoundingClientRect && (0, (0, parcelRequire("hZfwb")).default).domSupported && !$4cd59c60322a6a09$export$1b92e4fe606eff6d(el)) {
            var saved = el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] || (el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] = {});
            var markers = $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved);
            var transformer = $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse);
            if (transformer) {
                transformer(out, inX, inY);
                return true;
            }
        }
        return false;
    }
    function $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved) {
        var markers = saved.markers;
        if (markers) return markers;
        markers = saved.markers = [];
        var propLR = [
            'left',
            'right'
        ];
        var propTB = [
            'top',
            'bottom'
        ];
        for(var i = 0; i < 4; i++){
            var marker = document.createElement('div');
            var stl = marker.style;
            var idxLR = i % 2;
            var idxTB = (i >> 1) % 2;
            stl.cssText = [
                'position: absolute',
                'visibility: hidden',
                'padding: 0',
                'margin: 0',
                'border-width: 0',
                'user-select: none',
                'width:0',
                'height:0',
                propLR[idxLR] + ':0',
                propTB[idxTB] + ':0',
                propLR[1 - idxLR] + ':auto',
                propTB[1 - idxTB] + ':auto',
                ''
            ].join('!important;');
            el.appendChild(marker);
            markers.push(marker);
        }
        return markers;
    }
    function $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse) {
        var transformerName = inverse ? 'invTrans' : 'trans';
        var transformer = saved[transformerName];
        var oldSrcCoords = saved.srcCoords;
        var srcCoords = [];
        var destCoords = [];
        var oldCoordTheSame = true;
        for(var i = 0; i < 4; i++){
            var rect = markers[i].getBoundingClientRect();
            var ii = 2 * i;
            var x = rect.left;
            var y = rect.top;
            srcCoords.push(x, y);
            oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
            destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
        }
        return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, (0, parcelRequire("8QVDM")).buildTransformer)(destCoords, srcCoords) : (0, (0, parcelRequire("8QVDM")).buildTransformer)(srcCoords, destCoords));
    }
    function $4cd59c60322a6a09$export$1b92e4fe606eff6d(el) {
        return el.nodeName.toUpperCase() === 'CANVAS';
    }
});
parcelRegister("8QVDM", function(module, exports) {
    $parcel$export(module.exports, "buildTransformer", ()=>$671fe44ca8a82f31$export$fbdb2748a8171a7e);
    var $671fe44ca8a82f31$var$LN2 = Math.log(2);
    function $671fe44ca8a82f31$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
        var cacheKey = rowMask + '-' + colMask;
        var fullRank = rows.length;
        if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
        if (rank === 1) {
            var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $671fe44ca8a82f31$var$LN2);
            return rows[rowStart][colStart];
        }
        var subRowMask = rowMask | 1 << rowStart;
        var subRowStart = rowStart + 1;
        while(rowMask & 1 << subRowStart)subRowStart++;
        var sum = 0;
        for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
            var colTag = 1 << j;
            if (!(colTag & colMask)) {
                sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $671fe44ca8a82f31$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
                colLocalIdx++;
            }
        }
        detCache[cacheKey] = sum;
        return sum;
    }
    function $671fe44ca8a82f31$export$fbdb2748a8171a7e(src, dest) {
        var mA = [
            [
                src[0],
                src[1],
                1,
                0,
                0,
                0,
                -dest[0] * src[0],
                -dest[0] * src[1]
            ],
            [
                0,
                0,
                0,
                src[0],
                src[1],
                1,
                -dest[1] * src[0],
                -dest[1] * src[1]
            ],
            [
                src[2],
                src[3],
                1,
                0,
                0,
                0,
                -dest[2] * src[2],
                -dest[2] * src[3]
            ],
            [
                0,
                0,
                0,
                src[2],
                src[3],
                1,
                -dest[3] * src[2],
                -dest[3] * src[3]
            ],
            [
                src[4],
                src[5],
                1,
                0,
                0,
                0,
                -dest[4] * src[4],
                -dest[4] * src[5]
            ],
            [
                0,
                0,
                0,
                src[4],
                src[5],
                1,
                -dest[5] * src[4],
                -dest[5] * src[5]
            ],
            [
                src[6],
                src[7],
                1,
                0,
                0,
                0,
                -dest[6] * src[6],
                -dest[6] * src[7]
            ],
            [
                0,
                0,
                0,
                src[6],
                src[7],
                1,
                -dest[7] * src[6],
                -dest[7] * src[7]
            ]
        ];
        var detCache = {};
        var det = $671fe44ca8a82f31$var$determinant(mA, 8, 0, 0, 0, detCache);
        if (det === 0) return;
        var vh = [];
        for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
            vh[j] == null && (vh[j] = 0);
            vh[j] += ((i + j) % 2 ? -1 : 1) * $671fe44ca8a82f31$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
        }
        return function(out, srcPointX, srcPointY) {
            var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
            out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
            out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
        };
    }
});
parcelRegister("ljaBy", function(module, exports) {
    $parcel$export(module.exports, "throttle", ()=>$f833992c62ea3b89$export$de363e709c412c8a);
    $parcel$export(module.exports, "createOrUpdate", ()=>$f833992c62ea3b89$export$958e3e1a02eac4b6);
    $parcel$export(module.exports, "clear", ()=>$f833992c62ea3b89$export$42ffd38884aecdac);
    var $f833992c62ea3b89$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
    var $f833992c62ea3b89$var$RATE = '\0__throttleRate';
    var $f833992c62ea3b89$var$THROTTLE_TYPE = '\0__throttleType';
    function $f833992c62ea3b89$export$de363e709c412c8a(fn, delay, debounce) {
        var currCall;
        var lastCall = 0;
        var lastExec = 0;
        var timer = null;
        var diff;
        var scope;
        var args;
        var debounceNextCall;
        delay = delay || 0;
        function exec() {
            lastExec = new Date().getTime();
            timer = null;
            fn.apply(scope, args || []);
        }
        var cb = function() {
            var cbArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
            currCall = new Date().getTime();
            scope = this;
            args = cbArgs;
            var thisDelay = debounceNextCall || delay;
            var thisDebounce = debounceNextCall || debounce;
            debounceNextCall = null;
            diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
            clearTimeout(timer);
            if (thisDebounce) timer = setTimeout(exec, thisDelay);
            else if (diff >= 0) exec();
            else timer = setTimeout(exec, -diff);
            lastCall = currCall;
        };
        cb.clear = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
        cb.debounceNextCall = function(debounceDelay) {
            debounceNextCall = debounceDelay;
        };
        return cb;
    }
    function $f833992c62ea3b89$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
        var fn = obj[fnAttr];
        if (!fn) return;
        var originFn = fn[$f833992c62ea3b89$var$ORIGIN_METHOD] || fn;
        var lastThrottleType = fn[$f833992c62ea3b89$var$THROTTLE_TYPE];
        var lastRate = fn[$f833992c62ea3b89$var$RATE];
        if (lastRate !== rate || lastThrottleType !== throttleType) {
            if (rate == null || !throttleType) return obj[fnAttr] = originFn;
            fn = obj[fnAttr] = $f833992c62ea3b89$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
            fn[$f833992c62ea3b89$var$ORIGIN_METHOD] = originFn;
            fn[$f833992c62ea3b89$var$THROTTLE_TYPE] = throttleType;
            fn[$f833992c62ea3b89$var$RATE] = rate;
        }
        return fn;
    }
    function $f833992c62ea3b89$export$42ffd38884aecdac(obj, fnAttr) {
        var fn = obj[fnAttr];
        if (fn && fn[$f833992c62ea3b89$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$f833992c62ea3b89$var$ORIGIN_METHOD];
    }
});
parcelRegister("eSE0c", function(module, exports) {
    $parcel$export(module.exports, "buildElStyle", ()=>$ad552373bbd775da$export$b7fe459c7cc50060);
    $parcel$export(module.exports, "buildLabelElOption", ()=>$ad552373bbd775da$export$8206a9937c45910f);
    $parcel$export(module.exports, "getValueLabel", ()=>$ad552373bbd775da$export$7cffee0f9aed39d0);
    $parcel$export(module.exports, "getTransformedPosition", ()=>$ad552373bbd775da$export$4bb66440324c3a3d);
    $parcel$export(module.exports, "buildCartesianSingleLabelElOption", ()=>$ad552373bbd775da$export$fd3eb3812211a173);
    $parcel$export(module.exports, "makeLineShape", ()=>$ad552373bbd775da$export$885fa0ad5a826207);
    $parcel$export(module.exports, "makeRectShape", ()=>$ad552373bbd775da$export$a8b35248bcc02756);
    $parcel$export(module.exports, "makeSectorShape", ()=>$ad552373bbd775da$export$b0cf82e7ebc0d7d0);
    var $bahqM;
    var $fHITF;
    var $b7ZX8;
    var $dCJrM;
    var $izqgC;
    var $3GIoT;
    var $asa08;
    var $gvLUt;
    function $ad552373bbd775da$export$b7fe459c7cc50060(axisPointerModel) {
        var axisPointerType = axisPointerModel.get('type');
        var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
        var style;
        if (axisPointerType === 'line') {
            style = styleModel.getLineStyle();
            style.fill = null;
        } else if (axisPointerType === 'shadow') {
            style = styleModel.getAreaStyle();
            style.stroke = null;
        }
        return style;
    }
    function $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
        var value = axisPointerModel.get('value');
        var text = $ad552373bbd775da$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        });
        var labelModel = axisPointerModel.getModel('label');
        var paddings = (0, parcelRequire("dCJrM")).normalizeCssArray(labelModel.get('padding') || 0);
        var font = labelModel.getFont();
        var textRect = (0, parcelRequire("b7ZX8")).getBoundingRect(text, font);
        var position = labelPos.position;
        var width = textRect.width + paddings[1] + paddings[3];
        var height = textRect.height + paddings[0] + paddings[2];
        var align = labelPos.align;
        align === 'right' && (position[0] -= width);
        align === 'center' && (position[0] -= width / 2);
        var verticalAlign = labelPos.verticalAlign;
        verticalAlign === 'bottom' && (position[1] -= height);
        verticalAlign === 'middle' && (position[1] -= height / 2);
        $ad552373bbd775da$var$confineInContainer(position, width, height, api);
        var bgColor = labelModel.get('backgroundColor');
        if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        elOption.label = {
            x: position[0],
            y: position[1],
            style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(labelModel, {
                text: text,
                font: font,
                fill: labelModel.getTextColor(),
                padding: paddings,
                backgroundColor: bgColor
            }),
            z2: 10
        };
    }
    function $ad552373bbd775da$var$confineInContainer(position, width, height, api) {
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        position[0] = Math.min(position[0] + width, viewWidth) - width;
        position[1] = Math.min(position[1] + height, viewHeight) - height;
        position[0] = Math.max(position[0], 0);
        position[1] = Math.max(position[1], 0);
    }
    function $ad552373bbd775da$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
        value = axis.scale.parse(value);
        var text = axis.scale.getLabel({
            value: value
        }, {
            precision: opt.precision
        });
        var formatter = opt.formatter;
        if (formatter) {
            var params_1 = {
                value: (0, parcelRequire("3GIoT")).getAxisRawValue(axis, {
                    value: value
                }),
                axisDimension: axis.dim,
                axisIndex: axis.index,
                seriesData: []
            };
            (0, parcelRequire("bahqM")).each(seriesDataIndices, function(idxItem) {
                var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                var dataIndex = idxItem.dataIndexInside;
                var dataParams = series && series.getDataParams(dataIndex);
                dataParams && params_1.seriesData.push(dataParams);
            });
            if ((0, parcelRequire("bahqM")).isString(formatter)) text = formatter.replace('{value}', text);
            else if ((0, parcelRequire("bahqM")).isFunction(formatter)) text = formatter(params_1);
        }
        return text;
    }
    function $ad552373bbd775da$export$4bb66440324c3a3d(axis, value, layoutInfo) {
        var transform = (0, parcelRequire("izqgC")).create();
        (0, parcelRequire("izqgC")).rotate(transform, transform, layoutInfo.rotation);
        (0, parcelRequire("izqgC")).translate(transform, transform, layoutInfo.position);
        return (0, parcelRequire("fHITF")).applyTransform([
            axis.dataToCoord(value),
            (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
        ], transform);
    }
    function $ad552373bbd775da$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
        var textLayout = (0, (0, parcelRequire("asa08")).default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
        layoutInfo.labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
            position: $ad552373bbd775da$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
            align: textLayout.textAlign,
            verticalAlign: textLayout.textVerticalAlign
        });
    }
    function $ad552373bbd775da$export$885fa0ad5a826207(p1, p2, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x1: p1[xDimIndex],
            y1: p1[1 - xDimIndex],
            x2: p2[xDimIndex],
            y2: p2[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$a8b35248bcc02756(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
        return {
            cx: cx,
            cy: cy,
            r0: r0,
            r: r,
            startAngle: startAngle,
            endAngle: endAngle,
            clockwise: true
        };
    }
});
parcelRegister("5UrR7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44d7ca4f96167e1d$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $44d7ca4f96167e1d$var$AxisPointerModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerModel, _super);
        function AxisPointerModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerModel.type;
            return _this;
        }
        AxisPointerModel.type = 'axisPointer';
        AxisPointerModel.defaultOption = {
            show: 'auto',
            zlevel: 0,
            z: 50,
            type: 'line',
            snap: false,
            triggerTooltip: true,
            value: null,
            status: null,
            link: [],
            animation: null,
            animationDurationUpdate: 200,
            lineStyle: {
                color: '#B9BEC9',
                width: 1,
                type: 'dashed'
            },
            shadowStyle: {
                color: 'rgba(210,219,238,0.2)'
            },
            label: {
                show: true,
                formatter: null,
                precision: 'auto',
                margin: 3,
                color: '#fff',
                padding: [
                    5,
                    7,
                    5,
                    7
                ],
                backgroundColor: 'auto',
                borderColor: null,
                borderWidth: 0,
                borderRadius: 3
            },
            handle: {
                show: false,
                icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
                size: 45,
                margin: 50,
                color: '#333',
                shadowBlur: 3,
                shadowColor: '#aaa',
                shadowOffsetX: 0,
                shadowOffsetY: 2,
                throttle: 40
            }
        };
        return AxisPointerModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $44d7ca4f96167e1d$export$2e2bcd8739ae039 = $44d7ca4f96167e1d$var$AxisPointerModel;
});
parcelRegister("gPvBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c409edfe4aa8d133$export$2e2bcd8739ae039);
    var $3VFsf;
    var $iNebh;
    var $fkskt;
    var $c409edfe4aa8d133$var$AxisPointerView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerView, _super);
        function AxisPointerView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerView.type;
            return _this;
        }
        AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
            var globalTooltipModel = ecModel.getComponent('tooltip');
            var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
            (0, parcelRequire("iNebh")).register('axisPointer', api, function(currTrigger, e, dispatchAction) {
                if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                    type: 'updateAxisPointer',
                    currTrigger: currTrigger,
                    x: e && e.offsetX,
                    y: e && e.offsetY
                });
            });
        };
        AxisPointerView.prototype.remove = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.prototype.dispose = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.type = 'axisPointer';
        return AxisPointerView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $c409edfe4aa8d133$export$2e2bcd8739ae039 = $c409edfe4aa8d133$var$AxisPointerView;
});
parcelRegister("iNebh", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$dae7cd9e0e79e4d2$export$6503ec6e8aabbaf);
    $parcel$export(module.exports, "unregister", ()=>$dae7cd9e0e79e4d2$export$d07f55d4c15c0440);
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $dae7cd9e0e79e4d2$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $dae7cd9e0e79e4d2$var$each = (0, parcelRequire("bahqM")).each;
    function $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf(key, api, handler) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        $dae7cd9e0e79e4d2$var$inner(zr).records || ($dae7cd9e0e79e4d2$var$inner(zr).records = {});
        $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api);
        var record = $dae7cd9e0e79e4d2$var$inner(zr).records[key] || ($dae7cd9e0e79e4d2$var$inner(zr).records[key] = {});
        record.handler = handler;
    }
    function $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api) {
        if ($dae7cd9e0e79e4d2$var$inner(zr).initialized) return;
        $dae7cd9e0e79e4d2$var$inner(zr).initialized = true;
        useHandler('click', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'click'));
        useHandler('mousemove', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'mousemove'));
        useHandler('globalout', $dae7cd9e0e79e4d2$var$onLeave);
        function useHandler(eventType, cb) {
            zr.on(eventType, function(e) {
                var dis = $dae7cd9e0e79e4d2$var$makeDispatchAction(api);
                $dae7cd9e0e79e4d2$var$each($dae7cd9e0e79e4d2$var$inner(zr).records, function(record) {
                    record && cb(record, e, dis.dispatchAction);
                });
                $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(dis.pendings, api);
            });
        }
    }
    function $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(pendings, api) {
        var showLen = pendings.showTip.length;
        var hideLen = pendings.hideTip.length;
        var actuallyPayload;
        if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
        else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
        if (actuallyPayload) {
            actuallyPayload.dispatchAction = null;
            api.dispatchAction(actuallyPayload);
        }
    }
    function $dae7cd9e0e79e4d2$var$onLeave(record, e, dispatchAction) {
        record.handler('leave', null, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$doEnter(currTrigger, record, e, dispatchAction) {
        record.handler(currTrigger, e, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$makeDispatchAction(api) {
        var pendings = {
            showTip: [],
            hideTip: []
        };
        var dispatchAction = function(payload) {
            var pendingList = pendings[payload.type];
            if (pendingList) pendingList.push(payload);
            else {
                payload.dispatchAction = dispatchAction;
                api.dispatchAction(payload);
            }
        };
        return {
            dispatchAction: dispatchAction,
            pendings: pendings
        };
    }
    function $dae7cd9e0e79e4d2$export$d07f55d4c15c0440(key, api) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        var record = ($dae7cd9e0e79e4d2$var$inner(zr).records || {})[key];
        if (record) $dae7cd9e0e79e4d2$var$inner(zr).records[key] = null;
    }
});
parcelRegister("5TxwA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ac1811f8c8020d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $8QSpd;
    var $4LkI5;
    var $bahqM;
    var $44ac1811f8c8020d$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $44ac1811f8c8020d$export$2e2bcd8739ae039(payload, ecModel, api) {
        var currTrigger = payload.currTrigger;
        var point = [
            payload.x,
            payload.y
        ];
        var finder = payload;
        var dispatchAction = payload.dispatchAction || (0, (0, parcelRequire("bahqM")).bind)(api.dispatchAction, api);
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (!coordSysAxesInfo) return;
        if ($44ac1811f8c8020d$var$illegalPoint(point)) point = (0, (0, parcelRequire("4LkI5")).default)({
            seriesIndex: finder.seriesIndex,
            dataIndex: finder.dataIndex
        }, ecModel).point;
        var isIllegalPoint = $44ac1811f8c8020d$var$illegalPoint(point);
        var inputAxesInfo = finder.axesInfo;
        var axesInfo = coordSysAxesInfo.axesInfo;
        var shouldHide = currTrigger === 'leave' || $44ac1811f8c8020d$var$illegalPoint(point);
        var outputPayload = {};
        var showValueMap = {};
        var dataByCoordSys = {
            list: [],
            map: {}
        };
        var updaters = {
            showPointer: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showPointer, showValueMap),
            showTooltip: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showTooltip, dataByCoordSys)
        };
        (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
            var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
            (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
                var axis = axisInfo.axis;
                var inputAxisInfo = $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo);
                if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                    var val = inputAxisInfo && inputAxisInfo.value;
                    if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                    val != null && $44ac1811f8c8020d$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
                }
            });
        });
        var linkTriggers = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(tarAxisInfo, tarKey) {
            var linkGroup = tarAxisInfo.linkGroup;
            if (linkGroup && !showValueMap[tarKey]) (0, (0, parcelRequire("bahqM")).each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
                var srcValItem = showValueMap[srcKey];
                if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                    var val = srcValItem.value;
                    linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $44ac1811f8c8020d$var$makeMapperParam(srcAxisInfo), $44ac1811f8c8020d$var$makeMapperParam(tarAxisInfo))));
                    linkTriggers[tarAxisInfo.key] = val;
                }
            });
        });
        (0, (0, parcelRequire("bahqM")).each)(linkTriggers, function(val, tarKey) {
            $44ac1811f8c8020d$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
        });
        $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload);
        $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
        $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
        return outputPayload;
    }
    function $44ac1811f8c8020d$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
        var axis = axisInfo.axis;
        if (axis.scale.isBlank() || !axis.containData(newValue)) return;
        if (!axisInfo.involveSeries) {
            updaters.showPointer(axisInfo, newValue);
            return;
        }
        var payloadInfo = $44ac1811f8c8020d$var$buildPayloadsBySeries(newValue, axisInfo);
        var payloadBatch = payloadInfo.payloadBatch;
        var snapToValue = payloadInfo.snapToValue;
        if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, (0, parcelRequire("bahqM")).extend)(outputFinder, payloadBatch[0]);
        if (!noSnap && axisInfo.snap) {
            if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
        }
        updaters.showPointer(axisInfo, newValue, payloadBatch);
        updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
    }
    function $44ac1811f8c8020d$var$buildPayloadsBySeries(value, axisInfo) {
        var axis = axisInfo.axis;
        var dim = axis.dim;
        var snapToValue = value;
        var payloadBatch = [];
        var minDist = Number.MAX_VALUE;
        var minDiff = -1;
        (0, (0, parcelRequire("bahqM")).each)(axisInfo.seriesModels, function(series, idx) {
            var dataDim = series.getData().mapDimensionsAll(dim);
            var seriesNestestValue;
            var dataIndices;
            if (series.getAxisTooltipData) {
                var result = series.getAxisTooltipData(dataDim, value, axis);
                dataIndices = result.dataIndices;
                seriesNestestValue = result.nestestValue;
            } else {
                dataIndices = series.getData().indicesOfNearest(dataDim[0], value, axis.type === 'category' ? 0.5 : null);
                if (!dataIndices.length) return;
                seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
            }
            if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
            var diff = value - seriesNestestValue;
            var dist = Math.abs(diff);
            if (dist <= minDist) {
                if (dist < minDist || diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    snapToValue = seriesNestestValue;
                    payloadBatch.length = 0;
                }
                (0, (0, parcelRequire("bahqM")).each)(dataIndices, function(dataIndex) {
                    payloadBatch.push({
                        seriesIndex: series.seriesIndex,
                        dataIndexInside: dataIndex,
                        dataIndex: series.getData().getRawIndex(dataIndex)
                    });
                });
            }
        });
        return {
            payloadBatch: payloadBatch,
            snapToValue: snapToValue
        };
    }
    function $44ac1811f8c8020d$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
        showValueMap[axisInfo.key] = {
            value: value,
            payloadBatch: payloadBatch
        };
    }
    function $44ac1811f8c8020d$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
        var payloadBatch = payloadInfo.payloadBatch;
        var axis = axisInfo.axis;
        var axisModel = axis.model;
        var axisPointerModel = axisInfo.axisPointerModel;
        if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
        var coordSysModel = axisInfo.coordSys.model;
        var coordSysKey = (0, parcelRequire("8QSpd")).makeKey(coordSysModel);
        var coordSysItem = dataByCoordSys.map[coordSysKey];
        if (!coordSysItem) {
            coordSysItem = dataByCoordSys.map[coordSysKey] = {
                coordSysId: coordSysModel.id,
                coordSysIndex: coordSysModel.componentIndex,
                coordSysType: coordSysModel.type,
                coordSysMainType: coordSysModel.mainType,
                dataByAxis: []
            };
            dataByCoordSys.list.push(coordSysItem);
        }
        coordSysItem.dataByAxis.push({
            axisDim: axis.dim,
            axisIndex: axisModel.componentIndex,
            axisType: axisModel.type,
            axisId: axisModel.id,
            value: value,
            valueLabelOpt: {
                precision: axisPointerModel.get([
                    'label',
                    'precision'
                ]),
                formatter: axisPointerModel.get([
                    'label',
                    'formatter'
                ])
            },
            seriesDataIndices: payloadBatch.slice()
        });
    }
    function $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
        var outputAxesInfo = outputPayload.axesInfo = [];
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            var valItem = showValueMap[key];
            if (valItem) {
                !axisInfo.useHandle && (option.status = 'show');
                option.value = valItem.value;
                option.seriesDataIndices = (valItem.payloadBatch || []).slice();
            } else !axisInfo.useHandle && (option.status = 'hide');
            option.status === 'show' && outputAxesInfo.push({
                axisDim: axisInfo.axis.dim,
                axisIndex: axisInfo.axis.model.componentIndex,
                value: option.value
            });
        });
    }
    function $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
        if ($44ac1811f8c8020d$var$illegalPoint(point) || !dataByCoordSys.list.length) {
            dispatchAction({
                type: 'hideTip'
            });
            return;
        }
        var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
        dispatchAction({
            type: 'showTip',
            escapeConnect: true,
            x: point[0],
            y: point[1],
            tooltipOption: payload.tooltipOption,
            position: payload.position,
            dataIndexInside: sampleItem.dataIndexInside,
            dataIndex: sampleItem.dataIndex,
            seriesIndex: sampleItem.seriesIndex,
            dataByCoordSys: dataByCoordSys.list
        });
    }
    function $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
        var zr = api.getZr();
        var highDownKey = 'axisPointerLastHighlights';
        var lastHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] || {};
        var newHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            option.status === 'show' && (0, (0, parcelRequire("bahqM")).each)(option.seriesDataIndices, function(batchItem) {
                var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
                newHighlights[key] = batchItem;
            });
        });
        var toHighlight = [];
        var toDownplay = [];
        (0, (0, parcelRequire("bahqM")).each)(lastHighlights, function(batchItem, key) {
            !newHighlights[key] && toDownplay.push(batchItem);
        });
        (0, (0, parcelRequire("bahqM")).each)(newHighlights, function(batchItem, key) {
            !lastHighlights[key] && toHighlight.push(batchItem);
        });
        toDownplay.length && api.dispatchAction({
            type: 'downplay',
            escapeConnect: true,
            notBlur: true,
            batch: toDownplay
        });
        toHighlight.length && api.dispatchAction({
            type: 'highlight',
            escapeConnect: true,
            notBlur: true,
            batch: toHighlight
        });
    }
    function $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
        for(var i = 0; i < (inputAxesInfo || []).length; i++){
            var inputAxisInfo = inputAxesInfo[i];
            if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
        }
    }
    function $44ac1811f8c8020d$var$makeMapperParam(axisInfo) {
        var axisModel = axisInfo.axis.model;
        var item = {};
        var dim = item.axisDim = axisInfo.axis.dim;
        item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
        item.axisName = item[dim + 'AxisName'] = axisModel.name;
        item.axisId = item[dim + 'AxisId'] = axisModel.id;
        return item;
    }
    function $44ac1811f8c8020d$var$illegalPoint(point) {
        return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
    }
});
parcelRegister("4LkI5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$377b9dcb49ed57dc$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    function $377b9dcb49ed57dc$export$2e2bcd8739ae039(finder, ecModel) {
        var point = [];
        var seriesIndex = finder.seriesIndex;
        var seriesModel;
        if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
            point: []
        };
        var data = seriesModel.getData();
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, finder);
        if (dataIndex == null || dataIndex < 0 || (0, parcelRequire("bahqM")).isArray(dataIndex)) return {
            point: []
        };
        var el = data.getItemGraphicEl(dataIndex);
        var coordSys = seriesModel.coordinateSystem;
        if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
        else if (coordSys && coordSys.dataToPoint) {
            if (finder.isStacked) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var valueAxisDim = valueAxis.dim;
                var baseAxisDim = baseAxis.dim;
                var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
                var baseDim = data.mapDimension(baseAxisDim);
                var stackedData = [];
                stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
                stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
                point = coordSys.dataToPoint(stackedData) || [];
            } else point = coordSys.dataToPoint(data.getValues((0, parcelRequire("bahqM")).map(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }), dataIndex)) || [];
        } else if (el) {
            var rect = el.getBoundingRect().clone();
            rect.applyTransform(el.transform);
            point = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        }
        return {
            point: point,
            el: el
        };
    }
});
parcelRegister("alpND", function(module, exports) {
    $parcel$export(module.exports, "use", ()=>$787fe0d1b8504a01$export$1f96ae73734a86cc);
    var $8pqpA;
    var $fkskt;
    var $loerw;
    var $h4UlH;
    var $1O7Ua;
    var $bahqM;
    var $9Y5KT;
    var $787fe0d1b8504a01$var$extensions = [];
    var $787fe0d1b8504a01$var$extensionRegisters = {
        registerPreprocessor: (0, (0, parcelRequire("8pqpA")).registerPreprocessor),
        registerProcessor: (0, (0, parcelRequire("8pqpA")).registerProcessor),
        registerPostInit: (0, (0, parcelRequire("8pqpA")).registerPostInit),
        registerPostUpdate: (0, (0, parcelRequire("8pqpA")).registerPostUpdate),
        registerUpdateLifecycle: (0, (0, parcelRequire("8pqpA")).registerUpdateLifecycle),
        registerAction: (0, (0, parcelRequire("8pqpA")).registerAction),
        registerCoordinateSystem: (0, (0, parcelRequire("8pqpA")).registerCoordinateSystem),
        registerLayout: (0, (0, parcelRequire("8pqpA")).registerLayout),
        registerVisual: (0, (0, parcelRequire("8pqpA")).registerVisual),
        registerTransform: (0, (0, parcelRequire("8pqpA")).registerTransform),
        registerLoading: (0, (0, parcelRequire("8pqpA")).registerLoading),
        registerMap: (0, (0, parcelRequire("8pqpA")).registerMap),
        PRIORITY: (0, (0, parcelRequire("8pqpA")).PRIORITY),
        ComponentModel: (0, (0, parcelRequire("h4UlH")).default),
        ComponentView: (0, (0, parcelRequire("fkskt")).default),
        SeriesModel: (0, (0, parcelRequire("1O7Ua")).default),
        ChartView: (0, (0, parcelRequire("loerw")).default),
        registerComponentModel: function(ComponentModelClass) {
            (0, (0, parcelRequire("h4UlH")).default).registerClass(ComponentModelClass);
        },
        registerComponentView: function(ComponentViewClass) {
            (0, (0, parcelRequire("fkskt")).default).registerClass(ComponentViewClass);
        },
        registerSeriesModel: function(SeriesModelClass) {
            (0, (0, parcelRequire("1O7Ua")).default).registerClass(SeriesModelClass);
        },
        registerChartView: function(ChartViewClass) {
            (0, (0, parcelRequire("loerw")).default).registerClass(ChartViewClass);
        },
        registerSubTypeDefaulter: function(componentType, defaulter) {
            (0, (0, parcelRequire("h4UlH")).default).registerSubTypeDefaulter(componentType, defaulter);
        },
        registerPainter: function(painterType, PainterCtor) {
            (0, (0, parcelRequire("9Y5KT")).registerPainter)(painterType, PainterCtor);
        }
    };
    function $787fe0d1b8504a01$export$1f96ae73734a86cc(ext) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(ext)) {
            (0, (0, parcelRequire("bahqM")).each)(ext, function(singleExt) {
                $787fe0d1b8504a01$export$1f96ae73734a86cc(singleExt);
            });
            return;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($787fe0d1b8504a01$var$extensions, ext) >= 0) return;
        $787fe0d1b8504a01$var$extensions.push(ext);
        if ((0, (0, parcelRequire("bahqM")).isFunction)(ext)) ext = {
            install: ext
        };
        ext.install($787fe0d1b8504a01$var$extensionRegisters);
    }
});
parcelRegister("8pqpA", function(module, exports) {
    $parcel$export(module.exports, "version", ()=>$61f525521022d020$export$83d89fbfd8236492);
    $parcel$export(module.exports, "dependencies", ()=>$61f525521022d020$export$b74ff737e0e298b5);
    $parcel$export(module.exports, "PRIORITY", ()=>$61f525521022d020$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "init", ()=>$61f525521022d020$export$2cd8252107eb640b);
    $parcel$export(module.exports, "getInstanceByDom", ()=>$61f525521022d020$export$33b6fbccd4f643f8);
    $parcel$export(module.exports, "connect", ()=>$61f525521022d020$export$64605811ab45167f);
    $parcel$export(module.exports, "disConnect", ()=>$61f525521022d020$export$87cd6834112ecb52);
    $parcel$export(module.exports, "disconnect", ()=>$61f525521022d020$export$37dfea93db2e14ed);
    $parcel$export(module.exports, "dispose", ()=>$61f525521022d020$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "getInstanceById", ()=>$61f525521022d020$export$89b4be35062c4a3f);
    $parcel$export(module.exports, "registerTheme", ()=>$61f525521022d020$export$f9c59eed5de5ff80);
    $parcel$export(module.exports, "registerPreprocessor", ()=>$61f525521022d020$export$77095792a057b768);
    $parcel$export(module.exports, "registerProcessor", ()=>$61f525521022d020$export$d575e6557ac1729f);
    $parcel$export(module.exports, "registerPostInit", ()=>$61f525521022d020$export$c8c249911ee8c1ed);
    $parcel$export(module.exports, "registerUpdateLifecycle", ()=>$61f525521022d020$export$c9ec4b5faef04865);
    $parcel$export(module.exports, "registerPostUpdate", ()=>$61f525521022d020$export$99560909c18c76bb);
    $parcel$export(module.exports, "registerAction", ()=>$61f525521022d020$export$408c24786cd729c6);
    $parcel$export(module.exports, "registerCoordinateSystem", ()=>$61f525521022d020$export$1dd5e025a8a37dd);
    $parcel$export(module.exports, "getCoordinateSystemDimensions", ()=>$61f525521022d020$export$fc2638719e4159b9);
    $parcel$export(module.exports, "registerLayout", ()=>$61f525521022d020$export$d768f97700ca6bea);
    $parcel$export(module.exports, "registerVisual", ()=>$61f525521022d020$export$5f32c1eb94c381bb);
    $parcel$export(module.exports, "registerLoading", ()=>$61f525521022d020$export$e06b68a82007c015);
    $parcel$export(module.exports, "setCanvasCreator", ()=>$61f525521022d020$export$10425ea7a243b114);
    $parcel$export(module.exports, "registerMap", ()=>$61f525521022d020$export$d456de060be2dba1);
    $parcel$export(module.exports, "getMap", ()=>$61f525521022d020$export$b8586192aead8a7e);
    $parcel$export(module.exports, "registerTransform", ()=>$61f525521022d020$export$f01d71dd0389d7e4);
    $parcel$export(module.exports, "dataTool", ()=>$61f525521022d020$export$73cae5e090579589);
    $parcel$export(module.exports, "registerLocale", ()=>(parcelRequire("3OMoQ")).registerLocale);
    var $3VFsf;
    var $9Y5KT;
    var $bahqM;
    var $d6udH;
    var $hZfwb;
    var $aVBu2;
    var $bRKv5;
    var $74g78;
    var $iEvqc;
    var $gyhNQ;
    var $6LzFt;
    var $driCQ;
    var $iMppY;
    var $1O7Ua;
    var $fkskt;
    var $loerw;
    parcelRequire("fHITF");
    var $gcbBH;
    var $ghQ8v;
    var $7Tw7u;
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $eaKsF;
    var $ljaBy;
    var $cvEVp;
    var $4G956;
    var $14WFd;
    var $31FQc;
    var $dMJCs;
    var $aLwh0;
    var $cbv5T;
    var $7wiHx;
    var $fk5Gm;
    var $2cFRc;
    var $1nKsD;
    var $05ab4;
    var $3OMoQ;
    var $6IsbX;
    var $g2DhS;
    var $fEzwg;
    var $8cCW2;
    var $61f525521022d020$var$hasWindow = typeof window !== 'undefined';
    var $61f525521022d020$export$83d89fbfd8236492 = '5.2.1';
    var $61f525521022d020$export$b74ff737e0e298b5 = {
        zrender: '5.2.1'
    };
    var $61f525521022d020$var$TEST_FRAME_REMAIN_TIME = 1;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK = 900;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER = 1000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT = 1000;
    var $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
    var $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL = 2000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART = 3000;
    var $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT = 4000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
    var $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
    var $61f525521022d020$var$PRIORITY_VISUAL_BRUSH = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_ARIA = 6000;
    var $61f525521022d020$var$PRIORITY_VISUAL_DECAL = 7000;
    var $61f525521022d020$export$bb34f3538ba26c7e = {
        PROCESSOR: {
            FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER,
            SERIES_FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER,
            STATISTIC: $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC
        },
        VISUAL: {
            LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT,
            PROGRESSIVE_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
            GLOBAL: $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL,
            CHART: $61f525521022d020$var$PRIORITY_VISUAL_CHART,
            POST_CHART_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
            COMPONENT: $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT,
            BRUSH: $61f525521022d020$var$PRIORITY_VISUAL_BRUSH,
            CHART_ITEM: $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
            ARIA: $61f525521022d020$var$PRIORITY_VISUAL_ARIA,
            DECAL: $61f525521022d020$var$PRIORITY_VISUAL_DECAL
        }
    };
    var $61f525521022d020$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
    var $61f525521022d020$var$PENDING_UPDATE = '__pendingUpdate';
    var $61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
    var $61f525521022d020$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
    var $61f525521022d020$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
    var $61f525521022d020$var$CONNECT_STATUS_PENDING = 0;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATING = 1;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATED = 2;
    function $61f525521022d020$var$createRegisterEventWithLowercaseECharts(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.isDisposed()) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$toLowercaseNameAndCallEventful(host, method, args) {
        args[0] = args[0] && args[0].toLowerCase();
        return (0, (0, parcelRequire("bRKv5")).default).prototype[method].apply(host, args);
    }
    var $61f525521022d020$var$MessageCenter = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MessageCenter, _super);
        function MessageCenter() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return MessageCenter;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$messageCenterProto = $61f525521022d020$var$MessageCenter.prototype;
    $61f525521022d020$var$messageCenterProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('on');
    $61f525521022d020$var$messageCenterProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('off');
    var $61f525521022d020$var$prepare;
    var $61f525521022d020$var$prepareView;
    var $61f525521022d020$var$updateDirectly;
    var $61f525521022d020$var$updateMethods;
    var $61f525521022d020$var$doConvertPixel;
    var $61f525521022d020$var$updateStreamModes;
    var $61f525521022d020$var$doDispatchAction;
    var $61f525521022d020$var$flushPendingActions;
    var $61f525521022d020$var$triggerUpdatedEvent;
    var $61f525521022d020$var$bindRenderedEvent;
    var $61f525521022d020$var$bindMouseEvent;
    var $61f525521022d020$var$clearColorPalette;
    var $61f525521022d020$var$render;
    var $61f525521022d020$var$renderComponents;
    var $61f525521022d020$var$renderSeries;
    var $61f525521022d020$var$createExtensionAPI;
    var $61f525521022d020$var$enableConnect;
    var $61f525521022d020$var$markStatusToUpdate;
    var $61f525521022d020$var$applyChangedStates;
    var $61f525521022d020$var$ECharts = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECharts, _super);
        function ECharts(dom, theme, opts) {
            var _this = _super.call(this, new (0, (0, parcelRequire("cbv5T")).ECEventProcessor)()) || this;
            _this._chartsViews = [];
            _this._chartsMap = {};
            _this._componentsViews = [];
            _this._componentsMap = {};
            _this._pendingActions = [];
            opts = opts || {};
            if (typeof theme === 'string') theme = $61f525521022d020$var$themeStorage[theme];
            _this._dom = dom;
            var defaultRenderer = 'canvas';
            var defaultUseDirtyRect = false;
            var root, devUseDirtyRect;
            var zr = _this._zr = (0, parcelRequire("9Y5KT")).init(dom, {
                renderer: opts.renderer || defaultRenderer,
                devicePixelRatio: opts.devicePixelRatio,
                width: opts.width,
                height: opts.height,
                useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
            });
            _this._throttledZrFlush = (0, (0, parcelRequire("ljaBy")).throttle)((0, (0, parcelRequire("bahqM")).bind)(zr.flush, zr), 17);
            theme = (0, (0, parcelRequire("bahqM")).clone)(theme);
            theme && (0, (0, parcelRequire("driCQ")).default)(theme, true);
            _this._theme = theme;
            _this._locale = (0, (0, parcelRequire("3OMoQ")).createLocaleObject)(opts.locale || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG));
            _this._coordSysMgr = new (0, (0, parcelRequire("gyhNQ")).default)();
            var api = _this._api = $61f525521022d020$var$createExtensionAPI(_this);
            function prioritySortFunc(a, b) {
                return a.__prio - b.__prio;
            }
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$visualFuncs, prioritySortFunc);
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$dataProcessorFuncs, prioritySortFunc);
            _this._scheduler = new (0, (0, parcelRequire("14WFd")).default)(_this, api, $61f525521022d020$var$dataProcessorFuncs, $61f525521022d020$var$visualFuncs);
            _this._messageCenter = new $61f525521022d020$var$MessageCenter();
            _this._initEvents();
            _this.resize = (0, (0, parcelRequire("bahqM")).bind)(_this.resize, _this);
            zr.animation.on('frame', _this._onframe, _this);
            $61f525521022d020$var$bindRenderedEvent(zr, _this);
            $61f525521022d020$var$bindMouseEvent(zr, _this);
            (0, (0, parcelRequire("bahqM")).setAsPrimitive)(_this);
            return _this;
        }
        ECharts.prototype._onframe = function() {
            if (this._disposed) return;
            $61f525521022d020$var$applyChangedStates(this);
            var scheduler = this._scheduler;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                var silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, this[$61f525521022d020$var$PENDING_UPDATE].updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            } else if (scheduler.unfinished) {
                var remainTime = $61f525521022d020$var$TEST_FRAME_REMAIN_TIME;
                var ecModel = this._model;
                var api = this._api;
                scheduler.unfinished = false;
                do {
                    var startTime = +new Date();
                    scheduler.performSeriesTasks(ecModel);
                    scheduler.performDataProcessorTasks(ecModel);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    scheduler.performVisualTasks(ecModel);
                    $61f525521022d020$var$renderSeries(this, this._model, api, 'remain', {});
                    remainTime -= +new Date() - startTime;
                }while (remainTime > 0 && scheduler.unfinished)
                if (!scheduler.unfinished) this._zr.flush();
            }
        };
        ECharts.prototype.getDom = function() {
            return this._dom;
        };
        ECharts.prototype.getId = function() {
            return this.id;
        };
        ECharts.prototype.getZr = function() {
            return this._zr;
        };
        ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var silent;
            var replaceMerge;
            var transitionOpt;
            if ((0, (0, parcelRequire("bahqM")).isObject)(notMerge)) {
                lazyUpdate = notMerge.lazyUpdate;
                silent = notMerge.silent;
                replaceMerge = notMerge.replaceMerge;
                transitionOpt = notMerge.transition;
                notMerge = notMerge.notMerge;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            if (!this._model || notMerge) {
                var optionManager = new (0, (0, parcelRequire("6LzFt")).default)(this._api);
                var theme = this._theme;
                var ecModel = this._model = new (0, (0, parcelRequire("74g78")).default)();
                ecModel.scheduler = this._scheduler;
                ecModel.init(null, null, null, theme, this._locale, optionManager);
            }
            this._model.setOption(option, {
                replaceMerge: replaceMerge
            }, $61f525521022d020$var$optionPreprocessorFuncs);
            var updateParams = {
                seriesTransition: transitionOpt,
                optionChanged: true
            };
            if (lazyUpdate) {
                this[$61f525521022d020$var$PENDING_UPDATE] = {
                    silent: silent,
                    updateParams: updateParams
                };
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this.getZr().wakeUp();
            } else {
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            }
        };
        ECharts.prototype.setTheme = function() {
            console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
        };
        ECharts.prototype.getModel = function() {
            return this._model;
        };
        ECharts.prototype.getOption = function() {
            return this._model && this._model.getOption();
        };
        ECharts.prototype.getWidth = function() {
            return this._zr.getWidth();
        };
        ECharts.prototype.getHeight = function() {
            return this._zr.getHeight();
        };
        ECharts.prototype.getDevicePixelRatio = function() {
            return this._zr.painter.dpr || $61f525521022d020$var$hasWindow && window.devicePixelRatio || 1;
        };
        ECharts.prototype.getRenderedCanvas = function(opts) {
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            opts = opts || {};
            return this._zr.painter.getRenderedCanvas({
                backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
                pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
            });
        };
        ECharts.prototype.getSvgDataURL = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).svgSupported) return;
            var zr = this._zr;
            var list = zr.storage.getDisplayList();
            (0, (0, parcelRequire("bahqM")).each)(list, function(el) {
                el.stopAnimation(null, true);
            });
            return zr.painter.toDataURL();
        };
        ECharts.prototype.getDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            opts = opts || {};
            var excludeComponents = opts.excludeComponents;
            var ecModel = this._model;
            var excludesComponentViews = [];
            var self = this;
            (0, (0, parcelRequire("bahqM")).each)(excludeComponents, function(componentType) {
                ecModel.eachComponent({
                    mainType: componentType
                }, function(component) {
                    var view = self._componentsMap[component.__viewId];
                    if (!view.group.ignore) {
                        excludesComponentViews.push(view);
                        view.group.ignore = true;
                    }
                });
            });
            var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
            (0, (0, parcelRequire("bahqM")).each)(excludesComponentViews, function(view) {
                view.group.ignore = false;
            });
            return url;
        };
        ECharts.prototype.getConnectedDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            var isSvg = opts.type === 'svg';
            var groupId = this.group;
            var mathMin = Math.min;
            var mathMax = Math.max;
            var MAX_NUMBER = Infinity;
            if ($61f525521022d020$var$connectedGroups[groupId]) {
                var left_1 = MAX_NUMBER;
                var top_1 = MAX_NUMBER;
                var right_1 = -MAX_NUMBER;
                var bottom_1 = -MAX_NUMBER;
                var canvasList_1 = [];
                var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(chart, id) {
                    if (chart.group === groupId) {
                        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, (0, parcelRequire("bahqM")).clone)(opts));
                        var boundingRect = chart.getDom().getBoundingClientRect();
                        left_1 = mathMin(boundingRect.left, left_1);
                        top_1 = mathMin(boundingRect.top, top_1);
                        right_1 = mathMax(boundingRect.right, right_1);
                        bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                        canvasList_1.push({
                            dom: canvas,
                            left: boundingRect.left,
                            top: boundingRect.top
                        });
                    }
                });
                left_1 *= dpr_1;
                top_1 *= dpr_1;
                right_1 *= dpr_1;
                bottom_1 *= dpr_1;
                var width = right_1 - left_1;
                var height = bottom_1 - top_1;
                var targetCanvas = (0, (0, parcelRequire("bahqM")).createCanvas)();
                var zr_1 = (0, parcelRequire("9Y5KT")).init(targetCanvas, {
                    renderer: isSvg ? 'svg' : 'canvas'
                });
                zr_1.resize({
                    width: width,
                    height: height
                });
                if (isSvg) {
                    var content_1 = '';
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var x = item.left - left_1;
                        var y = item.top - top_1;
                        content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                    });
                    zr_1.painter.getSvgRoot().innerHTML = content_1;
                    if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                    zr_1.refreshImmediately();
                    return zr_1.painter.toDataURL();
                } else {
                    if (opts.connectedBackgroundColor) zr_1.add(new (0, parcelRequire("7Tw7u")).default({
                        shape: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        style: {
                            fill: opts.connectedBackgroundColor
                        }
                    }));
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var img = new (0, parcelRequire("gcbBH")).default({
                            style: {
                                x: item.left * dpr_1 - left_1,
                                y: item.top * dpr_1 - top_1,
                                image: item.dom
                            }
                        });
                        zr_1.add(img);
                    });
                    zr_1.refreshImmediately();
                    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
                }
            } else return this.getDataURL(opts);
        };
        ECharts.prototype.convertToPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertToPixel', finder, value);
        };
        ECharts.prototype.convertFromPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertFromPixel', finder, value);
        };
        ECharts.prototype.containPixel = function(finder, value) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var ecModel = this._model;
            var result;
            var findResult = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
            (0, (0, parcelRequire("bahqM")).each)(findResult, function(models, key) {
                key.indexOf('Models') >= 0 && (0, (0, parcelRequire("bahqM")).each)(models, function(model) {
                    var coordSys = model.coordinateSystem;
                    if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                    else if (key === 'seriesModels') {
                        var view = this._chartsMap[model.__viewId];
                        if (view && view.containPoint) result = result || view.containPoint(value, model);
                    }
                }, this);
            }, this);
            return !!result;
        };
        ECharts.prototype.getVisual = function(finder, visualType) {
            var ecModel = this._model;
            var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder, {
                defaultMainType: 'series'
            });
            var seriesModel = parsedFinder.seriesModel;
            var data = seriesModel.getData();
            var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
            return dataIndexInside != null ? (0, (0, parcelRequire("fk5Gm")).getItemVisualFromData)(data, dataIndexInside, visualType) : (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(data, visualType);
        };
        ECharts.prototype.getViewOfComponentModel = function(componentModel) {
            return this._componentsMap[componentModel.__viewId];
        };
        ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
            return this._chartsMap[seriesModel.__viewId];
        };
        ECharts.prototype._initEvents = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$MOUSE_EVENT_NAMES, function(eveName) {
                var handler = function(e) {
                    var ecModel = _this.getModel();
                    var el = e.target;
                    var params;
                    var isGlobalOut = eveName === 'globalout';
                    if (isGlobalOut) params = {};
                    else el && (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(parent) {
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(parent);
                        if (ecData && ecData.dataIndex != null) {
                            var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                            params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                            return true;
                        } else if (ecData.eventData) {
                            params = (0, (0, parcelRequire("bahqM")).extend)({}, ecData.eventData);
                            return true;
                        }
                    }, true);
                    if (params) {
                        var componentType = params.componentType;
                        var componentIndex = params.componentIndex;
                        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                            componentType = 'series';
                            componentIndex = params.seriesIndex;
                        }
                        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                        var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                        params.event = e;
                        params.type = eveName;
                        _this._$eventProcessor.eventInfo = {
                            targetEl: el,
                            packedEvent: params,
                            model: model,
                            view: view
                        };
                        _this.trigger(eveName, params);
                    }
                };
                handler.zrEventfulCallAtLast = true;
                _this._zr.on(eveName, handler, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)([
                'selectchanged'
            ], function(eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("1nKsD")).handleLegacySelectEvents)(this._messageCenter, this, this._api);
        };
        ECharts.prototype.isDisposed = function() {
            return this._disposed;
        };
        ECharts.prototype.clear = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this.setOption({
                series: []
            }, true);
        };
        ECharts.prototype.dispose = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._disposed = true;
            (0, parcelRequire("eaKsF")).setAttribute(this.getDom(), $61f525521022d020$var$DOM_ATTRIBUTE_KEY, '');
            var chart = this;
            var api = chart._api;
            var ecModel = chart._model;
            (0, (0, parcelRequire("bahqM")).each)(chart._componentsViews, function(component) {
                component.dispose(ecModel, api);
            });
            (0, (0, parcelRequire("bahqM")).each)(chart._chartsViews, function(chart) {
                chart.dispose(ecModel, api);
            });
            chart._zr.dispose();
            chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
            delete $61f525521022d020$var$instances[chart.id];
        };
        ECharts.prototype.resize = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._zr.resize(opts);
            var ecModel = this._model;
            this._loadingFX && this._loadingFX.resize();
            if (!ecModel) return;
            var needPrepare = ecModel.resetOption('media');
            var silent = opts && opts.silent;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                if (silent == null) silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                needPrepare = true;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            needPrepare && $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, (0, parcelRequire("bahqM")).extend)({
                    duration: 0
                }, opts && opts.animation)
            });
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.showLoading = function(name, cfg) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(name)) {
                cfg = name;
                name = '';
            }
            name = name || 'default';
            this.hideLoading();
            if (!$61f525521022d020$var$loadingEffects[name]) return;
            var el = $61f525521022d020$var$loadingEffects[name](this._api, cfg);
            var zr = this._zr;
            this._loadingFX = el;
            zr.add(el);
        };
        ECharts.prototype.hideLoading = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._loadingFX && this._zr.remove(this._loadingFX);
            this._loadingFX = null;
        };
        ECharts.prototype.makeActionFromEvent = function(eventObj) {
            var payload = (0, (0, parcelRequire("bahqM")).extend)({}, eventObj);
            payload.type = $61f525521022d020$var$eventActionMap[eventObj.type];
            return payload;
        };
        ECharts.prototype.dispatchAction = function(payload, opt) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) opt = {
                silent: !!opt
            };
            if (!$61f525521022d020$var$actions[payload.type]) return;
            if (!this._model) return;
            if (this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY]) {
                this._pendingActions.push(payload);
                return;
            }
            var silent = opt.silent;
            $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
            var flush = opt.flush;
            if (flush) this._zr.flush();
            else if (flush !== false && (0, (0, parcelRequire("hZfwb")).default).browser.weChat) this._throttledZrFlush();
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.updateLabelLayout = function() {
            (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', this._model, this._api, {
                updatedSeries: []
            });
        };
        ECharts.prototype.appendData = function(params) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var seriesIndex = params.seriesIndex;
            var ecModel = this.getModel();
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            seriesModel.appendData(params);
            this._scheduler.unfinished = true;
            this.getZr().wakeUp();
        };
        ECharts.internalField = function() {
            $61f525521022d020$var$prepare = function(ecIns) {
                var scheduler = ecIns._scheduler;
                scheduler.restorePipelines(ecIns._model);
                scheduler.prepareStageTasks();
                $61f525521022d020$var$prepareView(ecIns, true);
                $61f525521022d020$var$prepareView(ecIns, false);
                scheduler.plan();
            };
            $61f525521022d020$var$prepareView = function(ecIns, isComponent) {
                var ecModel = ecIns._model;
                var scheduler = ecIns._scheduler;
                var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
                var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
                var zr = ecIns._zr;
                var api = ecIns._api;
                for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
                isComponent ? ecModel.eachComponent(function(componentType, model) {
                    componentType !== 'series' && doPrepare(model);
                }) : ecModel.eachSeries(doPrepare);
                function doPrepare(model) {
                    var requireNewView = model.__requireNewView;
                    model.__requireNewView = false;
                    var viewId = '_ec_' + model.id + '_' + model.type;
                    var view = !requireNewView && viewMap[viewId];
                    if (!view) {
                        var classType = (0, (0, parcelRequire("aLwh0")).parseClassType)(model.type);
                        var Clazz = isComponent ? (0, (0, parcelRequire("fkskt")).default).getClass(classType.main, classType.sub) : (0, (0, parcelRequire("loerw")).default).getClass(classType.sub);
                        view = new Clazz();
                        view.init(ecModel, api);
                        viewMap[viewId] = view;
                        viewList.push(view);
                        zr.add(view.group);
                    }
                    model.__viewId = view.__id = viewId;
                    view.__alive = true;
                    view.__model = model;
                    view.group.__ecComponentInfo = {
                        mainType: model.mainType,
                        index: model.componentIndex
                    };
                    !isComponent && scheduler.prepareView(view, model, ecModel, api);
                }
                for(var i = 0; i < viewList.length;){
                    var view = viewList[i];
                    if (!view.__alive) {
                        !isComponent && view.renderTask.dispose();
                        zr.remove(view.group);
                        view.dispose(ecModel, api);
                        viewList.splice(i, 1);
                        if (viewMap[view.__id] === view) delete viewMap[view.__id];
                        view.__id = view.group.__ecComponentInfo = null;
                    } else i++;
                }
            };
            $61f525521022d020$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
                var ecModel = ecIns._model;
                ecModel.setUpdatePayload(payload);
                if (!mainType) {
                    (0, (0, parcelRequire("bahqM")).each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                    return;
                }
                var query = {};
                query[mainType + 'Id'] = payload[mainType + 'Id'];
                query[mainType + 'Index'] = payload[mainType + 'Index'];
                query[mainType + 'Name'] = payload[mainType + 'Name'];
                var condition = {
                    mainType: mainType,
                    query: query
                };
                subType && (condition.subType = subType);
                var excludeSeriesId = payload.excludeSeriesId;
                var excludeSeriesIdMap;
                if (excludeSeriesId != null) {
                    excludeSeriesIdMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(excludeSeriesId), function(id) {
                        var modelId = (0, parcelRequire("eaKsF")).convertOptionIdName(id, null);
                        if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                    });
                }
                if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) (0, (0, parcelRequire("fIXXx")).allLeaveBlur)(ecIns._api);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                        } else {
                            var _a = (0, (0, parcelRequire("fIXXx")).findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                            if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                                payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) ? (0, (0, parcelRequire("fIXXx")).enterEmphasis)(dispatcher) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(dispatcher);
                            });
                        }
                    } else if ((0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            (0, (0, parcelRequire("fIXXx")).toggleSelectionFromPayload)(model, payload, ecIns._api);
                            (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(model);
                            $61f525521022d020$var$markStatusToUpdate(ecIns);
                        }
                    }
                }, ecIns);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
                }, ecIns);
                function callView(view) {
                    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
                }
            };
            $61f525521022d020$var$updateMethods = {
                prepareAndUpdate: function(payload) {
                    $61f525521022d020$var$prepare(this);
                    $61f525521022d020$var$updateMethods.update.call(this, payload, {
                        optionChanged: payload.newOption != null
                    });
                },
                update: function(payload, updateParams) {
                    var ecModel = this._model;
                    var api = this._api;
                    var zr = this._zr;
                    var coordSysMgr = this._coordSysMgr;
                    var scheduler = this._scheduler;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    scheduler.restoreData(ecModel, payload);
                    scheduler.performSeriesTasks(ecModel);
                    coordSysMgr.create(ecModel, api);
                    scheduler.performDataProcessorTasks(ecModel, payload);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    coordSysMgr.update(ecModel, api);
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    scheduler.performVisualTasks(ecModel, payload);
                    $61f525521022d020$var$render(this, ecModel, api, payload, updateParams);
                    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                    var darkMode = ecModel.get('darkMode');
                    if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) {
                        var colorArr = (0, parcelRequire("d6udH")).parse(backgroundColor);
                        backgroundColor = (0, parcelRequire("d6udH")).stringify(colorArr, 'rgb');
                        if (colorArr[3] === 0) backgroundColor = 'transparent';
                    } else {
                        zr.setBackgroundColor(backgroundColor);
                        if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                    }
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateTransform: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    var api = this._api;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    var componentDirtyList = [];
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType === 'series') return;
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        if (componentView && componentView.__alive) {
                            if (componentView.updateTransform) {
                                var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                                result && result.update && componentDirtyList.push(componentView);
                            } else componentDirtyList.push(componentView);
                        }
                    });
                    var seriesDirtyMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        if (chartView.updateTransform) {
                            var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                            result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                        } else seriesDirtyMap.set(seriesModel.uid, 1);
                    });
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true,
                        dirtyMap: seriesDirtyMap
                    });
                    $61f525521022d020$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateView: function(payload) {
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateView');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true
                    });
                    $61f525521022d020$var$render(this, ecModel, this._api, payload, {});
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateVisual: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    ecModel.eachSeries(function(seriesModel) {
                        seriesModel.getData().clearAllVisual();
                    });
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateVisual');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        visualType: 'visual',
                        setDirty: true
                    });
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType !== 'series') {
                            var componentView = _this.getViewOfComponentModel(componentModel);
                            componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                        }
                    });
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                    });
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateLayout: function(payload) {
                    $61f525521022d020$var$updateMethods.update.call(this, payload);
                }
            };
            $61f525521022d020$var$doConvertPixel = function(ecIns, methodName, finder, value) {
                if (ecIns._disposed) {
                    $61f525521022d020$var$disposedWarning(ecIns.id);
                    return;
                }
                var ecModel = ecIns._model;
                var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
                var result;
                var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
                for(var i = 0; i < coordSysList.length; i++){
                    var coordSys = coordSysList[i];
                    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
                }
            };
            $61f525521022d020$var$updateStreamModes = function(ecIns, ecModel) {
                var chartsMap = ecIns._chartsMap;
                var scheduler = ecIns._scheduler;
                ecModel.eachSeries(function(seriesModel) {
                    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
                });
            };
            $61f525521022d020$var$doDispatchAction = function(payload, silent) {
                var _this = this;
                var ecModel = this.getModel();
                var payloadType = payload.type;
                var escapeConnect = payload.escapeConnect;
                var actionWrap = $61f525521022d020$var$actions[payloadType];
                var actionInfo = actionWrap.actionInfo;
                var cptTypeTmp = (actionInfo.update || 'update').split(':');
                var updateMethod = cptTypeTmp.pop();
                var cptType = cptTypeTmp[0] != null && (0, (0, parcelRequire("aLwh0")).parseClassType)(cptTypeTmp[0]);
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                var payloads = [
                    payload
                ];
                var batched = false;
                if (payload.batch) {
                    batched = true;
                    payloads = (0, (0, parcelRequire("bahqM")).map)(payload.batch, function(item) {
                        item = (0, (0, parcelRequire("bahqM")).defaults)((0, (0, parcelRequire("bahqM")).extend)({}, item), payload);
                        item.batch = null;
                        return item;
                    });
                }
                var eventObjBatch = [];
                var eventObj;
                var isSelectChange = (0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload);
                var isHighDown = (0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload);
                (0, (0, parcelRequire("bahqM")).each)(payloads, function(batchItem) {
                    eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                    eventObj = eventObj || (0, (0, parcelRequire("bahqM")).extend)({}, batchItem);
                    eventObj.type = actionInfo.event || eventObj.type;
                    eventObjBatch.push(eventObj);
                    if (isHighDown) {
                        var _a = (0, parcelRequire("eaKsF")).preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                        var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (isSelectChange) {
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (cptType) $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
                });
                if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                    if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                        $61f525521022d020$var$prepare(this);
                        $61f525521022d020$var$updateMethods.update.call(this, payload);
                        this[$61f525521022d020$var$PENDING_UPDATE] = null;
                    } else $61f525521022d020$var$updateMethods[updateMethod].call(this, payload);
                }
                if (batched) eventObj = {
                    type: actionInfo.event || payloadType,
                    escapeConnect: escapeConnect,
                    batch: eventObjBatch
                };
                else eventObj = eventObjBatch[0];
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                if (!silent) {
                    var messageCenter = this._messageCenter;
                    messageCenter.trigger(eventObj.type, eventObj);
                    if (isSelectChange) {
                        var newObj = {
                            type: 'selectchanged',
                            escapeConnect: escapeConnect,
                            selected: (0, (0, parcelRequire("fIXXx")).getAllSelectedIndices)(ecModel),
                            isFromClick: payload.isFromClick || false,
                            fromAction: payload.type,
                            fromActionPayload: payload
                        };
                        messageCenter.trigger(newObj.type, newObj);
                    }
                }
            };
            $61f525521022d020$var$flushPendingActions = function(silent) {
                var pendingActions = this._pendingActions;
                while(pendingActions.length){
                    var payload = pendingActions.shift();
                    $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
                }
            };
            $61f525521022d020$var$triggerUpdatedEvent = function(silent) {
                !silent && this.trigger('updated');
            };
            $61f525521022d020$var$bindRenderedEvent = function(zr, ecIns) {
                zr.on('rendered', function(params) {
                    ecIns.trigger('rendered', params);
                    if (zr.animation.isFinished() && !ecIns[$61f525521022d020$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
                });
            };
            $61f525521022d020$var$bindMouseEvent = function(zr, ecIns) {
                zr.on('mouseover', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('mouseout', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('click', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(target) {
                        return (0, (0, parcelRequire("7QjoM")).getECData)(target).dataIndex != null;
                    }, true);
                    if (dispatcher) {
                        var actionType = dispatcher.selected ? 'unselect' : 'select';
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
                        ecIns._api.dispatchAction({
                            type: actionType,
                            dataType: ecData.dataType,
                            dataIndexInside: ecData.dataIndex,
                            seriesIndex: ecData.seriesIndex,
                            isFromClick: true
                        });
                    }
                });
            };
            $61f525521022d020$var$clearColorPalette = function(ecModel) {
                ecModel.clearColorPalette();
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.clearColorPalette();
                });
            };
            $61f525521022d020$var$render = function(ecIns, ecModel, api, payload, updateParams) {
                $61f525521022d020$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    chart.__alive = false;
                });
                $61f525521022d020$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    if (!chart.__alive) chart.remove(ecModel, api);
                });
            };
            $61f525521022d020$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
                (0, (0, parcelRequire("bahqM")).each)(dirtyList || ecIns._componentsViews, function(componentView) {
                    var componentModel = componentView.__model;
                    clearStates(componentModel, componentView);
                    componentView.render(componentModel, ecModel, api, payload);
                    updateZ(componentModel, componentView);
                    updateStates(componentModel, componentView);
                });
            };
            $61f525521022d020$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
                var scheduler = ecIns._scheduler;
                updateParams = (0, (0, parcelRequire("bahqM")).extend)(updateParams || {}, {
                    updatedSeries: ecModel.getSeries()
                });
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:beforeupdate', ecModel, api, updateParams);
                var unfinished = false;
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    chartView.__alive = true;
                    var renderTask = chartView.renderTask;
                    scheduler.updatePayload(renderTask, payload);
                    clearStates(seriesModel, chartView);
                    if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                    if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                    chartView.group.silent = !!seriesModel.get('silent');
                    updateBlend(seriesModel, chartView);
                    (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(seriesModel);
                });
                scheduler.unfinished = unfinished || scheduler.unfinished;
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', ecModel, api, updateParams);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:transition', ecModel, api, updateParams);
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    updateZ(seriesModel, chartView);
                    updateStates(seriesModel, chartView);
                });
                updateHoverLayerStatus(ecIns, ecModel);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:afterupdate', ecModel, api, updateParams);
            };
            $61f525521022d020$var$markStatusToUpdate = function(ecIns) {
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = true;
                ecIns.getZr().wakeUp();
            };
            $61f525521022d020$var$applyChangedStates = function(ecIns) {
                if (!ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY]) return;
                ecIns.getZr().storage.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    applyElementStates(el);
                });
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = false;
            };
            function applyElementStates(el) {
                var newStates = [];
                var oldStates = el.currentStates;
                for(var i = 0; i < oldStates.length; i++){
                    var stateName = oldStates[i];
                    if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
                }
                if (el.selected && el.states.select) newStates.push('select');
                if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
                else if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
                el.useStates(newStates);
            }
            function updateHoverLayerStatus(ecIns, ecModel) {
                var zr = ecIns._zr;
                var storage = zr.storage;
                var elCount = 0;
                storage.traverse(function(el) {
                    if (!el.isGroup) elCount++;
                });
                if (elCount > ecModel.get('hoverLayerThreshold') && !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker) ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.group.traverse(function(el) {
                        if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                    });
                });
            }
            function updateBlend(seriesModel, chartView) {
                var blendMode = seriesModel.get('blendMode') || null;
                chartView.group.traverse(function(el) {
                    if (!el.isGroup) el.style.blend = blendMode;
                    if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                        displayable.style.blend = blendMode;
                    });
                });
            }
            function updateZ(model, view) {
                if (model.preventAutoZ) return;
                _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
            }
            function _updateZ(el, z, zlevel, maxZ2) {
                var label = el.getTextContent();
                var labelLine = el.getTextGuideLine();
                var isGroup = el.isGroup;
                if (isGroup) {
                    var children = el.childrenRef();
                    for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
                } else {
                    el.z = z;
                    el.zlevel = zlevel;
                    maxZ2 = Math.max(el.z2, maxZ2);
                }
                if (label) {
                    label.z = z;
                    label.zlevel = zlevel;
                    isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
                }
                if (labelLine) {
                    var textGuideLineConfig = el.textGuideLineConfig;
                    labelLine.z = z;
                    labelLine.zlevel = zlevel;
                    isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
                }
                return maxZ2;
            }
            function clearStates(model, view) {
                view.group.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    var textContent = el.getTextContent();
                    var textGuide = el.getTextGuideLine();
                    if (el.stateTransition) el.stateTransition = null;
                    if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                    if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                    if (el.hasState()) {
                        el.prevStates = el.currentStates;
                        el.clearStates();
                    } else if (el.prevStates) el.prevStates = null;
                });
            }
            function updateStates(model, view) {
                var stateAnimationModel = model.getModel('stateAnimation');
                var enableAnimation = model.isAnimationEnabled();
                var duration = stateAnimationModel.get('duration');
                var stateTransition = duration > 0 ? {
                    duration: duration,
                    delay: stateAnimationModel.get('delay'),
                    easing: stateAnimationModel.get('easing')
                } : null;
                view.group.traverse(function(el) {
                    if (el.states && el.states.emphasis) {
                        if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                        if (el instanceof (0, parcelRequire("ghQ8v")).default) (0, (0, parcelRequire("fIXXx")).savePathStates)(el);
                        if (el.__dirty) {
                            var prevStates = el.prevStates;
                            if (prevStates) el.useStates(prevStates);
                        }
                        if (enableAnimation) {
                            el.stateTransition = stateTransition;
                            var textContent = el.getTextContent();
                            var textGuide = el.getTextGuideLine();
                            if (textContent) textContent.stateTransition = stateTransition;
                            if (textGuide) textGuide.stateTransition = stateTransition;
                        }
                        if (el.__dirty) applyElementStates(el);
                    }
                });
            }
            $61f525521022d020$var$createExtensionAPI = function(ecIns) {
                return new (function(_super) {
                    (0, (0, parcelRequire("3VFsf")).__extends)(class_1, _super);
                    function class_1() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    class_1.prototype.getCoordinateSystems = function() {
                        return ecIns._coordSysMgr.getCoordinateSystems();
                    };
                    class_1.prototype.getComponentByElement = function(el) {
                        while(el){
                            var modelInfo = el.__ecComponentInfo;
                            if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                            el = el.parent;
                        }
                    };
                    class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).enterEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.getModel = function() {
                        return ecIns.getModel();
                    };
                    class_1.prototype.getViewOfComponentModel = function(componentModel) {
                        return ecIns.getViewOfComponentModel(componentModel);
                    };
                    class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                        return ecIns.getViewOfSeriesModel(seriesModel);
                    };
                    return class_1;
                }((0, (0, parcelRequire("iEvqc")).default)))(ecIns);
            };
            $61f525521022d020$var$enableConnect = function(chart) {
                function updateConnectedChartsStatus(charts, status) {
                    for(var i = 0; i < charts.length; i++){
                        var otherChart = charts[i];
                        otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] = status;
                    }
                }
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                    chart._messageCenter.on(eventType, function(event) {
                        if ($61f525521022d020$var$connectedGroups[chart.group] && chart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_PENDING) {
                            if (event && event.escapeConnect) return;
                            var action_1 = chart.makeActionFromEvent(event);
                            var otherCharts_1 = [];
                            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(otherChart) {
                                if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_PENDING);
                            (0, (0, parcelRequire("bahqM")).each)(otherCharts_1, function(otherChart) {
                                if (otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_UPDATED);
                        }
                    });
                });
            };
        }();
        return ECharts;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$echartsProto = $61f525521022d020$var$ECharts.prototype;
    $61f525521022d020$var$echartsProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('on');
    $61f525521022d020$var$echartsProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('off');
    $61f525521022d020$var$echartsProto.one = function(eventName, cb, ctx) {
        var self = this;
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('ECharts#one is deprecated.');
        function wrapped() {
            var args2 = [];
            for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
            cb && cb.apply && cb.apply(this, args2);
            self.off(eventName, wrapped);
        }
        this.on.call(this, eventName, wrapped, ctx);
    };
    var $61f525521022d020$var$MOUSE_EVENT_NAMES = [
        'click',
        'dblclick',
        'mouseover',
        'mouseout',
        'mousemove',
        'mousedown',
        'mouseup',
        'globalout',
        'contextmenu'
    ];
    function $61f525521022d020$var$disposedWarning(id) {}
    var $61f525521022d020$var$actions = {};
    var $61f525521022d020$var$eventActionMap = {};
    var $61f525521022d020$var$dataProcessorFuncs = [];
    var $61f525521022d020$var$optionPreprocessorFuncs = [];
    var $61f525521022d020$var$visualFuncs = [];
    var $61f525521022d020$var$themeStorage = {};
    var $61f525521022d020$var$loadingEffects = {};
    var $61f525521022d020$var$instances = {};
    var $61f525521022d020$var$connectedGroups = {};
    var $61f525521022d020$var$idBase = +new Date() - 0;
    var $61f525521022d020$var$groupIdBase = +new Date() - 0;
    var $61f525521022d020$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
    function $61f525521022d020$export$2cd8252107eb640b(dom, theme, opts) {
        var existInstance = $61f525521022d020$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
        var chart = new $61f525521022d020$var$ECharts(dom, theme, opts);
        chart.id = 'ec_' + $61f525521022d020$var$idBase++;
        $61f525521022d020$var$instances[chart.id] = chart;
        (0, parcelRequire("eaKsF")).setAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY, chart.id);
        $61f525521022d020$var$enableConnect(chart);
        (0, (0, parcelRequire("8cCW2")).default).trigger('afterinit', chart);
        return chart;
    }
    function $61f525521022d020$export$64605811ab45167f(groupId) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(groupId)) {
            var charts = groupId;
            groupId = null;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                if (chart.group != null) groupId = chart.group;
            });
            groupId = groupId || 'g_' + $61f525521022d020$var$groupIdBase++;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                chart.group = groupId;
            });
        }
        $61f525521022d020$var$connectedGroups[groupId] = true;
        return groupId;
    }
    function $61f525521022d020$export$87cd6834112ecb52(groupId) {
        $61f525521022d020$var$connectedGroups[groupId] = false;
    }
    var $61f525521022d020$export$37dfea93db2e14ed = $61f525521022d020$export$87cd6834112ecb52;
    function $61f525521022d020$export$fcfbbcec2cb820d5(chart) {
        if (typeof chart === 'string') chart = $61f525521022d020$var$instances[chart];
        else if (!(chart instanceof $61f525521022d020$var$ECharts)) chart = $61f525521022d020$export$33b6fbccd4f643f8(chart);
        if (chart instanceof $61f525521022d020$var$ECharts && !chart.isDisposed()) chart.dispose();
    }
    function $61f525521022d020$export$33b6fbccd4f643f8(dom) {
        return $61f525521022d020$var$instances[(0, parcelRequire("eaKsF")).getAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY)];
    }
    function $61f525521022d020$export$89b4be35062c4a3f(key) {
        return $61f525521022d020$var$instances[key];
    }
    function $61f525521022d020$export$f9c59eed5de5ff80(name, theme) {
        $61f525521022d020$var$themeStorage[name] = theme;
    }
    function $61f525521022d020$export$77095792a057b768(preprocessorFunc) {
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $61f525521022d020$var$optionPreprocessorFuncs.push(preprocessorFunc);
    }
    function $61f525521022d020$export$d575e6557ac1729f(priority, processor) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$dataProcessorFuncs, priority, processor, $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT);
    }
    function $61f525521022d020$export$c8c249911ee8c1ed(postInitFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterinit', postInitFunc);
    }
    function $61f525521022d020$export$99560909c18c76bb(postUpdateFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
    }
    function $61f525521022d020$export$c9ec4b5faef04865(name, cb) {
        (0, (0, parcelRequire("8cCW2")).default).on(name, cb);
    }
    function $61f525521022d020$export$408c24786cd729c6(actionInfo, eventName, action) {
        if (typeof eventName === 'function') {
            action = eventName;
            eventName = '';
        }
        var actionType = (0, (0, parcelRequire("bahqM")).isObject)(actionInfo) ? actionInfo.type : [
            actionInfo,
            actionInfo = {
                event: eventName
            }
        ][0];
        actionInfo.event = (actionInfo.event || actionType).toLowerCase();
        eventName = actionInfo.event;
        if ($61f525521022d020$var$eventActionMap[eventName]) return;
        (0, (0, parcelRequire("bahqM")).assert)($61f525521022d020$var$ACTION_REG.test(actionType) && $61f525521022d020$var$ACTION_REG.test(eventName));
        if (!$61f525521022d020$var$actions[actionType]) $61f525521022d020$var$actions[actionType] = {
            action: action,
            actionInfo: actionInfo
        };
        $61f525521022d020$var$eventActionMap[eventName] = actionType;
    }
    function $61f525521022d020$export$1dd5e025a8a37dd(type, coordSysCreator) {
        (0, (0, parcelRequire("gyhNQ")).default).register(type, coordSysCreator);
    }
    function $61f525521022d020$export$fc2638719e4159b9(type) {
        var coordSysCreator = (0, (0, parcelRequire("gyhNQ")).default).get(type);
        if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
    }
    function $61f525521022d020$export$d768f97700ca6bea(priority, layoutTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, layoutTask, $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT, 'layout');
    }
    function $61f525521022d020$export$5f32c1eb94c381bb(priority, visualTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, visualTask, $61f525521022d020$var$PRIORITY_VISUAL_CHART, 'visual');
    }
    var $61f525521022d020$var$registeredTasks = [];
    function $61f525521022d020$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
        if ((0, (0, parcelRequire("bahqM")).isFunction)(priority) || (0, (0, parcelRequire("bahqM")).isObject)(priority)) {
            fn = priority;
            priority = defaultPriority;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$registeredTasks, fn) >= 0) return;
        $61f525521022d020$var$registeredTasks.push(fn);
        var stageHandler = (0, (0, parcelRequire("14WFd")).default).wrapStageHandler(fn, visualType);
        stageHandler.__prio = priority;
        stageHandler.__raw = fn;
        targetList.push(stageHandler);
    }
    function $61f525521022d020$export$e06b68a82007c015(name, loadingFx) {
        $61f525521022d020$var$loadingEffects[name] = loadingFx;
    }
    function $61f525521022d020$export$10425ea7a243b114(creator) {
        (0, (0, parcelRequire("bahqM")).$override)('createCanvas', creator);
    }
    function $61f525521022d020$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
        (0, (0, parcelRequire("fEzwg")).default).registerMap(mapName, geoJson, specialAreas);
    }
    function $61f525521022d020$export$b8586192aead8a7e(mapName) {
        return (0, (0, parcelRequire("fEzwg")).default).getMapForUser(mapName);
    }
    var $61f525521022d020$export$f01d71dd0389d7e4 = (0, (0, parcelRequire("05ab4")).registerExternalTransform);
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("cvEVp")).seriesStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataColorPaletteTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("7wiHx")).seriesSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("7wiHx")).dataSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_DECAL, (0, (0, parcelRequire("g2DhS")).default));
    $61f525521022d020$export$77095792a057b768((0, (0, parcelRequire("driCQ")).default));
    $61f525521022d020$export$d575e6557ac1729f($61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK, (0, (0, parcelRequire("iMppY")).default));
    $61f525521022d020$export$e06b68a82007c015('default', (0, (0, parcelRequire("4G956")).default));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$f9c59eed5de5ff80('light', (0, (0, parcelRequire("31FQc")).default));
    $61f525521022d020$export$f9c59eed5de5ff80('dark', (0, (0, parcelRequire("dMJCs")).default));
    var $61f525521022d020$export$73cae5e090579589 = {};
});
parcelRegister("9Y5KT", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$741e2e865750343c$export$2cd8252107eb640b);
    $parcel$export(module.exports, "dispose", ()=>$741e2e865750343c$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "disposeAll", ()=>$741e2e865750343c$export$825f692fb04800ef);
    $parcel$export(module.exports, "getInstance", ()=>$741e2e865750343c$export$8bedcca5bbd73999);
    $parcel$export(module.exports, "registerPainter", ()=>$741e2e865750343c$export$a3e793ccb11823a5);
    $parcel$export(module.exports, "version", ()=>$741e2e865750343c$export$83d89fbfd8236492);
    var $hZfwb;
    var $bahqM;
    var $jaJTK;
    var $66sfA;
    var $F44Dl;
    var $bHSYT;
    var $d6udH;
    var $7y1my;
    var $4KVOr;
    var $741e2e865750343c$var$useVML = !(0, (0, parcelRequire("hZfwb")).default).canvasSupported;
    var $741e2e865750343c$var$painterCtors = {};
    var $741e2e865750343c$var$instances = {};
    function $741e2e865750343c$var$delInstance(id) {
        delete $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$var$isDarkMode(backgroundColor) {
        if (!backgroundColor) return false;
        if (typeof backgroundColor === 'string') return (0, (0, parcelRequire("d6udH")).lum)(backgroundColor, 1) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        else if (backgroundColor.colorStops) {
            var colorStops = backgroundColor.colorStops;
            var totalLum = 0;
            var len = colorStops.length;
            for(var i = 0; i < len; i++)totalLum += (0, (0, parcelRequire("d6udH")).lum)(colorStops[i].color, 1);
            totalLum /= len;
            return totalLum < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        }
        return false;
    }
    var $741e2e865750343c$var$ZRender = function() {
        function ZRender(id, dom, opts) {
            var _this = this;
            this._sleepAfterStill = 10;
            this._stillFrameAccum = 0;
            this._needsRefresh = true;
            this._needsRefreshHover = true;
            this._darkMode = false;
            opts = opts || {};
            this.dom = dom;
            this.id = id;
            var storage = new (0, (0, parcelRequire("66sfA")).default)();
            var rendererType = opts.renderer || 'canvas';
            if ($741e2e865750343c$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
            if (!$741e2e865750343c$var$painterCtors[rendererType]) rendererType = (0, parcelRequire("bahqM")).keys($741e2e865750343c$var$painterCtors)[0];
            if (!$741e2e865750343c$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
            opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
            var painter = new $741e2e865750343c$var$painterCtors[rendererType](dom, storage, opts, id);
            this.storage = storage;
            this.painter = painter;
            var handerProxy = !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker ? new (0, (0, parcelRequire("bHSYT")).default)(painter.getViewportRoot(), painter.root) : null;
            this.handler = new (0, (0, parcelRequire("jaJTK")).default)(storage, painter, handerProxy, painter.root);
            this.animation = new (0, (0, parcelRequire("F44Dl")).default)({
                stage: {
                    update: function() {
                        return _this._flush(true);
                    }
                }
            });
            this.animation.start();
        }
        ZRender.prototype.add = function(el) {
            if (!el) return;
            this.storage.addRoot(el);
            el.addSelfToZr(this);
            this.refresh();
        };
        ZRender.prototype.remove = function(el) {
            if (!el) return;
            this.storage.delRoot(el);
            el.removeSelfFromZr(this);
            this.refresh();
        };
        ZRender.prototype.configLayer = function(zLevel, config) {
            if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
            this.refresh();
        };
        ZRender.prototype.setBackgroundColor = function(backgroundColor) {
            if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
            this.refresh();
            this._backgroundColor = backgroundColor;
            this._darkMode = $741e2e865750343c$var$isDarkMode(backgroundColor);
        };
        ZRender.prototype.getBackgroundColor = function() {
            return this._backgroundColor;
        };
        ZRender.prototype.setDarkMode = function(darkMode) {
            this._darkMode = darkMode;
        };
        ZRender.prototype.isDarkMode = function() {
            return this._darkMode;
        };
        ZRender.prototype.refreshImmediately = function(fromInside) {
            if (!fromInside) this.animation.update(true);
            this._needsRefresh = false;
            this.painter.refresh();
            this._needsRefresh = false;
        };
        ZRender.prototype.refresh = function() {
            this._needsRefresh = true;
            this.animation.start();
        };
        ZRender.prototype.flush = function() {
            this._flush(false);
        };
        ZRender.prototype._flush = function(fromInside) {
            var triggerRendered;
            var start = new Date().getTime();
            if (this._needsRefresh) {
                triggerRendered = true;
                this.refreshImmediately(fromInside);
            }
            if (this._needsRefreshHover) {
                triggerRendered = true;
                this.refreshHoverImmediately();
            }
            var end = new Date().getTime();
            if (triggerRendered) {
                this._stillFrameAccum = 0;
                this.trigger('rendered', {
                    elapsedTime: end - start
                });
            } else if (this._sleepAfterStill > 0) {
                this._stillFrameAccum++;
                if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
            }
        };
        ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
            this._sleepAfterStill = stillFramesCount;
        };
        ZRender.prototype.wakeUp = function() {
            this.animation.start();
            this._stillFrameAccum = 0;
        };
        ZRender.prototype.addHover = function(el) {};
        ZRender.prototype.removeHover = function(el) {};
        ZRender.prototype.clearHover = function() {};
        ZRender.prototype.refreshHover = function() {
            this._needsRefreshHover = true;
        };
        ZRender.prototype.refreshHoverImmediately = function() {
            this._needsRefreshHover = false;
            if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
        };
        ZRender.prototype.resize = function(opts) {
            opts = opts || {};
            this.painter.resize(opts.width, opts.height);
            this.handler.resize();
        };
        ZRender.prototype.clearAnimation = function() {
            this.animation.clear();
        };
        ZRender.prototype.getWidth = function() {
            return this.painter.getWidth();
        };
        ZRender.prototype.getHeight = function() {
            return this.painter.getHeight();
        };
        ZRender.prototype.pathToImage = function(e, dpr) {
            if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
        };
        ZRender.prototype.setCursorStyle = function(cursorStyle) {
            this.handler.setCursorStyle(cursorStyle);
        };
        ZRender.prototype.findHover = function(x, y) {
            return this.handler.findHover(x, y);
        };
        ZRender.prototype.on = function(eventName, eventHandler, context) {
            this.handler.on(eventName, eventHandler, context);
            return this;
        };
        ZRender.prototype.off = function(eventName, eventHandler) {
            this.handler.off(eventName, eventHandler);
        };
        ZRender.prototype.trigger = function(eventName, event) {
            this.handler.trigger(eventName, event);
        };
        ZRender.prototype.clear = function() {
            var roots = this.storage.getRoots();
            for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, (0, parcelRequire("4KVOr")).default)) roots[i].removeSelfFromZr(this);
            this.storage.delAllRoots();
            this.painter.clear();
        };
        ZRender.prototype.dispose = function() {
            this.animation.stop();
            this.clear();
            this.storage.dispose();
            this.painter.dispose();
            this.handler.dispose();
            this.animation = this.storage = this.painter = this.handler = null;
            $741e2e865750343c$var$delInstance(this.id);
        };
        return ZRender;
    }();
    function $741e2e865750343c$export$2cd8252107eb640b(dom, opts) {
        var zr = new $741e2e865750343c$var$ZRender((0, parcelRequire("bahqM")).guid(), dom, opts);
        $741e2e865750343c$var$instances[zr.id] = zr;
        return zr;
    }
    function $741e2e865750343c$export$fcfbbcec2cb820d5(zr) {
        zr.dispose();
    }
    function $741e2e865750343c$export$825f692fb04800ef() {
        for(var key in $741e2e865750343c$var$instances)if ($741e2e865750343c$var$instances.hasOwnProperty(key)) $741e2e865750343c$var$instances[key].dispose();
        $741e2e865750343c$var$instances = {};
    }
    function $741e2e865750343c$export$8bedcca5bbd73999(id) {
        return $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$export$a3e793ccb11823a5(name, Ctor) {
        $741e2e865750343c$var$painterCtors[name] = Ctor;
    }
    var $741e2e865750343c$export$83d89fbfd8236492 = '5.2.1';
});
parcelRegister("jaJTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df528de50090e0a1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eLEew;
    var $8qDpt;
    var $bRKv5;
    var $65X4x;
    var $jYjcX;
    var $df528de50090e0a1$var$SILENT = 'silent';
    function $df528de50090e0a1$var$makeEventPacket(eveType, targetInfo, event) {
        return {
            type: eveType,
            event: event,
            target: targetInfo.target,
            topTarget: targetInfo.topTarget,
            cancelBubble: false,
            offsetX: event.zrX,
            offsetY: event.zrY,
            gestureEvent: event.gestureEvent,
            pinchX: event.pinchX,
            pinchY: event.pinchY,
            pinchScale: event.pinchScale,
            wheelDelta: event.zrDelta,
            zrByTouch: event.zrByTouch,
            which: event.which,
            stop: $df528de50090e0a1$var$stopEvent
        };
    }
    function $df528de50090e0a1$var$stopEvent() {
        (0, parcelRequire("65X4x")).stop(this.event);
    }
    var $df528de50090e0a1$var$EmptyProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EmptyProxy, _super);
        function EmptyProxy() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handler = null;
            return _this;
        }
        EmptyProxy.prototype.dispose = function() {};
        EmptyProxy.prototype.setCursor = function() {};
        return EmptyProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $df528de50090e0a1$var$HoveredResult = function() {
        function HoveredResult(x, y) {
            this.x = x;
            this.y = y;
        }
        return HoveredResult;
    }();
    var $df528de50090e0a1$var$handlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var $df528de50090e0a1$var$Handler = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Handler, _super);
        function Handler(storage, painter, proxy, painterRoot) {
            var _this = _super.call(this) || this;
            _this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
            _this.storage = storage;
            _this.painter = painter;
            _this.painterRoot = painterRoot;
            proxy = proxy || new $df528de50090e0a1$var$EmptyProxy();
            _this.proxy = null;
            _this.setHandlerProxy(proxy);
            _this._draggingMgr = new (0, (0, parcelRequire("8qDpt")).default)(_this);
            return _this;
        }
        Handler.prototype.setHandlerProxy = function(proxy) {
            if (this.proxy) this.proxy.dispose();
            if (proxy) {
                (0, parcelRequire("bahqM")).each($df528de50090e0a1$var$handlerNames, function(name) {
                    proxy.on && proxy.on(name, this[name], this);
                }, this);
                proxy.handler = this;
            }
            this.proxy = proxy;
        };
        Handler.prototype.mousemove = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var lastHovered = this._hovered;
            var lastHoveredTarget = lastHovered.target;
            if (lastHoveredTarget && !lastHoveredTarget.__zr) {
                lastHovered = this.findHover(lastHovered.x, lastHovered.y);
                lastHoveredTarget = lastHovered.target;
            }
            var hovered = this._hovered = isOutside ? new $df528de50090e0a1$var$HoveredResult(x, y) : this.findHover(x, y);
            var hoveredTarget = hovered.target;
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
            if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
            this.dispatchToElement(hovered, 'mousemove', event);
            if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
        };
        Handler.prototype.mouseout = function(event) {
            var eventControl = event.zrEventControl;
            if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
            if (eventControl !== 'no_globalout') this.trigger('globalout', {
                type: 'globalout',
                event: event
            });
        };
        Handler.prototype.resize = function() {
            this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
        };
        Handler.prototype.dispatch = function(eventName, eventArgs) {
            var handler = this[eventName];
            handler && handler.call(this, eventArgs);
        };
        Handler.prototype.dispose = function() {
            this.proxy.dispose();
            this.storage = null;
            this.proxy = null;
            this.painter = null;
        };
        Handler.prototype.setCursorStyle = function(cursorStyle) {
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(cursorStyle);
        };
        Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
            targetInfo = targetInfo || {};
            var el = targetInfo.target;
            if (el && el.silent) return;
            var eventKey = 'on' + eventName;
            var eventPacket = $df528de50090e0a1$var$makeEventPacket(eventName, targetInfo, event);
            while(el){
                el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
                el.trigger(eventName, eventPacket);
                el = el.__hostTarget ? el.__hostTarget : el.parent;
                if (eventPacket.cancelBubble) break;
            }
            if (!eventPacket.cancelBubble) {
                this.trigger(eventName, eventPacket);
                if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                    if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                    if (layer.trigger) layer.trigger(eventName, eventPacket);
                });
            }
        };
        Handler.prototype.findHover = function(x, y, exclude) {
            var list = this.storage.getDisplayList();
            var out = new $df528de50090e0a1$var$HoveredResult(x, y);
            for(var i = list.length - 1; i >= 0; i--){
                var hoverCheckResult = void 0;
                if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $df528de50090e0a1$var$isHover(list[i], x, y))) {
                    !out.topTarget && (out.topTarget = list[i]);
                    if (hoverCheckResult !== $df528de50090e0a1$var$SILENT) {
                        out.target = list[i];
                        break;
                    }
                }
            }
            return out;
        };
        Handler.prototype.processGesture = function(event, stage) {
            if (!this._gestureMgr) this._gestureMgr = new (0, (0, parcelRequire("jYjcX")).GestureMgr)();
            var gestureMgr = this._gestureMgr;
            stage === 'start' && gestureMgr.clear();
            var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
            stage === 'end' && gestureMgr.clear();
            if (gestureInfo) {
                var type = gestureInfo.type;
                event.gestureEvent = type;
                var res = new $df528de50090e0a1$var$HoveredResult();
                res.target = gestureInfo.target;
                this.dispatchToElement(res, type, gestureInfo.event);
            }
        };
        return Handler;
    }((0, (0, parcelRequire("bRKv5")).default));
    (0, parcelRequire("bahqM")).each([
        'click',
        'mousedown',
        'mouseup',
        'mousewheel',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $df528de50090e0a1$var$Handler.prototype[name] = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var hovered;
            var hoveredTarget;
            if (name !== 'mouseup' || !isOutside) {
                hovered = this.findHover(x, y);
                hoveredTarget = hovered.target;
            }
            if (name === 'mousedown') {
                this._downEl = hoveredTarget;
                this._downPoint = [
                    event.zrX,
                    event.zrY
                ];
                this._upEl = hoveredTarget;
            } else if (name === 'mouseup') this._upEl = hoveredTarget;
            else if (name === 'click') {
                if (this._downEl !== this._upEl || !this._downPoint || (0, parcelRequire("eLEew")).dist(this._downPoint, [
                    event.zrX,
                    event.zrY
                ]) > 4) return;
                this._downPoint = null;
            }
            this.dispatchToElement(hovered, name, event);
        };
    });
    function $df528de50090e0a1$var$isHover(displayable, x, y) {
        if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
            var el = displayable;
            var isSilent = void 0;
            var ignoreClip = false;
            while(el){
                if (el.ignoreClip) ignoreClip = true;
                if (!ignoreClip) {
                    var clipPath = el.getClipPath();
                    if (clipPath && !clipPath.contain(x, y)) return false;
                    if (el.silent) isSilent = true;
                }
                var hostEl = el.__hostTarget;
                el = hostEl ? hostEl : el.parent;
            }
            return isSilent ? $df528de50090e0a1$var$SILENT : true;
        }
        return false;
    }
    function $df528de50090e0a1$var$isOutsideBoundary(handlerInstance, x, y) {
        var painter = handlerInstance.painter;
        return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
    }
    var $df528de50090e0a1$export$2e2bcd8739ae039 = $df528de50090e0a1$var$Handler;
});
parcelRegister("8qDpt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f526eb8ccffa3$export$2e2bcd8739ae039);
    var $622f526eb8ccffa3$var$Param = function() {
        function Param(target, e) {
            this.target = target;
            this.topTarget = e && e.topTarget;
        }
        return Param;
    }();
    var $622f526eb8ccffa3$var$Draggable = function() {
        function Draggable(handler) {
            this.handler = handler;
            handler.on('mousedown', this._dragStart, this);
            handler.on('mousemove', this._drag, this);
            handler.on('mouseup', this._dragEnd, this);
        }
        Draggable.prototype._dragStart = function(e) {
            var draggingTarget = e.target;
            while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
            if (draggingTarget) {
                this._draggingTarget = draggingTarget;
                draggingTarget.dragging = true;
                this._x = e.offsetX;
                this._y = e.offsetY;
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragstart', e.event);
            }
        };
        Draggable.prototype._drag = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) {
                var x = e.offsetX;
                var y = e.offsetY;
                var dx = x - this._x;
                var dy = y - this._y;
                this._x = x;
                this._y = y;
                draggingTarget.drift(dx, dy, e);
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'drag', e.event);
                var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
                var lastDropTarget = this._dropTarget;
                this._dropTarget = dropTarget;
                if (draggingTarget !== dropTarget) {
                    if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(lastDropTarget, e), 'dragleave', e.event);
                    if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(dropTarget, e), 'dragenter', e.event);
                }
            }
        };
        Draggable.prototype._dragEnd = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) draggingTarget.dragging = false;
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragend', e.event);
            if (this._dropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(this._dropTarget, e), 'drop', e.event);
            this._draggingTarget = null;
            this._dropTarget = null;
        };
        return Draggable;
    }();
    var $622f526eb8ccffa3$export$2e2bcd8739ae039 = $622f526eb8ccffa3$var$Draggable;
});
parcelRegister("jYjcX", function(module, exports) {
    $parcel$export(module.exports, "GestureMgr", ()=>$e8a28537c27906ba$export$f7557d6f27e9503);
    var $65X4x;
    var $e8a28537c27906ba$export$f7557d6f27e9503 = function() {
        function GestureMgr() {
            this._track = [];
        }
        GestureMgr.prototype.recognize = function(event, target, root) {
            this._doTrack(event, target, root);
            return this._recognize(event);
        };
        GestureMgr.prototype.clear = function() {
            this._track.length = 0;
            return this;
        };
        GestureMgr.prototype._doTrack = function(event, target, root) {
            var touches = event.touches;
            if (!touches) return;
            var trackItem = {
                points: [],
                touches: [],
                target: target,
                event: event
            };
            for(var i = 0, len = touches.length; i < len; i++){
                var touch = touches[i];
                var pos = (0, parcelRequire("65X4x")).clientToLocal(root, touch, {});
                trackItem.points.push([
                    pos.zrX,
                    pos.zrY
                ]);
                trackItem.touches.push(touch);
            }
            this._track.push(trackItem);
        };
        GestureMgr.prototype._recognize = function(event) {
            for(var eventName in $e8a28537c27906ba$var$recognizers)if ($e8a28537c27906ba$var$recognizers.hasOwnProperty(eventName)) {
                var gestureInfo = $e8a28537c27906ba$var$recognizers[eventName](this._track, event);
                if (gestureInfo) return gestureInfo;
            }
        };
        return GestureMgr;
    }();
    function $e8a28537c27906ba$var$dist(pointPair) {
        var dx = pointPair[1][0] - pointPair[0][0];
        var dy = pointPair[1][1] - pointPair[0][1];
        return Math.sqrt(dx * dx + dy * dy);
    }
    function $e8a28537c27906ba$var$center(pointPair) {
        return [
            (pointPair[0][0] + pointPair[1][0]) / 2,
            (pointPair[0][1] + pointPair[1][1]) / 2
        ];
    }
    var $e8a28537c27906ba$var$recognizers = {
        pinch: function(tracks, event) {
            var trackLen = tracks.length;
            if (!trackLen) return;
            var pinchEnd = (tracks[trackLen - 1] || {}).points;
            var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
            if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
                var pinchScale = $e8a28537c27906ba$var$dist(pinchEnd) / $e8a28537c27906ba$var$dist(pinchPre);
                !isFinite(pinchScale) && (pinchScale = 1);
                event.pinchScale = pinchScale;
                var pinchCenter = $e8a28537c27906ba$var$center(pinchEnd);
                event.pinchX = pinchCenter[0];
                event.pinchY = pinchCenter[1];
                return {
                    type: 'pinch',
                    target: tracks[0].target,
                    event: event
                };
            }
        }
    };
});
parcelRegister("66sfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4719378990e09024$export$2e2bcd8739ae039);
    var $bahqM;
    var $hZfwb;
    var $aVBu2;
    var $aVawM;
    var $4719378990e09024$var$invalidZErrorLogged = false;
    function $4719378990e09024$var$logInvalidZError() {
        if ($4719378990e09024$var$invalidZErrorLogged) return;
        $4719378990e09024$var$invalidZErrorLogged = true;
        console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
    }
    function $4719378990e09024$var$shapeCompareFunc(a, b) {
        if (a.zlevel === b.zlevel) {
            if (a.z === b.z) return a.z2 - b.z2;
            return a.z - b.z;
        }
        return a.zlevel - b.zlevel;
    }
    var $4719378990e09024$var$Storage = function() {
        function Storage() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            this.displayableSortFunc = $4719378990e09024$var$shapeCompareFunc;
        }
        Storage.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
        };
        Storage.prototype.getDisplayList = function(update, includeIgnore) {
            includeIgnore = includeIgnore || false;
            var displayList = this._displayList;
            if (update || !displayList.length) this.updateDisplayList(includeIgnore);
            return displayList;
        };
        Storage.prototype.updateDisplayList = function(includeIgnore) {
            this._displayListLen = 0;
            var roots = this._roots;
            var displayList = this._displayList;
            for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
            displayList.length = this._displayListLen;
            (0, (0, parcelRequire("hZfwb")).default).canvasSupported && (0, (0, parcelRequire("aVBu2")).default)(displayList, $4719378990e09024$var$shapeCompareFunc);
        };
        Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
            if (el.ignore && !includeIgnore) return;
            el.beforeUpdate();
            el.update();
            el.afterUpdate();
            var userSetClipPath = el.getClipPath();
            if (el.ignoreClip) clipPaths = null;
            else if (userSetClipPath) {
                if (clipPaths) clipPaths = clipPaths.slice();
                else clipPaths = [];
                var currentClipPath = userSetClipPath;
                var parentClipPath = el;
                while(currentClipPath){
                    currentClipPath.parent = parentClipPath;
                    currentClipPath.updateTransform();
                    clipPaths.push(currentClipPath);
                    parentClipPath = currentClipPath;
                    currentClipPath = currentClipPath.getClipPath();
                }
            }
            if (el.childrenRef) {
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (el.__dirty) child.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                    this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
                }
                el.__dirty = 0;
            } else {
                var disp = el;
                if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
                else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
                if (isNaN(disp.z)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z = 0;
                }
                if (isNaN(disp.z2)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z2 = 0;
                }
                if (isNaN(disp.zlevel)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.zlevel = 0;
                }
                this._displayList[this._displayListLen++] = disp;
            }
            var decalEl = el.getDecalElement && el.getDecalElement();
            if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
            var textGuide = el.getTextGuideLine();
            if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
            var textEl = el.getTextContent();
            if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
        };
        Storage.prototype.addRoot = function(el) {
            if (el.__zr && el.__zr.storage === this) return;
            this._roots.push(el);
        };
        Storage.prototype.delRoot = function(el) {
            if (el instanceof Array) {
                for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
                return;
            }
            var idx = (0, parcelRequire("bahqM")).indexOf(this._roots, el);
            if (idx >= 0) this._roots.splice(idx, 1);
        };
        Storage.prototype.delAllRoots = function() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            return;
        };
        Storage.prototype.getRoots = function() {
            return this._roots;
        };
        Storage.prototype.dispose = function() {
            this._displayList = null;
            this._roots = null;
        };
        return Storage;
    }();
    var $4719378990e09024$export$2e2bcd8739ae039 = $4719378990e09024$var$Storage;
});
parcelRegister("aVBu2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f4c4daf73fbe3de$export$2e2bcd8739ae039);
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE = 32;
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING = 7;
    var $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
    function $7f4c4daf73fbe3de$var$minRunLength(n) {
        var r = 0;
        while(n >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE){
            r |= n & 1;
            n >>= 1;
        }
        return n + r;
    }
    function $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare) {
        var runHi = lo + 1;
        if (runHi === hi) return 1;
        if (compare(array[runHi++], array[lo]) < 0) {
            while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
            $7f4c4daf73fbe3de$var$reverseRun(array, lo, runHi);
        } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
        return runHi - lo;
    }
    function $7f4c4daf73fbe3de$var$reverseRun(array, lo, hi) {
        hi--;
        while(lo < hi){
            var t = array[lo];
            array[lo++] = array[hi];
            array[hi--] = t;
        }
    }
    function $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, start, compare) {
        if (start === lo) start++;
        for(; start < hi; start++){
            var pivot = array[start];
            var left = lo;
            var right = start;
            var mid;
            while(left < right){
                mid = left + right >>> 1;
                if (compare(pivot, array[mid]) < 0) right = mid;
                else left = mid + 1;
            }
            var n = start - left;
            switch(n){
                case 3:
                    array[left + 3] = array[left + 2];
                case 2:
                    array[left + 2] = array[left + 1];
                case 1:
                    array[left + 1] = array[left];
                    break;
                default:
                    while(n > 0){
                        array[left + n] = array[left + n - 1];
                        n--;
                    }
            }
            array[left] = pivot;
        }
    }
    function $7f4c4daf73fbe3de$var$gallopLeft(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) > 0) {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        } else {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
            else offset = m;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$gallopRight(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) < 0) {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        } else {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) < 0) offset = m;
            else lastOffset = m + 1;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$TimSort(array, compare) {
        var minGallop = $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING;
        var length = 0;
        var tmpStorageLength = $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH;
        var stackLength = 0;
        var runStart;
        var runLength;
        var stackSize = 0;
        length = array.length;
        if (length < 2 * $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
        var tmp = [];
        stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
        runStart = [];
        runLength = [];
        function pushRun(_runStart, _runLength) {
            runStart[stackSize] = _runStart;
            runLength[stackSize] = _runLength;
            stackSize += 1;
        }
        function mergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                    if (runLength[n - 1] < runLength[n + 1]) n--;
                } else if (runLength[n] > runLength[n + 1]) break;
                mergeAt(n);
            }
        }
        function forceMergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
                mergeAt(n);
            }
        }
        function mergeAt(i) {
            var start1 = runStart[i];
            var length1 = runLength[i];
            var start2 = runStart[i + 1];
            var length2 = runLength[i + 1];
            runLength[i] = length1 + length2;
            if (i === stackSize - 3) {
                runStart[i + 1] = runStart[i + 2];
                runLength[i + 1] = runLength[i + 2];
            }
            stackSize--;
            var k = $7f4c4daf73fbe3de$var$gallopRight(array[start2], array, start1, length1, 0, compare);
            start1 += k;
            length1 -= k;
            if (length1 === 0) return;
            length2 = $7f4c4daf73fbe3de$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
            if (length2 === 0) return;
            if (length1 <= length2) mergeLow(start1, length1, start2, length2);
            else mergeHigh(start1, length1, start2, length2);
        }
        function mergeLow(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
            var cursor1 = 0;
            var cursor2 = start2;
            var dest = start1;
            array[dest++] = array[cursor2++];
            if (--length2 === 0) {
                for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
                return;
            }
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
                return;
            }
            var _minGallop = minGallop;
            var count1;
            var count2;
            var exit;
            while(true){
                count1 = 0;
                count2 = 0;
                exit = false;
                do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                    array[dest++] = array[cursor2++];
                    count2++;
                    count1 = 0;
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest++] = tmp[cursor1++];
                    count1++;
                    count2 = 0;
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = $7f4c4daf73fbe3de$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                    if (count1 !== 0) {
                        for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                        dest += count1;
                        cursor1 += count1;
                        length1 -= count1;
                        if (length1 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = array[cursor2++];
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                    count2 = $7f4c4daf73fbe3de$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                    if (count2 !== 0) {
                        for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                        dest += count2;
                        cursor2 += count2;
                        length2 -= count2;
                        if (length2 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = tmp[cursor1++];
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            minGallop < 1 && (minGallop = 1);
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
            } else if (length1 === 0) throw new Error();
            else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
        }
        function mergeHigh(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
            var cursor1 = start1 + length1 - 1;
            var cursor2 = length2 - 1;
            var dest = start2 + length2 - 1;
            var customCursor = 0;
            var customDest = 0;
            array[dest--] = array[cursor1--];
            if (--length1 === 0) {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
                return;
            }
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
                return;
            }
            var _minGallop = minGallop;
            while(true){
                var count1 = 0;
                var count2 = 0;
                var exit = false;
                do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                    array[dest--] = array[cursor1--];
                    count1++;
                    count2 = 0;
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest--] = tmp[cursor2--];
                    count2++;
                    count1 = 0;
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = length1 - $7f4c4daf73fbe3de$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                    if (count1 !== 0) {
                        dest -= count1;
                        cursor1 -= count1;
                        length1 -= count1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;
                        for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                        if (length1 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = tmp[cursor2--];
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                    count2 = length2 - $7f4c4daf73fbe3de$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                    if (count2 !== 0) {
                        dest -= count2;
                        cursor2 -= count2;
                        length2 -= count2;
                        customDest = dest + 1;
                        customCursor = cursor2 + 1;
                        for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                        if (length2 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = array[cursor1--];
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            if (minGallop < 1) minGallop = 1;
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
            } else if (length2 === 0) throw new Error();
            else {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            }
        }
        return {
            mergeRuns: mergeRuns,
            forceMergeRuns: forceMergeRuns,
            pushRun: pushRun
        };
    }
    function $7f4c4daf73fbe3de$export$2e2bcd8739ae039(array, compare, lo, hi) {
        if (!lo) lo = 0;
        if (!hi) hi = array.length;
        var remaining = hi - lo;
        if (remaining < 2) return;
        var runLength = 0;
        if (remaining < $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE) {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
            return;
        }
        var ts = $7f4c4daf73fbe3de$var$TimSort(array, compare);
        var minRun = $7f4c4daf73fbe3de$var$minRunLength(remaining);
        do {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            if (runLength < minRun) {
                var force = remaining;
                if (force > minRun) force = minRun;
                $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
                runLength = force;
            }
            ts.pushRun(lo, runLength);
            ts.mergeRuns();
            remaining -= runLength;
            lo += runLength;
        }while (remaining !== 0)
        ts.forceMergeRuns();
    }
});
parcelRegister("F44Dl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b6fd689a4caf84$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bRKv5;
    var $04xko;
    var $hb2y5;
    var $07b6fd689a4caf84$var$Animation = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Animation, _super);
        function Animation(opts) {
            var _this = _super.call(this) || this;
            _this._running = false;
            _this._time = 0;
            _this._pausedTime = 0;
            _this._pauseStart = 0;
            _this._paused = false;
            opts = opts || {};
            _this.stage = opts.stage || {};
            _this.onframe = opts.onframe || function() {};
            return _this;
        }
        Animation.prototype.addClip = function(clip) {
            if (clip.animation) this.removeClip(clip);
            if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
            else {
                this._clipsTail.next = clip;
                clip.prev = this._clipsTail;
                clip.next = null;
                this._clipsTail = clip;
            }
            clip.animation = this;
        };
        Animation.prototype.addAnimator = function(animator) {
            animator.animation = this;
            var clip = animator.getClip();
            if (clip) this.addClip(clip);
        };
        Animation.prototype.removeClip = function(clip) {
            if (!clip.animation) return;
            var prev = clip.prev;
            var next = clip.next;
            if (prev) prev.next = next;
            else this._clipsHead = next;
            if (next) next.prev = prev;
            else this._clipsTail = prev;
            clip.next = clip.prev = clip.animation = null;
        };
        Animation.prototype.removeAnimator = function(animator) {
            var clip = animator.getClip();
            if (clip) this.removeClip(clip);
            animator.animation = null;
        };
        Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
            var time = new Date().getTime() - this._pausedTime;
            var delta = time - this._time;
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                var finished = clip.step(time, delta);
                if (finished) {
                    clip.ondestroy && clip.ondestroy();
                    this.removeClip(clip);
                    clip = nextClip;
                } else clip = nextClip;
            }
            this._time = time;
            if (!notTriggerFrameAndStageUpdate) {
                this.onframe(delta);
                this.trigger('frame', delta);
                this.stage.update && this.stage.update();
            }
        };
        Animation.prototype._startLoop = function() {
            var self = this;
            this._running = true;
            function step() {
                if (self._running) {
                    (0, (0, parcelRequire("04xko")).default)(step);
                    !self._paused && self.update();
                }
            }
            (0, (0, parcelRequire("04xko")).default)(step);
        };
        Animation.prototype.start = function() {
            if (this._running) return;
            this._time = new Date().getTime();
            this._pausedTime = 0;
            this._startLoop();
        };
        Animation.prototype.stop = function() {
            this._running = false;
        };
        Animation.prototype.pause = function() {
            if (!this._paused) {
                this._pauseStart = new Date().getTime();
                this._paused = true;
            }
        };
        Animation.prototype.resume = function() {
            if (this._paused) {
                this._pausedTime += new Date().getTime() - this._pauseStart;
                this._paused = false;
            }
        };
        Animation.prototype.clear = function() {
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                clip.prev = clip.next = clip.animation = null;
                clip = nextClip;
            }
            this._clipsHead = this._clipsTail = null;
        };
        Animation.prototype.isFinished = function() {
            return this._clipsHead == null;
        };
        Animation.prototype.animate = function(target, options) {
            options = options || {};
            this.start();
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, options.loop);
            this.addAnimator(animator);
            return animator;
        };
        return Animation;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $07b6fd689a4caf84$export$2e2bcd8739ae039 = $07b6fd689a4caf84$var$Animation;
});
parcelRegister("04xko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00da3a149d316342$export$2e2bcd8739ae039);
    var $00da3a149d316342$var$requestAnimationFrame;
    $00da3a149d316342$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
        return setTimeout(func, 16);
    };
    var $00da3a149d316342$export$2e2bcd8739ae039 = $00da3a149d316342$var$requestAnimationFrame;
});
parcelRegister("bHSYT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$885e5bfc09439923$export$2e2bcd8739ae039);
    var $3VFsf;
    var $65X4x;
    var $bahqM;
    var $bRKv5;
    var $hZfwb;
    var $885e5bfc09439923$var$TOUCH_CLICK_DELAY = 300;
    var $885e5bfc09439923$var$globalEventSupported = (0, (0, parcelRequire("hZfwb")).default).domSupported;
    var $885e5bfc09439923$var$localNativeListenerNames = function() {
        var mouseHandlerNames = [
            'click',
            'dblclick',
            'mousewheel',
            'wheel',
            'mouseout',
            'mouseup',
            'mousedown',
            'mousemove',
            'contextmenu'
        ];
        var touchHandlerNames = [
            'touchstart',
            'touchend',
            'touchmove'
        ];
        var pointerEventNameMap = {
            pointerdown: 1,
            pointerup: 1,
            pointermove: 1,
            pointerout: 1
        };
        var pointerHandlerNames = (0, parcelRequire("bahqM")).map(mouseHandlerNames, function(name) {
            var nm = name.replace('mouse', 'pointer');
            return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
        });
        return {
            mouse: mouseHandlerNames,
            touch: touchHandlerNames,
            pointer: pointerHandlerNames
        };
    }();
    var $885e5bfc09439923$var$globalNativeListenerNames = {
        mouse: [
            'mousemove',
            'mouseup'
        ],
        pointer: [
            'pointermove',
            'pointerup'
        ]
    };
    var $885e5bfc09439923$var$wheelEventSupported = false;
    function $885e5bfc09439923$var$isPointerFromTouch(event) {
        var pointerType = event.pointerType;
        return pointerType === 'pen' || pointerType === 'touch';
    }
    function $885e5bfc09439923$var$setTouchTimer(scope) {
        scope.touching = true;
        if (scope.touchTimer != null) {
            clearTimeout(scope.touchTimer);
            scope.touchTimer = null;
        }
        scope.touchTimer = setTimeout(function() {
            scope.touching = false;
            scope.touchTimer = null;
        }, 700);
    }
    function $885e5bfc09439923$var$markTouch(event) {
        event && (event.zrByTouch = true);
    }
    function $885e5bfc09439923$var$normalizeGlobalEvent(instance, event) {
        return (0, (0, parcelRequire("65X4x")).normalizeEvent)(instance.dom, new $885e5bfc09439923$var$FakeGlobalEvent(instance, event), true);
    }
    function $885e5bfc09439923$var$isLocalEl(instance, el) {
        var elTmp = el;
        var isLocal = false;
        while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
        return isLocal;
    }
    var $885e5bfc09439923$var$FakeGlobalEvent = function() {
        function FakeGlobalEvent(instance, event) {
            this.stopPropagation = (0, parcelRequire("bahqM")).noop;
            this.stopImmediatePropagation = (0, parcelRequire("bahqM")).noop;
            this.preventDefault = (0, parcelRequire("bahqM")).noop;
            this.type = event.type;
            this.target = this.currentTarget = instance.dom;
            this.pointerType = event.pointerType;
            this.clientX = event.clientX;
            this.clientY = event.clientY;
        }
        return FakeGlobalEvent;
    }();
    var $885e5bfc09439923$var$localDOMHandlers = {
        mousedown: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__mayPointerCapture = [
                event.zrX,
                event.zrY
            ];
            this.trigger('mousedown', event);
        },
        mousemove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var downPoint = this.__mayPointerCapture;
            if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
        },
        mouseout: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var element = event.toElement || event.relatedTarget;
            if (!$885e5bfc09439923$var$isLocalEl(this, element)) {
                if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
                this.trigger('mouseout', event);
            }
        },
        wheel: function(event) {
            $885e5bfc09439923$var$wheelEventSupported = true;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        mousewheel: function(event) {
            if ($885e5bfc09439923$var$wheelEventSupported) return;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        touchstart: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.__lastTouchMoment = new Date();
            this.handler.processGesture(event, 'start');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        touchmove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'change');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        touchend: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'end');
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
            if (+new Date() - +this.__lastTouchMoment < $885e5bfc09439923$var$TOUCH_CLICK_DELAY) $885e5bfc09439923$var$localDOMHandlers.click.call(this, event);
        },
        pointerdown: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
        },
        pointerout: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mouseout.call(this, event);
        }
    };
    (0, parcelRequire("bahqM")).each([
        'click',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $885e5bfc09439923$var$localDOMHandlers[name] = function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger(name, event);
        };
    });
    var $885e5bfc09439923$var$globalDOMHandlers = {
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$globalDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$globalDOMHandlers.mouseup.call(this, event);
        },
        mousemove: function(event) {
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            var pointerCaptureReleasing = this.__pointerCapturing;
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
            if (pointerCaptureReleasing) {
                event.zrEventControl = 'only_globalout';
                this.trigger('mouseout', event);
            }
        }
    };
    function $885e5bfc09439923$var$mountLocalDOMEventListeners(instance, scope) {
        var domHandlers = scope.domHandlers;
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.pointer, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
            });
        });
        else {
            if ((0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.touch, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    domHandlers[nativeEventName].call(instance, event);
                    $885e5bfc09439923$var$setTouchTimer(scope);
                });
            });
            (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.mouse, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                    if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
                });
            });
        }
    }
    function $885e5bfc09439923$var$mountGlobalDOMEventListeners(instance, scope) {
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.pointer, mount);
        else if (!(0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.mouse, mount);
        function mount(nativeEventName) {
            function nativeEventListener(event) {
                event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                if (!$885e5bfc09439923$var$isLocalEl(instance, event.target)) {
                    event = $885e5bfc09439923$var$normalizeGlobalEvent(instance, event);
                    scope.domHandlers[nativeEventName].call(instance, event);
                }
            }
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
                capture: true
            });
        }
    }
    function $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
        scope.mounted[nativeEventName] = listener;
        scope.listenerOpts[nativeEventName] = opt;
        (0, (0, parcelRequire("65X4x")).addEventListener)(scope.domTarget, nativeEventName, listener, opt);
    }
    function $885e5bfc09439923$var$unmountDOMEventListeners(scope) {
        var mounted = scope.mounted;
        for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, (0, parcelRequire("65X4x")).removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
        scope.mounted = {};
    }
    var $885e5bfc09439923$var$DOMHandlerScope = function() {
        function DOMHandlerScope(domTarget, domHandlers) {
            this.mounted = {};
            this.listenerOpts = {};
            this.touching = false;
            this.domTarget = domTarget;
            this.domHandlers = domHandlers;
        }
        return DOMHandlerScope;
    }();
    var $885e5bfc09439923$var$HandlerDomProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HandlerDomProxy, _super);
        function HandlerDomProxy(dom, painterRoot) {
            var _this = _super.call(this) || this;
            _this.__pointerCapturing = false;
            _this.dom = dom;
            _this.painterRoot = painterRoot;
            _this._localHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(dom, $885e5bfc09439923$var$localDOMHandlers);
            if ($885e5bfc09439923$var$globalEventSupported) _this._globalHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(document, $885e5bfc09439923$var$globalDOMHandlers);
            $885e5bfc09439923$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
            return _this;
        }
        HandlerDomProxy.prototype.dispose = function() {
            $885e5bfc09439923$var$unmountDOMEventListeners(this._localHandlerScope);
            if ($885e5bfc09439923$var$globalEventSupported) $885e5bfc09439923$var$unmountDOMEventListeners(this._globalHandlerScope);
        };
        HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
            this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
        };
        HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
            this.__mayPointerCapture = null;
            if ($885e5bfc09439923$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
                this.__pointerCapturing = isPointerCapturing;
                var globalHandlerScope = this._globalHandlerScope;
                isPointerCapturing ? $885e5bfc09439923$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $885e5bfc09439923$var$unmountDOMEventListeners(globalHandlerScope);
            }
        };
        return HandlerDomProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $885e5bfc09439923$export$2e2bcd8739ae039 = $885e5bfc09439923$var$HandlerDomProxy;
});
parcelRegister("74g78", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$525568051e570380$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eaKsF;
    var $gaMkj;
    var $h4UlH;
    var $34Vzq;
    var $cNGs8;
    var $iSVvO;
    var $aCu4v;
    var $2cFRc;
    var $525568051e570380$var$reCreateSeriesIndices;
    var $525568051e570380$var$assertSeriesInitialized;
    var $525568051e570380$var$initBase;
    var $525568051e570380$var$OPTION_INNER_KEY = '\0_ec_inner';
    var $525568051e570380$var$OPTION_INNER_VALUE = 1;
    var $525568051e570380$var$BUITIN_COMPONENTS_MAP = {
        grid: 'GridComponent',
        polar: 'PolarComponent',
        geo: 'GeoComponent',
        singleAxis: 'SingleAxisComponent',
        parallel: 'ParallelComponent',
        calendar: 'CalendarComponent',
        graphic: 'GraphicComponent',
        toolbox: 'ToolboxComponent',
        tooltip: 'TooltipComponent',
        axisPointer: 'AxisPointerComponent',
        brush: 'BrushComponent',
        title: 'TitleComponent',
        timeline: 'TimelineComponent',
        markPoint: 'MarkPointComponent',
        markLine: 'MarkLineComponent',
        markArea: 'MarkAreaComponent',
        legend: 'LegendComponent',
        dataZoom: 'DataZoomComponent',
        visualMap: 'VisualMapComponent',
        xAxis: 'GridComponent',
        yAxis: 'GridComponent',
        angleAxis: 'PolarComponent',
        radiusAxis: 'PolarComponent'
    };
    var $525568051e570380$var$BUILTIN_CHARTS_MAP = {
        line: 'LineChart',
        bar: 'BarChart',
        pie: 'PieChart',
        scatter: 'ScatterChart',
        radar: 'RadarChart',
        map: 'MapChart',
        tree: 'TreeChart',
        treemap: 'TreemapChart',
        graph: 'GraphChart',
        gauge: 'GaugeChart',
        funnel: 'FunnelChart',
        parallel: 'ParallelChart',
        sankey: 'SankeyChart',
        boxplot: 'BoxplotChart',
        candlestick: 'CandlestickChart',
        effectScatter: 'EffectScatterChart',
        lines: 'LinesChart',
        heatmap: 'HeatmapChart',
        pictorialBar: 'PictorialBarChart',
        themeRiver: 'ThemeRiverChart',
        sunburst: 'SunburstChart',
        custom: 'CustomChart'
    };
    var $525568051e570380$var$componetsMissingLogPrinted = {};
    function $525568051e570380$var$checkMissingComponents(option) {
        (0, (0, parcelRequire("bahqM")).each)(option, function(componentOption, mainType) {
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                var componentImportName = $525568051e570380$var$BUITIN_COMPONENTS_MAP[mainType];
                if (componentImportName && !$525568051e570380$var$componetsMissingLogPrinted[componentImportName]) {
                    (0, (0, parcelRequire("2cFRc")).error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                    $525568051e570380$var$componetsMissingLogPrinted[componentImportName] = true;
                }
            }
        });
    }
    var $525568051e570380$var$GlobalModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GlobalModel, _super);
        function GlobalModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
            theme = theme || {};
            this.option = null;
            this._theme = new (0, (0, parcelRequire("gaMkj")).default)(theme);
            this._locale = new (0, (0, parcelRequire("gaMkj")).default)(locale);
            this._optionManager = optionManager;
        };
        GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
            var innerOpt = $525568051e570380$var$normalizeSetOptionInput(opts);
            this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
            this._resetOption(null, innerOpt);
        };
        GlobalModel.prototype.resetOption = function(type, opt) {
            return this._resetOption(type, $525568051e570380$var$normalizeSetOptionInput(opt));
        };
        GlobalModel.prototype._resetOption = function(type, opt) {
            var optionChanged = false;
            var optionManager = this._optionManager;
            if (!type || type === 'recreate') {
                var baseOption = optionManager.mountOption(type === 'recreate');
                if (!this.option || type === 'recreate') $525568051e570380$var$initBase(this, baseOption);
                else {
                    this.restoreData();
                    this._mergeOption(baseOption, opt);
                }
                optionChanged = true;
            }
            if (type === 'timeline' || type === 'media') this.restoreData();
            if (!type || type === 'recreate' || type === 'timeline') {
                var timelineOption = optionManager.getTimelineOption(this);
                if (timelineOption) {
                    optionChanged = true;
                    this._mergeOption(timelineOption, opt);
                }
            }
            if (!type || type === 'recreate' || type === 'media') {
                var mediaOptions = optionManager.getMediaOption(this);
                if (mediaOptions.length) (0, (0, parcelRequire("bahqM")).each)(mediaOptions, function(mediaOption) {
                    optionChanged = true;
                    this._mergeOption(mediaOption, opt);
                }, this);
            }
            return optionChanged;
        };
        GlobalModel.prototype.mergeOption = function(option) {
            this._mergeOption(option, null);
        };
        GlobalModel.prototype._mergeOption = function(newOption, opt) {
            var option = this.option;
            var componentsMap = this._componentsMap;
            var componentsCount = this._componentsCount;
            var newCmptTypes = [];
            var newCmptTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
            (0, (0, parcelRequire("cNGs8")).resetSourceDefaulter)(this);
            (0, (0, parcelRequire("bahqM")).each)(newOption, function(componentOption, mainType) {
                if (componentOption == null) return;
                if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) option[mainType] = option[mainType] == null ? (0, (0, parcelRequire("bahqM")).clone)(componentOption) : (0, (0, parcelRequire("bahqM")).merge)(option[mainType], componentOption, true);
                else if (mainType) {
                    newCmptTypes.push(mainType);
                    newCmptTypeMap.set(mainType, true);
                }
            });
            if (replaceMergeMainTypeMap) replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                    newCmptTypes.push(mainTypeInReplaceMerge);
                    newCmptTypeMap.set(mainTypeInReplaceMerge, true);
                }
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(newCmptTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), visitComponent, this);
            function visitComponent(mainType) {
                var newCmptOptionList = (0, (0, parcelRequire("iSVvO")).concatInternalOptions)(this, mainType, (0, parcelRequire("eaKsF")).normalizeToArray(newOption[mainType]));
                var oldCmptList = componentsMap.get(mainType);
                var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
                var mappingResult = (0, parcelRequire("eaKsF")).mappingToExists(oldCmptList, newCmptOptionList, mergeMode);
                (0, parcelRequire("eaKsF")).setComponentTypeToKeyInfo(mappingResult, mainType, (0, (0, parcelRequire("h4UlH")).default));
                option[mainType] = null;
                componentsMap.set(mainType, null);
                componentsCount.set(mainType, 0);
                var optionsByMainType = [];
                var cmptsByMainType = [];
                var cmptsCountByMainType = 0;
                (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(resultItem, index) {
                    var componentModel = resultItem.existing;
                    var newCmptOption = resultItem.newOption;
                    if (!newCmptOption) {
                        if (componentModel) {
                            componentModel.mergeOption({}, this);
                            componentModel.optionUpdated({}, false);
                        }
                    } else {
                        var isSeriesType = mainType === 'series';
                        var ComponentModelClass = (0, (0, parcelRequire("h4UlH")).default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType);
                        if (!ComponentModelClass) {
                            var subType, seriesImportName;
                            return;
                        }
                        if (componentModel && componentModel.constructor === ComponentModelClass) {
                            componentModel.name = resultItem.keyInfo.name;
                            componentModel.mergeOption(newCmptOption, this);
                            componentModel.optionUpdated(newCmptOption, false);
                        } else {
                            var extraOpt = (0, (0, parcelRequire("bahqM")).extend)({
                                componentIndex: index
                            }, resultItem.keyInfo);
                            componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                            (0, (0, parcelRequire("bahqM")).extend)(componentModel, extraOpt);
                            if (resultItem.brandNew) componentModel.__requireNewView = true;
                            componentModel.init(newCmptOption, this, this);
                            componentModel.optionUpdated(null, true);
                        }
                    }
                    if (componentModel) {
                        optionsByMainType.push(componentModel.option);
                        cmptsByMainType.push(componentModel);
                        cmptsCountByMainType++;
                    } else {
                        optionsByMainType.push(void 0);
                        cmptsByMainType.push(void 0);
                    }
                }, this);
                option[mainType] = optionsByMainType;
                componentsMap.set(mainType, cmptsByMainType);
                componentsCount.set(mainType, cmptsCountByMainType);
                if (mainType === 'series') $525568051e570380$var$reCreateSeriesIndices(this);
            }
            if (!this._seriesIndices) $525568051e570380$var$reCreateSeriesIndices(this);
        };
        GlobalModel.prototype.getOption = function() {
            var option = (0, (0, parcelRequire("bahqM")).clone)(this.option);
            (0, (0, parcelRequire("bahqM")).each)(option, function(optInMainType, mainType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                    var opts = (0, parcelRequire("eaKsF")).normalizeToArray(optInMainType);
                    var realLen = opts.length;
                    var metNonInner = false;
                    for(var i = realLen - 1; i >= 0; i--)if (opts[i] && !(0, parcelRequire("eaKsF")).isComponentIdInternal(opts[i])) metNonInner = true;
                    else {
                        opts[i] = null;
                        !metNonInner && realLen--;
                    }
                    opts.length = realLen;
                    option[mainType] = opts;
                }
            });
            delete option[$525568051e570380$var$OPTION_INNER_KEY];
            return option;
        };
        GlobalModel.prototype.getTheme = function() {
            return this._theme;
        };
        GlobalModel.prototype.getLocaleModel = function() {
            return this._locale;
        };
        GlobalModel.prototype.setUpdatePayload = function(payload) {
            this._payload = payload;
        };
        GlobalModel.prototype.getUpdatePayload = function() {
            return this._payload;
        };
        GlobalModel.prototype.getComponent = function(mainType, idx) {
            var list = this._componentsMap.get(mainType);
            if (list) {
                var cmpt = list[idx || 0];
                if (cmpt) return cmpt;
                else if (idx == null) for(var i = 0; i < list.length; i++){
                    if (list[i]) return list[i];
                }
            }
        };
        GlobalModel.prototype.queryComponents = function(condition) {
            var mainType = condition.mainType;
            if (!mainType) return [];
            var index = condition.index;
            var id = condition.id;
            var name = condition.name;
            var cmpts = this._componentsMap.get(mainType);
            if (!cmpts || !cmpts.length) return [];
            var result;
            if (index != null) {
                result = [];
                (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(index), function(idx) {
                    cmpts[idx] && result.push(cmpts[idx]);
                });
            } else if (id != null) result = $525568051e570380$var$queryByIdOrName('id', id, cmpts);
            else if (name != null) result = $525568051e570380$var$queryByIdOrName('name', name, cmpts);
            else result = (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return !!cmpt;
            });
            return $525568051e570380$var$filterBySubType(result, condition);
        };
        GlobalModel.prototype.findComponents = function(condition) {
            var query = condition.query;
            var mainType = condition.mainType;
            var queryCond = getQueryCond(query);
            var result = queryCond ? this.queryComponents(queryCond) : (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get(mainType), function(cmpt) {
                return !!cmpt;
            });
            return doFilter($525568051e570380$var$filterBySubType(result, condition));
            function getQueryCond(q) {
                var indexAttr = mainType + 'Index';
                var idAttr = mainType + 'Id';
                var nameAttr = mainType + 'Name';
                return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                    mainType: mainType,
                    index: q[indexAttr],
                    id: q[idAttr],
                    name: q[nameAttr]
                } : null;
            }
            function doFilter(res) {
                return condition.filter ? (0, (0, parcelRequire("bahqM")).filter)(res, condition.filter) : res;
            }
        };
        GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
            var componentsMap = this._componentsMap;
            if ((0, (0, parcelRequire("bahqM")).isFunction)(mainType)) {
                var ctxForAll_1 = cb;
                var cbForAll_1 = mainType;
                componentsMap.each(function(cmpts, componentType) {
                    for(var i = 0; cmpts && i < cmpts.length; i++){
                        var cmpt = cmpts[i];
                        cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                    }
                });
            } else {
                var cmpts = (0, (0, parcelRequire("bahqM")).isString)(mainType) ? componentsMap.get(mainType) : (0, (0, parcelRequire("bahqM")).isObject)(mainType) ? this.findComponents(mainType) : null;
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cb.call(context, cmpt, cmpt.componentIndex);
                }
            }
        };
        GlobalModel.prototype.getSeriesByName = function(name) {
            var nameStr = (0, parcelRequire("eaKsF")).convertOptionIdName(name, null);
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
            });
        };
        GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
            return this._componentsMap.get('series')[seriesIndex];
        };
        GlobalModel.prototype.getSeriesByType = function(subType) {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && oneSeries.subType === subType;
            });
        };
        GlobalModel.prototype.getSeries = function() {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries;
            });
        };
        GlobalModel.prototype.getSeriesCount = function() {
            return this._componentsCount.get('series');
        };
        GlobalModel.prototype.eachSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeries = function(cb, context) {
            (0, (0, parcelRequire("bahqM")).each)(this._componentsMap.get('series'), function(series) {
                series && cb.call(context, series, series.componentIndex);
            });
        };
        GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
            return (0, (0, parcelRequire("bahqM")).each)(this.getSeriesByType(subType), cb, context);
        };
        GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
            $525568051e570380$var$assertSeriesInitialized(this);
            return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
        };
        GlobalModel.prototype.getCurrentSeriesIndices = function() {
            return (this._seriesIndices || []).slice();
        };
        GlobalModel.prototype.filterSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            var newSeriesIndices = [];
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(seriesRawIdx) {
                var series = this._componentsMap.get('series')[seriesRawIdx];
                cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
            }, this);
            this._seriesIndices = newSeriesIndices;
            this._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(newSeriesIndices);
        };
        GlobalModel.prototype.restoreData = function(payload) {
            $525568051e570380$var$reCreateSeriesIndices(this);
            var componentsMap = this._componentsMap;
            var componentTypes = [];
            componentsMap.each(function(components, componentType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(componentType)) componentTypes.push(componentType);
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(componentTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), function(componentType) {
                (0, (0, parcelRequire("bahqM")).each)(componentsMap.get(componentType), function(component) {
                    if (component && (componentType !== 'series' || !$525568051e570380$var$isNotTargetSeries(component, payload))) component.restoreData();
                });
            });
        };
        GlobalModel.internalField = function() {
            $525568051e570380$var$reCreateSeriesIndices = function(ecModel) {
                var seriesIndices = ecModel._seriesIndices = [];
                (0, (0, parcelRequire("bahqM")).each)(ecModel._componentsMap.get('series'), function(series) {
                    series && seriesIndices.push(series.componentIndex);
                });
                ecModel._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(seriesIndices);
            };
            $525568051e570380$var$assertSeriesInitialized = function(ecModel) {};
            $525568051e570380$var$initBase = function(ecModel, baseOption) {
                ecModel.option = {};
                ecModel.option[$525568051e570380$var$OPTION_INNER_KEY] = $525568051e570380$var$OPTION_INNER_VALUE;
                ecModel._componentsMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
                    series: []
                });
                ecModel._componentsCount = (0, (0, parcelRequire("bahqM")).createHashMap)();
                var airaOption = baseOption.aria;
                if ((0, (0, parcelRequire("bahqM")).isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
                $525568051e570380$var$mergeTheme(baseOption, ecModel._theme.option);
                (0, (0, parcelRequire("bahqM")).merge)(baseOption, (0, (0, parcelRequire("34Vzq")).default), false);
                ecModel._mergeOption(baseOption, null);
            };
        }();
        return GlobalModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    function $525568051e570380$var$isNotTargetSeries(seriesModel, payload) {
        if (payload) {
            var index = payload.seriesIndex;
            var id = payload.seriesId;
            var name_1 = payload.seriesName;
            return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
        }
    }
    function $525568051e570380$var$mergeTheme(option, theme) {
        var notMergeColorLayer = option.color && !option.colorLayer;
        (0, (0, parcelRequire("bahqM")).each)(theme, function(themeItem, name) {
            if (name === 'colorLayer' && notMergeColorLayer) return;
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(name)) {
                if (typeof themeItem === 'object') option[name] = !option[name] ? (0, (0, parcelRequire("bahqM")).clone)(themeItem) : (0, (0, parcelRequire("bahqM")).merge)(option[name], themeItem, false);
                else if (option[name] == null) option[name] = themeItem;
            }
        });
    }
    function $525568051e570380$var$queryByIdOrName(attr, idOrName, cmpts) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(idOrName)) {
            var keyMap_1 = (0, (0, parcelRequire("bahqM")).createHashMap)();
            (0, (0, parcelRequire("bahqM")).each)(idOrName, function(idOrNameItem) {
                if (idOrNameItem != null) {
                    var idName = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrNameItem, null);
                    idName != null && keyMap_1.set(idOrNameItem, true);
                }
            });
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && keyMap_1.get(cmpt[attr]);
            });
        } else {
            var idName_1 = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrName, null);
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && idName_1 != null && cmpt[attr] === idName_1;
            });
        }
    }
    function $525568051e570380$var$filterBySubType(components, condition) {
        return condition.hasOwnProperty('subType') ? (0, (0, parcelRequire("bahqM")).filter)(components, function(cmpt) {
            return cmpt && cmpt.subType === condition.subType;
        }) : components;
    }
    function $525568051e570380$var$normalizeSetOptionInput(opts) {
        var replaceMergeMainTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        opts && (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(opts.replaceMerge), function(mainType) {
            replaceMergeMainTypeMap.set(mainType, true);
        });
        return {
            replaceMergeMainTypeMap: replaceMergeMainTypeMap
        };
    }
    (0, (0, parcelRequire("bahqM")).mixin)($525568051e570380$var$GlobalModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    var $525568051e570380$export$2e2bcd8739ae039 = $525568051e570380$var$GlobalModel;
});
parcelRegister("34Vzq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23de6718d94f8f53$export$2e2bcd8739ae039);
    var $23de6718d94f8f53$var$platform = '';
    if (typeof navigator !== 'undefined') $23de6718d94f8f53$var$platform = navigator.platform || '';
    var $23de6718d94f8f53$var$decalColor = 'rgba(0, 0, 0, 0.2)';
    var $23de6718d94f8f53$export$2e2bcd8739ae039 = {
        darkMode: 'auto',
        colorBy: 'series',
        color: [
            '#5470c6',
            '#91cc75',
            '#fac858',
            '#ee6666',
            '#73c0de',
            '#3ba272',
            '#fc8452',
            '#9a60b4',
            '#ea7ccc'
        ],
        gradientColor: [
            '#f6efa6',
            '#d88273',
            '#bf444c'
        ],
        aria: {
            decal: {
                decals: [
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            2,
                            5
                        ],
                        symbolSize: 1,
                        rotation: Math.PI / 6
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'circle',
                        dashArrayX: [
                            [
                                8,
                                8
                            ],
                            [
                                0,
                                8,
                                8,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ],
                        symbolSize: 0.8
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            4,
                            3
                        ],
                        rotation: -Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                6,
                                6
                            ],
                            [
                                0,
                                6,
                                6,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ]
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                1,
                                0
                            ],
                            [
                                1,
                                6
                            ]
                        ],
                        dashArrayY: [
                            1,
                            0,
                            6,
                            0
                        ],
                        rotation: Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'triangle',
                        dashArrayX: [
                            [
                                9,
                                9
                            ],
                            [
                                0,
                                9,
                                9,
                                0
                            ]
                        ],
                        dashArrayY: [
                            7,
                            2
                        ],
                        symbolSize: 0.75
                    }
                ]
            }
        },
        textStyle: {
            fontFamily: $23de6718d94f8f53$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 'normal'
        },
        blendMode: null,
        stateAnimation: {
            duration: 300,
            easing: 'cubicOut'
        },
        animation: 'auto',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut',
        animationEasingUpdate: 'cubicInOut',
        animationThreshold: 2000,
        progressiveThreshold: 3000,
        progressive: 400,
        hoverLayerThreshold: 3000,
        useUTC: false
    };
});
parcelRegister("iSVvO", function(module, exports) {
    $parcel$export(module.exports, "registerInternalOptionCreator", ()=>$dbf9e1d336044ced$export$5a90be4668898d38);
    $parcel$export(module.exports, "concatInternalOptions", ()=>$dbf9e1d336044ced$export$c713a6a3b43f401d);
    var $bahqM;
    var $dbf9e1d336044ced$var$internalOptionCreatorMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $dbf9e1d336044ced$export$5a90be4668898d38(mainType, creator) {
        (0, (0, parcelRequire("bahqM")).assert)($dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType) == null && creator);
        $dbf9e1d336044ced$var$internalOptionCreatorMap.set(mainType, creator);
    }
    function $dbf9e1d336044ced$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
        var internalOptionCreator = $dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType);
        if (!internalOptionCreator) return newCmptOptionList;
        var internalOptions = internalOptionCreator(ecModel);
        if (!internalOptions) return newCmptOptionList;
        var i;
        return newCmptOptionList.concat(internalOptions);
    }
});
parcelRegister("iEvqc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9445617d131115d$export$2e2bcd8739ae039);
    var $bahqM;
    var $d9445617d131115d$var$availableMethods = [
        'getDom',
        'getZr',
        'getWidth',
        'getHeight',
        'getDevicePixelRatio',
        'dispatchAction',
        'isDisposed',
        'on',
        'off',
        'getDataURL',
        'getConnectedDataURL',
        'getOption',
        'getId',
        'updateLabelLayout'
    ];
    var $d9445617d131115d$var$ExtensionAPI = function() {
        function ExtensionAPI(ecInstance) {
            (0, parcelRequire("bahqM")).each($d9445617d131115d$var$availableMethods, function(methodName) {
                this[methodName] = (0, parcelRequire("bahqM")).bind(ecInstance[methodName], ecInstance);
            }, this);
        }
        return ExtensionAPI;
    }();
    var $d9445617d131115d$export$2e2bcd8739ae039 = $d9445617d131115d$var$ExtensionAPI;
});
parcelRegister("6LzFt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ed2ccc95e9b6d0d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $bahqM;
    var $4ed2ccc95e9b6d0d$var$QUERY_REG = /^(min|max)?(.+)$/;
    var $4ed2ccc95e9b6d0d$var$OptionManager = function() {
        function OptionManager(api) {
            this._timelineOptions = [];
            this._mediaList = [];
            this._currentMediaIndices = [];
            this._api = api;
        }
        OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
            if (rawOption) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.series), function(series) {
                    series && series.data && (0, (0, parcelRequire("bahqM")).isTypedArray)(series.data) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(series.data);
                });
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.dataset), function(dataset) {
                    dataset && dataset.source && (0, (0, parcelRequire("bahqM")).isTypedArray)(dataset.source) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(dataset.source);
                });
            }
            rawOption = (0, (0, parcelRequire("bahqM")).clone)(rawOption);
            var optionBackup = this._optionBackup;
            var newParsedOption = $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
            this._newBaseOption = newParsedOption.baseOption;
            if (optionBackup) {
                if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
                if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
                if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
            } else this._optionBackup = newParsedOption;
        };
        OptionManager.prototype.mountOption = function(isRecreate) {
            var optionBackup = this._optionBackup;
            this._timelineOptions = optionBackup.timelineOptions;
            this._mediaList = optionBackup.mediaList;
            this._mediaDefault = optionBackup.mediaDefault;
            this._currentMediaIndices = [];
            return (0, (0, parcelRequire("bahqM")).clone)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
        };
        OptionManager.prototype.getTimelineOption = function(ecModel) {
            var option;
            var timelineOptions = this._timelineOptions;
            if (timelineOptions.length) {
                var timelineModel = ecModel.getComponent('timeline');
                if (timelineModel) option = (0, (0, parcelRequire("bahqM")).clone)(timelineOptions[timelineModel.getCurrentIndex()]);
            }
            return option;
        };
        OptionManager.prototype.getMediaOption = function(ecModel) {
            var ecWidth = this._api.getWidth();
            var ecHeight = this._api.getHeight();
            var mediaList = this._mediaList;
            var mediaDefault = this._mediaDefault;
            var indices = [];
            var result = [];
            if (!mediaList.length && !mediaDefault) return result;
            for(var i = 0, len = mediaList.length; i < len; i++)if ($4ed2ccc95e9b6d0d$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
            if (!indices.length && mediaDefault) indices = [
                -1
            ];
            if (indices.length && !$4ed2ccc95e9b6d0d$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, (0, parcelRequire("bahqM")).map)(indices, function(index) {
                return (0, (0, parcelRequire("bahqM")).clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
            });
            this._currentMediaIndices = indices;
            return result;
        };
        return OptionManager;
    }();
    function $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
        var mediaList = [];
        var mediaDefault;
        var baseOption;
        var declaredBaseOption = rawOption.baseOption;
        var timelineOnRoot = rawOption.timeline;
        var timelineOptionsOnRoot = rawOption.options;
        var mediaOnRoot = rawOption.media;
        var hasMedia = !!rawOption.media;
        var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
        if (declaredBaseOption) {
            baseOption = declaredBaseOption;
            if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
        } else {
            if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
            baseOption = rawOption;
        }
        if (hasMedia) {
            if ((0, (0, parcelRequire("bahqM")).isArray)(mediaOnRoot)) (0, (0, parcelRequire("bahqM")).each)(mediaOnRoot, function(singleMedia) {
                if (singleMedia && singleMedia.option) {
                    if (singleMedia.query) mediaList.push(singleMedia);
                    else if (!mediaDefault) mediaDefault = singleMedia;
                }
            });
        }
        doPreprocess(baseOption);
        (0, (0, parcelRequire("bahqM")).each)(timelineOptionsOnRoot, function(option) {
            return doPreprocess(option);
        });
        (0, (0, parcelRequire("bahqM")).each)(mediaList, function(media) {
            return doPreprocess(media.option);
        });
        function doPreprocess(option) {
            (0, (0, parcelRequire("bahqM")).each)(optionPreprocessorFuncs, function(preProcess) {
                preProcess(option, isNew);
            });
        }
        return {
            baseOption: baseOption,
            timelineOptions: timelineOptionsOnRoot || [],
            mediaDefault: mediaDefault,
            mediaList: mediaList
        };
    }
    function $4ed2ccc95e9b6d0d$var$applyMediaQuery(query, ecWidth, ecHeight) {
        var realMap = {
            width: ecWidth,
            height: ecHeight,
            aspectratio: ecWidth / ecHeight
        };
        var applicatable = true;
        (0, (0, parcelRequire("bahqM")).each)(query, function(value, attr) {
            var matched = attr.match($4ed2ccc95e9b6d0d$var$QUERY_REG);
            if (!matched || !matched[1] || !matched[2]) return;
            var operator = matched[1];
            var realAttr = matched[2].toLowerCase();
            if (!$4ed2ccc95e9b6d0d$var$compare(realMap[realAttr], value, operator)) applicatable = false;
        });
        return applicatable;
    }
    function $4ed2ccc95e9b6d0d$var$compare(real, expect, operator) {
        if (operator === 'min') return real >= expect;
        else if (operator === 'max') return real <= expect;
        else return real === expect;
    }
    function $4ed2ccc95e9b6d0d$var$indicesEquals(indices1, indices2) {
        return indices1.join(',') === indices2.join(',');
    }
    var $4ed2ccc95e9b6d0d$export$2e2bcd8739ae039 = $4ed2ccc95e9b6d0d$var$OptionManager;
});
parcelRegister("driCQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c8c3e9bb43407b9$export$2e2bcd8739ae039);
    var $bahqM;
    var $9rY8k;
    var $eaKsF;
    function $9c8c3e9bb43407b9$var$get(opt, path) {
        var pathArr = path.split(',');
        var obj = opt;
        for(var i = 0; i < pathArr.length; i++){
            obj = obj && obj[pathArr[i]];
            if (obj == null) break;
        }
        return obj;
    }
    function $9c8c3e9bb43407b9$var$set(opt, path, val, overwrite) {
        var pathArr = path.split(',');
        var obj = opt;
        var key;
        var i = 0;
        for(; i < pathArr.length - 1; i++){
            key = pathArr[i];
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        }
        if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
    }
    function $9c8c3e9bb43407b9$var$compatLayoutProperties(option) {
        option && (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES, function(prop) {
            if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
        });
    }
    var $9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES = [
        [
            'x',
            'left'
        ],
        [
            'y',
            'top'
        ],
        [
            'x2',
            'right'
        ],
        [
            'y2',
            'bottom'
        ]
    ];
    var $9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS = [
        'grid',
        'geo',
        'parallel',
        'legend',
        'toolbox',
        'title',
        'visualMap',
        'dataZoom',
        'timeline'
    ];
    var $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP = [
        [
            'borderRadius',
            'barBorderRadius'
        ],
        [
            'borderColor',
            'barBorderColor'
        ],
        [
            'borderWidth',
            'barBorderWidth'
        ]
    ];
    function $9c8c3e9bb43407b9$var$compatBarItemStyle(option) {
        var itemStyle = option && option.itemStyle;
        if (itemStyle) for(var i = 0; i < $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP.length; i++){
            var oldName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][1];
            var newName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][0];
            if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
        }
    }
    function $9c8c3e9bb43407b9$var$compatPieLabel(option) {
        if (!option) return;
        if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
    }
    function $9c8c3e9bb43407b9$var$compatSunburstState(option) {
        if (!option) return;
        if (option.downplay && !option.blur) option.blur = option.downplay;
    }
    function $9c8c3e9bb43407b9$var$compatGraphFocus(option) {
        if (!option) return;
        if (option.focusNodeAdjacency != null) {
            option.emphasis = option.emphasis || {};
            if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
        }
    }
    function $9c8c3e9bb43407b9$var$traverseTree(data, cb) {
        if (data) for(var i = 0; i < data.length; i++){
            cb(data[i]);
            data[i] && $9c8c3e9bb43407b9$var$traverseTree(data[i].children, cb);
        }
    }
    function $9c8c3e9bb43407b9$export$2e2bcd8739ae039(option, isTheme) {
        (0, (0, parcelRequire("9rY8k")).default)(option, isTheme);
        option.series = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(option.series);
        (0, (0, parcelRequire("bahqM")).each)(option.series, function(seriesOpt) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(seriesOpt)) return;
            var seriesType = seriesOpt.type;
            if (seriesType === 'line') {
                if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
            } else if (seriesType === 'pie' || seriesType === 'gauge') {
                if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
                $9c8c3e9bb43407b9$var$compatPieLabel(seriesOpt.label);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) for(var i = 0; i < data.length; i++)$9c8c3e9bb43407b9$var$compatPieLabel(data[i]);
                if (seriesOpt.hoverOffset != null) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    seriesOpt.emphasis.scaleSize = null;
                }
            } else if (seriesType === 'gauge') {
                var pointerColor = $9c8c3e9bb43407b9$var$get(seriesOpt, 'pointer.color');
                pointerColor != null && $9c8c3e9bb43407b9$var$set(seriesOpt, 'itemStyle.color', pointerColor);
            } else if (seriesType === 'bar') {
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.backgroundStyle);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.emphasis);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) {
                    for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i]);
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i] && data[i].emphasis);
                    }
                }
            } else if (seriesType === 'sunburst') {
                var highlightPolicy = seriesOpt.highlightPolicy;
                if (highlightPolicy) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
                }
                $9c8c3e9bb43407b9$var$compatSunburstState(seriesOpt);
                $9c8c3e9bb43407b9$var$traverseTree(seriesOpt.data, $9c8c3e9bb43407b9$var$compatSunburstState);
            } else if (seriesType === 'graph' || seriesType === 'sankey') $9c8c3e9bb43407b9$var$compatGraphFocus(seriesOpt);
            else if (seriesType === 'map') {
                if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
                if (seriesOpt.mapLocation) (0, (0, parcelRequire("bahqM")).defaults)(seriesOpt, seriesOpt.mapLocation);
            }
            if (seriesOpt.hoverAnimation != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
            }
            $9c8c3e9bb43407b9$var$compatLayoutProperties(seriesOpt);
        });
        if (option.dataRange) option.visualMap = option.dataRange;
        (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS, function(componentName) {
            var options = option[componentName];
            if (options) {
                if (!(0, (0, parcelRequire("bahqM")).isArray)(options)) options = [
                    options
                ];
                (0, (0, parcelRequire("bahqM")).each)(options, function(option) {
                    $9c8c3e9bb43407b9$var$compatLayoutProperties(option);
                });
            }
        });
    }
});
parcelRegister("9rY8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e1547e334933782$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    var $6e1547e334933782$var$each = (0, parcelRequire("bahqM")).each;
    var $6e1547e334933782$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $6e1547e334933782$var$POSSIBLE_STYLES = [
        'areaStyle',
        'lineStyle',
        'nodeStyle',
        'linkStyle',
        'chordStyle',
        'label',
        'labelLine'
    ];
    function $6e1547e334933782$var$compatEC2ItemStyle(opt) {
        var itemStyleOpt = opt && opt.itemStyle;
        if (!itemStyleOpt) return;
        for(var i = 0, len = $6e1547e334933782$var$POSSIBLE_STYLES.length; i < len; i++){
            var styleName = $6e1547e334933782$var$POSSIBLE_STYLES[i];
            var normalItemStyleOpt = itemStyleOpt.normal;
            var emphasisItemStyleOpt = itemStyleOpt.emphasis;
            if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
                normalItemStyleOpt[styleName] = null;
            }
            if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
                emphasisItemStyleOpt[styleName] = null;
            }
        }
    }
    function $6e1547e334933782$var$convertNormalEmphasis(opt, optType, useExtend) {
        if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
            var normalOpt = opt[optType].normal;
            var emphasisOpt = opt[optType].emphasis;
            if (normalOpt) {
                if (useExtend) {
                    opt[optType].normal = opt[optType].emphasis = null;
                    (0, parcelRequire("bahqM")).defaults(opt[optType], normalOpt);
                } else opt[optType] = normalOpt;
            }
            if (emphasisOpt) {
                opt.emphasis = opt.emphasis || {};
                opt.emphasis[optType] = emphasisOpt;
                if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
                if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
            }
        }
    }
    function $6e1547e334933782$var$removeEC3NormalStatus(opt) {
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'itemStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'lineStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'areaStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'label');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'labelLine');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'upperLabel');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'edgeLabel');
    }
    function $6e1547e334933782$var$compatTextStyle(opt, propName) {
        var labelOptSingle = $6e1547e334933782$var$isObject(opt) && opt[propName];
        var textStyle = $6e1547e334933782$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
        if (textStyle) for(var i = 0, len = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS.length; i < len; i++){
            var textPropName = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS[i];
            if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
        }
    }
    function $6e1547e334933782$var$compatEC3CommonStyles(opt) {
        if (opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
            $6e1547e334933782$var$compatTextStyle(opt, 'label');
            opt.emphasis && $6e1547e334933782$var$compatTextStyle(opt.emphasis, 'label');
        }
    }
    function $6e1547e334933782$var$processSeries(seriesOpt) {
        if (!$6e1547e334933782$var$isObject(seriesOpt)) return;
        $6e1547e334933782$var$compatEC2ItemStyle(seriesOpt);
        $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt);
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'label');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'upperLabel');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'edgeLabel');
        if (seriesOpt.emphasis) {
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'label');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
        }
        var markPoint = seriesOpt.markPoint;
        if (markPoint) {
            $6e1547e334933782$var$compatEC2ItemStyle(markPoint);
            $6e1547e334933782$var$compatEC3CommonStyles(markPoint);
        }
        var markLine = seriesOpt.markLine;
        if (markLine) {
            $6e1547e334933782$var$compatEC2ItemStyle(markLine);
            $6e1547e334933782$var$compatEC3CommonStyles(markLine);
        }
        var markArea = seriesOpt.markArea;
        if (markArea) $6e1547e334933782$var$compatEC3CommonStyles(markArea);
        var data = seriesOpt.data;
        if (seriesOpt.type === 'graph') {
            data = data || seriesOpt.nodes;
            var edgeData = seriesOpt.links || seriesOpt.edges;
            if (edgeData && !(0, parcelRequire("bahqM")).isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(edgeData[i]);
            (0, parcelRequire("bahqM")).each(seriesOpt.categories, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        }
        if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) for(var i = 0; i < data.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(data[i]);
        markPoint = seriesOpt.markPoint;
        if (markPoint && markPoint.data) {
            var mpData = markPoint.data;
            for(var i = 0; i < mpData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(mpData[i]);
        }
        markLine = seriesOpt.markLine;
        if (markLine && markLine.data) {
            var mlData = markLine.data;
            for(var i = 0; i < mlData.length; i++)if ((0, parcelRequire("bahqM")).isArray(mlData[i])) {
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][0]);
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][1]);
            } else $6e1547e334933782$var$compatEC3CommonStyles(mlData[i]);
        }
        if (seriesOpt.type === 'gauge') {
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'title');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'detail');
        } else if (seriesOpt.type === 'treemap') {
            $6e1547e334933782$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
            (0, parcelRequire("bahqM")).each(seriesOpt.levels, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        } else if (seriesOpt.type === 'tree') $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt.leaves);
    }
    function $6e1547e334933782$var$toArr(o) {
        return (0, parcelRequire("bahqM")).isArray(o) ? o : o ? [
            o
        ] : [];
    }
    function $6e1547e334933782$var$toObj(o) {
        return ((0, parcelRequire("bahqM")).isArray(o) ? o[0] : o) || {};
    }
    function $6e1547e334933782$export$2e2bcd8739ae039(option, isTheme) {
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.series), function(seriesOpt) {
            $6e1547e334933782$var$isObject(seriesOpt) && $6e1547e334933782$var$processSeries(seriesOpt);
        });
        var axes = [
            'xAxis',
            'yAxis',
            'radiusAxis',
            'angleAxis',
            'singleAxis',
            'parallelAxis',
            'radar'
        ];
        isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
        $6e1547e334933782$var$each(axes, function(axisName) {
            $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option[axisName]), function(axisOpt) {
                if (axisOpt) {
                    $6e1547e334933782$var$compatTextStyle(axisOpt, 'axisLabel');
                    $6e1547e334933782$var$compatTextStyle(axisOpt.axisPointer, 'label');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.parallel), function(parallelOpt) {
            var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.calendar), function(calendarOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'dayLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'monthLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'yearLabel');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.radar), function(radarOpt) {
            $6e1547e334933782$var$compatTextStyle(radarOpt, 'name');
            if (radarOpt.name && radarOpt.axisName == null) {
                radarOpt.axisName = radarOpt.name;
                delete radarOpt.name;
            }
            if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
                radarOpt.axisNameGap = radarOpt.nameGap;
                delete radarOpt.nameGap;
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.geo), function(geoOpt) {
            if ($6e1547e334933782$var$isObject(geoOpt)) {
                $6e1547e334933782$var$compatEC3CommonStyles(geoOpt);
                $6e1547e334933782$var$each($6e1547e334933782$var$toArr(geoOpt.regions), function(regionObj) {
                    $6e1547e334933782$var$compatEC3CommonStyles(regionObj);
                });
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.timeline), function(timelineOpt) {
            $6e1547e334933782$var$compatEC3CommonStyles(timelineOpt);
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'label');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
            var data = timelineOpt.data;
            (0, parcelRequire("bahqM")).isArray(data) && (0, parcelRequire("bahqM")).each(data, function(item) {
                if ((0, parcelRequire("bahqM")).isObject(item)) {
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'label');
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'itemStyle');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.toolbox), function(toolboxOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
            $6e1547e334933782$var$each(toolboxOpt.feature, function(featureOpt) {
                $6e1547e334933782$var$convertNormalEmphasis(featureOpt, 'iconStyle');
            });
        });
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.axisPointer), 'label');
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.tooltip).axisPointer, 'label');
    }
});
parcelRegister("iMppY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dac06d23d0856818$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    function $dac06d23d0856818$export$2e2bcd8739ae039(ecModel) {
        var stackInfoMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var stack = seriesModel.get('stack');
            if (stack) {
                var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
                var data = seriesModel.getData();
                var stackInfo = {
                    stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                    stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                    stackedDimension: data.getCalculationInfo('stackedDimension'),
                    stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                    isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                    data: data,
                    seriesModel: seriesModel
                };
                if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
                stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
                stackInfoList.push(stackInfo);
            }
        });
        stackInfoMap.each($dac06d23d0856818$var$calculateStack);
    }
    function $dac06d23d0856818$var$calculateStack(stackInfoList) {
        (0, (0, parcelRequire("bahqM")).each)(stackInfoList, function(targetStackInfo, idxInStack) {
            var resultVal = [];
            var resultNaN = [
                NaN,
                NaN
            ];
            var dims = [
                targetStackInfo.stackResultDimension,
                targetStackInfo.stackedOverDimension
            ];
            var targetData = targetStackInfo.data;
            var isStackedByIndex = targetStackInfo.isStackedByIndex;
            targetData.modify(dims, function(v0, v1, dataIndex) {
                var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
                if (isNaN(sum)) return resultNaN;
                var byValue;
                var stackedDataRawIndex;
                if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
                else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
                var stackedOver = NaN;
                for(var j = idxInStack - 1; j >= 0; j--){
                    var stackInfo = stackInfoList[j];
                    if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                    if (stackedDataRawIndex >= 0) {
                        var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                        if (sum >= 0 && val > 0 || sum <= 0 && val < 0) {
                            sum = (0, (0, parcelRequire("jmSNG")).addSafe)(sum, val);
                            stackedOver = val;
                            break;
                        }
                    }
                }
                resultVal[0] = sum;
                resultVal[1] = stackedOver;
                return resultVal;
            });
        });
    }
});
parcelRegister("cvEVp", function(module, exports) {
    $parcel$export(module.exports, "seriesStyleTask", ()=>$91b820231b41a759$export$7ce4d65f9b69240);
    $parcel$export(module.exports, "dataStyleTask", ()=>$91b820231b41a759$export$f7dcb66a065003d1);
    $parcel$export(module.exports, "dataColorPaletteTask", ()=>$91b820231b41a759$export$cf9758b0d6dc0aa9);
    var $bahqM;
    var $1BJbl;
    var $4rldO;
    var $46U6E;
    var $gaMkj;
    var $eaKsF;
    var $91b820231b41a759$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $91b820231b41a759$var$defaultStyleMappers = {
        itemStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("4rldO")).ITEM_STYLE_KEY_MAP), true),
        lineStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("46U6E")).LINE_STYLE_KEY_MAP), true)
    };
    var $91b820231b41a759$var$defaultColorKey = {
        lineStyle: 'stroke',
        itemStyle: 'fill'
    };
    function $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath) {
        var styleMapper = seriesModel.visualStyleMapper || $91b820231b41a759$var$defaultStyleMappers[stylePath];
        if (!styleMapper) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return $91b820231b41a759$var$defaultStyleMappers.itemStyle;
        }
        return styleMapper;
    }
    function $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath) {
        var colorKey = seriesModel.visualDrawType || $91b820231b41a759$var$defaultColorKey[stylePath];
        if (!colorKey) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return 'fill';
        }
        return colorKey;
    }
    var $91b820231b41a759$export$7ce4d65f9b69240 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var styleModel = seriesModel.getModel(stylePath);
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var globalStyle = getStyle(styleModel);
            var decalOption = styleModel.getShallow('decal');
            if (decalOption) {
                data.setVisual('decal', decalOption);
                decalOption.dirty = true;
            }
            var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
            var color = globalStyle[colorKey];
            var colorCallback = (0, (0, parcelRequire("bahqM")).isFunction)(color) ? color : null;
            var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
            if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
                var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
                if (!globalStyle[colorKey]) {
                    globalStyle[colorKey] = colorPalette;
                    data.setVisual('colorFromPalette', true);
                }
                globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
                globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
            }
            data.setVisual('style', globalStyle);
            data.setVisual('drawType', colorKey);
            if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
                data.setVisual('colorFromPalette', false);
                return {
                    dataEach: function(data, idx) {
                        var dataParams = seriesModel.getDataParams(idx);
                        var itemStyle = (0, (0, parcelRequire("bahqM")).extend)({}, globalStyle);
                        itemStyle[colorKey] = colorCallback(dataParams);
                        data.setItemVisual(idx, 'style', itemStyle);
                    }
                };
            }
        }
    };
    var $91b820231b41a759$var$sharedModel = new (0, (0, parcelRequire("gaMkj")).default)();
    var $91b820231b41a759$export$f7dcb66a065003d1 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var colorKey = data.getVisual('drawType');
            return {
                dataEach: data.hasItemOption ? function(data, idx) {
                    var rawItem = data.getRawDataItem(idx);
                    if (rawItem && rawItem[stylePath]) {
                        $91b820231b41a759$var$sharedModel.option = rawItem[stylePath];
                        var style = getStyle($91b820231b41a759$var$sharedModel);
                        var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                        (0, (0, parcelRequire("bahqM")).extend)(existsStyle, style);
                        if ($91b820231b41a759$var$sharedModel.option.decal) {
                            data.setItemVisual(idx, 'decal', $91b820231b41a759$var$sharedModel.option.decal);
                            $91b820231b41a759$var$sharedModel.option.decal.dirty = true;
                        }
                        if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                    }
                } : null
            };
        }
    };
    var $91b820231b41a759$export$cf9758b0d6dc0aa9 = {
        performRawSeries: true,
        overallReset: function(ecModel) {
            var paletteScopeGroupByType = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var colorBy = seriesModel.getColorBy();
                if (seriesModel.isColorBySeries()) return;
                var key = seriesModel.type + '-' + colorBy;
                var colorScope = paletteScopeGroupByType.get(key);
                if (!colorScope) {
                    colorScope = {};
                    paletteScopeGroupByType.set(key, colorScope);
                }
                $91b820231b41a759$var$inner(seriesModel).scope = colorScope;
            });
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
                var dataAll = seriesModel.getRawData();
                var idxMap = {};
                var data = seriesModel.getData();
                var colorScope = $91b820231b41a759$var$inner(seriesModel).scope;
                var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
                var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
                data.each(function(idx) {
                    var rawIdx = data.getRawIndex(idx);
                    idxMap[rawIdx] = idx;
                });
                dataAll.each(function(rawIdx) {
                    var idx = idxMap[rawIdx];
                    var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                    if (fromPalette) {
                        var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                        var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                        var dataCount = dataAll.count();
                        itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                    }
                });
            });
        }
    };
});
parcelRegister("4G956", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3682210406d5dc21$export$2e2bcd8739ae039);
    var $bahqM;
    parcelRequire("fHITF");
    var $ixXaU;
    var $7Tw7u;
    var $4KVOr;
    var $4gEFv;
    var $3682210406d5dc21$var$PI = Math.PI;
    function $3682210406d5dc21$export$2e2bcd8739ae039(api, opts) {
        opts = opts || {};
        (0, parcelRequire("bahqM")).defaults(opts, {
            text: 'loading',
            textColor: '#000',
            fontSize: 12,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontFamily: 'sans-serif',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            showSpinner: true,
            color: '#5470c6',
            spinnerRadius: 10,
            lineWidth: 5,
            zlevel: 0
        });
        var group = new (0, parcelRequire("4KVOr")).default();
        var mask = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: opts.maskColor
            },
            zlevel: opts.zlevel,
            z: 10000
        });
        group.add(mask);
        var textContent = new (0, parcelRequire("4gEFv")).default({
            style: {
                text: opts.text,
                fill: opts.textColor,
                fontSize: opts.fontSize,
                fontWeight: opts.fontWeight,
                fontStyle: opts.fontStyle,
                fontFamily: opts.fontFamily
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        var labelRect = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: 'none'
            },
            textContent: textContent,
            textConfig: {
                position: 'right',
                distance: 10
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        group.add(labelRect);
        var arc;
        if (opts.showSpinner) {
            arc = new (0, parcelRequire("ixXaU")).default({
                shape: {
                    startAngle: -$3682210406d5dc21$var$PI / 2,
                    endAngle: -$3682210406d5dc21$var$PI / 2 + 0.1,
                    r: opts.spinnerRadius
                },
                style: {
                    stroke: opts.color,
                    lineCap: 'round',
                    lineWidth: opts.lineWidth
                },
                zlevel: opts.zlevel,
                z: 10001
            });
            arc.animateShape(true).when(1000, {
                endAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).start('circularInOut');
            arc.animateShape(true).when(1000, {
                startAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).delay(300).start('circularInOut');
            group.add(arc);
        }
        group.resize = function() {
            var textWidth = textContent.getBoundingRect().width;
            var r = opts.showSpinner ? opts.spinnerRadius : 0;
            var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
            var cy = api.getHeight() / 2;
            opts.showSpinner && arc.setShape({
                cx: cx,
                cy: cy
            });
            labelRect.setShape({
                x: cx - r,
                y: cy - r,
                width: r * 2,
                height: r * 2
            });
            mask.setShape({
                x: 0,
                y: 0,
                width: api.getWidth(),
                height: api.getHeight()
            });
        };
        group.resize();
        return group;
    }
});
parcelRegister("14WFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c93ab8c51628eb2$export$2e2bcd8739ae039);
    var $bahqM;
    var $92IK1;
    var $jvo6O;
    var $74g78;
    var $iEvqc;
    var $eaKsF;
    var $0c93ab8c51628eb2$var$Scheduler = function() {
        function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
            this._stageTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.ecInstance = ecInstance;
            this.api = api;
            dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
            visualHandlers = this._visualHandlers = visualHandlers.slice();
            this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
        }
        Scheduler.prototype.restoreData = function(ecModel, payload) {
            ecModel.restoreData(payload);
            this._stageTaskMap.each(function(taskRecord) {
                var overallTask = taskRecord.overallTask;
                overallTask && overallTask.dirty();
            });
        };
        Scheduler.prototype.getPerformArgs = function(task, isBlock) {
            if (!task.__pipeline) return;
            var pipeline = this._pipelineMap.get(task.__pipeline.id);
            var pCtx = pipeline.context;
            var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
            var step = incremental ? pipeline.step : null;
            var modDataCount = pCtx && pCtx.modDataCount;
            var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
            return {
                step: step,
                modBy: modBy,
                modDataCount: modDataCount
            };
        };
        Scheduler.prototype.getPipeline = function(pipelineId) {
            return this._pipelineMap.get(pipelineId);
        };
        Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
            var pipeline = this._pipelineMap.get(seriesModel.uid);
            var data = seriesModel.getData();
            var dataLen = data.count();
            var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
            var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
            var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
            seriesModel.pipelineContext = pipeline.context = {
                progressiveRender: progressiveRender,
                modDataCount: modDataCount,
                large: large
            };
        };
        Scheduler.prototype.restorePipelines = function(ecModel) {
            var scheduler = this;
            var pipelineMap = scheduler._pipelineMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var progressive = seriesModel.getProgressive();
                var pipelineId = seriesModel.uid;
                pipelineMap.set(pipelineId, {
                    id: pipelineId,
                    head: null,
                    tail: null,
                    threshold: seriesModel.getProgressiveThreshold(),
                    progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                    blockIndex: -1,
                    step: Math.round(progressive || 700),
                    count: 0
                });
                scheduler._pipe(seriesModel, seriesModel.dataTask);
            });
        };
        Scheduler.prototype.prepareStageTasks = function() {
            var stageTaskMap = this._stageTaskMap;
            var ecModel = this.api.getModel();
            var api = this.api;
            (0, (0, parcelRequire("bahqM")).each)(this._allHandlers, function(handler) {
                var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
                var errMsg = '';
                (0, (0, parcelRequire("bahqM")).assert)(!(handler.reset && handler.overallReset), errMsg);
                handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
                handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
            }, this);
        };
        Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
            var renderTask = view.renderTask;
            var context = renderTask.context;
            context.model = model;
            context.ecModel = ecModel;
            context.api = api;
            renderTask.__block = !view.incrementalPrepareRender;
            this._pipe(model, renderTask);
        };
        Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
            this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
                block: true
            });
        };
        Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
            this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
        };
        Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
            opt = opt || {};
            var unfinished = false;
            var scheduler = this;
            (0, (0, parcelRequire("bahqM")).each)(stageHandlers, function(stageHandler, idx) {
                if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
                var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
                var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
                var overallTask = stageHandlerRecord.overallTask;
                if (overallTask) {
                    var overallNeedDirty_1;
                    var agentStubMap = overallTask.agentStubMap;
                    agentStubMap.each(function(stub) {
                        if (needSetDirty(opt, stub)) {
                            stub.dirty();
                            overallNeedDirty_1 = true;
                        }
                    });
                    overallNeedDirty_1 && overallTask.dirty();
                    scheduler.updatePayload(overallTask, payload);
                    var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                    agentStubMap.each(function(stub) {
                        stub.perform(performArgs_1);
                    });
                    if (overallTask.perform(performArgs_1)) unfinished = true;
                } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                    if (needSetDirty(opt, task)) task.dirty();
                    var performArgs = scheduler.getPerformArgs(task, opt.block);
                    performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                    scheduler.updatePayload(task, payload);
                    if (task.perform(performArgs)) unfinished = true;
                });
            });
            function needSetDirty(opt, task) {
                return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
            }
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.performSeriesTasks = function(ecModel) {
            var unfinished;
            ecModel.eachSeries(function(seriesModel) {
                unfinished = seriesModel.dataTask.perform() || unfinished;
            });
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.plan = function() {
            this._pipelineMap.each(function(pipeline) {
                var task = pipeline.tail;
                do {
                    if (task.__block) {
                        pipeline.blockIndex = task.__idxInPipeline;
                        break;
                    }
                    task = task.getUpstream();
                }while (task)
            });
        };
        Scheduler.prototype.updatePayload = function(task, payload) {
            payload !== 'remain' && (task.context.payload = payload);
        };
        Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
            else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
            function create(seriesModel) {
                var pipelineId = seriesModel.uid;
                var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, (0, parcelRequire("92IK1")).createTask)({
                    plan: $0c93ab8c51628eb2$var$seriesTaskPlan,
                    reset: $0c93ab8c51628eb2$var$seriesTaskReset,
                    count: $0c93ab8c51628eb2$var$seriesTaskCount
                }));
                task.context = {
                    model: seriesModel,
                    ecModel: ecModel,
                    api: api,
                    useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                    plan: stageHandler.plan,
                    reset: stageHandler.reset,
                    scheduler: scheduler
                };
                scheduler._pipe(seriesModel, task);
            }
        };
        Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, (0, parcelRequire("92IK1")).createTask)({
                reset: $0c93ab8c51628eb2$var$overallTaskReset
            });
            overallTask.context = {
                ecModel: ecModel,
                api: api,
                overallReset: stageHandler.overallReset,
                scheduler: scheduler
            };
            var oldAgentStubMap = overallTask.agentStubMap;
            var newAgentStubMap = overallTask.agentStubMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            var overallProgress = true;
            var shouldOverallTaskDirty = false;
            var errMsg = '';
            (0, (0, parcelRequire("bahqM")).assert)(!stageHandler.createOnAllSeries, errMsg);
            if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
            else {
                overallProgress = false;
                (0, (0, parcelRequire("bahqM")).each)(ecModel.getSeries(), createStub);
            }
            function createStub(seriesModel) {
                var pipelineId = seriesModel.uid;
                var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || (shouldOverallTaskDirty = true, (0, (0, parcelRequire("92IK1")).createTask)({
                    reset: $0c93ab8c51628eb2$var$stubReset,
                    onDirty: $0c93ab8c51628eb2$var$stubOnDirty
                })));
                stub.context = {
                    model: seriesModel,
                    overallProgress: overallProgress
                };
                stub.agent = overallTask;
                stub.__block = overallProgress;
                scheduler._pipe(seriesModel, stub);
            }
            if (shouldOverallTaskDirty) overallTask.dirty();
        };
        Scheduler.prototype._pipe = function(seriesModel, task) {
            var pipelineId = seriesModel.uid;
            var pipeline = this._pipelineMap.get(pipelineId);
            !pipeline.head && (pipeline.head = task);
            pipeline.tail && pipeline.tail.pipe(task);
            pipeline.tail = task;
            task.__idxInPipeline = pipeline.count++;
            task.__pipeline = pipeline;
        };
        Scheduler.wrapStageHandler = function(stageHandler, visualType) {
            if ((0, (0, parcelRequire("bahqM")).isFunction)(stageHandler)) stageHandler = {
                overallReset: stageHandler,
                seriesType: $0c93ab8c51628eb2$var$detectSeriseType(stageHandler)
            };
            stageHandler.uid = (0, (0, parcelRequire("jvo6O")).getUID)('stageHandler');
            visualType && (stageHandler.visualType = visualType);
            return stageHandler;
        };
        return Scheduler;
    }();
    function $0c93ab8c51628eb2$var$overallTaskReset(context) {
        context.overallReset(context.ecModel, context.api, context.payload);
    }
    function $0c93ab8c51628eb2$var$stubReset(context) {
        return context.overallProgress && $0c93ab8c51628eb2$var$stubProgress;
    }
    function $0c93ab8c51628eb2$var$stubProgress() {
        this.agent.dirty();
        this.getDownstream().dirty();
    }
    function $0c93ab8c51628eb2$var$stubOnDirty() {
        this.agent && this.agent.dirty();
    }
    function $0c93ab8c51628eb2$var$seriesTaskPlan(context) {
        return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
    }
    function $0c93ab8c51628eb2$var$seriesTaskReset(context) {
        if (context.useClearVisual) context.data.clearAllVisual();
        var resetDefines = context.resetDefines = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
        return resetDefines.length > 1 ? (0, (0, parcelRequire("bahqM")).map)(resetDefines, function(v, idx) {
            return $0c93ab8c51628eb2$var$makeSeriesTaskProgress(idx);
        }) : $0c93ab8c51628eb2$var$singleSeriesTaskProgress;
    }
    var $0c93ab8c51628eb2$var$singleSeriesTaskProgress = $0c93ab8c51628eb2$var$makeSeriesTaskProgress(0);
    function $0c93ab8c51628eb2$var$makeSeriesTaskProgress(resetDefineIdx) {
        return function(params, context) {
            var data = context.data;
            var resetDefine = context.resetDefines[resetDefineIdx];
            if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
            else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
        };
    }
    function $0c93ab8c51628eb2$var$seriesTaskCount(context) {
        return context.data.count();
    }
    function $0c93ab8c51628eb2$var$detectSeriseType(legacyFunc) {
        $0c93ab8c51628eb2$var$seriesType = null;
        try {
            legacyFunc($0c93ab8c51628eb2$var$ecModelMock, $0c93ab8c51628eb2$var$apiMock);
        } catch (e) {}
        return $0c93ab8c51628eb2$var$seriesType;
    }
    var $0c93ab8c51628eb2$var$ecModelMock = {};
    var $0c93ab8c51628eb2$var$apiMock = {};
    var $0c93ab8c51628eb2$var$seriesType;
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$ecModelMock, (0, (0, parcelRequire("74g78")).default));
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$apiMock, (0, (0, parcelRequire("iEvqc")).default));
    $0c93ab8c51628eb2$var$ecModelMock.eachSeriesByType = $0c93ab8c51628eb2$var$ecModelMock.eachRawSeriesByType = function(type) {
        $0c93ab8c51628eb2$var$seriesType = type;
    };
    $0c93ab8c51628eb2$var$ecModelMock.eachComponent = function(cond) {
        if (cond.mainType === 'series' && cond.subType) $0c93ab8c51628eb2$var$seriesType = cond.subType;
    };
    function $0c93ab8c51628eb2$var$mockMethods(target, Clz) {
        for(var name_1 in Clz.prototype)target[name_1] = (0, (0, parcelRequire("bahqM")).noop);
    }
    var $0c93ab8c51628eb2$export$2e2bcd8739ae039 = $0c93ab8c51628eb2$var$Scheduler;
});
parcelRegister("31FQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2341ebce6d7d92ac$export$2e2bcd8739ae039);
    var $2341ebce6d7d92ac$var$colorAll = [
        '#37A2DA',
        '#32C5E9',
        '#67E0E3',
        '#9FE6B8',
        '#FFDB5C',
        '#ff9f7f',
        '#fb7293',
        '#E062AE',
        '#E690D1',
        '#e7bcf3',
        '#9d96f5',
        '#8378EA',
        '#96BFFF'
    ];
    var $2341ebce6d7d92ac$export$2e2bcd8739ae039 = {
        color: $2341ebce6d7d92ac$var$colorAll,
        colorLayer: [
            [
                '#37A2DA',
                '#ffd85c',
                '#fd7b5f'
            ],
            [
                '#37A2DA',
                '#67E0E3',
                '#FFDB5C',
                '#ff9f7f',
                '#E062AE',
                '#9d96f5'
            ],
            [
                '#37A2DA',
                '#32C5E9',
                '#9FE6B8',
                '#FFDB5C',
                '#ff9f7f',
                '#fb7293',
                '#e7bcf3',
                '#8378EA',
                '#96BFFF'
            ],
            $2341ebce6d7d92ac$var$colorAll
        ]
    };
});
parcelRegister("dMJCs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a093251ea09c66fc$export$2e2bcd8739ae039);
    var $a093251ea09c66fc$var$contrastColor = '#B9B8CE';
    var $a093251ea09c66fc$var$backgroundColor = '#100C2A';
    var $a093251ea09c66fc$var$axisCommon = function() {
        return {
            axisLine: {
                lineStyle: {
                    color: $a093251ea09c66fc$var$contrastColor
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#484753'
                }
            },
            splitArea: {
                areaStyle: {
                    color: [
                        'rgba(255,255,255,0.02)',
                        'rgba(255,255,255,0.05)'
                    ]
                }
            },
            minorSplitLine: {
                lineStyle: {
                    color: '#20203B'
                }
            }
        };
    };
    var $a093251ea09c66fc$var$colorPalette = [
        '#4992ff',
        '#7cffb2',
        '#fddd60',
        '#ff6e76',
        '#58d9f9',
        '#05c091',
        '#ff8a45',
        '#8d48e3',
        '#dd79ff'
    ];
    var $a093251ea09c66fc$var$theme = {
        darkMode: true,
        color: $a093251ea09c66fc$var$colorPalette,
        backgroundColor: $a093251ea09c66fc$var$backgroundColor,
        axisPointer: {
            lineStyle: {
                color: '#817f91'
            },
            crossStyle: {
                color: '#817f91'
            },
            label: {
                color: '#fff'
            }
        },
        legend: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        title: {
            textStyle: {
                color: '#EEF1FA'
            },
            subtextStyle: {
                color: '#B9B8CE'
            }
        },
        toolbox: {
            iconStyle: {
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        dataZoom: {
            borderColor: '#71708A',
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            brushStyle: {
                color: 'rgba(135,163,206,0.3)'
            },
            handleStyle: {
                color: '#353450',
                borderColor: '#C5CBE3'
            },
            moveHandleStyle: {
                color: '#B0B6C3',
                opacity: 0.3
            },
            fillerColor: 'rgba(135,163,206,0.2)',
            emphasis: {
                handleStyle: {
                    borderColor: '#91B7F2',
                    color: '#4D587D'
                },
                moveHandleStyle: {
                    color: '#636D9A',
                    opacity: 0.7
                }
            },
            dataBackground: {
                lineStyle: {
                    color: '#71708A',
                    width: 1
                },
                areaStyle: {
                    color: '#71708A'
                }
            },
            selectedDataBackground: {
                lineStyle: {
                    color: '#87A3CE'
                },
                areaStyle: {
                    color: '#87A3CE'
                }
            }
        },
        visualMap: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeline: {
            lineStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            label: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            controlStyle: {
                color: $a093251ea09c66fc$var$contrastColor,
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        calendar: {
            itemStyle: {
                color: $a093251ea09c66fc$var$backgroundColor
            },
            dayLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            monthLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            yearLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeAxis: $a093251ea09c66fc$var$axisCommon(),
        logAxis: $a093251ea09c66fc$var$axisCommon(),
        valueAxis: $a093251ea09c66fc$var$axisCommon(),
        categoryAxis: $a093251ea09c66fc$var$axisCommon(),
        line: {
            symbol: 'circle'
        },
        graph: {
            color: $a093251ea09c66fc$var$colorPalette
        },
        gauge: {
            title: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            axisLine: {
                lineStyle: {
                    color: [
                        [
                            1,
                            'rgba(207,212,219,0.2)'
                        ]
                    ]
                }
            },
            axisLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            detail: {
                color: '#EEF1FA'
            }
        },
        candlestick: {
            itemStyle: {
                color: '#f64e56',
                color0: '#54ea92',
                borderColor: '#f64e56',
                borderColor0: '#54ea92'
            }
        }
    };
    $a093251ea09c66fc$var$theme.categoryAxis.splitLine.show = false;
    var $a093251ea09c66fc$export$2e2bcd8739ae039 = $a093251ea09c66fc$var$theme;
});
parcelRegister("cbv5T", function(module, exports) {
    $parcel$export(module.exports, "ECEventProcessor", ()=>$8deea1bcfc845e61$export$d0fd09f950257b52);
    var $bahqM;
    var $aLwh0;
    var $8deea1bcfc845e61$export$d0fd09f950257b52 = function() {
        function ECEventProcessor() {}
        ECEventProcessor.prototype.normalizeQuery = function(query) {
            var cptQuery = {};
            var dataQuery = {};
            var otherQuery = {};
            if ((0, parcelRequire("bahqM")).isString(query)) {
                var condCptType = (0, (0, parcelRequire("aLwh0")).parseClassType)(query);
                cptQuery.mainType = condCptType.main || null;
                cptQuery.subType = condCptType.sub || null;
            } else {
                var suffixes_1 = [
                    'Index',
                    'Name',
                    'Id'
                ];
                var dataKeys_1 = {
                    name: 1,
                    dataIndex: 1,
                    dataType: 1
                };
                (0, parcelRequire("bahqM")).each(query, function(val, key) {
                    var reserved = false;
                    for(var i = 0; i < suffixes_1.length; i++){
                        var propSuffix = suffixes_1[i];
                        var suffixPos = key.lastIndexOf(propSuffix);
                        if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                            var mainType = key.slice(0, suffixPos);
                            if (mainType !== 'data') {
                                cptQuery.mainType = mainType;
                                cptQuery[propSuffix.toLowerCase()] = val;
                                reserved = true;
                            }
                        }
                    }
                    if (dataKeys_1.hasOwnProperty(key)) {
                        dataQuery[key] = val;
                        reserved = true;
                    }
                    if (!reserved) otherQuery[key] = val;
                });
            }
            return {
                cptQuery: cptQuery,
                dataQuery: dataQuery,
                otherQuery: otherQuery
            };
        };
        ECEventProcessor.prototype.filter = function(eventType, query) {
            var eventInfo = this.eventInfo;
            if (!eventInfo) return true;
            var targetEl = eventInfo.targetEl;
            var packedEvent = eventInfo.packedEvent;
            var model = eventInfo.model;
            var view = eventInfo.view;
            if (!model || !view) return true;
            var cptQuery = query.cptQuery;
            var dataQuery = query.dataQuery;
            return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
            function check(query, host, prop, propOnHost) {
                return query[prop] == null || host[propOnHost || prop] === query[prop];
            }
        };
        ECEventProcessor.prototype.afterTrigger = function() {
            this.eventInfo = null;
        };
        return ECEventProcessor;
    }();
});
parcelRegister("7wiHx", function(module, exports) {
    $parcel$export(module.exports, "seriesSymbolTask", ()=>$579a0738784e30ca$export$144ac3beded415d9);
    $parcel$export(module.exports, "dataSymbolTask", ()=>$579a0738784e30ca$export$435b956f7f1071fb);
    var $bahqM;
    var $579a0738784e30ca$export$144ac3beded415d9 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
            if (!seriesModel.hasSymbolVisual) return;
            var symbolType = seriesModel.get('symbol');
            var symbolSize = seriesModel.get('symbolSize');
            var keepAspect = seriesModel.get('symbolKeepAspect');
            var symbolRotate = seriesModel.get('symbolRotate');
            var symbolOffset = seriesModel.get('symbolOffset');
            var hasSymbolTypeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolType);
            var hasSymbolSizeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolSize);
            var hasSymbolRotateCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolRotate);
            var hasSymbolOffsetCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolOffset);
            var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
            var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
            var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
            var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
            var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
            data.setVisual({
                legendIcon: seriesModel.legendIcon || seriesSymbol,
                symbol: seriesSymbol,
                symbolSize: seriesSymbolSize,
                symbolKeepAspect: keepAspect,
                symbolRotate: seriesSymbolRotate,
                symbolOffset: seriesSymbolOffset
            });
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            function dataEach(data, idx) {
                var rawValue = seriesModel.getRawValue(idx);
                var params = seriesModel.getDataParams(idx);
                hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
                hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
                hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
                hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
            }
            return {
                dataEach: hasCallback ? dataEach : null
            };
        }
    };
    var $579a0738784e30ca$export$435b956f7f1071fb = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (!seriesModel.hasSymbolVisual) return;
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            function dataEach(data, idx) {
                var itemModel = data.getItemModel(idx);
                var itemSymbolType = itemModel.getShallow('symbol', true);
                var itemSymbolSize = itemModel.getShallow('symbolSize', true);
                var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
                var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
                var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true);
                if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
                if (itemSymbolSize != null) data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
                if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
                if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
                if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
            }
            return {
                dataEach: data.hasItemOption ? dataEach : null
            };
        }
    };
});
parcelRegister("fk5Gm", function(module, exports) {
    $parcel$export(module.exports, "getItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$91d919a86b2df624);
    $parcel$export(module.exports, "getVisualFromData", ()=>$b27d21a8d98c0d1c$export$d76e333a86ea1a2);
    $parcel$export(module.exports, "setItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$3aab879e9d0e7c75);
    function $b27d21a8d98c0d1c$export$91d919a86b2df624(data, dataIndex, key) {
        switch(key){
            case 'color':
                var style = data.getItemVisual(dataIndex, 'style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getItemVisual(dataIndex, 'style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getItemVisual(dataIndex, key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$d76e333a86ea1a2(data, key) {
        switch(key){
            case 'color':
                var style = data.getVisual('style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getVisual('style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getVisual(key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
        switch(key){
            case 'color':
                var style = data.ensureUniqueItemVisual(dataIndex, 'style');
                style[data.getVisual('drawType')] = value;
                data.setItemVisual(dataIndex, 'colorFromPalette', false);
                break;
            case 'opacity':
                data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
                break;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                data.setItemVisual(dataIndex, key, value);
                break;
            default:
        }
    }
});
parcelRegister("1nKsD", function(module, exports) {
    $parcel$export(module.exports, "createLegacyDataSelectAction", ()=>$101bfa9c2a38d115$export$62942ba95693dbfc);
    $parcel$export(module.exports, "handleLegacySelectEvents", ()=>$101bfa9c2a38d115$export$2575c83262e49d0c);
    var $bahqM;
    var $eaKsF;
    function $101bfa9c2a38d115$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
        function getSeriesIndices(ecModel, payload) {
            var seriesIndices = [];
            ecModel.eachComponent({
                mainType: 'series',
                subType: seriesType,
                query: payload
            }, function(seriesModel) {
                seriesIndices.push(seriesModel.seriesIndex);
            });
            return seriesIndices;
        }
        (0, (0, parcelRequire("bahqM")).each)([
            [
                seriesType + 'ToggleSelect',
                'toggleSelect'
            ],
            [
                seriesType + 'Select',
                'select'
            ],
            [
                seriesType + 'UnSelect',
                'unselect'
            ]
        ], function(eventsMap) {
            ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
                payload = (0, (0, parcelRequire("bahqM")).extend)({}, payload);
                api.dispatchAction((0, (0, parcelRequire("bahqM")).extend)(payload, {
                    type: eventsMap[1],
                    seriesIndex: getSeriesIndices(ecModel, payload)
                }));
            });
        });
    }
    function $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
        var legacyEventName = type + eventPostfix;
        if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
            mainType: 'series',
            subType: 'pie'
        }, function(seriesModel) {
            var seriesIndex = seriesModel.seriesIndex;
            var selected = payload.selected;
            for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
                var data = seriesModel.getData();
                var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload.fromActionPayload);
                ecIns.trigger(legacyEventName, {
                    type: legacyEventName,
                    seriesId: seriesModel.id,
                    name: (0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                    selected: (0, (0, parcelRequire("bahqM")).extend)({}, seriesModel.option.selectedMap)
                });
            }
        });
    }
    function $101bfa9c2a38d115$export$2575c83262e49d0c(messageCenter, ecIns, api) {
        messageCenter.on('selectchanged', function(params) {
            var ecModel = api.getModel();
            if (params.isFromClick) {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
            } else if (params.fromAction === 'select') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
            } else if (params.fromAction === 'unselect') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
            }
        });
    }
});
parcelRegister("6IsbX", function(module, exports) {
    $parcel$export(module.exports, "findEventDispatcher", ()=>$4e3cb87918e3df6d$export$8a4fca9e04eb4df6);
    function $4e3cb87918e3df6d$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
        var found;
        while(target){
            if (det(target)) {
                found = target;
                if (returnFirstMatch) break;
            }
            target = target.__hostTarget || target.parent;
        }
        return found;
    }
});
parcelRegister("g2DhS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$badb4ee06d190426$export$2e2bcd8739ae039);
    var $9LEsz;
    function $badb4ee06d190426$export$2e2bcd8739ae039(ecModel, api) {
        ecModel.eachRawSeries(function(seriesModel) {
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            if (data.hasItemVisual()) data.each(function(idx) {
                var decal = data.getItemVisual(idx, 'decal');
                if (decal) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    itemStyle.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
                }
            });
            var decal = data.getVisual('decal');
            if (decal) {
                var style = data.getVisual('style');
                style.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
            }
        });
    }
});
parcelRegister("9LEsz", function(module, exports) {
    $parcel$export(module.exports, "createOrUpdatePatternFromDecal", ()=>$71c7e35019979000$export$a3ba048e1a648972);
    var $822uQ;
    var $h4RuA;
    var $bahqM;
    var $jmSNG;
    var $7yklO;
    var $aSzOj;
    var $71c7e35019979000$var$decalMap = new (0, (0, parcelRequire("822uQ")).default)();
    var $71c7e35019979000$var$decalCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    var $71c7e35019979000$var$decalKeys = [
        'symbol',
        'symbolSize',
        'symbolKeepAspect',
        'color',
        'backgroundColor',
        'dashArrayX',
        'dashArrayY',
        'maxTileWidth',
        'maxTileHeight'
    ];
    function $71c7e35019979000$export$a3ba048e1a648972(decalObject, api) {
        if (decalObject === 'none') return null;
        var dpr = api.getDevicePixelRatio();
        var zr = api.getZr();
        var isSVG = zr.painter.type === 'svg';
        if (decalObject.dirty) $71c7e35019979000$var$decalMap["delete"](decalObject);
        var oldPattern = $71c7e35019979000$var$decalMap.get(decalObject);
        if (oldPattern) return oldPattern;
        var decalOpt = (0, (0, parcelRequire("bahqM")).defaults)(decalObject, {
            symbol: 'rect',
            symbolSize: 1,
            symbolKeepAspect: true,
            color: 'rgba(0, 0, 0, 0.2)',
            backgroundColor: null,
            dashArrayX: 5,
            dashArrayY: 5,
            rotation: 0,
            maxTileWidth: 512,
            maxTileHeight: 512
        });
        if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
        var pattern = {
            repeat: 'repeat'
        };
        setPatternnSource(pattern);
        pattern.rotation = decalOpt.rotation;
        pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
        $71c7e35019979000$var$decalMap.set(decalObject, pattern);
        decalObject.dirty = false;
        return pattern;
        function setPatternnSource(pattern) {
            var keys = [
                dpr
            ];
            var isValidKey = true;
            for(var i = 0; i < $71c7e35019979000$var$decalKeys.length; ++i){
                var value = decalOpt[$71c7e35019979000$var$decalKeys[i]];
                var valueType = typeof value;
                if (value != null && !(0, (0, parcelRequire("bahqM")).isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                    isValidKey = false;
                    break;
                }
                keys.push(value);
            }
            var cacheKey;
            if (isValidKey) {
                cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
                var cache = $71c7e35019979000$var$decalCache.get(cacheKey);
                if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
            }
            var dashArrayX = $71c7e35019979000$var$normalizeDashArrayX(decalOpt.dashArrayX);
            var dashArrayY = $71c7e35019979000$var$normalizeDashArrayY(decalOpt.dashArrayY);
            var symbolArray = $71c7e35019979000$var$normalizeSymbolArray(decalOpt.symbol);
            var lineBlockLengthsX = $71c7e35019979000$var$getLineBlockLengthX(dashArrayX);
            var lineBlockLengthY = $71c7e35019979000$var$getLineBlockLengthY(dashArrayY);
            var canvas = !isSVG && (0, (0, parcelRequire("bahqM")).createCanvas)();
            var svgRoot = isSVG && zr.painter.createSVGElement('g');
            var pSize = getPatternSize();
            var ctx;
            if (canvas) {
                canvas.width = pSize.width * dpr;
                canvas.height = pSize.height * dpr;
                ctx = canvas.getContext('2d');
            }
            brushDecal();
            if (isValidKey) $71c7e35019979000$var$decalCache.put(cacheKey, canvas || svgRoot);
            pattern.image = canvas;
            pattern.svgElement = svgRoot;
            pattern.svgWidth = pSize.width;
            pattern.svgHeight = pSize.height;
            function getPatternSize() {
                var width = 1;
                for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
                var symbolRepeats = 1;
                for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
                width *= symbolRepeats;
                var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
                var warn;
                return {
                    width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                    height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
                };
            }
            function brushDecal() {
                if (ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    if (decalOpt.backgroundColor) {
                        ctx.fillStyle = decalOpt.backgroundColor;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                }
                var ySum = 0;
                for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
                if (ySum <= 0) return;
                var y = -lineBlockLengthY;
                var yId = 0;
                var yIdTotal = 0;
                var xId0 = 0;
                while(y < pSize.height){
                    if (yId % 2 === 0) {
                        var symbolYId = yIdTotal / 2 % symbolArray.length;
                        var x = 0;
                        var xId1 = 0;
                        var xId1Total = 0;
                        while(x < pSize.width * 2){
                            var xSum = 0;
                            for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                            if (xSum <= 0) break;
                            if (xId1 % 2 === 0) {
                                var size = (1 - decalOpt.symbolSize) * 0.5;
                                var left = x + dashArrayX[xId0][xId1] * size;
                                var top_1 = y + dashArrayY[yId] * size;
                                var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                                var height = dashArrayY[yId] * decalOpt.symbolSize;
                                var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                                brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                            }
                            x += dashArrayX[xId0][xId1];
                            ++xId1Total;
                            ++xId1;
                            if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                        }
                        ++xId0;
                        if (xId0 === dashArrayX.length) xId0 = 0;
                    }
                    y += dashArrayY[yId];
                    ++yIdTotal;
                    ++yId;
                    if (yId === dashArrayY.length) yId = 0;
                }
                function brushSymbol(x, y, width, height, symbolType) {
                    var scale = isSVG ? 1 : dpr;
                    var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                    if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                    else (0, (0, parcelRequire("aSzOj")).brushSingle)(ctx, symbol);
                }
            }
        }
    }
    function $71c7e35019979000$var$normalizeSymbolArray(symbol) {
        if (!symbol || symbol.length === 0) return [
            [
                'rect'
            ]
        ];
        if (typeof symbol === 'string') return [
            [
                symbol
            ]
        ];
        var isAllString = true;
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
            isAllString = false;
            break;
        }
        if (isAllString) return $71c7e35019979000$var$normalizeSymbolArray([
            symbol
        ]);
        var result = [];
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
            symbol[i]
        ]);
        else result.push(symbol[i]);
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayX(dash) {
        if (!dash || dash.length === 0) return [
            [
                0,
                0
            ]
        ];
        if (typeof dash === 'number') {
            var dashValue = Math.ceil(dash);
            return [
                [
                    dashValue,
                    dashValue
                ]
            ];
        }
        var isAllNumber = true;
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
            isAllNumber = false;
            break;
        }
        if (isAllNumber) return $71c7e35019979000$var$normalizeDashArrayX([
            dash
        ]);
        var result = [];
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
            var dashValue = Math.ceil(dash[i]);
            result.push([
                dashValue,
                dashValue
            ]);
        } else {
            var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash[i], function(n) {
                return Math.ceil(n);
            });
            if (dashValue.length % 2 === 1) result.push(dashValue.concat(dashValue));
            else result.push(dashValue);
        }
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayY(dash) {
        if (!dash || typeof dash === 'object' && dash.length === 0) return [
            0,
            0
        ];
        if (typeof dash === 'number') {
            var dashValue_1 = Math.ceil(dash);
            return [
                dashValue_1,
                dashValue_1
            ];
        }
        var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash, function(n) {
            return Math.ceil(n);
        });
        return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
    }
    function $71c7e35019979000$var$getLineBlockLengthX(dash) {
        return (0, (0, parcelRequire("bahqM")).map)(dash, function(line) {
            return $71c7e35019979000$var$getLineBlockLengthY(line);
        });
    }
    function $71c7e35019979000$var$getLineBlockLengthY(dash) {
        var blockLength = 0;
        for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
        if (dash.length % 2 === 1) return blockLength * 2;
        return blockLength;
    }
});
parcelRegister("822uQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d9072624d2c732b$export$2e2bcd8739ae039);
    var $5d9072624d2c732b$var$wmUniqueIndex = Math.round(Math.random() * 9);
    var $5d9072624d2c732b$var$supportDefineProperty = typeof Object.defineProperty === 'function';
    var $5d9072624d2c732b$var$WeakMap = function() {
        function WeakMap() {
            this._id = '__ec_inner_' + $5d9072624d2c732b$var$wmUniqueIndex++;
        }
        WeakMap.prototype.get = function(key) {
            return this._guard(key)[this._id];
        };
        WeakMap.prototype.set = function(key, value) {
            var target = this._guard(key);
            if ($5d9072624d2c732b$var$supportDefineProperty) Object.defineProperty(target, this._id, {
                value: value,
                enumerable: false,
                configurable: true
            });
            else target[this._id] = value;
            return this;
        };
        WeakMap.prototype["delete"] = function(key) {
            if (this.has(key)) {
                delete this._guard(key)[this._id];
                return true;
            }
            return false;
        };
        WeakMap.prototype.has = function(key) {
            return !!this._guard(key)[this._id];
        };
        WeakMap.prototype._guard = function(key) {
            if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
            return key;
        };
        return WeakMap;
    }();
    var $5d9072624d2c732b$export$2e2bcd8739ae039 = $5d9072624d2c732b$var$WeakMap;
});
parcelRegister("aSzOj", function(module, exports) {
    $parcel$export(module.exports, "createCanvasPattern", ()=>$7ebab9bfc20d8461$export$8eb5db6b7bc27903);
    $parcel$export(module.exports, "brushSingle", ()=>$7ebab9bfc20d8461$export$567881adfc3eb7f3);
    $parcel$export(module.exports, "brush", ()=>$7ebab9bfc20d8461$export$da5d6544e8c27bc1);
    var $lBQ88;
    var $aA4Ws;
    var $63nvx;
    var $dPYp9;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $b7ZX8;
    var $bahqM;
    var $cpB91;
    var $6sllV;
    var $aVawM;
    var $7ebab9bfc20d8461$var$pathProxyForDraw = new (0, (0, parcelRequire("aA4Ws")).default)(true);
    function $7ebab9bfc20d8461$var$styleHasStroke(style) {
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    }
    function $7ebab9bfc20d8461$var$isValidStrokeFillStyle(strokeOrFill) {
        return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
    }
    function $7ebab9bfc20d8461$var$styleHasFill(style) {
        var fill = style.fill;
        return fill != null && fill !== 'none';
    }
    function $7ebab9bfc20d8461$var$doFillPath(ctx, style) {
        if (style.fillOpacity != null && style.fillOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.fillOpacity * style.opacity;
            ctx.fill();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.fill();
    }
    function $7ebab9bfc20d8461$var$doStrokePath(ctx, style) {
        if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.strokeOpacity * style.opacity;
            ctx.stroke();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.stroke();
    }
    function $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, pattern, el) {
        var image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(pattern.image, pattern.__image, el);
        if ((0, (0, parcelRequire("63nvx")).isImageReady)(image)) {
            var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
            if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
                var matrix = new DOMMatrix();
                matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
                matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
                matrix.translateSelf(pattern.x || 0, pattern.y || 0);
                canvasPattern.setTransform(matrix);
            }
            return canvasPattern;
        }
    }
    function $7ebab9bfc20d8461$var$brushPath(ctx, el, style, inBatch) {
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var strokePercent = style.strokePercent;
        var strokePart = strokePercent < 1;
        var firstDraw = !el.path;
        if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
        var path = el.path || $7ebab9bfc20d8461$var$pathProxyForDraw;
        if (!inBatch) {
            var fill = style.fill;
            var stroke = style.stroke;
            var hasFillGradient = hasFill && !!fill.colorStops;
            var hasStrokeGradient = hasStroke && !!stroke.colorStops;
            var hasFillPattern = hasFill && !!fill.image;
            var hasStrokePattern = hasStroke && !!stroke.image;
            var fillGradient = void 0;
            var strokeGradient = void 0;
            var fillPattern = void 0;
            var strokePattern = void 0;
            var rect = void 0;
            if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
            if (hasFillGradient) {
                fillGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
                el.__canvasFillGradient = fillGradient;
            }
            if (hasStrokeGradient) {
                strokeGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
                el.__canvasStrokeGradient = strokeGradient;
            }
            if (hasFillPattern) {
                fillPattern = el.__dirty || !el.__canvasFillPattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
                el.__canvasFillPattern = fillPattern;
            }
            if (hasStrokePattern) {
                strokePattern = el.__dirty || !el.__canvasStrokePattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
                el.__canvasStrokePattern = fillPattern;
            }
            if (hasFillGradient) ctx.fillStyle = fillGradient;
            else if (hasFillPattern) {
                if (fillPattern) ctx.fillStyle = fillPattern;
                else hasFill = false;
            }
            if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
            else if (hasStrokePattern) {
                if (strokePattern) ctx.strokeStyle = strokePattern;
                else hasStroke = false;
            }
        }
        var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
        var lineDashOffset = style.lineDashOffset;
        var ctxLineDash = !!ctx.setLineDash;
        var scale = el.getGlobalScale();
        path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
        if (lineDash) {
            var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
            if (lineScale_1 && lineScale_1 !== 1) {
                lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                    return rawVal / lineScale_1;
                });
                lineDashOffset /= lineScale_1;
            }
        }
        var needsRebuild = true;
        if (firstDraw || el.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
            path.setDPR(ctx.dpr);
            if (strokePart) path.setContext(null);
            else {
                path.setContext(ctx);
                needsRebuild = false;
            }
            path.reset();
            if (lineDash && !ctxLineDash) {
                path.setLineDash(lineDash);
                path.setLineDashOffset(lineDashOffset);
            }
            el.buildPath(path, el.shape, inBatch);
            path.toStatic();
            el.pathUpdated();
        }
        if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
        if (lineDash && ctxLineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (!inBatch) {
            if (style.strokeFirst) {
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
            } else {
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
            }
        }
        if (lineDash && ctxLineDash) ctx.setLineDash([]);
    }
    function $7ebab9bfc20d8461$var$brushImage(ctx, el, style) {
        var image = el.__image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(style.image, el.__image, el, el.onload);
        if (!image || !(0, (0, parcelRequire("63nvx")).isImageReady)(image)) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var width = el.getWidth();
        var height = el.getHeight();
        var aspect = image.width / image.height;
        if (width == null && height != null) width = height * aspect;
        else if (height == null && width != null) height = width / aspect;
        else if (width == null && height == null) {
            width = image.width;
            height = image.height;
        }
        if (style.sWidth && style.sHeight) {
            var sx = style.sx || 0;
            var sy = style.sy || 0;
            ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
        } else if (style.sx && style.sy) {
            var sx = style.sx;
            var sy = style.sy;
            var sWidth = width - sx;
            var sHeight = height - sy;
            ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
        } else ctx.drawImage(image, x, y, width, height);
    }
    function $7ebab9bfc20d8461$var$brushText(ctx, el, style) {
        var text = style.text;
        text != null && (text += '');
        if (text) {
            ctx.font = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            ctx.textAlign = style.textAlign;
            ctx.textBaseline = style.textBaseline;
            var hasLineDash = void 0;
            if (ctx.setLineDash) {
                var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
                var lineDashOffset = style.lineDashOffset;
                if (lineDash) {
                    var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                    if (lineScale_2 && lineScale_2 !== 1) {
                        lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                            return rawVal / lineScale_2;
                        });
                        lineDashOffset /= lineScale_2;
                    }
                    ctx.setLineDash(lineDash);
                    ctx.lineDashOffset = lineDashOffset;
                    hasLineDash = true;
                }
            }
            if (style.strokeFirst) {
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            } else {
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            }
            if (hasLineDash) ctx.setLineDash([]);
        }
    }
    var $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS = [
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    var $7ebab9bfc20d8461$var$STROKE_PROPS = [
        [
            'lineCap',
            'butt'
        ],
        [
            'lineJoin',
            'miter'
        ],
        [
            'miterLimit',
            10
        ]
    ];
    function $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
        var styleChanged = false;
        if (!forceSetAll) {
            prevStyle = prevStyle || {};
            if (style === prevStyle) return false;
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            var opacity = Math.max(Math.min(style.opacity, 1), 0);
            ctx.globalAlpha = isNaN(opacity) ? (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).opacity : opacity;
        }
        if (forceSetAll || style.blend !== prevStyle.blend) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalCompositeOperation = style.blend || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).blend;
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS.length; i++){
            var propName = $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS[i];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = ctx.dpr * (style[propName] || 0);
            }
        }
        if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.shadowColor = style.shadowColor || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).shadowColor;
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        var prevStyle = forceSetAll ? null : prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover) || {};
        if (style === prevStyle) return false;
        var styleChanged = $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
        if (forceSetAll || style.fill !== prevStyle.fill) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
        }
        if (forceSetAll || style.stroke !== prevStyle.stroke) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
        }
        if (el.hasStroke()) {
            var lineWidth = style.lineWidth;
            var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
            if (ctx.lineWidth !== newLineWidth) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx.lineWidth = newLineWidth;
            }
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$STROKE_PROPS.length; i++){
            var prop = $7ebab9bfc20d8461$var$STROKE_PROPS[i];
            var propName = prop[0];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = style[propName] || prop[1];
            }
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
        return $7ebab9bfc20d8461$var$bindCommonProps(ctx, $7ebab9bfc20d8461$var$getStyle(el, scope.inHover), prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
    }
    function $7ebab9bfc20d8461$var$setContextTransform(ctx, el) {
        var m = el.transform;
        var dpr = ctx.dpr || 1;
        if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
        else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope) {
        var allClipped = false;
        for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            allClipped = allClipped || clipPath.isZeroArea();
            $7ebab9bfc20d8461$var$setContextTransform(ctx, clipPath);
            ctx.beginPath();
            clipPath.buildPath(ctx, clipPath.shape);
            ctx.clip();
        }
        scope.allClipped = allClipped;
    }
    function $7ebab9bfc20d8461$var$isTransformChanged(m0, m1) {
        if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
        else if (!m0 && !m1) return false;
        return true;
    }
    var $7ebab9bfc20d8461$var$DRAW_TYPE_PATH = 1;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE = 2;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT = 3;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL = 4;
    function $7ebab9bfc20d8461$var$canPathBatch(style) {
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
    }
    function $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope) {
        scope.batchFill && ctx.fill();
        scope.batchStroke && ctx.stroke();
        scope.batchFill = '';
        scope.batchStroke = '';
    }
    function $7ebab9bfc20d8461$var$getStyle(el, inHover) {
        return inHover ? el.__hoverStyle || el.style : el.style;
    }
    function $7ebab9bfc20d8461$export$567881adfc3eb7f3(ctx, el) {
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, {
            inHover: false,
            viewWidth: 0,
            viewHeight: 0
        }, true);
    }
    function $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
        var m = el.transform;
        if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
            el.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            el.__isRendered = false;
            return;
        }
        var clipPaths = el.__clipPaths;
        var prevElClipPaths = scope.prevElClipPaths;
        var forceSetTransform = false;
        var forceSetStyle = false;
        if (!prevElClipPaths || (0, (0, parcelRequire("dPYp9")).isClipPathChanged)(clipPaths, prevElClipPaths)) {
            if (prevElClipPaths && prevElClipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.restore();
                forceSetStyle = forceSetTransform = true;
                scope.prevElClipPaths = null;
                scope.allClipped = false;
                scope.prevEl = null;
            }
            if (clipPaths && clipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.save();
                $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope);
                forceSetTransform = true;
            }
            scope.prevElClipPaths = clipPaths;
        }
        if (scope.allClipped) {
            el.__isRendered = false;
            return;
        }
        el.beforeBrush && el.beforeBrush();
        el.innerBeforeBrush();
        var prevEl = scope.prevEl;
        if (!prevEl) forceSetStyle = forceSetTransform = true;
        var canBatchPath = el instanceof (0, (0, parcelRequire("ghQ8v")).default) && el.autoBatch && $7ebab9bfc20d8461$var$canPathBatch(el.style);
        if (forceSetTransform || $7ebab9bfc20d8461$var$isTransformChanged(m, prevEl.transform)) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            $7ebab9bfc20d8461$var$setContextTransform(ctx, el);
        } else if (!canBatchPath) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_PATH) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_PATH;
            }
            $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
            $7ebab9bfc20d8461$var$brushPath(ctx, el, style, canBatchPath);
            if (canBatchPath) {
                scope.batchFill = style.fill || '';
                scope.batchStroke = style.stroke || '';
            }
        } else {
            if (el instanceof (0, (0, parcelRequire("45jlh")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT;
                }
                $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushText(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE;
                }
                $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushImage(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("6sllV")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL;
                }
                $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope);
            }
        }
        if (canBatchPath && isLast) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        el.innerAfterBrush();
        el.afterBrush && el.afterBrush();
        scope.prevEl = el;
        el.__dirty = 0;
        el.__isRendered = true;
    }
    function $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope) {
        var displayables = el.getDisplayables();
        var temporalDisplayables = el.getTemporalDisplayables();
        ctx.save();
        var innerScope = {
            prevElClipPaths: null,
            prevEl: null,
            allClipped: false,
            viewWidth: scope.viewWidth,
            viewHeight: scope.viewHeight,
            inHover: scope.inHover
        };
        var i;
        var len;
        for(i = el.getCursor(), len = displayables.length; i < len; i++){
            var displayable = displayables[i];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
            var displayable = temporalDisplayables[i_1];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        el.clearTemporalDisplayables();
        el.notClear = true;
        ctx.restore();
    }
});
parcelRegister("dPYp9", function(module, exports) {
    $parcel$export(module.exports, "getCanvasGradient", ()=>$a12ee4e4c244a026$export$3dab6afd018d48c7);
    $parcel$export(module.exports, "isClipPathChanged", ()=>$a12ee4e4c244a026$export$beeddc5150cb2e83);
    function $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect) {
        var x = obj.x == null ? 0 : obj.x;
        var x2 = obj.x2 == null ? 1 : obj.x2;
        var y = obj.y == null ? 0 : obj.y;
        var y2 = obj.y2 == null ? 0 : obj.y2;
        if (!obj.global) {
            x = x * rect.width + rect.x;
            x2 = x2 * rect.width + rect.x;
            y = y * rect.height + rect.y;
            y2 = y2 * rect.height + rect.y;
        }
        x = isNaN(x) ? 0 : x;
        x2 = isNaN(x2) ? 1 : x2;
        y = isNaN(y) ? 0 : y;
        y2 = isNaN(y2) ? 0 : y2;
        var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) {
        var width = rect.width;
        var height = rect.height;
        var min = Math.min(width, height);
        var x = obj.x == null ? 0.5 : obj.x;
        var y = obj.y == null ? 0.5 : obj.y;
        var r = obj.r == null ? 0.5 : obj.r;
        if (!obj.global) {
            x = x * width + rect.x;
            y = y * height + rect.y;
            r = r * min;
        }
        var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$3dab6afd018d48c7(ctx, obj, rect) {
        var canvasGradient = obj.type === 'radial' ? $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) : $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect);
        var colorStops = obj.colorStops;
        for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
        if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
        if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
        for(var i = 0; i < clipPaths.length; i++){
            if (clipPaths[i] !== prevClipPaths[i]) return true;
        }
        return false;
    }
});
parcelRegister("cpB91", function(module, exports) {
    $parcel$export(module.exports, "normalizeLineDash", ()=>$9094a1fa7d97ce08$export$9efb2ae8a603855d);
    var $bahqM;
    function $9094a1fa7d97ce08$export$9efb2ae8a603855d(lineType, lineWidth) {
        if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
        lineWidth = lineWidth || 1;
        return lineType === 'dashed' ? [
            4 * lineWidth,
            2 * lineWidth
        ] : lineType === 'dotted' ? [
            lineWidth
        ] : (0, (0, parcelRequire("bahqM")).isNumber)(lineType) ? [
            lineType
        ] : (0, (0, parcelRequire("bahqM")).isArray)(lineType) ? lineType : null;
    }
});
parcelRegister("fEzwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65624d7bef03239$export$2e2bcd8739ae039);
    var $bahqM;
    var $fBEGW;
    var $2iWFB;
    var $b65624d7bef03239$var$storage = (0, (0, parcelRequire("bahqM")).createHashMap)();
    var $b65624d7bef03239$export$2e2bcd8739ae039 = {
        registerMap: function(mapName, rawDef, rawSpecialAreas) {
            if (rawDef.svg) {
                var resource = new (0, (0, parcelRequire("fBEGW")).GeoSVGResource)(mapName, rawDef.svg);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            } else {
                var geoJSON = rawDef.geoJson || rawDef.geoJSON;
                if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
                else geoJSON = rawDef;
                var resource = new (0, (0, parcelRequire("2iWFB")).GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            }
        },
        getGeoResource: function(mapName) {
            return $b65624d7bef03239$var$storage.get(mapName);
        },
        getMapForUser: function(mapName) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            return resource && resource.type === 'geoJSON' && resource.getMapForUser();
        },
        load: function(mapName, nameMap, nameProperty) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            if (!resource) return;
            return resource.load(nameMap, nameProperty);
        }
    };
});
parcelRegister("fBEGW", function(module, exports) {
    $parcel$export(module.exports, "GeoSVGResource", ()=>$b5c9e032bcec003b$export$be52c950efae1f84);
    var $KN3aA;
    var $4KVOr;
    var $7Tw7u;
    var $bahqM;
    var $1E3E8;
    var $bsT8u;
    var $b8QyH;
    var $b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'rect',
        'circle',
        'line',
        'ellipse',
        'polygon',
        'polyline',
        'path',
        'text',
        'tspan',
        'g'
    ]);
    var $b5c9e032bcec003b$export$be52c950efae1f84 = function() {
        function GeoSVGResource(mapName, svg) {
            this.type = 'geoSVG';
            this._usedGraphicMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._freedGraphics = [];
            this._mapName = mapName;
            this._parsedXML = (0, (0, parcelRequire("bsT8u")).parseXML)(svg);
        }
        GeoSVGResource.prototype.load = function() {
            var firstGraphic = this._firstGraphic;
            if (!firstGraphic) {
                firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
                this._freedGraphics.push(firstGraphic);
                this._boundingRect = this._firstGraphic.boundingRect.clone();
                var _a = $b5c9e032bcec003b$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
                this._regions = regions;
                this._regionsMap = regionsMap;
            }
            return {
                boundingRect: this._boundingRect,
                regions: this._regions,
                regionsMap: this._regionsMap
            };
        };
        GeoSVGResource.prototype._buildGraphic = function(svgXML) {
            var result;
            var rootFromParse;
            try {
                result = svgXML && (0, (0, parcelRequire("KN3aA")).parseSVG)(svgXML, {
                    ignoreViewBox: true,
                    ignoreRootClip: true
                }) || {};
                rootFromParse = result.root;
                (0, (0, parcelRequire("bahqM")).assert)(rootFromParse != null);
            } catch (e) {
                throw new Error('Invalid svg format\n' + e.message);
            }
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            root.add(rootFromParse);
            root.isGeoSVGGraphicRoot = true;
            var svgWidth = result.width;
            var svgHeight = result.height;
            var viewBoxRect = result.viewBoxRect;
            var boundingRect = this._boundingRect;
            if (!boundingRect) {
                var bRectX = void 0;
                var bRectY = void 0;
                var bRectWidth = void 0;
                var bRectHeight = void 0;
                if (svgWidth != null) {
                    bRectX = 0;
                    bRectWidth = svgWidth;
                } else if (viewBoxRect) {
                    bRectX = viewBoxRect.x;
                    bRectWidth = viewBoxRect.width;
                }
                if (svgHeight != null) {
                    bRectY = 0;
                    bRectHeight = svgHeight;
                } else if (viewBoxRect) {
                    bRectY = viewBoxRect.y;
                    bRectHeight = viewBoxRect.height;
                }
                if (bRectX == null || bRectY == null) {
                    var calculatedBoundingRect = rootFromParse.getBoundingRect();
                    if (bRectX == null) {
                        bRectX = calculatedBoundingRect.x;
                        bRectWidth = calculatedBoundingRect.width;
                    }
                    if (bRectY == null) {
                        bRectY = calculatedBoundingRect.y;
                        bRectHeight = calculatedBoundingRect.height;
                    }
                }
                boundingRect = this._boundingRect = new (0, (0, parcelRequire("1E3E8")).default)(bRectX, bRectY, bRectWidth, bRectHeight);
            }
            if (viewBoxRect) {
                var viewBoxTransform = (0, (0, parcelRequire("KN3aA")).makeViewBoxTransform)(viewBoxRect, boundingRect);
                rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
                rootFromParse.x = viewBoxTransform.x;
                rootFromParse.y = viewBoxTransform.y;
            }
            root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: boundingRect.plain()
            }));
            var named = [];
            (0, (0, parcelRequire("bahqM")).each)(result.named, function(namedItem) {
                if ($b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                    named.push(namedItem);
                    $b5c9e032bcec003b$var$setSilent(namedItem.el);
                }
            });
            return {
                root: root,
                boundingRect: boundingRect,
                named: named
            };
        };
        GeoSVGResource.prototype.useGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) return svgGraphic;
            svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
            usedRootMap.set(hostKey, svgGraphic);
            return svgGraphic;
        };
        GeoSVGResource.prototype.freeGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) {
                usedRootMap.removeKey(hostKey);
                this._freedGraphics.push(svgGraphic);
            }
        };
        return GeoSVGResource;
    }();
    function $b5c9e032bcec003b$var$setSilent(el) {
        el.silent = false;
        if (el.isGroup) el.traverse(function(child) {
            child.silent = false;
        });
    }
    function $b5c9e032bcec003b$var$createRegions(named) {
        var regions = [];
        var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(named, function(namedItem) {
            if (namedItem.namedFrom != null) return;
            var region = new (0, (0, parcelRequire("b8QyH")).GeoSVGRegion)(namedItem.name, namedItem.el);
            regions.push(region);
            regionsMap.set(namedItem.name, region);
        });
        return {
            regions: regions,
            regionsMap: regionsMap
        };
    }
});
parcelRegister("KN3aA", function(module, exports) {
    $parcel$export(module.exports, "makeViewBoxTransform", ()=>$08ca58536684a52b$export$3e2db4420f14f50f);
    $parcel$export(module.exports, "parseSVG", ()=>$08ca58536684a52b$export$1919f5101c220601);
    var $4KVOr;
    var $gcbBH;
    var $jjfok;
    var $7Tw7u;
    var $kVeV8;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $izqgC;
    var $id1Rd;
    var $bahqM;
    var $9J7f8;
    var $faICo;
    var $45jlh;
    var $bsT8u;
    var $08ca58536684a52b$var$nodeParsers;
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
        'fill': 'fill',
        'stroke': 'stroke',
        'stroke-width': 'lineWidth',
        'opacity': 'opacity',
        'fill-opacity': 'fillOpacity',
        'stroke-opacity': 'strokeOpacity',
        'stroke-dasharray': 'lineDash',
        'stroke-dashoffset': 'lineDashOffset',
        'stroke-linecap': 'lineCap',
        'stroke-linejoin': 'lineJoin',
        'stroke-miterlimit': 'miterLimit',
        'font-family': 'fontFamily',
        'font-size': 'fontSize',
        'font-style': 'fontStyle',
        'font-weight': 'fontWeight',
        'text-anchor': 'textAlign',
        'visibility': 'visibility',
        'display': 'display'
    };
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP = {
        'alignment-baseline': 'textBaseline',
        'stop-color': 'stopColor'
    };
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SVGParser = function() {
        function SVGParser() {
            this._defs = {};
            this._root = null;
        }
        SVGParser.prototype.parse = function(xml, opt) {
            opt = opt || {};
            var svg = (0, (0, parcelRequire("bsT8u")).parseXML)(xml);
            if (!svg) throw new Error('Illegal svg');
            this._defsUsePending = [];
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            this._root = root;
            var named = [];
            var viewBox = svg.getAttribute('viewBox') || '';
            var width = parseFloat(svg.getAttribute('width') || opt.width);
            var height = parseFloat(svg.getAttribute('height') || opt.height);
            isNaN(width) && (width = null);
            isNaN(height) && (height = null);
            $08ca58536684a52b$var$parseAttributes(svg, root, null, true, false);
            var child = svg.firstChild;
            while(child){
                this._parseNode(child, root, named, null, false, false);
                child = child.nextSibling;
            }
            $08ca58536684a52b$var$applyDefs(this._defs, this._defsUsePending);
            this._defsUsePending = [];
            var viewBoxRect;
            var viewBoxTransform;
            if (viewBox) {
                var viewBoxArr = $08ca58536684a52b$var$splitNumberSequence(viewBox);
                if (viewBoxArr.length >= 4) viewBoxRect = {
                    x: parseFloat(viewBoxArr[0] || 0),
                    y: parseFloat(viewBoxArr[1] || 0),
                    width: parseFloat(viewBoxArr[2]),
                    height: parseFloat(viewBoxArr[3])
                };
            }
            if (viewBoxRect && width != null && height != null) {
                viewBoxTransform = $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                });
                if (!opt.ignoreViewBox) {
                    var elRoot = root;
                    root = new (0, (0, parcelRequire("4KVOr")).default)();
                    root.add(elRoot);
                    elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                    elRoot.x = viewBoxTransform.x;
                    elRoot.y = viewBoxTransform.y;
                }
            }
            if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                }
            }));
            return {
                root: root,
                width: width,
                height: height,
                viewBoxRect: viewBoxRect,
                viewBoxTransform: viewBoxTransform,
                named: named
            };
        };
        SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
            var nodeName = xmlNode.nodeName.toLowerCase();
            var el;
            var namedFromForSub = namedFrom;
            if (nodeName === 'defs') isInDefs = true;
            if (nodeName === 'text') isInText = true;
            if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
            else {
                if (!isInDefs) {
                    var parser_1 = $08ca58536684a52b$var$nodeParsers[nodeName];
                    if (parser_1 && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$nodeParsers, nodeName)) {
                        el = parser_1.call(this, xmlNode, parentGroup);
                        var nameAttr = xmlNode.getAttribute('name');
                        if (nameAttr) {
                            var newNamed = {
                                name: nameAttr,
                                namedFrom: null,
                                svgNodeTagLower: nodeName,
                                el: el
                            };
                            named.push(newNamed);
                            if (nodeName === 'g') namedFromForSub = newNamed;
                        } else if (namedFrom) named.push({
                            name: namedFrom.name,
                            namedFrom: namedFrom,
                            svgNodeTagLower: nodeName,
                            el: el
                        });
                        parentGroup.add(el);
                    }
                }
                var parser = $08ca58536684a52b$var$paintServerParsers[nodeName];
                if (parser && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$paintServerParsers, nodeName)) {
                    var def = parser.call(this, xmlNode);
                    var id = xmlNode.getAttribute('id');
                    if (id) this._defs[id] = def;
                }
            }
            if (el && el.isGroup) {
                var child = xmlNode.firstChild;
                while(child){
                    if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                    else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                    child = child.nextSibling;
                }
            }
        };
        SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
            var text = new (0, (0, parcelRequire("45jlh")).default)({
                style: {
                    text: xmlNode.textContent
                },
                silent: true,
                x: this._textX || 0,
                y: this._textY || 0
            });
            $08ca58536684a52b$var$inheritStyle(parentGroup, text);
            $08ca58536684a52b$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
            $08ca58536684a52b$var$applyTextAlignment(text, parentGroup);
            var textStyle = text.style;
            var fontSize = textStyle.fontSize;
            if (fontSize && fontSize < 9) {
                textStyle.fontSize = 9;
                text.scaleX *= fontSize / 9;
                text.scaleY *= fontSize / 9;
            }
            var font = (textStyle.fontSize || textStyle.fontFamily) && [
                textStyle.fontStyle,
                textStyle.fontWeight,
                (textStyle.fontSize || 12) + 'px',
                textStyle.fontFamily || 'sans-serif'
            ].join(' ');
            textStyle.font = font;
            var rect = text.getBoundingRect();
            this._textX += rect.width;
            parentGroup.add(text);
            return text;
        };
        SVGParser.internalField = function() {
            $08ca58536684a52b$var$nodeParsers = {
                'g': function(xmlNode, parentGroup) {
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                    return g;
                },
                'rect': function(xmlNode, parentGroup) {
                    var rect = new (0, (0, parcelRequire("7Tw7u")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, rect);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                    rect.setShape({
                        x: parseFloat(xmlNode.getAttribute('x') || '0'),
                        y: parseFloat(xmlNode.getAttribute('y') || '0'),
                        width: parseFloat(xmlNode.getAttribute('width') || '0'),
                        height: parseFloat(xmlNode.getAttribute('height') || '0')
                    });
                    rect.silent = true;
                    return rect;
                },
                'circle': function(xmlNode, parentGroup) {
                    var circle = new (0, (0, parcelRequire("jjfok")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, circle);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                    circle.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        r: parseFloat(xmlNode.getAttribute('r') || '0')
                    });
                    circle.silent = true;
                    return circle;
                },
                'line': function(xmlNode, parentGroup) {
                    var line = new (0, (0, parcelRequire("cZb1F")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, line);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                    line.setShape({
                        x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                        y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                        x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                        y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                    });
                    line.silent = true;
                    return line;
                },
                'ellipse': function(xmlNode, parentGroup) {
                    var ellipse = new (0, (0, parcelRequire("kVeV8")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, ellipse);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                    ellipse.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                        ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                    });
                    ellipse.silent = true;
                    return ellipse;
                },
                'polygon': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polygon = new (0, (0, parcelRequire("lQwBc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polygon);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                    return polygon;
                },
                'polyline': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polyline = new (0, (0, parcelRequire("32bXc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polyline);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                    return polyline;
                },
                'image': function(xmlNode, parentGroup) {
                    var img = new (0, (0, parcelRequire("gcbBH")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, img);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                    img.setStyle({
                        image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                        x: +xmlNode.getAttribute('x'),
                        y: +xmlNode.getAttribute('y'),
                        width: +xmlNode.getAttribute('width'),
                        height: +xmlNode.getAttribute('height')
                    });
                    img.silent = true;
                    return img;
                },
                'text': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x') || '0';
                    var y = xmlNode.getAttribute('y') || '0';
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    this._textX = parseFloat(x) + parseFloat(dx);
                    this._textY = parseFloat(y) + parseFloat(dy);
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    return g;
                },
                'tspan': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x');
                    var y = xmlNode.getAttribute('y');
                    if (x != null) this._textX = parseFloat(x);
                    if (y != null) this._textY = parseFloat(y);
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    this._textX += parseFloat(dx);
                    this._textY += parseFloat(dy);
                    return g;
                },
                'path': function(xmlNode, parentGroup) {
                    var d = xmlNode.getAttribute('d') || '';
                    var path = (0, (0, parcelRequire("id1Rd")).createFromString)(d);
                    $08ca58536684a52b$var$inheritStyle(parentGroup, path);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                    path.silent = true;
                    return path;
                }
            };
        }();
        return SVGParser;
    }();
    var $08ca58536684a52b$var$paintServerParsers = {
        'lineargradient': function(xmlNode) {
            var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
            var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
            var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
            var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
            var gradient = new (0, (0, parcelRequire("9J7f8")).default)(x1, y1, x2, y2);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        },
        'radialgradient': function(xmlNode) {
            var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
            var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
            var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
            var gradient = new (0, (0, parcelRequire("faICo")).default)(cx, cy, r);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        }
    };
    function $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient) {
        var gradientUnits = xmlNode.getAttribute('gradientUnits');
        if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
    }
    function $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient) {
        var stop = xmlNode.firstChild;
        while(stop){
            if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
                var offsetStr = stop.getAttribute('offset');
                var offset = void 0;
                if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
                else if (offsetStr) offset = parseFloat(offsetStr);
                else offset = 0;
                var styleVals = {};
                $08ca58536684a52b$var$parseInlineStyle(stop, styleVals, styleVals);
                var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
                gradient.colorStops.push({
                    offset: offset,
                    color: stopColor
                });
            }
            stop = stop.nextSibling;
        }
    }
    function $08ca58536684a52b$var$inheritStyle(parent, child) {
        if (parent && parent.__inheritedStyle) {
            if (!child.__inheritedStyle) child.__inheritedStyle = {};
            (0, (0, parcelRequire("bahqM")).defaults)(child.__inheritedStyle, parent.__inheritedStyle);
        }
    }
    function $08ca58536684a52b$var$parsePoints(pointsString) {
        var list = $08ca58536684a52b$var$splitNumberSequence(pointsString);
        var points = [];
        for(var i = 0; i < list.length; i += 2){
            var x = parseFloat(list[i]);
            var y = parseFloat(list[i + 1]);
            points.push([
                x,
                y
            ]);
        }
        return points;
    }
    function $08ca58536684a52b$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
        var disp = el;
        var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
        var selfStyle = {};
        if (xmlNode.nodeType === 1) {
            $08ca58536684a52b$var$parseTransformAttribute(xmlNode, el);
            $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
            if (!onlyInlineStyle) $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
        }
        disp.style = disp.style || {};
        if (inheritedStyle.fill != null) disp.style.fill = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
        if (inheritedStyle.stroke != null) disp.style.stroke = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
        (0, (0, parcelRequire("bahqM")).each)([
            'lineWidth',
            'opacity',
            'fillOpacity',
            'strokeOpacity',
            'miterLimit',
            'fontSize'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
        });
        (0, (0, parcelRequire("bahqM")).each)([
            'lineDashOffset',
            'lineCap',
            'lineJoin',
            'fontWeight',
            'fontFamily',
            'fontStyle',
            'textAlign'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
        });
        if (isTextGroup) disp.__selfStyle = selfStyle;
        if (inheritedStyle.lineDash) disp.style.lineDash = (0, (0, parcelRequire("bahqM")).map)($08ca58536684a52b$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
            return parseFloat(str);
        });
        if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
        if (inheritedStyle.display === 'none') disp.ignore = true;
    }
    function $08ca58536684a52b$var$applyTextAlignment(text, parentGroup) {
        var parentSelfStyle = parentGroup.__selfStyle;
        if (parentSelfStyle) {
            var textBaseline = parentSelfStyle.textBaseline;
            var zrTextBaseline = textBaseline;
            if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
            else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
            else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
            text.style.textBaseline = zrTextBaseline;
        }
        var parentInheritedStyle = parentGroup.__inheritedStyle;
        if (parentInheritedStyle) {
            var textAlign = parentInheritedStyle.textAlign;
            var zrTextAlign = textAlign;
            if (textAlign) {
                if (textAlign === 'middle') zrTextAlign = 'center';
                text.style.textAlign = zrTextAlign;
            }
        }
    }
    var $08ca58536684a52b$var$urlRegex = /^url\(\s*#(.*?)\)/;
    function $08ca58536684a52b$var$getFillStrokeStyle(el, method, str, defsUsePending) {
        var urlMatch = str && str.match($08ca58536684a52b$var$urlRegex);
        if (urlMatch) {
            var url = (0, (0, parcelRequire("bahqM")).trim)(urlMatch[1]);
            defsUsePending.push([
                el,
                method,
                url
            ]);
            return;
        }
        if (str === 'none') str = null;
        return str;
    }
    function $08ca58536684a52b$var$applyDefs(defs, defsUsePending) {
        for(var i = 0; i < defsUsePending.length; i++){
            var item = defsUsePending[i];
            item[0].style[item[1]] = defs[item[2]];
        }
    }
    var $08ca58536684a52b$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $08ca58536684a52b$var$splitNumberSequence(rawStr) {
        return rawStr.match($08ca58536684a52b$var$numberReg) || [];
    }
    var $08ca58536684a52b$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
    var $08ca58536684a52b$var$DEGREE_TO_ANGLE = Math.PI / 180;
    function $08ca58536684a52b$var$parseTransformAttribute(xmlNode, node) {
        var transform = xmlNode.getAttribute('transform');
        if (transform) {
            transform = transform.replace(/,/g, ' ');
            var transformOps_1 = [];
            var mt = null;
            transform.replace($08ca58536684a52b$var$transformRegex, function(str, type, value) {
                transformOps_1.push(type, value);
                return '';
            });
            for(var i = transformOps_1.length - 1; i > 0; i -= 2){
                var value = transformOps_1[i];
                var type = transformOps_1[i - 1];
                var valueArr = $08ca58536684a52b$var$splitNumberSequence(value);
                mt = mt || (0, parcelRequire("izqgC")).create();
                switch(type){
                    case 'translate':
                        (0, parcelRequire("izqgC")).translate(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || '0')
                        ]);
                        break;
                    case 'scale':
                        (0, parcelRequire("izqgC")).scale(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || valueArr[0])
                        ]);
                        break;
                    case 'rotate':
                        (0, parcelRequire("izqgC")).rotate(mt, mt, -parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        break;
                    case 'skewX':
                        var sx = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            0,
                            sx,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'skewY':
                        var sy = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            sy,
                            0,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'matrix':
                        mt[0] = parseFloat(valueArr[0]);
                        mt[1] = parseFloat(valueArr[1]);
                        mt[2] = parseFloat(valueArr[2]);
                        mt[3] = parseFloat(valueArr[3]);
                        mt[4] = parseFloat(valueArr[4]);
                        mt[5] = parseFloat(valueArr[5]);
                        break;
                }
            }
            node.setLocalTransform(mt);
        }
    }
    var $08ca58536684a52b$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
    function $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        var style = xmlNode.getAttribute('style');
        if (!style) return;
        $08ca58536684a52b$var$styleRegex.lastIndex = 0;
        var styleRegResult;
        while((styleRegResult = $08ca58536684a52b$var$styleRegex.exec(style)) != null){
            var svgStlAttr = styleRegResult[1];
            var zrInheritableStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
            var zrSelfStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
        }
    }
    function $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        for(var i = 0; i < $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) inheritableStyleResult[$08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
        for(var i = 0; i < $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) selfStyleResult[$08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
    function $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
        var scaleX = boundingRect.width / viewBoxRect.width;
        var scaleY = boundingRect.height / viewBoxRect.height;
        var scale = Math.min(scaleX, scaleY);
        return {
            scale: scale,
            x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
            y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
        };
    }
    function $08ca58536684a52b$export$1919f5101c220601(xml, opt) {
        var parser = new $08ca58536684a52b$var$SVGParser();
        return parser.parse(xml, opt);
    }
});
parcelRegister("bsT8u", function(module, exports) {
    $parcel$export(module.exports, "parseXML", ()=>$858d140ea42b55af$export$eacefc55fad2867e);
    var $bahqM;
    function $858d140ea42b55af$export$eacefc55fad2867e(svg) {
        if ((0, (0, parcelRequire("bahqM")).isString)(svg)) {
            var parser = new DOMParser();
            svg = parser.parseFromString(svg, 'text/xml');
        }
        var svgNode = svg;
        if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
        while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
        return svgNode;
    }
});
parcelRegister("b8QyH", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONRegion", ()=>$81c9361a69c93c5f$export$ee84fcb463f24b3d);
    $parcel$export(module.exports, "GeoSVGRegion", ()=>$81c9361a69c93c5f$export$5f3d89e7254f3e69);
    var $3VFsf;
    var $1E3E8;
    var $13I82;
    var $eLEew;
    var $hjZ9y;
    var $izqgC;
    var $81c9361a69c93c5f$var$TMP_TRANSFORM = [];
    var $81c9361a69c93c5f$export$b1f97c3099fc6872 = function() {
        function Region(name) {
            this.name = name;
        }
        Region.prototype.getCenter = function() {
            return;
        };
        return Region;
    }();
    var $81c9361a69c93c5f$export$ee84fcb463f24b3d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoJSONRegion, _super);
        function GeoJSONRegion(name, geometries, cp) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoJSON';
            _this.geometries = geometries;
            if (!cp) {
                var rect = _this.getBoundingRect();
                cp = [
                    rect.x + rect.width / 2,
                    rect.y + rect.height / 2
                ];
            } else cp = [
                cp[0],
                cp[1]
            ];
            _this._center = cp;
            return _this;
        }
        GeoJSONRegion.prototype.getBoundingRect = function() {
            var rect = this._rect;
            if (rect) return rect;
            var MAX_NUMBER = Number.MAX_VALUE;
            var min = [
                MAX_NUMBER,
                MAX_NUMBER
            ];
            var max = [
                -MAX_NUMBER,
                -MAX_NUMBER
            ];
            var min2 = [];
            var max2 = [];
            var geometries = this.geometries;
            var i = 0;
            for(; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                (0, parcelRequire("13I82")).fromPoints(exterior, min2, max2);
                (0, parcelRequire("eLEew")).min(min, min, min2);
                (0, parcelRequire("eLEew")).max(max, max, max2);
            }
            if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
            return this._rect = new (0, (0, parcelRequire("1E3E8")).default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        };
        GeoJSONRegion.prototype.contain = function(coord) {
            var rect = this.getBoundingRect();
            var geometries = this.geometries;
            if (!rect.contain(coord[0], coord[1])) return false;
            loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                if ((0, parcelRequire("hjZ9y")).contain(exterior, coord[0], coord[1])) {
                    for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                        if ((0, parcelRequire("hjZ9y")).contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                    }
                    return true;
                }
            }
            return false;
        };
        GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
            var rect = this.getBoundingRect();
            var aspect = rect.width / rect.height;
            if (!width) width = aspect * height;
            else if (!height) height = width / aspect;
            var target = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
            var transform = rect.calculateTransform(target);
            var geometries = this.geometries;
            for(var i = 0; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                for(var p = 0; p < exterior.length; p++)(0, parcelRequire("eLEew")).applyTransform(exterior[p], exterior[p], transform);
                for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)(0, parcelRequire("eLEew")).applyTransform(interiors[h][p], interiors[h][p], transform);
            }
            rect = this._rect;
            rect.copy(target);
            this._center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        };
        GeoJSONRegion.prototype.cloneShallow = function(name) {
            name == null && (name = this.name);
            var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
            newRegion._rect = this._rect;
            newRegion.transformTo = null;
            return newRegion;
        };
        GeoJSONRegion.prototype.getCenter = function() {
            return this._center;
        };
        GeoJSONRegion.prototype.setCenter = function(center) {
            this._center = center;
        };
        return GeoJSONRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
    var $81c9361a69c93c5f$export$5f3d89e7254f3e69 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoSVGRegion, _super);
        function GeoSVGRegion(name, elOnlyForCalculate) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoSVG';
            _this._elOnlyForCalculate = elOnlyForCalculate;
            return _this;
        }
        GeoSVGRegion.prototype.getCenter = function() {
            var center = this._center;
            if (!center) center = this._center = this._calculateCenter();
            return center;
        };
        GeoSVGRegion.prototype._calculateCenter = function() {
            var el = this._elOnlyForCalculate;
            var rect = el.getBoundingRect();
            var center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
            var mat = (0, parcelRequire("izqgC")).identity($81c9361a69c93c5f$var$TMP_TRANSFORM);
            var target = el;
            while(target && !target.isGeoSVGGraphicRoot){
                (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
                target = target.parent;
            }
            (0, parcelRequire("izqgC")).invert(mat, mat);
            (0, parcelRequire("eLEew")).applyTransform(center, center, mat);
            return center;
        };
        return GeoSVGRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
});
parcelRegister("hjZ9y", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$c9c3a5bccc65a1b5$export$8893e2b90ba10d92);
    var $3Ytji;
    var $c9c3a5bccc65a1b5$var$EPSILON = 1e-8;
    function $c9c3a5bccc65a1b5$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $c9c3a5bccc65a1b5$var$EPSILON;
    }
    function $c9c3a5bccc65a1b5$export$8893e2b90ba10d92(points, x, y) {
        var w = 0;
        var p = points[0];
        if (!p) return false;
        for(var i = 1; i < points.length; i++){
            var p2 = points[i];
            w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p2[0], p2[1], x, y);
            p = p2;
        }
        var p0 = points[0];
        if (!$c9c3a5bccc65a1b5$var$isAroundEqual(p[0], p0[0]) || !$c9c3a5bccc65a1b5$var$isAroundEqual(p[1], p0[1])) w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p0[0], p0[1], x, y);
        return w !== 0;
    }
});
parcelRegister("2iWFB", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONResource", ()=>$1adac5d85fe37b79$export$859cf85c67f2df51);
    var $bahqM;
    var $gyzY7;
    var $eEvpA;
    var $5i7yG;
    var $huNXv;
    var $ducHh;
    var $1E3E8;
    var $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY = 'name';
    var $1adac5d85fe37b79$export$859cf85c67f2df51 = function() {
        function GeoJSONResource(mapName, geoJSON, specialAreas) {
            this.type = 'geoJSON';
            this._parsedMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._mapName = mapName;
            this._specialAreas = specialAreas;
            this._geoJSON = $1adac5d85fe37b79$var$parseInput(geoJSON);
        }
        GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
            nameProperty = nameProperty || $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY;
            var parsed = this._parsedMap.get(nameProperty);
            if (!parsed) {
                var rawRegions = this._parseToRegions(nameProperty);
                parsed = this._parsedMap.set(nameProperty, {
                    regions: rawRegions,
                    boundingRect: $1adac5d85fe37b79$var$calculateBoundingRect(rawRegions)
                });
            }
            var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var finalRegions = [];
            (0, (0, parcelRequire("bahqM")).each)(parsed.regions, function(region) {
                var regionName = region.name;
                if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
                finalRegions.push(region);
                regionsMap.set(regionName, region);
            });
            return {
                regions: finalRegions,
                boundingRect: parsed.boundingRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0),
                regionsMap: regionsMap
            };
        };
        GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
            var mapName = this._mapName;
            var geoJSON = this._geoJSON;
            var rawRegions;
            try {
                rawRegions = geoJSON ? (0, (0, parcelRequire("gyzY7")).default)(geoJSON, nameProperty) : [];
            } catch (e) {
                throw new Error('Invalid geoJson format\n' + e.message);
            }
            (0, (0, parcelRequire("eEvpA")).default)(mapName, rawRegions);
            (0, (0, parcelRequire("bahqM")).each)(rawRegions, function(region) {
                var regionName = region.name;
                (0, (0, parcelRequire("5i7yG")).default)(mapName, region);
                (0, (0, parcelRequire("huNXv")).default)(mapName, region);
                (0, (0, parcelRequire("ducHh")).default)(mapName, region);
                var specialArea = this._specialAreas && this._specialAreas[regionName];
                if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
            }, this);
            return rawRegions;
        };
        GeoJSONResource.prototype.getMapForUser = function() {
            return {
                geoJson: this._geoJSON,
                geoJSON: this._geoJSON,
                specialAreas: this._specialAreas
            };
        };
        return GeoJSONResource;
    }();
    function $1adac5d85fe37b79$var$calculateBoundingRect(regions) {
        var rect;
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect();
            rect = rect || regionRect.clone();
            rect.union(regionRect);
        }
        return rect;
    }
    function $1adac5d85fe37b79$var$parseInput(source) {
        return !(0, (0, parcelRequire("bahqM")).isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
    }
});
parcelRegister("gyzY7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0dbb8f34f2c3106$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    function $c0dbb8f34f2c3106$var$decode(json) {
        if (!json.UTF8Encoding) return json;
        var jsonCompressed = json;
        var encodeScale = jsonCompressed.UTF8Scale;
        if (encodeScale == null) encodeScale = 1024;
        var features = jsonCompressed.features;
        for(var f = 0; f < features.length; f++){
            var feature = features[f];
            var geometry = feature.geometry;
            if (geometry.type === 'Polygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++)coordinates[c] = $c0dbb8f34f2c3106$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
            } else if (geometry.type === 'MultiPolygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++){
                    var coordinate = coordinates[c];
                    for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $c0dbb8f34f2c3106$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
                }
            }
        }
        jsonCompressed.UTF8Encoding = false;
        return jsonCompressed;
    }
    function $c0dbb8f34f2c3106$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
        var result = [];
        var prevX = encodeOffsets[0];
        var prevY = encodeOffsets[1];
        for(var i = 0; i < coordinate.length; i += 2){
            var x = coordinate.charCodeAt(i) - 64;
            var y = coordinate.charCodeAt(i + 1) - 64;
            x = x >> 1 ^ -(x & 1);
            y = y >> 1 ^ -(y & 1);
            x += prevX;
            y += prevY;
            prevX = x;
            prevY = y;
            result.push([
                x / encodeScale,
                y / encodeScale
            ]);
        }
        return result;
    }
    function $c0dbb8f34f2c3106$export$2e2bcd8739ae039(geoJson, nameProperty) {
        geoJson = $c0dbb8f34f2c3106$var$decode(geoJson);
        return (0, parcelRequire("bahqM")).map((0, parcelRequire("bahqM")).filter(geoJson.features, function(featureObj) {
            return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
        }), function(featureObj) {
            var properties = featureObj.properties;
            var geo = featureObj.geometry;
            var geometries = [];
            if (geo.type === 'Polygon') {
                var coordinates = geo.coordinates;
                geometries.push({
                    type: 'polygon',
                    exterior: coordinates[0],
                    interiors: coordinates.slice(1)
                });
            }
            if (geo.type === 'MultiPolygon') {
                var coordinates = geo.coordinates;
                (0, parcelRequire("bahqM")).each(coordinates, function(item) {
                    if (item[0]) geometries.push({
                        type: 'polygon',
                        exterior: item[0],
                        interiors: item.slice(1)
                    });
                });
            }
            var region = new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
            region.properties = properties;
            return region;
        });
    }
});
parcelRegister("eEvpA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaad2ad12dd4ec6c$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    var $aaad2ad12dd4ec6c$var$geoCoord = [
        126,
        25
    ];
    var $aaad2ad12dd4ec6c$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
    var $aaad2ad12dd4ec6c$var$points = [
        [
            [
                0,
                3.5
            ],
            [
                7,
                11.2
            ],
            [
                15,
                11.9
            ],
            [
                30,
                7
            ],
            [
                42,
                0.7
            ],
            [
                52,
                0.7
            ],
            [
                56,
                7.7
            ],
            [
                59,
                0.7
            ],
            [
                64,
                0.7
            ],
            [
                64,
                0
            ],
            [
                5,
                0
            ],
            [
                0,
                3.5
            ]
        ],
        [
            [
                13,
                16.1
            ],
            [
                19,
                14.7
            ],
            [
                16,
                21.7
            ],
            [
                11,
                23.1
            ],
            [
                13,
                16.1
            ]
        ],
        [
            [
                12,
                32.2
            ],
            [
                14,
                38.5
            ],
            [
                15,
                38.5
            ],
            [
                13,
                32.2
            ],
            [
                12,
                32.2
            ]
        ],
        [
            [
                16,
                47.6
            ],
            [
                12,
                53.2
            ],
            [
                13,
                53.2
            ],
            [
                18,
                47.6
            ],
            [
                16,
                47.6
            ]
        ],
        [
            [
                6,
                64.4
            ],
            [
                8,
                70
            ],
            [
                9,
                70
            ],
            [
                8,
                64.4
            ],
            [
                6,
                64.4
            ]
        ],
        [
            [
                23,
                82.6
            ],
            [
                29,
                79.8
            ],
            [
                30,
                79.8
            ],
            [
                25,
                82.6
            ],
            [
                23,
                82.6
            ]
        ],
        [
            [
                37,
                70.7
            ],
            [
                43,
                62.3
            ],
            [
                44,
                62.3
            ],
            [
                39,
                70.7
            ],
            [
                37,
                70.7
            ]
        ],
        [
            [
                48,
                51.1
            ],
            [
                51,
                45.5
            ],
            [
                53,
                45.5
            ],
            [
                50,
                51.1
            ],
            [
                48,
                51.1
            ]
        ],
        [
            [
                51,
                35
            ],
            [
                51,
                28.7
            ],
            [
                53,
                28.7
            ],
            [
                53,
                35
            ],
            [
                51,
                35
            ]
        ],
        [
            [
                52,
                22.4
            ],
            [
                55,
                17.5
            ],
            [
                56,
                17.5
            ],
            [
                53,
                22.4
            ],
            [
                52,
                22.4
            ]
        ],
        [
            [
                58,
                12.6
            ],
            [
                62,
                7
            ],
            [
                63,
                7
            ],
            [
                60,
                12.6
            ],
            [
                58,
                12.6
            ]
        ],
        [
            [
                0,
                3.5
            ],
            [
                0,
                93.1
            ],
            [
                64,
                93.1
            ],
            [
                64,
                0
            ],
            [
                63,
                0
            ],
            [
                63,
                92.4
            ],
            [
                1,
                92.4
            ],
            [
                1,
                3.5
            ],
            [
                0,
                3.5
            ]
        ]
    ];
    for(var $aaad2ad12dd4ec6c$var$i = 0; $aaad2ad12dd4ec6c$var$i < $aaad2ad12dd4ec6c$var$points.length; $aaad2ad12dd4ec6c$var$i++)for(var $aaad2ad12dd4ec6c$var$k = 0; $aaad2ad12dd4ec6c$var$k < $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i].length; $aaad2ad12dd4ec6c$var$k++){
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] /= 10.5;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] /= -14;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] += $aaad2ad12dd4ec6c$var$geoCoord[0];
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] += $aaad2ad12dd4ec6c$var$geoCoord[1];
    }
    function $aaad2ad12dd4ec6c$export$2e2bcd8739ae039(mapType, regions) {
        if (mapType === 'china') {
            for(var i = 0; i < regions.length; i++){
                if (regions[i].name === $aaad2ad12dd4ec6c$var$nanhaiName) return;
            }
            regions.push(new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)($aaad2ad12dd4ec6c$var$nanhaiName, (0, parcelRequire("bahqM")).map($aaad2ad12dd4ec6c$var$points, function(exterior) {
                return {
                    type: 'polygon',
                    exterior: exterior
                };
            }), $aaad2ad12dd4ec6c$var$geoCoord));
        }
    }
});
parcelRegister("5i7yG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3da47f1dbbeac6bc$export$2e2bcd8739ae039);
    var $3da47f1dbbeac6bc$var$coordsOffsetMap = {
        "\u5357\u6D77\u8BF8\u5C9B": [
            32,
            80
        ],
        "\u5E7F\u4E1C": [
            0,
            -10
        ],
        "\u9999\u6E2F": [
            10,
            5
        ],
        "\u6FB3\u95E8": [
            -10,
            10
        ],
        "\u5929\u6D25": [
            5,
            5
        ]
    };
    function $3da47f1dbbeac6bc$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china') {
            var coordFix = $3da47f1dbbeac6bc$var$coordsOffsetMap[region.name];
            if (coordFix) {
                var cp = region.getCenter();
                cp[0] += coordFix[0] / 10.5;
                cp[1] += -coordFix[1] / 14;
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("huNXv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbcbfdc69414efb9$export$2e2bcd8739ae039);
    var $cbcbfdc69414efb9$var$geoCoordMap = {
        'Russia': [
            100,
            60
        ],
        'United States': [
            -99,
            38
        ],
        'United States of America': [
            -99,
            38
        ]
    };
    function $cbcbfdc69414efb9$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'world') {
            var geoCoord = $cbcbfdc69414efb9$var$geoCoordMap[region.name];
            if (geoCoord) {
                var cp = [
                    geoCoord[0],
                    geoCoord[1]
                ];
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("ducHh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d17ed1a4c54aaef$export$2e2bcd8739ae039);
    var $9d17ed1a4c54aaef$var$points = [
        [
            [
                123.45165252685547,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.73527164402261
            ]
        ]
    ];
    function $9d17ed1a4c54aaef$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
            type: 'polygon',
            exterior: $9d17ed1a4c54aaef$var$points[0]
        });
    }
});
parcelRegister("8cCW2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f8da56db6246248$export$2e2bcd8739ae039);
    var $bRKv5;
    var $5f8da56db6246248$var$lifecycle = new (0, (0, parcelRequire("bRKv5")).default)();
    var $5f8da56db6246248$export$2e2bcd8739ae039 = $5f8da56db6246248$var$lifecycle;
});
parcelRegister("48mDj", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$3029774200831710$export$4b3e715f166fdd78);
    var $hpWan;
    var $9wang;
    var $ce402;
    function $3029774200831710$export$4b3e715f166fdd78(registers) {
        registers.registerComponentModel((0, (0, parcelRequire("9wang")).default));
        registers.registerComponentView((0, (0, parcelRequire("ce402")).default));
        registers.registerPreprocessor(function(opt) {
            if ((0, (0, parcelRequire("hpWan")).default)(opt.series, 'markLine')) opt.markLine = opt.markLine || {};
        });
    }
});
parcelRegister("hpWan", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cae1e41edf2dca89$export$2e2bcd8739ae039);
    var $bahqM;
    function $cae1e41edf2dca89$export$2e2bcd8739ae039(seriesOpts, markerType) {
        if (!seriesOpts) return false;
        var seriesOptArr = (0, (0, parcelRequire("bahqM")).isArray)(seriesOpts) ? seriesOpts : [
            seriesOpts
        ];
        for(var idx = 0; idx < seriesOptArr.length; idx++){
            if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
        }
        return false;
    }
});
parcelRegister("9wang", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6edf264d439d7d08$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h8Fle;
    var $6edf264d439d7d08$var$MarkLineModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkLineModel, _super);
        function MarkLineModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkLineModel.type;
            return _this;
        }
        MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
            return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
        };
        MarkLineModel.type = 'markLine';
        MarkLineModel.defaultOption = {
            zlevel: 0,
            z: 5,
            symbol: [
                'circle',
                'arrow'
            ],
            symbolSize: [
                8,
                16
            ],
            symbolOffset: 0,
            precision: 2,
            tooltip: {
                trigger: 'item'
            },
            label: {
                show: true,
                position: 'end',
                distance: 5
            },
            lineStyle: {
                type: 'dashed'
            },
            emphasis: {
                label: {
                    show: true
                },
                lineStyle: {
                    width: 3
                }
            },
            animationEasing: 'linear'
        };
        return MarkLineModel;
    }((0, (0, parcelRequire("h8Fle")).default));
    var $6edf264d439d7d08$export$2e2bcd8739ae039 = $6edf264d439d7d08$var$MarkLineModel;
});
parcelRegister("h8Fle", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7a34092fe996af9$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $guzSc;
    var $h4UlH;
    var $eaKsF;
    var $j5lKL;
    function $c7a34092fe996af9$var$fillLabel(opt) {
        (0, (0, parcelRequire("eaKsF")).defaultEmphasis)(opt, 'label', [
            'show'
        ]);
    }
    var $c7a34092fe996af9$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $c7a34092fe996af9$var$MarkerModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkerModel, _super);
        function MarkerModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkerModel.type;
            _this.createdBySelf = false;
            return _this;
        }
        MarkerModel.prototype.init = function(option, parentModel, ecModel) {
            this.mergeDefaultAndTheme(option, ecModel);
            this._mergeOption(option, ecModel, false, true);
        };
        MarkerModel.prototype.isAnimationEnabled = function() {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return false;
            var hostSeries = this.__hostSeries;
            return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
        };
        MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
            this._mergeOption(newOpt, ecModel, false, false);
        };
        MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
            var componentType = this.mainType;
            if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
                var markerOpt = seriesModel.get(this.mainType, true);
                var markerModel = $c7a34092fe996af9$var$inner(seriesModel)[componentType];
                if (!markerOpt || !markerOpt.data) {
                    $c7a34092fe996af9$var$inner(seriesModel)[componentType] = null;
                    return;
                }
                if (!markerModel) {
                    if (isInit) $c7a34092fe996af9$var$fillLabel(markerOpt);
                    (0, parcelRequire("bahqM")).each(markerOpt.data, function(item) {
                        if (item instanceof Array) {
                            $c7a34092fe996af9$var$fillLabel(item[0]);
                            $c7a34092fe996af9$var$fillLabel(item[1]);
                        } else $c7a34092fe996af9$var$fillLabel(item);
                    });
                    markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                    (0, parcelRequire("bahqM")).extend(markerModel, {
                        mainType: this.mainType,
                        seriesIndex: seriesModel.seriesIndex,
                        name: seriesModel.name,
                        createdBySelf: true
                    });
                    markerModel.__hostSeries = seriesModel;
                } else markerModel._mergeOption(markerOpt, ecModel, true);
                $c7a34092fe996af9$var$inner(seriesModel)[componentType] = markerModel;
            }, this);
        };
        MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            var data = this.getData();
            var value = this.getRawValue(dataIndex);
            var itemName = data.getName(dataIndex);
            return (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                header: this.name,
                blocks: [
                    (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                        name: itemName,
                        value: value,
                        noName: !itemName,
                        noValue: value == null
                    })
                ]
            });
        };
        MarkerModel.prototype.getData = function() {
            return this._data;
        };
        MarkerModel.prototype.setData = function(data) {
            this._data = data;
        };
        MarkerModel.getMarkerModelFromSeries = function(seriesModel, componentType) {
            return $c7a34092fe996af9$var$inner(seriesModel)[componentType];
        };
        MarkerModel.type = 'marker';
        MarkerModel.dependencies = [
            'series',
            'grid',
            'polar',
            'geo'
        ];
        return MarkerModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($c7a34092fe996af9$var$MarkerModel, (0, (0, parcelRequire("guzSc")).DataFormatMixin).prototype);
    var $c7a34092fe996af9$export$2e2bcd8739ae039 = $c7a34092fe996af9$var$MarkerModel;
});
parcelRegister("ce402", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e69e51972a54af1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $liBXN;
    var $jmSNG;
    var $gjRnj;
    var $2JPY0;
    var $k3pUt;
    var $5R8Hi;
    var $40dMe;
    var $7QjoM;
    var $h8Fle;
    var $bahqM;
    var $eaKsF;
    var $fk5Gm;
    var $8e69e51972a54af1$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $8e69e51972a54af1$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
        var data = seriesModel.getData();
        var itemArray;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(item)) {
            var mlType = item.type;
            if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' || item.xAxis != null || item.yAxis != null) {
                var valueAxis = void 0;
                var value = void 0;
                if (item.yAxis != null || item.xAxis != null) {
                    valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                    value = (0, (0, parcelRequire("bahqM")).retrieve)(item.yAxis, item.xAxis);
                } else {
                    var axisInfo = (0, parcelRequire("gjRnj")).getAxisInfo(item, data, coordSys, seriesModel);
                    valueAxis = axisInfo.valueAxis;
                    var valueDataDim = (0, (0, parcelRequire("5R8Hi")).getStackedDimension)(data, axisInfo.valueDataDim);
                    value = (0, parcelRequire("gjRnj")).numCalculate(data, valueDataDim, mlType);
                }
                var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
                var baseIndex = 1 - valueIndex;
                var mlFrom = (0, (0, parcelRequire("bahqM")).clone)(item);
                var mlTo = {
                    coord: []
                };
                mlFrom.type = null;
                mlFrom.coord = [];
                mlFrom.coord[baseIndex] = -Infinity;
                mlTo.coord[baseIndex] = Infinity;
                var precision = mlModel.get('precision');
                if (precision >= 0 && typeof value === 'number') value = +value.toFixed(Math.min(precision, 20));
                mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
                itemArray = [
                    mlFrom,
                    mlTo,
                    {
                        type: mlType,
                        valueIndex: item.valueIndex,
                        value: value
                    }
                ];
            } else itemArray = [];
        } else itemArray = item;
        var normalizedItem = [
            (0, parcelRequire("gjRnj")).dataTransform(seriesModel, itemArray[0]),
            (0, parcelRequire("gjRnj")).dataTransform(seriesModel, itemArray[1]),
            (0, (0, parcelRequire("bahqM")).extend)({}, itemArray[2])
        ];
        normalizedItem[2].type = normalizedItem[2].type || null;
        (0, (0, parcelRequire("bahqM")).merge)(normalizedItem[2], normalizedItem[0]);
        (0, (0, parcelRequire("bahqM")).merge)(normalizedItem[2], normalizedItem[1]);
        return normalizedItem;
    };
    function $8e69e51972a54af1$var$isInifinity(val) {
        return !isNaN(val) && !isFinite(val);
    }
    function $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
        var otherDimIndex = 1 - dimIndex;
        var dimName = coordSys.dimensions[dimIndex];
        return $8e69e51972a54af1$var$isInifinity(fromCoord[otherDimIndex]) && $8e69e51972a54af1$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
    }
    function $8e69e51972a54af1$var$markLineFilter(coordSys, item) {
        if (coordSys.type === 'cartesian2d') {
            var fromCoord = item[0].coord;
            var toCoord = item[1].coord;
            if (fromCoord && toCoord && ($8e69e51972a54af1$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        }
        return (0, parcelRequire("gjRnj")).dataFilter(coordSys, item[0]) && (0, parcelRequire("gjRnj")).dataFilter(coordSys, item[1]);
    }
    function $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var itemModel = data.getItemModel(idx);
        var point;
        var xPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('x'), api.getWidth());
        var yPx = (0, parcelRequire("jmSNG")).parsePercent(itemModel.get('y'), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else {
            if (seriesModel.getMarkerPosition) point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
            else {
                var dims = coordSys.dimensions;
                var x = data.get(dims[0], idx);
                var y = data.get(dims[1], idx);
                point = coordSys.dataToPoint([
                    x,
                    y
                ]);
            }
            if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coordSys, 'cartesian2d')) {
                var xAxis = coordSys.getAxis('x');
                var yAxis = coordSys.getAxis('y');
                var dims = coordSys.dimensions;
                if ($8e69e51972a54af1$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
                else if ($8e69e51972a54af1$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
            }
            if (!isNaN(xPx)) point[0] = xPx;
            if (!isNaN(yPx)) point[1] = yPx;
        }
        data.setItemLayout(idx, point);
    }
    var $8e69e51972a54af1$var$MarkLineView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkLineView, _super);
        function MarkLineView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkLineView.type;
            return _this;
        }
        MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
            ecModel.eachSeries(function(seriesModel) {
                var mlModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, 'markLine');
                if (mlModel) {
                    var mlData_1 = mlModel.getData();
                    var fromData_1 = $8e69e51972a54af1$var$inner(mlModel).from;
                    var toData_1 = $8e69e51972a54af1$var$inner(mlModel).to;
                    fromData_1.each(function(idx) {
                        $8e69e51972a54af1$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                        $8e69e51972a54af1$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                    });
                    mlData_1.each(function(idx) {
                        mlData_1.setItemLayout(idx, [
                            fromData_1.getItemLayout(idx),
                            toData_1.getItemLayout(idx)
                        ]);
                    });
                    this.markerGroupMap.get(seriesModel.id).updateLayout();
                }
            }, this);
        };
        MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesId = seriesModel.id;
            var seriesData = seriesModel.getData();
            var lineDrawMap = this.markerGroupMap;
            var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, (0, parcelRequire("2JPY0")).default)());
            this.group.add(lineDraw.group);
            var mlData = $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel);
            var fromData = mlData.from;
            var toData = mlData.to;
            var lineData = mlData.line;
            $8e69e51972a54af1$var$inner(mlModel).from = fromData;
            $8e69e51972a54af1$var$inner(mlModel).to = toData;
            mlModel.setData(lineData);
            var symbolType = mlModel.get('symbol');
            var symbolSize = mlModel.get('symbolSize');
            var symbolRotate = mlModel.get('symbolRotate');
            var symbolOffset = mlModel.get('symbolOffset');
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolType)) symbolType = [
                symbolType,
                symbolType
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolSize)) symbolSize = [
                symbolSize,
                symbolSize
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolRotate)) symbolRotate = [
                symbolRotate,
                symbolRotate
            ];
            if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolOffset)) symbolOffset = [
                symbolOffset,
                symbolOffset
            ];
            mlData.from.each(function(idx) {
                updateDataVisualAndLayout(fromData, idx, true);
                updateDataVisualAndLayout(toData, idx, false);
            });
            lineData.each(function(idx) {
                var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle();
                lineData.setItemLayout(idx, [
                    fromData.getItemLayout(idx),
                    toData.getItemLayout(idx)
                ]);
                if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
                lineData.setItemVisual(idx, {
                    fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                    fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                    fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                    fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                    fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                    toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                    toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                    toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                    toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                    toSymbol: toData.getItemVisual(idx, 'symbol'),
                    style: lineStyle
                });
            });
            lineDraw.updateData(lineData);
            mlData.line.eachItemGraphicEl(function(el, idx) {
                el.traverse(function(child) {
                    (0, (0, parcelRequire("7QjoM")).getECData)(child).dataModel = mlModel;
                });
            });
            function updateDataVisualAndLayout(data, idx, isFrom) {
                var itemModel = data.getItemModel(idx);
                $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
                var style = itemModel.getModel('itemStyle').getItemStyle();
                if (style.fill == null) style.fill = (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(seriesData, 'color');
                data.setItemVisual(idx, {
                    symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                    symbolOffset: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                    symbolRotate: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                    symbolSize: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                    symbol: (0, (0, parcelRequire("bahqM")).retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                    style: style
                });
            }
            this.markKeep(lineDraw);
            lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
        };
        MarkLineView.type = 'markLine';
        return MarkLineView;
    }((0, (0, parcelRequire("k3pUt")).default));
    function $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel) {
        var coordDimsInfos;
        if (coordSys) coordDimsInfos = (0, (0, parcelRequire("bahqM")).map)(coordSys && coordSys.dimensions, function(coordDim) {
            var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
            return (0, (0, parcelRequire("bahqM")).extend)((0, (0, parcelRequire("bahqM")).extend)({}, info), {
                name: coordDim,
                ordinalMeta: null
            });
        });
        else coordDimsInfos = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        var fromData = new (0, (0, parcelRequire("liBXN")).default)(coordDimsInfos, mlModel);
        var toData = new (0, (0, parcelRequire("liBXN")).default)(coordDimsInfos, mlModel);
        var lineData = new (0, (0, parcelRequire("liBXN")).default)([], mlModel);
        var optData = (0, (0, parcelRequire("bahqM")).map)(mlModel.get('data'), (0, (0, parcelRequire("bahqM")).curry)($8e69e51972a54af1$var$markLineTransform, seriesModel, coordSys, mlModel));
        if (coordSys) optData = (0, (0, parcelRequire("bahqM")).filter)(optData, (0, (0, parcelRequire("bahqM")).curry)($8e69e51972a54af1$var$markLineFilter, coordSys));
        var dimValueGetter = (0, parcelRequire("gjRnj")).createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
        fromData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[0];
        }), null, dimValueGetter);
        toData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[1];
        }), null, dimValueGetter);
        lineData.initData((0, (0, parcelRequire("bahqM")).map)(optData, function(item) {
            return item[2];
        }));
        lineData.hasItemOption = true;
        return {
            from: fromData,
            to: toData,
            line: lineData
        };
    }
    var $8e69e51972a54af1$export$2e2bcd8739ae039 = $8e69e51972a54af1$var$MarkLineView;
});
parcelRegister("gjRnj", function(module, exports) {
    $parcel$export(module.exports, "numCalculate", ()=>$be17d2d7c679ee45$export$18ddefb55c03640b);
    $parcel$export(module.exports, "dataTransform", ()=>$be17d2d7c679ee45$export$3eebd2d54b98c04f);
    $parcel$export(module.exports, "getAxisInfo", ()=>$be17d2d7c679ee45$export$bd39458db76002ab);
    $parcel$export(module.exports, "dataFilter", ()=>$be17d2d7c679ee45$export$179695f4a9040f73);
    $parcel$export(module.exports, "createMarkerDimValueGetter", ()=>$be17d2d7c679ee45$export$a53767c3c8f69cf7);
    var $jmSNG;
    var $5R8Hi;
    var $bahqM;
    var $2G90t;
    function $be17d2d7c679ee45$var$hasXOrY(item) {
        return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
    }
    function $be17d2d7c679ee45$var$hasXAndY(item) {
        return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
    }
    function $be17d2d7c679ee45$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
        var coordArr = [];
        var stacked = (0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, targetDataDim);
        var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
        var value = $be17d2d7c679ee45$export$18ddefb55c03640b(data, calcDataDim, markerType);
        var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
        coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
        coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
        var coordArrValue = data.get(targetDataDim, dataIndex);
        var precision = (0, parcelRequire("jmSNG")).getPrecision(data.get(targetDataDim, dataIndex));
        precision = Math.min(precision, 20);
        if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
        return [
            coordArr,
            coordArrValue
        ];
    }
    var $be17d2d7c679ee45$var$markerTypeCalculator = {
        min: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'min'),
        max: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'max'),
        average: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'average'),
        median: (0, (0, parcelRequire("bahqM")).curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'median')
    };
    function $be17d2d7c679ee45$export$3eebd2d54b98c04f(seriesModel, item) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        if (item && !$be17d2d7c679ee45$var$hasXAndY(item) && !(0, (0, parcelRequire("bahqM")).isArray)(item.coord) && coordSys) {
            var dims = coordSys.dimensions;
            var axisInfo = $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel);
            item = (0, (0, parcelRequire("bahqM")).clone)(item);
            if (item.type && $be17d2d7c679ee45$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
                var otherCoordIndex = (0, (0, parcelRequire("bahqM")).indexOf)(dims, axisInfo.baseAxis.dim);
                var targetCoordIndex = (0, (0, parcelRequire("bahqM")).indexOf)(dims, axisInfo.valueAxis.dim);
                var coordInfo = $be17d2d7c679ee45$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
                item.coord = coordInfo[0];
                item.value = coordInfo[1];
            } else {
                var coord = [
                    item.xAxis != null ? item.xAxis : item.radiusAxis,
                    item.yAxis != null ? item.yAxis : item.angleAxis
                ];
                for(var i = 0; i < 2; i++)if ($be17d2d7c679ee45$var$markerTypeCalculator[coord[i]]) coord[i] = $be17d2d7c679ee45$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
                item.coord = coord;
            }
        }
        return item;
    }
    function $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
        var ret = {};
        if (item.valueIndex != null || item.valueDim != null) {
            ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
            ret.valueAxis = coordSys.getAxis($be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
            ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
            ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        } else {
            ret.baseAxis = seriesModel.getBaseAxis();
            ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
            ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
            ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
        }
        return ret;
    }
    function $be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, dataDim) {
        var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
        return dimItem && dimItem.coordDim;
    }
    function $be17d2d7c679ee45$export$179695f4a9040f73(coordSys, item) {
        return coordSys && coordSys.containData && item.coord && !$be17d2d7c679ee45$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
    }
    function $be17d2d7c679ee45$export$a53767c3c8f69cf7(inCoordSys, dims) {
        return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
            var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(rawVal, dims[dimIndex]);
        } : function(item, dimName, dataIndex, dimIndex) {
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(item.value, dims[dimIndex]);
        };
    }
    function $be17d2d7c679ee45$export$18ddefb55c03640b(data, valueDataDim, type) {
        if (type === 'average') {
            var sum_1 = 0;
            var count_1 = 0;
            data.each(valueDataDim, function(val, idx) {
                if (!isNaN(val)) {
                    sum_1 += val;
                    count_1++;
                }
            });
            return sum_1 / count_1;
        } else if (type === 'median') return data.getMedian(valueDataDim);
        else return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
    }
});
parcelRegister("2JPY0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fe8183fc890aada$export$2e2bcd8739ae039);
    var $4KVOr;
    var $hKTLM;
    var $gvLUt;
    var $1fe8183fc890aada$var$LineDraw = function() {
        function LineDraw(LineCtor) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this._LineCtor = LineCtor || (0, (0, parcelRequire("hKTLM")).default);
        }
        LineDraw.prototype.isPersistent = function() {
            return true;
        };
        LineDraw.prototype.updateData = function(lineData) {
            var _this = this;
            var lineDraw = this;
            var group = lineDraw.group;
            var oldLineData = lineDraw._lineData;
            lineDraw._lineData = lineData;
            if (!oldLineData) group.removeAll();
            var seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
            lineData.diff(oldLineData).add(function(idx) {
                _this._doAdd(lineData, idx, seriesScope);
            }).update(function(newIdx, oldIdx) {
                _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
            }).remove(function(idx) {
                group.remove(oldLineData.getItemGraphicEl(idx));
            }).execute();
        };
        LineDraw.prototype.updateLayout = function() {
            var lineData = this._lineData;
            if (!lineData) return;
            lineData.eachItemGraphicEl(function(el, idx) {
                el.updateLayout(lineData, idx);
            }, this);
        };
        LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
            this._seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
            this._lineData = null;
            this.group.removeAll();
        };
        LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
            function updateIncrementalAndHover(el) {
                if (!el.isGroup && !$1fe8183fc890aada$var$isEffectObject(el)) {
                    el.incremental = true;
                    el.ensureState('emphasis').hoverLayer = true;
                }
            }
            for(var idx = taskParams.start; idx < taskParams.end; idx++){
                var itemLayout = lineData.getItemLayout(idx);
                if ($1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) {
                    var el = new this._LineCtor(lineData, idx, this._seriesScope);
                    el.traverse(updateIncrementalAndHover);
                    this.group.add(el);
                    lineData.setItemGraphicEl(idx, el);
                }
            }
        };
        LineDraw.prototype.remove = function() {
            this.group.removeAll();
        };
        LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
            var itemLayout = lineData.getItemLayout(idx);
            if (!$1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) return;
            var el = new this._LineCtor(lineData, idx, seriesScope);
            lineData.setItemGraphicEl(idx, el);
            this.group.add(el);
        };
        LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
            var itemEl = oldLineData.getItemGraphicEl(oldIdx);
            if (!$1fe8183fc890aada$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
                this.group.remove(itemEl);
                return;
            }
            if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
            else itemEl.updateData(newLineData, newIdx, seriesScope);
            newLineData.setItemGraphicEl(newIdx, itemEl);
            this.group.add(itemEl);
        };
        return LineDraw;
    }();
    function $1fe8183fc890aada$var$isEffectObject(el) {
        return el.animators && el.animators.length > 0;
    }
    function $1fe8183fc890aada$var$makeSeriesScope(lineData) {
        var hostModel = lineData.hostModel;
        return {
            lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
            emphasisLineStyle: hostModel.getModel([
                'emphasis',
                'lineStyle'
            ]).getLineStyle(),
            blurLineStyle: hostModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle(),
            selectLineStyle: hostModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle(),
            labelStatesModels: (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(hostModel)
        };
    }
    function $1fe8183fc890aada$var$isPointNaN(pt) {
        return isNaN(pt[0]) || isNaN(pt[1]);
    }
    function $1fe8183fc890aada$var$lineNeedsDraw(pts) {
        return !$1fe8183fc890aada$var$isPointNaN(pts[0]) && !$1fe8183fc890aada$var$isPointNaN(pts[1]);
    }
    var $1fe8183fc890aada$export$2e2bcd8739ae039 = $1fe8183fc890aada$var$LineDraw;
});
parcelRegister("hKTLM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ced1fe40d771d409$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eLEew;
    var $7yklO;
    var $iUQRt;
    var $4KVOr;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $fIXXx;
    var $gvLUt;
    var $jmSNG;
    var $ced1fe40d771d409$var$SYMBOL_CATEGORIES = [
        'fromSymbol',
        'toSymbol'
    ];
    function $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory) {
        return '_' + symbolCategory + 'Type';
    }
    function $ced1fe40d771d409$var$createSymbol(name, lineData, idx) {
        var symbolType = lineData.getItemVisual(idx, name);
        if (!symbolType || symbolType === 'none') return;
        var symbolSize = lineData.getItemVisual(idx, name + 'Size');
        var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
        var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
        var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
        var symbolSizeArr = (0, parcelRequire("7yklO")).normalizeSymbolSize(symbolSize);
        var symbolOffsetArr = (0, parcelRequire("7yklO")).normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
        var symbolPath = (0, parcelRequire("7yklO")).createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
        symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
        symbolPath.name = name;
        return symbolPath;
    }
    function $ced1fe40d771d409$var$createLine(points) {
        var line = new (0, (0, parcelRequire("iUQRt")).default)({
            name: 'line',
            subPixelOptimize: true
        });
        $ced1fe40d771d409$var$setLinePoints(line.shape, points);
        return line;
    }
    function $ced1fe40d771d409$var$setLinePoints(targetShape, points) {
        targetShape.x1 = points[0][0];
        targetShape.y1 = points[0][1];
        targetShape.x2 = points[1][0];
        targetShape.y2 = points[1][1];
        targetShape.percent = 1;
        var cp1 = points[2];
        if (cp1) {
            targetShape.cpx1 = cp1[0];
            targetShape.cpy1 = cp1[1];
        } else {
            targetShape.cpx1 = NaN;
            targetShape.cpy1 = NaN;
        }
    }
    var $ced1fe40d771d409$var$Line = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Line, _super);
        function Line(lineData, idx, seriesScope) {
            var _this = _super.call(this) || this;
            _this._createLine(lineData, idx, seriesScope);
            return _this;
        }
        Line.prototype._createLine = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var linePoints = lineData.getItemLayout(idx);
            var line = $ced1fe40d771d409$var$createLine(linePoints);
            line.shape.percent = 0;
            (0, parcelRequire("eYgMC")).initProps(line, {
                shape: {
                    percent: 1
                }
            }, seriesModel, idx);
            this.add(line);
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
                this[$ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
            }, this);
            this._updateCommonStl(lineData, idx, seriesScope);
        };
        Line.prototype.updateData = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var line = this.childOfName('line');
            var linePoints = lineData.getItemLayout(idx);
            var target = {
                shape: {}
            };
            $ced1fe40d771d409$var$setLinePoints(target.shape, linePoints);
            (0, parcelRequire("eYgMC")).updateProps(line, target, seriesModel, idx);
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbolType = lineData.getItemVisual(idx, symbolCategory);
                var key = $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory);
                if (this[key] !== symbolType) {
                    this.remove(this.childOfName(symbolCategory));
                    var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                    this.add(symbol);
                }
                this[key] = symbolType;
            }, this);
            this._updateCommonStl(lineData, idx, seriesScope);
        };
        Line.prototype.getLinePath = function() {
            return this.childAt(0);
        };
        Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
            var seriesModel = lineData.hostModel;
            var line = this.childOfName('line');
            var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
            var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
            var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
            var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
            if (!seriesScope || lineData.hasItemOption) {
                var itemModel = lineData.getItemModel(idx);
                emphasisLineStyle = itemModel.getModel([
                    'emphasis',
                    'lineStyle'
                ]).getLineStyle();
                blurLineStyle = itemModel.getModel([
                    'blur',
                    'lineStyle'
                ]).getLineStyle();
                selectLineStyle = itemModel.getModel([
                    'select',
                    'lineStyle'
                ]).getLineStyle();
                labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
            }
            var lineStyle = lineData.getItemVisual(idx, 'style');
            var visualColor = lineStyle.stroke;
            line.useStyle(lineStyle);
            line.style.fill = null;
            line.style.strokeNoScale = true;
            line.ensureState('emphasis').style = emphasisLineStyle;
            line.ensureState('blur').style = blurLineStyle;
            line.ensureState('select').style = selectLineStyle;
            (0, (0, parcelRequire("bahqM")).each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
                var symbol = this.childOfName(symbolCategory);
                if (symbol) {
                    symbol.setColor(visualColor);
                    symbol.style.opacity = lineStyle.opacity;
                    for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
                        var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
                        var lineState = line.getState(stateName);
                        if (lineState) {
                            var lineStateStyle = lineState.style || {};
                            var state = symbol.ensureState(stateName);
                            var stateStyle = state.style || (state.style = {});
                            if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                            if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                        }
                    }
                    symbol.markRedraw();
                }
            }, this);
            var rawVal = seriesModel.getRawValue(idx);
            (0, (0, parcelRequire("gvLUt")).setLabelStyle)(this, labelStatesModels, {
                labelDataIndex: idx,
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                    }
                },
                inheritColor: visualColor || '#000',
                defaultOpacity: lineStyle.opacity,
                defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, (0, parcelRequire("jmSNG")).round)(rawVal) : rawVal) + ''
            });
            var label = this.getTextContent();
            if (label) {
                var labelNormalModel = labelStatesModels.normal;
                label.__align = label.style.align;
                label.__verticalAlign = label.style.verticalAlign;
                label.__position = labelNormalModel.get('position') || 'middle';
                var distance = labelNormalModel.get('distance');
                if (!(0, (0, parcelRequire("bahqM")).isArray)(distance)) distance = [
                    distance,
                    distance
                ];
                label.__labelDistance = distance;
            }
            this.setTextConfig({
                position: null,
                local: true,
                inside: false
            });
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this);
        };
        Line.prototype.highlight = function() {
            (0, (0, parcelRequire("fIXXx")).enterEmphasis)(this);
        };
        Line.prototype.downplay = function() {
            (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(this);
        };
        Line.prototype.updateLayout = function(lineData, idx) {
            this.setLinePoints(lineData.getItemLayout(idx));
        };
        Line.prototype.setLinePoints = function(points) {
            var linePath = this.childOfName('line');
            $ced1fe40d771d409$var$setLinePoints(linePath.shape, points);
            linePath.dirty();
        };
        Line.prototype.beforeUpdate = function() {
            var lineGroup = this;
            var symbolFrom = lineGroup.childOfName('fromSymbol');
            var symbolTo = lineGroup.childOfName('toSymbol');
            var label = lineGroup.getTextContent();
            if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
            var invScale = 1;
            var parentNode = this.parent;
            while(parentNode){
                if (parentNode.scaleX) invScale /= parentNode.scaleX;
                parentNode = parentNode.parent;
            }
            var line = lineGroup.childOfName('line');
            if (!this.__dirty && !line.__dirty) return;
            var percent = line.shape.percent;
            var fromPos = line.pointAt(0);
            var toPos = line.pointAt(percent);
            var d = (0, parcelRequire("eLEew")).sub([], toPos, fromPos);
            (0, parcelRequire("eLEew")).normalize(d, d);
            function setSymbolRotation(symbol, percent) {
                var specifiedRotation = symbol.__specifiedRotation;
                if (specifiedRotation == null) {
                    var tangent = line.tangentAt(percent);
                    symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
                } else symbol.attr('rotation', specifiedRotation);
            }
            if (symbolFrom) {
                symbolFrom.setPosition(fromPos);
                setSymbolRotation(symbolFrom, 0);
                symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
                symbolFrom.markRedraw();
            }
            if (symbolTo) {
                symbolTo.setPosition(toPos);
                setSymbolRotation(symbolTo, 1);
                symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
                symbolTo.markRedraw();
            }
            if (label && !label.ignore) {
                label.x = label.y = 0;
                label.originX = label.originY = 0;
                var textAlign = void 0;
                var textVerticalAlign = void 0;
                var distance = label.__labelDistance;
                var distanceX = distance[0] * invScale;
                var distanceY = distance[1] * invScale;
                var halfPercent = percent / 2;
                var tangent = line.tangentAt(halfPercent);
                var n = [
                    tangent[1],
                    -tangent[0]
                ];
                var cp = line.pointAt(halfPercent);
                if (n[1] > 0) {
                    n[0] = -n[0];
                    n[1] = -n[1];
                }
                var dir = tangent[0] < 0 ? -1 : 1;
                if (label.__position !== 'start' && label.__position !== 'end') {
                    var rotation = -Math.atan2(tangent[1], tangent[0]);
                    if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                    label.rotation = rotation;
                }
                var dy = void 0;
                switch(label.__position){
                    case 'insideStartTop':
                    case 'insideMiddleTop':
                    case 'insideEndTop':
                    case 'middle':
                        dy = -distanceY;
                        textVerticalAlign = 'bottom';
                        break;
                    case 'insideStartBottom':
                    case 'insideMiddleBottom':
                    case 'insideEndBottom':
                        dy = distanceY;
                        textVerticalAlign = 'top';
                        break;
                    default:
                        dy = 0;
                        textVerticalAlign = 'middle';
                }
                switch(label.__position){
                    case 'end':
                        label.x = d[0] * distanceX + toPos[0];
                        label.y = d[1] * distanceY + toPos[1];
                        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                        break;
                    case 'start':
                        label.x = -d[0] * distanceX + fromPos[0];
                        label.y = -d[1] * distanceY + fromPos[1];
                        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                        break;
                    case 'insideStartTop':
                    case 'insideStart':
                    case 'insideStartBottom':
                        label.x = distanceX * dir + fromPos[0];
                        label.y = fromPos[1] + dy;
                        textAlign = tangent[0] < 0 ? 'right' : 'left';
                        label.originX = -distanceX * dir;
                        label.originY = -dy;
                        break;
                    case 'insideMiddleTop':
                    case 'insideMiddle':
                    case 'insideMiddleBottom':
                    case 'middle':
                        label.x = cp[0];
                        label.y = cp[1] + dy;
                        textAlign = 'center';
                        label.originY = -dy;
                        break;
                    case 'insideEndTop':
                    case 'insideEnd':
                    case 'insideEndBottom':
                        label.x = -distanceX * dir + toPos[0];
                        label.y = toPos[1] + dy;
                        textAlign = tangent[0] >= 0 ? 'right' : 'left';
                        label.originX = distanceX * dir;
                        label.originY = -dy;
                        break;
                }
                label.scaleX = label.scaleY = invScale;
                label.setStyle({
                    verticalAlign: label.__verticalAlign || textVerticalAlign,
                    align: label.__align || textAlign
                });
            }
        };
        return Line;
    }((0, parcelRequire("4KVOr")).default);
    var $ced1fe40d771d409$export$2e2bcd8739ae039 = $ced1fe40d771d409$var$Line;
});
parcelRegister("iUQRt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc56761fbff4269e$export$2e2bcd8739ae039);
    var $3VFsf;
    parcelRequire("fHITF");
    var $04gw0;
    var $cZb1F;
    var $ghQ8v;
    var $eLEew;
    var $dc56761fbff4269e$var$straightLineProto = (0, parcelRequire("cZb1F")).default.prototype;
    var $dc56761fbff4269e$var$bezierCurveProto = (0, parcelRequire("04gw0")).default.prototype;
    var $dc56761fbff4269e$var$StraightLineShape = function() {
        function StraightLineShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.percent = 1;
        }
        return StraightLineShape;
    }();
    var $dc56761fbff4269e$var$CurveShape = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CurveShape, _super);
        function CurveShape() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return CurveShape;
    }($dc56761fbff4269e$var$StraightLineShape);
    function $dc56761fbff4269e$var$isStraightLine(shape) {
        return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
    }
    var $dc56761fbff4269e$var$ECLinePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECLinePath, _super);
        function ECLinePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'ec-line';
            return _this;
        }
        ECLinePath.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        ECLinePath.prototype.getDefaultShape = function() {
            return new $dc56761fbff4269e$var$StraightLineShape();
        };
        ECLinePath.prototype.buildPath = function(ctx, shape) {
            if ($dc56761fbff4269e$var$isStraightLine(shape)) $dc56761fbff4269e$var$straightLineProto.buildPath.call(this, ctx, shape);
            else $dc56761fbff4269e$var$bezierCurveProto.buildPath.call(this, ctx, shape);
        };
        ECLinePath.prototype.pointAt = function(t) {
            if ($dc56761fbff4269e$var$isStraightLine(this.shape)) return $dc56761fbff4269e$var$straightLineProto.pointAt.call(this, t);
            else return $dc56761fbff4269e$var$bezierCurveProto.pointAt.call(this, t);
        };
        ECLinePath.prototype.tangentAt = function(t) {
            var shape = this.shape;
            var p = $dc56761fbff4269e$var$isStraightLine(shape) ? [
                shape.x2 - shape.x1,
                shape.y2 - shape.y1
            ] : $dc56761fbff4269e$var$bezierCurveProto.tangentAt.call(this, t);
            return (0, parcelRequire("eLEew")).normalize(p, p);
        };
        return ECLinePath;
    }((0, parcelRequire("ghQ8v")).default);
    var $dc56761fbff4269e$export$2e2bcd8739ae039 = $dc56761fbff4269e$var$ECLinePath;
});
parcelRegister("k3pUt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9982f98742e3477$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fkskt;
    var $bahqM;
    var $h8Fle;
    var $eaKsF;
    var $fIXXx;
    var $e9982f98742e3477$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $e9982f98742e3477$var$MarkerView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MarkerView, _super);
        function MarkerView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = MarkerView.type;
            return _this;
        }
        MarkerView.prototype.init = function() {
            this.markerGroupMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        };
        MarkerView.prototype.render = function(markerModel, ecModel, api) {
            var _this = this;
            var markerGroupMap = this.markerGroupMap;
            markerGroupMap.each(function(item) {
                $e9982f98742e3477$var$inner(item).keep = false;
            });
            ecModel.eachSeries(function(seriesModel) {
                var markerModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, _this.type);
                markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
            });
            markerGroupMap.each(function(item) {
                !$e9982f98742e3477$var$inner(item).keep && _this.group.remove(item.group);
            });
        };
        MarkerView.prototype.markKeep = function(drawGroup) {
            $e9982f98742e3477$var$inner(drawGroup).keep = true;
        };
        MarkerView.prototype.blurSeries = function(seriesModelList) {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)(seriesModelList, function(seriesModel) {
                var markerModel = (0, (0, parcelRequire("h8Fle")).default).getMarkerModelFromSeries(seriesModel, _this.type);
                if (markerModel) {
                    var data = markerModel.getData();
                    data.eachItemGraphicEl(function(el) {
                        if (el) (0, (0, parcelRequire("fIXXx")).enterBlur)(el);
                    });
                }
            });
        };
        MarkerView.type = 'marker';
        return MarkerView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $e9982f98742e3477$export$2e2bcd8739ae039 = $e9982f98742e3477$var$MarkerView;
});
parcelRegister("gLj36", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$c33fcfdcc4592871$export$4b3e715f166fdd78);
    var $hi3Y7;
    var $alpND;
    var $ixwqj;
    var $kfWc4;
    function $c33fcfdcc4592871$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("hi3Y7")).install));
        registers.registerComponentModel((0, (0, parcelRequire("ixwqj")).default));
        registers.registerComponentView((0, (0, parcelRequire("kfWc4")).default));
        registers.registerAction({
            type: 'showTip',
            event: 'showTip',
            update: 'tooltip:manuallyShowTip'
        }, function() {});
        registers.registerAction({
            type: 'hideTip',
            event: 'hideTip',
            update: 'tooltip:manuallyHideTip'
        }, function() {});
    }
});
parcelRegister("ixwqj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7f475abbf81e4fb$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $d7f475abbf81e4fb$var$TooltipModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TooltipModel, _super);
        function TooltipModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = TooltipModel.type;
            return _this;
        }
        TooltipModel.type = 'tooltip';
        TooltipModel.dependencies = [
            'axisPointer'
        ];
        TooltipModel.defaultOption = {
            zlevel: 0,
            z: 60,
            show: true,
            showContent: true,
            trigger: 'item',
            triggerOn: 'mousemove|click',
            alwaysShowContent: false,
            displayMode: 'single',
            renderMode: 'auto',
            confine: null,
            showDelay: 0,
            hideDelay: 100,
            transitionDuration: 0.4,
            enterable: false,
            backgroundColor: '#fff',
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, .2)',
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            borderRadius: 4,
            borderWidth: 1,
            padding: null,
            extraCssText: '',
            axisPointer: {
                type: 'line',
                axis: 'auto',
                animation: 'auto',
                animationDurationUpdate: 200,
                animationEasingUpdate: 'exponentialOut',
                crossStyle: {
                    color: '#999',
                    width: 1,
                    type: 'dashed',
                    textStyle: {}
                }
            },
            textStyle: {
                color: '#666',
                fontSize: 14
            }
        };
        return TooltipModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $d7f475abbf81e4fb$export$2e2bcd8739ae039 = $d7f475abbf81e4fb$var$TooltipModel;
});
parcelRegister("kfWc4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf2596432d1aebb$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $lh5Tz;
    var $bf1zw;
    var $dCJrM;
    var $jmSNG;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $4LkI5;
    var $65MS1;
    var $gaMkj;
    var $iNebh;
    var $3GIoT;
    var $eSE0c;
    var $eaKsF;
    var $fkskt;
    var $bc1Ad;
    var $7QjoM;
    var $l3AHA;
    var $guzSc;
    var $j5lKL;
    var $6IsbX;
    var $ljaBy;
    var $ebf2596432d1aebb$var$bind = (0, parcelRequire("bahqM")).bind;
    var $ebf2596432d1aebb$var$each = (0, parcelRequire("bahqM")).each;
    var $ebf2596432d1aebb$var$parsePercent = (0, parcelRequire("jmSNG")).parsePercent;
    var $ebf2596432d1aebb$var$proxyRect = new (0, parcelRequire("7Tw7u")).default({
        shape: {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        }
    });
    var $ebf2596432d1aebb$var$TooltipView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TooltipView, _super);
        function TooltipView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = TooltipView.type;
            return _this;
        }
        TooltipView.prototype.init = function(ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            var tooltipModel = ecModel.getComponent('tooltip');
            var renderMode = tooltipModel.get('renderMode');
            this._renderMode = (0, (0, parcelRequire("eaKsF")).getTooltipRenderMode)(renderMode);
            this._tooltipContent = this._renderMode === 'richText' ? new (0, (0, parcelRequire("bf1zw")).default)(api) : new (0, (0, parcelRequire("lh5Tz")).default)(api.getDom(), api, {
                appendToBody: tooltipModel.get('appendToBody', true)
            });
        };
        TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            this.group.removeAll();
            this._tooltipModel = tooltipModel;
            this._ecModel = ecModel;
            this._api = api;
            this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
            var tooltipContent = this._tooltipContent;
            tooltipContent.update(tooltipModel);
            tooltipContent.setEnterable(tooltipModel.get('enterable'));
            this._initGlobalListener();
            this._keepShow();
            this._updatePosition = this._renderMode === 'html' ? (0, (0, parcelRequire("ljaBy")).throttle)($ebf2596432d1aebb$var$bind(this._doUpdatePosition, this), 50) : this._doUpdatePosition;
        };
        TooltipView.prototype._initGlobalListener = function() {
            var tooltipModel = this._tooltipModel;
            var triggerOn = tooltipModel.get('triggerOn');
            (0, parcelRequire("iNebh")).register('itemTooltip', this._api, $ebf2596432d1aebb$var$bind(function(currTrigger, e, dispatchAction) {
                if (triggerOn !== 'none') {
                    if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                    else if (currTrigger === 'leave') this._hide(dispatchAction);
                }
            }, this));
        };
        TooltipView.prototype._keepShow = function() {
            var tooltipModel = this._tooltipModel;
            var ecModel = this._ecModel;
            var api = this._api;
            if (this._lastX != null && this._lastY != null && tooltipModel.get('triggerOn') !== 'none') {
                var self_1 = this;
                clearTimeout(this._refreshUpdateTimeout);
                this._refreshUpdateTimeout = setTimeout(function() {
                    !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                        x: self_1._lastX,
                        y: self_1._lastY,
                        dataByCoordSys: self_1._lastDataByCoordSys
                    });
                });
            }
        };
        TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
            if (payload.from === this.uid || (0, (0, parcelRequire("hZfwb")).default).node) return;
            var dispatchAction = $ebf2596432d1aebb$var$makeDispatchAction(payload, api);
            this._ticket = '';
            var dataByCoordSys = payload.dataByCoordSys;
            var cmptRef = $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api);
            if (cmptRef) {
                var rect = cmptRef.el.getBoundingRect().clone();
                rect.applyTransform(cmptRef.el.transform);
                this._tryShow({
                    offsetX: rect.x + rect.width / 2,
                    offsetY: rect.y + rect.height / 2,
                    target: cmptRef.el,
                    position: payload.position,
                    positionDefault: 'bottom'
                }, dispatchAction);
            } else if (payload.tooltip && payload.x != null && payload.y != null) {
                var el = $ebf2596432d1aebb$var$proxyRect;
                el.x = payload.x;
                el.y = payload.y;
                el.update();
                (0, (0, parcelRequire("7QjoM")).getECData)(el).tooltipConfig = {
                    name: null,
                    option: payload.tooltip
                };
                this._tryShow({
                    offsetX: payload.x,
                    offsetY: payload.y,
                    target: el
                }, dispatchAction);
            } else if (dataByCoordSys) this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                dataByCoordSys: dataByCoordSys,
                tooltipOption: payload.tooltipOption
            }, dispatchAction);
            else if (payload.seriesIndex != null) {
                if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
                var pointInfo = (0, (0, parcelRequire("4LkI5")).default)(payload, ecModel);
                var cx = pointInfo.point[0];
                var cy = pointInfo.point[1];
                if (cx != null && cy != null) this._tryShow({
                    offsetX: cx,
                    offsetY: cy,
                    target: pointInfo.el,
                    position: payload.position,
                    positionDefault: 'bottom'
                }, dispatchAction);
            } else if (payload.x != null && payload.y != null) {
                api.dispatchAction({
                    type: 'updateAxisPointer',
                    x: payload.x,
                    y: payload.y
                });
                this._tryShow({
                    offsetX: payload.x,
                    offsetY: payload.y,
                    position: payload.position,
                    target: api.getZr().findHover(payload.x, payload.y).target
                }, dispatchAction);
            }
        };
        TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
            var tooltipContent = this._tooltipContent;
            if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
            this._lastX = this._lastY = this._lastDataByCoordSys = null;
            if (payload.from !== this.uid) this._hide($ebf2596432d1aebb$var$makeDispatchAction(payload, api));
        };
        TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
            var seriesIndex = payload.seriesIndex;
            var dataIndex = payload.dataIndex;
            var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
            if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            if (!seriesModel) return;
            var data = seriesModel.getData();
            var tooltipCascadedModel = $ebf2596432d1aebb$var$buildTooltipModel([
                data.getItemModel(dataIndex),
                seriesModel,
                (seriesModel.coordinateSystem || {}).model
            ], this._tooltipModel);
            if (tooltipCascadedModel.get('trigger') !== 'axis') return;
            api.dispatchAction({
                type: 'updateAxisPointer',
                seriesIndex: seriesIndex,
                dataIndex: dataIndex,
                position: payload.position
            });
            return true;
        };
        TooltipView.prototype._tryShow = function(e, dispatchAction) {
            var el = e.target;
            var tooltipModel = this._tooltipModel;
            if (!tooltipModel) return;
            this._lastX = e.offsetX;
            this._lastY = e.offsetY;
            var dataByCoordSys = e.dataByCoordSys;
            if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
            else if (el) {
                this._lastDataByCoordSys = null;
                var seriesDispatcher_1;
                var cmptDispatcher_1;
                (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(target) {
                    if ((0, (0, parcelRequire("7QjoM")).getECData)(target).dataIndex != null) {
                        seriesDispatcher_1 = target;
                        return true;
                    }
                    if ((0, (0, parcelRequire("7QjoM")).getECData)(target).tooltipConfig != null) {
                        cmptDispatcher_1 = target;
                        return true;
                    }
                }, true);
                if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
                else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
                else this._hide(dispatchAction);
            } else {
                this._lastDataByCoordSys = null;
                this._hide(dispatchAction);
            }
        };
        TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
            var delay = tooltipModel.get('showDelay');
            cb = (0, parcelRequire("bahqM")).bind(cb, this);
            clearTimeout(this._showTimout);
            delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
        };
        TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
            var ecModel = this._ecModel;
            var globalTooltipModel = this._tooltipModel;
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var singleTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
                e.tooltipOption
            ], globalTooltipModel);
            var renderMode = this._renderMode;
            var cbParamsList = [];
            var articleMarkup = (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                blocks: [],
                noHeader: true
            });
            var markupTextArrLegacy = [];
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            $ebf2596432d1aebb$var$each(dataByCoordSys, function(itemCoordSys) {
                $ebf2596432d1aebb$var$each(itemCoordSys.dataByAxis, function(axisItem) {
                    var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                    var axisValue = axisItem.value;
                    if (!axisModel || axisValue == null) return;
                    var axisValueLabel = (0, parcelRequire("eSE0c")).getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                    var axisSectionMarkup = (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
                        header: axisValueLabel,
                        noHeader: !(0, parcelRequire("bahqM")).trim(axisValueLabel),
                        sortBlocks: true,
                        blocks: []
                    });
                    articleMarkup.blocks.push(axisSectionMarkup);
                    (0, parcelRequire("bahqM")).each(axisItem.seriesDataIndices, function(idxItem) {
                        var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                        var dataIndex = idxItem.dataIndexInside;
                        var cbParams = series.getDataParams(dataIndex);
                        if (cbParams.dataIndex < 0) return;
                        cbParams.axisDim = axisItem.axisDim;
                        cbParams.axisIndex = axisItem.axisIndex;
                        cbParams.axisType = axisItem.axisType;
                        cbParams.axisId = axisItem.axisId;
                        cbParams.axisValue = (0, parcelRequire("3GIoT")).getAxisRawValue(axisModel.axis, {
                            value: axisValue
                        });
                        cbParams.axisValueLabel = axisValueLabel;
                        cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, parcelRequire("dCJrM")).convertToColorString(cbParams.color), renderMode);
                        var seriesTooltipResult = (0, (0, parcelRequire("guzSc")).normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                        if (seriesTooltipResult.markupFragment) axisSectionMarkup.blocks.push(seriesTooltipResult.markupFragment);
                        if (seriesTooltipResult.markupText) markupTextArrLegacy.push(seriesTooltipResult.markupText);
                        cbParamsList.push(cbParams);
                    });
                });
            });
            articleMarkup.blocks.reverse();
            markupTextArrLegacy.reverse();
            var positionExpr = e.position;
            var orderMode = singleTooltipModel.get('order');
            var builtMarkupText = (0, (0, parcelRequire("j5lKL")).buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
            builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
            var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
            var allMarkupText = markupTextArrLegacy.join(blockBreak);
            this._showOrMove(singleTooltipModel, function() {
                if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
                else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
            });
        };
        TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
            var ecModel = this._ecModel;
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
            var seriesIndex = ecData.seriesIndex;
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            var dataModel = ecData.dataModel || seriesModel;
            var dataIndex = ecData.dataIndex;
            var dataType = ecData.dataType;
            var data = dataModel.getData(dataType);
            var renderMode = this._renderMode;
            var positionDefault = e.positionDefault;
            var tooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
                data.getItemModel(dataIndex),
                dataModel,
                seriesModel && (seriesModel.coordinateSystem || {}).model
            ], this._tooltipModel, positionDefault ? {
                position: positionDefault
            } : null);
            var tooltipTrigger = tooltipModel.get('trigger');
            if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
            var params = dataModel.getDataParams(dataIndex, dataType);
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            params.marker = markupStyleCreator.makeTooltipMarker('item', (0, parcelRequire("dCJrM")).convertToColorString(params.color), renderMode);
            var seriesTooltipResult = (0, (0, parcelRequire("guzSc")).normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
            var orderMode = tooltipModel.get('order');
            var markupText = seriesTooltipResult.markupFragment ? (0, (0, parcelRequire("j5lKL")).buildTooltipMarkup)(seriesTooltipResult.markupFragment, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.markupText;
            var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
            this._showOrMove(tooltipModel, function() {
                this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
            });
            dispatchAction({
                type: 'showTip',
                dataIndexInside: dataIndex,
                dataIndex: data.getRawIndex(dataIndex),
                seriesIndex: seriesIndex,
                from: this.uid
            });
        };
        TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            var tooltipConfig = ecData.tooltipConfig;
            var tooltipOpt = tooltipConfig.option || {};
            if ((0, parcelRequire("bahqM")).isString(tooltipOpt)) {
                var content = tooltipOpt;
                tooltipOpt = {
                    content: content,
                    formatter: content
                };
            }
            var tooltipModelCascade = [
                tooltipOpt
            ];
            var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
            if (cmpt) tooltipModelCascade.push(cmpt);
            tooltipModelCascade.push({
                formatter: tooltipOpt.content
            });
            var positionDefault = e.positionDefault;
            var subTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
                position: positionDefault
            } : null);
            var defaultHtml = subTooltipModel.get('content');
            var asyncTicket = Math.random() + '';
            var markupStyleCreator = new (0, (0, parcelRequire("j5lKL")).TooltipMarkupStyleCreator)();
            this._showOrMove(subTooltipModel, function() {
                var formatterParams = (0, parcelRequire("bahqM")).clone(subTooltipModel.get('formatterParams') || {});
                this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
            });
            dispatchAction({
                type: 'showTip',
                from: this.uid
            });
        };
        TooltipView.prototype._showTooltipContent = function(tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
            this._ticket = '';
            if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
            var tooltipContent = this._tooltipContent;
            var formatter = tooltipModel.get('formatter');
            positionExpr = positionExpr || tooltipModel.get('position');
            var html = defaultHtml;
            var nearPoint = this._getNearestPoint([
                x,
                y
            ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
            var nearPointColor = nearPoint.color;
            if (formatter) {
                if ((0, parcelRequire("bahqM")).isString(formatter)) {
                    var useUTC = tooltipModel.ecModel.get('useUTC');
                    var params0 = (0, parcelRequire("bahqM")).isArray(params) ? params[0] : params;
                    var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                    html = formatter;
                    if (isTimeAxis) html = (0, (0, parcelRequire("bc1Ad")).format)(params0.axisValue, html, useUTC);
                    html = (0, parcelRequire("dCJrM")).formatTpl(html, params, true);
                } else if ((0, parcelRequire("bahqM")).isFunction(formatter)) {
                    var callback = $ebf2596432d1aebb$var$bind(function(cbTicket, html) {
                        if (cbTicket === this._ticket) {
                            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                        }
                    }, this);
                    this._ticket = asyncTicket;
                    html = formatter(params, asyncTicket, callback);
                } else html = formatter;
            }
            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
            tooltipContent.show(tooltipModel, nearPointColor);
            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        };
        TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
            if (trigger === 'axis' || (0, parcelRequire("bahqM")).isArray(tooltipDataParams)) return {
                color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
            };
            if (!(0, parcelRequire("bahqM")).isArray(tooltipDataParams)) return {
                color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
            };
        };
        TooltipView.prototype._doUpdatePosition = function(tooltipModel, positionExpr, x, y, content, params, el) {
            var viewWidth = this._api.getWidth();
            var viewHeight = this._api.getHeight();
            positionExpr = positionExpr || tooltipModel.get('position');
            var contentSize = content.getSize();
            var align = tooltipModel.get('align');
            var vAlign = tooltipModel.get('verticalAlign');
            var rect = el && el.getBoundingRect().clone();
            el && rect.applyTransform(el.transform);
            if ((0, parcelRequire("bahqM")).isFunction(positionExpr)) positionExpr = positionExpr([
                x,
                y
            ], params, content.el, rect, {
                viewSize: [
                    viewWidth,
                    viewHeight
                ],
                contentSize: contentSize.slice()
            });
            if ((0, parcelRequire("bahqM")).isArray(positionExpr)) {
                x = $ebf2596432d1aebb$var$parsePercent(positionExpr[0], viewWidth);
                y = $ebf2596432d1aebb$var$parsePercent(positionExpr[1], viewHeight);
            } else if ((0, parcelRequire("bahqM")).isObject(positionExpr)) {
                var boxLayoutPosition = positionExpr;
                boxLayoutPosition.width = contentSize[0];
                boxLayoutPosition.height = contentSize[1];
                var layoutRect = (0, parcelRequire("65MS1")).getLayoutRect(boxLayoutPosition, {
                    width: viewWidth,
                    height: viewHeight
                });
                x = layoutRect.x;
                y = layoutRect.y;
                align = null;
                vAlign = null;
            } else if ((0, parcelRequire("bahqM")).isString(positionExpr) && el) {
                var pos = $ebf2596432d1aebb$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
                x = pos[0];
                y = pos[1];
            } else {
                var pos = $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
                x = pos[0];
                y = pos[1];
            }
            align && (x -= $ebf2596432d1aebb$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
            vAlign && (y -= $ebf2596432d1aebb$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
            if ((0, (0, parcelRequire("l3AHA")).shouldTooltipConfine)(tooltipModel)) {
                var pos = $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
                x = pos[0];
                y = pos[1];
            }
            content.moveTo(x, y);
        };
        TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
            var lastCoordSys = this._lastDataByCoordSys;
            var lastCbParamsList = this._cbParamsList;
            var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
            contentNotChanged && $ebf2596432d1aebb$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
                var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
                var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
                var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
                contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
                contentNotChanged && $ebf2596432d1aebb$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                    var thisItem = thisDataByAxis[indexAxis] || {};
                    var lastIndices = lastItem.seriesDataIndices || [];
                    var newIndices = thisItem.seriesDataIndices || [];
                    contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                    contentNotChanged && $ebf2596432d1aebb$var$each(lastIndices, function(lastIdxItem, j) {
                        var newIdxItem = newIndices[j];
                        contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                    });
                    lastCbParamsList && (0, parcelRequire("bahqM")).each(lastItem.seriesDataIndices, function(idxItem) {
                        var seriesIdx = idxItem.seriesIndex;
                        var cbParams = cbParamsList[seriesIdx];
                        var lastCbParams = lastCbParamsList[seriesIdx];
                        if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                    });
                });
            });
            this._lastDataByCoordSys = dataByCoordSys;
            this._cbParamsList = cbParamsList;
            return !!contentNotChanged;
        };
        TooltipView.prototype._hide = function(dispatchAction) {
            this._lastDataByCoordSys = null;
            dispatchAction({
                type: 'hideTip',
                from: this.uid
            });
        };
        TooltipView.prototype.dispose = function(ecModel, api) {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return;
            this._tooltipContent.dispose();
            (0, parcelRequire("iNebh")).unregister('itemTooltip', api);
        };
        TooltipView.type = 'tooltip';
        return TooltipView;
    }((0, (0, parcelRequire("fkskt")).default));
    function $ebf2596432d1aebb$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
        var ecModel = globalTooltipModel.ecModel;
        var resultModel;
        if (defaultTooltipOption) {
            resultModel = new (0, (0, parcelRequire("gaMkj")).default)(defaultTooltipOption, ecModel, ecModel);
            resultModel = new (0, (0, parcelRequire("gaMkj")).default)(globalTooltipModel.option, resultModel, ecModel);
        } else resultModel = globalTooltipModel;
        for(var i = modelCascade.length - 1; i >= 0; i--){
            var tooltipOpt = modelCascade[i];
            if (tooltipOpt) {
                if (tooltipOpt instanceof (0, (0, parcelRequire("gaMkj")).default)) tooltipOpt = tooltipOpt.get('tooltip', true);
                if ((0, parcelRequire("bahqM")).isString(tooltipOpt)) tooltipOpt = {
                    formatter: tooltipOpt
                };
                if (tooltipOpt) resultModel = new (0, (0, parcelRequire("gaMkj")).default)(tooltipOpt, resultModel, ecModel);
            }
        }
        return resultModel;
    }
    function $ebf2596432d1aebb$var$makeDispatchAction(payload, api) {
        return payload.dispatchAction || (0, parcelRequire("bahqM")).bind(api.dispatchAction, api);
    }
    function $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
        var size = content.getSize();
        var width = size[0];
        var height = size[1];
        if (gapH != null) {
            if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
            else x += gapH;
        }
        if (gapV != null) {
            if (y + height + gapV > viewHeight) y -= height + gapV;
            else y += gapV;
        }
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
        var size = content.getSize();
        var width = size[0];
        var height = size[1];
        x = Math.min(x + width, viewWidth) - width;
        y = Math.min(y + height, viewHeight) - height;
        x = Math.max(x, 0);
        y = Math.max(y, 0);
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
        var domWidth = contentSize[0];
        var domHeight = contentSize[1];
        var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
        var x = 0;
        var y = 0;
        var rectWidth = rect.width;
        var rectHeight = rect.height;
        switch(position){
            case 'inside':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y + rectHeight / 2 - domHeight / 2;
                break;
            case 'top':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y - domHeight - offset;
                break;
            case 'bottom':
                x = rect.x + rectWidth / 2 - domWidth / 2;
                y = rect.y + rectHeight + offset;
                break;
            case 'left':
                x = rect.x - domWidth - offset;
                y = rect.y + rectHeight / 2 - domHeight / 2;
                break;
            case 'right':
                x = rect.x + rectWidth + offset;
                y = rect.y + rectHeight / 2 - domHeight / 2;
        }
        return [
            x,
            y
        ];
    }
    function $ebf2596432d1aebb$var$isCenterAlign(align) {
        return align === 'center' || align === 'middle';
    }
    function $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api) {
        var queryOptionMap = (0, (0, parcelRequire("eaKsF")).preParseFinder)(payload).queryOptionMap;
        var componentMainType = queryOptionMap.keys()[0];
        if (!componentMainType || componentMainType === 'series') return;
        var queryResult = (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
            useDefault: false,
            enableAll: false,
            enableNone: false
        });
        var model = queryResult.models[0];
        if (!model) return;
        var view = api.getViewOfComponentModel(model);
        var el;
        view.group.traverse(function(subEl) {
            var tooltipConfig = (0, (0, parcelRequire("7QjoM")).getECData)(subEl).tooltipConfig;
            if (tooltipConfig && tooltipConfig.name === payload.name) {
                el = subEl;
                return true;
            }
        });
        if (el) return {
            componentMainType: componentMainType,
            componentIndex: model.componentIndex,
            el: el
        };
    }
    var $ebf2596432d1aebb$export$2e2bcd8739ae039 = $ebf2596432d1aebb$var$TooltipView;
});
parcelRegister("lh5Tz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7cfc2302c12dfb3$export$2e2bcd8739ae039);
    var $bahqM;
    var $d6udH;
    var $65X4x;
    var $6AZf6;
    var $hZfwb;
    var $dCJrM;
    var $l3AHA;
    var $j5lKL;
    var $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR = (0, (0, parcelRequire("l3AHA")).toCSSVendorPrefix)((0, (0, parcelRequire("l3AHA")).TRANSITION_VENDOR), 'transition');
    var $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR = (0, (0, parcelRequire("l3AHA")).toCSSVendorPrefix)((0, (0, parcelRequire("l3AHA")).TRANSFORM_VENDOR), 'transform');
    var $f7cfc2302c12dfb3$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, (0, parcelRequire("hZfwb")).default).transform3dSupported ? 'will-change:transform;' : '');
    function $f7cfc2302c12dfb3$var$mirrorPos(pos) {
        pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
        return pos;
    }
    function $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
        if (!(0, (0, parcelRequire("bahqM")).isString)(arrowPosition) || arrowPosition === 'inside') return '';
        var backgroundColor = tooltipModel.get('backgroundColor');
        var borderWidth = tooltipModel.get('borderWidth');
        borderColor = (0, (0, parcelRequire("dCJrM")).convertToColorString)(borderColor);
        var arrowPos = $f7cfc2302c12dfb3$var$mirrorPos(arrowPosition);
        var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
        var positionStyle = '';
        var transformStyle = $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':';
        var rotateDeg;
        if ((0, (0, parcelRequire("bahqM")).indexOf)([
            'left',
            'right'
        ], arrowPos) > -1) {
            positionStyle += 'top:50%';
            transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
        } else {
            positionStyle += 'left:50%';
            transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
        }
        var rotateRadian = rotateDeg * Math.PI / 180;
        var arrowWH = arrowSize + borderWidth;
        var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
        var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
        positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
        var borderStyle = borderColor + " solid " + borderWidth + "px;";
        var styleCss = [
            "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;",
            positionStyle + ";" + transformStyle + ";",
            "border-bottom:" + borderStyle,
            "border-right:" + borderStyle,
            "background-color:" + backgroundColor + ";"
        ];
        return "<div style=\"" + styleCss.join('') + "\"></div>";
    }
    function $f7cfc2302c12dfb3$var$assembleTransition(duration, onlyFade) {
        var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
        var transitionOption = " " + duration / 2 + "s " + transitionCurve;
        var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
        if (!onlyFade) {
            transitionOption = " " + duration + "s " + transitionCurve;
            transitionText += (0, (0, parcelRequire("hZfwb")).default).transformSupported ? "," + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
        }
        return $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
    }
    function $f7cfc2302c12dfb3$var$assembleTransform(x, y, toString) {
        var x0 = x.toFixed(0) + 'px';
        var y0 = y.toFixed(0) + 'px';
        if (!(0, (0, parcelRequire("hZfwb")).default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
            [
                'top',
                y0
            ],
            [
                'left',
                x0
            ]
        ];
        var is3d = (0, (0, parcelRequire("hZfwb")).default).transform3dSupported;
        var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
        return toString ? 'top:0;left:0;' + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
            [
                'top',
                0
            ],
            [
                'left',
                0
            ],
            [
                (0, (0, parcelRequire("l3AHA")).TRANSFORM_VENDOR),
                translate
            ]
        ];
    }
    function $f7cfc2302c12dfb3$var$assembleFont(textStyleModel) {
        var cssText = [];
        var fontSize = textStyleModel.get('fontSize');
        var color = textStyleModel.getTextColor();
        color && cssText.push('color:' + color);
        cssText.push('font:' + textStyleModel.getFont());
        fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
        var shadowColor = textStyleModel.get('textShadowColor');
        var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
        var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
        var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
        shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
        (0, (0, parcelRequire("bahqM")).each)([
            'decoration',
            'align'
        ], function(name) {
            var val = textStyleModel.get(name);
            val && cssText.push('text-' + name + ':' + val);
        });
        return cssText.join(';');
    }
    function $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
        var cssText = [];
        var transitionDuration = tooltipModel.get('transitionDuration');
        var backgroundColor = tooltipModel.get('backgroundColor');
        var shadowBlur = tooltipModel.get('shadowBlur');
        var shadowColor = tooltipModel.get('shadowColor');
        var shadowOffsetX = tooltipModel.get('shadowOffsetX');
        var shadowOffsetY = tooltipModel.get('shadowOffsetY');
        var textStyleModel = tooltipModel.getModel('textStyle');
        var padding = (0, (0, parcelRequire("j5lKL")).getPaddingFromTooltipModel)(tooltipModel, 'html');
        var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
        cssText.push('box-shadow:' + boxShadow);
        enableTransition && transitionDuration && cssText.push($f7cfc2302c12dfb3$var$assembleTransition(transitionDuration, onlyFade));
        if (backgroundColor) {
            if ((0, (0, parcelRequire("hZfwb")).default).canvasSupported) cssText.push('background-color:' + backgroundColor);
            else {
                cssText.push('background-color:#' + (0, (0, parcelRequire("d6udH")).toHex)(backgroundColor));
                cssText.push('filter:alpha(opacity=70)');
            }
        }
        (0, (0, parcelRequire("bahqM")).each)([
            'width',
            'color',
            'radius'
        ], function(name) {
            var borderName = 'border-' + name;
            var camelCase = (0, (0, parcelRequire("dCJrM")).toCamelCase)(borderName);
            var val = tooltipModel.get(camelCase);
            val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
        });
        cssText.push($f7cfc2302c12dfb3$var$assembleFont(textStyleModel));
        if (padding != null) cssText.push('padding:' + (0, (0, parcelRequire("dCJrM")).normalizeCssArray)(padding).join('px ') + 'px');
        return cssText.join(';') + ';';
    }
    function $f7cfc2302c12dfb3$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
        var zrPainter = zr && zr.painter;
        if (appendToBody) {
            var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
            if (zrViewportRoot) (0, (0, parcelRequire("6AZf6")).transformLocalCoord)(out, zrViewportRoot, document.body, zrX, zrY);
        } else {
            out[0] = zrX;
            out[1] = zrY;
            var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
            if (viewportRootOffset) {
                out[0] += viewportRootOffset.offsetLeft;
                out[1] += viewportRootOffset.offsetTop;
            }
        }
        out[2] = out[0] / zr.getWidth();
        out[3] = out[1] / zr.getHeight();
    }
    var $f7cfc2302c12dfb3$var$TooltipHTMLContent = function() {
        function TooltipHTMLContent(container, api, opt) {
            this._show = false;
            this._styleCoord = [
                0,
                0,
                0,
                0
            ];
            this._enterable = true;
            this._firstShow = true;
            this._longHide = true;
            if ((0, (0, parcelRequire("hZfwb")).default).wxa) return null;
            var el = document.createElement('div');
            el.domBelongToZr = true;
            this.el = el;
            var zr = this._zr = api.getZr();
            var appendToBody = this._appendToBody = opt && opt.appendToBody;
            $f7cfc2302c12dfb3$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
            if (appendToBody) document.body.appendChild(el);
            else container.appendChild(el);
            this._container = container;
            var self = this;
            el.onmouseenter = function() {
                if (self._enterable) {
                    clearTimeout(self._hideTimeout);
                    self._show = true;
                }
                self._inContent = true;
            };
            el.onmousemove = function(e) {
                e = e || window.event;
                if (!self._enterable) {
                    var handler = zr.handler;
                    var zrViewportRoot = zr.painter.getViewportRoot();
                    (0, (0, parcelRequire("65X4x")).normalizeEvent)(zrViewportRoot, e, true);
                    handler.dispatch('mousemove', e);
                }
            };
            el.onmouseleave = function() {
                self._inContent = false;
                if (self._enterable) {
                    if (self._show) self.hideLater(self._hideDelay);
                }
            };
        }
        TooltipHTMLContent.prototype.update = function(tooltipModel) {
            var container = this._container;
            var position = (0, (0, parcelRequire("l3AHA")).getComputedStyle)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
            var alwaysShowContent = tooltipModel.get('alwaysShowContent');
            alwaysShowContent && this._moveIfResized();
            this.el.className = tooltipModel.get('className') || '';
        };
        TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
            clearTimeout(this._hideTimeout);
            clearTimeout(this._longHideTimeout);
            var el = this.el;
            var style = el.style;
            var styleCoord = this._styleCoord;
            if (!el.innerHTML) style.display = 'none';
            else style.cssText = $f7cfc2302c12dfb3$var$gCssText + $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, (0, parcelRequire("dCJrM")).convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
            this._show = true;
            this._firstShow = false;
            this._longHide = false;
        };
        TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
            var el = this.el;
            if (content == null) {
                el.innerHTML = '';
                return;
            }
            var arrow = '';
            if ((0, (0, parcelRequire("bahqM")).isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, (0, parcelRequire("l3AHA")).shouldTooltipConfine)(tooltipModel)) arrow = $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
            if ((0, (0, parcelRequire("bahqM")).isString)(content)) el.innerHTML = content + arrow;
            else if (content) {
                el.innerHTML = '';
                if (!(0, (0, parcelRequire("bahqM")).isArray)(content)) content = [
                    content
                ];
                for(var i = 0; i < content.length; i++)if ((0, (0, parcelRequire("bahqM")).isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
                if (arrow && el.childNodes.length) {
                    var arrowEl = document.createElement('div');
                    arrowEl.innerHTML = arrow;
                    el.appendChild(arrowEl);
                }
            }
        };
        TooltipHTMLContent.prototype.setEnterable = function(enterable) {
            this._enterable = enterable;
        };
        TooltipHTMLContent.prototype.getSize = function() {
            var el = this.el;
            return [
                el.offsetWidth,
                el.offsetHeight
            ];
        };
        TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
            var styleCoord = this._styleCoord;
            $f7cfc2302c12dfb3$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
            if (styleCoord[0] != null && styleCoord[1] != null) {
                var style_1 = this.el.style;
                var transforms = $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1]);
                (0, (0, parcelRequire("bahqM")).each)(transforms, function(transform) {
                    style_1[transform[0]] = transform[1];
                });
            }
        };
        TooltipHTMLContent.prototype._moveIfResized = function() {
            var ratioX = this._styleCoord[2];
            var ratioY = this._styleCoord[3];
            this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
        };
        TooltipHTMLContent.prototype.hide = function() {
            var _this = this;
            var style = this.el.style;
            style.visibility = 'hidden';
            style.opacity = '0';
            (0, (0, parcelRequire("hZfwb")).default).transform3dSupported && (style.willChange = '');
            this._show = false;
            this._longHideTimeout = setTimeout(function() {
                return _this._longHide = true;
            }, 500);
        };
        TooltipHTMLContent.prototype.hideLater = function(time) {
            if (this._show && !(this._inContent && this._enterable)) {
                if (time) {
                    this._hideDelay = time;
                    this._show = false;
                    this._hideTimeout = setTimeout((0, (0, parcelRequire("bahqM")).bind)(this.hide, this), time);
                } else this.hide();
            }
        };
        TooltipHTMLContent.prototype.isShow = function() {
            return this._show;
        };
        TooltipHTMLContent.prototype.dispose = function() {
            this.el.parentNode.removeChild(this.el);
        };
        return TooltipHTMLContent;
    }();
    var $f7cfc2302c12dfb3$export$2e2bcd8739ae039 = $f7cfc2302c12dfb3$var$TooltipHTMLContent;
});
parcelRegister("l3AHA", function(module, exports) {
    $parcel$export(module.exports, "shouldTooltipConfine", ()=>$f54659081207367d$export$a309528050824ba4);
    $parcel$export(module.exports, "TRANSFORM_VENDOR", ()=>$f54659081207367d$export$7b4286b1e4a23439);
    $parcel$export(module.exports, "TRANSITION_VENDOR", ()=>$f54659081207367d$export$70a631ae991b5e76);
    $parcel$export(module.exports, "toCSSVendorPrefix", ()=>$f54659081207367d$export$5886acafe29a08d1);
    $parcel$export(module.exports, "getComputedStyle", ()=>$f54659081207367d$export$3735103072e4a80);
    var $dCJrM;
    var $hZfwb;
    function $f54659081207367d$export$a309528050824ba4(tooltipModel) {
        var confineOption = tooltipModel.get('confine');
        return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
    }
    function $f54659081207367d$var$testStyle(styleProps) {
        if (!(0, (0, parcelRequire("hZfwb")).default).domSupported) return;
        var style = document.documentElement.style;
        for(var i = 0, len = styleProps.length; i < len; i++){
            if (styleProps[i] in style) return styleProps[i];
        }
    }
    var $f54659081207367d$export$7b4286b1e4a23439 = $f54659081207367d$var$testStyle([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    var $f54659081207367d$export$70a631ae991b5e76 = $f54659081207367d$var$testStyle([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    function $f54659081207367d$export$5886acafe29a08d1(styleVendor, styleProp) {
        if (!styleVendor) return styleProp;
        styleProp = (0, (0, parcelRequire("dCJrM")).toCamelCase)(styleProp, true);
        var idx = styleVendor.indexOf(styleProp);
        styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
        return styleVendor.toLowerCase();
    }
    function $f54659081207367d$export$3735103072e4a80(el, style) {
        var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
        return stl ? style ? stl[style] : stl : null;
    }
});
parcelRegister("bf1zw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82f2508e80aaa8db$export$2e2bcd8739ae039);
    var $bahqM;
    var $4gEFv;
    var $j5lKL;
    var $2cFRc;
    var $82f2508e80aaa8db$var$TooltipRichContent = function() {
        function TooltipRichContent(api) {
            this._show = false;
            this._styleCoord = [
                0,
                0,
                0,
                0
            ];
            this._enterable = true;
            this._zr = api.getZr();
            $82f2508e80aaa8db$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
        }
        TooltipRichContent.prototype.update = function(tooltipModel) {
            var alwaysShowContent = tooltipModel.get('alwaysShowContent');
            alwaysShowContent && this._moveIfResized();
        };
        TooltipRichContent.prototype.show = function() {
            if (this._hideTimeout) clearTimeout(this._hideTimeout);
            this.el.show();
            this._show = true;
        };
        TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
            if ((0, parcelRequire("bahqM")).isObject(content)) (0, (0, parcelRequire("2cFRc")).throwError)('');
            if (this.el) this._zr.remove(this.el);
            var textStyleModel = tooltipModel.getModel('textStyle');
            this.el = new (0, (0, parcelRequire("4gEFv")).default)({
                style: {
                    rich: markupStyleCreator.richTextStyles,
                    text: content,
                    lineHeight: 22,
                    backgroundColor: tooltipModel.get('backgroundColor'),
                    borderRadius: tooltipModel.get('borderRadius'),
                    borderWidth: 1,
                    borderColor: borderColor,
                    shadowColor: tooltipModel.get('shadowColor'),
                    shadowBlur: tooltipModel.get('shadowBlur'),
                    shadowOffsetX: tooltipModel.get('shadowOffsetX'),
                    shadowOffsetY: tooltipModel.get('shadowOffsetY'),
                    textShadowColor: textStyleModel.get('textShadowColor'),
                    textShadowBlur: textStyleModel.get('textShadowBlur') || 0,
                    textShadowOffsetX: textStyleModel.get('textShadowOffsetX') || 0,
                    textShadowOffsetY: textStyleModel.get('textShadowOffsetY') || 0,
                    fill: tooltipModel.get([
                        'textStyle',
                        'color'
                    ]),
                    padding: (0, (0, parcelRequire("j5lKL")).getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                    verticalAlign: 'top',
                    align: 'left'
                },
                z: tooltipModel.get('z')
            });
            this._zr.add(this.el);
            var self = this;
            this.el.on('mouseover', function() {
                if (self._enterable) {
                    clearTimeout(self._hideTimeout);
                    self._show = true;
                }
                self._inContent = true;
            });
            this.el.on('mouseout', function() {
                if (self._enterable) {
                    if (self._show) self.hideLater(self._hideDelay);
                }
                self._inContent = false;
            });
        };
        TooltipRichContent.prototype.setEnterable = function(enterable) {
            this._enterable = enterable;
        };
        TooltipRichContent.prototype.getSize = function() {
            var el = this.el;
            var bounding = this.el.getBoundingRect();
            var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(el.style);
            return [
                bounding.width + shadowOuterSize.left + shadowOuterSize.right,
                bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
            ];
        };
        TooltipRichContent.prototype.moveTo = function(x, y) {
            var el = this.el;
            if (el) {
                var styleCoord = this._styleCoord;
                $82f2508e80aaa8db$var$makeStyleCoord(styleCoord, this._zr, x, y);
                x = styleCoord[0];
                y = styleCoord[1];
                var style = el.style;
                var borderWidth = $82f2508e80aaa8db$var$mathMaxWith0(style.borderWidth || 0);
                var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(style);
                el.x = x + borderWidth + shadowOuterSize.left;
                el.y = y + borderWidth + shadowOuterSize.top;
                el.markRedraw();
            }
        };
        TooltipRichContent.prototype._moveIfResized = function() {
            var ratioX = this._styleCoord[2];
            var ratioY = this._styleCoord[3];
            this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
        };
        TooltipRichContent.prototype.hide = function() {
            if (this.el) this.el.hide();
            this._show = false;
        };
        TooltipRichContent.prototype.hideLater = function(time) {
            if (this._show && !(this._inContent && this._enterable)) {
                if (time) {
                    this._hideDelay = time;
                    this._show = false;
                    this._hideTimeout = setTimeout((0, parcelRequire("bahqM")).bind(this.hide, this), time);
                } else this.hide();
            }
        };
        TooltipRichContent.prototype.isShow = function() {
            return this._show;
        };
        TooltipRichContent.prototype.dispose = function() {
            this._zr.remove(this.el);
        };
        return TooltipRichContent;
    }();
    function $82f2508e80aaa8db$var$mathMaxWith0(val) {
        return Math.max(0, val);
    }
    function $82f2508e80aaa8db$var$calcShadowOuterSize(style) {
        var shadowBlur = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowBlur || 0);
        var shadowOffsetX = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetX || 0);
        var shadowOffsetY = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetY || 0);
        return {
            left: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetX),
            right: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetX),
            top: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetY),
            bottom: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetY)
        };
    }
    function $82f2508e80aaa8db$var$makeStyleCoord(out, zr, zrX, zrY) {
        out[0] = zrX;
        out[1] = zrY;
        out[2] = out[0] / zr.getWidth();
        out[3] = out[1] / zr.getHeight();
    }
    var $82f2508e80aaa8db$export$2e2bcd8739ae039 = $82f2508e80aaa8db$var$TooltipRichContent;
});
parcelRegister("ixV1I", function(module, exports) {
    var $jtdCU;
    $parcel$exportWildcard(module.exports, (0, parcelRequire("jtdCU")));
});
parcelRegister("jtdCU", function(module, exports) {
    var $8pqpA;
    var $a7GWb;
    var $alpND;
    var $fKViU;
    (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("fKViU")).installLabelLayout));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("8pqpA")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("a7GWb")));
});
parcelRegister("a7GWb", function(module, exports) {
    $parcel$export(module.exports, "extendComponentModel", ()=>$75ebdd55a0204a2b$export$4dd01020bb736662);
    $parcel$export(module.exports, "extendComponentView", ()=>$75ebdd55a0204a2b$export$a4336148da8ef02);
    $parcel$export(module.exports, "extendSeriesModel", ()=>$75ebdd55a0204a2b$export$fe6d3114e3fc260c);
    $parcel$export(module.exports, "extendChartView", ()=>$75ebdd55a0204a2b$export$c750883d1b603e83);
    $parcel$export(module.exports, "zrender", ()=>(parcelRequire("9Y5KT")));
    $parcel$export(module.exports, "matrix", ()=>(parcelRequire("izqgC")));
    $parcel$export(module.exports, "vector", ()=>(parcelRequire("eLEew")));
    $parcel$export(module.exports, "zrUtil", ()=>(parcelRequire("bahqM")));
    $parcel$export(module.exports, "color", ()=>(parcelRequire("d6udH")));
    $parcel$export(module.exports, "throttle", ()=>(parcelRequire("ljaBy")).throttle);
    $parcel$export(module.exports, "helper", ()=>(parcelRequire("anaTl")));
    $parcel$export(module.exports, "use", ()=>(parcelRequire("alpND")).use);
    $parcel$export(module.exports, "parseGeoJSON", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "parseGeoJson", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "number", ()=>(parcelRequire("hJg2M")));
    $parcel$export(module.exports, "time", ()=>(parcelRequire("ats4w")));
    $parcel$export(module.exports, "graphic", ()=>(parcelRequire("fwli1")));
    $parcel$export(module.exports, "format", ()=>(parcelRequire("byxPd")));
    $parcel$export(module.exports, "util", ()=>(parcelRequire("fvUv7")));
    $parcel$export(module.exports, "env", ()=>(parcelRequire("hZfwb")).default);
    $parcel$export(module.exports, "List", ()=>(parcelRequire("liBXN")).default);
    $parcel$export(module.exports, "Model", ()=>(parcelRequire("gaMkj")).default);
    $parcel$export(module.exports, "Axis", ()=>(parcelRequire("g6Gq1")).default);
    $parcel$export(module.exports, "ComponentModel", ()=>(parcelRequire("h4UlH")).default);
    $parcel$export(module.exports, "ComponentView", ()=>(parcelRequire("fkskt")).default);
    $parcel$export(module.exports, "SeriesModel", ()=>(parcelRequire("1O7Ua")).default);
    $parcel$export(module.exports, "ChartView", ()=>(parcelRequire("loerw")).default);
    $parcel$export(module.exports, "innerDrawElementOnCanvas", ()=>(parcelRequire("aSzOj")).brushSingle);
    var $h4UlH;
    var $fkskt;
    var $1O7Ua;
    var $loerw;
    var $liBXN;
    var $9Y5KT;
    var $izqgC;
    var $eLEew;
    var $bahqM;
    var $d6udH;
    var $ljaBy;
    var $anaTl;
    var $alpND;
    var $gyzY7;
    var $hJg2M;
    var $ats4w;
    var $fwli1;
    var $byxPd;
    var $fvUv7;
    var $hZfwb;
    var $gaMkj;
    var $g6Gq1;
    var $aSzOj;
    function $75ebdd55a0204a2b$export$4dd01020bb736662(proto) {
        var Model = (0, (0, parcelRequire("h4UlH")).default).extend(proto);
        (0, (0, parcelRequire("h4UlH")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$a4336148da8ef02(proto) {
        var View = (0, (0, parcelRequire("fkskt")).default).extend(proto);
        (0, (0, parcelRequire("fkskt")).default).registerClass(View);
        return View;
    }
    function $75ebdd55a0204a2b$export$fe6d3114e3fc260c(proto) {
        var Model = (0, (0, parcelRequire("1O7Ua")).default).extend(proto);
        (0, (0, parcelRequire("1O7Ua")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$c750883d1b603e83(proto) {
        var View = (0, (0, parcelRequire("loerw")).default).extend(proto);
        (0, (0, parcelRequire("loerw")).default).registerClass(View);
        return View;
    }
});
parcelRegister("anaTl", function(module, exports) {
    $parcel$export(module.exports, "createList", ()=>$78d480381111bb0c$export$5897d8d7c7a3d871);
    $parcel$export(module.exports, "dataStack", ()=>$78d480381111bb0c$export$d6100971d5a3a0a7);
    $parcel$export(module.exports, "createScale", ()=>$78d480381111bb0c$export$587d9c3c553380c6);
    $parcel$export(module.exports, "mixinAxisModelCommonMethods", ()=>$78d480381111bb0c$export$4665cbe3470e4d57);
    $parcel$export(module.exports, "createTextStyle", ()=>$78d480381111bb0c$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "getLayoutRect", ()=>(parcelRequire("65MS1")).getLayoutRect);
    $parcel$export(module.exports, "createDimensions", ()=>(parcelRequire("h9jiS")).createDimensions);
    $parcel$export(module.exports, "createSymbol", ()=>(parcelRequire("7yklO")).createSymbol);
    $parcel$export(module.exports, "getECData", ()=>(parcelRequire("7QjoM")).getECData);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>(parcelRequire("fIXXx")).enableHoverEmphasis);
    var $bahqM;
    var $bAY5l;
    var $3GIoT;
    var $5pBRm;
    var $gaMkj;
    var $65MS1;
    var $5R8Hi;
    var $7QjoM;
    var $gvLUt;
    var $h9jiS;
    var $7yklO;
    var $fIXXx;
    function $78d480381111bb0c$export$5897d8d7c7a3d871(seriesModel) {
        return (0, (0, parcelRequire("bAY5l")).default)(null, seriesModel);
    }
    var $78d480381111bb0c$export$d6100971d5a3a0a7 = {
        isDimensionStacked: (0, (0, parcelRequire("5R8Hi")).isDimensionStacked),
        enableDataStack: (0, (0, parcelRequire("5R8Hi")).enableDataStack),
        getStackedDimension: (0, (0, parcelRequire("5R8Hi")).getStackedDimension)
    };
    function $78d480381111bb0c$export$587d9c3c553380c6(dataExtent, option) {
        var axisModel = option;
        if (!(option instanceof (0, (0, parcelRequire("gaMkj")).default))) axisModel = new (0, (0, parcelRequire("gaMkj")).default)(option);
        var scale = (0, parcelRequire("3GIoT")).createScaleByModel(axisModel);
        scale.setExtent(dataExtent[0], dataExtent[1]);
        (0, parcelRequire("3GIoT")).niceScaleExtent(scale, axisModel);
        return scale;
    }
    function $78d480381111bb0c$export$4665cbe3470e4d57(Model) {
        (0, parcelRequire("bahqM")).mixin(Model, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    }
    function $78d480381111bb0c$export$f8998c3d0a13de59(textStyleModel, opts) {
        opts = opts || {};
        return (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
    }
});
parcelRegister("hJg2M", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>(parcelRequire("jmSNG")).linearMap);
    $parcel$export(module.exports, "round", ()=>(parcelRequire("jmSNG")).round);
    $parcel$export(module.exports, "asc", ()=>(parcelRequire("jmSNG")).asc);
    $parcel$export(module.exports, "getPrecision", ()=>(parcelRequire("jmSNG")).getPrecision);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>(parcelRequire("jmSNG")).getPrecisionSafe);
    $parcel$export(module.exports, "getPixelPrecision", ()=>(parcelRequire("jmSNG")).getPixelPrecision);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>(parcelRequire("jmSNG")).getPercentWithPrecision);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>(parcelRequire("jmSNG")).MAX_SAFE_INTEGER);
    $parcel$export(module.exports, "remRadian", ()=>(parcelRequire("jmSNG")).remRadian);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>(parcelRequire("jmSNG")).isRadianAroundZero);
    $parcel$export(module.exports, "parseDate", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "quantity", ()=>(parcelRequire("jmSNG")).quantity);
    $parcel$export(module.exports, "quantityExponent", ()=>(parcelRequire("jmSNG")).quantityExponent);
    $parcel$export(module.exports, "nice", ()=>(parcelRequire("jmSNG")).nice);
    $parcel$export(module.exports, "quantile", ()=>(parcelRequire("jmSNG")).quantile);
    $parcel$export(module.exports, "reformIntervals", ()=>(parcelRequire("jmSNG")).reformIntervals);
    $parcel$export(module.exports, "isNumeric", ()=>(parcelRequire("jmSNG")).isNumeric);
    $parcel$export(module.exports, "numericToNumber", ()=>(parcelRequire("jmSNG")).numericToNumber);
    var $jmSNG;
});
parcelRegister("ats4w", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "format", ()=>(parcelRequire("bc1Ad")).format);
    var $jmSNG;
    var $bc1Ad;
});
parcelRegister("fwli1", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>(parcelRequire("fHITF")).extendShape);
    $parcel$export(module.exports, "extendPath", ()=>(parcelRequire("fHITF")).extendPath);
    $parcel$export(module.exports, "makePath", ()=>(parcelRequire("fHITF")).makePath);
    $parcel$export(module.exports, "makeImage", ()=>(parcelRequire("fHITF")).makeImage);
    $parcel$export(module.exports, "mergePath", ()=>(parcelRequire("fHITF")).mergePath);
    $parcel$export(module.exports, "resizePath", ()=>(parcelRequire("fHITF")).resizePath);
    $parcel$export(module.exports, "createIcon", ()=>(parcelRequire("fHITF")).createIcon);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "getTransform", ()=>(parcelRequire("fHITF")).getTransform);
    $parcel$export(module.exports, "clipPointsByRect", ()=>(parcelRequire("fHITF")).clipPointsByRect);
    $parcel$export(module.exports, "clipRectByRect", ()=>(parcelRequire("fHITF")).clipRectByRect);
    $parcel$export(module.exports, "registerShape", ()=>(parcelRequire("fHITF")).registerShape);
    $parcel$export(module.exports, "getShapeClass", ()=>(parcelRequire("fHITF")).getShapeClass);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    parcelRequire("fHITF");
    var $ixXaU;
    var $04gw0;
    var $jjfok;
    var $fHITF;
    var $kVeV8;
    var $gcbBH;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $LCHOw;
    var $elGBV;
    var $eYgMC;
    var $1E3E8;
    var $eGltS;
    var $4KVOr;
    var $6sllV;
    var $eYgMC;
    var $9J7f8;
    var $faICo;
    var $4gEFv;
});
parcelRegister("byxPd", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>(parcelRequire("dCJrM")).addCommas);
    $parcel$export(module.exports, "toCamelCase", ()=>(parcelRequire("dCJrM")).toCamelCase);
    $parcel$export(module.exports, "normalizeCssArray", ()=>(parcelRequire("dCJrM")).normalizeCssArray);
    $parcel$export(module.exports, "encodeHTML", ()=>(parcelRequire("dCJrM")).encodeHTML);
    $parcel$export(module.exports, "formatTpl", ()=>(parcelRequire("dCJrM")).formatTpl);
    $parcel$export(module.exports, "getTooltipMarker", ()=>(parcelRequire("dCJrM")).getTooltipMarker);
    $parcel$export(module.exports, "formatTime", ()=>(parcelRequire("dCJrM")).formatTime);
    $parcel$export(module.exports, "capitalFirst", ()=>(parcelRequire("dCJrM")).capitalFirst);
    $parcel$export(module.exports, "truncateText", ()=>(parcelRequire("h6fMM")).truncateText);
    $parcel$export(module.exports, "getTextRect", ()=>(parcelRequire("2emZ2")).getTextRect);
    var $dCJrM;
    var $2emZ2;
    var $h6fMM;
});
parcelRegister("fvUv7", function(module, exports) {
    $parcel$export(module.exports, "map", ()=>(parcelRequire("bahqM")).map);
    $parcel$export(module.exports, "each", ()=>(parcelRequire("bahqM")).each);
    $parcel$export(module.exports, "indexOf", ()=>(parcelRequire("bahqM")).indexOf);
    $parcel$export(module.exports, "inherits", ()=>(parcelRequire("bahqM")).inherits);
    $parcel$export(module.exports, "reduce", ()=>(parcelRequire("bahqM")).reduce);
    $parcel$export(module.exports, "filter", ()=>(parcelRequire("bahqM")).filter);
    $parcel$export(module.exports, "bind", ()=>(parcelRequire("bahqM")).bind);
    $parcel$export(module.exports, "curry", ()=>(parcelRequire("bahqM")).curry);
    $parcel$export(module.exports, "isArray", ()=>(parcelRequire("bahqM")).isArray);
    $parcel$export(module.exports, "isString", ()=>(parcelRequire("bahqM")).isString);
    $parcel$export(module.exports, "isObject", ()=>(parcelRequire("bahqM")).isObject);
    $parcel$export(module.exports, "isFunction", ()=>(parcelRequire("bahqM")).isFunction);
    $parcel$export(module.exports, "extend", ()=>(parcelRequire("bahqM")).extend);
    $parcel$export(module.exports, "defaults", ()=>(parcelRequire("bahqM")).defaults);
    $parcel$export(module.exports, "clone", ()=>(parcelRequire("bahqM")).clone);
    $parcel$export(module.exports, "merge", ()=>(parcelRequire("bahqM")).merge);
    var $bahqM;
});
parcelRegister("fKViU", function(module, exports) {
    $parcel$export(module.exports, "installLabelLayout", ()=>$b7879a416965ee89$export$5320d1b3745c02a5);
    var $eaKsF;
    var $JIQqQ;
    var $b7879a416965ee89$var$getLabelManager = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b7879a416965ee89$export$5320d1b3745c02a5(registers) {
        registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            if (!labelManager) labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager = new (0, (0, parcelRequire("JIQqQ")).default)();
            labelManager.clearLabels();
        });
        registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            params.updatedSeries.forEach(function(series) {
                labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
            });
            labelManager.updateLayoutConfig(api);
            labelManager.layout(api);
            labelManager.processLabelsOverall();
        });
    }
});
parcelRegister("JIQqQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0896fd4d6c482b72$export$2e2bcd8739ae039);
    var $1E3E8;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $7QjoM;
    var $jmSNG;
    var $e6gef;
    var $fxCHE;
    var $eaKsF;
    var $bahqM;
    var $3LB2b;
    var $gvLUt;
    function $0896fd4d6c482b72$var$cloneArr(points) {
        if (points) {
            var newPoints = [];
            for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
            return newPoints;
        }
    }
    function $0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl) {
        var label = labelItem.label;
        var labelLine = hostEl && hostEl.getTextGuideLine();
        return {
            dataIndex: labelItem.dataIndex,
            dataType: labelItem.dataType,
            seriesIndex: labelItem.seriesModel.seriesIndex,
            text: labelItem.label.style.text,
            rect: labelItem.hostRect,
            labelRect: labelItem.rect,
            align: label.style.align,
            verticalAlign: label.style.verticalAlign,
            labelLinePoints: $0896fd4d6c482b72$var$cloneArr(labelLine && labelLine.shape.points)
        };
    }
    var $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS = [
        'align',
        'verticalAlign',
        'width',
        'height',
        'fontSize'
    ];
    var $0896fd4d6c482b72$var$dummyTransformable = new (0, (0, parcelRequire("e6gef")).default)();
    var $0896fd4d6c482b72$var$labelLayoutInnerStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $0896fd4d6c482b72$var$labelLineAnimationStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $0896fd4d6c482b72$var$extendWithKeys(target, source, keys) {
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (source[key] != null) target[key] = source[key];
        }
    }
    var $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS = [
        'x',
        'y',
        'rotation'
    ];
    var $0896fd4d6c482b72$var$LabelManager = function() {
        function LabelManager() {
            this._labelList = [];
            this._chartViewList = [];
        }
        LabelManager.prototype.clearLabels = function() {
            this._labelList = [];
            this._chartViewList = [];
        };
        LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
            var labelStyle = label.style;
            var hostEl = label.__hostTarget;
            var textConfig = hostEl.textConfig || {};
            var labelTransform = label.getComputedTransform();
            var labelRect = label.getBoundingRect().plain();
            (0, (0, parcelRequire("1E3E8")).default).applyTransform(labelRect, labelRect, labelTransform);
            if (labelTransform) $0896fd4d6c482b72$var$dummyTransformable.setLocalTransform(labelTransform);
            else {
                $0896fd4d6c482b72$var$dummyTransformable.x = $0896fd4d6c482b72$var$dummyTransformable.y = $0896fd4d6c482b72$var$dummyTransformable.rotation = $0896fd4d6c482b72$var$dummyTransformable.originX = $0896fd4d6c482b72$var$dummyTransformable.originY = 0;
                $0896fd4d6c482b72$var$dummyTransformable.scaleX = $0896fd4d6c482b72$var$dummyTransformable.scaleY = 1;
            }
            var host = label.__hostTarget;
            var hostRect;
            if (host) {
                hostRect = host.getBoundingRect().plain();
                var transform = host.getComputedTransform();
                (0, (0, parcelRequire("1E3E8")).default).applyTransform(hostRect, hostRect, transform);
            }
            var labelGuide = hostRect && host.getTextGuideLine();
            this._labelList.push({
                label: label,
                labelLine: labelGuide,
                seriesModel: seriesModel,
                dataIndex: dataIndex,
                dataType: dataType,
                layoutOption: layoutOption,
                computedLayoutOption: null,
                rect: labelRect,
                hostRect: hostRect,
                priority: hostRect ? hostRect.width * hostRect.height : 0,
                defaultAttr: {
                    ignore: label.ignore,
                    labelGuideIgnore: labelGuide && labelGuide.ignore,
                    x: $0896fd4d6c482b72$var$dummyTransformable.x,
                    y: $0896fd4d6c482b72$var$dummyTransformable.y,
                    scaleX: $0896fd4d6c482b72$var$dummyTransformable.scaleX,
                    scaleY: $0896fd4d6c482b72$var$dummyTransformable.scaleY,
                    rotation: $0896fd4d6c482b72$var$dummyTransformable.rotation,
                    style: {
                        x: labelStyle.x,
                        y: labelStyle.y,
                        align: labelStyle.align,
                        verticalAlign: labelStyle.verticalAlign,
                        width: labelStyle.width,
                        height: labelStyle.height,
                        fontSize: labelStyle.fontSize
                    },
                    cursor: label.cursor,
                    attachedPos: textConfig.position,
                    attachedRot: textConfig.rotation
                }
            });
        };
        LabelManager.prototype.addLabelsOfSeries = function(chartView) {
            var _this = this;
            this._chartViewList.push(chartView);
            var seriesModel = chartView.__model;
            var layoutOption = seriesModel.get('labelLayout');
            if (!((0, (0, parcelRequire("bahqM")).isFunction)(layoutOption) || (0, (0, parcelRequire("bahqM")).keys)(layoutOption).length)) return;
            chartView.group.traverse(function(child) {
                if (child.ignore) return true;
                var textEl = child.getTextContent();
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(child);
                if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
            });
        };
        LabelManager.prototype.updateLayoutConfig = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            function createDragHandler(el, labelLineModel) {
                return function() {
                    (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
                };
            }
            for(var i = 0; i < this._labelList.length; i++){
                var labelItem = this._labelList[i];
                var label = labelItem.label;
                var hostEl = label.__hostTarget;
                var defaultLabelAttr = labelItem.defaultAttr;
                var layoutOption = void 0;
                if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl));
                else layoutOption = labelItem.layoutOption;
                layoutOption = layoutOption || {};
                labelItem.computedLayoutOption = layoutOption;
                var degreeToRadian = Math.PI / 180;
                if (hostEl) hostEl.setTextConfig({
                    local: false,
                    position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                    rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                    offset: [
                        layoutOption.dx || 0,
                        layoutOption.dy || 0
                    ]
                });
                var needsUpdateLabelLine = false;
                if (layoutOption.x != null) {
                    label.x = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.x, width);
                    label.setStyle('x', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.x = defaultLabelAttr.x;
                    label.setStyle('x', defaultLabelAttr.style.x);
                }
                if (layoutOption.y != null) {
                    label.y = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.y, height);
                    label.setStyle('y', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.y = defaultLabelAttr.y;
                    label.setStyle('y', defaultLabelAttr.style.y);
                }
                if (layoutOption.labelLinePoints) {
                    var guideLine = hostEl.getTextGuideLine();
                    if (guideLine) {
                        guideLine.setShape({
                            points: layoutOption.labelLinePoints
                        });
                        needsUpdateLabelLine = false;
                    }
                }
                var labelLayoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(label);
                labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
                label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
                label.scaleX = defaultLabelAttr.scaleX;
                label.scaleY = defaultLabelAttr.scaleY;
                for(var k = 0; k < $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                    var key = $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                    label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
                }
                if (layoutOption.draggable) {
                    label.draggable = true;
                    label.cursor = 'move';
                    if (hostEl) {
                        var hostModel = labelItem.seriesModel;
                        if (labelItem.dataIndex != null) {
                            var data = labelItem.seriesModel.getData(labelItem.dataType);
                            hostModel = data.getItemModel(labelItem.dataIndex);
                        }
                        label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                    }
                } else {
                    label.off('drag');
                    label.cursor = defaultLabelAttr.cursor;
                }
            }
        };
        LabelManager.prototype.layout = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)(this._labelList);
            var labelsNeedsAdjustOnX = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftX';
            });
            var labelsNeedsAdjustOnY = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftY';
            });
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
            var labelsNeedsHideOverlap = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.hideOverlap;
            });
            (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelsNeedsHideOverlap);
        };
        LabelManager.prototype.processLabelsOverall = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)(this._chartViewList, function(chartView) {
                var seriesModel = chartView.__model;
                var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
                var animationEnabled = seriesModel.isAnimationEnabled();
                chartView.group.traverse(function(child) {
                    if (child.ignore) return true;
                    var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                    var label = child.getTextContent();
                    if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $0896fd4d6c482b72$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                    if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                    if (animationEnabled) _this._animateLabels(child, seriesModel);
                });
            });
        };
        LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            var dataIndex = ecData.dataIndex;
            if (textEl && dataIndex != null) {
                var data = seriesModel.getData(ecData.dataType);
                var itemModel = data.getItemModel(dataIndex);
                var defaultStyle = {};
                var visualStyle = data.getItemVisual(dataIndex, 'style');
                var visualType = data.getVisual('drawType');
                defaultStyle.stroke = visualStyle[visualType];
                var labelLineModel = itemModel.getModel('labelLine');
                (0, (0, parcelRequire("fxCHE")).setLabelLineStyle)(el, (0, (0, parcelRequire("fxCHE")).getLabelLineStatesModels)(itemModel), defaultStyle);
                (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
            }
        };
        LabelManager.prototype._animateLabels = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var guideLine = el.getTextGuideLine();
            if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, (0, parcelRequire("eYgMC")).isElementRemoved)(el)) {
                var layoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(textEl);
                var oldLayout = layoutStore.oldLayout;
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
                var dataIndex = ecData.dataIndex;
                var newProps = {
                    x: textEl.x,
                    y: textEl.y,
                    rotation: textEl.rotation
                };
                var data = seriesModel.getData(ecData.dataType);
                if (!oldLayout) {
                    textEl.attr(newProps);
                    if (!(0, (0, parcelRequire("gvLUt")).labelInner)(textEl).valueAnimation) {
                        var oldOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textEl.style.opacity, 1);
                        textEl.style.opacity = 0;
                        (0, (0, parcelRequire("eYgMC")).initProps)(textEl, {
                            style: {
                                opacity: oldOpacity
                            }
                        }, seriesModel, dataIndex);
                    }
                } else {
                    textEl.attr(oldLayout);
                    var prevStates = el.prevStates;
                    if (prevStates) {
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                    }
                    (0, (0, parcelRequire("eYgMC")).updateProps)(textEl, newProps, seriesModel, dataIndex);
                }
                layoutStore.oldLayout = newProps;
                if (textEl.states.select) {
                    var layoutSelect = layoutStore.oldLayoutSelect = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, textEl.states.select, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                if (textEl.states.emphasis) {
                    var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                (0, (0, parcelRequire("gvLUt")).animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
            }
            if (guideLine && !guideLine.ignore && !guideLine.invisible) {
                var layoutStore = $0896fd4d6c482b72$var$labelLineAnimationStore(guideLine);
                var oldLayout = layoutStore.oldLayout;
                var newLayout = {
                    points: guideLine.shape.points
                };
                if (!oldLayout) {
                    guideLine.setShape(newLayout);
                    guideLine.style.strokePercent = 0;
                    (0, (0, parcelRequire("eYgMC")).initProps)(guideLine, {
                        style: {
                            strokePercent: 1
                        }
                    }, seriesModel);
                } else {
                    guideLine.attr({
                        shape: oldLayout
                    });
                    (0, (0, parcelRequire("eYgMC")).updateProps)(guideLine, {
                        shape: newLayout
                    }, seriesModel);
                }
                layoutStore.oldLayout = newLayout;
            }
        };
        return LabelManager;
    }();
    var $0896fd4d6c482b72$export$2e2bcd8739ae039 = $0896fd4d6c482b72$var$LabelManager;
});
parcelRegister("fxCHE", function(module, exports) {
    $parcel$export(module.exports, "updateLabelLinePoints", ()=>$02eb7bb47d256bbb$export$cc93ba643cd97d83);
    $parcel$export(module.exports, "limitTurnAngle", ()=>$02eb7bb47d256bbb$export$ac52062003fbe6a);
    $parcel$export(module.exports, "limitSurfaceAngle", ()=>$02eb7bb47d256bbb$export$973e1fdb2708f71b);
    $parcel$export(module.exports, "setLabelLineStyle", ()=>$02eb7bb47d256bbb$export$c09e0b0574bdd2dc);
    $parcel$export(module.exports, "getLabelLineStatesModels", ()=>$02eb7bb47d256bbb$export$2979fdbf5ebce521);
    parcelRequire("fHITF");
    var $ghQ8v;
    var $32bXc;
    var $bMDnR;
    var $aA4Ws;
    var $kvt3T;
    var $dr1jo;
    var $bahqM;
    var $izqgC;
    var $eLEew;
    var $fIXXx;
    var $02eb7bb47d256bbb$var$PI2 = Math.PI * 2;
    var $02eb7bb47d256bbb$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    function $02eb7bb47d256bbb$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
        var width = rect.width;
        var height = rect.height;
        switch(pos){
            case 'top':
                outPt.set(rect.x + width / 2, rect.y - distance);
                outDir.set(0, -1);
                break;
            case 'bottom':
                outPt.set(rect.x + width / 2, rect.y + height + distance);
                outDir.set(0, 1);
                break;
            case 'left':
                outPt.set(rect.x - distance, rect.y + height / 2);
                outDir.set(-1, 0);
                break;
            case 'right':
                outPt.set(rect.x + width + distance, rect.y + height / 2);
                outDir.set(1, 0);
                break;
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        x /= d;
        y /= d;
        var ox = x * r + cx;
        var oy = y * r + cy;
        if (Math.abs(startAngle - endAngle) % $02eb7bb47d256bbb$var$PI2 < 1e-4) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $02eb7bb47d256bbb$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $02eb7bb47d256bbb$var$PI2;
        if (angle >= startAngle && angle <= endAngle || angle + $02eb7bb47d256bbb$var$PI2 >= startAngle && angle + $02eb7bb47d256bbb$var$PI2 <= endAngle) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        var x1 = r * Math.cos(startAngle) + cx;
        var y1 = r * Math.sin(startAngle) + cy;
        var x2 = r * Math.cos(endAngle) + cx;
        var y2 = r * Math.sin(endAngle) + cy;
        var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
        var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
        if (d1 < d2) {
            out[0] = x1;
            out[1] = y1;
            return Math.sqrt(d1);
        } else {
            out[0] = x2;
            out[1] = y2;
            return Math.sqrt(d2);
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
        var dx = x - x1;
        var dy = y - y1;
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        dx1 /= lineLen;
        dy1 /= lineLen;
        var projectedLen = dx * dx1 + dy * dy1;
        var t = projectedLen / lineLen;
        if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
        t *= lineLen;
        var ox = out[0] = x1 + t * dx1;
        var oy = out[1] = y1 + t * dy1;
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    function $02eb7bb47d256bbb$var$projectPointToRect(x1, y1, width, height, x, y, out) {
        if (width < 0) {
            x1 = x1 + width;
            width = -width;
        }
        if (height < 0) {
            y1 = y1 + height;
            height = -height;
        }
        var x2 = x1 + width;
        var y2 = y1 + height;
        var ox = out[0] = Math.min(Math.max(x, x1), x2);
        var oy = out[1] = Math.min(Math.max(y, y1), y2);
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    var $02eb7bb47d256bbb$var$tmpPt = [];
    function $02eb7bb47d256bbb$var$nearestPointOnRect(pt, rect, out) {
        var dist = $02eb7bb47d256bbb$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $02eb7bb47d256bbb$var$tmpPt);
        out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
        return dist;
    }
    function $02eb7bb47d256bbb$var$nearestPointOnPath(pt, path, out) {
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        var minDist = Infinity;
        var data = path.data;
        var x = pt.x;
        var y = pt.y;
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            if (i === 1) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var d = minDist;
            switch(cmd){
                case $02eb7bb47d256bbb$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $02eb7bb47d256bbb$var$CMD.L:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.C:
                    d = (0, (0, parcelRequire("dr1jo")).cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.Q:
                    d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (i <= 1) {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    d = $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $02eb7bb47d256bbb$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    d = $02eb7bb47d256bbb$var$projectPointToRect(x0, y0, width, height, x, y, $02eb7bb47d256bbb$var$tmpPt);
                    break;
                case $02eb7bb47d256bbb$var$CMD.Z:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, x0, y0, x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (d < minDist) {
                minDist = d;
                out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
            }
        }
        return minDist;
    }
    var $02eb7bb47d256bbb$var$pt0 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt1 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt2 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir2 = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$cc93ba643cd97d83(target, labelLineModel) {
        if (!target) return;
        var labelLine = target.getTextGuideLine();
        var label = target.getTextContent();
        if (!(label && labelLine)) return;
        var labelGuideConfig = target.textGuideLineConfig || {};
        var points = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        var searchSpace = labelGuideConfig.candidates || $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE;
        var labelRect = label.getBoundingRect().clone();
        labelRect.applyTransform(label.getComputedTransform());
        var minDist = Infinity;
        var anchorPoint = labelGuideConfig.anchor;
        var targetTransform = target.getComputedTransform();
        var targetInversedTransform = targetTransform && (0, (0, parcelRequire("izqgC")).invert)([], targetTransform);
        var len = labelLineModel.get('length2') || 0;
        if (anchorPoint) $02eb7bb47d256bbb$var$pt2.copy(anchorPoint);
        for(var i = 0; i < searchSpace.length; i++){
            var candidate = searchSpace[i];
            $02eb7bb47d256bbb$var$getCandidateAnchor(candidate, 0, labelRect, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir);
            (0, (0, parcelRequire("bMDnR")).default).scaleAndAdd($02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir, len);
            $02eb7bb47d256bbb$var$pt1.transform(targetInversedTransform);
            var boundingRect = target.getBoundingRect();
            var dist = anchorPoint ? anchorPoint.distance($02eb7bb47d256bbb$var$pt1) : target instanceof (0, (0, parcelRequire("ghQ8v")).default) ? $02eb7bb47d256bbb$var$nearestPointOnPath($02eb7bb47d256bbb$var$pt1, target.path, $02eb7bb47d256bbb$var$pt2) : $02eb7bb47d256bbb$var$nearestPointOnRect($02eb7bb47d256bbb$var$pt1, boundingRect, $02eb7bb47d256bbb$var$pt2);
            if (dist < minDist) {
                minDist = dist;
                $02eb7bb47d256bbb$var$pt1.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.toArray(points[0]);
                $02eb7bb47d256bbb$var$pt1.toArray(points[1]);
                $02eb7bb47d256bbb$var$pt0.toArray(points[2]);
            }
        }
        $02eb7bb47d256bbb$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
        labelLine.setShape({
            points: points
        });
    }
    var $02eb7bb47d256bbb$var$tmpArr = [];
    var $02eb7bb47d256bbb$var$tmpProjPoint = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$ac52062003fbe6a(linePoints, minTurnAngle) {
        if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
        minTurnAngle = minTurnAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$pt1);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot($02eb7bb47d256bbb$var$dir2);
        var minTurnAngleCos = Math.cos(minTurnAngle);
        if (minTurnAngleCos < angleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
            var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
            else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
        if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
        maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot(surfaceNormal);
        var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
        if (angleCos < maxSurfaceAngleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            var HALF_PI = Math.PI / 2;
            var angle2 = Math.acos($02eb7bb47d256bbb$var$dir2.dot(surfaceNormal));
            var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
            if (newAngle >= HALF_PI) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            else {
                $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
                var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
                if (isNaN(t)) return;
                if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
                else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            }
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
        var isNormal = stateName === 'normal';
        var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
        stateObj.ignore = ignore;
        var smooth = stateModel.get('smooth');
        if (smooth && smooth === true) smooth = 0.3;
        stateObj.shape = stateObj.shape || {};
        if (smooth > 0) stateObj.shape.smooth = smooth;
        var styleObj = stateModel.getModel('lineStyle').getLineStyle();
        isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
    }
    function $02eb7bb47d256bbb$var$buildLabelLinePath(path, shape) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (!points) return;
        path.moveTo(points[0][0], points[0][1]);
        if (smooth > 0 && points.length >= 3) {
            var len1 = (0, parcelRequire("eLEew")).dist(points[0], points[1]);
            var len2 = (0, parcelRequire("eLEew")).dist(points[1], points[2]);
            if (!len1 || !len2) {
                path.lineTo(points[1][0], points[1][1]);
                path.lineTo(points[2][0], points[2][1]);
                return;
            }
            var moveLen = Math.min(len1, len2) * smooth;
            var midPoint0 = (0, parcelRequire("eLEew")).lerp([], points[1], points[0], moveLen / len1);
            var midPoint2 = (0, parcelRequire("eLEew")).lerp([], points[1], points[2], moveLen / len2);
            var midPoint1 = (0, parcelRequire("eLEew")).lerp([], midPoint0, midPoint2, 0.5);
            path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
            path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
        } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
    }
    function $02eb7bb47d256bbb$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
        var labelLine = targetEl.getTextGuideLine();
        var label = targetEl.getTextContent();
        if (!label) {
            if (labelLine) targetEl.removeTextGuideLine();
            return;
        }
        var normalModel = statesModels.normal;
        var showNormal = normalModel.get('show');
        var labelIgnoreNormal = label.ignore;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i];
            var stateModel = statesModels[stateName];
            var isNormal = stateName === 'normal';
            if (stateModel) {
                var stateShow = stateModel.get('show');
                var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, (0, parcelRequire("bahqM")).retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
                if (isLabelIgnored || !(0, (0, parcelRequire("bahqM")).retrieve2)(stateShow, showNormal)) {
                    var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                    if (stateObj) stateObj.ignore = true;
                    continue;
                }
                if (!labelLine) {
                    labelLine = new (0, (0, parcelRequire("32bXc")).default)();
                    targetEl.setTextGuideLine(labelLine);
                    if (!isNormal && (labelIgnoreNormal || !showNormal)) $02eb7bb47d256bbb$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                    if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
                }
                $02eb7bb47d256bbb$var$setLabelLineState(labelLine, false, stateName, stateModel);
            }
        }
        if (labelLine) {
            (0, (0, parcelRequire("bahqM")).defaults)(labelLine.style, defaultStyle);
            labelLine.style.fill = null;
            var showAbove = normalModel.get('showAbove');
            var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
            labelLineConfig.showAbove = showAbove || false;
            labelLine.buildPath = $02eb7bb47d256bbb$var$buildLabelLinePath;
        }
    }
    function $02eb7bb47d256bbb$export$2979fdbf5ebce521(itemModel, labelLineName) {
        labelLineName = labelLineName || 'labelLine';
        var statesModels = {
            normal: itemModel.getModel(labelLineName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelLineName
            ]);
        }
        return statesModels;
    }
});
parcelRegister("koMvQ", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$ed9bae1f5fcebf9c$export$4b3e715f166fdd78);
    var $9d3yg;
    function $ed9bae1f5fcebf9c$export$4b3e715f166fdd78(registers) {
        registers.registerPainter('svg', (0, (0, parcelRequire("9d3yg")).default));
    }
});
parcelRegister("9d3yg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b481536a5986ad8$export$2e2bcd8739ae039);
    var $dE0Hq;
    var $bahqM;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $iN8gp;
    var $9mQ8G;
    var $brSrY;
    var $i53xG;
    var $b6V4m;
    var $k0bb8;
    function $6b481536a5986ad8$var$parseInt10(val) {
        return parseInt(val, 10);
    }
    function $6b481536a5986ad8$var$getSvgProxy(el) {
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) return 0, (0, parcelRequire("k0bb8")).path;
        else if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) return 0, (0, parcelRequire("k0bb8")).image;
        else if (el instanceof (0, (0, parcelRequire("45jlh")).default)) return 0, (0, parcelRequire("k0bb8")).text;
        else return 0, (0, parcelRequire("k0bb8")).path;
    }
    function $6b481536a5986ad8$var$checkParentAvailable(parent, child) {
        return child && parent && child.parentNode !== parent;
    }
    function $6b481536a5986ad8$var$insertAfter(parent, child, prevSibling) {
        if ($6b481536a5986ad8$var$checkParentAvailable(parent, child) && prevSibling) {
            var nextSibling = prevSibling.nextSibling;
            nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
        }
    }
    function $6b481536a5986ad8$var$prepend(parent, child) {
        if ($6b481536a5986ad8$var$checkParentAvailable(parent, child)) {
            var firstChild = parent.firstChild;
            firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
        }
    }
    function $6b481536a5986ad8$var$remove(parent, child) {
        if (child && parent && child.parentNode === parent) parent.removeChild(child);
    }
    function $6b481536a5986ad8$var$removeFromMyParent(child) {
        if (child && child.parentNode) child.parentNode.removeChild(child);
    }
    function $6b481536a5986ad8$var$getSvgElement(displayable) {
        return displayable.__svgEl;
    }
    var $6b481536a5986ad8$var$SVGPainter = function() {
        function SVGPainter(root, storage, opts, zrId) {
            this.type = 'svg';
            this.refreshHover = $6b481536a5986ad8$var$createMethodNotSupport('refreshHover');
            this.pathToImage = $6b481536a5986ad8$var$createMethodNotSupport('pathToImage');
            this.configLayer = $6b481536a5986ad8$var$createMethodNotSupport('configLayer');
            this.root = root;
            this.storage = storage;
            this._opts = opts = (0, parcelRequire("bahqM")).extend({}, opts || {});
            var svgDom = (0, (0, parcelRequire("dE0Hq")).createElement)('svg');
            svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
            svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
            svgDom.setAttribute('version', '1.1');
            svgDom.setAttribute('baseProfile', 'full');
            svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
            var bgRoot = (0, (0, parcelRequire("dE0Hq")).createElement)('g');
            svgDom.appendChild(bgRoot);
            var svgRoot = (0, (0, parcelRequire("dE0Hq")).createElement)('g');
            svgDom.appendChild(svgRoot);
            this._gradientManager = new (0, (0, parcelRequire("9mQ8G")).default)(zrId, svgRoot);
            this._patternManager = new (0, (0, parcelRequire("brSrY")).default)(zrId, svgRoot);
            this._clipPathManager = new (0, (0, parcelRequire("i53xG")).default)(zrId, svgRoot);
            this._shadowManager = new (0, (0, parcelRequire("b6V4m")).default)(zrId, svgRoot);
            var viewport = document.createElement('div');
            viewport.style.cssText = 'overflow:hidden;position:relative';
            this._svgDom = svgDom;
            this._svgRoot = svgRoot;
            this._backgroundRoot = bgRoot;
            this._viewport = viewport;
            root.appendChild(viewport);
            viewport.appendChild(svgDom);
            this.resize(opts.width, opts.height);
            this._visibleList = [];
        }
        SVGPainter.prototype.getType = function() {
            return 'svg';
        };
        SVGPainter.prototype.getViewportRoot = function() {
            return this._viewport;
        };
        SVGPainter.prototype.getSvgDom = function() {
            return this._svgDom;
        };
        SVGPainter.prototype.getSvgRoot = function() {
            return this._svgRoot;
        };
        SVGPainter.prototype.getViewportRootOffset = function() {
            var viewportRoot = this.getViewportRoot();
            if (viewportRoot) return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        };
        SVGPainter.prototype.refresh = function() {
            var list = this.storage.getDisplayList(true);
            this._paintList(list);
        };
        SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
            if (this._backgroundRoot && this._backgroundNode) this._backgroundRoot.removeChild(this._backgroundNode);
            var bgNode = (0, (0, parcelRequire("dE0Hq")).createElement)('rect');
            bgNode.setAttribute('width', this.getWidth());
            bgNode.setAttribute('height', this.getHeight());
            bgNode.setAttribute('x', 0);
            bgNode.setAttribute('y', 0);
            bgNode.setAttribute('id', 0);
            var _a = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgNode.setAttribute('fill', color);
            bgNode.setAttribute('fill-opacity', opacity);
            this._backgroundRoot.appendChild(bgNode);
            this._backgroundNode = bgNode;
        };
        SVGPainter.prototype.createSVGElement = function(tag) {
            return (0, (0, parcelRequire("dE0Hq")).createElement)(tag);
        };
        SVGPainter.prototype.paintOne = function(el) {
            var svgProxy = $6b481536a5986ad8$var$getSvgProxy(el);
            svgProxy && svgProxy.brush(el);
            return $6b481536a5986ad8$var$getSvgElement(el);
        };
        SVGPainter.prototype._paintList = function(list) {
            var gradientManager = this._gradientManager;
            var patternManager = this._patternManager;
            var clipPathManager = this._clipPathManager;
            var shadowManager = this._shadowManager;
            gradientManager.markAllUnused();
            patternManager.markAllUnused();
            clipPathManager.markAllUnused();
            shadowManager.markAllUnused();
            var svgRoot = this._svgRoot;
            var visibleList = this._visibleList;
            var listLen = list.length;
            var newVisibleList = [];
            for(var i = 0; i < listLen; i++){
                var displayable = list[i];
                var svgProxy = $6b481536a5986ad8$var$getSvgProxy(displayable);
                var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                if (!displayable.invisible) {
                    if (displayable.__dirty || !svgElement) {
                        svgProxy && svgProxy.brush(displayable);
                        svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                        if (svgElement && displayable.style) {
                            gradientManager.update(displayable.style.fill);
                            gradientManager.update(displayable.style.stroke);
                            patternManager.update(displayable.style.fill);
                            patternManager.update(displayable.style.stroke);
                            shadowManager.update(svgElement, displayable);
                        }
                        displayable.__dirty = 0;
                    }
                    if (svgElement) newVisibleList.push(displayable);
                }
            }
            var diff = (0, (0, parcelRequire("iN8gp")).default)(visibleList, newVisibleList);
            var prevSvgElement;
            var topPrevSvgElement;
            for(var i = 0; i < diff.length; i++){
                var item = diff[i];
                if (item.removed) for(var k = 0; k < item.count; k++){
                    var displayable = visibleList[item.indices[k]];
                    var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                    (0, (0, parcelRequire("i53xG")).hasClipPath)(displayable) ? $6b481536a5986ad8$var$removeFromMyParent(svgElement) : $6b481536a5986ad8$var$remove(svgRoot, svgElement);
                }
            }
            var prevDisplayable;
            var currentClipGroup;
            for(var i = 0; i < diff.length; i++){
                var item = diff[i];
                if (item.removed) continue;
                for(var k = 0; k < item.count; k++){
                    var displayable = newVisibleList[item.indices[k]];
                    var clipGroup = clipPathManager.update(displayable, prevDisplayable);
                    if (clipGroup !== currentClipGroup) {
                        prevSvgElement = topPrevSvgElement;
                        if (clipGroup) {
                            prevSvgElement ? $6b481536a5986ad8$var$insertAfter(svgRoot, clipGroup, prevSvgElement) : $6b481536a5986ad8$var$prepend(svgRoot, clipGroup);
                            topPrevSvgElement = clipGroup;
                            prevSvgElement = null;
                        }
                        currentClipGroup = clipGroup;
                    }
                    var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                    prevSvgElement ? $6b481536a5986ad8$var$insertAfter(currentClipGroup || svgRoot, svgElement, prevSvgElement) : $6b481536a5986ad8$var$prepend(currentClipGroup || svgRoot, svgElement);
                    prevSvgElement = svgElement || prevSvgElement;
                    if (!currentClipGroup) topPrevSvgElement = prevSvgElement;
                    gradientManager.markUsed(displayable);
                    gradientManager.addWithoutUpdate(svgElement, displayable);
                    patternManager.markUsed(displayable);
                    patternManager.addWithoutUpdate(svgElement, displayable);
                    clipPathManager.markUsed(displayable);
                    prevDisplayable = displayable;
                }
            }
            gradientManager.removeUnused();
            patternManager.removeUnused();
            clipPathManager.removeUnused();
            shadowManager.removeUnused();
            this._visibleList = newVisibleList;
        };
        SVGPainter.prototype.resize = function(width, height) {
            var viewport = this._viewport;
            viewport.style.display = 'none';
            var opts = this._opts;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = this._getSize(0);
            height = this._getSize(1);
            viewport.style.display = '';
            if (this._width !== width || this._height !== height) {
                this._width = width;
                this._height = height;
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
                var svgRoot = this._svgDom;
                svgRoot.setAttribute('width', width + '');
                svgRoot.setAttribute('height', height + '');
            }
            if (this._backgroundNode) {
                this._backgroundNode.setAttribute('width', width);
                this._backgroundNode.setAttribute('height', height);
            }
        };
        SVGPainter.prototype.getWidth = function() {
            return this._width;
        };
        SVGPainter.prototype.getHeight = function() {
            return this._height;
        };
        SVGPainter.prototype._getSize = function(whIdx) {
            var opts = this._opts;
            var wh = [
                'width',
                'height'
            ][whIdx];
            var cwh = [
                'clientWidth',
                'clientHeight'
            ][whIdx];
            var plt = [
                'paddingLeft',
                'paddingTop'
            ][whIdx];
            var prb = [
                'paddingRight',
                'paddingBottom'
            ][whIdx];
            if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
            var root = this.root;
            var stl = document.defaultView.getComputedStyle(root);
            return (root[cwh] || $6b481536a5986ad8$var$parseInt10(stl[wh]) || $6b481536a5986ad8$var$parseInt10(root.style[wh])) - ($6b481536a5986ad8$var$parseInt10(stl[plt]) || 0) - ($6b481536a5986ad8$var$parseInt10(stl[prb]) || 0) | 0;
        };
        SVGPainter.prototype.dispose = function() {
            this.root.innerHTML = '';
            this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
        };
        SVGPainter.prototype.clear = function() {
            var viewportNode = this._viewport;
            if (viewportNode && viewportNode.parentNode) viewportNode.parentNode.removeChild(viewportNode);
        };
        SVGPainter.prototype.toDataURL = function() {
            this.refresh();
            var svgDom = this._svgDom;
            var outerHTML = svgDom.outerHTML || (svgDom.parentNode && svgDom.parentNode).innerHTML;
            var html = encodeURIComponent(outerHTML.replace(/></g, '>\n\r<'));
            return 'data:image/svg+xml;charset=UTF-8,' + html;
        };
        return SVGPainter;
    }();
    function $6b481536a5986ad8$var$createMethodNotSupport(method) {
        return function() {
            (0, parcelRequire("bahqM")).logError('In SVG mode painter not support method "' + method + '"');
        };
    }
    var $6b481536a5986ad8$export$2e2bcd8739ae039 = $6b481536a5986ad8$var$SVGPainter;
});
parcelRegister("dE0Hq", function(module, exports) {
    $parcel$export(module.exports, "createElement", ()=>$9eef8dacfbb7af72$export$c8a8987d4410bf2d);
    $parcel$export(module.exports, "normalizeColor", ()=>$9eef8dacfbb7af72$export$4cde5df63f53f473);
    var $d6udH;
    function $9eef8dacfbb7af72$export$c8a8987d4410bf2d(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    function $9eef8dacfbb7af72$export$4cde5df63f53f473(color) {
        var opacity;
        if (!color || color === 'transparent') color = 'none';
        else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
            var arr = (0, (0, parcelRequire("d6udH")).parse)(color);
            if (arr) {
                color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
                opacity = arr[3];
            }
        }
        return {
            color: color,
            opacity: opacity == null ? 1 : opacity
        };
    }
});
parcelRegister("iN8gp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dae3369130c6c165$export$2e2bcd8739ae039);
    function $dae3369130c6c165$var$diff(oldArr, newArr, equals) {
        if (!equals) equals = function(a, b) {
            return a === b;
        };
        oldArr = oldArr.slice();
        newArr = newArr.slice();
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var editLength = 1;
        var maxEditLength = newLen + oldLen;
        var bestPath = [
            {
                newPos: -1,
                components: []
            }
        ];
        var oldPos = $dae3369130c6c165$var$extractCommon(bestPath[0], newArr, oldArr, 0, equals);
        if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
            var indices = [];
            for(var i = 0; i < newArr.length; i++)indices.push(i);
            return [
                {
                    indices: indices,
                    count: newArr.length,
                    added: false,
                    removed: false
                }
            ];
        }
        function execEditLength() {
            for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
                var basePath;
                var addPath = bestPath[diagonalPath - 1];
                var removePath = bestPath[diagonalPath + 1];
                var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
                if (addPath) bestPath[diagonalPath - 1] = undefined;
                var canAdd = addPath && addPath.newPos + 1 < newLen;
                var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
                if (!canAdd && !canRemove) {
                    bestPath[diagonalPath] = undefined;
                    continue;
                }
                if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                    basePath = $dae3369130c6c165$var$clonePath(removePath);
                    $dae3369130c6c165$var$pushComponent(basePath.components, false, true);
                } else {
                    basePath = addPath;
                    basePath.newPos++;
                    $dae3369130c6c165$var$pushComponent(basePath.components, true, false);
                }
                oldPos = $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals);
                if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return $dae3369130c6c165$var$buildValues(basePath.components);
                else bestPath[diagonalPath] = basePath;
            }
            editLength++;
        }
        while(editLength <= maxEditLength){
            var ret = execEditLength();
            if (ret) return ret;
        }
    }
    function $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals) {
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var newPos = basePath.newPos;
        var oldPos = newPos - diagonalPath;
        var commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newArr[newPos + 1], oldArr[oldPos + 1])){
            newPos++;
            oldPos++;
            commonCount++;
        }
        if (commonCount) basePath.components.push({
            count: commonCount,
            added: false,
            removed: false,
            indices: []
        });
        basePath.newPos = newPos;
        return oldPos;
    }
    function $dae3369130c6c165$var$pushComponent(components, added, removed) {
        var last = components[components.length - 1];
        if (last && last.added === added && last.removed === removed) components[components.length - 1] = {
            count: last.count + 1,
            added: added,
            removed: removed,
            indices: []
        };
        else components.push({
            count: 1,
            added: added,
            removed: removed,
            indices: []
        });
    }
    function $dae3369130c6c165$var$buildValues(components) {
        var componentPos = 0;
        var componentLen = components.length;
        var newPos = 0;
        var oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            var component = components[componentPos];
            if (!component.removed) {
                var indices = [];
                for(var i = newPos; i < newPos + component.count; i++)indices.push(i);
                component.indices = indices;
                newPos += component.count;
                if (!component.added) oldPos += component.count;
            } else {
                for(var i = oldPos; i < oldPos + component.count; i++)component.indices.push(i);
                oldPos += component.count;
            }
        }
        return components;
    }
    function $dae3369130c6c165$var$clonePath(path) {
        return {
            newPos: path.newPos,
            components: path.components.slice(0)
        };
    }
    function $dae3369130c6c165$export$2e2bcd8739ae039(oldArr, newArr, equal) {
        return $dae3369130c6c165$var$diff(oldArr, newArr, equal);
    }
});
parcelRegister("9mQ8G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d1e9cd7c4fb6054$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $d6udH;
    function $6d1e9cd7c4fb6054$var$isLinearGradient(value) {
        return value.type === 'linear';
    }
    function $6d1e9cd7c4fb6054$var$isRadialGradient(value) {
        return value.type === 'radial';
    }
    function $6d1e9cd7c4fb6054$var$isGradient(value) {
        return value && (value.type === 'linear' || value.type === 'radial');
    }
    var $6d1e9cd7c4fb6054$var$GradientManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GradientManager, _super);
        function GradientManager(zrId, svgRoot) {
            return _super.call(this, zrId, svgRoot, [
                'linearGradient',
                'radialGradient'
            ], '__gradient_in_use__') || this;
        }
        GradientManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
            if (displayable && displayable.style) {
                var that_1 = this;
                (0, parcelRequire("bahqM")).each([
                    'fill',
                    'stroke'
                ], function(fillOrStroke) {
                    var value = displayable.style[fillOrStroke];
                    if ($6d1e9cd7c4fb6054$var$isGradient(value)) {
                        var gradient = value;
                        var defs = that_1.getDefs(true);
                        var dom = void 0;
                        if (gradient.__dom) {
                            dom = gradient.__dom;
                            if (!defs.contains(gradient.__dom)) that_1.addDom(dom);
                        } else dom = that_1.add(gradient);
                        that_1.markUsed(displayable);
                        var id = dom.getAttribute('id');
                        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                    }
                });
            }
        };
        GradientManager.prototype.add = function(gradient) {
            var dom;
            if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) dom = this.createElement('linearGradient');
            else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) dom = this.createElement('radialGradient');
            else {
                (0, parcelRequire("bahqM")).logError('Illegal gradient type.');
                return null;
            }
            gradient.id = gradient.id || this.nextId++;
            dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
            this.updateDom(gradient, dom);
            this.addDom(dom);
            return dom;
        };
        GradientManager.prototype.update = function(gradient) {
            if (!$6d1e9cd7c4fb6054$var$isGradient(gradient)) return;
            var that = this;
            this.doUpdate(gradient, function() {
                var dom = gradient.__dom;
                if (!dom) return;
                var tagName = dom.tagName;
                var type = gradient.type;
                if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') that.updateDom(gradient, gradient.__dom);
                else {
                    that.removeDom(gradient);
                    that.add(gradient);
                }
            });
        };
        GradientManager.prototype.updateDom = function(gradient, dom) {
            if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) {
                dom.setAttribute('x1', gradient.x + '');
                dom.setAttribute('y1', gradient.y + '');
                dom.setAttribute('x2', gradient.x2 + '');
                dom.setAttribute('y2', gradient.y2 + '');
            } else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) {
                dom.setAttribute('cx', gradient.x + '');
                dom.setAttribute('cy', gradient.y + '');
                dom.setAttribute('r', gradient.r + '');
            } else {
                (0, parcelRequire("bahqM")).logError('Illegal gradient type.');
                return;
            }
            if (gradient.global) dom.setAttribute('gradientUnits', 'userSpaceOnUse');
            else dom.setAttribute('gradientUnits', 'objectBoundingBox');
            dom.innerHTML = '';
            var colors = gradient.colorStops;
            for(var i = 0, len = colors.length; i < len; ++i){
                var stop_1 = this.createElement('stop');
                stop_1.setAttribute('offset', colors[i].offset * 100 + '%');
                var color = colors[i].color;
                if (color.indexOf('rgba') > -1) {
                    var opacity = (0, parcelRequire("d6udH")).parse(color)[3];
                    var hex = (0, parcelRequire("d6udH")).toHex(color);
                    stop_1.setAttribute('stop-color', '#' + hex);
                    stop_1.setAttribute('stop-opacity', opacity + '');
                } else stop_1.setAttribute('stop-color', colors[i].color);
                dom.appendChild(stop_1);
            }
            gradient.__dom = dom;
        };
        GradientManager.prototype.markUsed = function(displayable) {
            if (displayable.style) {
                var gradient = displayable.style.fill;
                if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
                gradient = displayable.style.stroke;
                if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
            }
        };
        return GradientManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $6d1e9cd7c4fb6054$export$2e2bcd8739ae039 = $6d1e9cd7c4fb6054$var$GradientManager;
});
parcelRegister("akOIm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78631c76dc8428b5$export$2e2bcd8739ae039);
    var $dE0Hq;
    var $bahqM;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $k0bb8;
    var $78631c76dc8428b5$var$MARK_UNUSED = '0';
    var $78631c76dc8428b5$var$MARK_USED = '1';
    var $78631c76dc8428b5$var$Definable = function() {
        function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
            this.nextId = 0;
            this._domName = '_dom';
            this.createElement = (0, (0, parcelRequire("dE0Hq")).createElement);
            this._zrId = zrId;
            this._svgRoot = svgRoot;
            this._tagNames = typeof tagNames === 'string' ? [
                tagNames
            ] : tagNames;
            this._markLabel = markLabel;
            if (domName) this._domName = domName;
        }
        Definable.prototype.getDefs = function(isForceCreating) {
            var svgRoot = this._svgRoot;
            var defs = this._svgRoot.getElementsByTagName('defs');
            if (defs.length === 0) {
                if (isForceCreating) {
                    var defs_1 = svgRoot.insertBefore(this.createElement('defs'), svgRoot.firstChild);
                    if (!defs_1.contains) defs_1.contains = function(el) {
                        var children = defs_1.children;
                        if (!children) return false;
                        for(var i = children.length - 1; i >= 0; --i){
                            if (children[i] === el) return true;
                        }
                        return false;
                    };
                    return defs_1;
                } else return null;
            } else return defs[0];
        };
        Definable.prototype.doUpdate = function(target, onUpdate) {
            if (!target) return;
            var defs = this.getDefs(false);
            if (target[this._domName] && defs.contains(target[this._domName])) {
                if (typeof onUpdate === 'function') onUpdate(target);
            } else {
                var dom = this.add(target);
                if (dom) target[this._domName] = dom;
            }
        };
        Definable.prototype.add = function(target) {
            return null;
        };
        Definable.prototype.addDom = function(dom) {
            var defs = this.getDefs(true);
            if (dom.parentNode !== defs) defs.appendChild(dom);
        };
        Definable.prototype.removeDom = function(target) {
            var defs = this.getDefs(false);
            if (defs && target[this._domName]) {
                defs.removeChild(target[this._domName]);
                target[this._domName] = null;
            }
        };
        Definable.prototype.getDoms = function() {
            var defs = this.getDefs(false);
            if (!defs) return [];
            var doms = [];
            (0, parcelRequire("bahqM")).each(this._tagNames, function(tagName) {
                var tags = defs.getElementsByTagName(tagName);
                for(var i = 0; i < tags.length; i++)doms.push(tags[i]);
            });
            return doms;
        };
        Definable.prototype.markAllUnused = function() {
            var doms = this.getDoms();
            var that = this;
            (0, parcelRequire("bahqM")).each(doms, function(dom) {
                dom[that._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED;
            });
        };
        Definable.prototype.markDomUsed = function(dom) {
            dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_USED);
        };
        Definable.prototype.markDomUnused = function(dom) {
            dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED);
        };
        Definable.prototype.isDomUnused = function(dom) {
            return dom && dom[this._markLabel] !== $78631c76dc8428b5$var$MARK_USED;
        };
        Definable.prototype.removeUnused = function() {
            var _this = this;
            var defs = this.getDefs(false);
            if (!defs) return;
            var doms = this.getDoms();
            (0, parcelRequire("bahqM")).each(doms, function(dom) {
                if (_this.isDomUnused(dom)) defs.removeChild(dom);
            });
        };
        Definable.prototype.getSvgProxy = function(displayable) {
            if (displayable instanceof (0, (0, parcelRequire("ghQ8v")).default)) return 0, (0, parcelRequire("k0bb8")).path;
            else if (displayable instanceof (0, (0, parcelRequire("gcbBH")).default)) return 0, (0, parcelRequire("k0bb8")).image;
            else if (displayable instanceof (0, (0, parcelRequire("45jlh")).default)) return 0, (0, parcelRequire("k0bb8")).text;
            else return 0, (0, parcelRequire("k0bb8")).path;
        };
        Definable.prototype.getSvgElement = function(displayable) {
            return displayable.__svgEl;
        };
        return Definable;
    }();
    var $78631c76dc8428b5$export$2e2bcd8739ae039 = $78631c76dc8428b5$var$Definable;
});
parcelRegister("k0bb8", function(module, exports) {
    $parcel$export(module.exports, "path", ()=>$e8fc7a90186e67dc$export$bb654e07daaf8c3a);
    $parcel$export(module.exports, "image", ()=>$e8fc7a90186e67dc$export$5c452ff88e35e47d);
    $parcel$export(module.exports, "text", ()=>$e8fc7a90186e67dc$export$6f093cfa640b7166);
    var $dE0Hq;
    var $gcbBH;
    var $b7ZX8;
    var $bahqM;
    var $cpB91;
    var $e8fc7a90186e67dc$var$NONE = 'none';
    var $e8fc7a90186e67dc$var$mathRound = Math.round;
    var $e8fc7a90186e67dc$var$mathSin = Math.sin;
    var $e8fc7a90186e67dc$var$mathCos = Math.cos;
    var $e8fc7a90186e67dc$var$PI = Math.PI;
    var $e8fc7a90186e67dc$var$PI2 = Math.PI * 2;
    var $e8fc7a90186e67dc$var$degree = 180 / $e8fc7a90186e67dc$var$PI;
    var $e8fc7a90186e67dc$var$EPSILON = 1e-4;
    function $e8fc7a90186e67dc$var$round3(val) {
        return $e8fc7a90186e67dc$var$mathRound(val * 1e3) / 1e3;
    }
    function $e8fc7a90186e67dc$var$round4(val) {
        return $e8fc7a90186e67dc$var$mathRound(val * 1e4) / 1e4;
    }
    function $e8fc7a90186e67dc$var$isAroundZero(val) {
        return val < $e8fc7a90186e67dc$var$EPSILON && val > -$e8fc7a90186e67dc$var$EPSILON;
    }
    function $e8fc7a90186e67dc$var$pathHasFill(style) {
        var fill = style.fill;
        return fill != null && fill !== $e8fc7a90186e67dc$var$NONE;
    }
    function $e8fc7a90186e67dc$var$pathHasStroke(style) {
        var stroke = style.stroke;
        return stroke != null && stroke !== $e8fc7a90186e67dc$var$NONE;
    }
    function $e8fc7a90186e67dc$var$setTransform(svgEl, m) {
        if (m) $e8fc7a90186e67dc$var$attr(svgEl, 'transform', 'matrix(' + $e8fc7a90186e67dc$var$round3(m[0]) + ',' + $e8fc7a90186e67dc$var$round3(m[1]) + ',' + $e8fc7a90186e67dc$var$round3(m[2]) + ',' + $e8fc7a90186e67dc$var$round3(m[3]) + ',' + $e8fc7a90186e67dc$var$round4(m[4]) + ',' + $e8fc7a90186e67dc$var$round4(m[5]) + ')');
    }
    function $e8fc7a90186e67dc$var$attr(el, key, val) {
        if (!val || val.type !== 'linear' && val.type !== 'radial') el.setAttribute(key, val);
    }
    function $e8fc7a90186e67dc$var$attrXLink(el, key, val) {
        el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
    }
    function $e8fc7a90186e67dc$var$attrXML(el, key, val) {
        el.setAttributeNS('http://www.w3.org/XML/1998/namespace', key, val);
    }
    function $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el) {
        var opacity = style.opacity == null ? 1 : style.opacity;
        if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) {
            $e8fc7a90186e67dc$var$attr(svgEl, 'opacity', opacity + '');
            return;
        }
        if ($e8fc7a90186e67dc$var$pathHasFill(style)) {
            var fill = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.fill);
            $e8fc7a90186e67dc$var$attr(svgEl, 'fill', fill.color);
            $e8fc7a90186e67dc$var$attr(svgEl, 'fill-opacity', (style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity) + '');
        } else $e8fc7a90186e67dc$var$attr(svgEl, 'fill', $e8fc7a90186e67dc$var$NONE);
        if ($e8fc7a90186e67dc$var$pathHasStroke(style)) {
            var stroke = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.stroke);
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', stroke.color);
            var strokeWidth = style.lineWidth;
            var strokeScale_1 = style.strokeNoScale ? el.getLineScale() : 1;
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-width', (strokeScale_1 ? strokeWidth / strokeScale_1 : 0) + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'paint-order', style.strokeFirst ? 'stroke' : 'fill');
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-opacity', (style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity) + '');
            var lineDash = style.lineDash && strokeWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, strokeWidth);
            if (lineDash) {
                var lineDashOffset = style.lineDashOffset;
                if (strokeScale_1 && strokeScale_1 !== 1) {
                    lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                        return rawVal / strokeScale_1;
                    });
                    if (lineDashOffset) {
                        lineDashOffset /= strokeScale_1;
                        lineDashOffset = $e8fc7a90186e67dc$var$mathRound(lineDashOffset);
                    }
                }
                $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', lineDash.join(','));
                $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dashoffset', (lineDashOffset || 0) + '');
            } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', $e8fc7a90186e67dc$var$NONE);
            style.lineCap && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linecap', style.lineCap);
            style.lineJoin && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linejoin', style.lineJoin);
            style.miterLimit && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-miterlimit', style.miterLimit + '');
        } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', $e8fc7a90186e67dc$var$NONE);
    }
    var $e8fc7a90186e67dc$var$SVGPathRebuilder = function() {
        function SVGPathRebuilder() {}
        SVGPathRebuilder.prototype.reset = function() {
            this._d = [];
            this._str = '';
        };
        SVGPathRebuilder.prototype.moveTo = function(x, y) {
            this._add('M', x, y);
        };
        SVGPathRebuilder.prototype.lineTo = function(x, y) {
            this._add('L', x, y);
        };
        SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
            this._add('C', x, y, x2, y2, x3, y3);
        };
        SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
            this._add('Q', x, y, x2, y2);
        };
        SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
            this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
        };
        SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
            var firstCmd = this._d.length === 0;
            var dTheta = endAngle - startAngle;
            var clockwise = !anticlockwise;
            var dThetaPositive = Math.abs(dTheta);
            var isCircle = $e8fc7a90186e67dc$var$isAroundZero(dThetaPositive - $e8fc7a90186e67dc$var$PI2) || (clockwise ? dTheta >= $e8fc7a90186e67dc$var$PI2 : -dTheta >= $e8fc7a90186e67dc$var$PI2);
            var unifiedTheta = dTheta > 0 ? dTheta % $e8fc7a90186e67dc$var$PI2 : dTheta % $e8fc7a90186e67dc$var$PI2 + $e8fc7a90186e67dc$var$PI2;
            var large = false;
            if (isCircle) large = true;
            else if ($e8fc7a90186e67dc$var$isAroundZero(dThetaPositive)) large = false;
            else large = unifiedTheta >= $e8fc7a90186e67dc$var$PI === !!clockwise;
            var x0 = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle));
            var y0 = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle));
            if (isCircle) {
                if (clockwise) dTheta = $e8fc7a90186e67dc$var$PI2 - 1e-4;
                else dTheta = -$e8fc7a90186e67dc$var$PI2 + 1e-4;
                large = true;
                if (firstCmd) this._d.push('M', x0, y0);
            }
            var x = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle + dTheta));
            var y = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle + dTheta));
            if (isNaN(x0) || isNaN(y0) || isNaN(rx) || isNaN(ry) || isNaN(psi) || isNaN($e8fc7a90186e67dc$var$degree) || isNaN(x) || isNaN(y)) return '';
            this._d.push('A', $e8fc7a90186e67dc$var$round4(rx), $e8fc7a90186e67dc$var$round4(ry), $e8fc7a90186e67dc$var$mathRound(psi * $e8fc7a90186e67dc$var$degree), +large, +clockwise, x, y);
        };
        SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
            this._add('M', x, y);
            this._add('L', x + w, y);
            this._add('L', x + w, y + h);
            this._add('L', x, y + h);
            this._add('L', x, y);
            this._add('Z');
        };
        SVGPathRebuilder.prototype.closePath = function() {
            if (this._d.length > 0) this._add('Z');
        };
        SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
            this._d.push(cmd);
            for(var i = 1; i < arguments.length; i++){
                var val = arguments[i];
                if (isNaN(val)) {
                    this._invalid = true;
                    return;
                }
                this._d.push($e8fc7a90186e67dc$var$round4(val));
            }
        };
        SVGPathRebuilder.prototype.generateStr = function() {
            this._str = this._invalid ? '' : this._d.join(' ');
            this._d = [];
        };
        SVGPathRebuilder.prototype.getStr = function() {
            return this._str;
        };
        return SVGPathRebuilder;
    }();
    var $e8fc7a90186e67dc$export$bb654e07daaf8c3a = {
        brush: function(el) {
            var style = el.style;
            var svgEl = el.__svgEl;
            if (!svgEl) {
                svgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('path');
                el.__svgEl = svgEl;
            }
            if (!el.path) el.createPathProxy();
            var path = el.path;
            if (el.shapeChanged()) {
                path.beginPath();
                el.buildPath(path, el.shape);
                el.pathUpdated();
            }
            var pathVersion = path.getVersion();
            var elExt = el;
            var svgPathBuilder = elExt.__svgPathBuilder;
            if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || el.style.strokePercent < 1) {
                if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new $e8fc7a90186e67dc$var$SVGPathRebuilder();
                svgPathBuilder.reset();
                path.rebuildPath(svgPathBuilder, el.style.strokePercent);
                svgPathBuilder.generateStr();
                elExt.__svgPathVersion = pathVersion;
            }
            $e8fc7a90186e67dc$var$attr(svgEl, 'd', svgPathBuilder.getStr());
            $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
        }
    };
    var $e8fc7a90186e67dc$export$5c452ff88e35e47d = {
        brush: function(el) {
            var style = el.style;
            var image = style.image;
            if (image instanceof HTMLImageElement) image = image.src;
            else if (image instanceof HTMLCanvasElement) image = image.toDataURL();
            if (!image) return;
            var x = style.x || 0;
            var y = style.y || 0;
            var dw = style.width;
            var dh = style.height;
            var svgEl = el.__svgEl;
            if (!svgEl) {
                svgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('image');
                el.__svgEl = svgEl;
            }
            if (image !== el.__imageSrc) {
                $e8fc7a90186e67dc$var$attrXLink(svgEl, 'href', image);
                el.__imageSrc = image;
            }
            $e8fc7a90186e67dc$var$attr(svgEl, 'width', dw + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'height', dh + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'x', x + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'y', y + '');
            $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
        }
    };
    var $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR = {
        left: 'start',
        right: 'end',
        center: 'middle',
        middle: 'middle'
    };
    function $e8fc7a90186e67dc$var$adjustTextY(y, lineHeight, textBaseline) {
        if (textBaseline === 'top') y += lineHeight / 2;
        else if (textBaseline === 'bottom') y -= lineHeight / 2;
        return y;
    }
    var $e8fc7a90186e67dc$export$6f093cfa640b7166 = {
        brush: function(el) {
            var style = el.style;
            var text = style.text;
            text != null && (text += '');
            if (!text || isNaN(style.x) || isNaN(style.y)) return;
            var textSvgEl = el.__svgEl;
            if (!textSvgEl) {
                textSvgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('text');
                $e8fc7a90186e67dc$var$attrXML(textSvgEl, 'xml:space', 'preserve');
                el.__svgEl = textSvgEl;
            }
            var font = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            var textSvgElStyle = textSvgEl.style;
            textSvgElStyle.font = font;
            textSvgEl.textContent = text;
            $e8fc7a90186e67dc$var$bindStyle(textSvgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(textSvgEl, el.transform);
            var x = style.x || 0;
            var y = $e8fc7a90186e67dc$var$adjustTextY(style.y || 0, (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font), style.textBaseline);
            var textAlign = $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR[style.textAlign] || style.textAlign;
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'dominant-baseline', 'central');
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'text-anchor', textAlign);
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'x', x + '');
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'y', y + '');
        }
    };
});
parcelRegister("brSrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$855c73ff662bd5dc$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $63nvx;
    var $822uQ;
    function $855c73ff662bd5dc$var$isPattern(value) {
        return value && (!!value.image || !!value.svgElement);
    }
    var $855c73ff662bd5dc$var$patternDomMap = new (0, (0, parcelRequire("822uQ")).default)();
    var $855c73ff662bd5dc$var$PatternManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(PatternManager, _super);
        function PatternManager(zrId, svgRoot) {
            return _super.call(this, zrId, svgRoot, [
                'pattern'
            ], '__pattern_in_use__') || this;
        }
        PatternManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
            if (displayable && displayable.style) {
                var that_1 = this;
                (0, parcelRequire("bahqM")).each([
                    'fill',
                    'stroke'
                ], function(fillOrStroke) {
                    var pattern = displayable.style[fillOrStroke];
                    if ($855c73ff662bd5dc$var$isPattern(pattern)) {
                        var defs = that_1.getDefs(true);
                        var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
                        if (dom) {
                            if (!defs.contains(dom)) that_1.addDom(dom);
                        } else dom = that_1.add(pattern);
                        that_1.markUsed(displayable);
                        var id = dom.getAttribute('id');
                        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                    }
                });
            }
        };
        PatternManager.prototype.add = function(pattern) {
            if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
            var dom = this.createElement('pattern');
            pattern.id = pattern.id == null ? this.nextId++ : pattern.id;
            dom.setAttribute('id', 'zr' + this._zrId + '-pattern-' + pattern.id);
            dom.setAttribute('x', '0');
            dom.setAttribute('y', '0');
            dom.setAttribute('patternUnits', 'userSpaceOnUse');
            this.updateDom(pattern, dom);
            this.addDom(dom);
            return dom;
        };
        PatternManager.prototype.update = function(pattern) {
            if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
            var that = this;
            this.doUpdate(pattern, function() {
                var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
                that.updateDom(pattern, dom);
            });
        };
        PatternManager.prototype.updateDom = function(pattern, patternDom) {
            var svgElement = pattern.svgElement;
            if (svgElement instanceof SVGElement) {
                if (svgElement.parentNode !== patternDom) {
                    patternDom.innerHTML = '';
                    patternDom.appendChild(svgElement);
                    patternDom.setAttribute('width', pattern.svgWidth + '');
                    patternDom.setAttribute('height', pattern.svgHeight + '');
                }
            } else {
                var img = void 0;
                var prevImage = patternDom.getElementsByTagName('image');
                if (prevImage.length) {
                    if (pattern.image) img = prevImage[0];
                    else {
                        patternDom.removeChild(prevImage[0]);
                        return;
                    }
                } else if (pattern.image) img = this.createElement('image');
                if (img) {
                    var imageSrc = void 0;
                    var patternImage = pattern.image;
                    if (typeof patternImage === 'string') imageSrc = patternImage;
                    else if (patternImage instanceof HTMLImageElement) imageSrc = patternImage.src;
                    else if (patternImage instanceof HTMLCanvasElement) imageSrc = patternImage.toDataURL();
                    if (imageSrc) {
                        img.setAttribute('href', imageSrc);
                        img.setAttribute('x', '0');
                        img.setAttribute('y', '0');
                        var hostEl = {
                            dirty: function() {}
                        };
                        var createdImage = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(imageSrc, img, hostEl, function(img) {
                            patternDom.setAttribute('width', img.width + '');
                            patternDom.setAttribute('height', img.height + '');
                        });
                        if (createdImage && createdImage.width && createdImage.height) {
                            patternDom.setAttribute('width', createdImage.width + '');
                            patternDom.setAttribute('height', createdImage.height + '');
                        }
                        patternDom.appendChild(img);
                    }
                }
            }
            var x = pattern.x || 0;
            var y = pattern.y || 0;
            var rotation = (pattern.rotation || 0) / Math.PI * 180;
            var scaleX = pattern.scaleX || 1;
            var scaleY = pattern.scaleY || 1;
            var transform = "translate(" + x + ", " + y + ") rotate(" + rotation + ") scale(" + scaleX + ", " + scaleY + ")";
            patternDom.setAttribute('patternTransform', transform);
            $855c73ff662bd5dc$var$patternDomMap.set(pattern, patternDom);
        };
        PatternManager.prototype.markUsed = function(displayable) {
            if (displayable.style) {
                if ($855c73ff662bd5dc$var$isPattern(displayable.style.fill)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.fill));
                if ($855c73ff662bd5dc$var$isPattern(displayable.style.stroke)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.stroke));
            }
        };
        return PatternManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $855c73ff662bd5dc$export$2e2bcd8739ae039 = $855c73ff662bd5dc$var$PatternManager;
});
parcelRegister("i53xG", function(module, exports) {
    $parcel$export(module.exports, "hasClipPath", ()=>$d29b710c2ddb799a$export$3918818844b1239b);
    $parcel$export(module.exports, "default", ()=>$d29b710c2ddb799a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $dPYp9;
    function $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths) {
        var key = [];
        if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            key.push(clipPath.id);
        }
        return key.join(',');
    }
    function $d29b710c2ddb799a$export$3918818844b1239b(displayable) {
        var clipPaths = displayable.__clipPaths;
        return clipPaths && clipPaths.length > 0;
    }
    var $d29b710c2ddb799a$var$ClippathManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ClippathManager, _super);
        function ClippathManager(zrId, svgRoot) {
            var _this = _super.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__') || this;
            _this._refGroups = {};
            _this._keyDuplicateCount = {};
            return _this;
        }
        ClippathManager.prototype.markAllUnused = function() {
            _super.prototype.markAllUnused.call(this);
            var refGroups = this._refGroups;
            for(var key in refGroups)if (refGroups.hasOwnProperty(key)) this.markDomUnused(refGroups[key]);
            this._keyDuplicateCount = {};
        };
        ClippathManager.prototype._getClipPathGroup = function(displayable, prevDisplayable) {
            if (!$d29b710c2ddb799a$export$3918818844b1239b(displayable)) return;
            var clipPaths = displayable.__clipPaths;
            var keyDuplicateCount = this._keyDuplicateCount;
            var clipPathKey = $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths);
            if ((0, (0, parcelRequire("dPYp9")).isClipPathChanged)(clipPaths, prevDisplayable && prevDisplayable.__clipPaths)) {
                keyDuplicateCount[clipPathKey] = keyDuplicateCount[clipPathKey] || 0;
                keyDuplicateCount[clipPathKey] && (clipPathKey += '-' + keyDuplicateCount[clipPathKey]);
                keyDuplicateCount[clipPathKey]++;
            }
            return this._refGroups[clipPathKey] || (this._refGroups[clipPathKey] = this.createElement('g'));
        };
        ClippathManager.prototype.update = function(displayable, prevDisplayable) {
            var clipGroup = this._getClipPathGroup(displayable, prevDisplayable);
            if (clipGroup) {
                this.markDomUsed(clipGroup);
                this.updateDom(clipGroup, displayable.__clipPaths);
            }
            return clipGroup;
        };
        ClippathManager.prototype.updateDom = function(parentEl, clipPaths) {
            if (clipPaths && clipPaths.length > 0) {
                var defs = this.getDefs(true);
                var clipPath = clipPaths[0];
                var clipPathEl = void 0;
                var id = void 0;
                if (clipPath._dom) {
                    id = clipPath._dom.getAttribute('id');
                    clipPathEl = clipPath._dom;
                    if (!defs.contains(clipPathEl)) defs.appendChild(clipPathEl);
                } else {
                    id = 'zr' + this._zrId + '-clip-' + this.nextId;
                    ++this.nextId;
                    clipPathEl = this.createElement('clipPath');
                    clipPathEl.setAttribute('id', id);
                    defs.appendChild(clipPathEl);
                    clipPath._dom = clipPathEl;
                }
                var svgProxy = this.getSvgProxy(clipPath);
                svgProxy.brush(clipPath);
                var pathEl = this.getSvgElement(clipPath);
                clipPathEl.innerHTML = '';
                clipPathEl.appendChild(pathEl);
                parentEl.setAttribute('clip-path', 'url(#' + id + ')');
                if (clipPaths.length > 1) this.updateDom(clipPathEl, clipPaths.slice(1));
            } else if (parentEl) parentEl.setAttribute('clip-path', 'none');
        };
        ClippathManager.prototype.markUsed = function(displayable) {
            var _this = this;
            if (displayable.__clipPaths) (0, parcelRequire("bahqM")).each(displayable.__clipPaths, function(clipPath) {
                if (clipPath._dom) _super.prototype.markDomUsed.call(_this, clipPath._dom);
            });
        };
        ClippathManager.prototype.removeUnused = function() {
            _super.prototype.removeUnused.call(this);
            var newRefGroupsMap = {};
            var refGroups = this._refGroups;
            for(var key in refGroups)if (refGroups.hasOwnProperty(key)) {
                var group = refGroups[key];
                if (!this.isDomUnused(group)) newRefGroupsMap[key] = group;
                else if (group.parentNode) group.parentNode.removeChild(group);
            }
            this._refGroups = newRefGroupsMap;
        };
        return ClippathManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $d29b710c2ddb799a$export$2e2bcd8739ae039 = $d29b710c2ddb799a$var$ClippathManager;
});
parcelRegister("b6V4m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$816c8609515aa333$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $dE0Hq;
    var $816c8609515aa333$var$ShadowManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ShadowManager, _super);
        function ShadowManager(zrId, svgRoot) {
            var _this = _super.call(this, zrId, svgRoot, [
                'filter'
            ], '__filter_in_use__', '_shadowDom') || this;
            _this._shadowDomMap = {};
            _this._shadowDomPool = [];
            return _this;
        }
        ShadowManager.prototype._getFromPool = function() {
            var shadowDom = this._shadowDomPool.pop();
            if (!shadowDom) {
                shadowDom = this.createElement('filter');
                shadowDom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + this.nextId++);
                var domChild = this.createElement('feDropShadow');
                shadowDom.appendChild(domChild);
                this.addDom(shadowDom);
            }
            return shadowDom;
        };
        ShadowManager.prototype.update = function(svgElement, displayable) {
            var style = displayable.style;
            if ($816c8609515aa333$var$hasShadow(style)) {
                var shadowKey = $816c8609515aa333$var$getShadowKey(displayable);
                var shadowDom = displayable._shadowDom = this._shadowDomMap[shadowKey];
                if (!shadowDom) {
                    shadowDom = this._getFromPool();
                    this._shadowDomMap[shadowKey] = shadowDom;
                }
                this.updateDom(svgElement, displayable, shadowDom);
            } else this.remove(svgElement, displayable);
        };
        ShadowManager.prototype.remove = function(svgElement, displayable) {
            if (displayable._shadowDom != null) {
                displayable._shadowDom = null;
                svgElement.removeAttribute('filter');
            }
        };
        ShadowManager.prototype.updateDom = function(svgElement, displayable, shadowDom) {
            var domChild = shadowDom.children[0];
            var style = displayable.style;
            var globalScale = displayable.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur = style.shadowBlur;
            var normalizedColor = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.shadowColor);
            domChild.setAttribute('dx', offsetX / scaleX + '');
            domChild.setAttribute('dy', offsetY / scaleY + '');
            domChild.setAttribute('flood-color', normalizedColor.color);
            domChild.setAttribute('flood-opacity', normalizedColor.opacity + '');
            var stdDx = blur / 2 / scaleX;
            var stdDy = blur / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            domChild.setAttribute('stdDeviation', stdDeviation);
            shadowDom.setAttribute('x', '-100%');
            shadowDom.setAttribute('y', '-100%');
            shadowDom.setAttribute('width', '300%');
            shadowDom.setAttribute('height', '300%');
            displayable._shadowDom = shadowDom;
            var id = shadowDom.getAttribute('id');
            svgElement.setAttribute('filter', 'url(#' + id + ')');
        };
        ShadowManager.prototype.removeUnused = function() {
            var defs = this.getDefs(false);
            if (!defs) return;
            var shadowDomsPool = this._shadowDomPool;
            var shadowDomMap = this._shadowDomMap;
            for(var key in shadowDomMap)if (shadowDomMap.hasOwnProperty(key)) shadowDomsPool.push(shadowDomMap[key]);
            this._shadowDomMap = {};
        };
        return ShadowManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $816c8609515aa333$export$2e2bcd8739ae039 = $816c8609515aa333$var$ShadowManager;
    function $816c8609515aa333$var$hasShadow(style) {
        return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
    }
    function $816c8609515aa333$var$getShadowKey(displayable) {
        var style = displayable.style;
        var globalScale = displayable.getGlobalScale();
        return [
            style.shadowColor,
            (style.shadowBlur || 0).toFixed(2),
            (style.shadowOffsetX || 0).toFixed(2),
            (style.shadowOffsetY || 0).toFixed(2),
            globalScale[0],
            globalScale[1]
        ].join(',');
    }
});
parcelRegister("2HWES", function(module, exports) {
    $parcel$export(module.exports, "getXAxisConfiguration", ()=>$4873fe759adbd590$export$1808d69f600e9ee6);
    $parcel$export(module.exports, "getYAxisConfiguration", ()=>$4873fe759adbd590$export$a9dea35efaf7afd0);
    $parcel$export(module.exports, "getGridConfiguration", ()=>$4873fe759adbd590$export$a124e1c1031832ab);
    $parcel$export(module.exports, "getTooltipConfiguration", ()=>$4873fe759adbd590$export$ed4f31d6303e81ef);
    var $5w2JH;
    var $8AhUZ;
    const $4873fe759adbd590$export$1808d69f600e9ee6 = (axisLabelsData)=>({
            type: (0, (0, parcelRequire("8AhUZ")).X_AXIS_TYPE),
            boundaryGap: false,
            axisLine: {
                lineStyle: {
                    color: (0, (0, parcelRequire("8AhUZ")).AXIS_COLOR)
                }
            },
            axisLabel: {
                color: (0, (0, parcelRequire("8AhUZ")).AXIS_LABEL_COLOR)
            },
            data: axisLabelsData
        });
    const $4873fe759adbd590$export$a9dea35efaf7afd0 = ({ yAxisFormatter: yAxisFormatter, minMaxConfig: minMaxConfig })=>{
        const config = {
            type: (0, (0, parcelRequire("8AhUZ")).Y_AXIS_TYPE),
            splitLine: {
                show: true,
                lineStyle: {
                    color: (0, (0, parcelRequire("8AhUZ")).AXIS_COLOR)
                }
            },
            axisLabel: {
                color: (0, (0, parcelRequire("8AhUZ")).AXIS_LABEL_COLOR),
                showMaxLabel: true,
                formatter: yAxisFormatter
            },
            minInterval: 1,
            boundaryGap: [
                '0',
                '5%'
            ],
            ...minMaxConfig
        };
        return config;
    };
    const $4873fe759adbd590$export$a124e1c1031832ab = ()=>({
            show: true,
            borderColor: (0, (0, parcelRequire("8AhUZ")).AXIS_COLOR),
            left: '5%',
            right: '3%',
            bottom: '15%'
        });
    const $4873fe759adbd590$export$ed4f31d6303e81ef = (formatter)=>({
            backgroundColor: `var(--ds-background-neutral-bold, ${(0, $72ba03e317f3d228$exports).N900})`,
            trigger: (0, (0, parcelRequire("8AhUZ")).TOOL_TIP_TRIGGER),
            triggerOn: 'none',
            transitionDuration: 0,
            textStyle: {
                color: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`
            },
            extraCssText: `box-shadow: ${"var(--ds-shadow-raised, 0 0 8px rgba(0, 0, 0, 0.3))"}`,
            axisPointer: {
                type: 'shadow',
                shadowStyle: {
                    color: (0, (0, parcelRequire("5w2JH")).default)('color.background.neutral.subtle.hovered', (0, $72ba03e317f3d228$exports).N10A)
                }
            },
            formatter: formatter
        });
});
parcelRegister("8AhUZ", function(module, exports) {
    $parcel$export(module.exports, "X_AXIS_TYPE", ()=>$f4286fa749e3f39c$export$6f19b351decf0777);
    $parcel$export(module.exports, "Y_AXIS_TYPE", ()=>$f4286fa749e3f39c$export$4d827148a5ec3256);
    $parcel$export(module.exports, "AXIS_COLOR", ()=>$f4286fa749e3f39c$export$12df7fe4b8077ee9);
    $parcel$export(module.exports, "AXIS_LABEL_COLOR", ()=>$f4286fa749e3f39c$export$b5ee262accc33477);
    $parcel$export(module.exports, "TOOL_TIP_TRIGGER", ()=>$f4286fa749e3f39c$export$bbaf67291ac3f6);
    var $5w2JH;
    const $f4286fa749e3f39c$export$6f19b351decf0777 = 'category';
    const $f4286fa749e3f39c$export$4d827148a5ec3256 = 'value';
    const $f4286fa749e3f39c$export$12df7fe4b8077ee9 = (0, (0, parcelRequire("5w2JH")).default)('color.border', (0, $72ba03e317f3d228$exports).N40);
    const $f4286fa749e3f39c$export$b5ee262accc33477 = (0, (0, parcelRequire("5w2JH")).default)('color.text.subtle', (0, $72ba03e317f3d228$exports).N300);
    const $f4286fa749e3f39c$export$bbaf67291ac3f6 = 'axis';
});
parcelRegister("aMUni", function(module, exports) {
    $parcel$export(module.exports, "useChartEvents", ()=>$d20e00222cfcabfd$export$17a4e5f119c7d26e);
    var $5uXOq = parcelRequire("5uXOq");
    var $80afZ = parcelRequire("80afZ");
    var $hXLCJ = parcelRequire("hXLCJ");
    var $7SUn6;
    const $d20e00222cfcabfd$export$17a4e5f119c7d26e = ({ onPointSelect: onPointSelect, source: source })=>{
        const chartRef = (0, $5uXOq.useRef)(undefined);
        const highlightedPointRef = (0, $5uXOq.useRef)(undefined);
        const setCurrentHighlightedPoint = (0, $5uXOq.useCallback)(()=>{
            highlightedPointRef.current && chartRef.current && chartRef.current.dispatchAction(highlightedPointRef.current);
        }, []);
        const highlightPoint = (0, $5uXOq.useCallback)((params)=>{
            if (!chartRef.current) return;
            chartRef.current.dispatchAction({
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
            });
            highlightedPointRef.current = {
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).HIGHLIGHT_SELECTED_POINT,
                seriesIndex: params.seriesIndex,
                seriesName: params.seriesName,
                dataIndex: params.dataIndex,
                name: params.name
            };
            setCurrentHighlightedPoint();
        }, [
            setCurrentHighlightedPoint
        ]);
        const downplayPoint = (0, $5uXOq.useCallback)(()=>{
            if (!chartRef.current) return;
            chartRef.current.dispatchAction({
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
            });
            highlightedPointRef.current = undefined;
        }, []);
        const refreshOptions = (0, $5uXOq.useCallback)((config)=>{
            chartRef.current && chartRef.current.setOption(config, {
                notMerge: true
            });
        }, []);
        const activateTooltipOnMouseOver = (0, $5uXOq.useCallback)((params)=>{
            chartRef.current && chartRef.current.dispatchAction({
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).SHOW_TOOL_TIP,
                seriesIndex: params.seriesIndex,
                seriesName: (0, ($parcel$interopDefault($hXLCJ))).sanitize(params.seriesName),
                dataIndex: params.dataIndex,
                name: params.name
            });
            setCurrentHighlightedPoint();
        }, [
            setCurrentHighlightedPoint
        ]);
        const hideTooltipOnMouseOut = (0, $5uXOq.useCallback)(()=>{
            chartRef.current && chartRef.current.dispatchAction({
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).HIDE_TIP
            });
            chartRef.current && chartRef.current.dispatchAction({
                type: (0, (0, parcelRequire("7SUn6")).GRAPH_ACTION_TYPES).DOWNPLAY_STALE_POINT
            });
            setCurrentHighlightedPoint();
        }, [
            setCurrentHighlightedPoint
        ]);
        const findSeries = (0, $5uXOq.useCallback)((echartsInstance, path)=>{
            const color = path.getAttribute('stroke');
            const transform = path.getAttribute('transform').split('matrix(')[1].split(')')[0].split(',');
            const transformX = Math.round(transform[4] * 100) / 100;
            const transformY = Math.round(transform[5] * 100) / 100;
            const seriesIndex = source.chartSeries.findIndex((series)=>series.itemStyle.color === color);
            const series = source.chartSeries[seriesIndex];
            const seriesInstance = Object.values(echartsInstance._chartsMap).find((instance)=>instance._data._visual.style.fill === color);
            const index = seriesInstance._data._graphicEls.findIndex((item)=>{
                if (Math.round(item.x * 100) / 100 === transformX && Math.round(item.y * 100) / 100 === transformY) return true;
                return false;
            });
            return {
                data: series.data[index],
                seriesName: series.name
            };
        }, [
            source.chartSeries
        ]);
        const registerEvents = (0, $5uXOq.useCallback)((echartsInstance)=>{
            const paths = chartRef.current._dom.querySelectorAll('path[d="M 1 0 A 1 1 0 1 1 1 -0.0001"]');
            for(let pathIndex = 0; pathIndex < paths.length; pathIndex++)paths[pathIndex].setAttribute('tabindex', 0);
            chartRef.current._dom.addEventListener('keydown', (event)=>{
                if (event.key === 'Enter' && event.target.nodeName === 'path' && event.target.getAttribute('tabindex')) {
                    const { data: data } = findSeries(echartsInstance, event.target);
                    if (onPointSelect) onPointSelect({
                        data: data
                    });
                }
            });
            if (!echartsInstance) return;
            if (onPointSelect) echartsInstance.on((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES).CLICK, (params)=>{
                onPointSelect(params);
            });
            echartsInstance.on((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES).MOUSE_OVER, activateTooltipOnMouseOver);
            echartsInstance.on((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES).MOUSE_OUT, hideTooltipOnMouseOut);
        }, [
            onPointSelect,
            activateTooltipOnMouseOver,
            hideTooltipOnMouseOut,
            findSeries
        ]);
        const initChartEventsOnMount = (0, $5uXOq.useCallback)((echartsInstance)=>{
            chartRef.current = echartsInstance;
            registerEvents(echartsInstance);
        }, [
            registerEvents
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (chartRef.current) {
                chartRef.current.off((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES).CLICK);
                chartRef.current && onPointSelect && chartRef.current.on((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES).CLICK, onPointSelect);
            }
        }, [
            onPointSelect
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                (0, ($parcel$interopDefault($80afZ)))((0, (0, parcelRequire("7SUn6")).GRAPH_EVENT_TYPES), (event)=>{
                    chartRef.current && chartRef.current.off(event);
                });
                chartRef.current && chartRef.current.dispose();
            }, []);
        return {
            initChartEventsOnMount: initChartEventsOnMount,
            highlightPoint: highlightPoint,
            downplayPoint: downplayPoint,
            refreshOptions: refreshOptions
        };
    };
});
parcelRegister("hXLCJ", function(module, exports) {
    (function(global, factory) {
        module.exports = factory();
    })(module.exports, function() {
        'use strict';
        function _typeof(obj) {
            "@babel/helpers - typeof";
            return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, _typeof(obj);
        }
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
                Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                return true;
            } catch (e) {
                return false;
            }
        }
        function _construct(Parent, args, Class) {
            if (_isNativeReflectConstruct()) _construct = Reflect.construct;
            else _construct = function _construct(Parent, args, Class) {
                var a = [
                    null
                ];
                a.push.apply(a, args);
                var Constructor = Function.bind.apply(Parent, a);
                var instance = new Constructor();
                if (Class) _setPrototypeOf(instance, Class.prototype);
                return instance;
            };
            return _construct.apply(null, arguments);
        }
        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }
        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _iterableToArray(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
        }
        function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor) n = o.constructor.name;
            if (n === "Map" || n === "Set") return Array.from(o);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;
            for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
            return arr2;
        }
        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var freeze = Object.freeze, seal = Object.seal, create = Object.create;
        var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
        if (!apply) apply = function apply(fun, thisValue, args) {
            return fun.apply(thisValue, args);
        };
        if (!freeze) freeze = function freeze(x) {
            return x;
        };
        if (!seal) seal = function seal(x) {
            return x;
        };
        if (!construct) construct = function construct(Func, args) {
            return _construct(Func, _toConsumableArray(args));
        };
        var arrayForEach = unapply(Array.prototype.forEach);
        var arrayPop = unapply(Array.prototype.pop);
        var arrayPush = unapply(Array.prototype.push);
        var stringToLowerCase = unapply(String.prototype.toLowerCase);
        var stringToString = unapply(String.prototype.toString);
        var stringMatch = unapply(String.prototype.match);
        var stringReplace = unapply(String.prototype.replace);
        var stringIndexOf = unapply(String.prototype.indexOf);
        var stringTrim = unapply(String.prototype.trim);
        var regExpTest = unapply(RegExp.prototype.test);
        var typeErrorCreate = unconstruct(TypeError);
        function unapply(func) {
            return function(thisArg) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                return apply(func, thisArg, args);
            };
        }
        function unconstruct(func) {
            return function() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return construct(func, args);
            };
        }
        function addToSet(set, array, transformCaseFunc) {
            var _transformCaseFunc;
            transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
            if (setPrototypeOf) setPrototypeOf(set, null);
            var l = array.length;
            while(l--){
                var element = array[l];
                if (typeof element === 'string') {
                    var lcElement = transformCaseFunc(element);
                    if (lcElement !== element) {
                        if (!isFrozen(array)) array[l] = lcElement;
                        element = lcElement;
                    }
                }
                set[element] = true;
            }
            return set;
        }
        function clone(object) {
            var newObject = create(null);
            var property;
            for(property in object)if (apply(hasOwnProperty, object, [
                property
            ]) === true) newObject[property] = object[property];
            return newObject;
        }
        function lookupGetter(object, prop) {
            while(object !== null){
                var desc = getOwnPropertyDescriptor(object, prop);
                if (desc) {
                    if (desc.get) return unapply(desc.get);
                    if (typeof desc.value === 'function') return unapply(desc.value);
                }
                object = getPrototypeOf(object);
            }
            function fallbackValue(element) {
                console.warn('fallback value for', element);
                return null;
            }
            return fallbackValue;
        }
        var html$1 = freeze([
            'a',
            'abbr',
            'acronym',
            'address',
            'area',
            'article',
            'aside',
            'audio',
            'b',
            'bdi',
            'bdo',
            'big',
            'blink',
            'blockquote',
            'body',
            'br',
            'button',
            'canvas',
            'caption',
            'center',
            'cite',
            'code',
            'col',
            'colgroup',
            'content',
            'data',
            'datalist',
            'dd',
            'decorator',
            'del',
            'details',
            'dfn',
            'dialog',
            'dir',
            'div',
            'dl',
            'dt',
            'element',
            'em',
            'fieldset',
            'figcaption',
            'figure',
            'font',
            'footer',
            'form',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'head',
            'header',
            'hgroup',
            'hr',
            'html',
            'i',
            'img',
            'input',
            'ins',
            'kbd',
            'label',
            'legend',
            'li',
            'main',
            'map',
            'mark',
            'marquee',
            'menu',
            'menuitem',
            'meter',
            'nav',
            'nobr',
            'ol',
            'optgroup',
            'option',
            'output',
            'p',
            'picture',
            'pre',
            'progress',
            'q',
            'rp',
            'rt',
            'ruby',
            's',
            'samp',
            'section',
            'select',
            'shadow',
            'small',
            'source',
            'spacer',
            'span',
            'strike',
            'strong',
            'style',
            'sub',
            'summary',
            'sup',
            'table',
            'tbody',
            'td',
            'template',
            'textarea',
            'tfoot',
            'th',
            'thead',
            'time',
            'tr',
            'track',
            'tt',
            'u',
            'ul',
            'var',
            'video',
            'wbr'
        ]);
        var svg$1 = freeze([
            'svg',
            'a',
            'altglyph',
            'altglyphdef',
            'altglyphitem',
            'animatecolor',
            'animatemotion',
            'animatetransform',
            'circle',
            'clippath',
            'defs',
            'desc',
            'ellipse',
            'filter',
            'font',
            'g',
            'glyph',
            'glyphref',
            'hkern',
            'image',
            'line',
            'lineargradient',
            'marker',
            'mask',
            'metadata',
            'mpath',
            'path',
            'pattern',
            'polygon',
            'polyline',
            'radialgradient',
            'rect',
            'stop',
            'style',
            'switch',
            'symbol',
            'text',
            'textpath',
            'title',
            'tref',
            'tspan',
            'view',
            'vkern'
        ]);
        var svgFilters = freeze([
            'feBlend',
            'feColorMatrix',
            'feComponentTransfer',
            'feComposite',
            'feConvolveMatrix',
            'feDiffuseLighting',
            'feDisplacementMap',
            'feDistantLight',
            'feFlood',
            'feFuncA',
            'feFuncB',
            'feFuncG',
            'feFuncR',
            'feGaussianBlur',
            'feImage',
            'feMerge',
            'feMergeNode',
            'feMorphology',
            'feOffset',
            'fePointLight',
            'feSpecularLighting',
            'feSpotLight',
            'feTile',
            'feTurbulence'
        ]);
        var svgDisallowed = freeze([
            'animate',
            'color-profile',
            'cursor',
            'discard',
            'fedropshadow',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'foreignobject',
            'hatch',
            'hatchpath',
            'mesh',
            'meshgradient',
            'meshpatch',
            'meshrow',
            'missing-glyph',
            'script',
            'set',
            'solidcolor',
            'unknown',
            'use'
        ]);
        var mathMl$1 = freeze([
            'math',
            'menclose',
            'merror',
            'mfenced',
            'mfrac',
            'mglyph',
            'mi',
            'mlabeledtr',
            'mmultiscripts',
            'mn',
            'mo',
            'mover',
            'mpadded',
            'mphantom',
            'mroot',
            'mrow',
            'ms',
            'mspace',
            'msqrt',
            'mstyle',
            'msub',
            'msup',
            'msubsup',
            'mtable',
            'mtd',
            'mtext',
            'mtr',
            'munder',
            'munderover'
        ]);
        var mathMlDisallowed = freeze([
            'maction',
            'maligngroup',
            'malignmark',
            'mlongdiv',
            'mscarries',
            'mscarry',
            'msgroup',
            'mstack',
            'msline',
            'msrow',
            'semantics',
            'annotation',
            'annotation-xml',
            'mprescripts',
            'none'
        ]);
        var text = freeze([
            '#text'
        ]);
        var html = freeze([
            'accept',
            'action',
            'align',
            'alt',
            'autocapitalize',
            'autocomplete',
            'autopictureinpicture',
            'autoplay',
            'background',
            'bgcolor',
            'border',
            'capture',
            'cellpadding',
            'cellspacing',
            'checked',
            'cite',
            'class',
            'clear',
            'color',
            'cols',
            'colspan',
            'controls',
            'controlslist',
            'coords',
            'crossorigin',
            'datetime',
            'decoding',
            'default',
            'dir',
            'disabled',
            'disablepictureinpicture',
            'disableremoteplayback',
            'download',
            'draggable',
            'enctype',
            'enterkeyhint',
            'face',
            'for',
            'headers',
            'height',
            'hidden',
            'high',
            'href',
            'hreflang',
            'id',
            'inputmode',
            'integrity',
            'ismap',
            'kind',
            'label',
            'lang',
            'list',
            'loading',
            'loop',
            'low',
            'max',
            'maxlength',
            'media',
            'method',
            'min',
            'minlength',
            'multiple',
            'muted',
            'name',
            'nonce',
            'noshade',
            'novalidate',
            'nowrap',
            'open',
            'optimum',
            'pattern',
            'placeholder',
            'playsinline',
            'poster',
            'preload',
            'pubdate',
            'radiogroup',
            'readonly',
            'rel',
            'required',
            'rev',
            'reversed',
            'role',
            'rows',
            'rowspan',
            'spellcheck',
            'scope',
            'selected',
            'shape',
            'size',
            'sizes',
            'span',
            'srclang',
            'start',
            'src',
            'srcset',
            'step',
            'style',
            'summary',
            'tabindex',
            'title',
            'translate',
            'type',
            'usemap',
            'valign',
            'value',
            'width',
            'xmlns',
            'slot'
        ]);
        var svg = freeze([
            'accent-height',
            'accumulate',
            'additive',
            'alignment-baseline',
            'ascent',
            'attributename',
            'attributetype',
            'azimuth',
            'basefrequency',
            'baseline-shift',
            'begin',
            'bias',
            'by',
            'class',
            'clip',
            'clippathunits',
            'clip-path',
            'clip-rule',
            'color',
            'color-interpolation',
            'color-interpolation-filters',
            'color-profile',
            'color-rendering',
            'cx',
            'cy',
            'd',
            'dx',
            'dy',
            'diffuseconstant',
            'direction',
            'display',
            'divisor',
            'dur',
            'edgemode',
            'elevation',
            'end',
            'fill',
            'fill-opacity',
            'fill-rule',
            'filter',
            'filterunits',
            'flood-color',
            'flood-opacity',
            'font-family',
            'font-size',
            'font-size-adjust',
            'font-stretch',
            'font-style',
            'font-variant',
            'font-weight',
            'fx',
            'fy',
            'g1',
            'g2',
            'glyph-name',
            'glyphref',
            'gradientunits',
            'gradienttransform',
            'height',
            'href',
            'id',
            'image-rendering',
            'in',
            'in2',
            'k',
            'k1',
            'k2',
            'k3',
            'k4',
            'kerning',
            'keypoints',
            'keysplines',
            'keytimes',
            'lang',
            'lengthadjust',
            'letter-spacing',
            'kernelmatrix',
            'kernelunitlength',
            'lighting-color',
            'local',
            'marker-end',
            'marker-mid',
            'marker-start',
            'markerheight',
            'markerunits',
            'markerwidth',
            'maskcontentunits',
            'maskunits',
            'max',
            'mask',
            'media',
            'method',
            'mode',
            'min',
            'name',
            'numoctaves',
            'offset',
            'operator',
            'opacity',
            'order',
            'orient',
            'orientation',
            'origin',
            'overflow',
            'paint-order',
            'path',
            'pathlength',
            'patterncontentunits',
            'patterntransform',
            'patternunits',
            'points',
            'preservealpha',
            'preserveaspectratio',
            'primitiveunits',
            'r',
            'rx',
            'ry',
            'radius',
            'refx',
            'refy',
            'repeatcount',
            'repeatdur',
            'restart',
            'result',
            'rotate',
            'scale',
            'seed',
            'shape-rendering',
            'specularconstant',
            'specularexponent',
            'spreadmethod',
            'startoffset',
            'stddeviation',
            'stitchtiles',
            'stop-color',
            'stop-opacity',
            'stroke-dasharray',
            'stroke-dashoffset',
            'stroke-linecap',
            'stroke-linejoin',
            'stroke-miterlimit',
            'stroke-opacity',
            'stroke',
            'stroke-width',
            'style',
            'surfacescale',
            'systemlanguage',
            'tabindex',
            'targetx',
            'targety',
            'transform',
            'transform-origin',
            'text-anchor',
            'text-decoration',
            'text-rendering',
            'textlength',
            'type',
            'u1',
            'u2',
            'unicode',
            'values',
            'viewbox',
            'visibility',
            'version',
            'vert-adv-y',
            'vert-origin-x',
            'vert-origin-y',
            'width',
            'word-spacing',
            'wrap',
            'writing-mode',
            'xchannelselector',
            'ychannelselector',
            'x',
            'x1',
            'x2',
            'xmlns',
            'y',
            'y1',
            'y2',
            'z',
            'zoomandpan'
        ]);
        var mathMl = freeze([
            'accent',
            'accentunder',
            'align',
            'bevelled',
            'close',
            'columnsalign',
            'columnlines',
            'columnspan',
            'denomalign',
            'depth',
            'dir',
            'display',
            'displaystyle',
            'encoding',
            'fence',
            'frame',
            'height',
            'href',
            'id',
            'largeop',
            'length',
            'linethickness',
            'lspace',
            'lquote',
            'mathbackground',
            'mathcolor',
            'mathsize',
            'mathvariant',
            'maxsize',
            'minsize',
            'movablelimits',
            'notation',
            'numalign',
            'open',
            'rowalign',
            'rowlines',
            'rowspacing',
            'rowspan',
            'rspace',
            'rquote',
            'scriptlevel',
            'scriptminsize',
            'scriptsizemultiplier',
            'selection',
            'separator',
            'separators',
            'stretchy',
            'subscriptshift',
            'supscriptshift',
            'symmetric',
            'voffset',
            'width',
            'xmlns'
        ]);
        var xml = freeze([
            'xlink:href',
            'xml:id',
            'xlink:title',
            'xml:space',
            'xmlns:xlink'
        ]);
        var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
        var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
        var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
        var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
        var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
        var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
        var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
        var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
        var DOCTYPE_NAME = seal(/^html$/i);
        var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
        var getGlobal = function getGlobal() {
            return typeof window === 'undefined' ? null : window;
        };
        var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
            if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
            var suffix = null;
            var ATTR_NAME = 'data-tt-policy-suffix';
            if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
            var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
            try {
                return trustedTypes.createPolicy(policyName, {
                    createHTML: function createHTML(html) {
                        return html;
                    },
                    createScriptURL: function createScriptURL(scriptUrl) {
                        return scriptUrl;
                    }
                });
            } catch (_) {
                console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
                return null;
            }
        };
        function createDOMPurify() {
            var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
            var DOMPurify = function DOMPurify(root) {
                return createDOMPurify(root);
            };
            DOMPurify.version = '2.5.7';
            DOMPurify.removed = [];
            if (!window1 || !window1.document || window1.document.nodeType !== 9) {
                DOMPurify.isSupported = false;
                return DOMPurify;
            }
            var originalDocument = window1.document;
            var document = window1.document;
            var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
            var ElementPrototype = Element.prototype;
            var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
            var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
            var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
            var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
            if (typeof HTMLTemplateElement === 'function') {
                var template = document.createElement('template');
                if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
            }
            var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
            var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
            var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
            var importNode = originalDocument.importNode;
            var documentMode = {};
            try {
                documentMode = clone(document).documentMode ? document.documentMode : {};
            } catch (_) {}
            var hooks = {};
            DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
            var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
            var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
            var ALLOWED_TAGS = null;
            var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
            var ALLOWED_ATTR = null;
            var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
            var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
                tagNameCheck: {
                    writable: true,
                    configurable: false,
                    enumerable: true,
                    value: null
                },
                attributeNameCheck: {
                    writable: true,
                    configurable: false,
                    enumerable: true,
                    value: null
                },
                allowCustomizedBuiltInElements: {
                    writable: true,
                    configurable: false,
                    enumerable: true,
                    value: false
                }
            }));
            var FORBID_TAGS = null;
            var FORBID_ATTR = null;
            var ALLOW_ARIA_ATTR = true;
            var ALLOW_DATA_ATTR = true;
            var ALLOW_UNKNOWN_PROTOCOLS = false;
            var ALLOW_SELF_CLOSE_IN_ATTR = true;
            var SAFE_FOR_TEMPLATES = false;
            var SAFE_FOR_XML = true;
            var WHOLE_DOCUMENT = false;
            var SET_CONFIG = false;
            var FORCE_BODY = false;
            var RETURN_DOM = false;
            var RETURN_DOM_FRAGMENT = false;
            var RETURN_TRUSTED_TYPE = false;
            var SANITIZE_DOM = true;
            var SANITIZE_NAMED_PROPS = false;
            var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
            var KEEP_CONTENT = true;
            var IN_PLACE = false;
            var USE_PROFILES = {};
            var FORBID_CONTENTS = null;
            var DEFAULT_FORBID_CONTENTS = addToSet({}, [
                'annotation-xml',
                'audio',
                'colgroup',
                'desc',
                'foreignobject',
                'head',
                'iframe',
                'math',
                'mi',
                'mn',
                'mo',
                'ms',
                'mtext',
                'noembed',
                'noframes',
                'noscript',
                'plaintext',
                'script',
                'style',
                'svg',
                'template',
                'thead',
                'title',
                'video',
                'xmp'
            ]);
            var DATA_URI_TAGS = null;
            var DEFAULT_DATA_URI_TAGS = addToSet({}, [
                'audio',
                'video',
                'img',
                'source',
                'image',
                'track'
            ]);
            var URI_SAFE_ATTRIBUTES = null;
            var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
                'alt',
                'class',
                'for',
                'id',
                'label',
                'name',
                'pattern',
                'placeholder',
                'role',
                'summary',
                'title',
                'value',
                'style',
                'xmlns'
            ]);
            var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
            var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
            var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
            var NAMESPACE = HTML_NAMESPACE;
            var IS_EMPTY_INPUT = false;
            var ALLOWED_NAMESPACES = null;
            var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
                MATHML_NAMESPACE,
                SVG_NAMESPACE,
                HTML_NAMESPACE
            ], stringToString);
            var PARSER_MEDIA_TYPE;
            var SUPPORTED_PARSER_MEDIA_TYPES = [
                'application/xhtml+xml',
                'text/html'
            ];
            var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
            var transformCaseFunc;
            var CONFIG = null;
            var formElement = document.createElement('form');
            var isRegexOrFunction = function isRegexOrFunction(testValue) {
                return testValue instanceof RegExp || testValue instanceof Function;
            };
            var _parseConfig = function _parseConfig(cfg) {
                if (CONFIG && CONFIG === cfg) return;
                if (!cfg || _typeof(cfg) !== 'object') cfg = {};
                cfg = clone(cfg);
                PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
                transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
                ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
                ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
                ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
                URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
                DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
                FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
                FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
                FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
                USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
                ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
                ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
                ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
                ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
                SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
                SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
                WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
                RETURN_DOM = cfg.RETURN_DOM || false;
                RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
                RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
                FORCE_BODY = cfg.FORCE_BODY || false;
                SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
                SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
                KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
                IN_PLACE = cfg.IN_PLACE || false;
                IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
                NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
                CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
                if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
                if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
                if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
                if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
                if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
                if (USE_PROFILES) {
                    ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                    ALLOWED_ATTR = [];
                    if (USE_PROFILES.html === true) {
                        addToSet(ALLOWED_TAGS, html$1);
                        addToSet(ALLOWED_ATTR, html);
                    }
                    if (USE_PROFILES.svg === true) {
                        addToSet(ALLOWED_TAGS, svg$1);
                        addToSet(ALLOWED_ATTR, svg);
                        addToSet(ALLOWED_ATTR, xml);
                    }
                    if (USE_PROFILES.svgFilters === true) {
                        addToSet(ALLOWED_TAGS, svgFilters);
                        addToSet(ALLOWED_ATTR, svg);
                        addToSet(ALLOWED_ATTR, xml);
                    }
                    if (USE_PROFILES.mathMl === true) {
                        addToSet(ALLOWED_TAGS, mathMl$1);
                        addToSet(ALLOWED_ATTR, mathMl);
                        addToSet(ALLOWED_ATTR, xml);
                    }
                }
                if (cfg.ADD_TAGS) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
                if (cfg.ADD_ATTR) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
                if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
                if (cfg.FORBID_CONTENTS) {
                    if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                    addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
                }
                if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
                if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                    'html',
                    'head',
                    'body'
                ]);
                if (ALLOWED_TAGS.table) {
                    addToSet(ALLOWED_TAGS, [
                        'tbody'
                    ]);
                    delete FORBID_TAGS.tbody;
                }
                if (freeze) freeze(cfg);
                CONFIG = cfg;
            };
            var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
                'mi',
                'mo',
                'mn',
                'ms',
                'mtext'
            ]);
            var HTML_INTEGRATION_POINTS = addToSet({}, [
                'annotation-xml'
            ]);
            var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
                'title',
                'style',
                'font',
                'a',
                'script'
            ]);
            var ALL_SVG_TAGS = addToSet({}, svg$1);
            addToSet(ALL_SVG_TAGS, svgFilters);
            addToSet(ALL_SVG_TAGS, svgDisallowed);
            var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
            addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
            var _checkValidNamespace = function _checkValidNamespace(element) {
                var parent = getParentNode(element);
                if (!parent || !parent.tagName) parent = {
                    namespaceURI: NAMESPACE,
                    tagName: 'template'
                };
                var tagName = stringToLowerCase(element.tagName);
                var parentTagName = stringToLowerCase(parent.tagName);
                if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
                if (element.namespaceURI === SVG_NAMESPACE) {
                    if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                    if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                    return Boolean(ALL_SVG_TAGS[tagName]);
                }
                if (element.namespaceURI === MATHML_NAMESPACE) {
                    if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                    if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                    return Boolean(ALL_MATHML_TAGS[tagName]);
                }
                if (element.namespaceURI === HTML_NAMESPACE) {
                    if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                    if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                    return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
                }
                if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
                return false;
            };
            var _forceRemove = function _forceRemove(node) {
                arrayPush(DOMPurify.removed, {
                    element: node
                });
                try {
                    node.parentNode.removeChild(node);
                } catch (_) {
                    try {
                        node.outerHTML = emptyHTML;
                    } catch (_) {
                        node.remove();
                    }
                }
            };
            var _removeAttribute = function _removeAttribute(name, node) {
                try {
                    arrayPush(DOMPurify.removed, {
                        attribute: node.getAttributeNode(name),
                        from: node
                    });
                } catch (_) {
                    arrayPush(DOMPurify.removed, {
                        attribute: null,
                        from: node
                    });
                }
                node.removeAttribute(name);
                if (name === 'is' && !ALLOWED_ATTR[name]) {
                    if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                        _forceRemove(node);
                    } catch (_) {}
                    else try {
                        node.setAttribute(name, '');
                    } catch (_) {}
                }
            };
            var _initDocument = function _initDocument(dirty) {
                var doc;
                var leadingWhitespace;
                if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
                else {
                    var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                    leadingWhitespace = matches && matches[0];
                }
                if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
                var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
                if (NAMESPACE === HTML_NAMESPACE) try {
                    doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
                } catch (_) {}
                if (!doc || !doc.documentElement) {
                    doc = implementation.createDocument(NAMESPACE, 'template', null);
                    try {
                        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                    } catch (_) {}
                }
                var body = doc.body || doc.documentElement;
                if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
                if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
                return WHOLE_DOCUMENT ? doc.documentElement : body;
            };
            var _createIterator = function _createIterator(root) {
                return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
            };
            var _isClobbered = function _isClobbered(elm) {
                return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
            };
            var _isNode = function _isNode(object) {
                return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
            };
            var _executeHook = function _executeHook(entryPoint, currentNode, data) {
                if (!hooks[entryPoint]) return;
                arrayForEach(hooks[entryPoint], function(hook) {
                    hook.call(DOMPurify, currentNode, data, CONFIG);
                });
            };
            var _sanitizeElements = function _sanitizeElements(currentNode) {
                var content;
                _executeHook('beforeSanitizeElements', currentNode, null);
                if (_isClobbered(currentNode)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                    _forceRemove(currentNode);
                    return true;
                }
                var tagName = transformCaseFunc(currentNode.nodeName);
                _executeHook('uponSanitizeElement', currentNode, {
                    tagName: tagName,
                    allowedTags: ALLOWED_TAGS
                });
                if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (currentNode.nodeType === 7) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                    if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                    }
                    if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                        var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                        var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                        if (childNodes && parentNode) {
                            var childCount = childNodes.length;
                            for(var i = childCount - 1; i >= 0; --i){
                                var childClone = cloneNode(childNodes[i], true);
                                childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                                parentNode.insertBefore(childClone, getNextSibling(currentNode));
                            }
                        }
                    }
                    _forceRemove(currentNode);
                    return true;
                }
                if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                    _forceRemove(currentNode);
                    return true;
                }
                if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                    content = currentNode.textContent;
                    content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                    content = stringReplace(content, ERB_EXPR$1, ' ');
                    content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                    if (currentNode.textContent !== content) {
                        arrayPush(DOMPurify.removed, {
                            element: currentNode.cloneNode()
                        });
                        currentNode.textContent = content;
                    }
                }
                _executeHook('afterSanitizeElements', currentNode, null);
                return false;
            };
            var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
                if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
                if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
                else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
                else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                    if (_basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                    else return false;
                } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
                else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
                else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
                else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
                else if (value) return false;
                return true;
            };
            var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
                return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
            };
            var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
                var attr;
                var value;
                var lcName;
                var l;
                _executeHook('beforeSanitizeAttributes', currentNode, null);
                var attributes = currentNode.attributes;
                if (!attributes) return;
                var hookEvent = {
                    attrName: '',
                    attrValue: '',
                    keepAttr: true,
                    allowedAttributes: ALLOWED_ATTR
                };
                l = attributes.length;
                while(l--){
                    attr = attributes[l];
                    var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                    value = name === 'value' ? attr.value : stringTrim(attr.value);
                    lcName = transformCaseFunc(name);
                    hookEvent.attrName = lcName;
                    hookEvent.attrValue = value;
                    hookEvent.keepAttr = true;
                    hookEvent.forceKeepAttr = undefined;
                    _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                    value = hookEvent.attrValue;
                    if (hookEvent.forceKeepAttr) continue;
                    _removeAttribute(name, currentNode);
                    if (!hookEvent.keepAttr) continue;
                    if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                        _removeAttribute(name, currentNode);
                        continue;
                    }
                    if (SAFE_FOR_TEMPLATES) {
                        value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                        value = stringReplace(value, ERB_EXPR$1, ' ');
                        value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                    }
                    var lcTag = transformCaseFunc(currentNode.nodeName);
                    if (!_isValidAttribute(lcTag, lcName, value)) continue;
                    if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                        _removeAttribute(name, currentNode);
                        value = SANITIZE_NAMED_PROPS_PREFIX + value;
                    }
                    if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                        _removeAttribute(name, currentNode);
                        continue;
                    }
                    if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                        if (namespaceURI) ;
                        else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                            case 'TrustedHTML':
                                value = trustedTypesPolicy.createHTML(value);
                                break;
                            case 'TrustedScriptURL':
                                value = trustedTypesPolicy.createScriptURL(value);
                                break;
                        }
                    }
                    try {
                        if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                        else currentNode.setAttribute(name, value);
                        if (_isClobbered(currentNode)) _forceRemove(currentNode);
                        else arrayPop(DOMPurify.removed);
                    } catch (_) {}
                }
                _executeHook('afterSanitizeAttributes', currentNode, null);
            };
            var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
                var shadowNode;
                var shadowIterator = _createIterator(fragment);
                _executeHook('beforeSanitizeShadowDOM', fragment, null);
                while(shadowNode = shadowIterator.nextNode()){
                    _executeHook('uponSanitizeShadowNode', shadowNode, null);
                    if (_sanitizeElements(shadowNode)) continue;
                    if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                    _sanitizeAttributes(shadowNode);
                }
                _executeHook('afterSanitizeShadowDOM', fragment, null);
            };
            DOMPurify.sanitize = function(dirty) {
                var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var body;
                var importedNode;
                var currentNode;
                var oldNode;
                var returnNode;
                IS_EMPTY_INPUT = !dirty;
                if (IS_EMPTY_INPUT) dirty = '<!-->';
                if (typeof dirty !== 'string' && !_isNode(dirty)) {
                    if (typeof dirty.toString === 'function') {
                        dirty = dirty.toString();
                        if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                    } else throw typeErrorCreate('toString is not a function');
                }
                if (!DOMPurify.isSupported) {
                    if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                        if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                        if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                    }
                    return dirty;
                }
                if (!SET_CONFIG) _parseConfig(cfg);
                DOMPurify.removed = [];
                if (typeof dirty === 'string') IN_PLACE = false;
                if (IN_PLACE) {
                    if (dirty.nodeName) {
                        var tagName = transformCaseFunc(dirty.nodeName);
                        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                    }
                } else if (dirty instanceof Node) {
                    body = _initDocument('<!---->');
                    importedNode = body.ownerDocument.importNode(dirty, true);
                    if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') body = importedNode;
                    else if (importedNode.nodeName === 'HTML') body = importedNode;
                    else body.appendChild(importedNode);
                } else {
                    if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                    body = _initDocument(dirty);
                    if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
                }
                if (body && FORCE_BODY) _forceRemove(body.firstChild);
                var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
                while(currentNode = nodeIterator.nextNode()){
                    if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                    if (_sanitizeElements(currentNode)) continue;
                    if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                    _sanitizeAttributes(currentNode);
                    oldNode = currentNode;
                }
                oldNode = null;
                if (IN_PLACE) return dirty;
                if (RETURN_DOM) {
                    if (RETURN_DOM_FRAGMENT) {
                        returnNode = createDocumentFragment.call(body.ownerDocument);
                        while(body.firstChild)returnNode.appendChild(body.firstChild);
                    } else returnNode = body;
                    if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) returnNode = importNode.call(originalDocument, returnNode, true);
                    return returnNode;
                }
                var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
                if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
                if (SAFE_FOR_TEMPLATES) {
                    serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                    serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                    serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
                }
                return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
            };
            DOMPurify.setConfig = function(cfg) {
                _parseConfig(cfg);
                SET_CONFIG = true;
            };
            DOMPurify.clearConfig = function() {
                CONFIG = null;
                SET_CONFIG = false;
            };
            DOMPurify.isValidAttribute = function(tag, attr, value) {
                if (!CONFIG) _parseConfig({});
                var lcTag = transformCaseFunc(tag);
                var lcName = transformCaseFunc(attr);
                return _isValidAttribute(lcTag, lcName, value);
            };
            DOMPurify.addHook = function(entryPoint, hookFunction) {
                if (typeof hookFunction !== 'function') return;
                hooks[entryPoint] = hooks[entryPoint] || [];
                arrayPush(hooks[entryPoint], hookFunction);
            };
            DOMPurify.removeHook = function(entryPoint) {
                if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
            };
            DOMPurify.removeHooks = function(entryPoint) {
                if (hooks[entryPoint]) hooks[entryPoint] = [];
            };
            DOMPurify.removeAllHooks = function() {
                hooks = {};
            };
            return DOMPurify;
        }
        var purify = createDOMPurify();
        return purify;
    });
});
parcelRegister("7SUn6", function(module, exports) {
    $parcel$export(module.exports, "GRAPH_ACTION_TYPES", ()=>$f90f361440644135$export$a53d967d2b838a48);
    $parcel$export(module.exports, "GRAPH_EVENT_TYPES", ()=>$f90f361440644135$export$226af313a4ea871b);
    const $f90f361440644135$export$a53d967d2b838a48 = {
        HIGHLIGHT_SELECTED_POINT: 'highlight',
        DOWNPLAY_STALE_POINT: 'downplay',
        SHOW_TOOL_TIP: 'showTip',
        HIDE_TIP: 'hideTip'
    };
    const $f90f361440644135$export$226af313a4ea871b = {
        CLICK: 'click',
        MOUSE_OVER: 'mouseover',
        MOUSE_OUT: 'mouseout'
    };
});
parcelRegister("61iTG", function(module, exports) {
    $parcel$export(module.exports, "formatTooltip", ()=>$c89ec9eec217bdd6$export$4f4aa504c717f7cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hXLCJ = parcelRequire("hXLCJ");
    var $8QpSo;
    var $9joA7 = parcelRequire("9joA7");
    var $bLDEj;
    var $gwIPs;
    var $9nenm;
    var $cnldZ;
    var $dVijb;
    const $c89ec9eec217bdd6$var$getCalendarIcon = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, $9joA7.renderToStaticMarkup)((0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bLDEj"))))), {
            label: "",
            primaryColor: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$exports).N50})`,
            size: "medium"
        })));
    const $c89ec9eec217bdd6$var$getYAxisValue = (intl, { data: data })=>(0, (0, parcelRequire("cnldZ")).getFormattedLabel)(data.valueType, data.value, intl.formatMessage);
    const $c89ec9eec217bdd6$export$9cf787c92908daee = (intl, points)=>points.map((point)=>`${point.marker} ${$c89ec9eec217bdd6$var$getYAxisValue(intl, point)} - ${(0, ($parcel$interopDefault($hXLCJ))).sanitize(point.seriesName)}`).join('<br />');
    const $c89ec9eec217bdd6$export$4f4aa504c717f7cb = (intl, points, searchBy)=>`<div style="padding: ${0, (0, parcelRequire("gwIPs")).gridSize}px;
                border-radius: ${(0, (0, parcelRequire("gwIPs")).gridSize) * 0.375}px;">
                <span style="display: flex;align-items: center;">
                    ${$c89ec9eec217bdd6$var$getCalendarIcon()}
                    <span style="font-size:${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px; align-self: flex-end;">
                        ${searchBy === (0, (0, parcelRequire("9nenm")).SEARCH_BY).weekly ? intl.formatMessage((0, (0, parcelRequire("dVijb")).default).weekStartingLabel, {
            formattedDate: points[0].data.formattedDate
        }) : points[0].data.formattedDate}
                    </span>
                </span>
                <br />
                ${$c89ec9eec217bdd6$export$9cf787c92908daee(intl, points)}
            </div>
            `;
});
parcelRegister("9joA7", function(module, exports) {
    $parcel$export(module.exports, "version", ()=>$6c78f4cae7505685$export$83d89fbfd8236492, (v)=>$6c78f4cae7505685$export$83d89fbfd8236492 = v);
    $parcel$export(module.exports, "renderToString", ()=>$6c78f4cae7505685$export$80e7718417253a51, (v)=>$6c78f4cae7505685$export$80e7718417253a51 = v);
    $parcel$export(module.exports, "renderToStaticMarkup", ()=>$6c78f4cae7505685$export$eb3a06aef9e6ee51, (v)=>$6c78f4cae7505685$export$eb3a06aef9e6ee51 = v);
    $parcel$export(module.exports, "renderToNodeStream", ()=>$6c78f4cae7505685$export$307591e98609eddd, (v)=>$6c78f4cae7505685$export$307591e98609eddd = v);
    $parcel$export(module.exports, "renderToStaticNodeStream", ()=>$6c78f4cae7505685$export$b23711c915539651, (v)=>$6c78f4cae7505685$export$b23711c915539651 = v);
    $parcel$export(module.exports, "renderToReadableStream", ()=>$6c78f4cae7505685$export$7020a3240b287705, (v)=>$6c78f4cae7505685$export$7020a3240b287705 = v);
    var $6c78f4cae7505685$export$83d89fbfd8236492;
    var $6c78f4cae7505685$export$80e7718417253a51;
    var $6c78f4cae7505685$export$eb3a06aef9e6ee51;
    var $6c78f4cae7505685$export$307591e98609eddd;
    var $6c78f4cae7505685$export$b23711c915539651;
    var $6c78f4cae7505685$export$7020a3240b287705;
    'use strict';
    var $6c78f4cae7505685$var$l, $6c78f4cae7505685$var$s;
    $6c78f4cae7505685$var$l = (parcelRequire("6aMuy"));
    $6c78f4cae7505685$var$s = (parcelRequire("l7JfX"));
    $6c78f4cae7505685$export$83d89fbfd8236492 = $6c78f4cae7505685$var$l.version;
    $6c78f4cae7505685$export$80e7718417253a51 = $6c78f4cae7505685$var$l.renderToString;
    $6c78f4cae7505685$export$eb3a06aef9e6ee51 = $6c78f4cae7505685$var$l.renderToStaticMarkup;
    $6c78f4cae7505685$export$307591e98609eddd = $6c78f4cae7505685$var$l.renderToNodeStream;
    $6c78f4cae7505685$export$b23711c915539651 = $6c78f4cae7505685$var$l.renderToStaticNodeStream;
    $6c78f4cae7505685$export$7020a3240b287705 = $6c78f4cae7505685$var$s.renderToReadableStream;
});
parcelRegister("6aMuy", function(module, exports) {
    $parcel$export(module.exports, "renderToNodeStream", ()=>$47e94abb28b53633$export$307591e98609eddd, (v)=>$47e94abb28b53633$export$307591e98609eddd = v);
    $parcel$export(module.exports, "renderToStaticMarkup", ()=>$47e94abb28b53633$export$eb3a06aef9e6ee51, (v)=>$47e94abb28b53633$export$eb3a06aef9e6ee51 = v);
    $parcel$export(module.exports, "renderToStaticNodeStream", ()=>$47e94abb28b53633$export$b23711c915539651, (v)=>$47e94abb28b53633$export$b23711c915539651 = v);
    $parcel$export(module.exports, "renderToString", ()=>$47e94abb28b53633$export$80e7718417253a51, (v)=>$47e94abb28b53633$export$80e7718417253a51 = v);
    $parcel$export(module.exports, "version", ()=>$47e94abb28b53633$export$83d89fbfd8236492, (v)=>$47e94abb28b53633$export$83d89fbfd8236492 = v);
    var $47e94abb28b53633$export$307591e98609eddd;
    var $47e94abb28b53633$export$eb3a06aef9e6ee51;
    var $47e94abb28b53633$export$b23711c915539651;
    var $47e94abb28b53633$export$80e7718417253a51;
    var $47e94abb28b53633$export$83d89fbfd8236492;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    function $47e94abb28b53633$var$l(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var $47e94abb28b53633$var$p = Object.prototype.hasOwnProperty, $47e94abb28b53633$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $47e94abb28b53633$var$ha = {}, $47e94abb28b53633$var$ia = {};
    function $47e94abb28b53633$var$ja(a) {
        if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ia, a)) return !0;
        if ($47e94abb28b53633$var$p.call($47e94abb28b53633$var$ha, a)) return !1;
        if ($47e94abb28b53633$var$fa.test(a)) return $47e94abb28b53633$var$ia[a] = !0;
        $47e94abb28b53633$var$ha[a] = !0;
        return !1;
    }
    function $47e94abb28b53633$var$r(a, b, c, d, f, e, g) {
        this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
        this.attributeName = d;
        this.attributeNamespace = f;
        this.mustUseProperty = c;
        this.propertyName = a;
        this.type = b;
        this.sanitizeURL = e;
        this.removeEmptyString = g;
    }
    var $47e94abb28b53633$var$t = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 0, !1, a, null, !1, !1);
    });
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(a) {
        var b = a[0];
        $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a[1], null, !1, !1);
    });
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
    });
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 2, !1, a, null, !1, !1);
    });
    "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
    });
    [
        "checked",
        "multiple",
        "muted",
        "selected"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 3, !0, a, null, !1, !1);
    });
    [
        "capture",
        "download"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 4, !1, a, null, !1, !1);
    });
    [
        "cols",
        "rows",
        "size",
        "span"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 6, !1, a, null, !1, !1);
    });
    [
        "rowSpan",
        "start"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
    });
    var $47e94abb28b53633$var$ka = /[\-:]([a-z])/g;
    function $47e94abb28b53633$var$la(a) {
        return a[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
        var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
        $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, null, !1, !1);
    });
    "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
        var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
        $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
    });
    [
        "xml:base",
        "xml:lang",
        "xml:space"
    ].forEach(function(a) {
        var b = a.replace($47e94abb28b53633$var$ka, $47e94abb28b53633$var$la);
        $47e94abb28b53633$var$t[b] = new $47e94abb28b53633$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
    });
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
    });
    $47e94abb28b53633$var$t.xlinkHref = new $47e94abb28b53633$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(a) {
        $47e94abb28b53633$var$t[a] = new $47e94abb28b53633$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
    });
    var $47e94abb28b53633$var$u = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
    }, $47e94abb28b53633$var$ma = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ];
    Object.keys($47e94abb28b53633$var$u).forEach(function(a) {
        $47e94abb28b53633$var$ma.forEach(function(b) {
            b = b + a.charAt(0).toUpperCase() + a.substring(1);
            $47e94abb28b53633$var$u[b] = $47e94abb28b53633$var$u[a];
        });
    });
    var $47e94abb28b53633$var$na = /["'&<>]/;
    function $47e94abb28b53633$var$v(a) {
        if ("boolean" === typeof a || "number" === typeof a) return "" + a;
        a = "" + a;
        var b = $47e94abb28b53633$var$na.exec(a);
        if (b) {
            var c = "", d, f = 0;
            for(d = b.index; d < a.length; d++){
                switch(a.charCodeAt(d)){
                    case 34:
                        b = "&quot;";
                        break;
                    case 38:
                        b = "&amp;";
                        break;
                    case 39:
                        b = "&#x27;";
                        break;
                    case 60:
                        b = "&lt;";
                        break;
                    case 62:
                        b = "&gt;";
                        break;
                    default:
                        continue;
                }
                f !== d && (c += a.substring(f, d));
                f = d + 1;
                c += b;
            }
            a = f !== d ? c + a.substring(f, d) : c;
        }
        return a;
    }
    var $47e94abb28b53633$var$oa = /([A-Z])/g, $47e94abb28b53633$var$pa = /^ms-/, $47e94abb28b53633$var$qa = Array.isArray;
    function $47e94abb28b53633$var$w(a, b) {
        return {
            insertionMode: a,
            selectedValue: b
        };
    }
    function $47e94abb28b53633$var$ra(a, b, c) {
        switch(b){
            case "select":
                return $47e94abb28b53633$var$w(1, null != c.value ? c.value : c.defaultValue);
            case "svg":
                return $47e94abb28b53633$var$w(2, null);
            case "math":
                return $47e94abb28b53633$var$w(3, null);
            case "foreignObject":
                return $47e94abb28b53633$var$w(1, null);
            case "table":
                return $47e94abb28b53633$var$w(4, null);
            case "thead":
            case "tbody":
            case "tfoot":
                return $47e94abb28b53633$var$w(5, null);
            case "colgroup":
                return $47e94abb28b53633$var$w(7, null);
            case "tr":
                return $47e94abb28b53633$var$w(6, null);
        }
        return 4 <= a.insertionMode || 0 === a.insertionMode ? $47e94abb28b53633$var$w(1, null) : a;
    }
    var $47e94abb28b53633$var$sa = new Map;
    function $47e94abb28b53633$var$ta(a, b, c) {
        if ("object" !== typeof c) throw Error($47e94abb28b53633$var$l(62));
        b = !0;
        for(var d in c)if ($47e94abb28b53633$var$p.call(c, d)) {
            var f = c[d];
            if (null != f && "boolean" !== typeof f && "" !== f) {
                if (0 === d.indexOf("--")) {
                    var e = $47e94abb28b53633$var$v(d);
                    f = $47e94abb28b53633$var$v(("" + f).trim());
                } else {
                    e = d;
                    var g = $47e94abb28b53633$var$sa.get(e);
                    void 0 !== g ? e = g : (g = $47e94abb28b53633$var$v(e.replace($47e94abb28b53633$var$oa, "-$1").toLowerCase().replace($47e94abb28b53633$var$pa, "-ms-")), $47e94abb28b53633$var$sa.set(e, g), e = g);
                    f = "number" === typeof f ? 0 === f || $47e94abb28b53633$var$p.call($47e94abb28b53633$var$u, d) ? "" + f : f + "px" : $47e94abb28b53633$var$v(("" + f).trim());
                }
                b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
            }
        }
        b || a.push('"');
    }
    function $47e94abb28b53633$var$x(a, b, c, d) {
        switch(c){
            case "style":
                $47e94abb28b53633$var$ta(a, b, d);
                return;
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
                return;
        }
        if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
            if (b = $47e94abb28b53633$var$t.hasOwnProperty(c) ? $47e94abb28b53633$var$t[c] : null, null !== b) {
                switch(typeof d){
                    case "function":
                    case "symbol":
                        return;
                    case "boolean":
                        if (!b.acceptsBooleans) return;
                }
                c = b.attributeName;
                switch(b.type){
                    case 3:
                        d && a.push(" ", c, '=""');
                        break;
                    case 4:
                        !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                        break;
                    case 5:
                        isNaN(d) || a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                        break;
                    case 6:
                        !isNaN(d) && 1 <= d && a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                        break;
                    default:
                        b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
                }
            } else if ($47e94abb28b53633$var$ja(c)) {
                switch(typeof d){
                    case "function":
                    case "symbol":
                        return;
                    case "boolean":
                        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
                }
                a.push(" ", c, '="', $47e94abb28b53633$var$v(d), '"');
            }
        }
    }
    function $47e94abb28b53633$var$y(a, b, c) {
        if (null != b) {
            if (null != c) throw Error($47e94abb28b53633$var$l(60));
            if ("object" !== typeof b || !("__html" in b)) throw Error($47e94abb28b53633$var$l(61));
            b = b.__html;
            null !== b && void 0 !== b && a.push("" + b);
        }
    }
    function $47e94abb28b53633$var$ua(a) {
        var b = "";
        $5uXOq.Children.forEach(a, function(a) {
            null != a && (b += a);
        });
        return b;
    }
    function $47e94abb28b53633$var$va(a, b, c, d) {
        a.push($47e94abb28b53633$var$A(c));
        var f = c = null, e;
        for(e in b)if ($47e94abb28b53633$var$p.call(b, e)) {
            var g = b[e];
            if (null != g) switch(e){
                case "children":
                    c = g;
                    break;
                case "dangerouslySetInnerHTML":
                    f = g;
                    break;
                default:
                    $47e94abb28b53633$var$x(a, d, e, g);
            }
        }
        a.push(">");
        $47e94abb28b53633$var$y(a, f, c);
        return "string" === typeof c ? (a.push($47e94abb28b53633$var$v(c)), null) : c;
    }
    var $47e94abb28b53633$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $47e94abb28b53633$var$xa = new Map;
    function $47e94abb28b53633$var$A(a) {
        var b = $47e94abb28b53633$var$xa.get(a);
        if (void 0 === b) {
            if (!$47e94abb28b53633$var$wa.test(a)) throw Error($47e94abb28b53633$var$l(65, a));
            b = "<" + a;
            $47e94abb28b53633$var$xa.set(a, b);
        }
        return b;
    }
    function $47e94abb28b53633$var$ya(a, b, c, d, f) {
        switch(b){
            case "select":
                a.push($47e94abb28b53633$var$A("select"));
                var e = null, g = null;
                for(n in c)if ($47e94abb28b53633$var$p.call(c, n)) {
                    var h = c[n];
                    if (null != h) switch(n){
                        case "children":
                            e = h;
                            break;
                        case "dangerouslySetInnerHTML":
                            g = h;
                            break;
                        case "defaultValue":
                        case "value":
                            break;
                        default:
                            $47e94abb28b53633$var$x(a, d, n, h);
                    }
                }
                a.push(">");
                $47e94abb28b53633$var$y(a, g, e);
                return e;
            case "option":
                g = f.selectedValue;
                a.push($47e94abb28b53633$var$A("option"));
                var k = h = null, m = null;
                var n = null;
                for(e in c)if ($47e94abb28b53633$var$p.call(c, e)) {
                    var q = c[e];
                    if (null != q) switch(e){
                        case "children":
                            h = q;
                            break;
                        case "selected":
                            m = q;
                            break;
                        case "dangerouslySetInnerHTML":
                            n = q;
                            break;
                        case "value":
                            k = q;
                        default:
                            $47e94abb28b53633$var$x(a, d, e, q);
                    }
                }
                if (null != g) {
                    if (c = null !== k ? "" + k : $47e94abb28b53633$var$ua(h), $47e94abb28b53633$var$qa(g)) {
                        for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                            a.push(' selected=""');
                            break;
                        }
                    } else "" + g === c && a.push(' selected=""');
                } else m && a.push(' selected=""');
                a.push(">");
                $47e94abb28b53633$var$y(a, n, h);
                return h;
            case "textarea":
                a.push($47e94abb28b53633$var$A("textarea"));
                n = g = e = null;
                for(h in c)if ($47e94abb28b53633$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                    case "children":
                        n = k;
                        break;
                    case "value":
                        e = k;
                        break;
                    case "defaultValue":
                        g = k;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($47e94abb28b53633$var$l(91));
                    default:
                        $47e94abb28b53633$var$x(a, d, h, k);
                }
                null === e && null !== g && (e = g);
                a.push(">");
                if (null != n) {
                    if (null != e) throw Error($47e94abb28b53633$var$l(92));
                    if ($47e94abb28b53633$var$qa(n) && 1 < n.length) throw Error($47e94abb28b53633$var$l(93));
                    e = "" + n;
                }
                "string" === typeof e && "\n" === e[0] && a.push("\n");
                null !== e && a.push($47e94abb28b53633$var$v("" + e));
                return null;
            case "input":
                a.push($47e94abb28b53633$var$A("input"));
                k = n = h = e = null;
                for(g in c)if ($47e94abb28b53633$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($47e94abb28b53633$var$l(399, "input"));
                    case "defaultChecked":
                        k = m;
                        break;
                    case "defaultValue":
                        h = m;
                        break;
                    case "checked":
                        n = m;
                        break;
                    case "value":
                        e = m;
                        break;
                    default:
                        $47e94abb28b53633$var$x(a, d, g, m);
                }
                null !== n ? $47e94abb28b53633$var$x(a, d, "checked", n) : null !== k && $47e94abb28b53633$var$x(a, d, "checked", k);
                null !== e ? $47e94abb28b53633$var$x(a, d, "value", e) : null !== h && $47e94abb28b53633$var$x(a, d, "value", h);
                a.push("/>");
                return null;
            case "menuitem":
                a.push($47e94abb28b53633$var$A("menuitem"));
                for(var C in c)if ($47e94abb28b53633$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($47e94abb28b53633$var$l(400));
                    default:
                        $47e94abb28b53633$var$x(a, d, C, e);
                }
                a.push(">");
                return null;
            case "title":
                a.push($47e94abb28b53633$var$A("title"));
                e = null;
                for(q in c)if ($47e94abb28b53633$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                    case "children":
                        e = g;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($47e94abb28b53633$var$l(434));
                    default:
                        $47e94abb28b53633$var$x(a, d, q, g);
                }
                a.push(">");
                return e;
            case "listing":
            case "pre":
                a.push($47e94abb28b53633$var$A(b));
                g = e = null;
                for(k in c)if ($47e94abb28b53633$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    default:
                        $47e94abb28b53633$var$x(a, d, k, h);
                }
                a.push(">");
                if (null != g) {
                    if (null != e) throw Error($47e94abb28b53633$var$l(60));
                    if ("object" !== typeof g || !("__html" in g)) throw Error($47e94abb28b53633$var$l(61));
                    c = g.__html;
                    null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
                }
                "string" === typeof e && "\n" === e[0] && a.push("\n");
                return e;
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                a.push($47e94abb28b53633$var$A(b));
                for(var D in c)if ($47e94abb28b53633$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($47e94abb28b53633$var$l(399, b));
                    default:
                        $47e94abb28b53633$var$x(a, d, D, e);
                }
                a.push("/>");
                return null;
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return $47e94abb28b53633$var$va(a, c, b, d);
            case "html":
                return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $47e94abb28b53633$var$va(a, c, b, d);
            default:
                if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $47e94abb28b53633$var$va(a, c, b, d);
                a.push($47e94abb28b53633$var$A(b));
                g = e = null;
                for(m in c)if ($47e94abb28b53633$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "style":
                        $47e94abb28b53633$var$ta(a, d, h);
                        break;
                    case "suppressContentEditableWarning":
                    case "suppressHydrationWarning":
                        break;
                    default:
                        $47e94abb28b53633$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $47e94abb28b53633$var$v(h), '"');
                }
                a.push(">");
                $47e94abb28b53633$var$y(a, g, e);
                return e;
        }
    }
    function $47e94abb28b53633$var$za(a, b, c) {
        a.push('\x3c!--$?--\x3e<template id="');
        if (null === c) throw Error($47e94abb28b53633$var$l(395));
        a.push(c);
        return a.push('"></template>');
    }
    function $47e94abb28b53633$var$Aa(a, b, c, d) {
        switch(c.insertionMode){
            case 0:
            case 1:
                return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 2:
                return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 3:
                return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 4:
                return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 5:
                return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 6:
                return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            case 7:
                return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
            default:
                throw Error($47e94abb28b53633$var$l(397));
        }
    }
    function $47e94abb28b53633$var$Ba(a, b) {
        switch(b.insertionMode){
            case 0:
            case 1:
                return a.push("</div>");
            case 2:
                return a.push("</svg>");
            case 3:
                return a.push("</math>");
            case 4:
                return a.push("</table>");
            case 5:
                return a.push("</tbody></table>");
            case 6:
                return a.push("</tr></table>");
            case 7:
                return a.push("</colgroup></table>");
            default:
                throw Error($47e94abb28b53633$var$l(397));
        }
    }
    var $47e94abb28b53633$var$Ca = /[<\u2028\u2029]/g;
    function $47e94abb28b53633$var$Da(a) {
        return JSON.stringify(a).replace($47e94abb28b53633$var$Ca, function(a) {
            switch(a){
                case "<":
                    return "\\u003c";
                case "\u2028":
                    return "\\u2028";
                case "\u2029":
                    return "\\u2029";
                default:
                    throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
            }
        });
    }
    function $47e94abb28b53633$var$Ea(a, b) {
        b = void 0 === b ? "" : b;
        return {
            bootstrapChunks: [],
            startInlineScript: "<script>",
            placeholderPrefix: b + "P:",
            segmentPrefix: b + "S:",
            boundaryPrefix: b + "B:",
            idPrefix: b,
            nextSuspenseID: 0,
            sentCompleteSegmentFunction: !1,
            sentCompleteBoundaryFunction: !1,
            sentClientRenderFunction: !1,
            generateStaticMarkup: a
        };
    }
    function $47e94abb28b53633$var$Fa(a, b, c, d) {
        if (c.generateStaticMarkup) return a.push($47e94abb28b53633$var$v(b)), !1;
        "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($47e94abb28b53633$var$v(b)), a = !0);
        return a;
    }
    var $47e94abb28b53633$var$B = Object.assign, $47e94abb28b53633$var$Ga = Symbol.for("react.element"), $47e94abb28b53633$var$Ha = Symbol.for("react.portal"), $47e94abb28b53633$var$Ia = Symbol.for("react.fragment"), $47e94abb28b53633$var$Ja = Symbol.for("react.strict_mode"), $47e94abb28b53633$var$Ka = Symbol.for("react.profiler"), $47e94abb28b53633$var$La = Symbol.for("react.provider"), $47e94abb28b53633$var$Ma = Symbol.for("react.context"), $47e94abb28b53633$var$Na = Symbol.for("react.forward_ref"), $47e94abb28b53633$var$Oa = Symbol.for("react.suspense"), $47e94abb28b53633$var$Pa = Symbol.for("react.suspense_list"), $47e94abb28b53633$var$Qa = Symbol.for("react.memo"), $47e94abb28b53633$var$Ra = Symbol.for("react.lazy"), $47e94abb28b53633$var$Sa = Symbol.for("react.scope"), $47e94abb28b53633$var$Ta = Symbol.for("react.debug_trace_mode"), $47e94abb28b53633$var$Ua = Symbol.for("react.legacy_hidden"), $47e94abb28b53633$var$Va = Symbol.for("react.default_value"), $47e94abb28b53633$var$Wa = Symbol.iterator;
    function $47e94abb28b53633$var$Xa(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case $47e94abb28b53633$var$Ia:
                return "Fragment";
            case $47e94abb28b53633$var$Ha:
                return "Portal";
            case $47e94abb28b53633$var$Ka:
                return "Profiler";
            case $47e94abb28b53633$var$Ja:
                return "StrictMode";
            case $47e94abb28b53633$var$Oa:
                return "Suspense";
            case $47e94abb28b53633$var$Pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case $47e94abb28b53633$var$Ma:
                return (a.displayName || "Context") + ".Consumer";
            case $47e94abb28b53633$var$La:
                return (a._context.displayName || "Context") + ".Provider";
            case $47e94abb28b53633$var$Na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case $47e94abb28b53633$var$Qa:
                return b = a.displayName || null, null !== b ? b : $47e94abb28b53633$var$Xa(a.type) || "Memo";
            case $47e94abb28b53633$var$Ra:
                b = a._payload;
                a = a._init;
                try {
                    return $47e94abb28b53633$var$Xa(a(b));
                } catch (c) {}
        }
        return null;
    }
    var $47e94abb28b53633$var$Ya = {};
    function $47e94abb28b53633$var$Za(a, b) {
        a = a.contextTypes;
        if (!a) return $47e94abb28b53633$var$Ya;
        var c = {}, d;
        for(d in a)c[d] = b[d];
        return c;
    }
    var $47e94abb28b53633$var$E = null;
    function $47e94abb28b53633$var$F(a, b) {
        if (a !== b) {
            a.context._currentValue2 = a.parentValue;
            a = a.parent;
            var c = b.parent;
            if (null === a) {
                if (null !== c) throw Error($47e94abb28b53633$var$l(401));
            } else {
                if (null === c) throw Error($47e94abb28b53633$var$l(401));
                $47e94abb28b53633$var$F(a, c);
            }
            b.context._currentValue2 = b.value;
        }
    }
    function $47e94abb28b53633$var$$a(a) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        null !== a && $47e94abb28b53633$var$$a(a);
    }
    function $47e94abb28b53633$var$ab(a) {
        var b = a.parent;
        null !== b && $47e94abb28b53633$var$ab(b);
        a.context._currentValue2 = a.value;
    }
    function $47e94abb28b53633$var$bb(a, b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        if (null === a) throw Error($47e94abb28b53633$var$l(402));
        a.depth === b.depth ? $47e94abb28b53633$var$F(a, b) : $47e94abb28b53633$var$bb(a, b);
    }
    function $47e94abb28b53633$var$cb(a, b) {
        var c = b.parent;
        if (null === c) throw Error($47e94abb28b53633$var$l(402));
        a.depth === c.depth ? $47e94abb28b53633$var$F(a, c) : $47e94abb28b53633$var$cb(a, c);
        b.context._currentValue2 = b.value;
    }
    function $47e94abb28b53633$var$G(a) {
        var b = $47e94abb28b53633$var$E;
        b !== a && (null === b ? $47e94abb28b53633$var$ab(a) : null === a ? $47e94abb28b53633$var$$a(b) : b.depth === a.depth ? $47e94abb28b53633$var$F(b, a) : b.depth > a.depth ? $47e94abb28b53633$var$bb(b, a) : $47e94abb28b53633$var$cb(b, a), $47e94abb28b53633$var$E = a);
    }
    var $47e94abb28b53633$var$db = {
        isMounted: function() {
            return !1;
        },
        enqueueSetState: function(a, b) {
            a = a._reactInternals;
            null !== a.queue && a.queue.push(b);
        },
        enqueueReplaceState: function(a, b) {
            a = a._reactInternals;
            a.replace = !0;
            a.queue = [
                b
            ];
        },
        enqueueForceUpdate: function() {}
    };
    function $47e94abb28b53633$var$eb(a, b, c, d) {
        var f = void 0 !== a.state ? a.state : null;
        a.updater = $47e94abb28b53633$var$db;
        a.props = c;
        a.state = f;
        var e = {
            queue: [],
            replace: !1
        };
        a._reactInternals = e;
        var g = b.contextType;
        a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
        g = b.getDerivedStateFromProps;
        "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $47e94abb28b53633$var$B({}, f, g), a.state = f);
        if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
            if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $47e94abb28b53633$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
                if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
                else {
                    e = g ? b[0] : a.state;
                    f = !0;
                    for(g = g ? 1 : 0; g < b.length; g++){
                        var h = b[g];
                        h = "function" === typeof h ? h.call(a, e, c, d) : h;
                        null != h && (f ? (f = !1, e = $47e94abb28b53633$var$B({}, e, h)) : $47e94abb28b53633$var$B(e, h));
                    }
                    a.state = e;
                }
            } else e.queue = null;
        }
    }
    var $47e94abb28b53633$var$fb = {
        id: 1,
        overflow: ""
    };
    function $47e94abb28b53633$var$gb(a, b, c) {
        var d = a.id;
        a = a.overflow;
        var f = 32 - $47e94abb28b53633$var$H(d) - 1;
        d &= ~(1 << f);
        c += 1;
        var e = 32 - $47e94abb28b53633$var$H(b) + f;
        if (30 < e) {
            var g = f - f % 5;
            e = (d & (1 << g) - 1).toString(32);
            d >>= g;
            f -= g;
            return {
                id: 1 << 32 - $47e94abb28b53633$var$H(b) + f | c << f | d,
                overflow: e + a
            };
        }
        return {
            id: 1 << e | c << f | d,
            overflow: a
        };
    }
    var $47e94abb28b53633$var$H = Math.clz32 ? Math.clz32 : $47e94abb28b53633$var$hb, $47e94abb28b53633$var$ib = Math.log, $47e94abb28b53633$var$jb = Math.LN2;
    function $47e94abb28b53633$var$hb(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - ($47e94abb28b53633$var$ib(a) / $47e94abb28b53633$var$jb | 0) | 0;
    }
    function $47e94abb28b53633$var$kb(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var $47e94abb28b53633$var$lb = "function" === typeof Object.is ? Object.is : $47e94abb28b53633$var$kb, $47e94abb28b53633$var$I = null, $47e94abb28b53633$var$ob = null, $47e94abb28b53633$var$J = null, $47e94abb28b53633$var$K = null, $47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$O = null, $47e94abb28b53633$var$P = 0;
    function $47e94abb28b53633$var$Q() {
        if (null === $47e94abb28b53633$var$I) throw Error($47e94abb28b53633$var$l(321));
        return $47e94abb28b53633$var$I;
    }
    function $47e94abb28b53633$var$pb() {
        if (0 < $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(312));
        return {
            memoizedState: null,
            queue: null,
            next: null
        };
    }
    function $47e94abb28b53633$var$qb() {
        null === $47e94abb28b53633$var$K ? null === $47e94abb28b53633$var$J ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$J = $47e94abb28b53633$var$K = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$J) : null === $47e94abb28b53633$var$K.next ? ($47e94abb28b53633$var$L = !1, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next = $47e94abb28b53633$var$pb()) : ($47e94abb28b53633$var$L = !0, $47e94abb28b53633$var$K = $47e94abb28b53633$var$K.next);
        return $47e94abb28b53633$var$K;
    }
    function $47e94abb28b53633$var$rb() {
        $47e94abb28b53633$var$ob = $47e94abb28b53633$var$I = null;
        $47e94abb28b53633$var$M = !1;
        $47e94abb28b53633$var$J = null;
        $47e94abb28b53633$var$P = 0;
        $47e94abb28b53633$var$K = $47e94abb28b53633$var$O = null;
    }
    function $47e94abb28b53633$var$sb(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function $47e94abb28b53633$var$tb(a, b, c) {
        $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
        $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
        if ($47e94abb28b53633$var$L) {
            var d = $47e94abb28b53633$var$K.queue;
            b = d.dispatch;
            if (null !== $47e94abb28b53633$var$O && (c = $47e94abb28b53633$var$O.get(d), void 0 !== c)) {
                $47e94abb28b53633$var$O.delete(d);
                d = $47e94abb28b53633$var$K.memoizedState;
                do d = a(d, c.action), c = c.next;
                while (null !== c)
                $47e94abb28b53633$var$K.memoizedState = d;
                return [
                    d,
                    b
                ];
            }
            return [
                $47e94abb28b53633$var$K.memoizedState,
                b
            ];
        }
        a = a === $47e94abb28b53633$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
        $47e94abb28b53633$var$K.memoizedState = a;
        a = $47e94abb28b53633$var$K.queue = {
            last: null,
            dispatch: null
        };
        a = a.dispatch = $47e94abb28b53633$var$ub.bind(null, $47e94abb28b53633$var$I, a);
        return [
            $47e94abb28b53633$var$K.memoizedState,
            a
        ];
    }
    function $47e94abb28b53633$var$vb(a, b) {
        $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
        $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
        b = void 0 === b ? null : b;
        if (null !== $47e94abb28b53633$var$K) {
            var c = $47e94abb28b53633$var$K.memoizedState;
            if (null !== c && null !== b) {
                var d = c[1];
                a: if (null === d) d = !1;
                else {
                    for(var f = 0; f < d.length && f < b.length; f++)if (!$47e94abb28b53633$var$lb(b[f], d[f])) {
                        d = !1;
                        break a;
                    }
                    d = !0;
                }
                if (d) return c[0];
            }
        }
        a = a();
        $47e94abb28b53633$var$K.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function $47e94abb28b53633$var$ub(a, b, c) {
        if (25 <= $47e94abb28b53633$var$P) throw Error($47e94abb28b53633$var$l(301));
        if (a === $47e94abb28b53633$var$I) {
            if ($47e94abb28b53633$var$M = !0, a = {
                action: c,
                next: null
            }, null === $47e94abb28b53633$var$O && ($47e94abb28b53633$var$O = new Map), c = $47e94abb28b53633$var$O.get(b), void 0 === c) $47e94abb28b53633$var$O.set(b, a);
            else {
                for(b = c; null !== b.next;)b = b.next;
                b.next = a;
            }
        }
    }
    function $47e94abb28b53633$var$wb() {
        throw Error($47e94abb28b53633$var$l(394));
    }
    function $47e94abb28b53633$var$R() {}
    var $47e94abb28b53633$var$xb = {
        readContext: function(a) {
            return a._currentValue2;
        },
        useContext: function(a) {
            $47e94abb28b53633$var$Q();
            return a._currentValue2;
        },
        useMemo: $47e94abb28b53633$var$vb,
        useReducer: $47e94abb28b53633$var$tb,
        useRef: function(a) {
            $47e94abb28b53633$var$I = $47e94abb28b53633$var$Q();
            $47e94abb28b53633$var$K = $47e94abb28b53633$var$qb();
            var b = $47e94abb28b53633$var$K.memoizedState;
            return null === b ? (a = {
                current: a
            }, $47e94abb28b53633$var$K.memoizedState = a) : b;
        },
        useState: function(a) {
            return $47e94abb28b53633$var$tb($47e94abb28b53633$var$sb, a);
        },
        useInsertionEffect: $47e94abb28b53633$var$R,
        useLayoutEffect: function() {},
        useCallback: function(a, b) {
            return $47e94abb28b53633$var$vb(function() {
                return a;
            }, b);
        },
        useImperativeHandle: $47e94abb28b53633$var$R,
        useEffect: $47e94abb28b53633$var$R,
        useDebugValue: $47e94abb28b53633$var$R,
        useDeferredValue: function(a) {
            $47e94abb28b53633$var$Q();
            return a;
        },
        useTransition: function() {
            $47e94abb28b53633$var$Q();
            return [
                !1,
                $47e94abb28b53633$var$wb
            ];
        },
        useId: function() {
            var a = $47e94abb28b53633$var$ob.treeContext;
            var b = a.overflow;
            a = a.id;
            a = (a & ~(1 << 32 - $47e94abb28b53633$var$H(a) - 1)).toString(32) + b;
            var c = $47e94abb28b53633$var$S;
            if (null === c) throw Error($47e94abb28b53633$var$l(404));
            b = $47e94abb28b53633$var$N++;
            a = ":" + c.idPrefix + "R" + a;
            0 < b && (a += "H" + b.toString(32));
            return a + ":";
        },
        useMutableSource: function(a, b) {
            $47e94abb28b53633$var$Q();
            return b(a._source);
        },
        useSyncExternalStore: function(a, b, c) {
            if (void 0 === c) throw Error($47e94abb28b53633$var$l(407));
            return c();
        }
    }, $47e94abb28b53633$var$S = null, $47e94abb28b53633$var$yb = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
    function $47e94abb28b53633$var$zb(a) {
        console.error(a);
        return null;
    }
    function $47e94abb28b53633$var$T() {}
    function $47e94abb28b53633$var$Ab(a, b, c, d, f, e, g, h, k) {
        var m = [], n = new Set;
        b = {
            destination: null,
            responseState: b,
            progressiveChunkSize: void 0 === d ? 12800 : d,
            status: 0,
            fatalError: null,
            nextSegmentId: 0,
            allPendingTasks: 0,
            pendingRootTasks: 0,
            completedRootSegment: null,
            abortableTasks: n,
            pingedTasks: m,
            clientRenderedBoundaries: [],
            completedBoundaries: [],
            partialBoundaries: [],
            onError: void 0 === f ? $47e94abb28b53633$var$zb : f,
            onAllReady: void 0 === e ? $47e94abb28b53633$var$T : e,
            onShellReady: void 0 === g ? $47e94abb28b53633$var$T : g,
            onShellError: void 0 === h ? $47e94abb28b53633$var$T : h,
            onFatalError: void 0 === k ? $47e94abb28b53633$var$T : k
        };
        c = $47e94abb28b53633$var$U(b, 0, null, c, !1, !1);
        c.parentFlushed = !0;
        a = $47e94abb28b53633$var$Bb(b, a, null, c, n, $47e94abb28b53633$var$Ya, null, $47e94abb28b53633$var$fb);
        m.push(a);
        return b;
    }
    function $47e94abb28b53633$var$Bb(a, b, c, d, f, e, g, h) {
        a.allPendingTasks++;
        null === c ? a.pendingRootTasks++ : c.pendingTasks++;
        var k = {
            node: b,
            ping: function() {
                var b = a.pingedTasks;
                b.push(k);
                1 === b.length && $47e94abb28b53633$var$Cb(a);
            },
            blockedBoundary: c,
            blockedSegment: d,
            abortSet: f,
            legacyContext: e,
            context: g,
            treeContext: h
        };
        f.add(k);
        return k;
    }
    function $47e94abb28b53633$var$U(a, b, c, d, f, e) {
        return {
            status: 0,
            id: -1,
            index: b,
            parentFlushed: !1,
            chunks: [],
            children: [],
            formatContext: d,
            boundary: c,
            lastPushedText: f,
            textEmbedded: e
        };
    }
    function $47e94abb28b53633$var$V(a, b) {
        a = a.onError(b);
        if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
        return a;
    }
    function $47e94abb28b53633$var$W(a, b) {
        var c = a.onShellError;
        c(b);
        c = a.onFatalError;
        c(b);
        null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
    }
    function $47e94abb28b53633$var$Db(a, b, c, d, f) {
        $47e94abb28b53633$var$I = {};
        $47e94abb28b53633$var$ob = b;
        $47e94abb28b53633$var$N = 0;
        for(a = c(d, f); $47e94abb28b53633$var$M;)$47e94abb28b53633$var$M = !1, $47e94abb28b53633$var$N = 0, $47e94abb28b53633$var$P += 1, $47e94abb28b53633$var$K = null, a = c(d, f);
        $47e94abb28b53633$var$rb();
        return a;
    }
    function $47e94abb28b53633$var$Eb(a, b, c, d) {
        var f = c.render(), e = d.childContextTypes;
        if (null !== e && void 0 !== e) {
            var g = b.legacyContext;
            if ("function" !== typeof c.getChildContext) d = g;
            else {
                c = c.getChildContext();
                for(var h in c)if (!(h in e)) throw Error($47e94abb28b53633$var$l(108, $47e94abb28b53633$var$Xa(d) || "Unknown", h));
                d = $47e94abb28b53633$var$B({}, g, c);
            }
            b.legacyContext = d;
            $47e94abb28b53633$var$X(a, b, f);
            b.legacyContext = g;
        } else $47e94abb28b53633$var$X(a, b, f);
    }
    function $47e94abb28b53633$var$Fb(a, b) {
        if (a && a.defaultProps) {
            b = $47e94abb28b53633$var$B({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    function $47e94abb28b53633$var$Gb(a, b, c, d, f) {
        if ("function" === typeof c) {
            if (c.prototype && c.prototype.isReactComponent) {
                f = $47e94abb28b53633$var$Za(c, b.legacyContext);
                var e = c.contextType;
                e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
                $47e94abb28b53633$var$eb(e, c, d, f);
                $47e94abb28b53633$var$Eb(a, b, e, c);
            } else {
                e = $47e94abb28b53633$var$Za(c, b.legacyContext);
                f = $47e94abb28b53633$var$Db(a, b, c, d, e);
                var g = 0 !== $47e94abb28b53633$var$N;
                if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $47e94abb28b53633$var$eb(f, c, d, e), $47e94abb28b53633$var$Eb(a, b, f, c);
                else if (g) {
                    d = b.treeContext;
                    b.treeContext = $47e94abb28b53633$var$gb(d, 1, 0);
                    try {
                        $47e94abb28b53633$var$X(a, b, f);
                    } finally{
                        b.treeContext = d;
                    }
                } else $47e94abb28b53633$var$X(a, b, f);
            }
        } else if ("string" === typeof c) {
            f = b.blockedSegment;
            e = $47e94abb28b53633$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
            f.lastPushedText = !1;
            g = f.formatContext;
            f.formatContext = $47e94abb28b53633$var$ra(g, c, d);
            $47e94abb28b53633$var$Hb(a, b, e);
            f.formatContext = g;
            switch(c){
                case "area":
                case "base":
                case "br":
                case "col":
                case "embed":
                case "hr":
                case "img":
                case "input":
                case "keygen":
                case "link":
                case "meta":
                case "param":
                case "source":
                case "track":
                case "wbr":
                    break;
                default:
                    f.chunks.push("</", c, ">");
            }
            f.lastPushedText = !1;
        } else {
            switch(c){
                case $47e94abb28b53633$var$Ua:
                case $47e94abb28b53633$var$Ta:
                case $47e94abb28b53633$var$Ja:
                case $47e94abb28b53633$var$Ka:
                case $47e94abb28b53633$var$Ia:
                    $47e94abb28b53633$var$X(a, b, d.children);
                    return;
                case $47e94abb28b53633$var$Pa:
                    $47e94abb28b53633$var$X(a, b, d.children);
                    return;
                case $47e94abb28b53633$var$Sa:
                    throw Error($47e94abb28b53633$var$l(343));
                case $47e94abb28b53633$var$Oa:
                    a: {
                        c = b.blockedBoundary;
                        f = b.blockedSegment;
                        e = d.fallback;
                        d = d.children;
                        g = new Set;
                        var h = {
                            id: null,
                            rootSegmentID: -1,
                            parentFlushed: !1,
                            pendingTasks: 0,
                            forceClientRender: !1,
                            completedSegments: [],
                            byteSize: 0,
                            fallbackAbortableTasks: g,
                            errorDigest: null
                        }, k = $47e94abb28b53633$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                        f.children.push(k);
                        f.lastPushedText = !1;
                        var m = $47e94abb28b53633$var$U(a, 0, null, f.formatContext, !1, !1);
                        m.parentFlushed = !0;
                        b.blockedBoundary = h;
                        b.blockedSegment = m;
                        try {
                            if ($47e94abb28b53633$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $47e94abb28b53633$var$Y(h, m), 0 === h.pendingTasks) break a;
                        } catch (n) {
                            m.status = 4, h.forceClientRender = !0, h.errorDigest = $47e94abb28b53633$var$V(a, n);
                        } finally{
                            b.blockedBoundary = c, b.blockedSegment = f;
                        }
                        b = $47e94abb28b53633$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                        a.pingedTasks.push(b);
                    }
                    return;
            }
            if ("object" === typeof c && null !== c) switch(c.$$typeof){
                case $47e94abb28b53633$var$Na:
                    d = $47e94abb28b53633$var$Db(a, b, c.render, d, f);
                    if (0 !== $47e94abb28b53633$var$N) {
                        c = b.treeContext;
                        b.treeContext = $47e94abb28b53633$var$gb(c, 1, 0);
                        try {
                            $47e94abb28b53633$var$X(a, b, d);
                        } finally{
                            b.treeContext = c;
                        }
                    } else $47e94abb28b53633$var$X(a, b, d);
                    return;
                case $47e94abb28b53633$var$Qa:
                    c = c.type;
                    d = $47e94abb28b53633$var$Fb(c, d);
                    $47e94abb28b53633$var$Gb(a, b, c, d, f);
                    return;
                case $47e94abb28b53633$var$La:
                    f = d.children;
                    c = c._context;
                    d = d.value;
                    e = c._currentValue2;
                    c._currentValue2 = d;
                    g = $47e94abb28b53633$var$E;
                    $47e94abb28b53633$var$E = d = {
                        parent: g,
                        depth: null === g ? 0 : g.depth + 1,
                        context: c,
                        parentValue: e,
                        value: d
                    };
                    b.context = d;
                    $47e94abb28b53633$var$X(a, b, f);
                    a = $47e94abb28b53633$var$E;
                    if (null === a) throw Error($47e94abb28b53633$var$l(403));
                    d = a.parentValue;
                    a.context._currentValue2 = d === $47e94abb28b53633$var$Va ? a.context._defaultValue : d;
                    a = $47e94abb28b53633$var$E = a.parent;
                    b.context = a;
                    return;
                case $47e94abb28b53633$var$Ma:
                    d = d.children;
                    d = d(c._currentValue2);
                    $47e94abb28b53633$var$X(a, b, d);
                    return;
                case $47e94abb28b53633$var$Ra:
                    f = c._init;
                    c = f(c._payload);
                    d = $47e94abb28b53633$var$Fb(c, d);
                    $47e94abb28b53633$var$Gb(a, b, c, d, void 0);
                    return;
            }
            throw Error($47e94abb28b53633$var$l(130, null == c ? c : typeof c, ""));
        }
    }
    function $47e94abb28b53633$var$X(a, b, c) {
        b.node = c;
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $47e94abb28b53633$var$Ga:
                    $47e94abb28b53633$var$Gb(a, b, c.type, c.props, c.ref);
                    return;
                case $47e94abb28b53633$var$Ha:
                    throw Error($47e94abb28b53633$var$l(257));
                case $47e94abb28b53633$var$Ra:
                    var d = c._init;
                    c = d(c._payload);
                    $47e94abb28b53633$var$X(a, b, c);
                    return;
            }
            if ($47e94abb28b53633$var$qa(c)) {
                $47e94abb28b53633$var$Ib(a, b, c);
                return;
            }
            null === c || "object" !== typeof c ? d = null : (d = $47e94abb28b53633$var$Wa && c[$47e94abb28b53633$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
            if (d && (d = d.call(c))) {
                c = d.next();
                if (!c.done) {
                    var f = [];
                    do f.push(c.value), c = d.next();
                    while (!c.done)
                    $47e94abb28b53633$var$Ib(a, b, f);
                }
                return;
            }
            a = Object.prototype.toString.call(c);
            throw Error($47e94abb28b53633$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
        }
        "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $47e94abb28b53633$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
    }
    function $47e94abb28b53633$var$Ib(a, b, c) {
        for(var d = c.length, f = 0; f < d; f++){
            var e = b.treeContext;
            b.treeContext = $47e94abb28b53633$var$gb(e, d, f);
            try {
                $47e94abb28b53633$var$Hb(a, b, c[f]);
            } finally{
                b.treeContext = e;
            }
        }
    }
    function $47e94abb28b53633$var$Hb(a, b, c) {
        var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
        try {
            return $47e94abb28b53633$var$X(a, b, c);
        } catch (k) {
            if ($47e94abb28b53633$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
                c = k;
                var g = b.blockedSegment, h = $47e94abb28b53633$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
                g.children.push(h);
                g.lastPushedText = !1;
                a = $47e94abb28b53633$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
                c.then(a, a);
                b.blockedSegment.formatContext = d;
                b.legacyContext = f;
                b.context = e;
                $47e94abb28b53633$var$G(e);
            } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $47e94abb28b53633$var$G(e), k;
        }
    }
    function $47e94abb28b53633$var$Jb(a) {
        var b = a.blockedBoundary;
        a = a.blockedSegment;
        a.status = 3;
        $47e94abb28b53633$var$Kb(this, b, a);
    }
    function $47e94abb28b53633$var$Lb(a, b, c) {
        var d = a.blockedBoundary;
        a.blockedSegment.status = 3;
        null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($47e94abb28b53633$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
            return $47e94abb28b53633$var$Lb(a, b, c);
        }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
    }
    function $47e94abb28b53633$var$Y(a, b) {
        if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
            var c = b.children[0];
            c.id = b.id;
            c.parentFlushed = !0;
            1 === c.status && $47e94abb28b53633$var$Y(a, c);
        } else a.completedSegments.push(b);
    }
    function $47e94abb28b53633$var$Kb(a, b, c) {
        if (null === b) {
            if (c.parentFlushed) {
                if (null !== a.completedRootSegment) throw Error($47e94abb28b53633$var$l(389));
                a.completedRootSegment = c;
            }
            a.pendingRootTasks--;
            0 === a.pendingRootTasks && (a.onShellError = $47e94abb28b53633$var$T, b = a.onShellReady, b());
        } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $47e94abb28b53633$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($47e94abb28b53633$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($47e94abb28b53633$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
        a.allPendingTasks--;
        0 === a.allPendingTasks && (a = a.onAllReady, a());
    }
    function $47e94abb28b53633$var$Cb(a) {
        if (2 !== a.status) {
            var b = $47e94abb28b53633$var$E, c = $47e94abb28b53633$var$yb.current;
            $47e94abb28b53633$var$yb.current = $47e94abb28b53633$var$xb;
            var d = $47e94abb28b53633$var$S;
            $47e94abb28b53633$var$S = a.responseState;
            try {
                var f = a.pingedTasks, e;
                for(e = 0; e < f.length; e++){
                    var g = f[e];
                    var h = a, k = g.blockedSegment;
                    if (0 === k.status) {
                        $47e94abb28b53633$var$G(g.context);
                        try {
                            $47e94abb28b53633$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $47e94abb28b53633$var$Kb(h, g.blockedBoundary, k);
                        } catch (z) {
                            if ($47e94abb28b53633$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                                var m = g.ping;
                                z.then(m, m);
                            } else {
                                g.abortSet.delete(g);
                                k.status = 4;
                                var n = g.blockedBoundary, q = z, C = $47e94abb28b53633$var$V(h, q);
                                null === n ? $47e94abb28b53633$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                                h.allPendingTasks--;
                                if (0 === h.allPendingTasks) {
                                    var D = h.onAllReady;
                                    D();
                                }
                            }
                        } finally{}
                    }
                }
                f.splice(0, e);
                null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
            } catch (z) {
                $47e94abb28b53633$var$V(a, z), $47e94abb28b53633$var$W(a, z);
            } finally{
                $47e94abb28b53633$var$S = d, $47e94abb28b53633$var$yb.current = c, c === $47e94abb28b53633$var$xb && $47e94abb28b53633$var$G(b);
            }
        }
    }
    function $47e94abb28b53633$var$Z(a, b, c) {
        c.parentFlushed = !0;
        switch(c.status){
            case 0:
                var d = c.id = a.nextSegmentId++;
                c.lastPushedText = !1;
                c.textEmbedded = !1;
                a = a.responseState;
                b.push('<template id="');
                b.push(a.placeholderPrefix);
                a = d.toString(16);
                b.push(a);
                return b.push('"></template>');
            case 1:
                c.status = 2;
                var f = !0;
                d = c.chunks;
                var e = 0;
                c = c.children;
                for(var g = 0; g < c.length; g++){
                    for(f = c[g]; e < f.index; e++)b.push(d[e]);
                    f = $47e94abb28b53633$var$Nb(a, b, f);
                }
                for(; e < d.length - 1; e++)b.push(d[e]);
                e < d.length && (f = b.push(d[e]));
                return f;
            default:
                throw Error($47e94abb28b53633$var$l(390));
        }
    }
    function $47e94abb28b53633$var$Nb(a, b, c) {
        var d = c.boundary;
        if (null === d) return $47e94abb28b53633$var$Z(a, b, c);
        d.parentFlushed = !0;
        if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $47e94abb28b53633$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $47e94abb28b53633$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
        if (0 < d.pendingTasks) {
            d.rootSegmentID = a.nextSegmentId++;
            0 < d.completedSegments.length && a.partialBoundaries.push(d);
            var f = a.responseState;
            var e = f.nextSuspenseID++;
            f = f.boundaryPrefix + e.toString(16);
            d = d.id = f;
            $47e94abb28b53633$var$za(b, a.responseState, d);
            $47e94abb28b53633$var$Z(a, b, c);
            return b.push("\x3c!--/$--\x3e");
        }
        if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $47e94abb28b53633$var$za(b, a.responseState, d.id), $47e94abb28b53633$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
        a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
        c = d.completedSegments;
        if (1 !== c.length) throw Error($47e94abb28b53633$var$l(391));
        $47e94abb28b53633$var$Nb(a, b, c[0]);
        a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
        return a;
    }
    function $47e94abb28b53633$var$Ob(a, b, c) {
        $47e94abb28b53633$var$Aa(b, a.responseState, c.formatContext, c.id);
        $47e94abb28b53633$var$Nb(a, b, c);
        return $47e94abb28b53633$var$Ba(b, c.formatContext);
    }
    function $47e94abb28b53633$var$Pb(a, b, c) {
        for(var d = c.completedSegments, f = 0; f < d.length; f++)$47e94abb28b53633$var$Qb(a, b, c, d[f]);
        d.length = 0;
        a = a.responseState;
        d = c.id;
        c = c.rootSegmentID;
        b.push(a.startInlineScript);
        a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
        if (null === d) throw Error($47e94abb28b53633$var$l(395));
        c = c.toString(16);
        b.push(d);
        b.push('","');
        b.push(a.segmentPrefix);
        b.push(c);
        return b.push('")\x3c/script>');
    }
    function $47e94abb28b53633$var$Qb(a, b, c, d) {
        if (2 === d.status) return !0;
        var f = d.id;
        if (-1 === f) {
            if (-1 === (d.id = c.rootSegmentID)) throw Error($47e94abb28b53633$var$l(392));
            return $47e94abb28b53633$var$Ob(a, b, d);
        }
        $47e94abb28b53633$var$Ob(a, b, d);
        a = a.responseState;
        b.push(a.startInlineScript);
        a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
        b.push(a.segmentPrefix);
        f = f.toString(16);
        b.push(f);
        b.push('","');
        b.push(a.placeholderPrefix);
        b.push(f);
        return b.push('")\x3c/script>');
    }
    function $47e94abb28b53633$var$Mb(a, b) {
        try {
            var c = a.completedRootSegment;
            if (null !== c && 0 === a.pendingRootTasks) {
                $47e94abb28b53633$var$Nb(a, b, c);
                a.completedRootSegment = null;
                var d = a.responseState.bootstrapChunks;
                for(c = 0; c < d.length - 1; c++)b.push(d[c]);
                c < d.length && b.push(d[c]);
            }
            var f = a.clientRenderedBoundaries, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                d = b;
                var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
                d.push(h.startInlineScript);
                h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
                if (null === k) throw Error($47e94abb28b53633$var$l(395));
                d.push(k);
                d.push('"');
                if (m || n || q) {
                    d.push(",");
                    var C = $47e94abb28b53633$var$Da(m || "");
                    d.push(C);
                }
                if (n || q) {
                    d.push(",");
                    var D = $47e94abb28b53633$var$Da(n || "");
                    d.push(D);
                }
                if (q) {
                    d.push(",");
                    var z = $47e94abb28b53633$var$Da(q);
                    d.push(z);
                }
                if (!d.push(")\x3c/script>")) {
                    a.destination = null;
                    e++;
                    f.splice(0, e);
                    return;
                }
            }
            f.splice(0, e);
            var ba = a.completedBoundaries;
            for(e = 0; e < ba.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ba[e])) {
                a.destination = null;
                e++;
                ba.splice(0, e);
                return;
            }
            ba.splice(0, e);
            var ca = a.partialBoundaries;
            for(e = 0; e < ca.length; e++){
                var mb = ca[e];
                a: {
                    f = a;
                    g = b;
                    var da = mb.completedSegments;
                    for(h = 0; h < da.length; h++)if (!$47e94abb28b53633$var$Qb(f, g, mb, da[h])) {
                        h++;
                        da.splice(0, h);
                        var nb = !1;
                        break a;
                    }
                    da.splice(0, h);
                    nb = !0;
                }
                if (!nb) {
                    a.destination = null;
                    e++;
                    ca.splice(0, e);
                    return;
                }
            }
            ca.splice(0, e);
            var ea = a.completedBoundaries;
            for(e = 0; e < ea.length; e++)if (!$47e94abb28b53633$var$Pb(a, b, ea[e])) {
                a.destination = null;
                e++;
                ea.splice(0, e);
                return;
            }
            ea.splice(0, e);
        } finally{
            0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
        }
    }
    function $47e94abb28b53633$var$Rb(a, b) {
        try {
            var c = a.abortableTasks;
            c.forEach(function(c) {
                return $47e94abb28b53633$var$Lb(c, a, b);
            });
            c.clear();
            null !== a.destination && $47e94abb28b53633$var$Mb(a, a.destination);
        } catch (d) {
            $47e94abb28b53633$var$V(a, d), $47e94abb28b53633$var$W(a, d);
        }
    }
    function $47e94abb28b53633$var$Sb() {}
    function $47e94abb28b53633$var$Tb(a, b, c, d) {
        var f = !1, e = null, g = "", h = {
            push: function(a) {
                null !== a && (g += a);
                return !0;
            },
            destroy: function(a) {
                f = !0;
                e = a;
            }
        }, k = !1;
        a = $47e94abb28b53633$var$Ab(a, $47e94abb28b53633$var$Ea(c, b ? b.identifierPrefix : void 0), {
            insertionMode: 1,
            selectedValue: null
        }, Infinity, $47e94abb28b53633$var$Sb, void 0, function() {
            k = !0;
        }, void 0, void 0);
        $47e94abb28b53633$var$Cb(a);
        $47e94abb28b53633$var$Rb(a, d);
        if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
        else if (2 !== a.status && null === a.destination) {
            a.destination = h;
            try {
                $47e94abb28b53633$var$Mb(a, h);
            } catch (m) {
                $47e94abb28b53633$var$V(a, m), $47e94abb28b53633$var$W(a, m);
            }
        }
        if (f) throw e;
        if (!k) throw Error($47e94abb28b53633$var$l(426));
        return g;
    }
    $47e94abb28b53633$export$307591e98609eddd = function() {
        throw Error($47e94abb28b53633$var$l(207));
    };
    $47e94abb28b53633$export$eb3a06aef9e6ee51 = function(a, b) {
        return $47e94abb28b53633$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    };
    $47e94abb28b53633$export$b23711c915539651 = function() {
        throw Error($47e94abb28b53633$var$l(208));
    };
    $47e94abb28b53633$export$80e7718417253a51 = function(a, b) {
        return $47e94abb28b53633$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    };
    $47e94abb28b53633$export$83d89fbfd8236492 = "18.2.0";
});
parcelRegister("l7JfX", function(module, exports) {
    $parcel$export(module.exports, "renderToReadableStream", ()=>$f60d5b61c638db60$export$7020a3240b287705, (v)=>$f60d5b61c638db60$export$7020a3240b287705 = v);
    $parcel$export(module.exports, "version", ()=>$f60d5b61c638db60$export$83d89fbfd8236492, (v)=>$f60d5b61c638db60$export$83d89fbfd8236492 = v);
    var $f60d5b61c638db60$export$7020a3240b287705;
    var $f60d5b61c638db60$export$83d89fbfd8236492;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    function $f60d5b61c638db60$var$k(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0;
    function $f60d5b61c638db60$var$p(a, b) {
        if (0 !== b.length) {
            if (512 < b.length) 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0), a.enqueue(b);
            else {
                var c = $f60d5b61c638db60$var$l.length - $f60d5b61c638db60$var$n;
                c < b.length && (0 === c ? a.enqueue($f60d5b61c638db60$var$l) : ($f60d5b61c638db60$var$l.set(b.subarray(0, c), $f60d5b61c638db60$var$n), a.enqueue($f60d5b61c638db60$var$l), b = b.subarray(c)), $f60d5b61c638db60$var$l = new Uint8Array(512), $f60d5b61c638db60$var$n = 0);
                $f60d5b61c638db60$var$l.set(b, $f60d5b61c638db60$var$n);
                $f60d5b61c638db60$var$n += b.length;
            }
        }
    }
    function $f60d5b61c638db60$var$t(a, b) {
        $f60d5b61c638db60$var$p(a, b);
        return !0;
    }
    function $f60d5b61c638db60$var$ba(a) {
        $f60d5b61c638db60$var$l && 0 < $f60d5b61c638db60$var$n && (a.enqueue(new Uint8Array($f60d5b61c638db60$var$l.buffer, 0, $f60d5b61c638db60$var$n)), $f60d5b61c638db60$var$l = null, $f60d5b61c638db60$var$n = 0);
    }
    var $f60d5b61c638db60$var$ca = new TextEncoder;
    function $f60d5b61c638db60$var$u(a) {
        return $f60d5b61c638db60$var$ca.encode(a);
    }
    function $f60d5b61c638db60$var$w(a) {
        return $f60d5b61c638db60$var$ca.encode(a);
    }
    function $f60d5b61c638db60$var$da(a, b) {
        "function" === typeof a.error ? a.error(b) : a.close();
    }
    var $f60d5b61c638db60$var$x = Object.prototype.hasOwnProperty, $f60d5b61c638db60$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f60d5b61c638db60$var$fa = {}, $f60d5b61c638db60$var$ha = {};
    function $f60d5b61c638db60$var$ia(a) {
        if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$ha, a)) return !0;
        if ($f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$fa, a)) return !1;
        if ($f60d5b61c638db60$var$ea.test(a)) return $f60d5b61c638db60$var$ha[a] = !0;
        $f60d5b61c638db60$var$fa[a] = !0;
        return !1;
    }
    function $f60d5b61c638db60$var$y(a, b, c, d, f, e, g) {
        this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
        this.attributeName = d;
        this.attributeNamespace = f;
        this.mustUseProperty = c;
        this.propertyName = a;
        this.type = b;
        this.sanitizeURL = e;
        this.removeEmptyString = g;
    }
    var $f60d5b61c638db60$var$z = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 0, !1, a, null, !1, !1);
    });
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(a) {
        var b = a[0];
        $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a[1], null, !1, !1);
    });
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
    });
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 2, !1, a, null, !1, !1);
    });
    "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
    });
    [
        "checked",
        "multiple",
        "muted",
        "selected"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 3, !0, a, null, !1, !1);
    });
    [
        "capture",
        "download"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 4, !1, a, null, !1, !1);
    });
    [
        "cols",
        "rows",
        "size",
        "span"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 6, !1, a, null, !1, !1);
    });
    [
        "rowSpan",
        "start"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
    });
    var $f60d5b61c638db60$var$ja = /[\-:]([a-z])/g;
    function $f60d5b61c638db60$var$ka(a) {
        return a[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
        var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
        $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, null, !1, !1);
    });
    "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
        var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
        $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
    });
    [
        "xml:base",
        "xml:lang",
        "xml:space"
    ].forEach(function(a) {
        var b = a.replace($f60d5b61c638db60$var$ja, $f60d5b61c638db60$var$ka);
        $f60d5b61c638db60$var$z[b] = new $f60d5b61c638db60$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
    });
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
    });
    $f60d5b61c638db60$var$z.xlinkHref = new $f60d5b61c638db60$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(a) {
        $f60d5b61c638db60$var$z[a] = new $f60d5b61c638db60$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
    });
    var $f60d5b61c638db60$var$B = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
    }, $f60d5b61c638db60$var$la = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ];
    Object.keys($f60d5b61c638db60$var$B).forEach(function(a) {
        $f60d5b61c638db60$var$la.forEach(function(b) {
            b = b + a.charAt(0).toUpperCase() + a.substring(1);
            $f60d5b61c638db60$var$B[b] = $f60d5b61c638db60$var$B[a];
        });
    });
    var $f60d5b61c638db60$var$oa = /["'&<>]/;
    function $f60d5b61c638db60$var$C(a) {
        if ("boolean" === typeof a || "number" === typeof a) return "" + a;
        a = "" + a;
        var b = $f60d5b61c638db60$var$oa.exec(a);
        if (b) {
            var c = "", d, f = 0;
            for(d = b.index; d < a.length; d++){
                switch(a.charCodeAt(d)){
                    case 34:
                        b = "&quot;";
                        break;
                    case 38:
                        b = "&amp;";
                        break;
                    case 39:
                        b = "&#x27;";
                        break;
                    case 60:
                        b = "&lt;";
                        break;
                    case 62:
                        b = "&gt;";
                        break;
                    default:
                        continue;
                }
                f !== d && (c += a.substring(f, d));
                f = d + 1;
                c += b;
            }
            a = f !== d ? c + a.substring(f, d) : c;
        }
        return a;
    }
    var $f60d5b61c638db60$var$pa = /([A-Z])/g, $f60d5b61c638db60$var$qa = /^ms-/, $f60d5b61c638db60$var$ra = Array.isArray, $f60d5b61c638db60$var$sa = $f60d5b61c638db60$var$w("<script>"), $f60d5b61c638db60$var$ta = $f60d5b61c638db60$var$w("\x3c/script>"), $f60d5b61c638db60$var$ua = $f60d5b61c638db60$var$w('<script src="'), $f60d5b61c638db60$var$va = $f60d5b61c638db60$var$w('<script type="module" src="'), $f60d5b61c638db60$var$wa = $f60d5b61c638db60$var$w('" async="">\x3c/script>'), $f60d5b61c638db60$var$xa = /(<\/|<)(s)(cript)/gi;
    function $f60d5b61c638db60$var$ya(a, b, c, d) {
        return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
    }
    function $f60d5b61c638db60$var$za(a, b, c, d, f) {
        a = void 0 === a ? "" : a;
        b = void 0 === b ? $f60d5b61c638db60$var$sa : $f60d5b61c638db60$var$w('<script nonce="' + $f60d5b61c638db60$var$C(b) + '">');
        var e = [];
        void 0 !== c && e.push(b, $f60d5b61c638db60$var$u(("" + c).replace($f60d5b61c638db60$var$xa, $f60d5b61c638db60$var$ya)), $f60d5b61c638db60$var$ta);
        if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($f60d5b61c638db60$var$ua, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d[c])), $f60d5b61c638db60$var$wa);
        if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($f60d5b61c638db60$var$va, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(f[d])), $f60d5b61c638db60$var$wa);
        return {
            bootstrapChunks: e,
            startInlineScript: b,
            placeholderPrefix: $f60d5b61c638db60$var$w(a + "P:"),
            segmentPrefix: $f60d5b61c638db60$var$w(a + "S:"),
            boundaryPrefix: a + "B:",
            idPrefix: a,
            nextSuspenseID: 0,
            sentCompleteSegmentFunction: !1,
            sentCompleteBoundaryFunction: !1,
            sentClientRenderFunction: !1
        };
    }
    function $f60d5b61c638db60$var$D(a, b) {
        return {
            insertionMode: a,
            selectedValue: b
        };
    }
    function $f60d5b61c638db60$var$Aa(a) {
        return $f60d5b61c638db60$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
    }
    function $f60d5b61c638db60$var$Ba(a, b, c) {
        switch(b){
            case "select":
                return $f60d5b61c638db60$var$D(1, null != c.value ? c.value : c.defaultValue);
            case "svg":
                return $f60d5b61c638db60$var$D(2, null);
            case "math":
                return $f60d5b61c638db60$var$D(3, null);
            case "foreignObject":
                return $f60d5b61c638db60$var$D(1, null);
            case "table":
                return $f60d5b61c638db60$var$D(4, null);
            case "thead":
            case "tbody":
            case "tfoot":
                return $f60d5b61c638db60$var$D(5, null);
            case "colgroup":
                return $f60d5b61c638db60$var$D(7, null);
            case "tr":
                return $f60d5b61c638db60$var$D(6, null);
        }
        return 4 <= a.insertionMode || 0 === a.insertionMode ? $f60d5b61c638db60$var$D(1, null) : a;
    }
    var $f60d5b61c638db60$var$Ca = $f60d5b61c638db60$var$w("\x3c!-- --\x3e");
    function $f60d5b61c638db60$var$Da(a, b, c, d) {
        if ("" === b) return d;
        d && a.push($f60d5b61c638db60$var$Ca);
        a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(b)));
        return !0;
    }
    var $f60d5b61c638db60$var$Ea = new Map, $f60d5b61c638db60$var$Fa = $f60d5b61c638db60$var$w(' style="'), $f60d5b61c638db60$var$Ga = $f60d5b61c638db60$var$w(":"), $f60d5b61c638db60$var$Ha = $f60d5b61c638db60$var$w(";");
    function $f60d5b61c638db60$var$Ia(a, b, c) {
        if ("object" !== typeof c) throw Error($f60d5b61c638db60$var$k(62));
        b = !0;
        for(var d in c)if ($f60d5b61c638db60$var$x.call(c, d)) {
            var f = c[d];
            if (null != f && "boolean" !== typeof f && "" !== f) {
                if (0 === d.indexOf("--")) {
                    var e = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d));
                    f = $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
                } else {
                    e = d;
                    var g = $f60d5b61c638db60$var$Ea.get(e);
                    void 0 !== g ? e = g : (g = $f60d5b61c638db60$var$w($f60d5b61c638db60$var$C(e.replace($f60d5b61c638db60$var$pa, "-$1").toLowerCase().replace($f60d5b61c638db60$var$qa, "-ms-"))), $f60d5b61c638db60$var$Ea.set(e, g), e = g);
                    f = "number" === typeof f ? 0 === f || $f60d5b61c638db60$var$x.call($f60d5b61c638db60$var$B, d) ? $f60d5b61c638db60$var$u("" + f) : $f60d5b61c638db60$var$u(f + "px") : $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(("" + f).trim()));
                }
                b ? (b = !1, a.push($f60d5b61c638db60$var$Fa, e, $f60d5b61c638db60$var$Ga, f)) : a.push($f60d5b61c638db60$var$Ha, e, $f60d5b61c638db60$var$Ga, f);
            }
        }
        b || a.push($f60d5b61c638db60$var$E);
    }
    var $f60d5b61c638db60$var$H = $f60d5b61c638db60$var$w(" "), $f60d5b61c638db60$var$I = $f60d5b61c638db60$var$w('="'), $f60d5b61c638db60$var$E = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Ja = $f60d5b61c638db60$var$w('=""');
    function $f60d5b61c638db60$var$J(a, b, c, d) {
        switch(c){
            case "style":
                $f60d5b61c638db60$var$Ia(a, b, d);
                return;
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
                return;
        }
        if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
            if (b = $f60d5b61c638db60$var$z.hasOwnProperty(c) ? $f60d5b61c638db60$var$z[c] : null, null !== b) {
                switch(typeof d){
                    case "function":
                    case "symbol":
                        return;
                    case "boolean":
                        if (!b.acceptsBooleans) return;
                }
                c = $f60d5b61c638db60$var$u(b.attributeName);
                switch(b.type){
                    case 3:
                        d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja);
                        break;
                    case 4:
                        !0 === d ? a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$Ja) : !1 !== d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                        break;
                    case 5:
                        isNaN(d) || a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                        break;
                    case 6:
                        !isNaN(d) && 1 <= d && a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                        break;
                    default:
                        b.sanitizeURL && (d = "" + d), a.push($f60d5b61c638db60$var$H, c, $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
                }
            } else if ($f60d5b61c638db60$var$ia(c)) {
                switch(typeof d){
                    case "function":
                    case "symbol":
                        return;
                    case "boolean":
                        if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
                }
                a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d)), $f60d5b61c638db60$var$E);
            }
        }
    }
    var $f60d5b61c638db60$var$K = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Ka = $f60d5b61c638db60$var$w("/>");
    function $f60d5b61c638db60$var$L(a, b, c) {
        if (null != b) {
            if (null != c) throw Error($f60d5b61c638db60$var$k(60));
            if ("object" !== typeof b || !("__html" in b)) throw Error($f60d5b61c638db60$var$k(61));
            b = b.__html;
            null !== b && void 0 !== b && a.push($f60d5b61c638db60$var$u("" + b));
        }
    }
    function $f60d5b61c638db60$var$La(a) {
        var b = "";
        $5uXOq.Children.forEach(a, function(a) {
            null != a && (b += a);
        });
        return b;
    }
    var $f60d5b61c638db60$var$Ma = $f60d5b61c638db60$var$w(' selected=""');
    function $f60d5b61c638db60$var$Na(a, b, c, d) {
        a.push($f60d5b61c638db60$var$M(c));
        var f = c = null, e;
        for(e in b)if ($f60d5b61c638db60$var$x.call(b, e)) {
            var g = b[e];
            if (null != g) switch(e){
                case "children":
                    c = g;
                    break;
                case "dangerouslySetInnerHTML":
                    f = g;
                    break;
                default:
                    $f60d5b61c638db60$var$J(a, d, e, g);
            }
        }
        a.push($f60d5b61c638db60$var$K);
        $f60d5b61c638db60$var$L(a, f, c);
        return "string" === typeof c ? (a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(c))), null) : c;
    }
    var $f60d5b61c638db60$var$Oa = $f60d5b61c638db60$var$w("\n"), $f60d5b61c638db60$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $f60d5b61c638db60$var$Qa = new Map;
    function $f60d5b61c638db60$var$M(a) {
        var b = $f60d5b61c638db60$var$Qa.get(a);
        if (void 0 === b) {
            if (!$f60d5b61c638db60$var$Pa.test(a)) throw Error($f60d5b61c638db60$var$k(65, a));
            b = $f60d5b61c638db60$var$w("<" + a);
            $f60d5b61c638db60$var$Qa.set(a, b);
        }
        return b;
    }
    var $f60d5b61c638db60$var$Ra = $f60d5b61c638db60$var$w("<!DOCTYPE html>");
    function $f60d5b61c638db60$var$Sa(a, b, c, d, f) {
        switch(b){
            case "select":
                a.push($f60d5b61c638db60$var$M("select"));
                var e = null, g = null;
                for(r in c)if ($f60d5b61c638db60$var$x.call(c, r)) {
                    var h = c[r];
                    if (null != h) switch(r){
                        case "children":
                            e = h;
                            break;
                        case "dangerouslySetInnerHTML":
                            g = h;
                            break;
                        case "defaultValue":
                        case "value":
                            break;
                        default:
                            $f60d5b61c638db60$var$J(a, d, r, h);
                    }
                }
                a.push($f60d5b61c638db60$var$K);
                $f60d5b61c638db60$var$L(a, g, e);
                return e;
            case "option":
                g = f.selectedValue;
                a.push($f60d5b61c638db60$var$M("option"));
                var m = h = null, q = null;
                var r = null;
                for(e in c)if ($f60d5b61c638db60$var$x.call(c, e)) {
                    var v = c[e];
                    if (null != v) switch(e){
                        case "children":
                            h = v;
                            break;
                        case "selected":
                            q = v;
                            break;
                        case "dangerouslySetInnerHTML":
                            r = v;
                            break;
                        case "value":
                            m = v;
                        default:
                            $f60d5b61c638db60$var$J(a, d, e, v);
                    }
                }
                if (null != g) {
                    if (c = null !== m ? "" + m : $f60d5b61c638db60$var$La(h), $f60d5b61c638db60$var$ra(g)) {
                        for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                            a.push($f60d5b61c638db60$var$Ma);
                            break;
                        }
                    } else "" + g === c && a.push($f60d5b61c638db60$var$Ma);
                } else q && a.push($f60d5b61c638db60$var$Ma);
                a.push($f60d5b61c638db60$var$K);
                $f60d5b61c638db60$var$L(a, r, h);
                return h;
            case "textarea":
                a.push($f60d5b61c638db60$var$M("textarea"));
                r = g = e = null;
                for(h in c)if ($f60d5b61c638db60$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                    case "children":
                        r = m;
                        break;
                    case "value":
                        e = m;
                        break;
                    case "defaultValue":
                        g = m;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($f60d5b61c638db60$var$k(91));
                    default:
                        $f60d5b61c638db60$var$J(a, d, h, m);
                }
                null === e && null !== g && (e = g);
                a.push($f60d5b61c638db60$var$K);
                if (null != r) {
                    if (null != e) throw Error($f60d5b61c638db60$var$k(92));
                    if ($f60d5b61c638db60$var$ra(r) && 1 < r.length) throw Error($f60d5b61c638db60$var$k(93));
                    e = "" + r;
                }
                "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
                null !== e && a.push($f60d5b61c638db60$var$u($f60d5b61c638db60$var$C("" + e)));
                return null;
            case "input":
                a.push($f60d5b61c638db60$var$M("input"));
                m = r = h = e = null;
                for(g in c)if ($f60d5b61c638db60$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f60d5b61c638db60$var$k(399, "input"));
                    case "defaultChecked":
                        m = q;
                        break;
                    case "defaultValue":
                        h = q;
                        break;
                    case "checked":
                        r = q;
                        break;
                    case "value":
                        e = q;
                        break;
                    default:
                        $f60d5b61c638db60$var$J(a, d, g, q);
                }
                null !== r ? $f60d5b61c638db60$var$J(a, d, "checked", r) : null !== m && $f60d5b61c638db60$var$J(a, d, "checked", m);
                null !== e ? $f60d5b61c638db60$var$J(a, d, "value", e) : null !== h && $f60d5b61c638db60$var$J(a, d, "value", h);
                a.push($f60d5b61c638db60$var$Ka);
                return null;
            case "menuitem":
                a.push($f60d5b61c638db60$var$M("menuitem"));
                for(var A in c)if ($f60d5b61c638db60$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f60d5b61c638db60$var$k(400));
                    default:
                        $f60d5b61c638db60$var$J(a, d, A, e);
                }
                a.push($f60d5b61c638db60$var$K);
                return null;
            case "title":
                a.push($f60d5b61c638db60$var$M("title"));
                e = null;
                for(v in c)if ($f60d5b61c638db60$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                    case "children":
                        e = g;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($f60d5b61c638db60$var$k(434));
                    default:
                        $f60d5b61c638db60$var$J(a, d, v, g);
                }
                a.push($f60d5b61c638db60$var$K);
                return e;
            case "listing":
            case "pre":
                a.push($f60d5b61c638db60$var$M(b));
                g = e = null;
                for(m in c)if ($f60d5b61c638db60$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    default:
                        $f60d5b61c638db60$var$J(a, d, m, h);
                }
                a.push($f60d5b61c638db60$var$K);
                if (null != g) {
                    if (null != e) throw Error($f60d5b61c638db60$var$k(60));
                    if ("object" !== typeof g || !("__html" in g)) throw Error($f60d5b61c638db60$var$k(61));
                    c = g.__html;
                    null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($f60d5b61c638db60$var$Oa, $f60d5b61c638db60$var$u(c)) : a.push($f60d5b61c638db60$var$u("" + c)));
                }
                "string" === typeof e && "\n" === e[0] && a.push($f60d5b61c638db60$var$Oa);
                return e;
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                a.push($f60d5b61c638db60$var$M(b));
                for(var F in c)if ($f60d5b61c638db60$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f60d5b61c638db60$var$k(399, b));
                    default:
                        $f60d5b61c638db60$var$J(a, d, F, e);
                }
                a.push($f60d5b61c638db60$var$Ka);
                return null;
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return $f60d5b61c638db60$var$Na(a, c, b, d);
            case "html":
                return 0 === f.insertionMode && a.push($f60d5b61c638db60$var$Ra), $f60d5b61c638db60$var$Na(a, c, b, d);
            default:
                if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $f60d5b61c638db60$var$Na(a, c, b, d);
                a.push($f60d5b61c638db60$var$M(b));
                g = e = null;
                for(q in c)if ($f60d5b61c638db60$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "style":
                        $f60d5b61c638db60$var$Ia(a, d, h);
                        break;
                    case "suppressContentEditableWarning":
                    case "suppressHydrationWarning":
                        break;
                    default:
                        $f60d5b61c638db60$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($f60d5b61c638db60$var$H, $f60d5b61c638db60$var$u(q), $f60d5b61c638db60$var$I, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(h)), $f60d5b61c638db60$var$E);
                }
                a.push($f60d5b61c638db60$var$K);
                $f60d5b61c638db60$var$L(a, g, e);
                return e;
        }
    }
    var $f60d5b61c638db60$var$Ta = $f60d5b61c638db60$var$w("</"), $f60d5b61c638db60$var$Ua = $f60d5b61c638db60$var$w(">"), $f60d5b61c638db60$var$Va = $f60d5b61c638db60$var$w('<template id="'), $f60d5b61c638db60$var$Wa = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$Xa = $f60d5b61c638db60$var$w("\x3c!--$--\x3e"), $f60d5b61c638db60$var$Ya = $f60d5b61c638db60$var$w('\x3c!--$?--\x3e<template id="'), $f60d5b61c638db60$var$Za = $f60d5b61c638db60$var$w('"></template>'), $f60d5b61c638db60$var$$a = $f60d5b61c638db60$var$w("\x3c!--$!--\x3e"), $f60d5b61c638db60$var$ab = $f60d5b61c638db60$var$w("\x3c!--/$--\x3e"), $f60d5b61c638db60$var$bb = $f60d5b61c638db60$var$w("<template"), $f60d5b61c638db60$var$cb = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$db = $f60d5b61c638db60$var$w(' data-dgst="');
    $f60d5b61c638db60$var$w(' data-msg="');
    $f60d5b61c638db60$var$w(' data-stck="');
    var $f60d5b61c638db60$var$eb = $f60d5b61c638db60$var$w("></template>");
    function $f60d5b61c638db60$var$fb(a, b, c) {
        $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$Ya);
        if (null === c) throw Error($f60d5b61c638db60$var$k(395));
        $f60d5b61c638db60$var$p(a, c);
        return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Za);
    }
    var $f60d5b61c638db60$var$gb = $f60d5b61c638db60$var$w('<div hidden id="'), $f60d5b61c638db60$var$hb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ib = $f60d5b61c638db60$var$w("</div>"), $f60d5b61c638db60$var$jb = $f60d5b61c638db60$var$w('<svg aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$kb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$lb = $f60d5b61c638db60$var$w("</svg>"), $f60d5b61c638db60$var$mb = $f60d5b61c638db60$var$w('<math aria-hidden="true" style="display:none" id="'), $f60d5b61c638db60$var$nb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ob = $f60d5b61c638db60$var$w("</math>"), $f60d5b61c638db60$var$pb = $f60d5b61c638db60$var$w('<table hidden id="'), $f60d5b61c638db60$var$qb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$rb = $f60d5b61c638db60$var$w("</table>"), $f60d5b61c638db60$var$sb = $f60d5b61c638db60$var$w('<table hidden><tbody id="'), $f60d5b61c638db60$var$tb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$ub = $f60d5b61c638db60$var$w("</tbody></table>"), $f60d5b61c638db60$var$vb = $f60d5b61c638db60$var$w('<table hidden><tr id="'), $f60d5b61c638db60$var$wb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$xb = $f60d5b61c638db60$var$w("</tr></table>"), $f60d5b61c638db60$var$yb = $f60d5b61c638db60$var$w('<table hidden><colgroup id="'), $f60d5b61c638db60$var$zb = $f60d5b61c638db60$var$w('">'), $f60d5b61c638db60$var$Ab = $f60d5b61c638db60$var$w("</colgroup></table>");
    function $f60d5b61c638db60$var$Bb(a, b, c, d) {
        switch(c.insertionMode){
            case 0:
            case 1:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$gb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$hb);
            case 2:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$jb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$kb);
            case 3:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$mb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$nb);
            case 4:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$pb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$qb);
            case 5:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$sb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$tb);
            case 6:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$vb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$wb);
            case 7:
                return $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$yb), $f60d5b61c638db60$var$p(a, b.segmentPrefix), $f60d5b61c638db60$var$p(a, $f60d5b61c638db60$var$u(d.toString(16))), $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$zb);
            default:
                throw Error($f60d5b61c638db60$var$k(397));
        }
    }
    function $f60d5b61c638db60$var$Cb(a, b) {
        switch(b.insertionMode){
            case 0:
            case 1:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ib);
            case 2:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$lb);
            case 3:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ob);
            case 4:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$rb);
            case 5:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$ub);
            case 6:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$xb);
            case 7:
                return $f60d5b61c638db60$var$t(a, $f60d5b61c638db60$var$Ab);
            default:
                throw Error($f60d5b61c638db60$var$k(397));
        }
    }
    var $f60d5b61c638db60$var$Db = $f60d5b61c638db60$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $f60d5b61c638db60$var$Eb = $f60d5b61c638db60$var$w('$RS("'), $f60d5b61c638db60$var$Gb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Hb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Ib = $f60d5b61c638db60$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $f60d5b61c638db60$var$Jb = $f60d5b61c638db60$var$w('$RC("'), $f60d5b61c638db60$var$Kb = $f60d5b61c638db60$var$w('","'), $f60d5b61c638db60$var$Lb = $f60d5b61c638db60$var$w('")\x3c/script>'), $f60d5b61c638db60$var$Mb = $f60d5b61c638db60$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $f60d5b61c638db60$var$Nb = $f60d5b61c638db60$var$w('$RX("'), $f60d5b61c638db60$var$Ob = $f60d5b61c638db60$var$w('"'), $f60d5b61c638db60$var$Pb = $f60d5b61c638db60$var$w(")\x3c/script>"), $f60d5b61c638db60$var$Qb = $f60d5b61c638db60$var$w(","), $f60d5b61c638db60$var$Rb = /[<\u2028\u2029]/g;
    function $f60d5b61c638db60$var$Sb(a) {
        return JSON.stringify(a).replace($f60d5b61c638db60$var$Rb, function(a) {
            switch(a){
                case "<":
                    return "\\u003c";
                case "\u2028":
                    return "\\u2028";
                case "\u2029":
                    return "\\u2029";
                default:
                    throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
            }
        });
    }
    var $f60d5b61c638db60$var$N = Object.assign, $f60d5b61c638db60$var$Tb = Symbol.for("react.element"), $f60d5b61c638db60$var$Ub = Symbol.for("react.portal"), $f60d5b61c638db60$var$Vb = Symbol.for("react.fragment"), $f60d5b61c638db60$var$Wb = Symbol.for("react.strict_mode"), $f60d5b61c638db60$var$Xb = Symbol.for("react.profiler"), $f60d5b61c638db60$var$Yb = Symbol.for("react.provider"), $f60d5b61c638db60$var$Zb = Symbol.for("react.context"), $f60d5b61c638db60$var$$b = Symbol.for("react.forward_ref"), $f60d5b61c638db60$var$ac = Symbol.for("react.suspense"), $f60d5b61c638db60$var$bc = Symbol.for("react.suspense_list"), $f60d5b61c638db60$var$cc = Symbol.for("react.memo"), $f60d5b61c638db60$var$dc = Symbol.for("react.lazy"), $f60d5b61c638db60$var$ec = Symbol.for("react.scope"), $f60d5b61c638db60$var$fc = Symbol.for("react.debug_trace_mode"), $f60d5b61c638db60$var$gc = Symbol.for("react.legacy_hidden"), $f60d5b61c638db60$var$hc = Symbol.for("react.default_value"), $f60d5b61c638db60$var$ic = Symbol.iterator;
    function $f60d5b61c638db60$var$jc(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case $f60d5b61c638db60$var$Vb:
                return "Fragment";
            case $f60d5b61c638db60$var$Ub:
                return "Portal";
            case $f60d5b61c638db60$var$Xb:
                return "Profiler";
            case $f60d5b61c638db60$var$Wb:
                return "StrictMode";
            case $f60d5b61c638db60$var$ac:
                return "Suspense";
            case $f60d5b61c638db60$var$bc:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case $f60d5b61c638db60$var$Zb:
                return (a.displayName || "Context") + ".Consumer";
            case $f60d5b61c638db60$var$Yb:
                return (a._context.displayName || "Context") + ".Provider";
            case $f60d5b61c638db60$var$$b:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case $f60d5b61c638db60$var$cc:
                return b = a.displayName || null, null !== b ? b : $f60d5b61c638db60$var$jc(a.type) || "Memo";
            case $f60d5b61c638db60$var$dc:
                b = a._payload;
                a = a._init;
                try {
                    return $f60d5b61c638db60$var$jc(a(b));
                } catch (c) {}
        }
        return null;
    }
    var $f60d5b61c638db60$var$kc = {};
    function $f60d5b61c638db60$var$lc(a, b) {
        a = a.contextTypes;
        if (!a) return $f60d5b61c638db60$var$kc;
        var c = {}, d;
        for(d in a)c[d] = b[d];
        return c;
    }
    var $f60d5b61c638db60$var$O = null;
    function $f60d5b61c638db60$var$P(a, b) {
        if (a !== b) {
            a.context._currentValue = a.parentValue;
            a = a.parent;
            var c = b.parent;
            if (null === a) {
                if (null !== c) throw Error($f60d5b61c638db60$var$k(401));
            } else {
                if (null === c) throw Error($f60d5b61c638db60$var$k(401));
                $f60d5b61c638db60$var$P(a, c);
            }
            b.context._currentValue = b.value;
        }
    }
    function $f60d5b61c638db60$var$mc(a) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        null !== a && $f60d5b61c638db60$var$mc(a);
    }
    function $f60d5b61c638db60$var$nc(a) {
        var b = a.parent;
        null !== b && $f60d5b61c638db60$var$nc(b);
        a.context._currentValue = a.value;
    }
    function $f60d5b61c638db60$var$oc(a, b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        if (null === a) throw Error($f60d5b61c638db60$var$k(402));
        a.depth === b.depth ? $f60d5b61c638db60$var$P(a, b) : $f60d5b61c638db60$var$oc(a, b);
    }
    function $f60d5b61c638db60$var$pc(a, b) {
        var c = b.parent;
        if (null === c) throw Error($f60d5b61c638db60$var$k(402));
        a.depth === c.depth ? $f60d5b61c638db60$var$P(a, c) : $f60d5b61c638db60$var$pc(a, c);
        b.context._currentValue = b.value;
    }
    function $f60d5b61c638db60$var$Q(a) {
        var b = $f60d5b61c638db60$var$O;
        b !== a && (null === b ? $f60d5b61c638db60$var$nc(a) : null === a ? $f60d5b61c638db60$var$mc(b) : b.depth === a.depth ? $f60d5b61c638db60$var$P(b, a) : b.depth > a.depth ? $f60d5b61c638db60$var$oc(b, a) : $f60d5b61c638db60$var$pc(b, a), $f60d5b61c638db60$var$O = a);
    }
    var $f60d5b61c638db60$var$qc = {
        isMounted: function() {
            return !1;
        },
        enqueueSetState: function(a, b) {
            a = a._reactInternals;
            null !== a.queue && a.queue.push(b);
        },
        enqueueReplaceState: function(a, b) {
            a = a._reactInternals;
            a.replace = !0;
            a.queue = [
                b
            ];
        },
        enqueueForceUpdate: function() {}
    };
    function $f60d5b61c638db60$var$rc(a, b, c, d) {
        var f = void 0 !== a.state ? a.state : null;
        a.updater = $f60d5b61c638db60$var$qc;
        a.props = c;
        a.state = f;
        var e = {
            queue: [],
            replace: !1
        };
        a._reactInternals = e;
        var g = b.contextType;
        a.context = "object" === typeof g && null !== g ? g._currentValue : d;
        g = b.getDerivedStateFromProps;
        "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $f60d5b61c638db60$var$N({}, f, g), a.state = f);
        if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
            if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $f60d5b61c638db60$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
                if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
                else {
                    e = g ? b[0] : a.state;
                    f = !0;
                    for(g = g ? 1 : 0; g < b.length; g++){
                        var h = b[g];
                        h = "function" === typeof h ? h.call(a, e, c, d) : h;
                        null != h && (f ? (f = !1, e = $f60d5b61c638db60$var$N({}, e, h)) : $f60d5b61c638db60$var$N(e, h));
                    }
                    a.state = e;
                }
            } else e.queue = null;
        }
    }
    var $f60d5b61c638db60$var$sc = {
        id: 1,
        overflow: ""
    };
    function $f60d5b61c638db60$var$tc(a, b, c) {
        var d = a.id;
        a = a.overflow;
        var f = 32 - $f60d5b61c638db60$var$uc(d) - 1;
        d &= ~(1 << f);
        c += 1;
        var e = 32 - $f60d5b61c638db60$var$uc(b) + f;
        if (30 < e) {
            var g = f - f % 5;
            e = (d & (1 << g) - 1).toString(32);
            d >>= g;
            f -= g;
            return {
                id: 1 << 32 - $f60d5b61c638db60$var$uc(b) + f | c << f | d,
                overflow: e + a
            };
        }
        return {
            id: 1 << e | c << f | d,
            overflow: a
        };
    }
    var $f60d5b61c638db60$var$uc = Math.clz32 ? Math.clz32 : $f60d5b61c638db60$var$vc, $f60d5b61c638db60$var$wc = Math.log, $f60d5b61c638db60$var$xc = Math.LN2;
    function $f60d5b61c638db60$var$vc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - ($f60d5b61c638db60$var$wc(a) / $f60d5b61c638db60$var$xc | 0) | 0;
    }
    function $f60d5b61c638db60$var$yc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var $f60d5b61c638db60$var$zc = "function" === typeof Object.is ? Object.is : $f60d5b61c638db60$var$yc, $f60d5b61c638db60$var$R = null, $f60d5b61c638db60$var$Ac = null, $f60d5b61c638db60$var$Bc = null, $f60d5b61c638db60$var$S = null, $f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$V = null, $f60d5b61c638db60$var$Dc = 0;
    function $f60d5b61c638db60$var$W() {
        if (null === $f60d5b61c638db60$var$R) throw Error($f60d5b61c638db60$var$k(321));
        return $f60d5b61c638db60$var$R;
    }
    function $f60d5b61c638db60$var$Ec() {
        if (0 < $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(312));
        return {
            memoizedState: null,
            queue: null,
            next: null
        };
    }
    function $f60d5b61c638db60$var$Fc() {
        null === $f60d5b61c638db60$var$S ? null === $f60d5b61c638db60$var$Bc ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$Bc = $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Bc) : null === $f60d5b61c638db60$var$S.next ? ($f60d5b61c638db60$var$T = !1, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next = $f60d5b61c638db60$var$Ec()) : ($f60d5b61c638db60$var$T = !0, $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$S.next);
        return $f60d5b61c638db60$var$S;
    }
    function $f60d5b61c638db60$var$Gc() {
        $f60d5b61c638db60$var$Ac = $f60d5b61c638db60$var$R = null;
        $f60d5b61c638db60$var$Cc = !1;
        $f60d5b61c638db60$var$Bc = null;
        $f60d5b61c638db60$var$Dc = 0;
        $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$V = null;
    }
    function $f60d5b61c638db60$var$Hc(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function $f60d5b61c638db60$var$Ic(a, b, c) {
        $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
        $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
        if ($f60d5b61c638db60$var$T) {
            var d = $f60d5b61c638db60$var$S.queue;
            b = d.dispatch;
            if (null !== $f60d5b61c638db60$var$V && (c = $f60d5b61c638db60$var$V.get(d), void 0 !== c)) {
                $f60d5b61c638db60$var$V.delete(d);
                d = $f60d5b61c638db60$var$S.memoizedState;
                do d = a(d, c.action), c = c.next;
                while (null !== c)
                $f60d5b61c638db60$var$S.memoizedState = d;
                return [
                    d,
                    b
                ];
            }
            return [
                $f60d5b61c638db60$var$S.memoizedState,
                b
            ];
        }
        a = a === $f60d5b61c638db60$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
        $f60d5b61c638db60$var$S.memoizedState = a;
        a = $f60d5b61c638db60$var$S.queue = {
            last: null,
            dispatch: null
        };
        a = a.dispatch = $f60d5b61c638db60$var$Jc.bind(null, $f60d5b61c638db60$var$R, a);
        return [
            $f60d5b61c638db60$var$S.memoizedState,
            a
        ];
    }
    function $f60d5b61c638db60$var$Kc(a, b) {
        $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
        $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
        b = void 0 === b ? null : b;
        if (null !== $f60d5b61c638db60$var$S) {
            var c = $f60d5b61c638db60$var$S.memoizedState;
            if (null !== c && null !== b) {
                var d = c[1];
                a: if (null === d) d = !1;
                else {
                    for(var f = 0; f < d.length && f < b.length; f++)if (!$f60d5b61c638db60$var$zc(b[f], d[f])) {
                        d = !1;
                        break a;
                    }
                    d = !0;
                }
                if (d) return c[0];
            }
        }
        a = a();
        $f60d5b61c638db60$var$S.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function $f60d5b61c638db60$var$Jc(a, b, c) {
        if (25 <= $f60d5b61c638db60$var$Dc) throw Error($f60d5b61c638db60$var$k(301));
        if (a === $f60d5b61c638db60$var$R) {
            if ($f60d5b61c638db60$var$Cc = !0, a = {
                action: c,
                next: null
            }, null === $f60d5b61c638db60$var$V && ($f60d5b61c638db60$var$V = new Map), c = $f60d5b61c638db60$var$V.get(b), void 0 === c) $f60d5b61c638db60$var$V.set(b, a);
            else {
                for(b = c; null !== b.next;)b = b.next;
                b.next = a;
            }
        }
    }
    function $f60d5b61c638db60$var$Lc() {
        throw Error($f60d5b61c638db60$var$k(394));
    }
    function $f60d5b61c638db60$var$Mc() {}
    var $f60d5b61c638db60$var$Oc = {
        readContext: function(a) {
            return a._currentValue;
        },
        useContext: function(a) {
            $f60d5b61c638db60$var$W();
            return a._currentValue;
        },
        useMemo: $f60d5b61c638db60$var$Kc,
        useReducer: $f60d5b61c638db60$var$Ic,
        useRef: function(a) {
            $f60d5b61c638db60$var$R = $f60d5b61c638db60$var$W();
            $f60d5b61c638db60$var$S = $f60d5b61c638db60$var$Fc();
            var b = $f60d5b61c638db60$var$S.memoizedState;
            return null === b ? (a = {
                current: a
            }, $f60d5b61c638db60$var$S.memoizedState = a) : b;
        },
        useState: function(a) {
            return $f60d5b61c638db60$var$Ic($f60d5b61c638db60$var$Hc, a);
        },
        useInsertionEffect: $f60d5b61c638db60$var$Mc,
        useLayoutEffect: function() {},
        useCallback: function(a, b) {
            return $f60d5b61c638db60$var$Kc(function() {
                return a;
            }, b);
        },
        useImperativeHandle: $f60d5b61c638db60$var$Mc,
        useEffect: $f60d5b61c638db60$var$Mc,
        useDebugValue: $f60d5b61c638db60$var$Mc,
        useDeferredValue: function(a) {
            $f60d5b61c638db60$var$W();
            return a;
        },
        useTransition: function() {
            $f60d5b61c638db60$var$W();
            return [
                !1,
                $f60d5b61c638db60$var$Lc
            ];
        },
        useId: function() {
            var a = $f60d5b61c638db60$var$Ac.treeContext;
            var b = a.overflow;
            a = a.id;
            a = (a & ~(1 << 32 - $f60d5b61c638db60$var$uc(a) - 1)).toString(32) + b;
            var c = $f60d5b61c638db60$var$Nc;
            if (null === c) throw Error($f60d5b61c638db60$var$k(404));
            b = $f60d5b61c638db60$var$U++;
            a = ":" + c.idPrefix + "R" + a;
            0 < b && (a += "H" + b.toString(32));
            return a + ":";
        },
        useMutableSource: function(a, b) {
            $f60d5b61c638db60$var$W();
            return b(a._source);
        },
        useSyncExternalStore: function(a, b, c) {
            if (void 0 === c) throw Error($f60d5b61c638db60$var$k(407));
            return c();
        }
    }, $f60d5b61c638db60$var$Nc = null, $f60d5b61c638db60$var$Pc = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
    function $f60d5b61c638db60$var$Qc(a) {
        console.error(a);
        return null;
    }
    function $f60d5b61c638db60$var$X() {}
    function $f60d5b61c638db60$var$Rc(a, b, c, d, f, e, g, h, m) {
        var q = [], r = new Set;
        b = {
            destination: null,
            responseState: b,
            progressiveChunkSize: void 0 === d ? 12800 : d,
            status: 0,
            fatalError: null,
            nextSegmentId: 0,
            allPendingTasks: 0,
            pendingRootTasks: 0,
            completedRootSegment: null,
            abortableTasks: r,
            pingedTasks: q,
            clientRenderedBoundaries: [],
            completedBoundaries: [],
            partialBoundaries: [],
            onError: void 0 === f ? $f60d5b61c638db60$var$Qc : f,
            onAllReady: void 0 === e ? $f60d5b61c638db60$var$X : e,
            onShellReady: void 0 === g ? $f60d5b61c638db60$var$X : g,
            onShellError: void 0 === h ? $f60d5b61c638db60$var$X : h,
            onFatalError: void 0 === m ? $f60d5b61c638db60$var$X : m
        };
        c = $f60d5b61c638db60$var$Sc(b, 0, null, c, !1, !1);
        c.parentFlushed = !0;
        a = $f60d5b61c638db60$var$Tc(b, a, null, c, r, $f60d5b61c638db60$var$kc, null, $f60d5b61c638db60$var$sc);
        q.push(a);
        return b;
    }
    function $f60d5b61c638db60$var$Tc(a, b, c, d, f, e, g, h) {
        a.allPendingTasks++;
        null === c ? a.pendingRootTasks++ : c.pendingTasks++;
        var m = {
            node: b,
            ping: function() {
                var b = a.pingedTasks;
                b.push(m);
                1 === b.length && $f60d5b61c638db60$var$Uc(a);
            },
            blockedBoundary: c,
            blockedSegment: d,
            abortSet: f,
            legacyContext: e,
            context: g,
            treeContext: h
        };
        f.add(m);
        return m;
    }
    function $f60d5b61c638db60$var$Sc(a, b, c, d, f, e) {
        return {
            status: 0,
            id: -1,
            index: b,
            parentFlushed: !1,
            chunks: [],
            children: [],
            formatContext: d,
            boundary: c,
            lastPushedText: f,
            textEmbedded: e
        };
    }
    function $f60d5b61c638db60$var$Y(a, b) {
        a = a.onError(b);
        if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
        return a;
    }
    function $f60d5b61c638db60$var$Vc(a, b) {
        var c = a.onShellError;
        c(b);
        c = a.onFatalError;
        c(b);
        null !== a.destination ? (a.status = 2, $f60d5b61c638db60$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
    }
    function $f60d5b61c638db60$var$Wc(a, b, c, d, f) {
        $f60d5b61c638db60$var$R = {};
        $f60d5b61c638db60$var$Ac = b;
        $f60d5b61c638db60$var$U = 0;
        for(a = c(d, f); $f60d5b61c638db60$var$Cc;)$f60d5b61c638db60$var$Cc = !1, $f60d5b61c638db60$var$U = 0, $f60d5b61c638db60$var$Dc += 1, $f60d5b61c638db60$var$S = null, a = c(d, f);
        $f60d5b61c638db60$var$Gc();
        return a;
    }
    function $f60d5b61c638db60$var$Xc(a, b, c, d) {
        var f = c.render(), e = d.childContextTypes;
        if (null !== e && void 0 !== e) {
            var g = b.legacyContext;
            if ("function" !== typeof c.getChildContext) d = g;
            else {
                c = c.getChildContext();
                for(var h in c)if (!(h in e)) throw Error($f60d5b61c638db60$var$k(108, $f60d5b61c638db60$var$jc(d) || "Unknown", h));
                d = $f60d5b61c638db60$var$N({}, g, c);
            }
            b.legacyContext = d;
            $f60d5b61c638db60$var$Z(a, b, f);
            b.legacyContext = g;
        } else $f60d5b61c638db60$var$Z(a, b, f);
    }
    function $f60d5b61c638db60$var$Yc(a, b) {
        if (a && a.defaultProps) {
            b = $f60d5b61c638db60$var$N({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    function $f60d5b61c638db60$var$Zc(a, b, c, d, f) {
        if ("function" === typeof c) {
            if (c.prototype && c.prototype.isReactComponent) {
                f = $f60d5b61c638db60$var$lc(c, b.legacyContext);
                var e = c.contextType;
                e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
                $f60d5b61c638db60$var$rc(e, c, d, f);
                $f60d5b61c638db60$var$Xc(a, b, e, c);
            } else {
                e = $f60d5b61c638db60$var$lc(c, b.legacyContext);
                f = $f60d5b61c638db60$var$Wc(a, b, c, d, e);
                var g = 0 !== $f60d5b61c638db60$var$U;
                if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $f60d5b61c638db60$var$rc(f, c, d, e), $f60d5b61c638db60$var$Xc(a, b, f, c);
                else if (g) {
                    d = b.treeContext;
                    b.treeContext = $f60d5b61c638db60$var$tc(d, 1, 0);
                    try {
                        $f60d5b61c638db60$var$Z(a, b, f);
                    } finally{
                        b.treeContext = d;
                    }
                } else $f60d5b61c638db60$var$Z(a, b, f);
            }
        } else if ("string" === typeof c) {
            f = b.blockedSegment;
            e = $f60d5b61c638db60$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
            f.lastPushedText = !1;
            g = f.formatContext;
            f.formatContext = $f60d5b61c638db60$var$Ba(g, c, d);
            $f60d5b61c638db60$var$$c(a, b, e);
            f.formatContext = g;
            switch(c){
                case "area":
                case "base":
                case "br":
                case "col":
                case "embed":
                case "hr":
                case "img":
                case "input":
                case "keygen":
                case "link":
                case "meta":
                case "param":
                case "source":
                case "track":
                case "wbr":
                    break;
                default:
                    f.chunks.push($f60d5b61c638db60$var$Ta, $f60d5b61c638db60$var$u(c), $f60d5b61c638db60$var$Ua);
            }
            f.lastPushedText = !1;
        } else {
            switch(c){
                case $f60d5b61c638db60$var$gc:
                case $f60d5b61c638db60$var$fc:
                case $f60d5b61c638db60$var$Wb:
                case $f60d5b61c638db60$var$Xb:
                case $f60d5b61c638db60$var$Vb:
                    $f60d5b61c638db60$var$Z(a, b, d.children);
                    return;
                case $f60d5b61c638db60$var$bc:
                    $f60d5b61c638db60$var$Z(a, b, d.children);
                    return;
                case $f60d5b61c638db60$var$ec:
                    throw Error($f60d5b61c638db60$var$k(343));
                case $f60d5b61c638db60$var$ac:
                    a: {
                        c = b.blockedBoundary;
                        f = b.blockedSegment;
                        e = d.fallback;
                        d = d.children;
                        g = new Set;
                        var h = {
                            id: null,
                            rootSegmentID: -1,
                            parentFlushed: !1,
                            pendingTasks: 0,
                            forceClientRender: !1,
                            completedSegments: [],
                            byteSize: 0,
                            fallbackAbortableTasks: g,
                            errorDigest: null
                        }, m = $f60d5b61c638db60$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                        f.children.push(m);
                        f.lastPushedText = !1;
                        var q = $f60d5b61c638db60$var$Sc(a, 0, null, f.formatContext, !1, !1);
                        q.parentFlushed = !0;
                        b.blockedBoundary = h;
                        b.blockedSegment = q;
                        try {
                            if ($f60d5b61c638db60$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($f60d5b61c638db60$var$Ca), q.status = 1, $f60d5b61c638db60$var$ad(h, q), 0 === h.pendingTasks) break a;
                        } catch (r) {
                            q.status = 4, h.forceClientRender = !0, h.errorDigest = $f60d5b61c638db60$var$Y(a, r);
                        } finally{
                            b.blockedBoundary = c, b.blockedSegment = f;
                        }
                        b = $f60d5b61c638db60$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                        a.pingedTasks.push(b);
                    }
                    return;
            }
            if ("object" === typeof c && null !== c) switch(c.$$typeof){
                case $f60d5b61c638db60$var$$b:
                    d = $f60d5b61c638db60$var$Wc(a, b, c.render, d, f);
                    if (0 !== $f60d5b61c638db60$var$U) {
                        c = b.treeContext;
                        b.treeContext = $f60d5b61c638db60$var$tc(c, 1, 0);
                        try {
                            $f60d5b61c638db60$var$Z(a, b, d);
                        } finally{
                            b.treeContext = c;
                        }
                    } else $f60d5b61c638db60$var$Z(a, b, d);
                    return;
                case $f60d5b61c638db60$var$cc:
                    c = c.type;
                    d = $f60d5b61c638db60$var$Yc(c, d);
                    $f60d5b61c638db60$var$Zc(a, b, c, d, f);
                    return;
                case $f60d5b61c638db60$var$Yb:
                    f = d.children;
                    c = c._context;
                    d = d.value;
                    e = c._currentValue;
                    c._currentValue = d;
                    g = $f60d5b61c638db60$var$O;
                    $f60d5b61c638db60$var$O = d = {
                        parent: g,
                        depth: null === g ? 0 : g.depth + 1,
                        context: c,
                        parentValue: e,
                        value: d
                    };
                    b.context = d;
                    $f60d5b61c638db60$var$Z(a, b, f);
                    a = $f60d5b61c638db60$var$O;
                    if (null === a) throw Error($f60d5b61c638db60$var$k(403));
                    d = a.parentValue;
                    a.context._currentValue = d === $f60d5b61c638db60$var$hc ? a.context._defaultValue : d;
                    a = $f60d5b61c638db60$var$O = a.parent;
                    b.context = a;
                    return;
                case $f60d5b61c638db60$var$Zb:
                    d = d.children;
                    d = d(c._currentValue);
                    $f60d5b61c638db60$var$Z(a, b, d);
                    return;
                case $f60d5b61c638db60$var$dc:
                    f = c._init;
                    c = f(c._payload);
                    d = $f60d5b61c638db60$var$Yc(c, d);
                    $f60d5b61c638db60$var$Zc(a, b, c, d, void 0);
                    return;
            }
            throw Error($f60d5b61c638db60$var$k(130, null == c ? c : typeof c, ""));
        }
    }
    function $f60d5b61c638db60$var$Z(a, b, c) {
        b.node = c;
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f60d5b61c638db60$var$Tb:
                    $f60d5b61c638db60$var$Zc(a, b, c.type, c.props, c.ref);
                    return;
                case $f60d5b61c638db60$var$Ub:
                    throw Error($f60d5b61c638db60$var$k(257));
                case $f60d5b61c638db60$var$dc:
                    var d = c._init;
                    c = d(c._payload);
                    $f60d5b61c638db60$var$Z(a, b, c);
                    return;
            }
            if ($f60d5b61c638db60$var$ra(c)) {
                $f60d5b61c638db60$var$bd(a, b, c);
                return;
            }
            null === c || "object" !== typeof c ? d = null : (d = $f60d5b61c638db60$var$ic && c[$f60d5b61c638db60$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
            if (d && (d = d.call(c))) {
                c = d.next();
                if (!c.done) {
                    var f = [];
                    do f.push(c.value), c = d.next();
                    while (!c.done)
                    $f60d5b61c638db60$var$bd(a, b, f);
                }
                return;
            }
            a = Object.prototype.toString.call(c);
            throw Error($f60d5b61c638db60$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
        }
        "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $f60d5b61c638db60$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
    }
    function $f60d5b61c638db60$var$bd(a, b, c) {
        for(var d = c.length, f = 0; f < d; f++){
            var e = b.treeContext;
            b.treeContext = $f60d5b61c638db60$var$tc(e, d, f);
            try {
                $f60d5b61c638db60$var$$c(a, b, c[f]);
            } finally{
                b.treeContext = e;
            }
        }
    }
    function $f60d5b61c638db60$var$$c(a, b, c) {
        var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
        try {
            return $f60d5b61c638db60$var$Z(a, b, c);
        } catch (m) {
            if ($f60d5b61c638db60$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
                c = m;
                var g = b.blockedSegment, h = $f60d5b61c638db60$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
                g.children.push(h);
                g.lastPushedText = !1;
                a = $f60d5b61c638db60$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
                c.then(a, a);
                b.blockedSegment.formatContext = d;
                b.legacyContext = f;
                b.context = e;
                $f60d5b61c638db60$var$Q(e);
            } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $f60d5b61c638db60$var$Q(e), m;
        }
    }
    function $f60d5b61c638db60$var$cd(a) {
        var b = a.blockedBoundary;
        a = a.blockedSegment;
        a.status = 3;
        $f60d5b61c638db60$var$dd(this, b, a);
    }
    function $f60d5b61c638db60$var$ed(a, b, c) {
        var d = a.blockedBoundary;
        a.blockedSegment.status = 3;
        null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($f60d5b61c638db60$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
            return $f60d5b61c638db60$var$ed(a, b, c);
        }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
    }
    function $f60d5b61c638db60$var$ad(a, b) {
        if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
            var c = b.children[0];
            c.id = b.id;
            c.parentFlushed = !0;
            1 === c.status && $f60d5b61c638db60$var$ad(a, c);
        } else a.completedSegments.push(b);
    }
    function $f60d5b61c638db60$var$dd(a, b, c) {
        if (null === b) {
            if (c.parentFlushed) {
                if (null !== a.completedRootSegment) throw Error($f60d5b61c638db60$var$k(389));
                a.completedRootSegment = c;
            }
            a.pendingRootTasks--;
            0 === a.pendingRootTasks && (a.onShellError = $f60d5b61c638db60$var$X, b = a.onShellReady, b());
        } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $f60d5b61c638db60$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($f60d5b61c638db60$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($f60d5b61c638db60$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
        a.allPendingTasks--;
        0 === a.allPendingTasks && (a = a.onAllReady, a());
    }
    function $f60d5b61c638db60$var$Uc(a) {
        if (2 !== a.status) {
            var b = $f60d5b61c638db60$var$O, c = $f60d5b61c638db60$var$Pc.current;
            $f60d5b61c638db60$var$Pc.current = $f60d5b61c638db60$var$Oc;
            var d = $f60d5b61c638db60$var$Nc;
            $f60d5b61c638db60$var$Nc = a.responseState;
            try {
                var f = a.pingedTasks, e;
                for(e = 0; e < f.length; e++){
                    var g = f[e];
                    var h = a, m = g.blockedSegment;
                    if (0 === m.status) {
                        $f60d5b61c638db60$var$Q(g.context);
                        try {
                            $f60d5b61c638db60$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($f60d5b61c638db60$var$Ca), g.abortSet.delete(g), m.status = 1, $f60d5b61c638db60$var$dd(h, g.blockedBoundary, m);
                        } catch (G) {
                            if ($f60d5b61c638db60$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                                var q = g.ping;
                                G.then(q, q);
                            } else {
                                g.abortSet.delete(g);
                                m.status = 4;
                                var r = g.blockedBoundary, v = G, A = $f60d5b61c638db60$var$Y(h, v);
                                null === r ? $f60d5b61c638db60$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                                h.allPendingTasks--;
                                if (0 === h.allPendingTasks) {
                                    var F = h.onAllReady;
                                    F();
                                }
                            }
                        } finally{}
                    }
                }
                f.splice(0, e);
                null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
            } catch (G) {
                $f60d5b61c638db60$var$Y(a, G), $f60d5b61c638db60$var$Vc(a, G);
            } finally{
                $f60d5b61c638db60$var$Nc = d, $f60d5b61c638db60$var$Pc.current = c, c === $f60d5b61c638db60$var$Oc && $f60d5b61c638db60$var$Q(b);
            }
        }
    }
    function $f60d5b61c638db60$var$gd(a, b, c) {
        c.parentFlushed = !0;
        switch(c.status){
            case 0:
                var d = c.id = a.nextSegmentId++;
                c.lastPushedText = !1;
                c.textEmbedded = !1;
                a = a.responseState;
                $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Va);
                $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
                a = $f60d5b61c638db60$var$u(d.toString(16));
                $f60d5b61c638db60$var$p(b, a);
                return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Wa);
            case 1:
                c.status = 2;
                var f = !0;
                d = c.chunks;
                var e = 0;
                c = c.children;
                for(var g = 0; g < c.length; g++){
                    for(f = c[g]; e < f.index; e++)$f60d5b61c638db60$var$p(b, d[e]);
                    f = $f60d5b61c638db60$var$hd(a, b, f);
                }
                for(; e < d.length - 1; e++)$f60d5b61c638db60$var$p(b, d[e]);
                e < d.length && (f = $f60d5b61c638db60$var$t(b, d[e]));
                return f;
            default:
                throw Error($f60d5b61c638db60$var$k(390));
        }
    }
    function $f60d5b61c638db60$var$hd(a, b, c) {
        var d = c.boundary;
        if (null === d) return $f60d5b61c638db60$var$gd(a, b, c);
        d.parentFlushed = !0;
        if (d.forceClientRender) d = d.errorDigest, $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$$a), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$bb), d && ($f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$db), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$C(d))), $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$cb)), $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$eb), $f60d5b61c638db60$var$gd(a, b, c);
        else if (0 < d.pendingTasks) {
            d.rootSegmentID = a.nextSegmentId++;
            0 < d.completedSegments.length && a.partialBoundaries.push(d);
            var f = a.responseState;
            var e = f.nextSuspenseID++;
            f = $f60d5b61c638db60$var$w(f.boundaryPrefix + e.toString(16));
            d = d.id = f;
            $f60d5b61c638db60$var$fb(b, a.responseState, d);
            $f60d5b61c638db60$var$gd(a, b, c);
        } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $f60d5b61c638db60$var$fb(b, a.responseState, d.id), $f60d5b61c638db60$var$gd(a, b, c);
        else {
            $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Xa);
            c = d.completedSegments;
            if (1 !== c.length) throw Error($f60d5b61c638db60$var$k(391));
            $f60d5b61c638db60$var$hd(a, b, c[0]);
        }
        return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$ab);
    }
    function $f60d5b61c638db60$var$id(a, b, c) {
        $f60d5b61c638db60$var$Bb(b, a.responseState, c.formatContext, c.id);
        $f60d5b61c638db60$var$hd(a, b, c);
        return $f60d5b61c638db60$var$Cb(b, c.formatContext);
    }
    function $f60d5b61c638db60$var$jd(a, b, c) {
        for(var d = c.completedSegments, f = 0; f < d.length; f++)$f60d5b61c638db60$var$kd(a, b, c, d[f]);
        d.length = 0;
        a = a.responseState;
        d = c.id;
        c = c.rootSegmentID;
        $f60d5b61c638db60$var$p(b, a.startInlineScript);
        a.sentCompleteBoundaryFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Ib));
        if (null === d) throw Error($f60d5b61c638db60$var$k(395));
        c = $f60d5b61c638db60$var$u(c.toString(16));
        $f60d5b61c638db60$var$p(b, d);
        $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Kb);
        $f60d5b61c638db60$var$p(b, a.segmentPrefix);
        $f60d5b61c638db60$var$p(b, c);
        return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Lb);
    }
    function $f60d5b61c638db60$var$kd(a, b, c, d) {
        if (2 === d.status) return !0;
        var f = d.id;
        if (-1 === f) {
            if (-1 === (d.id = c.rootSegmentID)) throw Error($f60d5b61c638db60$var$k(392));
            return $f60d5b61c638db60$var$id(a, b, d);
        }
        $f60d5b61c638db60$var$id(a, b, d);
        a = a.responseState;
        $f60d5b61c638db60$var$p(b, a.startInlineScript);
        a.sentCompleteSegmentFunction ? $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Eb) : (a.sentCompleteSegmentFunction = !0, $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Db));
        $f60d5b61c638db60$var$p(b, a.segmentPrefix);
        f = $f60d5b61c638db60$var$u(f.toString(16));
        $f60d5b61c638db60$var$p(b, f);
        $f60d5b61c638db60$var$p(b, $f60d5b61c638db60$var$Gb);
        $f60d5b61c638db60$var$p(b, a.placeholderPrefix);
        $f60d5b61c638db60$var$p(b, f);
        return $f60d5b61c638db60$var$t(b, $f60d5b61c638db60$var$Hb);
    }
    function $f60d5b61c638db60$var$fd(a, b) {
        $f60d5b61c638db60$var$l = new Uint8Array(512);
        $f60d5b61c638db60$var$n = 0;
        try {
            var c = a.completedRootSegment;
            if (null !== c && 0 === a.pendingRootTasks) {
                $f60d5b61c638db60$var$hd(a, b, c);
                a.completedRootSegment = null;
                var d = a.responseState.bootstrapChunks;
                for(c = 0; c < d.length - 1; c++)$f60d5b61c638db60$var$p(b, d[c]);
                c < d.length && $f60d5b61c638db60$var$t(b, d[c]);
            }
            var f = a.clientRenderedBoundaries, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                d = b;
                var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
                $f60d5b61c638db60$var$p(d, h.startInlineScript);
                h.sentClientRenderFunction ? $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Nb) : (h.sentClientRenderFunction = !0, $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Mb));
                if (null === m) throw Error($f60d5b61c638db60$var$k(395));
                $f60d5b61c638db60$var$p(d, m);
                $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Ob);
                if (q || r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(q || "")));
                if (r || v) $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(r || "")));
                v && ($f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$Qb), $f60d5b61c638db60$var$p(d, $f60d5b61c638db60$var$u($f60d5b61c638db60$var$Sb(v))));
                if (!$f60d5b61c638db60$var$t(d, $f60d5b61c638db60$var$Pb)) {
                    a.destination = null;
                    e++;
                    f.splice(0, e);
                    return;
                }
            }
            f.splice(0, e);
            var A = a.completedBoundaries;
            for(e = 0; e < A.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, A[e])) {
                a.destination = null;
                e++;
                A.splice(0, e);
                return;
            }
            A.splice(0, e);
            $f60d5b61c638db60$var$ba(b);
            $f60d5b61c638db60$var$l = new Uint8Array(512);
            $f60d5b61c638db60$var$n = 0;
            var F = a.partialBoundaries;
            for(e = 0; e < F.length; e++){
                var G = F[e];
                a: {
                    f = a;
                    g = b;
                    var ma = G.completedSegments;
                    for(h = 0; h < ma.length; h++)if (!$f60d5b61c638db60$var$kd(f, g, G, ma[h])) {
                        h++;
                        ma.splice(0, h);
                        var Fb = !1;
                        break a;
                    }
                    ma.splice(0, h);
                    Fb = !0;
                }
                if (!Fb) {
                    a.destination = null;
                    e++;
                    F.splice(0, e);
                    return;
                }
            }
            F.splice(0, e);
            var na = a.completedBoundaries;
            for(e = 0; e < na.length; e++)if (!$f60d5b61c638db60$var$jd(a, b, na[e])) {
                a.destination = null;
                e++;
                na.splice(0, e);
                return;
            }
            na.splice(0, e);
        } finally{
            $f60d5b61c638db60$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
        }
    }
    function $f60d5b61c638db60$var$ld(a, b) {
        try {
            var c = a.abortableTasks;
            c.forEach(function(c) {
                return $f60d5b61c638db60$var$ed(c, a, b);
            });
            c.clear();
            null !== a.destination && $f60d5b61c638db60$var$fd(a, a.destination);
        } catch (d) {
            $f60d5b61c638db60$var$Y(a, d), $f60d5b61c638db60$var$Vc(a, d);
        }
    }
    $f60d5b61c638db60$export$7020a3240b287705 = function(a, b) {
        return new Promise(function(c, d) {
            var f, e, g = new Promise(function(a, b) {
                e = a;
                f = b;
            }), h = $f60d5b61c638db60$var$Rc(a, $f60d5b61c638db60$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $f60d5b61c638db60$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
                var a = new ReadableStream({
                    type: "bytes",
                    pull: function(a) {
                        if (1 === h.status) h.status = 2, $f60d5b61c638db60$var$da(a, h.fatalError);
                        else if (2 !== h.status && null === h.destination) {
                            h.destination = a;
                            try {
                                $f60d5b61c638db60$var$fd(h, a);
                            } catch (A) {
                                $f60d5b61c638db60$var$Y(h, A), $f60d5b61c638db60$var$Vc(h, A);
                            }
                        }
                    },
                    cancel: function() {
                        $f60d5b61c638db60$var$ld(h);
                    }
                }, {
                    highWaterMark: 0
                });
                a.allReady = g;
                c(a);
            }, function(a) {
                g.catch(function() {});
                d(a);
            }, f);
            if (b && b.signal) {
                var m = b.signal, q = function() {
                    $f60d5b61c638db60$var$ld(h, m.reason);
                    m.removeEventListener("abort", q);
                };
                m.addEventListener("abort", q);
            }
            $f60d5b61c638db60$var$Uc(h);
        });
    };
    $f60d5b61c638db60$export$83d89fbfd8236492 = "18.2.0";
});
parcelRegister("dVijb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$329939dd47a716cd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $329939dd47a716cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weekStartingLabel: {
            "id": "servicedesk-reports-common.chart.tooltip.week-starting-label",
            "defaultMessage": "Week starting - {formattedDate}"
        }
    });
});
parcelRegister("aVOcX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc817eaf65198e6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2APCZ;
    var $koVbs;
    var $hDzhb;
    var $cnldZ;
    var $3HHkL;
    const $bc817eaf65198e6c$var$seriesActionContainerStyles = null;
    const $bc817eaf65198e6c$var$OverallSummary = ({ isEditable: isEditable = false, onEditSeriesClick: onEditSeriesClick = (0, ($parcel$interopDefault($8Rkzz))), onRemoveSeriesClick: onRemoveSeriesClick = (0, ($parcel$interopDefault($8Rkzz))), chartSeries: chartSeries = [], reportLink: reportLink })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const list = (0, $5uXOq.useMemo)(()=>chartSeries.map(({ seriesIndex: seriesIndex, name: name, summaryValue: { value: value, valueType: valueType }, itemStyle: itemStyle })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$LabelValuePair, {
                    key: seriesIndex
                }, reportLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                    href: reportLink
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Label, {
                    itemStyle: itemStyle
                }, (0, (0, parcelRequire("cnldZ")).getFormattedLabel)(valueType, value, formatMessage))) : (0, ($parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Label, {
                    itemStyle: itemStyle
                }, (0, (0, parcelRequire("cnldZ")).getFormattedLabel)(valueType, value, formatMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, name), isEditable && (0, ($parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Inline, null, (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                    "data-test-id": "servicedesk-reports-common.ui.overall-summary.edit-series",
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ])
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                    appearance: "link",
                    onClick: ()=>{
                        onEditSeriesClick(seriesIndex);
                    },
                    spacing: "none"
                }, formatMessage((0, (0, parcelRequire("3HHkL")).default).editLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                    "data-test-id": "servicedesk-reports-common.ui.overall-summary.remove-series",
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ])
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                    appearance: "link",
                    onClick: ()=>{
                        onRemoveSeriesClick(seriesIndex);
                    }
                }, formatMessage((0, (0, parcelRequire("3HHkL")).default).removeLabel)))))), [
            chartSeries,
            formatMessage,
            isEditable,
            onEditSeriesClick,
            onRemoveSeriesClick,
            reportLink
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bc817eaf65198e6c$var$Inline, {
            "data-test-id": "servicedesk-reports-common.ui.overall-summary.label-value-list"
        }, list);
    };
    var $bc817eaf65198e6c$export$2e2bcd8739ae039 = $bc817eaf65198e6c$var$OverallSummary;
    const $bc817eaf65198e6c$var$Inline = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1n261g80 _4cvr1h6o _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $bc817eaf65198e6c$var$LabelValuePair = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1y6m _18s86ucv _p12f68cl",
                __cmplp.className
            ])
        });
    });
    const $bc817eaf65198e6c$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { itemStyle: itemStyle, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1btszcl": (0, (0, parcelRequire("lD23V")).default)(__cmplp.itemStyle.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazrmj3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3HHkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f40de30121fc8c3c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f40de30121fc8c3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editLabel: {
            "id": "servicedesk-reports-common.overall-summary.edit-label",
            "defaultMessage": "Edit"
        },
        removeLabel: {
            "id": "servicedesk-reports-common.overall-summary.remove-label",
            "defaultMessage": "Remove"
        }
    });
});
parcelRegister("dZIz9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f853dd7089102710$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2Ccf7;
    var $dAFqR;
    var $esPpy;
    var $kU57e;
    var $4lDEP;
    var $3z9Bw;
    const $f853dd7089102710$var$Table = ({ summaryResource: summaryResource, drilldownResource: drilldownResource, isDisabled: isDisabled, selectedDrillDownPoint: selectedDrillDownPoint, onSetDrillDownPoint: onSetDrillDownPoint, onDrilldownPageChange: onDrilldownPageChange })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!drilldownResource.loading && drilldownResource.data) (0, (0, parcelRequire("2Ccf7")).DrillDownReportExperience).success();
        }, [
            drilldownResource.loading,
            drilldownResource.data
        ]);
        if (summaryResource.error !== undefined || drilldownResource.error !== undefined || summaryResource.data === undefined) {
            if (drilldownResource.error !== undefined) (0, (0, parcelRequire("2Ccf7")).DrillDownReportExperience).failure();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAFqR")).default), null);
        }
        if (!selectedDrillDownPoint) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3z9Bw")).SummaryTable), {
            isDisabled: isDisabled,
            source: summaryResource.data,
            onSelect: ({ data: data })=>{
                onSetDrillDownPoint(data);
            }
        });
        const { data: data, loading: loading } = drilldownResource;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4lDEP")).SeriesPicker), {
            source: summaryResource.data,
            selectedDrillDownPoint: selectedDrillDownPoint,
            onSwitchSeries: onSetDrillDownPoint,
            onSwitchTable: ()=>onSetDrillDownPoint()
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("esPpy")).default), {
            onPageChange: onDrilldownPageChange,
            ...data,
            loading: loading
        }), data && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kU57e")).PaginationLabel), {
            label: data.paginationCountString
        }));
    };
    var $f853dd7089102710$export$2e2bcd8739ae039 = $f853dd7089102710$var$Table;
});
parcelRegister("2Ccf7", function(module, exports) {
    $parcel$export(module.exports, "DrillDownReportExperience", ()=>$14a6fe6a77e02e76$export$8d3c23ffc1a7f28f);
    var $cqpQr;
    var $fwViQ;
    const $14a6fe6a77e02e76$export$8d3c23ffc1a7f28f = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-drill-down-reports', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
});
parcelRegister("esPpy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50257e68a7751e61$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7IZ99;
    var $2oKQq;
    var $8RXs9;
    var $aC16r;
    var $1Gl9g;
    var $fUIaM;
    const $50257e68a7751e61$var$IssueTable = ({ page: page, pageSize: pageSize, loading: loading, intl: intl, onPageChange: onPageChange, rows: rows = [], columns: columns = [], totalIssues: totalIssues })=>{
        const paginationi18n = (0, $5uXOq.useMemo)(()=>({
                prev: intl.formatMessage((0, (0, parcelRequire("fUIaM")).default).paginationPrev),
                next: intl.formatMessage((0, (0, parcelRequire("fUIaM")).default).paginationNext)
            }), [
            intl
        ]);
        const head = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1Gl9g")).default)(columns), [
            columns
        ]);
        const formattedRows = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("aC16r")).default)({
                rows: rows,
                totalIssues: totalIssues,
                page: page,
                pageSize: pageSize
            }), [
            pageSize,
            page,
            rows,
            totalIssues
        ]);
        const emptyView = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: intl.formatMessage((0, (0, parcelRequire("fUIaM")).default).noData)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($50257e68a7751e61$var$TableContainer, {
            "data-test-id": "servicedesk-reports-common.ui.table.issue-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IZ99")).default), {
            testId: "servicedesk-reports-common.ui.table.issue-table.issue-table",
            page: page,
            rowsPerPage: pageSize,
            head: head,
            rows: formattedRows,
            onSetPage: onPageChange,
            isLoading: loading,
            paginationi18n: paginationi18n,
            emptyView: emptyView,
            isFixedSize: true
        }));
    };
    var $50257e68a7751e61$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($50257e68a7751e61$var$IssueTable);
    const $50257e68a7751e61$var$TableContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81bpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7IZ99", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ddd52e269d929fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cjvv;
    var $gCBvJ;
    var $aGjCX;
    var $7senc;
    var $4cBIq;
    var $bjhuu;
    var $1xf56;
    var $67yNd;
    var $i2gva;
    var $20pg6;
    var $e29Bd;
    function $2ddd52e269d929fa$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65:
                return 0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b;
            case 0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b:
                return 0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $2ddd52e269d929fa$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("gCBvJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("gCBvJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("gCBvJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("gCBvJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("aGjCX")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("aGjCX")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b) : $2ddd52e269d929fa$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("aGjCX")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3) : (0, $a96aa7f4f3ce56d4$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cBIq")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cBIq")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i2gva")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e29Bd")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($2ddd52e269d929fa$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("20pg6")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67yNd")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $2ddd52e269d929fa$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("1G9i6")));
    const $2ddd52e269d929fa$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjhuu")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xf56")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2ddd52e269d929fa$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $2ddd52e269d929fa$export$2e2bcd8739ae039 = $2ddd52e269d929fa$var$DynamicTable;
});
const $a96aa7f4f3ce56d4$export$1dee026a19752d6b = 'ASC';
const $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65 = 'DESC';
const $a96aa7f4f3ce56d4$export$71dd4c8ecd45e95f = 'small';
const $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3 = 'large';
const $a96aa7f4f3ce56d4$export$3843c586a90b9cbf = 0.22;
parcelRegister("aGjCX", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$c2de66b2a3576b49$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$c2de66b2a3576b49$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$c2de66b2a3576b49$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$c2de66b2a3576b49$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$c2de66b2a3576b49$export$c476bbe5da59992d);
    const $c2de66b2a3576b49$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $c2de66b2a3576b49$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $c2de66b2a3576b49$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $c2de66b2a3576b49$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $c2de66b2a3576b49$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $c2de66b2a3576b49$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $c2de66b2a3576b49$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $c2de66b2a3576b49$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("7senc", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$1f853547f6ce5190$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$1f853547f6ce5190$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$1f853547f6ce5190$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$1f853547f6ce5190$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $v0afU;
    function $1f853547f6ce5190$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1f853547f6ce5190$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $1f853547f6ce5190$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $1f853547f6ce5190$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $1f853547f6ce5190$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("v0afU")).tableBorder).borderColor}`
    });
    const $1f853547f6ce5190$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).hoverBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).highlightedBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).hoverHighlightedBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("v0afU")).row).focusOutline
            },
            css: [
                $1f853547f6ce5190$var$tableStyles,
                isFixedSize && $1f853547f6ce5190$var$fixedSizeTableStyles,
                hasDataRow && $1f853547f6ce5190$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $1f853547f6ce5190$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $1f853547f6ce5190$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $1f853547f6ce5190$var$captionStyles
        }, children);
    const $1f853547f6ce5190$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $1f853547f6ce5190$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1f853547f6ce5190$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("v0afU", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$7375941814b05804$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$7375941814b05804$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$7375941814b05804$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$7375941814b05804$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$7375941814b05804$export$38d703b73e2cf64d);
    const $7375941814b05804$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $7375941814b05804$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$72ba03e317f3d228$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$72ba03e317f3d228$export$e2ef2124cf4024b1})`
    };
    const $7375941814b05804$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$72ba03e317f3d228$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$72ba03e317f3d228$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$72ba03e317f3d228$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$72ba03e317f3d228$export$8c13c2ee36917869})`
    };
    const $7375941814b05804$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$e2ef2124cf4024b1})`
    };
    const $7375941814b05804$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$72ba03e317f3d228$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("4cBIq", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$7b50cb98d7ed065a$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$7b50cb98d7ed065a$export$381ea436de119582);
    var $f8Sb3;
    function $7b50cb98d7ed065a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7b50cb98d7ed065a$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $7b50cb98d7ed065a$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7b50cb98d7ed065a$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $7b50cb98d7ed065a$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $7b50cb98d7ed065a$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7b50cb98d7ed065a$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("bjhuu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1340edfe31e64882$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1KUVl;
    var $alATQ;
    class $1340edfe31e64882$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("alATQ")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $1340edfe31e64882$var$Body = (0, (0, parcelRequire("1KUVl")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1340edfe31e64882$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $1340edfe31e64882$export$2e2bcd8739ae039 = $1340edfe31e64882$var$Body;
});
parcelRegister("1KUVl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$863593a48fd0f0c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aGjCX;
    const $863593a48fd0f0c1$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $863593a48fd0f0c1$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $863593a48fd0f0c1$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $863593a48fd0f0c1$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $863593a48fd0f0c1$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("aGjCX")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $863593a48fd0f0c1$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("aGjCX")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("alATQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c6796f853f83aaa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnWKh;
    var $agbGh;
    const $0c6796f853f83aaa$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agbGh")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnWKh")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $0c6796f853f83aaa$export$2e2bcd8739ae039 = $0c6796f853f83aaa$var$Row;
});
parcelRegister("jnWKh", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$8784660980bab086$export$948e91fcef170792);
    var $f8Sb3;
    var $iqCjf;
    const $8784660980bab086$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("iqCjf")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("iqCjf")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("iqCjf")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("iqCjf")).overflowTruncateStyles),
                (0, (0, parcelRequire("iqCjf")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("iqCjf", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$b041d0e7b1d3197b$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$b041d0e7b1d3197b$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$b041d0e7b1d3197b$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$b041d0e7b1d3197b$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$b041d0e7b1d3197b$export$f7913df521f684e2);
    var $f8Sb3;
    function $b041d0e7b1d3197b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b041d0e7b1d3197b$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $b041d0e7b1d3197b$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$b041d0e7b1d3197b$var$CSS_VAR_WIDTH})`
    });
    const $b041d0e7b1d3197b$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $b041d0e7b1d3197b$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $b041d0e7b1d3197b$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$b041d0e7b1d3197b$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $b041d0e7b1d3197b$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("agbGh", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$47789b31b0b1d18e$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7senc;
    const $47789b31b0b1d18e$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $47789b31b0b1d18e$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $47789b31b0b1d18e$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $47789b31b0b1d18e$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $47789b31b0b1d18e$var$rowStyles,
                isHighlighted ? $47789b31b0b1d18e$var$rowHighlightedBackgroundStyles : $47789b31b0b1d18e$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("1xf56", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d4e8a37cf2024d58$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $d4e8a37cf2024d58$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("67yNd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad4d33547315ba00$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $113Tq;
    var $9RFqC;
    class $ad4d33547315ba00$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $a96aa7f4f3ce56d4$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("9RFqC", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$9b63de7d07ea3f20$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$9b63de7d07ea3f20$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$9b63de7d07ea3f20$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $9b63de7d07ea3f20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9b63de7d07ea3f20$export$c335a80381ec61f5 = '--contents-opacity';
    const $9b63de7d07ea3f20$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $9b63de7d07ea3f20$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9b63de7d07ea3f20$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $9b63de7d07ea3f20$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$9b63de7d07ea3f20$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $9b63de7d07ea3f20$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$9b63de7d07ea3f20$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $9b63de7d07ea3f20$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $9b63de7d07ea3f20$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $9b63de7d07ea3f20$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9b63de7d07ea3f20$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("i2gva", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68d4d803da2924e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $113Tq;
    var $9cqRz;
    class $68d4d803da2924e8$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $a96aa7f4f3ce56d4$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("9cqRz", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$aa972554a9f731ee$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$aa972554a9f731ee$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$aa972554a9f731ee$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $aa972554a9f731ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $aa972554a9f731ee$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $aa972554a9f731ee$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $aa972554a9f731ee$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $aa972554a9f731ee$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $aa972554a9f731ee$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $aa972554a9f731ee$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("20pg6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719ae0e388181bba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8ZV9b;
    class $719ae0e388181bba$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ZV9b")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("8ZV9b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bffd94785d620cef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cjvv;
    var $gCBvJ;
    var $cI4Vd;
    var $asmPY;
    var $80QIn;
    var $6Ll2T;
    var $fm763;
    var $99gde;
    var $aYK2t;
    var $eqjqY;
    var $ashNT;
    var $cRtpB;
    var $55OLU;
    const $bffd94785d620cef$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $bffd94785d620cef$var$paginationMenuStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $bffd94785d620cef$var$paginationMenuItemStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $bffd94785d620cef$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingInline: 'space.075'
    });
    function $bffd94785d620cef$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("asmPY"))))) : (0, ($parcel$interopDefault((0, parcelRequire("80QIn")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span",
            xcss: $bffd94785d620cef$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $bffd94785d620cef$var$InnerPagination({ components: components = (0, (0, parcelRequire("cRtpB")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("cRtpB")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("gCBvJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("ashNT")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("cI4Vd")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$bffd94785d620cef$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
                as: "li",
                xcss: $bffd94785d620cef$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqjqY")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYK2t")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($bffd94785d620cef$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $bffd94785d620cef$var$paginationMenuStyles
        }, (0, (0, parcelRequire("55OLU")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYK2t")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($bffd94785d620cef$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $bffd94785d620cef$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($bffd94785d620cef$var$InnerPagination));
    var $bffd94785d620cef$export$2e2bcd8739ae039 = $bffd94785d620cef$var$Pagination;
});
parcelRegister("aYK2t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a32ad5907d466ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    function $5a32ad5907d466ce$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("eqjqY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6c146866dbb414e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    function $b6c146866dbb414e$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("ashNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bff36923574c1b9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $AHUyh;
    const $bff36923574c1b9a$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $bff36923574c1b9a$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $bff36923574c1b9a$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AHUyh")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("cRtpB", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$3caf0da65b4820eb$export$3f860eba1218f8d3);
    const $3caf0da65b4820eb$export$3f860eba1218f8d3 = {};
});
parcelRegister("55OLU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$605acaae51a91016$export$2e2bcd8739ae039);
    var $8QpSo;
    const $605acaae51a91016$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $605acaae51a91016$export$2e2bcd8739ae039 = $605acaae51a91016$var$collapseRange;
});
parcelRegister("e29Bd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$256ac7e407d97c05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aGjCX;
    var $cp6ND;
    var $2dlI8;
    var $kLXOj;
    class $256ac7e407d97c05$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("aGjCX")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("aGjCX")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("2dlI8")).default) : (0, (0, parcelRequire("kLXOj")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cp6ND")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $256ac7e407d97c05$export$2e2bcd8739ae039 = $256ac7e407d97c05$var$TableHead;
});
parcelRegister("cp6ND", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$7a324f86902d232b$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$7a324f86902d232b$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $v0afU;
    var $iqCjf;
    function $7a324f86902d232b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7a324f86902d232b$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $7a324f86902d232b$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $7a324f86902d232b$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $7a324f86902d232b$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $7a324f86902d232b$var$headStyles,
                isRanking && $7a324f86902d232b$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $7a324f86902d232b$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("v0afU")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$7a324f86902d232b$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $7a324f86902d232b$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $72ba03e317f3d228$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $7a324f86902d232b$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $7a324f86902d232b$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $7a324f86902d232b$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $7a324f86902d232b$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("iqCjf")).getTruncationStyleVars)({
                width: width
            }),
            [$7a324f86902d232b$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("v0afU")).head).textColor
        };
        const isASC = sortOrder === (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("iqCjf")).cellStyles),
                $7a324f86902d232b$var$headCellBaseStyles,
                onClick && $7a324f86902d232b$var$onClickStyles,
                (0, (0, parcelRequire("iqCjf")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("iqCjf")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("iqCjf")).overflowTruncateStyles),
                isSortable && $7a324f86902d232b$var$baseStyles,
                isASC && $7a324f86902d232b$var$ascendingStyles,
                isDESC && $7a324f86902d232b$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("2dlI8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5a1089e3027a848$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $epIxA;
    var $aGjCX;
    var $kLXOj;
    class $c5a1089e3027a848$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("aGjCX")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kLXOj")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $c5a1089e3027a848$var$RankableTableHeadCell = (0, (0, parcelRequire("epIxA")).default)($c5a1089e3027a848$var$RankableTableHeadCellComponent);
    var $c5a1089e3027a848$export$2e2bcd8739ae039 = $c5a1089e3027a848$var$RankableTableHeadCell;
});
parcelRegister("epIxA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dda015132e24d01$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8dda015132e24d01$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("kLXOj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77b969a5244946d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cp6ND;
    const $77b969a5244946d0$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cp6ND")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $77b969a5244946d0$export$2e2bcd8739ae039 = $77b969a5244946d0$var$TableHeadCell;
});
parcelRegister("1G9i6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dcsW0")
    ]).then(()=>parcelRequire('l5pwz'));
});
parcelRegister("aC16r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b985b6cda10df468$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ij7C8 = parcelRequire("ij7C8");
    var $ljZL8;
    const $b985b6cda10df468$var$getTableRows = ({ totalIssues: totalIssues, pageSize: pageSize, rows: rows, page: page = 1 })=>{
        let totalRows = [];
        const totalPages = Math.ceil(totalIssues / pageSize);
        if (!rows || !rows.length) return totalRows;
        const visibleRows = rows.map((row)=>{
            const cells = row.map((field, index)=>({
                    key: `field-${index}`,
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljZL8")).default), field)
                }));
            return {
                cells: cells
            };
        });
        const emptyRow = {
            cells: []
        };
        const numberOfPreviousRows = (page - 1) * pageSize;
        const numberOfNextRows = Math.max(0, (totalPages - page) * pageSize);
        const previousRows = (0, ($parcel$interopDefault($ij7C8)))(Array(numberOfPreviousRows), emptyRow);
        const nextRows = (0, ($parcel$interopDefault($ij7C8)))(Array(numberOfNextRows), emptyRow);
        totalRows = [
            ...previousRows,
            ...visibleRows,
            ...nextRows
        ];
        return totalRows;
    };
    var $b985b6cda10df468$export$2e2bcd8739ae039 = $b985b6cda10df468$var$getTableRows;
});
parcelRegister("ij7C8", function(module, exports) {
    var $bTFL0 = parcelRequire("bTFL0");
    var $4rDUz = parcelRequire("4rDUz");
    function $d53fe857806ab26c$var$fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) return [];
        if (start && typeof start != 'number' && $4rDUz(array, value, start)) {
            start = 0;
            end = length;
        }
        return $bTFL0(array, value, start, end);
    }
    module.exports = $d53fe857806ab26c$var$fill;
});
parcelRegister("bTFL0", function(module, exports) {
    var $kPZpS = parcelRequire("kPZpS");
    var $6u9J6 = parcelRequire("6u9J6");
    function $8a9538e21a24514e$var$baseFill(array, value, start, end) {
        var length = array.length;
        start = $kPZpS(start);
        if (start < 0) start = -start > length ? 0 : length + start;
        end = end === undefined || end > length ? length : $kPZpS(end);
        if (end < 0) end += length;
        end = start > end ? 0 : $6u9J6(end);
        while(start < end)array[start++] = value;
        return array;
    }
    module.exports = $8a9538e21a24514e$var$baseFill;
});
parcelRegister("6u9J6", function(module, exports) {
    var $gPWEE = parcelRequire("gPWEE");
    var $kPZpS = parcelRequire("kPZpS");
    var $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH = 4294967295;
    function $4b8d16e2178c6ba7$var$toLength(value) {
        return value ? $gPWEE($kPZpS(value), 0, $4b8d16e2178c6ba7$var$MAX_ARRAY_LENGTH) : 0;
    }
    module.exports = $4b8d16e2178c6ba7$var$toLength;
});
parcelRegister("gPWEE", function(module, exports) {
    function $c41ee85d08292e29$var$baseClamp(number, lower, upper) {
        if (number === number) {
            if (upper !== undefined) number = number <= upper ? number : upper;
            if (lower !== undefined) number = number >= lower ? number : lower;
        }
        return number;
    }
    module.exports = $c41ee85d08292e29$var$baseClamp;
});
parcelRegister("ljZL8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0922bfcb2bb7fda$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hXLCJ = parcelRequire("hXLCJ");
    var $ZuPvl;
    var $jcw0u;
    var $g5X3G;
    var $bmKPg;
    var $lVJAU;
    var $dlQrJ;
    var $4IaNM;
    var $1k2a1;
    var $3EaUd;
    var $hy166;
    var $4oLCE;
    var $5Ahqf;
    var $lDWfd;
    const $d0922bfcb2bb7fda$var$FieldRenderer = ({ fieldHtml: fieldHtml, fieldClass: fieldClass })=>{
        const [paramReportId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('reportId');
        const [paramTimescaleId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('timescaleId');
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = fieldHtml;
        if (tempDiv && tempDiv.firstChild) {
            if (tempDiv.querySelector('SD-KB-DIALOG-LINK')) {
                const el = tempDiv.firstChild;
                if (el instanceof Element) {
                    const kbLinkProps = (0, (0, parcelRequire("lDWfd")).getKbLinkProps)(el);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ahqf")).default), kbLinkProps);
                }
            }
            if (fieldClass === 'reporter' || fieldClass === 'assignee') {
                const agentFieldProps = (0, (0, parcelRequire("lDWfd")).getAgentFieldProps)(tempDiv);
                if (agentFieldProps !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3EaUd")).default), {
                    agent: {
                        ...agentFieldProps
                    }
                });
            }
            if (tempDiv.querySelector('.sd-feedback-rating-column')) {
                const rating = tempDiv.querySelectorAll('.sd-feedback-rating-column .feedback-star').length;
                return (0, (0, parcelRequire("hy166")).default)[rating];
            }
            if (tempDiv.querySelector('.report-drilldown-field-view-article-user')) {
                const nameSpan = tempDiv.querySelector('.drilldown-field-username');
                const image = tempDiv.querySelector('img');
                if (nameSpan instanceof Element && image instanceof Element) {
                    const name = nameSpan.innerHTML;
                    const imageSrc = String(image.getAttribute('src'));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1k2a1")).default), {
                        name: name,
                        imageUrl: imageSrc,
                        withBorder: true
                    });
                }
            }
            if (tempDiv.querySelector('.sd-request-type')) {
                const image = tempDiv.querySelector('img');
                if (image instanceof Element) {
                    const name = tempDiv.innerText || '';
                    const imageSrc = String(image.getAttribute('src'));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1k2a1")).default), {
                        name: name,
                        imageUrl: imageSrc
                    });
                }
            }
            if (fieldClass === 'status') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oLCE")).RequestStatus), {
                source: tempDiv.children[0]
            });
            if (fieldClass === 'issuekey' || fieldClass === 'summary') {
                const reportId = (0, (0, parcelRequire("dlQrJ")).toReportId)(String(paramReportId));
                const timescaleId = paramTimescaleId !== undefined ? Number(paramTimescaleId) : undefined;
                const link = tempDiv.querySelector('a[data-issue-key]') || tempDiv.querySelector('a[data-jira-key]');
                if (!link) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'fieldRendererPayloadAssumptions',
                            packageName: 'jiraServicedeskReportsCommon',
                            teamName: 'itsm-saga'
                        }
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, fieldHtml);
                }
                const issueKey = link.dataset.issueKey || link.dataset.jiraKey;
                const onClick = (event)=>{
                    if (!reportId) return;
                    const { ctrlKey: ctrlKey, metaKey: metaKey } = event;
                    if (ctrlKey || metaKey) return;
                    if (issueKey) {
                        const path = (0, (0, parcelRequire("4IaNM")).getReportsFragment)(reportId, (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey), timescaleId);
                        event.preventDefault();
                        push(path);
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                    as: "p"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    "data-issue-key": link.dataset.issueKey,
                    href: link?.attributes?.getNamedItem('href')?.value,
                    onClick: onClick
                }, link.textContent)));
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, ($parcel$interopDefault($hXLCJ))).sanitize(fieldHtml, {
                    ALLOWED_TAGS: [
                        'p',
                        'strong',
                        'span',
                        'a'
                    ],
                    ALLOWED_ATTR: [
                        'data-issue-key',
                        'href'
                    ]
                })
            }
        });
    };
    var $d0922bfcb2bb7fda$export$2e2bcd8739ae039 = $d0922bfcb2bb7fda$var$FieldRenderer;
});
parcelRegister("dlQrJ", function(module, exports) {
    $parcel$export(module.exports, "toReportId", ()=>$dc5652368490c1ea$export$19ba7e9702c884f7);
    const $dc5652368490c1ea$export$19ba7e9702c884f7 = (reportId)=>reportId;
    const $dc5652368490c1ea$export$1d8d88bc534f5ef6 = (reportId)=>reportId;
});
parcelRegister("4IaNM", function(module, exports) {
    $parcel$export(module.exports, "getReportsFragment", ()=>$bcf83f1a6058c734$export$59ea3cac05f90154);
    const $bcf83f1a6058c734$export$59ea3cac05f90154 = (reportId, issueKey, timescaleId)=>timescaleId !== undefined ? `${timescaleId}/${String(issueKey)}` : `${String(reportId)}/timescale/2/${String(issueKey)}`;
});
parcelRegister("1k2a1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f9d073dfa148432$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1f9d073dfa148432$var$ArticleProfile = ({ imageUrl: imageUrl, name: name, withBorder: withBorder })=>(0, ($parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$ImageWrapper, {
            src: imageUrl,
            alt: name,
            withBorder: withBorder
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($1f9d073dfa148432$var$NameWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, name)));
    var $1f9d073dfa148432$export$2e2bcd8739ae039 = $1f9d073dfa148432$var$ArticleProfile;
    const $1f9d073dfa148432$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $1f9d073dfa148432$var$ImageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withBorder: withBorder, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_vqks4j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.withBorder ? '50%' : 0)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l1ejb _p12f1ejb _2rkoo7dz",
                __cmplp.className
            ])
        });
    });
    const $1f9d073dfa148432$var$NameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz41tcg _19bvutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3EaUd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49233a0b4004cc6f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    var $kYYfm;
    var $9OXo1;
    var $hDzhb;
    const $49233a0b4004cc6f$var$AgentCell = ({ agent: agent, TenantContextSubscriber: TenantContextSubscriber = (0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), Link: Link })=>{
        const baseUrl = '';
        const { avatarUrl: avatarUrl, displayName: displayName, accountId: accountId } = agent;
        if (accountId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kYYfm")).AsyncProfileCardNext), {
            accountId: agent.accountId,
            TenantContextSubscriber: TenantContextSubscriber,
            actions: [
                (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$StyledAgent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            src: avatarUrl,
            size: "small",
            borderColor: "transparent"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Link, {
            href: `${baseUrl}/jira/people/${accountId}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($49233a0b4004cc6f$var$DisplayName, null, displayName)))));
        return null;
    };
    $49233a0b4004cc6f$var$AgentCell.defaultProps = {
        Link: (0, (0, parcelRequire("hDzhb")).default)
    };
    var $49233a0b4004cc6f$export$2e2bcd8739ae039 = $49233a0b4004cc6f$var$AgentCell;
    const $49233a0b4004cc6f$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4swc3 _1e0c1txw _y3gn1e5h",
                __cmplp.className
            ])
        });
    });
    const $49233a0b4004cc6f$var$StyledAgent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _bfhk18uv _19itidpf _2rko1l7b _1yt4otz2 _1bsb1osq _4t3izwfg _1reo15vq _syaz1kw7 _11c81psy _zg8l4jg8 _12ji1r31 _1qu2glyw _12y31o36",
                __cmplp.className
            ])
        });
    });
    const $49233a0b4004cc6f$var$DisplayName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _vwz419ii _19bvu2gc _2hwxu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kYYfm", function(module, exports) {
    $parcel$export(module.exports, "AsyncProfileCardNext", ()=>$15521008cc986085$export$a3c0845f856d4292);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $gcl1l;
    var $lfTZh;
    var $1jUsD;
    const $15521008cc986085$var$LazyComponent = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("beEVQ")).then((module)=>module.ProfileCard), {
        moduleId: "./src/packages/profilecard-next/src/main.tsx"
    });
    const $15521008cc986085$export$a3c0845f856d4292 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "AsyncProfileCardNext",
            packageName: "jiraProfilecardNext",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children),
            sendToPrivacyUnsafeSplunk: true,
            teamName: "empanada",
            attributes: (0, (0, parcelRequire("gcl1l")).isLoaderErrorAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-profile-card-next-view",
            fallback: props.children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
    var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;
});
parcelRegister("gcl1l", function(module, exports) {
    $parcel$export(module.exports, "isLoaderErrorAttributes", ()=>$ecfe970d67067a10$export$c7209ce2e0d060ea);
    var $bv77P;
    const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
            isLoaderError: (0, (0, parcelRequire("bv77P")).isLoaderError)(error)
        });
});
parcelRegister("beEVQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ek7ue")
    ]).then(()=>parcelRequire('jO6eK'));
});
const $e6a2e0952e4731b8$export$febebefae5a09065 = 'profile-card.loaded';
const $e6a2e0952e4731b8$export$3ca1936ee743bd18 = 'profile-card.view';
const $e6a2e0952e4731b8$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $e6a2e0952e4731b8$export$86aa8b9c379ebbbd = 'profile-card.error';
const $e6a2e0952e4731b8$export$4442e31da6ba4127 = 'profile-card.click';
const $e6a2e0952e4731b8$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';
parcelRegister("hy166", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c845628001a65b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iASWI = parcelRequire("iASWI");
    var $1MwJJ;
    var $YSzt9;
    const $2c845628001a65b9$var$getStars = (rating, scale = 5)=>{
        const stars = (0, ($parcel$interopDefault($iASWI)))(scale).map((starIndex)=>starIndex < rating ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("YSzt9"))))), {
                testId: "servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-filled-icon",
                key: starIndex,
                primaryColor: `var(--ds-icon-accent-orange, ${(0, $72ba03e317f3d228$exports).Y300})`,
                label: `${starIndex} star filled`
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1MwJJ"))))), {
                testId: "servicedesk-reports-common.ui.table.issue-table.body.field-renderer.fields.ratings.star-icon",
                key: starIndex,
                primaryColor: `var(--ds-icon, ${(0, $72ba03e317f3d228$exports).N60})`,
                label: `${starIndex} star unfilled`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, stars);
    };
    const $2c845628001a65b9$var$Ratings = (0, ($parcel$interopDefault($iASWI)))(6).map((id)=>$2c845628001a65b9$var$getStars(id));
    var $2c845628001a65b9$export$2e2bcd8739ae039 = $2c845628001a65b9$var$Ratings;
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("4oLCE", function(module, exports) {
    $parcel$export(module.exports, "RequestStatus", ()=>$506e958c4ae57ed7$export$600e7c1f9e0414e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cZ1Pf;
    var $8ptrG;
    var $loZC0;
    const $506e958c4ae57ed7$export$600e7c1f9e0414e1 = ({ source: source })=>{
        let appearance = 'default';
        const tooltipTemp = document.createElement('span');
        tooltipTemp.innerHTML = source.getAttribute('data-tooltip') || '';
        if (source.classList.contains('jira-issue-status-lozenge-indeterminate')) appearance = 'inprogress';
        else if (source.classList.contains('jira-issue-status-lozenge-done')) appearance = 'success';
        const tooltipTitle = tooltipTemp.querySelector('.jira-issue-status-tooltip-title');
        const tooltipDesc = tooltipTemp.querySelector('.jira-issue-status-tooltip-desc');
        const tooltipContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, tooltipTitle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($506e958c4ae57ed7$var$TooltipTitle, null, tooltipTitle.innerText)), tooltipDesc && (0, ($parcel$interopDefault($5uXOq))).createElement($506e958c4ae57ed7$var$TooltipDescription, null, tooltipDesc.innerText));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: tooltipContent,
            position: "left"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ptrG")).default), {
            appearance: appearance
        }, source.textContent));
    };
    const $506e958c4ae57ed7$var$TooltipTitle = (0, $5uXOq.forwardRef)(({ as: C = "b", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr",
                __cmplp.className
            ])
        });
    });
    const $506e958c4ae57ed7$var$TooltipDescription = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _19pku2gc _11c81oud",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5Ahqf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fb1e621b75eea29$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8EE8i;
    var $bTmOP;
    var $2Yyer;
    var $i9cxd;
    var $2TrWf;
    var $4uJJm;
    var $113Tq;
    var $41j30;
    var $9fuVs;
    var $iXVV6;
    var $cAofY;
    var $2YP9W;
    var $cwU1O;
    var $5XuaQ;
    const $6fb1e621b75eea29$var$KbLink = ({ name: name, link: link, iframeSrc: iframeSrc, editLink: editLink, shareable: shareable })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("cAofY")).serviceDeskContextResource));
        const onClick = (e)=>{
            e.preventDefault();
            setIsOpen(true);
        };
        if (!data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            size: "small"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            href: `${data?.customerUrl}/${link}`,
            onClick: (e)=>onClick(e)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6fb1e621b75eea29$var$LinkInnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, name), !shareable && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EE8i"))))), {
            primaryColor: `var(--ds-icon-danger, ${(0, $72ba03e317f3d228$exports).R300})`,
            label: ""
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "test"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uJJm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
            width: "x-large",
            onClose: ()=>setIsOpen(!isOpen),
            height: "100%"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9cxd")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2TrWf")).default), null, name)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Yyer")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwU1O")).default), {
            name: name,
            src: iframeSrc
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5XuaQ")).default), {
            editLink: editLink,
            link: `${data?.customerUrl}/${link}`,
            onCancel: ()=>setIsOpen(false)
        }))))));
    };
    var $6fb1e621b75eea29$export$2e2bcd8739ae039 = $6fb1e621b75eea29$var$KbLink;
    const $6fb1e621b75eea29$var$LinkInnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8EE8i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64d130b3954f4062$var$_react = $64d130b3954f4062$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $64d130b3954f4062$var$_lockLocked = $64d130b3954f4062$var$_interopRequireDefault((parcelRequire("1YyFm")));
    function $64d130b3954f4062$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64d130b3954f4062$var$LockFilledIcon = (props)=>$64d130b3954f4062$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
        }, props, {
            newIcon: $64d130b3954f4062$var$_lockLocked.default
        }));
    $64d130b3954f4062$var$LockFilledIcon.displayName = 'LockFilledIcon';
    var $64d130b3954f4062$var$_default = module.exports.default = $64d130b3954f4062$var$LockFilledIcon;
});
parcelRegister("1YyFm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $17064906e847fb27$var$_react = $17064906e847fb27$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $17064906e847fb27$var$_UNSAFE_baseNew = $17064906e847fb27$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $17064906e847fb27$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $17064906e847fb27$var$LockLockedIcon = (props)=>$17064906e847fb27$var$_react.default.createElement($17064906e847fb27$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $17064906e847fb27$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $17064906e847fb27$var$_default = module.exports.default = $17064906e847fb27$var$LockLockedIcon;
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("cwU1O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b882eeeca5e1a3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    const $5b882eeeca5e1a3c$var$Body = ({ name: name, src: src })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("iframe", {
            onLoad: ()=>setIsLoading(false),
            frameBorder: "0",
            title: name,
            src: src,
            height: "100%",
            width: "100%"
        }));
    };
    var $5b882eeeca5e1a3c$export$2e2bcd8739ae039 = $5b882eeeca5e1a3c$var$Body;
});
parcelRegister("5XuaQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a78218f2d3f08fd3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $1UU68;
    var $2APCZ;
    var $iwduc;
    var $4qSaV;
    var $8mGGj;
    var $4R6GH;
    var $8RXs9;
    var $UFJ9V;
    const $a78218f2d3f08fd3$var$FadeOut = ({ show: show, children: children })=>{
        const [shouldRender, setRender] = (0, $5uXOq.useState)(show);
        (0, $5uXOq.useEffect)(()=>{
            if (show) setRender(true);
        }, [
            show
        ]);
        const onAnimationEnd = ()=>{
            if (!show) setRender(false);
        };
        if (shouldRender) return (0, (0, parcelRequire("4R6GH")).fg)('jsm_migrated_styled_component_18081') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onAnimationEnd: onAnimationEnd,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !show && "",
                !show && "_y44v1ukk"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$FadeWrapper, {
            show: show,
            onAnimationEnd: onAnimationEnd
        }, children);
        return null;
    };
    const $a78218f2d3f08fd3$export$a06f1c675e846f6f = ({ onCancel: onCancel, editLink: editLink, link: link, intl: intl })=>{
        const linkTextArea = (0, $5uXOq.useRef)(null);
        const [copied, setCopied] = (0, $5uXOq.useState)(false);
        const copyToClipboard = ()=>{
            if (linkTextArea.current !== null) {
                linkTextArea.current.select();
                document.execCommand('copy');
                setCopied(true);
                setTimeout(()=>{
                    setCopied(false);
                }, 1000);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qSaV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UU68")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "default",
            href: editLink,
            target: "_blank"
        }, intl.formatMessage((0, (0, parcelRequire("UFJ9V")).default).editPage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
            value: link,
            isReadOnly: true,
            isCompact: true,
            ref: linkTextArea
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "default",
            onClick: ()=>copyToClipboard()
        }, intl.formatMessage((0, (0, parcelRequire("UFJ9V")).default).copyLink)), (0, ($parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a78218f2d3f08fd3$var$FadeOut, {
            show: copied
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iwduc"))))), {
            primaryColor: `var(--ds-icon-success, ${(0, $72ba03e317f3d228$exports).G300})`,
            size: "medium",
            label: ""
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "subtle",
            onClick: ()=>onCancel()
        }, intl.formatMessage((0, (0, parcelRequire("UFJ9V")).default).cancel)))));
    };
    var $a78218f2d3f08fd3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a78218f2d3f08fd3$export$a06f1c675e846f6f);
    const $a78218f2d3f08fd3$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $a78218f2d3f08fd3$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb7vkz",
                __cmplp.className
            ])
        });
    });
    const $a78218f2d3f08fd3$var$fadeOut = (0, $47bDC.keyframes)({
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    });
    const $a78218f2d3f08fd3$var$fadeOut2 = null;
    const $a78218f2d3f08fd3$var$FadeWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1sra7lj-0"
    })`animation:${(props)=>!props.show ? $a78218f2d3f08fd3$var$fadeOut : ''} 0.8s linear;`;
    const $a78218f2d3f08fd3$var$fadeOutAnimationStyle = null;
});
parcelRegister("iwduc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d7b5ad35639fa424$var$_react = $d7b5ad35639fa424$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $d7b5ad35639fa424$var$_checkCircle = $d7b5ad35639fa424$var$_interopRequireDefault((parcelRequire("gVfwB")));
    function $d7b5ad35639fa424$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d7b5ad35639fa424$var$CheckCircleOutlineIcon = (props)=>$d7b5ad35639fa424$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $d7b5ad35639fa424$var$_checkCircle.default
        }));
    $d7b5ad35639fa424$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
    var $d7b5ad35639fa424$var$_default = module.exports.default = $d7b5ad35639fa424$var$CheckCircleOutlineIcon;
});
parcelRegister("gVfwB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c51e031c40013c10$var$_react = $c51e031c40013c10$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c51e031c40013c10$var$_UNSAFE_baseNew = $c51e031c40013c10$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $c51e031c40013c10$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c51e031c40013c10$var$CheckCircleIcon = (props)=>$c51e031c40013c10$var$_react.default.createElement($c51e031c40013c10$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $c51e031c40013c10$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $c51e031c40013c10$var$_default = module.exports.default = $c51e031c40013c10$var$CheckCircleIcon;
});
parcelRegister("8mGGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af711023521e2d75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $9EfCw;
    const $af711023521e2d75$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $af711023521e2d75$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9EfCw")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("9EfCw")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $af711023521e2d75$export$2e2bcd8739ae039 = $af711023521e2d75$var$Textfield;
});
parcelRegister("9EfCw", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$a7502c1f5abf97ed$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$a7502c1f5abf97ed$export$3eeb47dc8e6249d9);
    const $a7502c1f5abf97ed$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $a7502c1f5abf97ed$var$backgroundColor[appearance],
            borderColor: $a7502c1f5abf97ed$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorHover[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorFocus[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$a7502c1f5abf97ed$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $a7502c1f5abf97ed$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $a7502c1f5abf97ed$var$getMaxWidth = (width)=>!width ? `100%` : width in $a7502c1f5abf97ed$var$widthMap ? $a7502c1f5abf97ed$var$widthMap[width] : +width;
    const $a7502c1f5abf97ed$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $a7502c1f5abf97ed$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $a7502c1f5abf97ed$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("UFJ9V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a017ddc50c2bce82$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a017ddc50c2bce82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyLink: {
            "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.copy-link",
            "defaultMessage": "Copy link"
        },
        editPage: {
            "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.edit-page",
            "defaultMessage": "Edit page"
        },
        cancel: {
            "id": "servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("lDWfd", function(module, exports) {
    $parcel$export(module.exports, "getKbLinkProps", ()=>$b67205cee8595deb$export$26ed3646363ada0a);
    $parcel$export(module.exports, "getAgentFieldProps", ()=>$b67205cee8595deb$export$ec2cadd99971a33);
    const $b67205cee8595deb$export$11493bbdcbc7d6ce = (baseUrl, pageId, applicationId)=>{
        const originUrl = new URL(baseUrl).origin;
        const url = new URL(`${originUrl}/servicedesk/customer/kb/view/${pageId}`);
        url.searchParams.append('applicationId', applicationId);
        return url.toString();
    };
    const $b67205cee8595deb$export$8137b2ada5bef74a = (pageId, applicationId)=>`kb/view/${pageId}?applicationId=${applicationId}`;
    const $b67205cee8595deb$export$29a4f5ce2fc7e182 = (baseUrl, pageId)=>`${baseUrl}/pages/editpage.action?pageId=${pageId}`;
    const $b67205cee8595deb$export$26ed3646363ada0a = (el)=>{
        const name = String(el.getAttribute('DATA-TITLE'));
        const pageId = String(el.getAttribute('DATA-ID'));
        const baseUrl = String(el.getAttribute('DATA-APPLINK-URL'));
        const applicationId = String(el.getAttribute('DATA-APPLINK-ID'));
        const shareable = el.getAttribute('data-shareable') === 'true' || el.getAttribute('data-hidepadlock') === 'true' || false;
        const iframeSrc = `${baseUrl}/plugins/servlet/remotepageview?pageId=${pageId}`;
        const link = $b67205cee8595deb$export$8137b2ada5bef74a(Number(pageId), applicationId);
        const editLink = $b67205cee8595deb$export$29a4f5ce2fc7e182(baseUrl, Number(pageId));
        return {
            iframeSrc: iframeSrc,
            link: link,
            editLink: editLink,
            shareable: shareable,
            name: name
        };
    };
    const $b67205cee8595deb$export$ec2cadd99971a33 = (el)=>{
        const userAnchor = el.querySelector('.user-hover');
        if (userAnchor instanceof Element) {
            const href = String(userAnchor.getAttribute('href'));
            const accountId = href.substring(href.indexOf('accountId=') + 10);
            return {
                accountId: accountId,
                displayName: userAnchor.innerHTML,
                avatarUrl: ''
            };
        }
        return undefined;
    };
});
parcelRegister("1Gl9g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$440ff202ea5eba49$export$2e2bcd8739ae039);
    const $440ff202ea5eba49$var$getTableHeader = (columns)=>{
        const cells = columns.map((column, index)=>({
                key: `column-${index}`,
                content: column.columnName
            }));
        return {
            cells: cells
        };
    };
    var $440ff202ea5eba49$export$2e2bcd8739ae039 = $440ff202ea5eba49$var$getTableHeader;
});
parcelRegister("fUIaM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b2fea5e73aebf32$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5b2fea5e73aebf32$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        paginationPrev: {
            "id": "servicedesk-reports-common.table.issue-table.pagination-prev",
            "defaultMessage": "Prev"
        },
        paginationNext: {
            "id": "servicedesk-reports-common.table.issue-table.pagination-next",
            "defaultMessage": "Next"
        },
        noData: {
            "id": "servicedesk-reports-common.table.issue-table.no-data",
            "defaultMessage": "No data found for this period"
        }
    });
});
parcelRegister("kU57e", function(module, exports) {
    $parcel$export(module.exports, "PaginationLabel", ()=>$4c1e5997643ffb4a$export$5742121915cb78c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $kTrC2;
    const $4c1e5997643ffb4a$export$5742121915cb78c6 = ({ label: label = '', start: start = 0, end: end = 0, size: size = 0 })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (label) return (0, ($parcel$interopDefault($5uXOq))).createElement($4c1e5997643ffb4a$var$Label, null, label);
        if (size > 0 && end >= start) return (0, ($parcel$interopDefault($5uXOq))).createElement($4c1e5997643ffb4a$var$Label, null, formatMessage((0, (0, parcelRequire("kTrC2")).default).paginationMessage, {
            start: start,
            end: end,
            size: size
        }));
        return null;
    };
    const $4c1e5997643ffb4a$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1aaxusic _19pkidpf _2hwxidpf _otyridpf _18u0idpf _t9ec1i9q",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kTrC2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8f40023897ce001$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d8f40023897ce001$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        paginationMessage: {
            "id": "servicedesk-reports-common.table.pagination-count-label.pagination-message",
            "defaultMessage": "{start}-{end} of {size}"
        }
    });
});
parcelRegister("4lDEP", function(module, exports) {
    $parcel$export(module.exports, "SeriesPicker", ()=>$0945e11bffe29a73$export$b2b877c4ab1b9a94);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2APCZ;
    var $gN6Vx;
    var $gwIPs;
    var $8RXs9;
    var $3nKyk;
    var $fSMNO;
    const $0945e11bffe29a73$export$a88f400462875b1a = ({ intl: { formatMessage: formatMessage }, source: { chartSeries: chartSeries, searchBy: searchBy }, selectedDrillDownPoint: selectedDrillDownPoint, onSwitchSeries: onSwitchSeries, onSwitchTable: onSwitchTable })=>{
        const seriesPickerWithLabel = (0, $5uXOq.useMemo)(()=>{
            let seriesPicker;
            if (chartSeries.length === 1) {
                const { itemStyle: itemStyle, name: name } = chartSeries[0];
                seriesPicker = (0, ($parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$OptionWithHighlighter, {
                    background: itemStyle.color
                }, name);
            } else {
                const selectableOptions = chartSeries.map(({ name: name, ...rest })=>({
                        label: name,
                        value: rest
                    }));
                const selectedOption = selectableOptions.find(({ value: { seriesIndex: seriesIndex } })=>seriesIndex === selectedDrillDownPoint.seriesIndex);
                seriesPicker = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
                    value: selectedOption,
                    options: selectableOptions,
                    styles: $0945e11bffe29a73$var$colourStyles,
                    onChange: ({ value: { seriesId: seriesId, seriesIndex: seriesIndex } })=>{
                        onSwitchSeries({
                            ...selectedDrillDownPoint,
                            seriesId: seriesId,
                            seriesIndex: seriesIndex
                        });
                    }
                });
            }
            const timeInterval = (0, (0, parcelRequire("fSMNO")).getSelectedTimePeriodMessage)(searchBy, selectedDrillDownPoint.expandedDate, formatMessage);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$InlineLabel, {
                as: "label",
                for: "react-select-2-input"
            }, formatMessage((0, (0, parcelRequire("3nKyk")).default).seriesPickerDetailsLabel)), seriesPicker, (0, ($parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$InlineLabel, null, timeInterval));
        }, [
            chartSeries,
            formatMessage,
            onSwitchSeries,
            searchBy,
            selectedDrillDownPoint
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$Container, {
            "data-test-id": "servicedesk-reports-common.ui.table.series-picker.container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0945e11bffe29a73$var$SeriesPickerWrapper, null, seriesPickerWithLabel), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "link",
            onClick: onSwitchTable
        }, formatMessage((0, (0, parcelRequire("3nKyk")).default).returnToSummary)));
    };
    const $0945e11bffe29a73$export$b2b877c4ab1b9a94 = (0, (0, parcelRequire("8RXs9")).default)($0945e11bffe29a73$export$a88f400462875b1a);
    const $0945e11bffe29a73$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bahesu3 _otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $0945e11bffe29a73$var$SeriesPickerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _2hwx1wug",
                __cmplp.className
            ])
        });
    });
    const $0945e11bffe29a73$var$OptionWithHighlighter = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { background: background, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_192fqt6": (0, (0, parcelRequire("lD23V")).default)(__cmplp.background)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4u2gc _1kt9b3bt _cfu11o8l _1s6k10d2 _1n6qu2gc _eid3u2gc _7dwz1ilg",
                __cmplp.className
            ])
        });
    });
    const $0945e11bffe29a73$var$InlineLabel = (0, $5uXOq.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $0945e11bffe29a73$var$getOptionHighlighter = (color = '#ccc')=>({
            alignItems: 'center',
            display: 'flex',
            ':before': {
                content: '" "',
                display: 'block',
                background: color,
                marginRight: `${0, (0, parcelRequire("gwIPs")).gridSize}px`,
                padding: `${0, (0, parcelRequire("gwIPs")).gridSize}px`
            }
        });
    const $0945e11bffe29a73$var$colourStyles = {
        option: (styles, { value: { itemStyle: { color: color } } })=>({
                ...styles,
                ...$0945e11bffe29a73$var$getOptionHighlighter(color)
            }),
        singleValue: (styles, { data: { value: { itemStyle: { color: color } } } })=>({
                ...styles,
                ...$0945e11bffe29a73$var$getOptionHighlighter(color)
            }),
        container: (styles)=>({
                ...styles,
                padding: "var(--ds-space-100, 8px)",
                width: '25%'
            })
    };
});
parcelRegister("3nKyk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$758c1a91a74cd054$export$2e2bcd8739ae039);
    var $7VHMR;
    var $758c1a91a74cd054$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        seriesPickerDetailsLabel: {
            "id": "servicedesk-reports-common.table.series-picker.series-picker-details-label",
            "defaultMessage": "Details for"
        },
        atDateTime: {
            "id": "servicedesk-reports-common.table.series-picker.at-date-time",
            "defaultMessage": "at {dateTimestamp}"
        },
        onDate: {
            "id": "servicedesk-reports-common.table.series-picker.on-date",
            "defaultMessage": "on {dateTimestamp}"
        },
        inWeek: {
            "id": "servicedesk-reports-common.table.series-picker.in-week",
            "defaultMessage": "in week starting {dateTimestamp}"
        },
        inMonth: {
            "id": "servicedesk-reports-common.table.series-picker.in-month",
            "defaultMessage": "in {dateTimestamp}"
        },
        returnToSummary: {
            "id": "servicedesk-reports-common.table.series-picker.return-to-summary",
            "defaultMessage": "Return to summary table"
        }
    });
});
parcelRegister("fSMNO", function(module, exports) {
    $parcel$export(module.exports, "getSelectedTimePeriodMessage", ()=>$454bba9396fbb2b8$export$6c208bc6fa2d1ece);
    var $9nenm;
    var $3nKyk;
    const $454bba9396fbb2b8$export$755b91df20ec2f47 = (searchBy)=>{
        switch(searchBy){
            case (0, (0, parcelRequire("9nenm")).SEARCH_BY).hourly:
                return (0, (0, parcelRequire("3nKyk")).default).atDateTime;
            case (0, (0, parcelRequire("9nenm")).SEARCH_BY).weekly:
                return (0, (0, parcelRequire("3nKyk")).default).inWeek;
            case (0, (0, parcelRequire("9nenm")).SEARCH_BY).monthly:
                return (0, (0, parcelRequire("3nKyk")).default).inMonth;
            default:
                return (0, (0, parcelRequire("3nKyk")).default).onDate;
        }
    };
    const $454bba9396fbb2b8$export$6c208bc6fa2d1ece = (searchBy, dateTimestamp, formatMessage)=>{
        const message = $454bba9396fbb2b8$export$755b91df20ec2f47(searchBy);
        return formatMessage(message, {
            dateTimestamp: dateTimestamp
        });
    };
});
parcelRegister("3z9Bw", function(module, exports) {
    $parcel$export(module.exports, "SummaryTable", ()=>$23d99969d3c45cd4$export$dcecbe055cf73c86);
    var $5uXOq = parcelRequire("5uXOq");
    var $k9ie1;
    var $koVbs;
    var $babc9;
    const $23d99969d3c45cd4$var$paginationi18n = {
        next: '',
        prev: ''
    };
    const $23d99969d3c45cd4$export$dcecbe055cf73c86 = ({ source: source, onSelect: onSelect, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const head = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("babc9")).createHead)(source, {
                formatMessage: formatMessage
            }), [
            formatMessage,
            source
        ]);
        const rows = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("babc9")).createRows)(source, {
                formatMessage: formatMessage,
                onClick: onSelect,
                isDisabled: isDisabled
            }), [
            formatMessage,
            isDisabled,
            onSelect,
            source
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "servicedesk-reports-common.ui.table.summary-table.summary-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k9ie1")).default), {
            head: head,
            rows: rows,
            paginationi18n: $23d99969d3c45cd4$var$paginationi18n,
            isFixedSize: true
        }));
    };
});
parcelRegister("k9ie1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e61c507a6596da6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gCBvJ;
    var $aGjCX;
    var $7IZ99;
    class $0e61c507a6596da6$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("gCBvJ")).default),
                onSort: (0, (0, parcelRequire("gCBvJ")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IZ99")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            };
            this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            };
            this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            };
            this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            };
            this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("aGjCX")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("babc9", function(module, exports) {
    $parcel$export(module.exports, "createHead", ()=>$c1a79a1b61bc2a63$export$b87bd21e0602bd96);
    $parcel$export(module.exports, "createRows", ()=>$c1a79a1b61bc2a63$export$d7ac61300192caab);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2APCZ;
    var $knKRw;
    var $9nenm;
    var $cnldZ;
    var $8TqM4;
    var $7TzgI;
    const $c1a79a1b61bc2a63$export$b87bd21e0602bd96 = ({ chartSeries: chartSeries }, { formatMessage: formatMessage })=>{
        const cells = chartSeries.map(({ seriesIndex: seriesIndex, name: name })=>({
                key: `${seriesIndex}`,
                content: name
            }));
        cells.unshift({
            key: 'date-column',
            content: formatMessage((0, (0, parcelRequire("7TzgI")).default).dateColumnLabel)
        });
        return {
            cells: cells
        };
    };
    const $c1a79a1b61bc2a63$export$bf3bed7d90816f1c = ({ seriesIndex: seriesIndex, dataIndex: dataIndex, data: data, value: value, valueType: valueType, onClick: onClick, isDisabled: isDisabled, formatMessage: formatMessage })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            isDisabled: isDisabled,
            appearance: "link",
            onClick: ()=>{
                onClick({
                    seriesIndex: seriesIndex,
                    dataIndex: dataIndex,
                    data: data
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$var$ButtonLabel, {
            "data-test-id": "servicedesk-reports-common.ui.table.summary-table.button-label"
        }, (0, (0, parcelRequire("cnldZ")).getFormattedLabel)(valueType, value, formatMessage)));
    const $c1a79a1b61bc2a63$export$d7ac61300192caab = ({ chartSeries: chartSeries, searchBy: searchBy }, { formatMessage: formatMessage, onClick: onClick, isDisabled: isDisabled })=>chartSeries.reduce((accumulator, { name: name, data: data, seriesIndex: seriesIndex })=>{
            data.forEach((pointData)=>{
                const { id: id, expandedDate: expandedDate, value: value, valueType: valueType, dataIndex: dataIndex } = pointData;
                const row = accumulator.find(({ key: key })=>key === `${id}`);
                if (!row) {
                    const label = searchBy === (0, (0, parcelRequire("9nenm")).SEARCH_BY).weekly ? formatMessage((0, (0, parcelRequire("7TzgI")).default).weekStartingLabel, {
                        expandedDate: expandedDate
                    }) : expandedDate;
                    const cells = [
                        {
                            key: `${name}-${expandedDate}`,
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TqM4")).LabelWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
                                name: "dateLabel",
                                label: label
                            }, ()=>(0, ($parcel$interopDefault($8Rkzz)))))
                        },
                        {
                            key: `${name}-${id}`,
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$export$bf3bed7d90816f1c, {
                                isDisabled: isDisabled,
                                seriesIndex: seriesIndex,
                                dataIndex: dataIndex,
                                value: value,
                                valueType: valueType,
                                data: pointData,
                                onClick: onClick,
                                formatMessage: formatMessage
                            })
                        }
                    ];
                    accumulator.push({
                        key: `${id}`,
                        cells: cells
                    });
                } else row.cells.push({
                    key: `${name}-${id}`,
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement($c1a79a1b61bc2a63$export$bf3bed7d90816f1c, {
                        isDisabled: isDisabled,
                        seriesIndex: seriesIndex,
                        dataIndex: dataIndex,
                        value: value,
                        valueType: valueType,
                        data: pointData,
                        onClick: onClick,
                        formatMessage: formatMessage
                    })
                });
            });
            return accumulator;
        }, []);
    const $c1a79a1b61bc2a63$var$ButtonLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41wcj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7TzgI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41bbeabca1bbc633$export$2e2bcd8739ae039);
    var $7VHMR;
    var $41bbeabca1bbc633$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weekStartingLabel: {
            "id": "servicedesk-reports-common.table.summary-table.week-starting-label",
            "defaultMessage": "Week starting - {expandedDate}"
        },
        dateColumnLabel: {
            "id": "servicedesk-reports-common.table.summary-table.date-column-label",
            "defaultMessage": "Date"
        }
    });
});
parcelRegister("kuEHb", function(module, exports) {
    $parcel$export(module.exports, "kbRequestsReportsPageLoad", ()=>$f9c0f3cfc2ad3eb2$export$64c48e4611415eec);
    var $55AbO;
    const $f9c0f3cfc2ad3eb2$export$64c48e4611415eec = (0, (0, parcelRequire("55AbO")).metrics).pageLoad({
        key: 'service-management.kb-requests-reports'
    });
});
parcelRegister("8u51m", function(module, exports) {
    $parcel$export(module.exports, "APP_DEFAULTS", ()=>$7ff0c24a5324a8a2$export$533ff3a9b30dcc50);
    $parcel$export(module.exports, "APP_PAGINATION_DEFAULTS", ()=>$7ff0c24a5324a8a2$export$f31fb3281b965fce);
    const $7ff0c24a5324a8a2$export$533ff3a9b30dcc50 = {
        searchByPastSevenDays: 2,
        timeBreakdown: 'd'
    };
    const $7ff0c24a5324a8a2$export$f31fb3281b965fce = {
        start: 0,
        limit: 50
    };
});
parcelRegister("fySF6", function(module, exports) {
    $parcel$export(module.exports, "useUrlActions", ()=>$4fcd234ce1a5dd19$export$a3fe1c11ec400f1c);
    $parcel$export(module.exports, "getCsvUrl", ()=>$4fcd234ce1a5dd19$export$90f14bb6f669812c);
    $parcel$export(module.exports, "getCsvForGeneratedReport", ()=>$4fcd234ce1a5dd19$export$8c9a255147c6f59d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $32TkL;
    var $bvS9p;
    var $doZTA;
    var $8u51m;
    const $4fcd234ce1a5dd19$export$a3fe1c11ec400f1c = ({ baseUrl: baseUrl, projectKey: projectKey, routerProps: { reportId: reportId } })=>{
        const [{ location: pathname }, { push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const modifyPageUrl = (0, $5uXOq.useCallback)((query)=>{
            const queryString = (0, $ebyGx.stringify)({
                startTime: query.startDate,
                endTime: query.endDate,
                timeBreakdown: query.timeBreakdown
            }, (0, (0, parcelRequire("32TkL")).stringifyOptions));
            const timescaleId = query.timescaleId !== undefined ? query.timescaleId.toString() : '';
            const targetUrl = `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports/${reportId}/timescale/${timescaleId}${queryString ? `?${queryString}` : ''}`;
            if (pathname !== targetUrl) push(targetUrl);
        }, [
            baseUrl,
            pathname,
            projectKey,
            push,
            reportId
        ]);
        return {
            modifyPageUrl: modifyPageUrl
        };
    };
    const $4fcd234ce1a5dd19$var$getDrillDrownCsvUrlForCustomTimeScale = (urlPrefix, { reportId: reportId, timeBreakdown: timeBreakdown }, { id: id, seriesId: seriesId })=>`${urlPrefix}/series-date-range/${reportId}/${seriesId}/csv?${(0, $ebyGx.stringify)({
            date: id,
            timeBreakdown: timeBreakdown
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $4fcd234ce1a5dd19$var$getCsvUrlForCustomTimeScale = (urlPrefix, { reportId: reportId, startDate: startDate, endDate: endDate, timeBreakdown: timeBreakdown })=>`${urlPrefix}/report-date-range/${reportId}/csv?${(0, $ebyGx.stringify)({
            startDate: startDate,
            endDate: endDate,
            timeBreakdown: timeBreakdown
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $4fcd234ce1a5dd19$var$getCsvUrlForTimescale = (urlPrefix, { reportId: reportId }, timescaleId)=>`${urlPrefix}/report/predefined/${reportId}/csv?${(0, $ebyGx.stringify)({
            timescaleId: timescaleId
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $4fcd234ce1a5dd19$var$getDrillDownCsvUrlForTimescale = (urlPrefix, { reportId: reportId }, timescaleId, { id: id, seriesId: seriesId })=>`${urlPrefix}/series/predefined/${reportId}/${seriesId}/csv?${(0, $ebyGx.stringify)({
            date: id,
            timescaleId: timescaleId
        }, (0, (0, parcelRequire("32TkL")).stringifyOptions))}`;
    const $4fcd234ce1a5dd19$export$90f14bb6f669812c = (baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint)=>{
        const timescaleId = dateFilterQuery.timescaleId === undefined ? (0, (0, parcelRequire("8u51m")).APP_DEFAULTS).searchByPastSevenDays : dateFilterQuery.timescaleId;
        const urlPrefix = `${baseUrl}/rest/servicedesk/reports/1/servicedesk/${projectKey}/export`;
        if ((0, (0, parcelRequire("bvS9p")).isCustomTimeScale)(timescaleId)) return selectedDrillDownPoint !== undefined ? $4fcd234ce1a5dd19$var$getDrillDrownCsvUrlForCustomTimeScale(urlPrefix, dateFilterQuery, selectedDrillDownPoint) : $4fcd234ce1a5dd19$var$getCsvUrlForCustomTimeScale(urlPrefix, dateFilterQuery);
        return selectedDrillDownPoint !== undefined ? $4fcd234ce1a5dd19$var$getDrillDownCsvUrlForTimescale(urlPrefix, dateFilterQuery, timescaleId, selectedDrillDownPoint) : $4fcd234ce1a5dd19$var$getCsvUrlForTimescale(urlPrefix, dateFilterQuery, timescaleId);
    };
    const $4fcd234ce1a5dd19$export$8c9a255147c6f59d = (baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint, taskId)=>{
        if (taskId !== undefined && selectedDrillDownPoint === undefined) return `${baseUrl}/rest/servicedesk/reports/1/reports/async/${projectKey}/export/csv?&jobID=${taskId}`;
        return $4fcd234ce1a5dd19$export$90f14bb6f669812c(baseUrl, projectKey, dateFilterQuery, selectedDrillDownPoint);
    };
});
parcelRegister("eEETY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$335aa4f5fc63025e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $doZTA;
    var $335aa4f5fc63025e$export$2e2bcd8739ae039 = ()=>{
        const [{ match: { params: params }, location: location }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const routerProps = (0, $5uXOq.useMemo)(()=>{
            const reportId = params.reportId || '';
            const timescaleId = params.timescaleId !== undefined ? Number(params.timescaleId) : undefined;
            const { startTime: startDate, endTime: endDate, timeBreakdown: timeBreakdown } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
            return {
                reportId: reportId,
                timescaleId: timescaleId,
                startDate: startDate,
                endDate: endDate,
                timeBreakdown: timeBreakdown
            };
        }, [
            location.search,
            params.reportId,
            params.timescaleId
        ]);
        return routerProps;
    };
});
